import { ADMIN_EMAIL, USE_FIREBASE, firebaseConfig } from "./firebase-config.js?v=4";
import { adsConfig } from "./ads-config.js?v=12";

const STORAGE_KEY = "skillup-class-content-v4";
const FIREBASE_CONTENT_CACHE_KEY = "skillup-class-firebase-content-v1";
const FIREBASE_SDK_TIMEOUT_MS = 12000;
const FIREBASE_CONTENT_CACHE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;
const INQUIRY_STORAGE_KEY = "skillup-class-inquiries-v1";
const PROGRESS_STORAGE_KEY = "skillup-class-progress-v1";
const BOOKMARK_STORAGE_KEY = "skillup-class-bookmarks-v1";
const QUIZ_STORAGE_KEY = "skillup-class-quiz-v1";
const INQUIRY_EMAIL = "skillupcodes@gmail.com";
const INQUIRY_RETENTION_DAYS = 30;
const MERMAID_SCRIPT_URL = "https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.min.js";
const DOCX_LIB_SCRIPT_URL = "https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js";
const HOME_FEATURE_VIDEO_URL = "https://www.youtube.com/watch?v=qqVn49Djq6k";
const SKILLUP_YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@SkillupClass";
const SKILLUP_WHATSAPP_COMMUNITY_URL = "https://chat.whatsapp.com/BSI8YYO4M0k7WW20AGZ4f0";

// App Check proves a request came from this site rather than a script, which
// is what stops the inquiry form being flooded. Paste the reCAPTCHA v3 site
// key from Firebase console -> App Check -> Apps -> Register here. While it
// is empty nothing loads, so this ships safely before the key exists.
// Kept in app.js rather than firebase-config.js on purpose: that file is
// served with a one-year immutable cache, so a new export added there would
// never reach returning visitors and would break the module import.
const APP_CHECK_SITE_KEY = "";

// Analytics waits this long for Google's consent platform to appear before
// deciding none is running on this visit.
const ANALYTICS_CONSENT_WAIT_MS = 3000;
const CLIENT_ERROR_LIMIT_PER_PAGE = 5;
const PUBLIC_NAV_TABS = [
  { id: "courses", label: "Courses", pages: ["courses", "programs"] },
  { id: "sessions", label: "1:1 Sessions", pages: ["sessions"] },
  { id: "tutorials", label: "Tutorials", pages: ["tutorials", "articles", "article"] },
  { id: "coding-practice", label: "Coding Practice", pages: ["practice", "coding", "coding-round", "coding-practice"] },
  { id: "community", label: "Students Hub", pages: ["community"] },
  { id: "events", label: "Events", pages: ["events"] },
  { id: "blog", label: "Blog", pages: ["blog", "blogs"] },
  { id: "whatsapp", label: "WhatsApp", pages: ["whatsapp"] },
  { id: "youtube", label: "YouTube", pages: [] },
  { id: "inquiry", label: "Course Inquiry", pages: ["inquiry"] }
];

// Small inline-SVG icon set used throughout the site (badges, cards, meta
// rows) so key concepts read as real icons instead of plain text/letters.
// Stroke-based, 24x24 viewBox, currentColor - sizing/color is controlled by
// the surrounding CSS (badge background, font color, width/height).
const ICON_PATHS = {
  "graduation-cap": '<path d="M22 10 12 5 2 10l10 5 10-5Z"/><path d="M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5"/><path d="M22 10v6"/>',
  "book-open": '<path d="M12 7c-2-1.5-5-2-8-1.5v13c3-.5 6 0 8 1.5 2-1.5 5-2 8-1.5v-13c-3-.5-6 0-8 1.5Z"/><path d="M12 7v13"/>',
  code: '<polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>',
  "edit-3": '<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
  "message-circle": '<path d="M21 11.5a8.38 8.38 0 0 1-4.8 7.6 8.5 8.5 0 0 1-8.5-.6L3 20l1.6-4.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 8.5-8.5h.3a8.48 8.48 0 0 1 8 8v.5Z"/>',
  "play-circle": '<circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/>',
  sparkles: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8"/>',
  target: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.4"/>',
  repeat: '<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  upload: '<path d="M21 15v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>',
  flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V4s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/>',
  "trending-up": '<polyline points="22 6 13.5 14.5 8.5 9.5 2 16"/><polyline points="16 6 22 6 22 12"/>',
  clock: '<circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/>',
  "bar-chart": '<line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/>',
  lightbulb: '<path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.6c.6.5 1 1.3 1 2.2v.2h6v-.2c0-.9.4-1.7 1-2.2A7 7 0 0 0 12 2Z"/>',
  award: '<circle cx="12" cy="8" r="6"/><polyline points="8.2 13.9 7 23 12 20 17 23 15.8 13.9"/>',
  compass: '<circle cx="12" cy="12" r="9"/><polygon points="15.5 8.5 13.4 13.4 8.5 15.5 10.6 10.6 15.5 8.5"/>',
  calendar: '<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  "arrow-right": '<line x1="4" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/>',
  "check-circle": '<path d="M22 11.1V12a10 10 0 1 1-5.9-9.1"/><polyline points="22 4 12 14.5 9 11.5"/>',
  "x-circle": '<circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>',
  smartphone: '<rect x="6" y="2" width="12" height="20" rx="2"/><line x1="11" y1="18" x2="13" y2="18"/>',
  layers: '<polygon points="12 3 21 8 12 13 3 8 12 3"/><polyline points="3 13 12 18 21 13"/><polyline points="3 17.5 12 22.5 21 17.5"/>',
  apple: '<path d="M12 7c-3 0-5.5 2.5-5.5 6.5C6.5 18 9 21 11 21c.8 0 1.2-.4 2-.4s1.2.4 2 .4c2 0 4.5-3 4.5-7.5C19.5 9.5 17 7 14 7c-.7 0-1.3.2-2 .5"/><path d="M12 7c.3-1.5 1.5-3 3-3.2"/>',
  users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>'
};

function icon(name, className = "") {
  const path = ICON_PATHS[name];
  if (!path) return "";
  return `<svg class="icon${className ? ` ${className}` : ""}" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${path}</svg>`;
}

let mermaidLoadPromise = null;
let docxLibLoadPromise = null;
let docxTemplateAssetsPromise = null;
const FULL_VIEW_MENU_STORAGE_KEY = "skillup-class-full-view-menu-visible";
const FULL_VIEW_THEME_STORAGE_KEY = "skillup-class-full-view-theme";
const FULL_VIEW_THEMES = new Set(["light", "dark"]);
const DEFAULT_SECTION_ID = "core-tutorials";
const DEFAULT_SECTION_TITLE = "Core tutorials";
const UNSECTIONED_SECTION_ID = "unsectioned";
const UNSECTIONED_SECTION_TITLE = "Unsectioned";
const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
const MAX_DOCUMENT_SIZE = 20 * 1024 * 1024;
const MAX_TUTORIAL_IMPORT_SIZE = 30 * 1024 * 1024;
const IMAGE_TYPES = new Set(["image/jpeg", "image/png", "image/webp", "image/gif", "image/avif"]);
const DOCUMENT_EXTENSIONS = new Set(["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt"]);
const TUTORIAL_IMPORT_EXTENSIONS = new Set(["md", "markdown", "ipynb", "docx", "doc"]);
const DIAGRAM_SYMBOLS = [
  { key: "hline", label: "Horizontal line", value: "---", preview: "---" },
  { key: "vline", label: "Vertical line", value: "|", preview: "|" },
  { key: "branch", label: "Branch", value: "+-- ", preview: "+--" },
  { key: "tee", label: "Tree branch", value: "|-- ", preview: "|--" },
  { key: "corner", label: "Corner", value: "+", preview: "+" },
  { key: "right", label: "Right arrow", value: " --> ", preview: "-->" },
  { key: "left", label: "Left arrow", value: " <-- ", preview: "<--" },
  { key: "up", label: "Top arrow", value: "↑\n|", preview: "↑\n|" },
  { key: "down", label: "Bottom arrow", value: "|\n↓", preview: "|\n↓" },
  { key: "indent", label: "Indent space", value: "    ", preview: "Indent" },
  { key: "newline", label: "New line", value: "\n", preview: "New line" },
  { key: "box", label: "Box label", value: "[Node]", preview: "[Node]" },
  { key: "round", label: "Round node", value: "(Node)", preview: "(Node)" },
  { key: "activity", label: "Activity name", value: "Activity", preview: "Activity" }
];
const loadedPublicCollections = new Set();
const loadingPublicCollections = new Map();
const stalePublicCollections = new Set();
let routeContentLoadToken = 0;
let adminContentLoaded = false;

const IMAGE_EXTENSION_BY_TYPE = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/gif": "gif",
  "image/avif": "avif"
};

const seedContent = {
  tutorials: [
    {
      id: "ai-career-accelerator",
      title: "AI Career Accelerator",
      slug: "ai-career-accelerator",
      description:
        "A 6-month online track for developers who want to move into AI engineering with practical projects and interview preparation.",
      outcome: "Build production-style AI features, explain core internals clearly, and prepare for AI engineer interviews.",
      category: "AI and Machine Learning",
      level: "Career Track",
      duration: "6 months",
      topics: ["ai fundamentals", "llm projects", "interview prep"],
      status: "published",
      order: 1,
      createdAt: "2026-06-13T10:00:00.000Z",
      updatedAt: "2026-06-13T10:00:00.000Z"
    },
    {
      id: "full-stack-project-sprint",
      title: "Full-Stack Project Sprint",
      slug: "full-stack-project-sprint",
      description:
        "A project-based path for building clean interfaces, connected backends, and portfolio evidence that hiring teams can inspect.",
      outcome: "Ship a polished web product with authentication, data storage, responsive UI, and a readable project write-up.",
      category: "Web Development",
      level: "Project Track",
      duration: "12 weeks",
      topics: ["frontend", "firebase", "portfolio"],
      status: "published",
      order: 2,
      createdAt: "2026-06-13T10:05:00.000Z",
      updatedAt: "2026-06-13T10:05:00.000Z"
    },
    {
      id: "system-design-interview-lab",
      title: "System Design Interview Lab",
      slug: "system-design-interview-lab",
      description:
        "A guided preparation lab focused on internals, architecture tradeoffs, mock discussions, and confident technical storytelling.",
      outcome: "Practice system design from first principles and turn your project experience into interview-ready explanations.",
      category: "System Design",
      level: "Interview Lab",
      duration: "8 weeks",
      topics: ["internals", "architecture", "mock interviews"],
      status: "published",
      order: 3,
      createdAt: "2026-06-13T10:10:00.000Z",
      updatedAt: "2026-06-13T10:10:00.000Z"
    }
  ],
  subjects: [
    {
      id: "python",
      title: "Python",
      slug: "python",
      order: 1,
      createdAt: "2026-06-13T10:15:00.000Z",
      updatedAt: "2026-06-13T10:15:00.000Z"
    },
    {
      id: "web-development",
      title: "Web Development",
      slug: "web-development",
      order: 2,
      createdAt: "2026-06-13T10:16:00.000Z",
      updatedAt: "2026-06-13T10:16:00.000Z"
    },
    {
      id: "firebase",
      title: "Firebase",
      slug: "firebase",
      order: 3,
      createdAt: "2026-06-13T10:17:00.000Z",
      updatedAt: "2026-06-13T10:17:00.000Z"
    },
    {
      id: "ai-career",
      title: "AI Career",
      slug: "ai-career",
      order: 4,
      createdAt: "2026-06-13T10:18:00.000Z",
      updatedAt: "2026-06-13T10:18:00.000Z"
    },
    {
      id: "interview-prep",
      title: "Interview Prep",
      slug: "interview-prep",
      order: 5,
      createdAt: "2026-06-13T10:19:00.000Z",
      updatedAt: "2026-06-13T10:19:00.000Z"
    }
  ],
  articles: [
    {
      id: "python-tutorial",
      title: "Python Tutorial",
      slug: "python-tutorial",
      excerpt:
        "Start Python from the ground up with syntax, variables, control flow, functions, and small practice tasks.",
      body: `# Python Tutorial

Python is a beginner-friendly programming language used for web development, automation, data analysis, artificial intelligence, scripting, and software testing.

## Why Learn Python

Python is easy to read, has a large library ecosystem, and works well for both small scripts and production applications.

## Where Python Is Used

Python is used in backend APIs, data dashboards, machine learning pipelines, test automation, cloud scripts, web scraping, and internal business tools.

## Installing Python

Download Python from the official website, install it, and confirm the setup by running \`python --version\` from your terminal. If your system uses the Python launcher, \`py --version\` also works.

## First Python Example

Create a file named app.py and write:

\`print("Hello, SkillUp")\`

Run it from the terminal with \`python app.py\`.

## Python Syntax

Python uses indentation to group related statements. Keep indentation consistent, and prefer clear names over short unclear names.

## Variables

A variable stores a value that your program can reuse.

\`course = "Python"\`
\`duration = 30\`
\`is_active = True\`

## Data Types

The most common beginner data types are strings, integers, floats, booleans, lists, tuples, sets, and dictionaries.

## Operators

Python supports arithmetic, comparison, logical, assignment, and membership operators. Use them to calculate values and make decisions.

## Conditions

Use \`if\`, \`elif\`, and \`else\` when your program needs to choose between multiple paths.

## Loops

Use a \`for\` loop to process each item in a sequence. Use a \`while\` loop when repetition depends on a condition.

## Functions

Functions make code reusable. A good function name should clearly describe the task it performs.

## Lists and Dictionaries

Lists store ordered items. Dictionaries store key-value pairs and are useful for structured data such as profiles, settings, and API responses.

## Error Handling

Errors are part of programming. Read the error message, identify the line number, and fix the smallest possible issue first.

## Mini Project Idea

Build a student marks calculator. Store student names and marks, calculate total and average marks, and print a pass or improvement message.

## What You Should Practice

- Writing simple output
- Creating variables
- Using conditions and loops
- Splitting logic into functions
- Reading errors carefully
- Explaining your code in simple words`,
      category: "Python",
      tags: ["python", "beginner", "syntax"],
      status: "published",
      featured: true,
      publishedAt: "2026-06-13T10:20:00.000Z",
      createdAt: "2026-06-13T10:20:00.000Z",
      updatedAt: "2026-06-13T10:20:00.000Z"
    },
    {
      id: "python-variables-and-data-types",
      title: "Python Variables and Data Types",
      slug: "python-variables-and-data-types",
      excerpt:
        "Understand how Python stores text, numbers, booleans, lists, dictionaries, and other useful values.",
      body: `# Python Variables and Data Types

A variable is a name that points to a value. Python decides the type from the value you assign.

## Creating Variables

\`name = "SkillUp"\`
\`score = 95\`
\`is_active = True\`

## Common Data Types

- String: text values like names and messages
- Integer: whole numbers
- Float: decimal numbers
- Boolean: true or false values
- List: ordered collections
- Dictionary: key-value data

## Practice Task

Create a student profile dictionary with name, course, marks, and active status. Print each value with a clear label.`,
      category: "Python",
      tags: ["variables", "data types", "practice"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:25:00.000Z",
      createdAt: "2026-06-13T10:25:00.000Z",
      updatedAt: "2026-06-13T10:25:00.000Z"
    },
    {
      id: "python-control-flow",
      title: "Python Control Flow",
      slug: "python-control-flow",
      excerpt:
        "Use if statements and loops to make Python programs decide, repeat, and process collections.",
      body: `# Python Control Flow

Control flow decides which code runs and how many times it runs.

## If Else

Use \`if\`, \`elif\`, and \`else\` when your program must choose between paths.

## Loops

Use a \`for\` loop when you want to process items in a sequence. Use a \`while\` loop when repetition depends on a condition.

## Practice Task

Write a program that prints all even numbers from 1 to 20, then prints the total count of even numbers.`,
      category: "Python",
      tags: ["conditions", "loops", "logic"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:28:00.000Z",
      createdAt: "2026-06-13T10:28:00.000Z",
      updatedAt: "2026-06-13T10:28:00.000Z"
    },
    {
      id: "python-functions",
      title: "Python Functions",
      slug: "python-functions",
      excerpt:
        "Split repeated logic into clean reusable blocks with parameters, return values, and small examples.",
      body: `# Python Functions

A function is a named block of code that performs one clear task. Functions help you reuse logic and keep programs easier to test.

## Defining a Function

\`def greet(name):\`
\`    return "Hello " + name\`

## Parameters and Return Values

Parameters receive input. Return values send a result back to the caller.

## Practice Task

Create a function called \`calculate_average\` that accepts a list of marks and returns the average score.`,
      category: "Python",
      tags: ["functions", "parameters", "return"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:29:00.000Z",
      createdAt: "2026-06-13T10:29:00.000Z",
      updatedAt: "2026-06-13T10:29:00.000Z"
    },
    {
      id: "html-css-foundation",
      title: "HTML and CSS Foundation",
      slug: "html-css-foundation",
      excerpt:
        "Learn page structure, semantic sections, responsive layout, and styling habits for clean web pages.",
      body: `# HTML and CSS Foundation

HTML gives a page structure. CSS controls layout, spacing, color, and responsive behavior.

## Semantic HTML

Use elements like \`header\`, \`main\`, \`section\`, \`article\`, and \`footer\` to describe the purpose of content.

## CSS Layout

Flexbox is useful for one-dimensional layouts. Grid is useful for two-dimensional page sections and card lists.

## Practice Task

Build a two-column profile page that becomes a single-column layout on mobile screens.`,
      category: "Web Development",
      tags: ["html", "css", "responsive"],
      status: "published",
      featured: true,
      publishedAt: "2026-06-13T10:31:00.000Z",
      createdAt: "2026-06-13T10:31:00.000Z",
      updatedAt: "2026-06-13T10:31:00.000Z"
    },
    {
      id: "javascript-dom-basics",
      title: "JavaScript DOM Basics",
      slug: "javascript-dom-basics",
      excerpt:
        "Select elements, handle events, update content, and build small interactive browser features.",
      body: `# JavaScript DOM Basics

The Document Object Model lets JavaScript read and update page content after the browser loads HTML.

## Selecting Elements

Use \`document.querySelector()\` for one element and \`document.querySelectorAll()\` for a list.

## Handling Events

Events let you react to clicks, typing, form submits, and other user actions.

## Practice Task

Create a search input that filters a list of course cards as the user types.`,
      category: "Web Development",
      tags: ["javascript", "dom", "events"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:32:00.000Z",
      createdAt: "2026-06-13T10:32:00.000Z",
      updatedAt: "2026-06-13T10:32:00.000Z"
    },
    {
      id: "firebase-auth-and-firestore",
      title: "Firebase Auth and Firestore",
      slug: "firebase-auth-and-firestore",
      excerpt:
        "Connect sign-in, database reads, publishing states, and safe rules for a simple learning platform.",
      body: `# Firebase Auth and Firestore

Firebase helps static web apps add authentication, cloud data, and hosting without running a custom server.

## Authentication

Use Firebase Authentication when your app needs sign-in, admin access, or protected workflows.

## Firestore

Firestore stores structured documents in collections. Keep documents small and design queries around the screens you need.

## Practice Task

Create a collection for tutorials with status, title, slug, body, category, and updated date fields.`,
      category: "Firebase",
      tags: ["firebase", "auth", "firestore"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:33:00.000Z",
      createdAt: "2026-06-13T10:33:00.000Z",
      updatedAt: "2026-06-13T10:33:00.000Z"
    },
    {
      id: "ai-project-portfolio",
      title: "Build an AI Project Portfolio",
      slug: "ai-project-portfolio",
      excerpt:
        "Turn AI learning into visible proof with scoped projects, clear demos, and technical write-ups.",
      body: `# Build an AI Project Portfolio

An AI portfolio should show the problem, data or prompts, model behavior, tradeoffs, and how users interact with the result.

## Choose a Focused Problem

Start with one workflow, such as resume feedback, support ticket tagging, or document summarization.

## Explain Tradeoffs

Write about accuracy, latency, safety checks, cost, and how you would improve the system.

## Practice Task

Build a small AI assistant and write a one-page project note explaining the architecture and limitations.`,
      category: "AI Career",
      tags: ["ai", "portfolio", "projects"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:34:00.000Z",
      createdAt: "2026-06-13T10:34:00.000Z",
      updatedAt: "2026-06-13T10:34:00.000Z"
    },
    {
      id: "system-design-study-notes",
      title: "System Design Study Notes",
      slug: "system-design-study-notes",
      excerpt:
        "Prepare system design explanations with requirements, APIs, storage, scaling, and tradeoffs.",
      body: `# System Design Study Notes

System design interviews test how clearly you turn vague product needs into reliable technical decisions.

## Start with Requirements

Clarify users, read/write patterns, latency expectations, data size, and failure cases before choosing tools.

## Explain the Architecture

Cover APIs, data model, services, caching, queues, monitoring, and tradeoffs.

## Practice Task

Design a course progress tracker and explain how it stores lessons, users, completed topics, and reports.`,
      category: "Interview Prep",
      tags: ["system design", "interviews", "architecture"],
      status: "published",
      featured: false,
      publishedAt: "2026-06-13T10:35:00.000Z",
      createdAt: "2026-06-13T10:35:00.000Z",
      updatedAt: "2026-06-13T10:35:00.000Z"
    },
    {
      id: "draft-course-outline",
      title: "Draft: Course Outline Template",
      slug: "draft-course-outline",
      excerpt: "A hidden draft sample that only appears in the admin panel.",
      body: "# Draft: Tutorial Outline Template\n\nUse this tutorial as a starting draft.",
      category: "Admin Draft",
      tags: ["draft"],
      status: "draft",
      featured: false,
      publishedAt: "",
      createdAt: "2026-06-13T10:30:00.000Z",
      updatedAt: "2026-06-13T10:30:00.000Z"
    }
  ],
  blogs: []
};

const state = {
  tutorials: [],
  articles: [],
  blogs: [],
  codingProblems: [],
  codingMeta: null,
  siteNavigation: getDefaultSiteNavigation(),
  siteNavigationReady: false,
  subjects: [],
  inquiries: [],
  students: [],
  studentProfile: null,
  adminStudentLoadError: "",
  user: null,
  isAdmin: false,
  // Set when the signed-in account is an active contributor (see
  // loadContributorRecord). Contributors get a restricted dashboard.
  isContributor: false,
  contributorRecord: null,
  contributors: [],
  contributorsLoaded: false,
  // 1:1 sessions (see the "1:1 sessions" section).
  sessions: [],
  sessionsLoaded: false,
  sessionAvailability: null,
  takenSessionSlots: new Set(),
  takenSessionSlotsLoaded: false,
  mySessionBookings: [],
  mySessionBookingsLoaded: false,
  adminSessionBookings: [],
  editingSessionId: null,
  bookingModal: null,
  reviewModal: null,
  // Certificates: the signed-in student's own (null until loaded), and any
  // opened by link, keyed by id (null = not found).
  myCertificates: null,
  certificateCache: {},
  codingLeaderboard: null,
  suggestedBlogs: null,
  sessionReviews: [],
  sessionReviewsLoaded: false,
  mySessionReviews: [],
  mySessionReviewsLoaded: false,
  editingSessionReviewId: null,
  adminInsights: null,
  adminType: "overview",
  authView: "login",
  studentAuthView: "login",
  editingId: null,
  editingSubjectId: null,
  activeSubjectId: "",
  fullViewTutorialId: "",
  activeCourseId: "",
  fullViewMenuVisible: getFullViewMenuPreference(),
  fullViewTheme: getFullViewThemePreference(),
  firebaseEnabled: false,
  firebaseInitializing: true,
  firebaseError: "",
  discussionComments: {},
  discussionLoading: new Set(),
  discussionError: {},
  discussionReplyTarget: {},
  adminComments: [],
  adminCommentLoadError: "",
  communities: [],
  communitiesLoaded: false,
  communityMembers: {},
  communityMemberLoading: new Set(),
  communityMemberError: {},
  communityPosts: {},
  communityPostLoading: new Set(),
  communityPostError: {},
  communityPostReplyTarget: {},
  communityMembershipsByUid: {},
  publicProfiles: {},
  publicProfileLoading: new Set(),
  editingCommunityId: null,
  adminCommunityPosts: [],
  adminCommunityPostLoadError: "",
  communityPolicy: null,
  communityPolicyReady: false,
  blockedRecord: null,
  blockedRecordChecked: false,
  adminBlockedUsers: [],
  adminModerationFilter: "all",
  pendingSuspicious: {},
  events: [],
  eventsLoaded: false,
  editingEventId: null,
  eventRegistrations: {},
  eventRegistrationLoading: new Set(),
  eventRegistrationError: {},
  myEventRegistrations: {},
  myEventRegistrationsLoaded: false,
  eventMeetings: {},
  eventMeetingLoading: new Set(),
  editingEventMeetingId: null,
  clientErrors: [],
  clientErrorsLoaded: false
};

const firebase = {
  app: null,
  auth: null,
  db: null,
  storage: null,
  api: null
};

const app = document.querySelector("#app");
const toast = document.querySelector("[data-toast]");
const appLoader = document.querySelector("[data-app-loader]");
const loaderMessage = document.querySelector("[data-loader-message]");
const loaderProgress = document.querySelector("[data-loader-progress]");
const loaderProgressBar = document.querySelector("[data-loader-progress-bar]");
const richSelections = new WeakMap();
let activeRichImageFigure = null;
let richImageResizeState = null;
let loadingDepth = 0;
let deferredInstallPrompt = null;

document.addEventListener("click", handleClick);
document.addEventListener("submit", handleSubmit);
// Registered after handleClick, so a link that handler already dealt with
// (event.defaultPrevented) is left alone.
document.addEventListener("click", handleRouteLinkClick);
document.addEventListener("input", handleInput);
document.addEventListener("paste", handlePaste);
document.addEventListener("change", handleChange);
document.addEventListener("selectionchange", handleSelectionChange);
document.addEventListener("pointerdown", handleMouseDown);
document.addEventListener("pointermove", handlePointerMove);
document.addEventListener("pointerup", handlePointerUp);
document.addEventListener("keydown", handleKeyDown);
document.addEventListener("scroll", handleScroll, true);
document.addEventListener("error", handleManagedImageError, true);

// ---- Client error reports ---------------------------------------------------
// Uncaught errors go to `clientErrors` so they show up in Admin -> Settings,
// not only on the screen of the student who hit them. Nothing identifying is
// sent: no uid, no email, no page content.
const reportedClientErrors = new Set();

function getAppBuildLabel() {
  const script = document.querySelector('script[type="module"][src*="app"]');
  return String(script?.getAttribute("src") || "").slice(0, 60);
}

function reportClientError(message, stack = "") {
  try {
    if (!state.firebaseEnabled || !firebase.db || !firebase.api?.addDoc) return;
    const text = String(message || "").trim();
    if (!text || reportedClientErrors.has(text) || reportedClientErrors.size >= CLIENT_ERROR_LIMIT_PER_PAGE) return;
    // Cross-origin scripts and extensions surface as "Script error." with
    // nothing actionable; ResizeObserver loops are benign browser noise.
    if (/^Script error\.?$/i.test(text) || /ResizeObserver loop/i.test(text)) return;
    reportedClientErrors.add(text);
    const { addDoc, collection } = firebase.api;
    addDoc(collection(firebase.db, "clientErrors"), {
      message: text.slice(0, 500),
      stack: String(stack || "").slice(0, 2000),
      route: String(window.location.pathname + window.location.search).slice(0, 200),
      userAgent: String(navigator.userAgent || "").slice(0, 300),
      appVersion: getAppBuildLabel(),
      createdAt: new Date().toISOString()
    }).catch(() => {});
  } catch {
    // Reporting an error must never become an error of its own.
  }
}

window.addEventListener("error", (event) => {
  if (!(event instanceof ErrorEvent)) return;
  reportClientError(event.message, event.error?.stack || `${event.filename}:${event.lineno}:${event.colno}`);
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  reportClientError(reason?.message || String(reason), reason?.stack || "");
});
// An old-style #page link (typed, or in content saved before clean URLs)
// arrives as a hash change and is turned into its clean address. In-page
// anchors such as #app are left to the browser.
window.addEventListener("hashchange", () => {
  if (upgradeLegacyHashRoute()) handleHashChange();
});
// Back and forward. A hash-only change on the same page (an in-page anchor)
// also fires popstate; there is nothing to re-render for it.
window.addEventListener("popstate", () => {
  if (getCurrentRoutePath() !== renderedRoutePath) handleHashChange();
});
window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
window.addEventListener("appinstalled", handleAppInstalled);


function handleBeforeInstallPrompt(event) {
  event.preventDefault();
  deferredInstallPrompt = event;
  document.querySelectorAll("[data-install-app]").forEach((button) => {
    button.hidden = false;
    button.removeAttribute("aria-disabled");
  });
}

function handleAppInstalled() {
  deferredInstallPrompt = null;
  showToast("SkillUp Class installed successfully.");
}

async function installSkillUpApp() {
  if (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone) {
    showToast("SkillUp Class is already installed as an app.");
    return;
  }

  if (!deferredInstallPrompt) {
    showToast("Open Chrome menu and choose Install app or Add to Home screen.");
    return;
  }

  deferredInstallPrompt.prompt();
  const choice = await deferredInstallPrompt.userChoice.catch(() => null);
  deferredInstallPrompt = null;

  if (choice?.outcome === "accepted") {
    showToast("Installing SkillUp Class...");
  } else {
    showToast("Install canceled. You can install later from the browser menu.");
  }
}
function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Service worker registration failed:", error);
    });
  });
}
async function boot() {
  hydrateCachedFirebaseContent();
  upgradeLegacyHashRoute();
  if (window.location.pathname === "/index.html") history.replaceState(history.state, "", `/${window.location.search}`);
  renderedRoutePath = getCurrentRoutePath();
  render();
  endLoading();

  try {
    await initFirebase();
  } finally {
    state.firebaseInitializing = false;
    if (!state.firebaseEnabled) {
      loadLocalContent();
    }
    render();
    endLoading();
  }
}
async function startAppCheck() {
  if (!APP_CHECK_SITE_KEY || !firebase.app) return;
  try {
    const appCheck = await import("./assets/firebase-10.12.2-v1/firebase-app-check.js");
    appCheck.initializeAppCheck(firebase.app, {
      provider: new appCheck.ReCaptchaV3Provider(APP_CHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  } catch (error) {
    console.warn("App Check could not start:", error);
  }
}

// Analytics starts with storage denied. Where Google's consent message runs
// (visitors in the EEA, UK and Switzerland, once it is switched on in AdSense
// -> Privacy & messaging) it reports the visitor's choice through the IAB
// __tcfapi interface, and storage follows that choice - including later
// changes. Where no consent platform appears, none is required, so storage
// is granted.
async function startAnalytics() {
  if (!firebaseConfig?.measurementId || !firebase.app) return;
  try {
    const analytics = await import("./assets/firebase-10.12.2-v1/firebase-analytics.js");
    if (!(await analytics.isSupported())) return;
    analytics.setConsent({
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied"
    });
    firebase.analytics = analytics.getAnalytics(firebase.app);
    firebase.analyticsApi = analytics;
    watchAnalyticsConsent((granted) => {
      analytics.setConsent({ analytics_storage: granted ? "granted" : "denied" });
    });
    trackPageView(getRoute());
  } catch (error) {
    console.warn("Analytics could not start:", error);
  }
}

function watchAnalyticsConsent(onDecision) {
  const listen = () => {
    window.__tcfapi("addEventListener", 2, (tcData, success) => {
      if (!success || !tcData) return;
      if (tcData.eventStatus !== "tcloaded" && tcData.eventStatus !== "useractioncomplete") return;
      onDecision(tcData.gdprApplies === false || Boolean(tcData.purpose?.consents?.[1]));
    });
  };
  if (typeof window.__tcfapi === "function") {
    listen();
    return;
  }
  const started = Date.now();
  const timer = setInterval(() => {
    if (typeof window.__tcfapi === "function") {
      clearInterval(timer);
      listen();
    } else if (Date.now() - started > ANALYTICS_CONSENT_WAIT_MS) {
      clearInterval(timer);
      onDecision(true);
    }
  }, 250);
}

let lastTrackedPagePath = "";

function trackPageView(route) {
  if (!firebase.analytics || !firebase.analyticsApi || route.page === "admin") return;
  const pagePath = `/${route.page || "home"}${route.id ? `/${route.id}` : ""}`;
  if (pagePath === lastTrackedPagePath) return;
  lastTrackedPagePath = pagePath;
  firebase.analyticsApi.logEvent(firebase.analytics, "page_view", {
    page_path: pagePath,
    page_title: document.title,
    page_location: window.location.href
  });
}

async function loadClientErrors({ force = false } = {}) {
  if (!state.isAdmin || !state.firebaseEnabled) return;
  if (state.clientErrorsLoaded && !force) return;
  try {
    const { collection, getDocs, query, orderBy, limit } = firebase.api;
    const snapshot = await getDocs(query(collection(firebase.db, "clientErrors"), orderBy("createdAt", "desc"), limit(25)));
    state.clientErrors = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
  } catch (error) {
    console.warn("Could not load site errors:", error);
    state.clientErrors = [];
  }
  state.clientErrorsLoaded = true;
}

async function clearClientErrors() {
  if (!state.isAdmin) return;
  const { doc, deleteDoc } = firebase.api;
  for (const item of state.clientErrors) {
    await deleteDoc(doc(firebase.db, "clientErrors", item.id)).catch(() => {});
  }
  state.clientErrors = [];
  showToast("Site errors cleared.");
  render();
}

function renderClientErrorsAdminPanel() {
  const errors = state.clientErrors || [];
  return `
    <section class="admin-card client-errors-panel">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Site health</p>
          <h2>Recent site errors</h2>
          <span>Errors students hit in their browser, newest first. No names or emails are recorded.</span>
        </div>
        <div class="admin-actions">
          <button class="button ghost small" type="button" data-refresh-client-errors>Refresh</button>
          ${errors.length ? `<button class="button ghost small" type="button" data-clear-client-errors>Clear all</button>` : ""}
        </div>
      </div>
      ${errors.length ? `
        <ul class="client-error-list">
          ${errors.map((item) => `
            <li>
              <strong>${escapeHtml(item.message)}</strong>
              <small>${escapeHtml(formatRelativeTime(item.createdAt))} · ${escapeHtml(item.route || "")} · ${escapeHtml(item.appVersion || "")}</small>
              ${item.stack ? `<pre>${escapeHtml(String(item.stack).slice(0, 600))}</pre>` : ""}
            </li>
          `).join("")}
        </ul>
      ` : renderEmptyState(state.clientErrorsLoaded ? "No errors reported. Nothing is breaking for students right now." : "Loading...")}
    </section>
  `;
}

async function initFirebase() {
  if (!hasFirebaseConfig()) {
    state.firebaseEnabled = false;
    return;
  }

  try {
    const [appModule, authModule, firestoreModule] = await withTimeout(Promise.all([
      import("./assets/firebase-10.12.2-v1/firebase-app.js"),
      import("./assets/firebase-10.12.2-v1/firebase-auth.js"),
      import("./assets/firebase-10.12.2-v1/firebase-firestore.js")
    ]), FIREBASE_SDK_TIMEOUT_MS, "Loading timed out. Please refresh the page. If it repeats, disable ad blocker/VPN for skillupclass.com and try again.");

    firebase.app = appModule.initializeApp(firebaseConfig);
    firebase.auth = authModule.getAuth(firebase.app);
    firebase.db = firestoreModule.getFirestore(firebase.app);
    firebase.api = { ...authModule, ...firestoreModule };
    // Before any Firestore request, so the first reads already carry a token.
    await startAppCheck();
    state.firebaseEnabled = true;
    startAnalytics();

    authModule.onAuthStateChanged(firebase.auth, async (user) => {
      state.user = user;
      state.isAdmin = isAdminEmail(user?.email);
      state.studentProfile = null;
      state.isContributor = false;
      state.contributorRecord = null;
      state.mySessionBookings = [];
      state.mySessionBookingsLoaded = false;
      state.myCertificates = null;
      state.codingLeaderboard = null;
      state.sessionReviewsLoaded = false;
      state.mySessionReviews = [];
      state.mySessionReviewsLoaded = false;
      state.editingSessionReviewId = null;
      state.adminInsights = null;
      // Re-check on every auth change: a block applied while signed in
      // should take effect on the next load, and a different account must
      // not inherit the previous user's status.
      state.blockedRecord = null;
      state.blockedRecordChecked = false;
      if (user && !state.isAdmin) {
        await loadContributorRecord(user);
      }
      // A contributor account is not a student account: no student profile
      // is created for it.
      if (user && !state.isAdmin && !state.isContributor) {
        await ensureStudentProfile(user).catch((error) => console.warn("Could not sync student profile:", error));
        state.studentProfile = await loadCurrentStudentProfile(user).catch((error) => {
          console.warn("Could not load student profile:", error);
          return null;
        });
        await loadBlockedRecordForCurrentUser({ force: true });
      }
      await loadCommunityPolicy().catch(() => {});
      const route = getRoute();

      if ((state.isAdmin || state.isContributor) && route.page === "admin") {
        await loadContent({ admin: true });
      } else {
        await loadRouteContent(route, { quiet: true });
      }

      render();
    });
  } catch (error) {
    state.firebaseEnabled = false;
    state.firebaseError = describeConnectionError(error);
  }
}

// Shown on the admin, login and registration forms. The raw SDK message names
// the backend service, so visitors get a plain line and the detail goes to the
// console.
function describeConnectionError(error) {
  console.warn("Connection error:", error);
  return "Could not connect right now. Refresh the page and try again.";
}

function withTimeout(promise, timeoutMs, message) {
  let timerId;
  const timeout = new Promise((_, reject) => {
    timerId = window.setTimeout(() => reject(new Error(message)), timeoutMs);
  });
  return Promise.race([promise, timeout]).finally(() => window.clearTimeout(timerId));
}function hasFirebaseConfig() {
  if (!USE_FIREBASE) return false;
  return Object.values(firebaseConfig).every((value) => {
    const text = String(value || "");
    return text && !text.startsWith("YOUR_");
  });
}

async function loadContent({ admin = false, quiet = false } = {}) {
  if (!state.firebaseEnabled) {
    loadLocalContent();
    return;
  }

  // The dashboard's full load is the admin's; a contributor gets published
  // content plus their own submissions.
  if (admin && !state.isAdmin) {
    if (state.isContributor) await loadContributorContent({ quiet });
    return;
  }

  if (!quiet) beginLoading(admin ? "Loading admin content..." : "Loading courses and tutorials...");
  try {
    const canReadLearning = admin || canReadTutorials();
    const [articles, tutorials, subjects, blogs, codingProblems, codingMeta, siteNavigation] = await Promise.all([
      canReadLearning ? loadCollection("articles", admin) : Promise.resolve([]),
      loadCollection("tutorials", admin),
      loadCollection("subjects", admin).catch(() => []),
      loadCollection("blogs", admin).catch(() => []),
      canReadLearning ? loadCollection("codingProblems", admin).catch(() => []) : Promise.resolve([]),
      loadCodingMeta().catch(() => null),
      loadSiteNavigation({ force: admin }).catch(() => null)
    ]);

    let inquiries = [];
    let students = [];
    let adminComments = [];
    state.adminStudentLoadError = "";
    state.adminCommentLoadError = "";

    if (admin) {
      const [inquiriesResult, studentsResult, commentsResult] = await Promise.allSettled([loadInquiries(), loadStudents(), loadAdminComments()]);
      if (inquiriesResult.status === "fulfilled") {
        inquiries = inquiriesResult.value;
      } else {
        console.warn("Could not load course inquiries:", inquiriesResult.reason);
      }
      if (studentsResult.status === "fulfilled") {
        students = studentsResult.value;
      } else {
        state.adminStudentLoadError = formatAdminLoadError(studentsResult.reason);
        console.warn("Could not load students:", studentsResult.reason);
      }
      if (commentsResult.status === "fulfilled") {
        adminComments = commentsResult.value;
      } else {
        state.adminCommentLoadError = formatAdminLoadError(commentsResult.reason);
        console.warn("Could not load flagged comments:", commentsResult.reason);
      }
    }

    state.articles = articles;
    state.tutorials = tutorials;
    state.blogs = blogs;
    state.codingMeta = codingMeta ? normalizeCodingMeta(codingMeta) : state.codingMeta;
    if (siteNavigation) {
      state.siteNavigation = normalizeSiteNavigation(siteNavigation);
      state.siteNavigationReady = true;
    }
    state.codingProblems = codingProblems.map((item, index) => normalizeCodingProblem(item, index + 1));
    state.subjects = getNormalizedSubjects(subjects, articles);
    state.inquiries = admin ? await cleanupExpiredInquiries(inquiries) : [];
    state.students = admin ? students : [];
    state.adminComments = admin ? adminComments : [];
    if (admin) {
      adminContentLoaded = true;
      // Needed so each moderation row knows whether its author is already
      // blocked, and to render the blocked-students list.
      await refreshAdminBlockedUsers();
      await loadContributors();
      await Promise.all([
        loadSessions({ force: true }),
        loadSessionAvailability({ force: true }),
        loadAdminSessionBookings(),
        loadTakenSessionSlots({ force: true }),
        loadSessionReviews({ force: true })
      ]);
    }

    if (!admin) {
      cacheFirebaseContent({ articles, tutorials, subjects, blogs, codingProblems, codingMeta: state.codingMeta, siteNavigation: state.siteNavigation });
    }
  } catch (error) {
    state.firebaseError = describeConnectionError(error);
    if (!quiet) showToast("Could not load the latest content. Refresh the page and try again.");
  } finally {
    if (!quiet) endLoading();
  }
}
// ---- Contributors -----------------------------------------------------------
//
// A contributor is someone the admin added in Admin > Contributors. They sign
// in on the admin page and see only Tutorials, Coding Problems, Courses, Blogs
// and Events. Everything they save is a draft credited to them, which the
// admin reviews and publishes. firestore.rules and storage.rules enforce this;
// the dashboard only mirrors it.
const CONTRIBUTOR_ADMIN_TYPES = ["articles", "codingProblems", "tutorials", "blogs", "events"];
const CONTRIBUTABLE_COLLECTIONS = ["articles", "tutorials", "blogs", "codingProblems", "events"];

function getContributorKey(email) {
  return String(email || "").trim().toLowerCase();
}

async function loadContributorRecord(user) {
  state.isContributor = false;
  state.contributorRecord = null;
  if (!state.firebaseEnabled || !user?.email) return;
  try {
    const { doc, getDoc } = firebase.api;
    const snapshot = await getDoc(doc(firebase.db, "contributors", getContributorKey(user.email)));
    if (snapshot.exists() && snapshot.data().active === true) {
      state.contributorRecord = { id: snapshot.id, ...snapshot.data() };
      state.isContributor = true;
      // Links the record to this account, so the admin can match drafts to
      // the person without the email being stored on the drafts.
      if (snapshot.data().uid !== user.uid && user.emailVerified) {
        firebase.api.setDoc(snapshot.ref, { uid: user.uid, updatedAt: new Date().toISOString() }, { merge: true })
          .then(() => { if (state.contributorRecord) state.contributorRecord.uid = user.uid; })
          .catch((error) => console.warn("Could not link contributor record:", error));
      }
      if (!CONTRIBUTOR_ADMIN_TYPES.includes(state.adminType)) state.adminType = "articles";
    }
  } catch (error) {
    console.warn("Could not check contributor access:", error);
  }
}

function isContributorEmailConfirmed() {
  return Boolean(state.user?.emailVerified);
}

function isOwnContribution(item) {
  return Boolean(item && state.user && item.submittedByUid === state.user.uid);
}

// A contributor may change an item only while it is their own draft; a new
// item (no existing record) is always theirs to write.
function canContributorEdit(item) {
  return !item || (isOwnContribution(item) && item.status === "draft");
}

// What the dashboard lists: everything for the admin, only their own
// submissions for a contributor.
function getAdminListItems(items) {
  return !state.isAdmin && state.isContributor ? items.filter(isOwnContribution) : items;
}

// Contributors see only the sections they can add to, without group labels.
function getAdminNavItemsForRole(items) {
  if (state.isAdmin || !state.isContributor) return items;
  return items.filter((item) => !item.group && CONTRIBUTOR_ADMIN_TYPES.includes(item.type));
}

// A contributor's save is always a draft credited to them by account id and
// name. Their email is not stored on the content, which anyone can read once
// it is published. Saving again puts it back in the admin's review queue.
function applyContributorDraft(payload, existing) {
  return {
    ...payload,
    ...(Object.prototype.hasOwnProperty.call(payload, "publishedAt") ? { publishedAt: "" } : {}),
    status: "draft",
    reviewStatus: "pending",
    reviewNote: "",
    submittedByUid: state.user.uid,
    submittedByName: String(state.contributorRecord?.name || state.user.displayName || String(state.user.email || "").split("@")[0] || "Contributor").slice(0, 120),
    submittedAt: existing?.submittedAt || new Date().toISOString()
  };
}

// Kept through normalizing so the credit survives a reload.
function pickContributionFields(source = {}) {
  return source.submittedByUid
    ? {
        submittedByUid: String(source.submittedByUid),
        submittedByName: String(source.submittedByName || ""),
        submittedAt: String(source.submittedAt || ""),
        reviewStatus: String(source.reviewStatus || "pending"),
        reviewNote: String(source.reviewNote || "")
      }
    : {};
}

// Published content (for the public pages) plus the contributor's own
// submissions, which the public queries cannot return.
async function loadContributorContent({ quiet = false } = {}) {
  if (!state.firebaseEnabled || !state.user) return;
  if (!quiet) beginLoading("Loading your drafts...");
  try {
    const { collection, getDocs, query, where } = firebase.api;
    const ownItems = (name) => getDocs(query(collection(firebase.db, name), where("submittedByUid", "==", state.user.uid)))
      .then((snapshot) => snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() })));
    const [, ownArticles, ownCourses, ownBlogs, ownProblems] = await Promise.all([
      loadContent({ quiet: true }),
      ownItems("articles"),
      ownItems("tutorials"),
      ownItems("blogs"),
      ownItems("codingProblems")
    ]);
    const merge = (published, own, normalize) => {
      const byId = new Map(published.map((item) => [item.id, item]));
      own.forEach((item, index) => byId.set(item.id, normalize(item, index + 1)));
      return [...byId.values()];
    };
    state.articles = merge(state.articles, ownArticles, (item, order) => normalizeItem(item, "articles", order));
    state.tutorials = merge(state.tutorials, ownCourses, (item, order) => normalizeItem(item, "tutorials", order));
    state.blogs = merge(state.blogs, ownBlogs, (item, order) => normalizeItem(item, "blogs", order));
    state.codingProblems = merge(state.codingProblems, ownProblems, (item, order) => normalizeCodingProblem(item, order));
    state.subjects = getNormalizedSubjects(state.subjects, state.articles);
    await loadEventsForDashboard();
    adminContentLoaded = true;
  } catch (error) {
    console.warn("Could not load contributor drafts:", error);
    if (!quiet) showToast("Could not load your drafts. Refresh the page and try again.");
  } finally {
    if (!quiet) endLoading();
  }
}

// Events for the dashboard: published ones, plus a contributor's own drafts.
async function loadEventsForDashboard() {
  await loadEvents({ force: true });
  if (state.isAdmin || !state.isContributor || !state.user) return;
  const { collection, getDocs, query, where } = firebase.api;
  const snapshot = await getDocs(query(collection(firebase.db, "events"), where("submittedByUid", "==", state.user.uid)));
  const byId = new Map(state.events.map((item) => [item.id, item]));
  snapshot.docs.forEach((docSnap) => byId.set(docSnap.id, normalizeEvent({ id: docSnap.id, ...docSnap.data() })));
  state.events = [...byId.values()];
}

async function loadCollection(collectionName, admin) {
  const { collection, getDocs, orderBy, query, where } = firebase.api;
  const collectionRef = collection(firebase.db, collectionName);
  const constraints = collectionName === "subjects"
    ? [orderBy("order", "asc")]
    : admin
      ? [orderBy("updatedAt", "desc")]
      : collectionName === "articles" || collectionName === "blogs"
        ? [where("status", "==", "published"), orderBy("publishedAt", "desc")]
        : [where("status", "==", "published"), orderBy("order", "asc")];

  const snapshot = await getDocs(query(collectionRef, ...constraints));
  return snapshot.docs.map((docSnap, index) => {
    const item = { id: docSnap.id, ...docSnap.data() };
    return collectionName === "subjects" ? normalizeSubject(item, index + 1) : normalizeItem(item, collectionName, index + 1);
  });
}
async function loadCodingMeta() {
  if (!state.firebaseEnabled) return state.codingMeta || getDefaultCodingMeta();

  const { doc, getDoc } = firebase.api;
  const snapshot = await getDoc(doc(firebase.db, "siteSettings", "codingPractice"));
  return snapshot.exists() ? normalizeCodingMeta(snapshot.data()) : getDefaultCodingMeta();
}
function getDefaultSiteNavigation() {
  const visibleTabs = {};
  PUBLIC_NAV_TABS.forEach((tab) => {
    visibleTabs[tab.id] = true;
  });
  return { visibleTabs, updatedAt: "" };
}

function normalizeSiteNavigation(settings = {}) {
  const defaults = getDefaultSiteNavigation();
  const sourceTabs = settings.visibleTabs && typeof settings.visibleTabs === "object" ? settings.visibleTabs : {};
  const hiddenTabs = Array.isArray(settings.hiddenTabs) ? new Set(settings.hiddenTabs.map((id) => String(id))) : new Set();
  const visibleTabs = {};

  PUBLIC_NAV_TABS.forEach((tab) => {
    visibleTabs[tab.id] = Object.prototype.hasOwnProperty.call(sourceTabs, tab.id)
      ? sourceTabs[tab.id] !== false
      : !hiddenTabs.has(tab.id) && defaults.visibleTabs[tab.id] !== false;
  });

  return {
    visibleTabs,
    updatedAt: String(settings.updatedAt || "")
  };
}

// ---- Community policy, spam heuristics, and moderation blocks ---------

const COMMUNITY_POLICY_DOC = "communityPolicy";

function getDefaultCommunityPolicy() {
  return {
    body: [
      "Keep posts related to learning and building - questions, code, and feedback are all welcome.",
      "No promotions, advertising, referral or affiliate links, or recruiting.",
      "Do not share phone numbers, WhatsApp or Telegram handles, emails, or payment details.",
      "Be respectful. No harassment, hate speech, or personal attacks.",
      "Posts that break these rules can be hidden or removed, and repeat offenders can be blocked."
    ].join("\n"),
    updatedAt: ""
  };
}

function normalizeCommunityPolicy(raw = {}) {
  const fallback = getDefaultCommunityPolicy();
  const body = String(raw.body || "").trim();
  return {
    body: body || fallback.body,
    updatedAt: String(raw.updatedAt || "")
  };
}

function getCommunityPolicy() {
  return state.communityPolicy || getDefaultCommunityPolicy();
}

async function loadCommunityPolicy({ force = false } = {}) {
  if (!state.firebaseEnabled) return getCommunityPolicy();
  if (!force && state.communityPolicyReady) return getCommunityPolicy();

  try {
    const { doc, getDoc } = firebase.api;
    const snapshot = await getDoc(doc(firebase.db, "siteSettings", COMMUNITY_POLICY_DOC));
    state.communityPolicy = normalizeCommunityPolicy(snapshot.exists() ? snapshot.data() : {});
  } catch (error) {
    console.warn("Could not load the community policy:", error);
    state.communityPolicy = getDefaultCommunityPolicy();
  }
  state.communityPolicyReady = true;
  return getCommunityPolicy();
}

async function saveCommunityPolicy(body) {
  if (!state.isAdmin) return false;

  const trimmed = String(body || "").trim();
  if (!trimmed) {
    showToast("Add the policy text before saving.");
    return false;
  }

  try {
    const { doc, setDoc } = firebase.api;
    const payload = { body: trimmed.slice(0, 4000), updatedAt: new Date().toISOString() };
    await setDoc(doc(firebase.db, "siteSettings", COMMUNITY_POLICY_DOC), payload);
    state.communityPolicy = normalizeCommunityPolicy(payload);
    state.communityPolicyReady = true;
    showToast("Community policy saved.");
    return true;
  } catch (error) {
    showToast("Could not save the community policy.");
    console.warn("Could not save community policy:", error);
    return false;
  }
}

// Browser-side spam heuristics. This is a guardrail, not a wall - anyone
// determined can edit the page and skip it. Its real job is to warn the
// student and to mark the post `suspicious` so it reaches the admin
// review queue even when nobody reports it.
const SUSPICIOUS_PATTERNS = [
  { test: /\bhttps?:\/\/|\bwww\.|\b[a-z0-9-]+\.(com|net|org|in|io|co|me|xyz|shop|link)\b/i, reason: "links to another site" },
  { test: /(\+?\d[\d\s-]{8,}\d)/, reason: "a phone number" },
  { test: /[\w.+-]+@[\w-]+\.[a-z]{2,}/i, reason: "an email address" },
  { test: /\b(whats\s?app|whtsapp|telegram|insta(gram)?\s*(id|handle)?|dm\s+me|inbox\s+me|ping\s+me)\b/i, reason: "a request to move the chat elsewhere" },
  { test: /\b(referral|refer\s*&?\s*earn|affiliate|promo\s*code|coupon|cashback|discount|limited\s+offer|buy\s+now|order\s+now|subscribe\s+my|join\s+my)\b/i, reason: "promotional wording" },
  { test: /\b(upi|paytm|phonepe|gpay|google\s?pay|bank\s+transfer|paid\s+course)\b/i, reason: "payment details" },
  { test: /(.)\1{6,}/, reason: "repeated characters" }
];

function analysePostContent(body = "") {
  const text = String(body || "");
  const reasons = [];
  SUSPICIOUS_PATTERNS.forEach((pattern) => {
    if (pattern.test.test(text)) reasons.push(pattern.reason);
  });

  const letters = text.replace(/[^A-Za-z]/g, "");
  if (letters.length >= 20 && letters === letters.toUpperCase()) {
    reasons.push("all capital letters");
  }

  return { suspicious: reasons.length > 0, reasons };
}

// The WhatsApp invite is deliberately public: it is a shareable invite
// link, and the point is reach. It rides on the community document, which
// is already public-read, so no extra fetch or collection is needed.
// Trade-off accepted: someone can join the WhatsApp group without going
// through the on-site policy gate.
function normalizeWhatsappInvite(value) {
  const url = String(value || "").trim();
  return url.startsWith("https://chat.whatsapp.com/") ? url.slice(0, 300) : "";
}

function renderCommunityWhatsappCta(community) {
  const url = safeUrl(community?.whatsappUrl);
  if (!url) return "";

  return `
    <div class="community-whatsapp-cta">
      <div>
        <strong>Continue the chat on WhatsApp</strong>
        <span>The community rules apply there too.</span>
      </div>
      <a class="button primary small" href="${escapeAttr(url)}" target="_blank" rel="noreferrer noopener">
        Join WhatsApp group
      </a>
    </div>
  `;
}

// ---- Events: admin-created sessions students can register for ---------
// Three collections rather than one document:
//   events/{id}                         public once published
//   eventRegistrations/{eventId}_{uid}  admin + the student who made it
//   eventMeetings/{eventId}             admin + registered students only
// The split exists so the meeting link is not sitting on a document the
// whole internet can read. See the comments in firestore.rules.

const EVENT_MODES = [
  { id: "online", label: "Online" },
  { id: "offline", label: "In person" },
  { id: "hybrid", label: "Hybrid" }
];

function normalizeEvent(raw = {}) {
  return {
    id: String(raw.id || ""),
    title: String(raw.title || "").trim() || "Untitled event",
    slug: String(raw.slug || raw.id || ""),
    description: String(raw.description || ""),
    coverImage: String(raw.coverImage || ""),
    coverImagePath: String(raw.coverImagePath || ""),
    startAt: String(raw.startAt || ""),
    endAt: String(raw.endAt || ""),
    mode: EVENT_MODES.some((mode) => mode.id === raw.mode) ? raw.mode : "online",
    location: String(raw.location || ""),
    host: String(raw.host || ""),
    capacity: Number(raw.capacity || 0),
    seatsTaken: Number(raw.seatsTaken || 0),
    status: raw.status === "archived" || raw.status === "draft" ? raw.status : "published",
    createdAt: String(raw.createdAt || ""),
    updatedAt: String(raw.updatedAt || ""),
    ...pickContributionFields(raw)
  };
}

function eventStartTime(event) {
  const time = new Date(event?.startAt || 0).getTime();
  return Number.isNaN(time) ? 0 : time;
}

// Events are often published without an end time. Rather than treating
// those as finished the instant they start, give them an assumed run time
// so they can still read as "happening now".
const EVENT_ASSUMED_RUN_MS = 2 * 60 * 60 * 1000;

function eventEndTime(event) {
  const end = new Date(event?.endAt || 0).getTime();
  if (!Number.isNaN(end) && end) return end;
  const start = eventStartTime(event);
  return start ? start + EVENT_ASSUMED_RUN_MS : 0;
}

// An event counts as past only once its end time has gone by; a session that
// has started but not finished should still read as "happening now".
function isPastEvent(event) {
  const end = eventEndTime(event);
  if (!end) return false;
  return end < Date.now();
}

function isLiveEvent(event) {
  const start = eventStartTime(event);
  if (!start) return false;
  const now = Date.now();
  return start <= now && now <= eventEndTime(event);
}

function getLiveEvents() {
  return getPublicEvents().filter(isLiveEvent);
}

function getPublicEvents() {
  return state.events
    .filter((event) => event.status === "published")
    .sort((a, b) => eventStartTime(a) - eventStartTime(b));
}

function getUpcomingEvents() {
  return getPublicEvents().filter((event) => !isPastEvent(event));
}

function getPastEvents() {
  return getPublicEvents().filter(isPastEvent).reverse();
}

function getAdminEvents() {
  return getAdminListItems([...state.events]).sort((a, b) => eventStartTime(b) - eventStartTime(a));
}

function findEventById(id) {
  return state.events.find((event) => event.id === id) || null;
}

async function loadEvents({ force = false } = {}) {
  if (!state.firebaseEnabled) return false;
  if (state.eventsLoaded && !force) return false;

  try {
    const { collection, getDocs, query, where } = firebase.api;
    // Same filter-must-match-the-rule constraint as loadCommunities: a
    // non-admin list query needs where("status","==","published") or
    // Firestore refuses the whole read.
    const constraints = state.isAdmin ? [] : [where("status", "==", "published")];
    const snapshot = await getDocs(query(collection(firebase.db, "events"), ...constraints));
    state.events = snapshot.docs.map((docSnap) => normalizeEvent({ id: docSnap.id, ...docSnap.data() }));
    state.eventsLoaded = true;
    return true;
  } catch (error) {
    console.warn("Could not load events:", error);
    return false;
  }
}

function eventPayload(formData) {
  const now = new Date().toISOString();
  const existing = findEventById(state.editingEventId);
  const title = String(formData.get("title") || "").trim();
  const slug = existing?.id || slugify(title);
  return {
    id: slug,
    title,
    slug,
    description: String(formData.get("description") || "").trim().slice(0, 1200),
    coverImage: String(formData.get("coverImage") || "").trim(),
    coverImagePath: String(formData.get("coverImagePath") || "").trim(),
    startAt: localInputToIso(formData.get("startAt")),
    endAt: localInputToIso(formData.get("endAt")),
    mode: EVENT_MODES.some((mode) => mode.id === formData.get("mode")) ? String(formData.get("mode")) : "online",
    location: String(formData.get("location") || "").trim().slice(0, 200),
    host: String(formData.get("host") || "").trim().slice(0, 120),
    capacity: Math.max(0, Number(formData.get("capacity") || 0)),
    // Carried through so saving the form never resets a published count.
    seatsTaken: Math.max(0, Number(existing?.seatsTaken || 0)),
    status: ["archived", "draft"].includes(formData.get("status")) ? String(formData.get("status")) : "published",
    createdAt: existing?.createdAt || now,
    updatedAt: now
  };
}

async function saveEvent(payload) {
  const asContributor = !state.isAdmin && state.isContributor;
  if (!state.isAdmin && !asContributor) return false;
  if (asContributor) {
    const editingEvent = findEventById(state.editingEventId);
    if (editingEvent && !canContributorEdit(editingEvent)) {
      showToast("This event is published, so only the admin can change it now.");
      return false;
    }
    if (!isContributorEmailConfirmed()) {
      showToast("Confirm your email before saving drafts.");
      return false;
    }
    payload = applyContributorDraft(payload, editingEvent);
  }
  if (!payload.title) {
    showToast("Give the event a title.");
    return false;
  }
  if (!payload.startAt) {
    showToast("Pick a start date and time.");
    return false;
  }
  if (payload.endAt && new Date(payload.endAt) < new Date(payload.startAt)) {
    showToast("The end time cannot be before the start time.");
    return false;
  }
  if (!state.firebaseEnabled) {
    showToast("Events are not available right now. Please try again later.");
    return false;
  }
  const duplicate = state.events.find((event) => event.id === payload.id && event.id !== state.editingEventId);
  if (duplicate) {
    showToast("An event with this title already exists.");
    return false;
  }

  try {
    const { doc, setDoc } = firebase.api;
    const previousEvent = findEventById(state.editingEventId);
    const written = !asContributor && previousEvent?.submittedByUid ? { ...payload, submittedByEmail: firebase.api.deleteField() } : payload;
    await setDoc(doc(firebase.db, "events", payload.id), written, { merge: true });
    await loadEventsForDashboard();
    state.editingEventId = null;
    showToast(asContributor ? "Draft event saved. The admin will review it." : "Event saved.");
    render();
    return true;
  } catch (error) {
    showToast("Could not save this event. Please try again.");
    console.warn("Could not save event:", error);
    return false;
  }
}

async function deleteEvent(eventId) {
  if (!state.isAdmin) {
    const draft = findEventById(eventId);
    if (!state.isContributor || !draft || !canContributorEdit(draft)) return;
    try {
      await firebase.api.deleteDoc(firebase.api.doc(firebase.db, "events", eventId));
      await loadEventsForDashboard();
      showToast("Draft event removed.");
      render();
    } catch (error) {
      showToast("Could not remove this draft. Please try again.");
      console.warn("Could not remove draft event:", error);
    }
    return;
  }
  try {
    const { doc, deleteDoc, collection, getDocs, query, where } = firebase.api;
    // Clear the registrations and the meeting link too, so deleting an event
    // does not leave student records pointing at something that no longer
    // exists - the same orphan problem fixed for community replies.
    try {
      const snapshot = await getDocs(query(
        collection(firebase.db, "eventRegistrations"),
        where("eventId", "==", eventId)
      ));
      for (const registration of snapshot.docs) {
        await deleteDoc(registration.ref);
      }
      await deleteDoc(doc(firebase.db, "eventMeetings", eventId));
    } catch (cleanupError) {
      console.warn("Could not remove every record attached to this event:", cleanupError);
    }
    await deleteDoc(doc(firebase.db, "events", eventId));
    delete state.eventRegistrations[eventId];
    delete state.eventMeetings[eventId];
    await loadEvents({ force: true });
    showToast("Event deleted.");
    render();
  } catch (error) {
    showToast("Could not delete this event. Please try again.");
    console.warn("Could not delete event:", error);
  }
}

// ---- Student registration --------------------------------------------

// Capacity. The admin's registration list is the real count; this is the
// published copy students can read. It is a guardrail, not a hard limit -
// two people registering between admin refreshes can both get through. A
// strict limit would need a trusted process holding the counter.
function getEventSeatsTaken(event) {
  const adminList = state.eventRegistrations[event?.id];
  if (Array.isArray(adminList)) return adminList.length;
  return Math.max(0, Number(event?.seatsTaken || 0));
}

function getEventSeatsLeft(event) {
  if (!event?.capacity) return null;
  return Math.max(0, event.capacity - getEventSeatsTaken(event));
}

function isEventFull(event) {
  const left = getEventSeatsLeft(event);
  return left !== null && left <= 0;
}

// Called after the admin loads registrations, so the number students see
// tracks reality without them needing to read the list themselves.
async function publishEventSeatCount(eventId) {
  if (!state.isAdmin || !state.firebaseEnabled) return;
  const event = findEventById(eventId);
  const registrations = state.eventRegistrations[eventId];
  if (!event || !Array.isArray(registrations)) return;
  if (Number(event.seatsTaken || 0) === registrations.length) return;

  try {
    const { doc, updateDoc } = firebase.api;
    await updateDoc(doc(firebase.db, "events", eventId), {
      seatsTaken: registrations.length,
      updatedAt: new Date().toISOString()
    });
    event.seatsTaken = registrations.length;
  } catch (error) {
    console.warn("Could not publish the seat count:", error);
  }
}

function isRegisteredForEvent(eventId) {
  return Boolean(state.myEventRegistrations[eventId]);
}

async function loadMyEventRegistrations({ force = false } = {}) {
  if (!state.firebaseEnabled || !state.user) return false;
  if (state.myEventRegistrationsLoaded && !force) return false;

  try {
    const { collection, getDocs, query, where } = firebase.api;
    // where("uid","==",own uid) matches the read rule exactly, so this list
    // query is provably safe and Firestore allows it.
    const snapshot = await getDocs(query(
      collection(firebase.db, "eventRegistrations"),
      where("uid", "==", state.user.uid)
    ));
    const registrations = {};
    snapshot.docs.forEach((docSnap) => {
      const eventId = String(docSnap.data().eventId || "");
      if (eventId) registrations[eventId] = true;
    });
    state.myEventRegistrations = registrations;
    state.myEventRegistrationsLoaded = true;
    return true;
  } catch (error) {
    console.warn("Could not load your event registrations:", error);
    return false;
  }
}

async function registerForEvent(eventId) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to register for an event.");
    return;
  }
  if (!isEmailVerified()) {
    promptEmailVerification("register for events");
    return;
  }
  if (isBlockedFromArea("events")) {
    showToast("An admin has blocked your account from registering for events.");
    return;
  }

  const event = findEventById(eventId);
  if (!event || event.status !== "published") {
    showToast("This event is no longer open for registration.");
    return;
  }
  if (isEventFull(event)) {
    showToast("This event is full. Check back in case a place opens up.");
    return;
  }

  try {
    const { doc, setDoc } = firebase.api;
    const registration = {
      eventId,
      uid: state.user.uid,
      studentName: state.studentProfile?.name || state.user.displayName || "Student",
      // Stored so the admin can send the meeting invite without having to
      // cross-reference the students collection.
      studentEmail: state.studentProfile?.email || state.user.email || "",
      registeredAt: new Date().toISOString(),
      status: "registered"
    };
    await setDoc(doc(firebase.db, "eventRegistrations", eventId + "_" + state.user.uid), registration);
    state.myEventRegistrations[eventId] = true;
    delete state.eventRegistrations[eventId];
    showToast("You're registered. Meeting details appear here once the admin shares them.");
    render();
    loadEventMeeting(eventId, { force: true });
  } catch (error) {
    showToast("Could not register for this event. Please try again.");
    console.warn("Could not register for event:", error);
  }
}

async function cancelEventRegistration(eventId) {
  if (!state.user) return;
  try {
    const { doc, deleteDoc } = firebase.api;
    await deleteDoc(doc(firebase.db, "eventRegistrations", eventId + "_" + state.user.uid));
    delete state.myEventRegistrations[eventId];
    delete state.eventRegistrations[eventId];
    delete state.eventMeetings[eventId];
    showToast("Registration cancelled.");
    render();
  } catch (error) {
    showToast("Could not cancel your registration. Please try again.");
    console.warn("Could not cancel registration:", error);
  }
}

// ---- Admin: who registered, and the meeting link ----------------------

async function loadEventRegistrations(eventId, { force = false } = {}) {
  if (!state.firebaseEnabled || !state.isAdmin || !eventId) return false;
  if (state.eventRegistrationLoading.has(eventId)) return false;
  if (state.eventRegistrations[eventId] && !force) return false;

  state.eventRegistrationLoading.add(eventId);
  try {
    const { collection, getDocs, query, where } = firebase.api;
    // Sorted client-side: adding orderBy() here would need a composite
    // index, and the list is small enough that it is not worth one.
    const snapshot = await getDocs(query(
      collection(firebase.db, "eventRegistrations"),
      where("eventId", "==", eventId)
    ));
    state.eventRegistrations[eventId] = snapshot.docs
      .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
      .sort((a, b) => String(a.registeredAt).localeCompare(String(b.registeredAt)));
    state.eventRegistrationError[eventId] = "";
    await publishEventSeatCount(eventId);
    return true;
  } catch (error) {
    state.eventRegistrationError[eventId] = "Could not load registrations for this event.";
    console.warn("Could not load event registrations:", error);
    return false;
  } finally {
    state.eventRegistrationLoading.delete(eventId);
  }
}

async function loadEventMeeting(eventId, { force = false } = {}) {
  if (!state.firebaseEnabled || !eventId || !state.user) return false;
  if (state.eventMeetingLoading.has(eventId)) return false;
  if (eventId in state.eventMeetings && !force) return false;
  if (!state.isAdmin && !isRegisteredForEvent(eventId)) return false;

  state.eventMeetingLoading.add(eventId);
  try {
    const { doc, getDoc } = firebase.api;
    const snap = await getDoc(doc(firebase.db, "eventMeetings", eventId));
    state.eventMeetings[eventId] = snap.exists() ? snap.data() : null;
    return true;
  } catch (error) {
    // A denial here is expected for anyone not registered, so it is not
    // surfaced to the student - the page simply shows no meeting details.
    state.eventMeetings[eventId] = null;
    console.warn("Could not load meeting details:", error);
    return false;
  } finally {
    state.eventMeetingLoading.delete(eventId);
  }
}

async function saveEventMeeting(eventId, meetingLink, meetingNote) {
  if (!state.isAdmin) return false;
  const link = String(meetingLink || "").trim().slice(0, 500);
  if (link && !/^https:\/\//i.test(link)) {
    showToast("The meeting link must start with https://");
    return false;
  }

  try {
    const { doc, setDoc } = firebase.api;
    const payload = {
      eventId,
      meetingLink: link,
      meetingNote: String(meetingNote || "").trim().slice(0, 500),
      updatedAt: new Date().toISOString()
    };
    await setDoc(doc(firebase.db, "eventMeetings", eventId), payload);
    state.eventMeetings[eventId] = payload;
    showToast(link ? "Meeting link saved. Registered students can see it now." : "Meeting link cleared.");
    render();
    return true;
  } catch (error) {
    showToast("Could not save the meeting details. Please try again.");
    console.warn("Could not save meeting details:", error);
    return false;
  }
}

function getEventRegistrationEmails(eventId) {
  return (state.eventRegistrations[eventId] || [])
    .map((registration) => String(registration.studentEmail || "").trim())
    .filter(Boolean);
}

// Queues a real email through the `mail` collection, which the Firebase
// Trigger Email extension picks up - the same pipeline course inquiries
// already use. Recipients go in bcc so nobody sees the attendee list.
async function sendEventInviteEmail(event) {
  if (!state.isAdmin) return false;
  const emails = getEventRegistrationEmails(event.id);
  if (!emails.length) {
    showToast("Nobody has registered for this event yet.");
    return false;
  }

  const meeting = state.eventMeetings[event.id];
  const lines = buildEventInviteLines(event, meeting);

  try {
    const { collection, doc, setDoc } = firebase.api;
    await setDoc(doc(collection(firebase.db, "mail")), {
      bcc: emails.slice(0, 200),
      replyTo: INQUIRY_EMAIL,
      createdAt: new Date().toISOString(),
      message: {
        subject: `Meeting invite: ${event.title}`,
        text: lines.join("\n"),
        html: lines.map((line) => line ? `<p>${escapeHtml(line)}</p>` : "<br>").join("")
      }
    });
    showToast(`Invite queued for ${emails.length} registrant${emails.length === 1 ? "" : "s"}.`);
    return true;
  } catch (error) {
    showToast("Could not queue the invite. Use \"Open in mail app\" instead.");
    console.warn("Could not queue event invite email:", error);
    return false;
  }
}

function buildEventInviteLines(event, meeting) {
  const lines = [
    "Hello,",
    "",
    'You are registered for "' + event.title + '".',
    "",
    "When: " + formatEventDateTime(event.startAt) + (event.endAt ? " - " + formatEventDateTime(event.endAt) : "")
  ];
  if (event.mode !== "online" && event.location) lines.push("Where: " + event.location);
  if (meeting && meeting.meetingLink) lines.push("Join here: " + meeting.meetingLink);
  if (meeting && meeting.meetingNote) lines.push("", meeting.meetingNote);
  lines.push("", "See you there,", "SkillUp Class");
  return lines;
}

// Built as a mailto: because this is static hosting with no mail backend.
// Addresses go in bcc so registrants never see each other's email address.
function buildEventInviteMailto(event, meeting) {
  const emails = getEventRegistrationEmails(event.id);
  if (!emails.length) return "";

  const lines = buildEventInviteLines(event, meeting);

  const params = new URLSearchParams({
    bcc: emails.join(","),
    subject: "Meeting invite: " + event.title,
    body: lines.join("\n")
  });
  // URLSearchParams encodes spaces as "+", which mail clients render
  // literally inside the body - so put real percent-encoding back.
  return "mailto:?" + params.toString().replace(/\+/g, "%20");
}

function formatEventDateTime(value) {
  if (!value) return "Date to be announced";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Date to be announced";
  return date.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
}

// <input type="datetime-local"> gives "2026-10-05T18:30" with no zone, which
// new Date() reads as local time - exactly what the admin typed.
function localInputToIso(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
}

function isoToLocalInput(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate())
    + "T" + pad(date.getHours()) + ":" + pad(date.getMinutes());
}

function getBlockedAreas() {
  const areas = state.blockedRecord?.areas;
  return Array.isArray(areas) ? areas : [];
}

function isBlockedFromArea(area) {
  const areas = getBlockedAreas();
  return areas.includes(area) || areas.includes("all");
}

// The signed-in student's own block record. Rules let a user read only
// their own, so this is a single cheap document read used to explain why
// posting is disabled instead of letting the write fail.
async function loadBlockedRecordForCurrentUser({ force = false } = {}) {
  if (!state.firebaseEnabled || !state.user) {
    state.blockedRecord = null;
    state.blockedRecordChecked = true;
    return null;
  }
  if (!force && state.blockedRecordChecked) return state.blockedRecord;

  try {
    const { doc, getDoc } = firebase.api;
    const snapshot = await getDoc(doc(firebase.db, "blockedUsers", state.user.uid));
    state.blockedRecord = snapshot.exists() ? snapshot.data() : null;
  } catch (error) {
    console.warn("Could not check moderation status:", error);
    state.blockedRecord = null;
  }
  state.blockedRecordChecked = true;
  return state.blockedRecord;
}

async function loadAdminBlockedUsers() {
  if (!state.firebaseEnabled || !state.isAdmin) return [];

  const { collection, getDocs } = firebase.api;
  const snapshot = await getDocs(collection(firebase.db, "blockedUsers"));
  return snapshot.docs
    .map((docSnap) => ({ uid: docSnap.id, ...docSnap.data() }))
    .sort((a, b) => String(b.blockedAt || "").localeCompare(String(a.blockedAt || "")));
}

async function refreshAdminBlockedUsers() {
  if (!state.firebaseEnabled || !state.isAdmin) return false;
  try {
    state.adminBlockedUsers = await loadAdminBlockedUsers();
    return true;
  } catch (error) {
    console.warn("Could not load blocked students:", error);
    return false;
  }
}

async function blockStudentFromAreas({ uid, name, areas, reason }) {
  if (!state.isAdmin || !uid) return;

  const cleanAreas = (Array.isArray(areas) ? areas : []).filter((area) => ["community", "tutorials", "all"].includes(area));
  if (!cleanAreas.length) {
    showToast("Choose at least one area to block.");
    return;
  }

  try {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "blockedUsers", uid), {
      uid,
      name: String(name || "Student").slice(0, 120),
      areas: cleanAreas,
      reason: String(reason || "").slice(0, 300),
      blockedAt: new Date().toISOString(),
      blockedBy: state.user?.email || ADMIN_EMAIL
    });
    await refreshAdminBlockedUsers();
    showToast("Student blocked.");
    render();
  } catch (error) {
    showToast("Could not block this student.");
    console.warn("Could not block student:", error);
  }
}

async function unblockStudent(uid) {
  if (!state.isAdmin || !uid) return;
  try {
    const { doc, deleteDoc } = firebase.api;
    await deleteDoc(doc(firebase.db, "blockedUsers", uid));
    state.adminBlockedUsers = state.adminBlockedUsers.filter((entry) => entry.uid !== uid);
    showToast("Student unblocked.");
    render();
  } catch (error) {
    showToast("Could not unblock this student.");
    console.warn("Could not unblock student:", error);
  }
}

async function loadSiteNavigation({ force = false } = {}) {
  if (!state.firebaseEnabled) return state.siteNavigation || getDefaultSiteNavigation();
  if (!force && loadedPublicCollections.has("siteNavigation")) return state.siteNavigation || getDefaultSiteNavigation();

  const { doc, getDoc } = firebase.api;
  const snapshot = await getDoc(doc(firebase.db, "siteSettings", "navigation"));
  const settings = snapshot.exists() ? normalizeSiteNavigation(snapshot.data()) : getDefaultSiteNavigation();
  loadedPublicCollections.add("siteNavigation");
  stalePublicCollections.delete("siteNavigation");
  state.siteNavigationReady = true;
  return settings;
}

function getRouteTabId(page = "") {
  return PUBLIC_NAV_TABS.find((tab) => tab.pages.includes(page))?.id || "";
}

function isPublicTabVisible(tabId = "") {
  if (!tabId || state.isAdmin) return true;
  const navigationReady = state.siteNavigationReady;
  if (!navigationReady && (state.firebaseInitializing || state.firebaseEnabled)) return false;
  const visibleTabs = normalizeSiteNavigation(state.siteNavigation).visibleTabs;
  return visibleTabs[tabId] !== false;
}

const PUBLIC_TAB_SUGGESTION_INFO = {
  courses: { icon: "graduation-cap", body: "Browse outcome-focused course paths with project sprints and interview preparation." },
  sessions: { icon: "clock", body: "Book a 1:1 mentorship, resume review or mock interview session." },
  tutorials: { icon: "book-open", body: "Read subject-based tutorials with a guided topic roadmap." },
  "coding-practice": { icon: "code", body: "Practice interview coding problems with instant test runs." },
  community: { icon: "users", body: "Share your ideas, ask questions, and discuss what you are building with other students." },
  events: { icon: "clock", body: "Register for live sessions, workshops, and doubt-clearing calls." },
  whatsapp: { icon: "message-circle", body: "Join the SkillUp Class WhatsApp community for quick questions and updates on your phone." },
  blog: { icon: "edit-3", body: "Read announcements and learning notes from SkillUp Class." },
  youtube: { icon: "play-circle", href: "https://www.youtube.com/@SkillupClass", external: true, body: "Watch practical lessons and walkthroughs on the SkillUp Class channel." },
  inquiry: { icon: "message-circle", body: "Tell us your goals and get guidance on the right course or path." }
};

function renderHiddenPublicTabPage(tabId = "") {
  const tab = PUBLIC_NAV_TABS.find((item) => item.id === tabId);
  const suggestions = PUBLIC_NAV_TABS
    .filter((item) => item.id !== tabId && isPublicTabVisible(item.id))
    .map((item) => ({ ...item, ...PUBLIC_TAB_SUGGESTION_INFO[item.id] }))
    .filter((item) => item.body);

  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Unavailable</p>
      <h1>${escapeHtml(tab?.label || "This section")} is currently hidden.</h1>
      <p>This area is temporarily hidden from the public website. Admin users can still preview and manage it. Here is what's open right now instead.</p>
      <a class="button primary" href="#home">Back to home</a>
    </section>
    ${suggestions.length ? `
      <section class="section-band">
        <div class="section-heading" data-reveal>
          <div>
            <p class="eyebrow">Keep exploring</p>
            <h2>Plenty else to learn right now.</h2>
          </div>
        </div>
        <div class="home-feature-grid">
          ${suggestions.map((item) => `
            <a
              class="home-feature-card home-feature-card--link"
              href="${escapeAttr(item.href || `#${item.id}`)}"
              ${item.external ? 'target="_blank" rel="noreferrer"' : ""}
              data-reveal
            >
              <span>${icon(item.icon)}</span>
              <h3>${escapeHtml(item.label)}</h3>
              <p>${escapeHtml(item.body)}</p>
            </a>
          `).join("")}
        </div>
      </section>
    ` : ""}
  `;
}

function formatAdminLoadError(error) {
  return error?.message || "Could not load this admin data. Check Firebase rules and try again.";
}
async function loadInquiries() {
  if (!state.firebaseEnabled || !state.isAdmin) return [];

  const { collection, getDocs, orderBy, query } = firebase.api;
  const snapshot = await getDocs(query(collection(firebase.db, "courseInquiries"), orderBy("createdAt", "desc")));
  return snapshot.docs.map((docSnap) => normalizeInquiry({ id: docSnap.id, ...docSnap.data() })).sort(sortInquiries);
}

async function loadStudents() {
  if (!state.firebaseEnabled || !state.isAdmin) return [];

  const { collection, getDocs, orderBy, query } = firebase.api;
  const snapshot = await getDocs(query(collection(firebase.db, "students"), orderBy("createdAt", "desc")));
  return snapshot.docs.map((docSnap) => normalizeStudent({ id: docSnap.id, ...docSnap.data() }));
}

async function refreshAdminStudents() {
  if (!state.firebaseEnabled || !state.isAdmin) return false;

  beginLoading("Loading students...");
  try {
    state.adminStudentLoadError = "";
    state.students = await loadStudents();
    return true;
  } catch (error) {
    state.adminStudentLoadError = formatAdminLoadError(error);
    showToast("Could not load students. Check Firebase rules.");
    console.warn("Could not refresh students:", error);
    return false;
  } finally {
    endLoading();
    render();
  }
}
function normalizeIdList(value) {
  if (!Array.isArray(value)) return [];
  return [...new Set(value.map((item) => String(item || "").trim()).filter(Boolean))];
}

function normalizeStudent(student = {}) {
  return {
    id: String(student.id || student.uid || ""),
    uid: String(student.uid || student.id || ""),
    name: String(student.name || student.displayName || "Student").trim() || "Student",
    email: String(student.email || "").trim().toLowerCase(),
    mobileNo: String(student.mobileNo || "").trim(),
    profession: String(student.profession || "").trim(),
    currentOrganisation: String(student.currentOrganisation || "").trim(),
    experienceLevel: String(student.experienceLevel || "").trim(),
    currentDegree: String(student.currentDegree || "").trim(),
    collegeName: String(student.collegeName || "").trim(),
    role: String(student.role || "student"),
    createdAt: String(student.createdAt || ""),
    updatedAt: String(student.updatedAt || ""),
    lastLoginAt: String(student.lastLoginAt || ""),
    completedTutorials: normalizeIdList(student.completedTutorials),
    bookmarkedTutorials: normalizeIdList(student.bookmarkedTutorials),
    // Continue reading, streak days and quiz scores. Leaving these out meant a
    // signed-in student's loaded profile had none, so the next save wrote
    // today's date and one quiz score over their whole history.
    lastTutorialId: String(student.lastTutorialId || ""),
    lastTutorialAt: String(student.lastTutorialAt || ""),
    activityDates: Array.isArray(student.activityDates) ? student.activityDates.map(String) : [],
    quizScores: student.quizScores && typeof student.quizScores === "object" && !Array.isArray(student.quizScores) ? student.quizScores : {},
    emailReplies: student.emailReplies !== false,
    solvedProblems: student.solvedProblems && typeof student.solvedProblems === "object" && !Array.isArray(student.solvedProblems) ? student.solvedProblems : {}
  };
}

function normalizeComment(raw = {}) {
  return {
    id: String(raw.id || ""),
    contentType: raw.contentType === "blog" ? "blog" : "tutorial",
    contentId: String(raw.contentId || ""),
    contentTitle: String(raw.contentTitle || ""),
    parentId: raw.parentId ? String(raw.parentId) : null,
    authorUid: String(raw.authorUid || ""),
    authorName: String(raw.authorName || "Learner").trim() || "Learner",
    body: String(raw.body || ""),
    createdAt: String(raw.createdAt || ""),
    status: raw.status === "hidden" ? "hidden" : "visible",
    flagCount: Number(raw.flagCount) || 0,
    flaggedBy: normalizeIdList(raw.flaggedBy),
    suspicious: raw.suspicious === true,
    upvotedBy: normalizeIdList(raw.upvotedBy),
    upvoteCount: Number(raw.upvoteCount) || 0,
    acceptedReplyId: raw.acceptedReplyId ? String(raw.acceptedReplyId) : null
  };
}

function getDiscussionKey(contentType, contentId) {
  return `${contentType}:${contentId}`;
}

async function loadDiscussionComments(contentType, contentId, contentTitle = "") {
  const key = getDiscussionKey(contentType, contentId);
  if (!state.firebaseEnabled || !contentId) return;
  // Also stop once a load has failed - render() calls scheduleDiscussionLoad()
  // on every render, and without this check a failed fetch would set
  // discussionError, trigger a re-render in the `finally` block below, that
  // re-render would call scheduleDiscussionLoad() again, which would retry
  // and fail again, forever: an infinite fail/re-render loop that looked
  // like the whole page "refreshing again and again". A real retry now only
  // happens via the explicit Retry button, which clears discussionError first.
  if (state.discussionLoading.has(key) || state.discussionComments[key] || state.discussionError[key]) return;

  state.discussionLoading.add(key);
  try {
    const { collection, getDocs, query, where, orderBy } = firebase.api;
    const snapshot = await getDocs(query(
      collection(firebase.db, "comments"),
      where("contentId", "==", contentId),
      // contentType is filtered explicitly (not just implied by contentId)
      // because the security rule's outcome depends on it - blog comments
      // need no auth, tutorial comments need isSignedIn(). Without this
      // filter, Firestore can't prove the rule holds from the query alone
      // and denies the whole list request every time, which is what was
      // producing "Could not load the discussion for this page."
      where("contentType", "==", contentType),
      where("status", "==", "visible"),
      orderBy("createdAt", "asc")
    ));
    state.discussionComments[key] = snapshot.docs.map((docSnap) => normalizeComment({ id: docSnap.id, ...docSnap.data() }));
    state.discussionError[key] = "";
  } catch (error) {
    state.discussionError[key] = "Could not load the discussion for this page.";
    console.warn(`Could not load comments for ${contentType} ${contentId}:`, error);
  } finally {
    state.discussionLoading.delete(key);
    render();
  }
}

async function postDiscussionComment({ contentType, contentId, contentTitle, body, parentId = null }) {
  if (state.user && !isEmailVerified()) {
    promptEmailVerification("post comments");
    return false;
  }
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to join the discussion.");
    return;
  }

  if (isBlockedFromArea("tutorials")) {
    showToast("An admin has blocked your account from commenting.");
    return;
  }

  const trimmedBody = String(body || "").trim();
  if (!trimmedBody) {
    showToast("Write something before posting.");
    return;
  }
  if (trimmedBody.length > 2000) {
    showToast("Comments are limited to 2000 characters.");
    return;
  }

  const key = getDiscussionKey(contentType, contentId);
  // Warn once, then let the student decide. If they continue, the comment
  // is stored flagged so an admin sees it without waiting for a report.
  const analysis = analysePostContent(trimmedBody);
  if (analysis.suspicious && state.pendingSuspicious[key] !== trimmedBody) {
    state.pendingSuspicious[key] = trimmedBody;
    render();
    return;
  }
  delete state.pendingSuspicious[key];
  const { doc, collection, setDoc } = firebase.api;
  const commentRef = doc(collection(firebase.db, "comments"));
  const comment = {
    id: commentRef.id,
    contentType,
    contentId,
    contentTitle: String(contentTitle || "").slice(0, 200),
    parentId: parentId || null,
    authorUid: state.user.uid,
    authorName: state.studentProfile?.name || state.user.displayName || "Learner",
    body: trimmedBody,
    createdAt: new Date().toISOString(),
    status: "visible",
    flagCount: 0,
    flaggedBy: [],
    suspicious: analysis.suspicious
  };

  try {
    await setDoc(commentRef, comment);
    const list = state.discussionComments[key] || [];
    state.discussionComments[key] = [...list, normalizeComment(comment)];
    delete state.discussionReplyTarget[key];
    showToast(parentId ? "Reply posted." : "Comment posted.");
    render();
  } catch (error) {
    showToast("Could not post your comment. Please try again.");
    console.warn("Could not post comment:", error);
  }
}

async function flagDiscussionComment(contentType, contentId, commentId) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to report a comment.");
    return;
  }

  const key = getDiscussionKey(contentType, contentId);
  const list = state.discussionComments[key] || [];
  const target = list.find((comment) => comment.id === commentId);
  if (!target) return;
  if (target.flaggedBy.includes(state.user.uid)) {
    showToast("You already reported this comment.");
    return;
  }

  try {
    const { doc, updateDoc } = firebase.api;
    const nextFlaggedBy = [...target.flaggedBy, state.user.uid];
    await updateDoc(doc(firebase.db, "comments", commentId), {
      flaggedBy: nextFlaggedBy,
      flagCount: target.flagCount + 1
    });
    target.flaggedBy = nextFlaggedBy;
    target.flagCount += 1;
    showToast("Comment reported. Our team will review it.");
    render();
  } catch (error) {
    showToast("Could not report this comment. Please try again.");
    console.warn("Could not flag comment:", error);
  }
}

async function deleteDiscussionComment(contentType, contentId, commentId) {
  if (!state.user) return;
  const key = getDiscussionKey(contentType, contentId);
  const list = state.discussionComments[key] || [];
  const target = list.find((comment) => comment.id === commentId);
  if (!target) return;
  if (!state.isAdmin && target.authorUid !== state.user.uid) return;
  if (!state.isAdmin && hasRepliesFromOthers(list, commentId, state.user.uid)) {
    showToast("This comment has replies from other members. Ask an admin to remove the whole thread.");
    return;
  }

  try {
    const removed = await deleteThreadDocuments("comments", commentId);
    state.discussionComments[key] = list.filter((comment) => !removed.includes(comment.id) && comment.parentId !== commentId);
    showToast(removed.length > 1 ? "Comment and its replies deleted." : "Comment deleted.");
    render();
  } catch (error) {
    showToast("Could not delete this comment. Please try again.");
    console.warn("Could not delete comment:", error);
  }
}

async function loadAdminComments() {
  if (!state.firebaseEnabled || !state.isAdmin) return [];

  // Fetch recent comments rather than only reported ones, so an admin can
  // moderate anything. Ordering on a single field stays auto-indexed; the
  // All / Reported / Suspicious split is done client-side to avoid needing
  // a composite index.
  const { collection, getDocs, query, orderBy, limit } = firebase.api;
  const snapshot = await getDocs(query(
    collection(firebase.db, "comments"),
    orderBy("createdAt", "desc"),
    limit(150)
  ));
  return snapshot.docs.map((docSnap) => normalizeComment({ id: docSnap.id, ...docSnap.data() }));
}

async function refreshAdminComments() {
  if (!state.firebaseEnabled || !state.isAdmin) return false;

  beginLoading("Loading flagged comments...");
  try {
    state.adminCommentLoadError = "";
    state.adminComments = await loadAdminComments();
    return true;
  } catch (error) {
    state.adminCommentLoadError = formatAdminLoadError(error);
    showToast("Could not load flagged comments. Check Firebase rules.");
    console.warn("Could not refresh flagged comments:", error);
    return false;
  } finally {
    endLoading();
    render();
  }
}

async function setCommentStatus(commentId, status) {
  if (!state.isAdmin) return;
  try {
    const { doc, updateDoc } = firebase.api;
    await updateDoc(doc(firebase.db, "comments", commentId), { status });
    state.adminComments = state.adminComments.map((comment) => comment.id === commentId ? { ...comment, status } : comment);
    showToast(status === "hidden" ? "Comment hidden." : "Comment restored.");
    render();
  } catch (error) {
    showToast("Could not update this comment. Please try again.");
    console.warn("Could not update comment status:", error);
  }
}

async function dismissCommentFlags(commentId) {
  if (!state.isAdmin) return;
  try {
    const { doc, updateDoc } = firebase.api;
    await updateDoc(doc(firebase.db, "comments", commentId), { flagCount: 0, flaggedBy: [] });
    state.adminComments = state.adminComments.filter((comment) => comment.id !== commentId);
    showToast("Reports dismissed.");
    render();
  } catch (error) {
    showToast("Could not dismiss reports. Please try again.");
    console.warn("Could not dismiss comment flags:", error);
  }
}

async function deleteAdminComment(commentId) {
  if (!state.isAdmin) return;
  try {
    const removed = await deleteThreadDocuments("comments", commentId);
    state.adminComments = state.adminComments.filter((comment) => !removed.includes(comment.id));
    Object.keys(state.discussionComments).forEach((key) => {
      state.discussionComments[key] = (state.discussionComments[key] || [])
        .filter((comment) => !removed.includes(comment.id));
    });
    showToast(removed.length > 1 ? "Comment and its replies deleted." : "Comment deleted.");
    render();
  } catch (error) {
    showToast("Could not delete this comment. Please try again.");
    console.warn("Could not delete comment:", error);
  }
}

// ==========================================================================
// Community - admin-created topic communities students join, discuss in,
// and see a privacy-safe member directory for. Mirrors the tutorial/blog
// discussion system above (same load/retry/flag/delete shape), scoped by
// communityId instead of contentType+contentId, plus membership and a
// separate publicProfiles collection that structurally cannot hold
// email/mobileNo - see the plan notes on why that can't just be a relaxed
// read rule on the existing students collection.
// ==========================================================================

function normalizeCommunity(raw = {}) {
  return {
    id: String(raw.id || ""),
    title: String(raw.title || "").trim() || "Community",
    slug: String(raw.slug || raw.id || ""),
    description: String(raw.description || ""),
    icon: String(raw.icon || "users"),
    logoImage: String(raw.logoImage || ""),
    logoImagePath: String(raw.logoImagePath || ""),
    whatsappUrl: String(raw.whatsappUrl || ""),
    status: raw.status === "archived" ? "archived" : "published",
    order: Number(raw.order) || 1,
    createdAt: String(raw.createdAt || ""),
    updatedAt: String(raw.updatedAt || "")
  };
}

function normalizeCommunityMembership(raw = {}) {
  return {
    id: String(raw.id || ""),
    communityId: String(raw.communityId || ""),
    uid: String(raw.uid || ""),
    memberName: String(raw.memberName || "Learner").trim() || "Learner",
    joinedAt: String(raw.joinedAt || ""),
    status: raw.status === "active" ? "active" : "active"
  };
}

function normalizeCommunityPost(raw = {}) {
  return {
    id: String(raw.id || ""),
    communityId: String(raw.communityId || ""),
    parentId: raw.parentId ? String(raw.parentId) : null,
    authorUid: String(raw.authorUid || ""),
    authorName: String(raw.authorName || "Learner").trim() || "Learner",
    body: String(raw.body || ""),
    createdAt: String(raw.createdAt || ""),
    status: raw.status === "hidden" ? "hidden" : "visible",
    flagCount: Number(raw.flagCount) || 0,
    flaggedBy: normalizeIdList(raw.flaggedBy),
    suspicious: raw.suspicious === true,
    upvotedBy: normalizeIdList(raw.upvotedBy),
    upvoteCount: Number(raw.upvoteCount) || 0,
    acceptedReplyId: raw.acceptedReplyId ? String(raw.acceptedReplyId) : null
  };
}

function normalizePublicProfile(raw = {}) {
  return {
    uid: String(raw.uid || ""),
    name: String(raw.name || "Learner").trim() || "Learner",
    profession: String(raw.profession || ""),
    currentOrganisation: String(raw.currentOrganisation || ""),
    experienceLevel: String(raw.experienceLevel || ""),
    currentDegree: String(raw.currentDegree || ""),
    collegeName: String(raw.collegeName || ""),
    updatedAt: String(raw.updatedAt || ""),
    solvedCount: Number(raw.solvedCount) || 0
  };
}

function getPublicCommunities() {
  return [...state.communities]
    .filter((community) => state.isAdmin || community.status === "published")
    .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title));
}

function findCommunityById(id) {
  return state.communities.find((community) => community.id === id) || null;
}

function getAdminCommunities() {
  return [...state.communities].sort((a, b) => a.order - b.order || a.title.localeCompare(b.title));
}

async function loadCommunities({ force = false } = {}) {
  if (!state.firebaseEnabled) return false;
  if (state.communitiesLoaded && !force) return false;

  try {
    const { collection, getDocs, query, where } = firebase.api;
    // Non-admin requests need an explicit status filter matching the read
    // rule (isAdmin() || status=="published") - otherwise Firestore can't
    // prove every possible result document satisfies the rule and denies
    // the whole list with 403, the same class of bug fixed earlier this
    // session for the comments/contentType query. Admin requests are
    // provably safe with no filter (isAdmin() doesn't depend on any
    // document field), so admins see archived communities too.
    const constraints = state.isAdmin ? [] : [where("status", "==", "published")];
    const snapshot = await getDocs(query(collection(firebase.db, "communities"), ...constraints));
    state.communities = snapshot.docs.map((docSnap) => normalizeCommunity({ id: docSnap.id, ...docSnap.data() }));
    state.communitiesLoaded = true;
    return true;
  } catch (error) {
    console.warn("Could not load communities:", error);
    return false;
  }
}

async function loadCommunityPosts(communityId) {
  if (!state.firebaseEnabled || !communityId) return;
  // Same "don't retry after a failure, only via the explicit Retry button"
  // guard as loadDiscussionComments - see the comment there for why.
  if (state.communityPostLoading.has(communityId) || state.communityPosts[communityId] || state.communityPostError[communityId]) return;

  state.communityPostLoading.add(communityId);
  try {
    const { collection, getDocs, query, where, orderBy } = firebase.api;
    const snapshot = await getDocs(query(
      collection(firebase.db, "communityPosts"),
      where("communityId", "==", communityId),
      where("status", "==", "visible"),
      orderBy("createdAt", "asc")
    ));
    state.communityPosts[communityId] = snapshot.docs.map((docSnap) => normalizeCommunityPost({ id: docSnap.id, ...docSnap.data() }));
    state.communityPostError[communityId] = "";
  } catch (error) {
    state.communityPostError[communityId] = "Could not load the discussion for this community.";
    console.warn(`Could not load posts for community ${communityId}:`, error);
  } finally {
    state.communityPostLoading.delete(communityId);
    render();
  }
}

async function loadCommunityMembers(communityId) {
  if (!state.firebaseEnabled || !communityId) return;
  if (state.communityMemberLoading.has(communityId) || state.communityMembers[communityId] || state.communityMemberError[communityId]) return;

  state.communityMemberLoading.add(communityId);
  try {
    const { collection, getDocs, query, where, orderBy } = firebase.api;
    const snapshot = await getDocs(query(
      collection(firebase.db, "communityMemberships"),
      where("communityId", "==", communityId),
      orderBy("joinedAt", "asc")
    ));
    const members = snapshot.docs.map((docSnap) => normalizeCommunityMembership({ id: docSnap.id, ...docSnap.data() }));
    state.communityMembers[communityId] = members;
    state.communityMemberError[communityId] = "";
    await loadPublicProfilesForMembers(members);
  } catch (error) {
    state.communityMemberError[communityId] = "Could not load members for this community.";
    console.warn(`Could not load members for community ${communityId}:`, error);
  } finally {
    state.communityMemberLoading.delete(communityId);
    render();
  }
}

async function loadPublicProfilesForMembers(members = []) {
  if (!state.firebaseEnabled) return;
  const uids = [...new Set(members.map((member) => member.uid))].filter((uid) => uid && !state.publicProfiles[uid] && !state.publicProfileLoading.has(uid));
  if (!uids.length) return;
  uids.forEach((uid) => state.publicProfileLoading.add(uid));

  try {
    const { collection, getDocs, query, where, documentId } = firebase.api;
    // Firestore's "in" operator caps at 10 values per query, so chunk it.
    for (let i = 0; i < uids.length; i += 10) {
      const chunk = uids.slice(i, i + 10);
      const snapshot = await getDocs(query(collection(firebase.db, "publicProfiles"), where(documentId(), "in", chunk)));
      snapshot.docs.forEach((docSnap) => {
        state.publicProfiles[docSnap.id] = normalizePublicProfile({ uid: docSnap.id, ...docSnap.data() });
      });
    }
  } catch (error) {
    console.warn("Could not load member profiles:", error);
  } finally {
    uids.forEach((uid) => state.publicProfileLoading.delete(uid));
  }
}

function isCommunityMember(communityId) {
  return Boolean(state.communityMembershipsByUid[communityId]);
}

async function checkCommunityMembership(communityId) {
  if (!state.firebaseEnabled || !communityId || !state.user) return;
  if (communityId in state.communityMembershipsByUid) return;

  try {
    const { doc, getDoc } = firebase.api;
    const snap = await getDoc(doc(firebase.db, "communityMemberships", `${communityId}_${state.user.uid}`));
    state.communityMembershipsByUid[communityId] = snap.exists();
    render();
  } catch (error) {
    console.warn(`Could not check membership for community ${communityId}:`, error);
  }
}

async function joinCommunity(communityId) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to join a community.");
    return;
  }
  if (isBlockedFromArea("community")) {
    showToast("An admin has blocked your account from joining communities.");
    return;
  }

  try {
    const { doc, setDoc } = firebase.api;
    const policy = getCommunityPolicy();
    const membership = {
      communityId,
      uid: state.user.uid,
      memberName: state.studentProfile?.name || state.user.displayName || "Learner",
      joinedAt: new Date().toISOString(),
      status: "active",
      policyAcceptedAt: new Date().toISOString(),
      policyVersion: String(policy.updatedAt || "default").slice(0, 60)
    };
    await setDoc(doc(firebase.db, "communityMemberships", `${communityId}_${state.user.uid}`), membership);
    state.communityMembershipsByUid[communityId] = true;
    delete state.communityMembers[communityId];
    showToast("Joined community.");
    render();
  } catch (error) {
    showToast("Could not join this community. Please try again.");
    console.warn("Could not join community:", error);
  }
}

async function leaveCommunity(communityId) {
  if (!state.user) return;
  try {
    const { doc, deleteDoc } = firebase.api;
    await deleteDoc(doc(firebase.db, "communityMemberships", `${communityId}_${state.user.uid}`));
    state.communityMembershipsByUid[communityId] = false;
    delete state.communityMembers[communityId];
    showToast("Left community.");
    render();
  } catch (error) {
    showToast("Could not leave this community. Please try again.");
    console.warn("Could not leave community:", error);
  }
}

async function postCommunityMessage({ communityId, body, parentId = null }) {
  if (state.user && !isEmailVerified()) {
    promptEmailVerification("post in the Students Hub");
    return false;
  }
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to join the discussion.");
    return;
  }
  if (!isCommunityMember(communityId)) {
    showToast("Join this community to post.");
    return;
  }
  if (isBlockedFromArea("community")) {
    showToast("An admin has blocked your account from posting in communities.");
    return;
  }

  const trimmedBody = String(body || "").trim();
  if (!trimmedBody) {
    showToast("Write something before posting.");
    return;
  }
  if (trimmedBody.length > 2000) {
    showToast("Posts are limited to 2000 characters.");
    return;
  }

  const analysis = analysePostContent(trimmedBody);
  if (analysis.suspicious && state.pendingSuspicious[communityId] !== trimmedBody) {
    state.pendingSuspicious[communityId] = trimmedBody;
    render();
    return;
  }
  delete state.pendingSuspicious[communityId];

  const { doc, collection, setDoc } = firebase.api;
  const postRef = doc(collection(firebase.db, "communityPosts"));
  const post = {
    id: postRef.id,
    communityId,
    parentId: parentId || null,
    authorUid: state.user.uid,
    authorName: state.studentProfile?.name || state.user.displayName || "Learner",
    body: trimmedBody,
    createdAt: new Date().toISOString(),
    status: "visible",
    flagCount: 0,
    flaggedBy: [],
    suspicious: analysis.suspicious
  };

  try {
    await setDoc(postRef, post);
    const list = state.communityPosts[communityId] || [];
    state.communityPosts[communityId] = [...list, normalizeCommunityPost(post)];
    delete state.communityPostReplyTarget[communityId];
    showToast(parentId ? "Reply posted." : "Post published.");
    render();
  } catch (error) {
    showToast("Could not post your message. Please try again.");
    console.warn("Could not post community message:", error);
  }
}

async function flagCommunityPost(communityId, postId) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to report a post.");
    return;
  }

  const list = state.communityPosts[communityId] || [];
  const target = list.find((post) => post.id === postId);
  if (!target) return;
  if (target.flaggedBy.includes(state.user.uid)) {
    showToast("You already reported this post.");
    return;
  }

  try {
    const { doc, updateDoc } = firebase.api;
    const nextFlaggedBy = [...target.flaggedBy, state.user.uid];
    await updateDoc(doc(firebase.db, "communityPosts", postId), {
      flaggedBy: nextFlaggedBy,
      flagCount: target.flagCount + 1
    });
    target.flaggedBy = nextFlaggedBy;
    target.flagCount += 1;
    showToast("Post reported. Our team will review it.");
    render();
  } catch (error) {
    showToast("Could not report this post. Please try again.");
    console.warn("Could not flag community post:", error);
  }
}

// Deleting a thread has to remove the replies too. Previously only the
// parent document was deleted while the replies were merely filtered out
// of local state, so they survived in Firestore: invisible in the thread
// (their parent was gone) but still stored and still counted in the admin
// queue. Returns the ids removed so callers can prune their own state.
async function deleteThreadDocuments(collectionName, parentId) {
  const { doc, collection, deleteDoc, getDocs, query, where } = firebase.api;
  const removed = [parentId];

  try {
    const replySnapshot = await getDocs(query(
      collection(firebase.db, collectionName),
      where("parentId", "==", parentId)
    ));
    for (const replyDoc of replySnapshot.docs) {
      await deleteDoc(replyDoc.ref);
      removed.push(replyDoc.id);
    }
  } catch (error) {
    // A student may only delete their own replies, so a partial failure
    // here is possible; the parent delete below still reports success.
    console.warn("Could not remove every reply in the thread:", error);
  }

  await deleteDoc(doc(firebase.db, collectionName, parentId));
  return removed;
}

// A student deleting their own post must not strand other people's
// replies, and rules stop them deleting those replies. Admins can remove
// the whole thread, so send them there instead.
function hasRepliesFromOthers(list, parentId, uid) {
  return list.some((item) => item.parentId === parentId && item.authorUid !== uid);
}

async function deleteCommunityPost(communityId, postId) {
  if (!state.user) return;
  const list = state.communityPosts[communityId] || [];
  const target = list.find((post) => post.id === postId);
  if (!target) return;
  if (!state.isAdmin && target.authorUid !== state.user.uid) return;
  if (!state.isAdmin && hasRepliesFromOthers(list, postId, state.user.uid)) {
    showToast("This post has replies from other members. Ask an admin to remove the whole thread.");
    return;
  }

  try {
    const removed = await deleteThreadDocuments("communityPosts", postId);
    state.communityPosts[communityId] = list.filter((post) => !removed.includes(post.id) && post.parentId !== postId);
    showToast(removed.length > 1 ? "Post and its replies deleted." : "Post deleted.");
    render();
  } catch (error) {
    showToast("Could not delete this post. Please try again.");
    console.warn("Could not delete community post:", error);
  }
}

async function loadAdminCommunityPosts() {
  if (!state.firebaseEnabled || !state.isAdmin) return [];

  const { collection, getDocs, query, orderBy, limit } = firebase.api;
  const snapshot = await getDocs(query(
    collection(firebase.db, "communityPosts"),
    orderBy("createdAt", "desc"),
    limit(150)
  ));
  return snapshot.docs.map((docSnap) => normalizeCommunityPost({ id: docSnap.id, ...docSnap.data() }));
}

async function refreshAdminCommunityPosts() {
  if (!state.firebaseEnabled || !state.isAdmin) return false;

  beginLoading("Loading flagged community posts...");
  try {
    state.adminCommunityPostLoadError = "";
    state.adminCommunityPosts = await loadAdminCommunityPosts();
    return true;
  } catch (error) {
    state.adminCommunityPostLoadError = formatAdminLoadError(error);
    showToast("Could not load flagged community posts. Check Firebase rules.");
    console.warn("Could not refresh flagged community posts:", error);
    return false;
  } finally {
    endLoading();
    render();
  }
}

async function setCommunityPostStatus(postId, status) {
  if (!state.isAdmin) return;
  try {
    const { doc, updateDoc } = firebase.api;
    await updateDoc(doc(firebase.db, "communityPosts", postId), { status });
    state.adminCommunityPosts = state.adminCommunityPosts.map((post) => post.id === postId ? { ...post, status } : post);
    showToast(status === "hidden" ? "Post hidden." : "Post restored.");
    render();
  } catch (error) {
    showToast("Could not update this post. Please try again.");
    console.warn("Could not update community post status:", error);
  }
}

async function dismissCommunityPostFlags(postId) {
  if (!state.isAdmin) return;
  try {
    const { doc, updateDoc } = firebase.api;
    await updateDoc(doc(firebase.db, "communityPosts", postId), { flagCount: 0, flaggedBy: [] });
    state.adminCommunityPosts = state.adminCommunityPosts.filter((post) => post.id !== postId);
    showToast("Reports dismissed.");
    render();
  } catch (error) {
    showToast("Could not dismiss reports. Please try again.");
    console.warn("Could not dismiss community post flags:", error);
  }
}

async function deleteAdminCommunityPost(postId) {
  if (!state.isAdmin) return;
  try {
    const removed = await deleteThreadDocuments("communityPosts", postId);
    state.adminCommunityPosts = state.adminCommunityPosts.filter((post) => !removed.includes(post.id));
    Object.keys(state.communityPosts).forEach((communityId) => {
      state.communityPosts[communityId] = (state.communityPosts[communityId] || [])
        .filter((post) => !removed.includes(post.id));
    });
    showToast(removed.length > 1 ? "Post and its replies deleted." : "Post deleted.");
    render();
  } catch (error) {
    showToast("Could not delete this post. Please try again.");
    console.warn("Could not delete community post:", error);
  }
}

function communityPayload(formData) {
  const now = new Date().toISOString();
  const existing = findCommunityById(state.editingCommunityId);
  const title = String(formData.get("title") || "").trim();
  const slug = existing?.id || slugify(title);
  return {
    id: slug,
    title,
    slug,
    description: String(formData.get("description") || "").trim().slice(0, 500),
    icon: String(formData.get("icon") || "users"),
    logoImage: String(formData.get("logoImage") || "").trim(),
    logoImagePath: String(formData.get("logoImagePath") || "").trim(),
    whatsappUrl: normalizeWhatsappInvite(formData.get("whatsappUrl")),
    status: formData.get("status") === "archived" ? "archived" : "published",
    order: Number(formData.get("order") || existing?.order || getAdminCommunities().length + 1),
    createdAt: existing?.createdAt || now,
    updatedAt: now
  };
}

async function saveCommunity(payload) {
  if (!state.isAdmin) return false;
  if (!payload.title) {
    showToast("Give the community a name.");
    return false;
  }
  if (!state.firebaseEnabled) {
    showToast("Communities are not available right now. Please try again later.");
    return false;
  }
  const duplicate = state.communities.find((community) => community.id === payload.id && community.id !== state.editingCommunityId);
  if (duplicate) {
    showToast("A community with this name already exists.");
    return false;
  }

  try {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "communities", payload.id), payload, { merge: true });
    await loadCommunities({ force: true });
    state.editingCommunityId = null;
    showToast("Community saved.");
    render();
    return true;
  } catch (error) {
    showToast("Could not save this community. Please try again.");
    console.warn("Could not save community:", error);
    return false;
  }
}

async function deleteCommunity(communityId) {
  if (!state.isAdmin) return;
  try {
    const { doc, deleteDoc } = firebase.api;
    await deleteDoc(doc(firebase.db, "communities", communityId));
    await loadCommunities({ force: true });
    showToast("Community deleted.");
    render();
  } catch (error) {
    showToast("Could not delete this community. Please try again.");
    console.warn("Could not delete community:", error);
  }
}

// Safe-fields-only subset ever written to publicProfiles/{uid} - deliberately
// excludes email and mobileNo so the member directory structurally cannot
// leak them, regardless of what the UI does or doesn't render.
function buildPublicProfilePayload(profile) {
  return {
    uid: profile.uid,
    name: profile.name,
    profession: profile.profession || "",
    currentOrganisation: profile.currentOrganisation || "",
    experienceLevel: profile.experienceLevel || "",
    currentDegree: profile.currentDegree || "",
    collegeName: profile.collegeName || "",
    updatedAt: profile.updatedAt || new Date().toISOString(),
    solvedCount: Object.keys(profile.solvedProblems || {}).length
  };
}

async function cleanupExpiredInquiries(inquiries = []) {
  const retained = [];
  const expired = [];

  inquiries.forEach((inquiry) => {
    if (isInquiryExpired(inquiry)) {
      expired.push(inquiry);
    } else {
      retained.push(inquiry);
    }
  });

  if (expired.length && state.firebaseEnabled && state.isAdmin) {
    await Promise.all(
      expired.map((inquiry) => firebase.api.deleteDoc(firebase.api.doc(firebase.db, "courseInquiries", inquiry.id)))
    );
  }

  return retained.sort(sortInquiries);
}

function loadLocalContent() {
  const stored = readStoredContent();
  applyPublicContent(stored, { markLoaded: true });
  state.siteNavigationReady = true;
  state.inquiries = readInquiries().map(normalizeInquiry);
}

function hydrateCachedFirebaseContent() {
  const cached = readCachedFirebaseContent();
  if (!cached) return false;
  applyPublicContent(cached, { markLoaded: true });
  state.siteNavigationReady = Boolean(cached.siteNavigation);
  ["articles", "tutorials", "subjects", "blogs", "codingProblems", "siteNavigation"].forEach((collectionName) => stalePublicCollections.add(collectionName));
  state.inquiries = [];
  return true;
}

function readCachedFirebaseContent() {
  try {
    const cached = JSON.parse(localStorage.getItem(FIREBASE_CONTENT_CACHE_KEY));
    if (!cached || Date.now() - Number(cached.cachedAt || 0) > FIREBASE_CONTENT_CACHE_MAX_AGE) return null;
    if (!Array.isArray(cached.articles) || !Array.isArray(cached.tutorials) || !Array.isArray(cached.subjects)) return null;
    cached.blogs = Array.isArray(cached.blogs) ? cached.blogs : [];
    cached.codingProblems = Array.isArray(cached.codingProblems) ? cached.codingProblems : [];
    cached.codingMeta = cached.codingMeta && typeof cached.codingMeta === "object" ? cached.codingMeta : null;
    cached.siteNavigation = cached.siteNavigation && typeof cached.siteNavigation === "object" ? cached.siteNavigation : null;
    return cached;
  } catch {
    localStorage.removeItem(FIREBASE_CONTENT_CACHE_KEY);
    return null;
  }
}
function cacheFirebaseContent(content) {
  try {
    localStorage.setItem(
      FIREBASE_CONTENT_CACHE_KEY,
      JSON.stringify({
        cachedAt: Date.now(),
        articles: content.articles || [],
        tutorials: content.tutorials || [],
        subjects: content.subjects || [],
        blogs: content.blogs || [],
        codingProblems: content.codingProblems || [],
        codingMeta: content.codingMeta || null,
        siteNavigation: content.siteNavigation || null
      })
    );
  } catch {
    // The cache is a speed boost only; the live Firebase fetch still keeps content correct.
  }
}
function applyPublicContent(content, { markLoaded = false } = {}) {
  state.articles = (content.articles || []).map((item, index) => normalizeItem(item, "articles", index + 1));
  state.tutorials = (content.tutorials || []).map((item, index) => normalizeItem(item, "tutorials", index + 1));
  state.blogs = (content.blogs || []).map((item, index) => normalizeItem(item, "blogs", index + 1));
  state.codingMeta = content.codingMeta ? normalizeCodingMeta(content.codingMeta) : state.codingMeta;
  if (content.siteNavigation) {
    state.siteNavigation = normalizeSiteNavigation(content.siteNavigation);
    state.siteNavigationReady = true;
  }
  state.codingProblems = (content.codingProblems || []).map((item, index) => normalizeItem(item, "codingProblems", index + 1));
  state.subjects = getNormalizedSubjects(content.subjects || [], state.articles);

  if (markLoaded) {
    ["articles", "tutorials", "subjects", "blogs", "codingProblems", "siteNavigation"].forEach((collectionName) => loadedPublicCollections.add(collectionName));
  }
}
function applyCollectionContent(collectionName, items = []) {
  if (collectionName === "articles") {
    state.articles = items.map((item, index) => normalizeItem(item, "articles", index + 1));
  } else if (collectionName === "tutorials") {
    state.tutorials = items.map((item, index) => normalizeItem(item, "tutorials", index + 1));
  } else if (collectionName === "subjects") {
    state.subjects = items.map((item, index) => normalizeSubject(item, index + 1));
  } else if (collectionName === "blogs") {
    state.blogs = items.map((item, index) => normalizeItem(item, "blogs", index + 1));
  } else if (collectionName === "codingProblems") {
    state.codingProblems = items.map((item, index) => normalizeItem(item, "codingProblems", index + 1));
  }

  state.subjects = getNormalizedSubjects(state.subjects, state.articles);
  loadedPublicCollections.add(collectionName);
  stalePublicCollections.delete(collectionName);
  cacheFirebaseContent({ articles: state.articles, tutorials: state.tutorials, subjects: state.subjects, blogs: state.blogs, codingProblems: state.codingProblems, codingMeta: state.codingMeta, siteNavigation: state.siteNavigation });
}
async function loadPublicCollection(collectionName, { quiet = true } = {}) {
  const shouldRefresh = stalePublicCollections.has(collectionName);
  if (loadedPublicCollections.has(collectionName) && !shouldRefresh) return false;

  if (!state.firebaseEnabled) {
    loadLocalContent();
    return true;
  }

  if (loadingPublicCollections.has(collectionName)) {
    await loadingPublicCollections.get(collectionName);
    return false;
  }

  const request = (async () => {
    const items = await loadCollection(collectionName, false);
    applyCollectionContent(collectionName, items);
    return true;
  })();

  loadingPublicCollections.set(collectionName, request);
  try {
    return await request;
  } catch (error) {
    state.firebaseError = describeConnectionError(error);
    if (quiet) {
      console.warn(`Could not load ${collectionName}:`, error);
    } else {
      showToast("Could not load content. Check your connection and try again.");
    }
    return false;
  } finally {
    loadingPublicCollections.delete(collectionName);
  }
}

async function loadRouteContent(route = getRoute(), { quiet = true } = {}) {
  if (!state.firebaseEnabled) return false;

  if ((state.isAdmin || state.isContributor) && route.page === "admin") {
    if (adminContentLoaded) return false;
    await loadContent({ admin: true, quiet });
    return true;
  }

  const refreshedNavigation = await loadSiteNavigation({ force: stalePublicCollections.has("siteNavigation") }).catch(() => null);
  let changed = false;
  if (refreshedNavigation) {
    const normalizedNavigation = normalizeSiteNavigation(refreshedNavigation);
    if (JSON.stringify(state.siteNavigation || {}) !== JSON.stringify(normalizedNavigation)) {
      state.siteNavigation = normalizedNavigation;
      changed = true;
    }
  }

  if (route.page === "privacy" || route.page === "admin") return changed;

  const routeKey = route.page === "programs" ? "courses" : route.page;
  const canReadLearning = canReadTutorials();
  const protectedLearningCollections = canReadLearning ? ["articles", "subjects"] : ["subjects"];
  const searchCollections = canReadLearning ? ["articles", "subjects", "tutorials", "blogs", "codingProblems"] : ["subjects", "tutorials", "blogs"];
  const collectionsByRoute = {
    home: canReadLearning ? ["tutorials", "subjects", "articles", "blogs"] : ["tutorials", "subjects", "blogs"],
    courses: ["tutorials"],
    inquiry: ["tutorials"],
    tutorials: protectedLearningCollections,
    articles: protectedLearningCollections,
    article: protectedLearningCollections,
    practice: [],
    coding: [],
    "coding-round": [],
    "coding-practice": canReadLearning ? ["codingProblems"] : [],
    blog: ["blogs"],
    blogs: ["blogs"],
    search: searchCollections,
    // Coding problems are readable only when signed in.
    authors: state.user ? ["articles", "subjects", "tutorials", "blogs", "codingProblems"] : ["articles", "subjects", "tutorials", "blogs"],
    sessions: [],
    certificates: []
  };
  const collections = collectionsByRoute[routeKey] || collectionsByRoute.home;
  for (const collectionName of collections) {
    changed = await loadPublicCollection(collectionName, { quiet }) || changed;
  }

  if (routeKey === "coding-practice") {
    const codingMeta = await loadCodingMeta().catch(() => null);
    if (codingMeta) {
      const normalizedMeta = normalizeCodingMeta(codingMeta);
      if (JSON.stringify(state.codingMeta || {}) !== JSON.stringify(normalizedMeta)) {
        state.codingMeta = normalizedMeta;
        changed = true;
      }
    }
  }

  return changed;
}
function scheduleRouteContentLoad(route = getRoute()) {
  if (!state.firebaseEnabled) return;

  const token = ++routeContentLoadToken;
  loadRouteContent(route, { quiet: true }).then((changed) => {
    if (changed && token === routeContentLoadToken) {
      render();
    }
  });
}
function scheduleDiscussionLoad(route) {
  if (!state.firebaseEnabled) return;

  if (["tutorials", "articles", "article"].includes(route.page) && canReadTutorials()) {
    const tutorials = getPublicTutorials();
    const selected = route.id ? findTutorialById(tutorials, route.id) : tutorials[0];
    if (selected) loadDiscussionComments("tutorial", selected.id, selected.title);
    return;
  }

  if (["blog", "blogs"].includes(route.page) && route.id) {
    const blogs = getPublished(state.blogs).sort(sortNewest);
    const selected = blogs.find((item) => item.id === route.id || item.slug === route.id);
    if (selected) loadDiscussionComments("blog", selected.id, selected.title);
  }
}
// Events are public to read, so the list loads regardless of login state.
// Registrations and the meeting link need an account and are fetched only
// once there is one.
function scheduleEventLoad(route) {
  // The home page needs these too, for the live/upcoming highlight.
  if (!state.firebaseEnabled || !["events", "home"].includes(route.page)) return;

  loadEvents().then((changed) => { if (changed) render(); });
  if (route.page !== "events" || !state.user) return;
  loadMyEventRegistrations().then((changed) => { if (changed) render(); });
  if (route.id && isRegisteredForEvent(route.id)) loadEventMeeting(route.id);
}

function scheduleCommunityLoad(route) {
  if (!state.firebaseEnabled || route.page !== "community") return;

  // The communities list itself is public (no login needed to read it) so
  // it loads regardless of login state - this is what makes the logged-out
  // #community screen show real community names via renderCommunityAuthPreview()
  // instead of a bare login form. Posts/members require being signed in
  // (per their Firestore rules), so those only load once actually logged in.
  loadCommunities().then((changed) => { if (changed) render(); });
  if (!hasLearningAccess() || !route.id) return;

  loadCommunityPosts(route.id);
  loadCommunityMembers(route.id);
  if (state.user) checkCommunityMembership(route.id);
}
function isPublicCollectionReady(collectionName) {
  return !state.firebaseEnabled || state.isAdmin || loadedPublicCollections.has(collectionName);
}

function readStoredContent() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (stored && (Array.isArray(stored.articles) || Array.isArray(stored.tutorials) || Array.isArray(stored.subjects) || Array.isArray(stored.blogs) || Array.isArray(stored.codingProblems))) {
      return {
        articles: Array.isArray(stored.articles) ? stored.articles : [],
        tutorials: Array.isArray(stored.tutorials) ? stored.tutorials : [],
        blogs: Array.isArray(stored.blogs) ? stored.blogs : [],
        codingProblems: Array.isArray(stored.codingProblems) ? stored.codingProblems : [],
        codingMeta: stored.codingMeta && typeof stored.codingMeta === "object" ? stored.codingMeta : null,
        siteNavigation: stored.siteNavigation && typeof stored.siteNavigation === "object" ? stored.siteNavigation : null,
        subjects: Array.isArray(stored.subjects) && stored.subjects.length ? stored.subjects : seedContent.subjects
      };
    }
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }

  const copy = structuredClone(seedContent);
  if (!Array.isArray(copy.codingProblems)) copy.codingProblems = [];
  if (!copy.codingMeta || typeof copy.codingMeta !== "object") copy.codingMeta = null;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(copy));
  return copy;
}
function persistLocalContent() {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      articles: state.articles,
      tutorials: state.tutorials,
      blogs: state.blogs,
      codingProblems: state.codingProblems,
      codingMeta: state.codingMeta,
      siteNavigation: state.siteNavigation,
      subjects: state.subjects
    })
  );
}
function normalizeQuiz(quiz = []) {
  const source = Array.isArray(quiz) ? quiz : [];
  return source
    .map((item, index) => {
      const options = Array.isArray(item?.options)
        ? item.options.map((option) => String(option || "").trim()).filter(Boolean)
        : [];
      const answer = normalizeQuizAnswer(item?.answer || item?.correctAnswer || "", options);
      return {
        id: item?.id || `question-${index + 1}`,
        question: String(item?.question || item?.title || "").trim(),
        options,
        answer,
        explanation: String(item?.explanation || "").trim()
      };
    })
    .filter((item) => item.question && item.options.length >= 2 && item.answer);
}

function normalizeQuizAnswer(answer, options = []) {
  const raw = String(answer || "").trim();
  if (!raw) return "";
  const letter = raw.match(/^[A-D]$/i)?.[0]?.toUpperCase();
  if (letter && options[letter.charCodeAt(0) - 65]) return letter;
  const optionIndex = options.findIndex((option) => option.toLowerCase() === raw.toLowerCase());
  if (optionIndex >= 0) return String.fromCharCode(65 + optionIndex);
  return letter || raw.toUpperCase();
}

function parseQuizInput(value = "") {
  const text = String(value || "").trim();
  if (!text) return [];

  try {
    const parsed = JSON.parse(text);
    return normalizeQuiz(parsed);
  } catch {
    // Plain text quiz format is supported below.
  }

  const blocks = text.split(/\n\s*---+\s*\n|\n\s*\d+\.\s+(?=.+\?)/).map((block) => block.trim()).filter(Boolean);
  const questions = blocks.map((block, index) => {
    const lines = block.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
    let question = "";
    const options = [];
    let answer = "";
    let explanation = "";

    lines.forEach((line) => {
      const optionMatch = line.match(/^([A-D])[\).:-]?\s*(.+)$/i);
      const answerMatch = line.match(/^answer\s*[:=-]\s*(.+)$/i);
      const explanationMatch = line.match(/^explanation\s*[:=-]\s*(.+)$/i);
      const questionMatch = line.match(/^(question|q)\s*[:=-]\s*(.+)$/i);

      if (answerMatch) {
        answer = answerMatch[1].trim();
      } else if (explanationMatch) {
        explanation = explanationMatch[1].trim();
      } else if (optionMatch) {
        options[optionMatch[1].toUpperCase().charCodeAt(0) - 65] = optionMatch[2].trim();
      } else if (questionMatch) {
        question = questionMatch[2].trim();
      } else if (!question) {
        question = line.replace(/^\d+[\).]\s*/, "").trim();
      } else if (!explanation && /^why\b|^because\b/i.test(line)) {
        explanation = line;
      }
    });

    const compactOptions = options.filter(Boolean);
    return {
      id: `question-${index + 1}`,
      question,
      options: compactOptions,
      answer: normalizeQuizAnswer(answer, compactOptions),
      explanation
    };
  });

  return normalizeQuiz(questions);
}

function formatQuizForEditor(quiz = []) {
  return normalizeQuiz(quiz)
    .map((item) => {
      const lines = [`Question: ${item.question}`];
      item.options.forEach((option, index) => {
        lines.push(`${String.fromCharCode(65 + index)}) ${option}`);
      });
      lines.push(`Answer: ${item.answer}`);
      if (item.explanation) lines.push(`Explanation: ${item.explanation}`);
      return lines.join("\n");
    })
    .join("\n---\n");
}

function normalizeItem(item, collectionName, fallbackOrder = 1) {
  if (collectionName === "codingProblems") {
    return normalizeCodingProblem(item, fallbackOrder);
  }

  if (collectionName === "articles") {
    return {
      id: item.id || item.slug,
      title: item.title || "Untitled tutorial",
      slug: item.slug || item.id || slugify(item.title || "untitled-tutorial"),
      excerpt: item.excerpt || "",
      body: item.body || "",
      category: item.category || "General",
      sectionId: item.sectionId || "",
      tags: toArray(item.tags),
      quiz: normalizeQuiz(item.quiz || item.practiceQuestions || []),
      youtubeUrl: normalizeYouTubeInput(item.youtubeUrl || item.youtubeLink || item.videoUrl || ""),
      documentUrl: item.documentUrl || "",
      documentName: item.documentName || "",
      documentPath: item.documentPath || "",
      status: item.status || "draft",
      featured: Boolean(item.featured),
      showOnHome: Boolean(item.showOnHome),
      order: Number(item.order || fallbackOrder || 1),
      publishedAt: item.publishedAt || "",
      createdAt: item.createdAt || new Date().toISOString(),
      updatedAt: item.updatedAt || new Date().toISOString(),
      ...pickContributionFields(item)
    };
  }

  if (collectionName === "blogs") {
    return {
      id: item.id || item.slug,
      title: item.title || "Untitled blog",
      slug: item.slug || item.id || slugify(item.title || "untitled-blog"),
      excerpt: item.excerpt || "",
      body: item.body || "",
      category: item.category || "SkillUp Blog",
      tags: toArray(item.tags),
      coverImage: item.coverImage || "",
      coverImagePath: item.coverImagePath || "",
      youtubeUrl: normalizeYouTubeInput(item.youtubeUrl || item.youtubeLink || item.videoUrl || ""),
      documentUrl: item.documentUrl || "",
      documentName: item.documentName || "",
      documentPath: item.documentPath || "",
      status: item.status || "draft",
      featured: Boolean(item.featured),
      showOnHome: Boolean(item.showOnHome),
      order: Number(item.order || fallbackOrder || 1),
      publishedAt: item.publishedAt || "",
      createdAt: item.createdAt || new Date().toISOString(),
      updatedAt: item.updatedAt || new Date().toISOString(),
      ...pickContributionFields(item)
    };
  }

  return {
    id: item.id || item.slug,
    title: item.title || "Untitled course",
    slug: item.slug || item.id || slugify(item.title || "untitled-course"),
    description: item.description || "",
    outcome: item.outcome || "",
    originalPrice: item.originalPrice || "",
    finalPrice: item.finalPrice || "",
    category: item.category || "General",
    level: item.level || "Beginner",
    duration: item.duration || "",
    topics: toArray(item.topics),
    coverImage: item.coverImage || "",
    coverImagePath: item.coverImagePath || "",
    status: item.status || "draft",
    hiddenFromPublic: Boolean(item.hiddenFromPublic),
    showOnHome: Boolean(item.showOnHome),
    order: Number(item.order || 1),
    createdAt: item.createdAt || new Date().toISOString(),
    updatedAt: item.updatedAt || new Date().toISOString(),
    ...pickContributionFields(item)
  };
}
function normalizeCodingPracticeTestCases(testCases = []) {
  const source = Array.isArray(testCases) ? testCases : [];
  return source.map((testCase, index) => {
    const isObject = testCase && typeof testCase === "object" && !Array.isArray(testCase);
    const hasInput = isObject && Object.prototype.hasOwnProperty.call(testCase, "input");
    const hasExpected = isObject && Object.prototype.hasOwnProperty.call(testCase, "expected");
    const hasOutput = isObject && Object.prototype.hasOwnProperty.call(testCase, "output");
    return {
      name: String(isObject ? testCase.name || testCase.title || `Case ${index + 1}` : `Case ${index + 1}`).trim() || `Case ${index + 1}`,
      input: hasInput ? testCase.input : testCase,
      expected: hasExpected ? testCase.expected : hasOutput ? testCase.output : undefined,
      note: String(isObject ? testCase.note || testCase.explanation || "" : "").trim()
    };
  }).filter((testCase) => testCase.input !== undefined || testCase.expected !== undefined);
}

function parseCodingPracticeTestCasesInput(value) {
  const text = String(value || "").trim();
  if (!text) return [];
  try {
    const parsed = JSON.parse(text);
    if (!Array.isArray(parsed)) throw new Error("Test cases must be an array.");
    return normalizeCodingPracticeTestCases(parsed);
  } catch {
    throw new Error("Test cases must be valid JSON array with name, input, expected, and optional note.");
  }
}

function formatCodingProblemTestCasesForEditor(testCases = []) {
  const normalized = normalizeCodingPracticeTestCases(testCases);
  const sample = normalized.length ? normalized : [
    { name: "Sample case", input: [1, 2, 3, 1], expected: true, note: "Change this to match the problem." },
    { name: "Edge case", input: [], expected: false, note: "Keep at least five cases for good practice." }
  ];
  return JSON.stringify(sample, null, 2);
}

function normalizeCodingProblem(item = {}, fallbackOrder = 1) {
  const now = new Date().toISOString();
  const title = String(item.title || "Untitled problem").trim() || "Untitled problem";
  const kind = normalizeCodingTypeId(item.kind || item.type || item.kindLabel || "dsa");
  const kindLabel = String(item.kindLabel || getCodingTypeLabel(kind) || "DSA").trim() || "DSA";
  const category = String(item.category || item.topic || "General Practice").trim() || "General Practice";
  const difficulty = normalizeCodingDifficultyId(item.difficulty || "medium");
  const difficultyLabel = getCodingDifficultyLabel(difficulty);
  const slug = slugify(item.slug || item.id || `${category}-${title}`);
  const companies = toArray(item.companies).map((company) => String(company || "").trim()).filter(Boolean);
  const constraints = toArray(item.constraints).map((constraint) => String(constraint || "").trim()).filter(Boolean);
  const testCases = normalizeCodingPracticeTestCases(item.testCases || item.tests || []);
  const prompt = String(item.prompt || item.description || item.statement || "").trim();
  const status = String(item.status || "draft").toLowerCase() === "published" ? "published" : "draft";
  const order = Number(item.order || fallbackOrder || 1);
  return {
    id: String(item.id || slug), title, slug, kind, kindLabel,
    category, topic: category, difficulty, difficultyLabel, companies, prompt, description: prompt,
    constraints, testCases, status, order,
    createdAt: String(item.createdAt || now), updatedAt: String(item.updatedAt || now),
    ...pickContributionFields(item),
    searchText: [title, category, difficultyLabel, difficulty, kindLabel, kind, ...companies].join(" ").toLowerCase()
  };
}
function normalizeSubject(item = {}, fallbackOrder = 1) {
  const source = typeof item === "string" ? { title: item } : item || {};
  const title = String(source.title || source.name || source.category || "General").trim() || "General";
  const slug = slugify(source.slug || source.id || title);
  const now = new Date().toISOString();

  return {
    id: source.id || slug,
    title,
    slug,
    order: Number(source.order || fallbackOrder || 1),
    coverImage: source.coverImage || source.imageUrl || "",
    coverImagePath: source.coverImagePath || "",
    hiddenFromPublic: Boolean(source.hiddenFromPublic || source.hideFromPublic || source.isHidden || source.hidden),
    sections: normalizeSubjectSections(source.sections || []),
    createdAt: source.createdAt || now,
    updatedAt: source.updatedAt || now
  };
}

function normalizeSubjectSections(sections = []) {
  const source = Array.isArray(sections) ? sections : [];
  const usedIds = new Set();

  return source
    .map((section, index) => {
      const value = typeof section === "string" ? { title: section } : section || {};
      const title = String(value.title || value.name || "").trim();
      if (!title) return null;
      let id = slugify(value.id || value.slug || title) || `section-${index + 1}`;
      const baseId = id;
      let repeat = 2;
      while (usedIds.has(id)) {
        id = `${baseId}-${repeat}`;
        repeat += 1;
      }
      usedIds.add(id);
      return {
        id,
        title,
        slug: id,
        order: Number(value.order || index + 1)
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title));
}
function normalizeInquiry(item = {}) {
  const now = new Date().toISOString();
  const createdAt = item.createdAt || now;
  const pinned = Boolean(item.pinned);

  return {
    id: item.id || `inquiry-${Date.now()}`,
    name: String(item.name || "").trim(),
    email: String(item.email || "").trim(),
    phone: String(item.phone || "").trim(),
    course: String(item.course || "").trim(),
    city: String(item.city || "").trim(),
    goal: String(item.goal || "").trim(),
    message: String(item.message || "").trim(),
    source: item.source || "website",
    status: item.status || "new",
    pinned,
    pinnedAt: pinned ? item.pinnedAt || now : "",
    emailQueued: Boolean(item.emailQueued),
    createdAt,
    updatedAt: item.updatedAt || createdAt
  };
}

function sortInquiries(a, b) {
  if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
  return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
}

function isInquiryExpired(inquiry) {
  if (inquiry.pinned) return false;
  const createdTime = new Date(inquiry.createdAt || 0).getTime();
  if (!Number.isFinite(createdTime)) return false;
  return Date.now() - createdTime > INQUIRY_RETENTION_DAYS * 24 * 60 * 60 * 1000;
}

function getNormalizedSubjects(subjects = [], articles = []) {
  const subjectMap = new Map();

  const addSubject = (subject, fallbackOrder) => {
    const normalized = normalizeSubject(subject, fallbackOrder);
    if (!subjectMap.has(normalized.slug)) {
      subjectMap.set(normalized.slug, normalized);
    }
  };

  subjects.forEach((subject, index) => addSubject(subject, index + 1));

  articles
    .map((article) => article.category)
    .filter(Boolean)
    .forEach((title, index) => {
      const slug = slugify(title);
      if (!subjectMap.has(slug)) {
        addSubject({ id: slug, title, slug, order: subjects.length + index + 1 }, subjects.length + index + 1);
      }
    });

  return [...subjectMap.values()].sort((a, b) => a.order - b.order || a.title.localeCompare(b.title));
}

function loadMermaid() {
  if (window.mermaid) return Promise.resolve(window.mermaid);
  if (mermaidLoadPromise) return mermaidLoadPromise;

  mermaidLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${MERMAID_SCRIPT_URL}"]`);
    const finish = () => window.mermaid ? resolve(window.mermaid) : reject(new Error("Mermaid did not initialize."));
    if (existing) {
      existing.addEventListener("load", finish, { once: true });
      existing.addEventListener("error", () => reject(new Error("Unable to load Mermaid.")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = MERMAID_SCRIPT_URL;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.onload = finish;
    script.onerror = () => reject(new Error("Unable to load Mermaid."));
    document.head.appendChild(script);
  });

  return mermaidLoadPromise;
}

function loadDocxLib() {
  if (window.JSZip) return Promise.resolve(window.JSZip);
  if (docxLibLoadPromise) return docxLibLoadPromise;

  docxLibLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${DOCX_LIB_SCRIPT_URL}"]`);
    const finish = () => window.JSZip ? resolve(window.JSZip) : reject(new Error("JSZip did not initialize."));
    if (existing) {
      existing.addEventListener("load", finish, { once: true });
      existing.addEventListener("error", () => reject(new Error("Unable to load JSZip.")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = DOCX_LIB_SCRIPT_URL;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.onload = finish;
    script.onerror = () => reject(new Error("Unable to load JSZip."));
    document.head.appendChild(script);
  });

  return docxLibLoadPromise;
}

async function initializeMermaidDiagrams(root = document) {
  const nodes = [...root.querySelectorAll(".tutorial-mermaid-diagram .mermaid:not([data-processed])")];
  if (!nodes.length) return;

  nodes.forEach((node) => {
    node.closest("[data-mermaid-diagram]")?.setAttribute("data-mermaid-diagram", "loading");
  });

  try {
    const mermaid = await loadMermaid();
    mermaid.initialize({
      startOnLoad: false,
      securityLevel: "strict",
      theme: "base",
      themeVariables: {
        primaryColor: "#eaffdf",
        primaryTextColor: "#102033",
        primaryBorderColor: "#75cf55",
        lineColor: "#2f6f1f",
        secondaryColor: "#edf7ff",
        tertiaryColor: "#ffffff",
        fontFamily: "Inter, Arial, sans-serif"
      }
    });

    for (const node of nodes) {
      try {
        await mermaid.run({ nodes: [node] });
        node.closest("[data-mermaid-diagram]")?.setAttribute("data-mermaid-diagram", "ready");
      } catch (error) {
        node.closest("[data-mermaid-diagram]")?.setAttribute("data-mermaid-diagram", "error");
        console.warn("Could not render Mermaid diagram:", error);
      }
    }
  } catch (error) {
    nodes.forEach((node) => node.closest("[data-mermaid-diagram]")?.setAttribute("data-mermaid-diagram", "error"));
    console.warn("Mermaid diagrams are unavailable:", error);
  }
}
function render() {
  const route = getRoute();
  try {
    const activePage = route.page === "programs"
      ? "courses"
      : ["tutorials", "articles", "article"].includes(route.page)
        ? "tutorials"
        : ["blog", "blogs"].includes(route.page)
          ? "blog"
          : ["practice", "coding", "coding-round", "coding-practice"].includes(route.page)
            ? "coding-practice"
            : route.page;
    updateActiveNav(activePage);
    // Lets CSS target a single page without a renderer knowing about it -
    // used by the mobile home ordering in styles.css.
    document.body.dataset.page = activePage;

    const routeTabId = getRouteTabId(route.page);
    if (routeTabId && !isPublicTabVisible(routeTabId)) {
      app.innerHTML = renderHiddenPublicTabPage(routeTabId);
    } else if (route.page === "courses" || route.page === "programs") {
      app.innerHTML = route.id ? renderCourseDetailsPage(route.id) : renderCoursesPage();
    } else if (["tutorials", "articles", "article"].includes(route.page)) {
      app.innerHTML = renderTutorialsPage(route.id);
    } else if (["blog", "blogs"].includes(route.page)) {
      app.innerHTML = renderBlogPage(route.id);
    } else if (["practice", "coding", "coding-round", "coding-practice"].includes(route.page)) {
      app.innerHTML = hasLearningAccess() ? renderCodingPracticePage(route.id) : renderLearningAuthGate("coding practice");
    } else if (route.page === "certificates") {
      app.innerHTML = renderCertificatePage(route.id);
    } else if (route.page === "authors") {
      app.innerHTML = renderAuthorPage(route.id);
    } else if (route.page === "sessions") {
      app.innerHTML = renderSessionsPage(route.id);
    } else if (route.page === "events") {
      app.innerHTML = renderEventsPage(route.id);
    } else if (route.page === "whatsapp") {
      app.innerHTML = renderWhatsappPage();
    } else if (route.page === "community") {
      app.innerHTML = hasLearningAccess() ? renderCommunityPage(route.id) : renderLearningAuthGate("community");
    } else if (route.page === "search") {
      app.innerHTML = renderSearchPage();
    } else if (route.page === "inquiry") {
      app.innerHTML = renderInquiryPage();
    } else if (route.page === "about") {
      app.innerHTML = renderAboutPage();
    } else if (route.page === "contact") {
      app.innerHTML = renderContactPage();
    } else if (route.page === "terms") {
      app.innerHTML = renderTermsPage();
    } else if (route.page === "privacy") {
      app.innerHTML = renderPrivacyPage();
    } else if (route.page === "profile") {
      app.innerHTML = renderStudentProfilePage();
    } else if (route.page === "admin") {
      app.innerHTML = renderAdminPage();
    } else {
      app.innerHTML = renderHomePage();
    }

    updateMetaTags(route);
    updateCourseStructuredData();
    trackPageView(route);
    closeMenu();
    optimizeRenderedImages();
    app.insertAdjacentHTML("beforeend", renderCourseModal());
    // Inside the admin shell so the admin theme (icon sizes, buttons) applies,
    // but after its data-reveal columns, whose transform would trap the
    // fixed overlay inside them.
    (app.querySelector(".admin-dashboard-shell") || app).insertAdjacentHTML("beforeend", renderAdminSectionModal() + renderAdminStudentModal() + renderAdminBookingModal() + renderAdminReviewModal());
    normalizeRouteLinks();
    hideLinksToHiddenSections();
    revealVisibleItems();
    initializeAds();
    alignActiveTopicInSidebar();
    resetTutorialScrollOnChange();
    initializeFullViewScrollSpy();
    initializeMermaidDiagrams();
    document.body.classList.toggle("tutorial-full-view-open", Boolean(document.querySelector("[data-tutorial-full-view]")));
    document.body.classList.toggle("course-modal-open", Boolean(document.querySelector("[data-course-modal]")));
    // A section popup that did not render (the admin changed screen or
    // subject) is dropped, so it cannot reappear later out of context.
    if (state.sectionModal && !document.querySelector("[data-section-modal]")) state.sectionModal = null;
    if (state.studentDetailId && !document.querySelector("[data-student-modal]")) state.studentDetailId = null;
    if (state.bookingModal && !document.querySelector("[data-booking-modal]")) state.bookingModal = null;
    if (state.reviewModal && !document.querySelector("[data-review-modal]")) state.reviewModal = null;
    document.body.classList.toggle("admin-modal-open", Boolean(state.sectionModal || state.studentDetailId || state.bookingModal || state.reviewModal));
    scheduleRouteContentLoad(route);
    scheduleDiscussionLoad(route);
    scheduleCommunityLoad(route);
    scheduleEventLoad(route);
    scheduleSessionLoad(route);
    scheduleCertificateLoad(route);
    scheduleLeaderboardLoad(route);
  } catch (error) {
    console.error("SkillUp render failed:", error);
    app.innerHTML = renderAppError(route, error);
    document.body.classList.remove("tutorial-full-view-open", "course-modal-open", "admin-modal-open");
  }
}

function renderAppError(route, error) {
  const isAdminRoute = route?.page === "admin";
  const message = error?.message || "Something went wrong while opening this page.";
  return `
    <section class="admin-shell admin-login-shell section-band">
      <div class="admin-card login-panel" data-reveal>
        <p class="eyebrow">${isAdminRoute ? "Admin dashboard" : "SkillUp Class"}</p>
        <h1>${isAdminRoute ? "Admin page needs a refresh." : "This page could not open."}</h1>
        <p class="muted">${escapeHtml(message)}</p>
        <div class="form-actions">
          <button class="button primary" type="button" data-reload-page>Refresh page</button>
          <a class="button ghost" href="#home">Go home</a>
        </div>
      </div>
    </section>
  `;
}
const SITE_ORIGIN = "https://skillupclass.com";
const DEFAULT_META = {
  title: "SkillUp Class | Learn AI: Machine Learning, Generative AI, RAG and AI Agents",
  description: "Learn AI the practical way with free tutorials and a clear roadmap: Python, machine learning, NLP, generative AI, RAG and agentic AI.",
  image: `${SITE_ORIGIN}/assets/skillup-logo.jpg`
};

function truncateForMeta(text, max = 160) {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max - 1).trimEnd()}…`;
}

function setMetaContent(selector, content) {
  const node = document.head.querySelector(selector);
  if (node && content) node.setAttribute("content", content);
}

function resolveRouteMeta(route) {
  const meta = { ...DEFAULT_META, path: "/" };

  if (route.page === "sessions" && route.id) {
    const session = findSessionById(route.id);
    if (session && session.status === "published") {
      meta.title = `${session.title} | 1:1 Session | SkillUp Class`;
      meta.description = truncateForMeta(summarizeFormattedText(session.description, 200) || DEFAULT_META.description);
      meta.image = safeUrl(session.coverImage) || DEFAULT_META.image;
      meta.path = `/sessions/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  if (route.page === "certificates" && route.id) {
    const certificate = state.certificateCache[route.id];
    if (certificate) {
      meta.title = `Certificate: ${certificate.subjectTitle} | SkillUp Class`;
      meta.description = truncateForMeta(`${certificate.name} completed every tutorial in ${certificate.subjectTitle} on SkillUp Class.`);
      meta.path = `/certificates/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  if (route.page === "authors" && route.id) {
    const works = getAuthorPublications(route.id);
    const name = [...works.tutorials, ...works.blogs, ...works.courses][0]?.submittedByName;
    if (name) {
      meta.title = `${name} | Author | SkillUp Class`;
      meta.description = truncateForMeta(`Tutorials, blog posts and courses by ${name} on SkillUp Class.`);
      meta.path = `/authors/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  if ((route.page === "courses" || route.page === "programs") && route.id) {
    const course = getPublicCourses().find((item) => item.id === route.id || item.slug === route.id);
    if (course) {
      meta.title = `${course.title} | SkillUp Class`;
      meta.description = truncateForMeta(course.description || course.outcome || DEFAULT_META.description);
      meta.image = safeUrl(course.coverImage) || DEFAULT_META.image;
      meta.path = `/courses/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  if (["tutorials", "articles", "article"].includes(route.page) && route.id) {
    const tutorial = findTutorialById(sortTutorials(getPublicTutorials()), route.id);
    if (tutorial) {
      meta.title = `${tutorial.title} | SkillUp Class`;
      meta.description = truncateForMeta(tutorial.excerpt || DEFAULT_META.description);
      meta.image = safeUrl(tutorial.coverImage) || DEFAULT_META.image;
      meta.path = `/tutorials/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  if (["blog", "blogs"].includes(route.page) && route.id) {
    const blog = getPublished(state.blogs).sort(sortNewest).find((item) => item.id === route.id || item.slug === route.id);
    if (blog) {
      meta.title = `${blog.title} | SkillUp Class`;
      meta.description = truncateForMeta(blog.excerpt || DEFAULT_META.description);
      meta.image = safeUrl(blog.coverImage) || DEFAULT_META.image;
      meta.path = `/blog/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  if (["practice", "coding", "coding-round", "coding-practice"].includes(route.page) && route.id) {
    const problem = getCodingPracticeItemBySlug(route.id);
    if (problem) {
      meta.title = `${problem.title} | SkillUp Class Coding Practice`;
      meta.description = truncateForMeta(problem.description || DEFAULT_META.description);
      meta.path = `/coding-practice/${encodeURIComponent(route.id)}`;
    }
    return meta;
  }

  const sectionMeta = {
    courses: { title: "Courses | SkillUp Class", description: "Browse SkillUp Class courses in AI and software development, with project work and interview preparation." },
    programs: { title: "Courses | SkillUp Class", description: "Browse SkillUp Class courses in AI and software development, with project work and interview preparation." },
    tutorials: { title: "Tutorials | SkillUp Class", description: "Free AI and technology tutorials, organised by subject so you always know what to learn next." },
    articles: { title: "Tutorials | SkillUp Class", description: "Free AI and technology tutorials, organised by subject so you always know what to learn next." },
    article: { title: "Tutorials | SkillUp Class", description: "Free AI and technology tutorials, organised by subject so you always know what to learn next." },
    blog: { title: "Blog | SkillUp Class", description: "Independent articles, announcements, and learning notes from SkillUp Class." },
    blogs: { title: "Blog | SkillUp Class", description: "Independent articles, announcements, and learning notes from SkillUp Class." },
    "coding-practice": { title: "Coding Practice | SkillUp Class", description: "Practice coding interview problems with instant test runs in JavaScript and Kotlin." },
    practice: { title: "Coding Practice | SkillUp Class", description: "Practice coding interview problems with instant test runs in JavaScript and Kotlin." },
    coding: { title: "Coding Practice | SkillUp Class", description: "Practice coding interview problems with instant test runs in JavaScript and Kotlin." },
    "coding-round": { title: "Coding Practice | SkillUp Class", description: "Practice coding interview problems with instant test runs in JavaScript and Kotlin." },
    inquiry: { title: "Course Inquiry | SkillUp Class", description: "Tell SkillUp Class about your goals and get guidance on the right course or learning path." },
    privacy: { title: "Privacy Policy | SkillUp Class", description: "How SkillUp Class collects, uses, and protects your information." },
    terms: { title: "Terms of Use | SkillUp Class", description: "The rules for using SkillUp Class, its Students Hub and events." },
    about: { title: "About | SkillUp Class", description: "SkillUp Class teaches practical AI, from Python and machine learning to generative AI, RAG and AI agents, through free tutorials and guided courses." },
    contact: { title: "Contact | SkillUp Class", description: "How to reach SkillUp Class about courses, your account or your data." },
    search: { title: "Search | SkillUp Class", description: "Search SkillUp Class courses, tutorials, and blog posts." },
    community: { title: "Students Hub | SkillUp Class", description: "Share your ideas, ask questions, and discuss what you are building with other SkillUp Class students." },
    events: { title: "Events | SkillUp Class", description: "Register for SkillUp Class live sessions, workshops, and doubt-clearing calls." },
    sessions: { title: "1:1 Sessions | SkillUp Class", description: "Book a 1:1 mentorship, resume review or mock interview session with a SkillUp Class mentor." },
    whatsapp: { title: "WhatsApp Community | SkillUp Class", description: "Join the SkillUp Class WhatsApp community to ask quick questions, share ideas, and hear about new tutorials first." }
  };

  const section = sectionMeta[route.page];
  if (section) {
    meta.title = section.title;
    meta.description = section.description;
    meta.path = `/${route.page}`;
  }

  return meta;
}

function updateMetaTags(route) {
  try {
    const meta = resolveRouteMeta(route);
    const canonicalUrl = `${SITE_ORIGIN}${meta.path === "/" ? "/" : meta.path}`;

    document.title = meta.title;
    setMetaContent('meta[name="description"]', meta.description);
    setMetaContent('meta[property="og:title"]', meta.title);
    setMetaContent('meta[property="og:description"]', meta.description);
    setMetaContent('meta[property="og:image"]', meta.image);
    setMetaContent('meta[property="og:url"]', canonicalUrl);
    setMetaContent('meta[name="twitter:title"]', meta.title);
    setMetaContent('meta[name="twitter:description"]', meta.description);
    setMetaContent('meta[name="twitter:image"]', meta.image);

    const canonicalLink = document.head.querySelector("link[data-canonical]");
    if (canonicalLink) canonicalLink.setAttribute("href", canonicalUrl);
  } catch (error) {
    console.warn("Could not update page meta tags:", error);
  }
}

// Tracks which tutorial's reader panel was last on screen so we only jump
// to the top when the user actually opens a DIFFERENT lesson, never on a
// re-render of the same lesson (e.g. clicking "mark complete" or bookmark
// while scrolled down). Needed now that .tutorial-reader-panel scrolls as
// part of the normal page instead of resetting itself via its own internal
// scrollbox - see the .tutorial-reader-panel comment in styles.css.
let lastTutorialReaderId = "";
function resetTutorialScrollOnChange() {
  const panel = document.querySelector(".tutorial-reader-panel");
  if (!panel) {
    lastTutorialReaderId = "";
    return;
  }
  const renderedId = panel.getAttribute("data-tutorial-id") || "";
  if (renderedId === lastTutorialReaderId) return;
  lastTutorialReaderId = renderedId;
  window.scrollTo(0, 0);
  recordLearningActivity({ tutorialId: renderedId });
  updateTutorialReadingProgress();
}

function alignActiveTopicInSidebar() {
  const align = () => {
    const sidebar = document.querySelector(".topic-sidebar");
    const activeTopic = sidebar?.querySelector(".topic-list a.is-active");
    if (!sidebar || !activeTopic || sidebar.scrollHeight <= sidebar.clientHeight) return;

    const sidebarTop = sidebar.getBoundingClientRect().top;
    const activeTop = activeTopic.getBoundingClientRect().top;
    const maxScrollTop = sidebar.scrollHeight - sidebar.clientHeight;
    const targetTop = sidebar.scrollTop + activeTop - sidebarTop - 12;
    sidebar.scrollTop = Math.max(0, Math.min(targetTop, maxScrollTop));
  };

  window.requestAnimationFrame(() => {
    align();
    window.setTimeout(align, 80);
    window.setTimeout(align, 240);
  });
}

function handleHashChange() {
  renderedRoutePath = getCurrentRoutePath();
  const route = getRoute();
  const keepsFullViewOpen = state.fullViewTutorialId
    && ["tutorials", "articles", "article"].includes(route.page)
    && route.id === state.fullViewTutorialId;

  if (!keepsFullViewOpen) {
    state.fullViewTutorialId = "";
  }
  state.activeCourseId = "";

  render();
}

// ---- Routing ----------------------------------------------------------------------
//
// Every page has a real address (/sessions/mock-interview), so search engines
// can index it and it can be shared. Addresses from before, with the page
// after a "#" (/#sessions/mock-interview), still work: they are rewritten to
// the clean form on load, and #page links still found in saved content are
// routed when clicked.

// The first part of the address for every page render() knows.
const ROUTE_PAGES = new Set([
  "home", "courses", "programs", "tutorials", "articles", "article", "blog", "blogs",
  "practice", "coding", "coding-round", "coding-practice", "certificates", "authors",
  "sessions", "events", "whatsapp", "community", "search", "inquiry", "about", "contact",
  "terms", "privacy", "profile", "admin"
]);

let renderedRoutePath = "";

function getRoute() {
  let raw = "";
  try {
    raw = decodeURIComponent(window.location.pathname.replace(/^\/+/, ""));
  } catch {
    raw = window.location.pathname.replace(/^\/+/, "");
  }
  const [page, ...rest] = (raw || "home").split("/");
  return {
    page: page || "home",
    id: rest.join("/").replace(/\/+$/, ""),
    query: new URLSearchParams(window.location.search)
  };
}

function getCurrentRoutePath() {
  return window.location.pathname + window.location.search;
}

// "#sessions/mock?x=1" -> "/sessions/mock?x=1", "#home" -> "/". Anything that
// is not one of the site's pages (an in-page anchor like #app) gives "".
function hashToRoutePath(hash) {
  const text = String(hash || "").replace(/^#\/?/, "");
  const page = text.split(/[/?]/)[0];
  if (!ROUTE_PAGES.has(page)) return "";
  return text === "home" ? "/" : `/${text}`;
}

// Swaps an old-style address for its clean form in place, keeping the
// history entry. Returns whether it did.
function upgradeLegacyHashRoute() {
  const path = hashToRoutePath(window.location.hash);
  if (!path) return false;
  history.replaceState(history.state, "", path);
  return true;
}

// Opens a page without reloading the site. Accepts "/sessions" or "#sessions".
function navigateTo(target, { replace = false } = {}) {
  const text = String(target || "/");
  const path = text.startsWith("#") ? hashToRoutePath(text) || "/" : text;
  if (path === getCurrentRoutePath()) {
    render();
    return;
  }
  history[replace ? "replaceState" : "pushState"](null, "", path);
  handleHashChange();
  window.scrollTo(0, 0);
}

// The page address a link leads to, or "" when the browser should follow it
// itself (another site, a file such as /sitemap.xml, an in-page anchor).
function getInternalLinkPath(link) {
  const raw = link.getAttribute("href") || "";
  if (raw.startsWith("#")) return hashToRoutePath(raw);
  let url;
  try {
    url = new URL(raw, window.location.href);
  } catch {
    return "";
  }
  if (url.origin !== window.location.origin) return "";
  if (url.pathname === "/" && url.hash) return hashToRoutePath(url.hash);
  const page = url.pathname.replace(/^\/+/, "").split("/")[0];
  if (page && !ROUTE_PAGES.has(page)) return "";
  return url.pathname + url.search;
}

function handleRouteLinkClick(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest("a[href]");
  if (!link || link.hasAttribute("download") || (link.target && link.target !== "_self")) return;
  const path = getInternalLinkPath(link);
  if (!path) return;
  event.preventDefault();
  navigateTo(path);
}

// Rendered links are written as #page; this gives each one its real
// address, so search engines can follow it and "open in new tab" works.
function normalizeRouteLinks(root = document) {
  root.querySelectorAll('a[href^="#"], a[href*="/#"]').forEach((link) => {
    const raw = link.getAttribute("href");
    let path = "";
    if (raw.startsWith("#")) {
      path = hashToRoutePath(raw);
    } else {
      try {
        const url = new URL(raw, window.location.href);
        if (url.origin === window.location.origin && url.pathname === "/") path = hashToRoutePath(url.hash);
      } catch {
        path = "";
      }
    }
    if (path) link.setAttribute("href", path);
  });
}

function updateActiveNav(page) {
  syncPublicNavigation();
  document.querySelectorAll("[data-nav-link]").forEach((link) => {
    link.classList.toggle("is-active", link.dataset.navLink === page);
  });
  syncStudentNavAccount();
}

// The nav and footer links carry data-public-tab, so syncPublicNavigation()
// hides those. But most links are rendered inline by the page renderers -
// home CTAs, "back to" buttons, card links - and tagging each one by hand
// would leave the next new link to leak again. Sweeping the rendered DOM
// keeps the rule in one place: if a section is hidden from students, no
// link into it survives anywhere on the page.
function hideLinksToHiddenSections() {
  document.querySelectorAll('a[href^="#"], a[href^="/"]').forEach((link) => {
    // Already handled by syncPublicNavigation, and it owns those nodes.
    if (link.hasAttribute("data-public-tab")) return;
    const page = link.getAttribute("href").replace(/^[#/]+/, "").split(/[/?#]/)[0];
    const tabId = getRouteTabId(page);
    if (!tabId || isPublicTabVisible(tabId)) return;
    // Only ever hide - never clear someone else's hidden flag. The home
    // search results ship hidden and are revealed by typing, so assigning
    // hidden=false here would pop the whole list open on load.
    link.hidden = true;
  });
}

function syncPublicNavigation() {
  document.querySelectorAll("[data-public-tab]").forEach((node) => {
    node.hidden = !isPublicTabVisible(node.dataset.publicTab);
  });
}

function syncStudentNavAccount() {
  const nav = document.querySelector("[data-nav]");
  if (!nav) return;

  nav.querySelectorAll("[data-nav-account]").forEach((node) => node.remove());

  const isSignedIn = Boolean(state.user);
  const label = isSignedIn
    ? state.isAdmin
      ? "Admin"
      : state.isContributor
        ? state.contributorRecord?.name || state.user.email || "Contributor"
        : state.studentProfile?.name || state.user.displayName || state.user.email || "Student"
    : "Account";
  const initials = isSignedIn ? getInitials(label) : "U";
  const helperText = isSignedIn
    ? state.isAdmin ? "Administrator" : state.isContributor ? "Contributor" : "Student account"
    : "Login options";
  const accountActions = isSignedIn
    ? state.isAdmin || state.isContributor
      ? `
        <a href="#admin" data-account-menu-link>${state.isAdmin ? "Go to Admin Page" : "Go to Dashboard"}</a>
        ${state.isAdmin ? "" : `<a href="#profile" data-account-menu-link>Edit Profile</a>`}
        <button type="button" data-signout>Sign out</button>
      `
      : `
        <a href="#profile" data-account-menu-link>Edit Profile</a>
        <button type="button" data-signout>Sign out</button>
      `
    : `
        <a href="#profile" data-account-menu-link>Student Login</a>
        <a href="#admin" data-account-menu-link>Admin Login</a>
      `;

  nav.insertAdjacentHTML("beforeend", `
    <div class="nav-account" data-nav-account>
      <button class="account-menu-button" type="button" data-account-menu-toggle aria-expanded="false" aria-label="Open user menu">
        <span class="account-avatar" aria-hidden="true">${escapeHtml(initials)}</span>
        <span class="account-menu-name">${escapeHtml(label)}</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
      </button>
      <div class="account-dropdown" data-account-dropdown>
        <div class="account-dropdown-head">
          <span class="account-avatar is-large" aria-hidden="true">${escapeHtml(initials)}</span>
          <span><strong>${escapeHtml(label)}</strong><small>${escapeHtml(helperText)}</small></span>
        </div>
        <div class="account-dropdown-actions">
          ${accountActions}
        </div>
      </div>
    </div>
  `);
}
const PRACTICE_TOPICS = [
  {
    title: "Arrays & Hashing",
    problems: [
      { title: "Contains Duplicate", difficulty: "easy", companies: ["Google", "Amazon", "Apple"] },
      { title: "Valid Anagram", difficulty: "easy", companies: ["Amazon", "Bloomberg"] },
      { title: "Two Sum", difficulty: "easy", companies: ["Google", "Microsoft"] },
      { title: "Group Anagrams", difficulty: "medium", companies: ["Amazon", "Meta"] },
      { title: "Top K Frequent Elements", difficulty: "medium", companies: ["Google", "Uber"] },
      { title: "Product of Array Except Self", difficulty: "medium", companies: ["Meta", "Apple"] },
      { title: "Valid Sudoku", difficulty: "medium", companies: ["Amazon"] },
      { title: "Longest Consecutive Sequence", difficulty: "medium", companies: ["Google", "Microsoft"] }
    ]
  },
  {
    title: "Two Pointers",
    problems: [
      { title: "Valid Palindrome", difficulty: "easy", companies: ["Microsoft", "Meta"] },
      { title: "Two Sum II", difficulty: "medium", companies: ["Amazon"] },
      { title: "3Sum", difficulty: "medium", companies: ["Meta", "Google"] },
      { title: "Container With Most Water", difficulty: "medium", companies: ["Google", "Amazon"] },
      { title: "Trapping Rain Water", difficulty: "hard", companies: ["Google", "Apple"] }
    ]
  },
  {
    title: "Sliding Window",
    problems: [
      { title: "Best Time to Buy and Sell Stock", difficulty: "easy", companies: ["Amazon", "Microsoft"] },
      { title: "Longest Substring Without Repeating Characters", difficulty: "medium", companies: ["Google", "Meta"] },
      { title: "Longest Repeating Character Replacement", difficulty: "medium", companies: ["Amazon"] },
      { title: "Permutation in String", difficulty: "medium", companies: ["Microsoft"] },
      { title: "Minimum Window Substring", difficulty: "hard", companies: ["Google", "Meta"] }
    ]
  },
  {
    title: "Stack & Queue",
    problems: [
      { title: "Valid Parentheses", difficulty: "easy", companies: ["Google", "Amazon"] },
      { title: "Min Stack", difficulty: "medium", companies: ["Amazon"] },
      { title: "Evaluate Reverse Polish Notation", difficulty: "medium", companies: ["LinkedIn"] },
      { title: "Daily Temperatures", difficulty: "medium", companies: ["Meta"] },
      { title: "Largest Rectangle in Histogram", difficulty: "hard", companies: ["Google"] }
    ]
  },
  {
    title: "Binary Search",
    problems: [
      { title: "Binary Search", difficulty: "easy", companies: ["Google"] },
      { title: "Search a 2D Matrix", difficulty: "medium", companies: ["Amazon"] },
      { title: "Koko Eating Bananas", difficulty: "medium", companies: ["Google"] },
      { title: "Search in Rotated Sorted Array", difficulty: "medium", companies: ["Microsoft", "Meta"] },
      { title: "Median of Two Sorted Arrays", difficulty: "hard", companies: ["Google"] }
    ]
  },
  {
    title: "Linked List",
    problems: [
      { title: "Reverse Linked List", difficulty: "easy", companies: ["Google", "Meta"] },
      { title: "Merge Two Sorted Lists", difficulty: "easy", companies: ["Amazon"] },
      { title: "Linked List Cycle", difficulty: "easy", companies: ["Microsoft"] },
      { title: "Reorder List", difficulty: "medium", companies: ["Meta"] },
      { title: "Merge K Sorted Lists", difficulty: "hard", companies: ["Amazon", "Google"] }
    ]
  },
  {
    title: "Trees & Graphs",
    problems: [
      { title: "Invert Binary Tree", difficulty: "easy", companies: ["Google"] },
      { title: "Maximum Depth of Binary Tree", difficulty: "easy", companies: ["Amazon"] },
      { title: "Validate Binary Search Tree", difficulty: "medium", companies: ["Microsoft"] },
      { title: "Number of Islands", difficulty: "medium", companies: ["Google", "Meta"] },
      { title: "Course Schedule", difficulty: "medium", companies: ["Amazon"] },
      { title: "Word Ladder", difficulty: "hard", companies: ["Google"] }
    ]
  },
  {
    title: "Dynamic Programming",
    problems: [
      { title: "Climbing Stairs", difficulty: "easy", companies: ["Amazon"] },
      { title: "House Robber", difficulty: "medium", companies: ["Google"] },
      { title: "Coin Change", difficulty: "medium", companies: ["Amazon", "Uber"] },
      { title: "Longest Increasing Subsequence", difficulty: "medium", companies: ["Microsoft"] },
      { title: "Edit Distance", difficulty: "hard", companies: ["Google"] }
    ]
  },
  {
    title: "Mobile System Scenarios",
    problems: [
      { title: "LRU Cache", difficulty: "medium", companies: ["Google", "Amazon"] },
      { title: "Rate Limiter", difficulty: "medium", companies: ["Uber"] },
      { title: "Pagination Window", difficulty: "easy", companies: ["Meta"] },
      { title: "Retry With Exponential Backoff", difficulty: "easy", companies: ["Amazon"] },
      { title: "Debounce User Input", difficulty: "medium", companies: ["Google"] }
    ]
  }
];

const CODING_ROUND_CATEGORIES = [
  {
    title: "String Programs",
    programs: [
      { title: "Palindrome String", difficulty: "easy" },
      { title: "Reverse a String", difficulty: "easy" },
      { title: "Count Vowels in a String", difficulty: "easy" },
      { title: "Check Two Strings are Anagram", difficulty: "easy" },
      { title: "Balanced Parentheses", difficulty: "medium" },
      { title: "First Non-Repeating Character", difficulty: "medium" },
      { title: "Longest Substring Without Repeating Characters", difficulty: "medium" },
      { title: "Longest Palindromic Substring", difficulty: "hard" }
    ]
  },
  {
    title: "Number Programs",
    programs: [
      { title: "Factorial of a Number", difficulty: "easy" },
      { title: "Check Prime Number", difficulty: "easy" },
      { title: "Fibonacci Series", difficulty: "easy" },
      { title: "Armstrong Number", difficulty: "easy" },
      { title: "GCD of Two Numbers", difficulty: "medium" },
      { title: "Decimal to Binary", difficulty: "medium" },
      { title: "Count Primes", difficulty: "medium" }
    ]
  },
  {
    title: "Array Programs",
    programs: [
      { title: "Largest Element in an Array", difficulty: "easy" },
      { title: "Reverse an Array", difficulty: "easy" },
      { title: "Second Largest Element", difficulty: "easy" },
      { title: "Find the Missing Number", difficulty: "medium" },
      { title: "Maximum Subarray Sum", difficulty: "medium" },
      { title: "Rotate Array by K", difficulty: "medium" },
      { title: "Merge Two Sorted Arrays", difficulty: "medium" },
      { title: "First Missing Positive", difficulty: "hard" }
    ]
  },
  {
    title: "Pattern Programs",
    programs: [
      { title: "Right-Angled Star Triangle", difficulty: "easy" },
      { title: "Inverted Star Triangle", difficulty: "easy" },
      { title: "Floyd's Triangle", difficulty: "easy" },
      { title: "Pyramid Star Pattern", difficulty: "medium" },
      { title: "Diamond Star Pattern", difficulty: "medium" },
      { title: "Pascal's Triangle", difficulty: "medium" }
    ]
  },
  {
    title: "Searching & Sorting",
    programs: [
      { title: "Linear Search", difficulty: "easy" },
      { title: "Binary Search", difficulty: "easy" },
      { title: "Bubble Sort", difficulty: "easy" },
      { title: "Selection Sort", difficulty: "easy" },
      { title: "Insertion Sort", difficulty: "easy" },
      { title: "Kth Largest Element", difficulty: "medium" },
      { title: "Search in Rotated Sorted Array", difficulty: "medium" }
    ]
  },
  {
    title: "Matrix Programs",
    programs: [
      { title: "Transpose of a Matrix", difficulty: "easy" },
      { title: "Rotate Matrix 90 Degrees", difficulty: "medium" },
      { title: "Set Matrix Zeroes", difficulty: "medium" },
      { title: "Spiral Matrix", difficulty: "medium" },
      { title: "Matrix Multiplication", difficulty: "medium" },
      { title: "Search a 2D Matrix", difficulty: "medium" }
    ]
  },
  {
    title: "Recursion & Backtracking",
    programs: [
      { title: "Print Numbers Recursively", difficulty: "easy" },
      { title: "Recursive Fibonacci", difficulty: "easy" },
      { title: "Subsets", difficulty: "medium" },
      { title: "Permutations", difficulty: "medium" },
      { title: "Combination Sum", difficulty: "medium" },
      { title: "N Queens", difficulty: "hard" }
    ]
  },
  {
    title: "Real-World Scenarios",
    programs: [
      { title: "LRU Cache", difficulty: "medium" },
      { title: "Pagination", difficulty: "easy" },
      { title: "Chunk an Array", difficulty: "easy" },
      { title: "Exponential Backoff Delays", difficulty: "easy" },
      { title: "Debounce Simulation", difficulty: "medium" },
      { title: "Rate Limiter", difficulty: "medium" },
      { title: "Parse Query String", difficulty: "medium" },
      { title: "Event Emitter", difficulty: "medium" }
    ]
  }
];

function getPracticeProblems() {
  return PRACTICE_TOPICS.flatMap((topic) => topic.problems.map((problem) => ({ ...problem, topic: topic.title, slug: slugify(`${topic.title}-${problem.title}`) })));
}

function getCodingRoundPrograms() {
  return CODING_ROUND_CATEGORIES.flatMap((category) => category.programs.map((program) => ({ ...program, category: category.title, slug: slugify(`${category.title}-${program.title}`) })));
}

// Solved coding problems (slug -> date). Kept in the browser, and on the
// student record when signed in, so they follow the student across devices
// and count on the leaderboard.
function getPracticeSolvedMap() {
  let local = {};
  try {
    local = JSON.parse(localStorage.getItem("skillup_practice_solved") || "{}") || {};
  } catch {
    local = {};
  }
  const account = hasStudentProgressSync() ? state.studentProfile?.solvedProblems || {} : {};
  return { ...local, ...account };
}

function setPracticeSolvedMap(map) {
  try {
    localStorage.setItem("skillup_practice_solved", JSON.stringify(map || {}));
  } catch (error) {
    console.warn("Could not save solved problems in this browser:", error);
  }
  if (hasStudentProgressSync()) syncSolvedProblems(map || {});
}

async function syncSolvedProblems(map) {
  const solvedProblems = Object.fromEntries(Object.entries(map).slice(0, 5000));
  const now = new Date().toISOString();
  try {
    await firebase.api.updateDoc(firebase.api.doc(firebase.db, "students", state.user.uid), { solvedProblems, updatedAt: now });
    state.studentProfile = { ...state.studentProfile, solvedProblems, updatedAt: now };
    await firebase.api.setDoc(
      firebase.api.doc(firebase.db, "publicProfiles", state.user.uid),
      buildPublicProfilePayload(state.studentProfile),
      { merge: true }
    );
    state.codingLeaderboard = null;
  } catch (error) {
    console.warn("Could not save solved problems:", error);
  }
}

const CODING_PRACTICE_RUNNER_ENDPOINT = "/api/run-code";
const CODING_PRACTICE_FUNCTION_REGION = "us-central1";
const CODING_PRACTICE_COMPILER_TIMEOUT_MS = 25000;
const CODING_PRACTICE_FREE_MODE = true;
const CODING_PRACTICE_LANGUAGES = [
  { id: "javascript", label: "JavaScript", extension: "js", runner: "browser", runnable: true },
  { id: "python", label: "Python", extension: "py", runner: "browser", runnable: true, engine: "pyodide" },
  { id: "kotlin", label: "Kotlin", extension: "kt", runner: "browser", runnable: true, beta: true },
  { id: "java", label: "Java", extension: "java", runner: "remote", runnable: false },
  { id: "dart", label: "Dart", extension: "dart", runner: "remote", runnable: false },
  { id: "swift", label: "Swift", extension: "swift", runner: "remote", runnable: false },
  { id: "cpp", label: "C++", extension: "cpp", runner: "remote", runnable: false }
];
const PYODIDE_CDN_BASE = "https://cdn.jsdelivr.net/pyodide/v0.26.4/full/";
const pythonRunnerState = { worker: null, workerUrl: null, ready: false, requestSeq: 0 };
function canRunCodingPracticeLanguage(language) {
  return language?.runner === "browser" || (!CODING_PRACTICE_FREE_MODE && Boolean(language?.runnable));
}

const DEFAULT_CODING_META_TYPES = [
  { id: "dsa", label: "DSA", order: 1 },
  { id: "program", label: "Coding Round", order: 2 }
];
const DEFAULT_CODING_META_DIFFICULTIES = [
  { id: "easy", label: "Easy", order: 1 },
  { id: "medium", label: "Medium", order: 2 },
  { id: "hard", label: "Hard", order: 3 }
];

function getDefaultCodingMeta() {
  return {
    types: DEFAULT_CODING_META_TYPES,
    difficulties: DEFAULT_CODING_META_DIFFICULTIES,
    categories: getDefaultCodingCategoryOptions()
  };
}

function getDefaultCodingCategoryOptions() {
  const categoryNames = [
    ...PRACTICE_TOPICS.map((topic) => topic.title),
    ...CODING_ROUND_CATEGORIES.map((category) => category.title),
    ...state.codingProblems.map((problem) => problem.category)
  ].map((label) => String(label || "").trim()).filter(Boolean);
  return [...new Set(categoryNames)].map((label, index) => ({ id: slugify(label), label, order: index + 1 }));
}

function normalizeCodingMeta(meta = {}) {
  const defaults = getDefaultCodingMeta();
  return {
    types: normalizeCodingMetaList(meta.types, defaults.types),
    difficulties: normalizeCodingMetaList(meta.difficulties, defaults.difficulties),
    categories: normalizeCodingMetaList(meta.categories, defaults.categories),
    updatedAt: String(meta.updatedAt || "")
  };
}

function normalizeCodingMetaList(list, fallbackList = []) {
  const source = Array.isArray(list) && list.length ? list : fallbackList;
  const usedIds = new Set();
  return source
    .map((option, index) => normalizeCodingMetaOption(option, index + 1))
    .filter(Boolean)
    .map((option) => {
      let id = option.id;
      const baseId = id || "item";
      let repeat = 2;
      while (usedIds.has(id)) {
        id = `${baseId}-${repeat}`;
        repeat += 1;
      }
      usedIds.add(id);
      return { ...option, id };
    })
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label));
}

function normalizeCodingMetaOption(option = {}, fallbackOrder = 1) {
  const source = typeof option === "string" ? { label: option } : option || {};
  const label = String(source.label || source.title || source.name || source.id || "").trim();
  if (!label) return null;
  return {
    id: normalizeCodingMetaId(source.id || source.slug || label),
    label,
    order: Number(source.order || fallbackOrder || 1)
  };
}

function normalizeCodingMetaId(value = "") {
  return slugify(String(value || "").trim()) || "item";
}

function getCodingMeta() {
  return normalizeCodingMeta(state.codingMeta || getDefaultCodingMeta());
}

function getCodingTypeOptions() {
  return getCodingMeta().types;
}

function getCodingDifficultyOptions() {
  return getCodingMeta().difficulties;
}

function getCodingCategoryOptions() {
  return getCodingMeta().categories;
}

function getCodingOptionLabel(listName, value, fallback = "") {
  const id = listName === "types"
    ? normalizeCodingTypeId(value)
    : listName === "difficulties"
      ? normalizeCodingDifficultyId(value)
      : normalizeCodingMetaId(value);
  const list = getCodingMeta()[listName] || [];
  const option = list.find((item) => item.id === id || item.label.toLowerCase() === String(value || "").toLowerCase());
  return option?.label || fallback || capitalize(String(value || id).replace(/[-_]/g, " "));
}

function getCodingTypeLabel(value) {
  const id = normalizeCodingTypeId(value);
  return getCodingOptionLabel("types", id, id === "program" ? "Coding Round" : id === "dsa" ? "DSA" : capitalize(id.replace(/[-_]/g, " ")));
}

function getCodingDifficultyLabel(value) {
  const id = normalizeCodingDifficultyId(value);
  return getCodingOptionLabel("difficulties", id, capitalize(id.replace(/[-_]/g, " ")));
}

function normalizeCodingTypeId(value = "") {
  const text = String(value || "dsa").trim();
  const lower = text.toLowerCase();
  if (lower === "program" || lower.includes("coding round") || lower.includes("program")) return "program";
  if (lower === "dsa" || lower.includes("data structure") || lower.includes("arrays & hashing")) return "dsa";
  return normalizeCodingMetaId(text || "dsa");
}

function normalizeCodingDifficultyId(value = "") {
  return normalizeCodingMetaId(String(value || "medium").toLowerCase()) || "medium";
}

function getCodingPracticeFilterOptions(items = [], field = "kind", listName = "types") {
  const ids = new Set(items.map((item) => String(item[field] || "").trim()).filter(Boolean));
  const configured = listName === "difficulties" ? getCodingDifficultyOptions() : getCodingTypeOptions();
  const options = configured.filter((option) => !ids.size || ids.has(option.id));
  ids.forEach((id) => {
    if (!options.some((option) => option.id === id)) {
      options.push({ id, label: listName === "difficulties" ? getCodingDifficultyLabel(id) : getCodingTypeLabel(id), order: options.length + 1 });
    }
  });
  return sortByOrder(options);
}

function renderCodingMetaSelectOptions(options = [], selectedValue = "") {
  const selected = normalizeCodingMetaId(selectedValue);
  const hasSelected = options.some((option) => option.id === selected || option.label === selectedValue);
  const customOption = selectedValue && !hasSelected ? [{ id: selected, label: selectedValue, order: 0 }] : [];
  return [...customOption, ...options].map((option) => `<option value="${escapeAttr(option.id)}" ${option.id === selected ? "selected" : ""}>${escapeHtml(option.label)}</option>`).join("");
}

function renderCodingCategorySelectOptions(selectedValue = "") {
  const options = getCodingCategoryOptions();
  const selectedLabel = String(selectedValue || "").trim();
  const selectedId = normalizeCodingMetaId(selectedLabel);
  const hasSelected = options.some((option) => option.id === selectedId || option.label.toLowerCase() === selectedLabel.toLowerCase());
  const customOption = selectedLabel && !hasSelected ? [{ id: selectedId, label: selectedLabel, order: 0 }] : [];
  return [...customOption, ...options].map((option) => `<option value="${escapeAttr(option.label)}" ${(option.id === selectedId || option.label === selectedLabel) ? "selected" : ""}>${escapeHtml(option.label)}</option>`).join("");
}
function getStaticCodingPracticeItems() {
  const dsaItems = getPracticeProblems().map((problem, index) => normalizeCodingProblem({
    ...problem,
    id: problem.slug,
    slug: problem.slug,
    kind: "dsa",
    category: problem.topic,
    status: "published",
    order: index + 1
  }, index + 1));
  const programOffset = dsaItems.length;
  const programItems = getCodingRoundPrograms().map((program, index) => {
    const slug = `program-${program.slug}`;
    return normalizeCodingProblem({
      ...program,
      id: slug,
      slug,
      kind: "program",
      category: program.category,
      companies: [],
      status: "published",
      order: programOffset + index + 1
    }, programOffset + index + 1);
  });
  return [...dsaItems, ...programItems];
}

function shouldUseDynamicCodingProblems() {
  return state.codingProblems.length > 0;
}

function getCodingPracticeItems() {
  const source = shouldUseDynamicCodingProblems() ? state.codingProblems : getStaticCodingPracticeItems();
  return sortByOrder(source.map((item, index) => normalizeCodingProblem(item, index + 1))).filter((item) => state.isAdmin || item.status === "published");
}

function getStaticCodingPracticeSeedItems() {
  const now = new Date().toISOString();
  return getStaticCodingPracticeItems().map((item, index) => normalizeCodingProblem({
    ...item,
    id: item.slug,
    prompt: getCodingPracticePrompt(item),
    constraints: getCodingPracticeConstraints(item),
    testCases: getCodingPracticeTestCases(item),
    status: "published",
    order: index + 1,
    createdAt: item.createdAt || now,
    updatedAt: now
  }, index + 1));
}

async function seedStaticCodingProblems() {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  const seedItems = getStaticCodingPracticeSeedItems();
  if (!seedItems.length) {
    showToast("No static coding problems found to seed.");
    return false;
  }
  if (state.firebaseEnabled) {
    const { doc, writeBatch } = firebase.api;
    for (let start = 0; start < seedItems.length; start += 400) {
      const batch = writeBatch(firebase.db);
      seedItems.slice(start, start + 400).forEach((item) => {
        batch.set(doc(firebase.db, "codingProblems", item.id), item, { merge: true });
      });
      await batch.commit();
    }
    await loadContent({ admin: true });
  } else {
    const existingById = new Map(state.codingProblems.map((item) => [item.id, item]));
    seedItems.forEach((item) => existingById.set(item.id, item));
    state.codingProblems = sortByOrder([...existingById.values()].map((item, index) => normalizeCodingProblem(item, index + 1)));
    persistLocalContent();
  }
  state.adminType = "codingProblems";
  state.editingId = null;
  showToast(`${seedItems.length} coding problems are ready in the database.`);
  render();
  return true;
}

function getCodingPracticeItemBySlug(slug = "") {
  const items = getCodingPracticeItems();
  const decodedSlug = decodeURIComponent(String(slug || "")).trim();
  if (!decodedSlug) return null;
  return items.find((item) => item.slug === decodedSlug || item.id === decodedSlug) || null;
}

function getCodingPracticeLanguage(languageId = "") {
  return CODING_PRACTICE_LANGUAGES.find((language) => language.id === languageId) || CODING_PRACTICE_LANGUAGES[0];
}

function getCodingPracticeSavedLanguage() {
  try {
    const saved = localStorage.getItem("skillup_code_language") || "";
    const migrated = localStorage.getItem("skillup_code_default_js_v1") === "true";
    if (!migrated && saved && !canRunCodingPracticeLanguage(getCodingPracticeLanguage(saved))) {
      localStorage.setItem("skillup_code_default_js_v1", "true");
      localStorage.setItem("skillup_code_language", "javascript");
      return "javascript";
    }
    if (!saved) {
      localStorage.setItem("skillup_code_default_js_v1", "true");
    }
    return saved || "javascript";
  } catch {
    return "javascript";
  }
}

function setCodingPracticeSavedLanguage(languageId) {
  try {
    localStorage.setItem("skillup_code_language", languageId);
  } catch {
    // Local storage can be disabled in private browsing; the editor still works for the current view.
  }
}

function getCodingPracticeStorageKey(slug, languageId) {
  return `skillup_code_${slug}_${languageId}`;
}

function getCodingPracticeSavedCode(slug, languageId) {
  try {
    return localStorage.getItem(getCodingPracticeStorageKey(slug, languageId)) || "";
  } catch {
    return "";
  }
}

function setCodingPracticeSavedCode(slug, languageId, code) {
  try {
    localStorage.setItem(getCodingPracticeStorageKey(slug, languageId), code || "");
  } catch {
    // Draft persistence is optional; never block typing if storage is unavailable.
  }
}

function getCodingPracticeStarterCode(item, languageId) {
  const title = item?.title || "Coding Practice";
  const language = getCodingPracticeLanguage(languageId).id;

  if (language === "java") {
    return `import java.io.*;
import java.nio.charset.StandardCharsets;

public class Main {
    public static void main(String[] args) throws Exception {
        String input = new String(System.in.readAllBytes(), StandardCharsets.UTF_8).trim();
        System.out.print(solve(input));
    }

    static String solve(String input) {
        // ${title}
        // input is JSON text for one test case.
        return input;
    }
}`;
  }

  if (language === "python") {
    return `def solve(input):
    # ${title}
    # The browser test runner calls solve(input) for every test case.
    # input can be a number, string, list, or dict.
    return input`;
  }

  if (language === "javascript") {
    return `function solve(input) {
  // ${title}
  return input;
}

// The browser test runner calls solve(input) for every test case.`;
  }

  if (language === "dart") {
    return `import 'dart:convert';
import 'dart:io';

Future<void> main() async {
  final input = (await stdin.transform(utf8.decoder).join()).trim();
  stdout.write(solve(input));
}

String solve(String input) {
  // ${title}
  // input is JSON text for one test case.
  return input;
}`;
  }

  if (language === "swift") {
    return `import Foundation

let data = FileHandle.standardInput.readDataToEndOfFile()
let input = String(data: data, encoding: .utf8)?.trimmingCharacters(in: .whitespacesAndNewlines) ?? ""
print(solve(input), terminator: "")

func solve(_ input: String) -> String {
    // ${title}
    // input is JSON text for one test case.
    return input
}`;
  }

  if (language === "cpp") {
    return `#include <bits/stdc++.h>
using namespace std;

string solve(const string& input) {
    // ${title}
    // input is JSON text for one test case.
    return input;
}

int main() {
    ostringstream buffer;
    buffer << cin.rdbuf();
    string input = buffer.str();
    while (!input.empty() && isspace(static_cast<unsigned char>(input.back()))) input.pop_back();
    cout << solve(input);
    return 0;
}`;
  }

  return `fun solve(input: Any?): Any? {
    // ${title}
    // Free browser runner: input is one test case value.
    // It can be a number, string, list, or map/object.
    return input
}`;
}

function getCodingPracticePrompt(item) {
  if (!item) return "Choose a problem from the list and start solving.";
  if (String(item.prompt || "").trim()) return String(item.prompt).trim();
  if (String(item.description || "").trim()) return String(item.description).trim();
  if (item.kind === "dsa") {
    return `Solve ${item.title} using a clean algorithm. Start with the brute force idea if needed, then improve the time and space complexity. Explain edge cases before submitting your final answer.`;
  }
  return `Write a complete program for ${item.title}. Keep the input handling simple, split the logic into a small function, and test it with at least one normal case and one edge case.`;
}

function getCodingPracticeTestCases(item) {
  const customTestCases = normalizeCodingPracticeTestCases(item?.testCases || []);
  if (customTestCases.length) return customTestCases;
  const title = String(item?.title || "").toLowerCase();
  const make = (name, input, expected, note = "") => ({ name, input, expected, note });

  if (title.includes("two sum")) {
    return [
      make("Basic pair", { nums: [2, 7, 11, 15], target: 9 }, [0, 1], "Return indexes of the two numbers."),
      make("Middle pair", { nums: [3, 2, 4], target: 6 }, [1, 2]),
      make("Duplicate values", { nums: [3, 3], target: 6 }, [0, 1]),
      make("Negative value", { nums: [-1, -2, -3, -4, -5], target: -8 }, [2, 4]),
      make("Zero target", { nums: [0, 4, 3, 0], target: 0 }, [0, 3])
    ];
  }

  if (title.includes("contains duplicate")) {
    return [
      make("Duplicate exists", [1, 2, 3, 1], true),
      make("All unique", [1, 2, 3, 4], false),
      make("Single item", [7], false),
      make("Empty array", [], false),
      make("Multiple duplicates", [4, 4, 4, 2], true)
    ];
  }

  if (title.includes("anagram")) {
    return [
      make("Simple anagram", { s: "anagram", t: "nagaram" }, true),
      make("Different count", { s: "rat", t: "car" }, false),
      make("Empty strings", { s: "", t: "" }, true),
      make("Repeated letters", { s: "aacc", t: "ccac" }, false),
      make("Same letters", { s: "listen", t: "silent" }, true)
    ];
  }

  if (title.includes("valid parentheses") || title.includes("balanced parentheses")) {
    return [
      make("Round brackets", "()", true),
      make("Mixed valid", "()[]{}", true),
      make("Wrong order", "(]", false),
      make("Nested valid", "{[]}", true),
      make("Unclosed", "((())", false)
    ];
  }

  if (title.includes("palindrome")) {
    return [
      make("Odd length", "madam", true),
      make("Even length", "abba", true),
      make("Not palindrome", "skillup", false),
      make("Single char", "a", true),
      make("Sentence", "A man a plan a canal Panama", true)
    ];
  }

  if (title.includes("reverse a string") || title.includes("reverse string")) {
    return [
      make("Simple", "skillup", "pulliks"),
      make("Single char", "a", "a"),
      make("Empty", "", ""),
      make("With space", "hi all", "lla ih"),
      make("Numbers as text", "12345", "54321")
    ];
  }

  if (title.includes("count vowels")) {
    return [
      make("Lowercase", "education", 5),
      make("No vowels", "rhythm", 0),
      make("Mixed case", "SkillUp Class", 3),
      make("Empty", "", 0),
      make("Only vowels", "aeiouAEIOU", 10)
    ];
  }

  if (title.includes("factorial")) {
    return [
      make("Five", 5, 120),
      make("Zero", 0, 1),
      make("One", 1, 1),
      make("Three", 3, 6),
      make("Seven", 7, 5040)
    ];
  }

  if (title.includes("fibonacci")) {
    return [
      make("Six numbers", 6, [0, 1, 1, 2, 3, 5]),
      make("One number", 1, [0]),
      make("Two numbers", 2, [0, 1]),
      make("Zero numbers", 0, []),
      make("Eight numbers", 8, [0, 1, 1, 2, 3, 5, 8, 13])
    ];
  }

  if (title.includes("prime")) {
    return [
      make("Prime", 17, true),
      make("Not prime", 20, false),
      make("Two", 2, true),
      make("One", 1, false),
      make("Negative", -7, false)
    ];
  }

  if (title.includes("gcd")) {
    return [
      make("Basic", { a: 12, b: 18 }, 6),
      make("Same numbers", { a: 9, b: 9 }, 9),
      make("Coprime", { a: 17, b: 13 }, 1),
      make("One zero", { a: 0, b: 8 }, 8),
      make("Larger", { a: 48, b: 180 }, 12)
    ];
  }

  if (title.includes("binary search") || title.includes("linear search")) {
    return [
      make("Found middle", { nums: [1, 3, 5, 7], target: 5 }, 2),
      make("Found first", { nums: [2, 4, 6], target: 2 }, 0),
      make("Found last", { nums: [2, 4, 6], target: 6 }, 2),
      make("Not found", { nums: [1, 2, 3], target: 9 }, -1),
      make("Empty", { nums: [], target: 1 }, -1)
    ];
  }

  if (title.includes("largest element")) {
    return [
      make("Basic", [1, 5, 2, 9], 9),
      make("Negative values", [-5, -1, -9], -1),
      make("Single item", [8], 8),
      make("Duplicate max", [3, 7, 7, 2], 7),
      make("Zero included", [0, -1, -2], 0)
    ];
  }

  if (title.includes("second largest")) {
    return [
      make("Basic", [1, 5, 2, 9], 5),
      make("Duplicates", [4, 4, 3, 2], 3),
      make("Two items", [10, 7], 7),
      make("Negative values", [-8, -3, -1], -3),
      make("No second distinct", [2, 2, 2], null)
    ];
  }

  if (title.includes("missing number")) {
    return [
      make("Middle missing", { nums: [1, 2, 4, 5], n: 5 }, 3),
      make("First missing", { nums: [2, 3, 4], n: 4 }, 1),
      make("Last missing", { nums: [1, 2, 3], n: 4 }, 4),
      make("Single missing", { nums: [], n: 1 }, 1),
      make("Unsorted", { nums: [4, 2, 1, 5], n: 5 }, 3)
    ];
  }

  if (title.includes("maximum subarray")) {
    return [
      make("Mixed values", [-2, 1, -3, 4, -1, 2, 1, -5, 4], 6),
      make("All positive", [1, 2, 3], 6),
      make("All negative", [-3, -2, -5], -2),
      make("Single", [5], 5),
      make("Includes zero", [0, -1, 2, 3], 5)
    ];
  }

  if (title.includes("reverse an array")) {
    return [
      make("Basic", [1, 2, 3], [3, 2, 1]),
      make("Single", [7], [7]),
      make("Empty", [], []),
      make("Strings", ["a", "b"], ["b", "a"]),
      make("Mixed", [1, 0, -1], [-1, 0, 1])
    ];
  }

  if (title.includes("rotate array")) {
    return [
      make("Rotate two", { nums: [1, 2, 3, 4, 5], k: 2 }, [4, 5, 1, 2, 3]),
      make("Rotate zero", { nums: [1, 2], k: 0 }, [1, 2]),
      make("K larger", { nums: [1, 2, 3], k: 4 }, [3, 1, 2]),
      make("Single", { nums: [9], k: 3 }, [9]),
      make("Empty", { nums: [], k: 2 }, [])
    ];
  }

  if (title.includes("merge two sorted")) {
    return [
      make("Basic", { a: [1, 3], b: [2, 4] }, [1, 2, 3, 4]),
      make("Left empty", { a: [], b: [1] }, [1]),
      make("Right empty", { a: [1], b: [] }, [1]),
      make("Duplicates", { a: [1, 2], b: [2, 3] }, [1, 2, 2, 3]),
      make("Negative", { a: [-3, -1], b: [-2, 0] }, [-3, -2, -1, 0])
    ];
  }

  return [
    make("Sample text", "sample", "sample"),
    make("Empty text", "", ""),
    make("Single item", [1], [1]),
    make("Small list", [1, 2, 3], [1, 2, 3]),
    make("Object input", { value: "skillup" }, { value: "skillup" })
  ];
}

function formatCodingPracticeValue(value) {
  if (typeof value === "string") return `"${value}"`;
  if (value === undefined) return "undefined";
  return JSON.stringify(value, null, 2);
}

function normalizeCodingPracticeComparable(value) {
  if (Array.isArray(value)) return value.map(normalizeCodingPracticeComparable);
  if (value && typeof value === "object") {
    return Object.keys(value).sort().reduce((acc, key) => {
      acc[key] = normalizeCodingPracticeComparable(value[key]);
      return acc;
    }, {});
  }
  return value;
}

function isCodingPracticeEqual(actual, expected) {
  return JSON.stringify(normalizeCodingPracticeComparable(actual)) === JSON.stringify(normalizeCodingPracticeComparable(expected));
}

function highlightCodingPracticeCode(code = "", languageId = "javascript") {
  const keywords = {
    javascript: "break|case|catch|class|const|continue|default|else|export|for|function|if|import|let|new|null|return|switch|throw|try|typeof|undefined|var|while|true|false",
    kotlin: "as|break|class|continue|data|do|else|false|for|fun|if|in|interface|is|null|object|return|true|val|var|when|while",
    java: "boolean|break|case|catch|class|continue|double|else|false|final|for|if|import|int|new|null|private|public|return|static|String|true|void|while",
    python: "and|as|break|class|continue|def|elif|else|False|for|from|if|import|in|is|lambda|None|not|or|return|True|try|while",
    dart: "bool|break|case|catch|class|const|continue|else|false|final|for|if|import|int|null|return|String|true|var|void|while",
    swift: "class|else|false|for|func|if|import|in|let|nil|return|struct|true|var|while",
    cpp: "auto|bool|break|case|catch|class|const|continue|else|false|for|if|include|int|long|namespace|nullptr|return|string|true|using|void|while"
  };

  const tokens = [];
  const stash = (html) => `@@CODETOKEN${tokens.push(html) - 1}@@`;
  let html = escapeHtml(code);
  html = html.replace(/(&quot;.*?&quot;|&#039;.*?&#039;)/g, (match) => stash(`<span class="token-string">${match}</span>`));
  html = html.replace(/(\/\/.*?$|#.*?$)/gm, (match) => stash(`<span class="token-comment">${match}</span>`));
  html = html.replace(/\b(\d+(?:\.\d+)?)\b/g, '<span class="token-number">$1</span>');
  const keywordPattern = keywords[languageId] || keywords.javascript;
  html = html.replace(new RegExp(`\\b(${keywordPattern})\\b`, "g"), '<span class="token-keyword">$1</span>');
  html = html.replace(/@@CODETOKEN(\d+)@@/g, (_, index) => tokens[Number(index)] || "");
  return html || " ";
}

function parseCodingPracticeOutput(stdout, expected) {
  const text = String(stdout ?? "").trim();
  if (typeof expected === "string") {
    if (text === expected) return text;
    try {
      const parsed = JSON.parse(text);
      return typeof parsed === "string" ? parsed : text;
    } catch {
      return text;
    }
  }
  if (typeof expected === "number") {
    const numberValue = Number(text);
    return Number.isNaN(numberValue) ? text : numberValue;
  }
  if (typeof expected === "boolean") {
    if (/^true$/i.test(text)) return true;
    if (/^false$/i.test(text)) return false;
  }
  if (text === "null") return null;
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}
function escapeRegExp(value = "") {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function stripKotlinParameterTypes(params = "") {
  return splitTopLevelKotlinArguments(params)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => part
      .replace(/^(val|var)\s+/, "")
      .replace(/\s*:\s*[^=]+(?==|$)/, "")
      .replace(/\s*=\s*.+$/, "")
      .trim())
    .filter(Boolean)
    .join(", ");
}

function splitTopLevelKotlinArguments(value = "") {
  const parts = [];
  let depth = 0;
  let quote = "";
  let start = 0;
  for (let index = 0; index < value.length; index += 1) {
    const char = value[index];
    const prev = value[index - 1];
    if (quote) {
      if (char === quote && prev !== "\\") quote = "";
      continue;
    }
    if (char === "\"" || char === "'" || char === "`") {
      quote = char;
      continue;
    }
    if ("([{<".includes(char)) depth += 1;
    if (")]}>".includes(char)) depth = Math.max(0, depth - 1);
    if (char === "," && depth === 0) {
      parts.push(value.slice(start, index).trim());
      start = index + 1;
    }
  }
  const last = value.slice(start).trim();
  if (last) parts.push(last);
  return parts;
}

function compileKotlinMapEntries(args = "") {
  const entries = splitTopLevelKotlinArguments(args)
    .map((entry) => {
      const match = entry.match(/^([\s\S]+?)\s+to\s+([\s\S]+)$/);
      return match ? `[${match[1].trim()}, ${match[2].trim()}]` : entry;
    })
    .filter(Boolean);
  return entries.length ? `new Map([${entries.join(", ")}])` : "new Map()";
}

function rewriteKotlinMapAccess(source = "", name = "") {
  const token = `${name}[`;
  let output = "";
  let index = 0;

  while (index < source.length) {
    const start = source.indexOf(token, index);
    if (start < 0) {
      output += source.slice(index);
      break;
    }

    output += source.slice(index, start);
    let cursor = start + token.length;
    let depth = 0;
    let quote = "";
    let close = -1;

    for (; cursor < source.length; cursor += 1) {
      const char = source[cursor];
      const prev = source[cursor - 1];
      if (quote) {
        if (char === quote && prev !== "\\") quote = "";
        continue;
      }
      if (char === "\"" || char === "'" || char === "`") {
        quote = char;
        continue;
      }
      if (char === "[") {
        depth += 1;
        continue;
      }
      if (char === "]") {
        if (depth === 0) {
          close = cursor;
          break;
        }
        depth -= 1;
      }
    }

    if (close < 0) {
      output += source.slice(start);
      break;
    }

    const key = source.slice(start + token.length, close).trim();
    let after = close + 1;
    while (source[after] === " " || source[after] === "\t") after += 1;
    if (source.slice(after, after + 2) === "!!") after += 2;

    if (source.slice(after, after + 2) === "?:") {
      const expressionStart = after + 2;
      let expressionEnd = expressionStart;
      while (expressionEnd < source.length && !"\n;".includes(source[expressionEnd])) expressionEnd += 1;
      output += `(${name}.get(${key}) ?? ${source.slice(expressionStart, expressionEnd).trim()})`;
      index = expressionEnd;
      continue;
    }

    if (source[after] === "=" && source[after + 1] !== "=") {
      const expressionStart = after + 1;
      let expressionEnd = expressionStart;
      while (expressionEnd < source.length && !"\n;".includes(source[expressionEnd])) expressionEnd += 1;
      output += `${name}.set(${key}, ${source.slice(expressionStart, expressionEnd).trim()})`;
      index = expressionEnd;
      continue;
    }

    output += `${name}.get(${key})`;
    index = close + 1;
  }

  const escaped = escapeRegExp(name);
  const containsKeyPattern = new RegExp(escaped + "\\.containsKey\\(([^)]+)\\)", "g");
  const containsValuePattern = new RegExp(escaped + "\\.containsValue\\(([^)]+)\\)", "g");
  const getOrDefaultPattern = new RegExp(escaped + "\\.getOrDefault\\(([^,]+),\\s*([^)]+)\\)", "g");
  const putPattern = new RegExp(escaped + "\\.put\\(([^,]+),\\s*([^)]+)\\)", "g");
  const keysPattern = new RegExp(escaped + "\\.keys\\b", "g");
  const valuesPattern = new RegExp(escaped + "\\.values\\b", "g");
  return output
    .replace(containsKeyPattern, name + ".has($1)")
    .replace(containsValuePattern, "kotlinToList(" + name + ".values()).includes($1)")
    .replace(getOrDefaultPattern, "(" + name + ".has($1) ? " + name + ".get($1) : $2)")
    .replace(putPattern, name + ".set($1, $2)")
    .replace(keysPattern, "Array.from(" + name + ".keys())")
    .replace(valuesPattern, "Array.from(" + name + ".values())");
}
function normalizeKotlinLambdaBody(body = "", paramName = "it") {
  const param = paramName || "it";
  const paramPattern = escapeRegExp(param);
  let output = String(body || "").trim().replace(/[;,]$/, "");
  output = output
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\s+!in\\s+([^?:&|,)]+)", "g"), "!kotlinContains($2, $1)")
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\s+in\\s+([^?:&|,)]+)", "g"), "kotlinContains($2, $1)")
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\.digitToInt\\(\\)", "g"), "kotlinDigitToInt($1)")
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\.isDigit\\(\\)", "g"), "kotlinIsDigit($1)")
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\.isLetterOrDigit\\(\\)", "g"), "kotlinIsLetterOrDigit($1)")
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\.isLetter\\(\\)", "g"), "kotlinIsLetter($1)")
    .replace(new RegExp("\\b(" + paramPattern + "|it)\\.isWhitespace\\(\\)", "g"), "kotlinIsWhitespace($1)")
    .replace(/\.lowercase\(\)|\.lowercaseChar\(\)/g, ".toLowerCase()")
    .replace(/\.uppercase\(\)|\.uppercaseChar\(\)/g, ".toUpperCase()");
  return output || "undefined";
}

function rewriteKotlinCollectionLambdas(source = "", receiverPattern = "") {
  const rules = [
    ["filter", "kotlinFilter"],
    ["map", "kotlinMap"],
    ["flatMap", "kotlinFlatMap"],
    ["forEach", "kotlinForEach"],
    ["any", "kotlinAny"],
    ["all", "kotlinAll"],
    ["none", "kotlinNone"],
    ["count", "kotlinCount"],
    ["firstOrNull", "kotlinFirstOrNull"],
    ["find", "kotlinFirstOrNull"]
  ];

  return rules.reduce((output, rule) => {
    const method = rule[0];
    const helper = rule[1];
    const pattern = new RegExp(receiverPattern + "\\." + method + "\\s*\\{\\s*(?:([A-Za-z_$][\\w$]*)\\s*->\\s*)?([\\s\\S]*?)\\}", "g");
    return output.replace(pattern, (_, receiver, paramName, body) => {
      const param = paramName || "it";
      return helper + "(" + receiver + ", (" + param + ") => " + normalizeKotlinLambdaBody(body, param) + ")";
    });
  }, source);
}

function rewriteKotlinIfExpressions(source = "") {
  const condition = "((?:[^)(]+|\\([^)(]*\\))*)";
  return String(source || "")
    .replace(new RegExp("\\breturn\\s+if\\s*\\(" + condition + "\\)\\s*([^{}\\n;]+?)\\s+else\\s+([^{}\\n;]+)", "g"), (_, test, yes, no) => "return ((" + test.trim() + ") ? " + yes.trim() + " : " + no.trim() + ")")
    .replace(new RegExp("=\\s*if\\s*\\(" + condition + "\\)\\s*([^{}\\n;]+?)\\s+else\\s+([^{}\\n;]+)", "g"), (_, test, yes, no) => "= ((" + test.trim() + ") ? " + yes.trim() + " : " + no.trim() + ")");
}

function rewriteKotlinExpressionBodyFunctions(source = "") {
  return String(source || "").replace(/\bfun\s+([A-Za-z_$][\w$]*)\s*\(([^)]*)\)\s*(?::\s*[^=\n]+)?\s*=\s*([^\n]+)/g, (_, name, params, expression) => {
    return "function " + name + "(" + stripKotlinParameterTypes(params) + ") { return " + String(expression || "").trim().replace(/[;,]$/, "") + "; }";
  });
}

function rewriteKotlinRepeatBlocks(source = "") {
  return String(source || "")
    .replace(/\brepeat\s*\(([^)]+)\)\s*\{\s*([A-Za-z_$][\w$]*)\s*->/g, "for (let $2 = 0; $2 < $1; $2++) {")
    .replace(/\brepeat\s*\(([^)]+)\)\s*\{/g, "for (let __skillupRepeatIndex = 0; __skillupRepeatIndex < $1; __skillupRepeatIndex++) {");
}

function rewriteKotlinArrayConstructors(source = "") {
  let output = String(source || "");
  output = output.replace(/\b(?:IntArray|LongArray|DoubleArray|BooleanArray|CharArray|Array|List|MutableList)\s*(?:<[^>]+>)?\s*\(([^)]*)\)\s*\{\s*(?:([A-Za-z_$][\w$]*)\s*->\s*)?([^{}]+)\}/g, (_, size, paramName, expression) => {
    const param = paramName || "it";
    return "Array.from({ length: Number(" + size.trim() + ") }, (_, " + param + ") => " + normalizeKotlinLambdaBody(expression, param) + ")";
  });
  return output
    .replace(/\b(?:IntArray|LongArray)\s*\(([^)]*)\)/g, "Array(Number($1)).fill(0)")
    .replace(/\bDoubleArray\s*\(([^)]*)\)/g, "Array(Number($1)).fill(0)")
    .replace(/\bBooleanArray\s*\(([^)]*)\)/g, "Array(Number($1)).fill(false)")
    .replace(/\bCharArray\s*\(([^)]*)\)/g, "Array(Number($1)).fill(\"\\u0000\")");
}

function rewriteKotlinWhenReturnExpressions(source = "") {
  return String(source || "").replace(/return\s+when\s*(?:\(([^)]*)\))?\s*\{([\s\S]*?)\n\s*\}/g, (_, subject, body) => {
    const branches = String(body || "").split("\n").map((line) => line.trim().replace(/,$/, "")).filter(Boolean);
    const statements = branches.map((branch) => {
      const match = branch.match(/^(.+?)\s*->\s*(.+)$/);
      if (!match) return "";
      const condition = match[1].trim();
      const value = match[2].trim();
      if (condition === "else") return "return " + value + ";";
      if (!subject) return "if (" + condition + ") return " + value + ";";
      const checks = splitTopLevelKotlinArguments(condition).map((part) => {
        const token = part.trim();
        if (/^in\s+/.test(token)) return "kotlinContains(" + token.replace(/^in\s+/, "") + ", " + subject.trim() + ")";
        return subject.trim() + " === " + token;
      }).join(" || ");
      return "if (" + checks + ") return " + value + ";";
    }).filter(Boolean);
    return "return (() => { " + statements.join(" ") + " return undefined; })()";
  });
}

function createCodingPracticeCompilerError(message, line = 0, column = 0) {
  const error = new Error(message);
  error.line = Number(line) || 0;
  error.column = Number(column) || 0;
  return error;
}

function getCodeLineColumnFromIndex(code = "", index = 0) {
  const before = String(code || "").slice(0, Math.max(0, Number(index) || 0));
  const lines = before.replace(/\r\n/g, "\n").split("\n");
  return {
    line: lines.length,
    column: lines[lines.length - 1].length + 1
  };
}

function stripCodeStringsAndComments(code = "") {
  return String(code || "")
    .replace(/\/\*[\s\S]*?\*\//g, (match) => " ".repeat(match.length))
    .replace(/\/\/.*$/gm, (match) => " ".repeat(match.length))
    .replace(/"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`/g, (match) => " ".repeat(match.length));
}

function getKotlinLiteralType(expression = "") {
  const value = String(expression || "").trim().replace(/[,;]$/, "");
  if (!value) return "unknown";
  const safeCast = value.match(/\bas\?\s*([A-Za-z_$][\w$]*)/);
  if (safeCast) return `${safeCast[1]}?`;
  const hardCast = value.match(/\bas\s*([A-Za-z_$][\w$]*)/);
  if (hardCast) return hardCast[1];
  if (/^null\b/.test(value)) return "Null";
  if (/^(true|false)\b/.test(value)) return "Boolean";
  if (/^["'`]/.test(value)) return "String";
  if (/^-?\d+$/.test(value)) return "Int";
  if (/^-?\d+\.\d+f?$/i.test(value)) return "Double";
  if (/^(listOf|mutableListOf|arrayListOf|arrayOf|intArrayOf|emptyList|emptyArray)\b/.test(value)) return "List";
  if (/^(setOf|mutableSetOf|hashSetOf|emptySet)\b/.test(value)) return "Set";
  if (/^(mapOf|mutableMapOf|hashMapOf|emptyMap)\b/.test(value)) return "Map";
  return "unknown";
}

function isKotlinTypeCompatible(declaredType = "", actualType = "unknown") {
  const type = String(declaredType || "").replace(/\s+/g, "");
  const nullable = type.endsWith("?");
  const base = type.replace(/[?]/g, "").replace(/<.*$/, "");
  if (actualType === "unknown") return true;
  if (actualType === "Null") return nullable || base === "Any";
  if (base === "Any") return true;
  if (["Number"].includes(base)) return ["Int", "Long", "Double", "Float"].includes(actualType);
  if (["Int", "Long"].includes(base)) return actualType === "Int";
  if (["Double", "Float"].includes(base)) return ["Int", "Double"].includes(actualType);
  if (base === "String") return actualType === "String";
  if (base === "Boolean") return actualType === "Boolean";
  if (["List", "MutableList", "Array", "IntArray"].includes(base)) return actualType === "List";
  if (["Set", "MutableSet"].includes(base)) return actualType === "Set";
  if (["Map", "MutableMap"].includes(base)) return actualType === "Map";
  return true;
}

function validateKotlinDeclaredTypes(code = "") {
  const lines = String(code || "").replace(/\r\n/g, "\n").split("\n");
  const valNames = new Map();
  const declarationPattern = /\b(val|var)\s+([A-Za-z_$][\w$]*)\s*:\s*([^=\n]+?)\s*=\s*(.+)$/;

  lines.forEach((line, index) => {
    const declaration = line.match(declarationPattern);
    if (declaration) {
      const [, kind, name, declaredType, expression] = declaration;
      if (kind === "val") valNames.set(name, index + 1);
      const actualType = getKotlinLiteralType(expression);
      if (!isKotlinTypeCompatible(declaredType, actualType)) {
        throw createCodingPracticeCompilerError(
          `Type mismatch: declared ${declaredType.trim()} but assigned ${actualType}.`,
          index + 1,
          Math.max(1, line.indexOf(expression.trim()) + 1)
        );
      }
      return;
    }

    const valDeclaration = line.match(/\bval\s+([A-Za-z_$][\w$]*)\b/);
    if (valDeclaration) valNames.set(valDeclaration[1], index + 1);
  });

  lines.forEach((line, index) => {
    for (const [name] of valNames) {
      const assignment = new RegExp(`(^|[^.\\w$])${escapeRegExp(name)}\\s*=(?!=)`).exec(line);
      if (assignment && !new RegExp(`\\bval\\s+${escapeRegExp(name)}\\b`).test(line)) {
        throw createCodingPracticeCompilerError(
          `Val cannot be reassigned: ${name}. Use var if this value must change.`,
          index + 1,
          assignment.index + assignment[1].length + 1
        );
      }
    }
  });

  const solveReturnType = String(code || "").match(/\bfun\s+solve\s*\([^)]*\)\s*:\s*([^\s{]+)[\s\S]*?\{/);
  if (solveReturnType) {
    const declaredType = solveReturnType[1];
    lines.forEach((line, index) => {
      const returned = line.match(/\breturn\s+(.+)$/);
      if (!returned) return;
      const actualType = getKotlinLiteralType(returned[1]);
      if (!isKotlinTypeCompatible(declaredType, actualType)) {
        throw createCodingPracticeCompilerError(
          `Return type mismatch: solve returns ${declaredType.trim()} but this line returns ${actualType}.`,
          index + 1,
          Math.max(1, line.indexOf(returned[1].trim()) + 1)
        );
      }
    });
  }
}

function validateKotlinNullSafetySyntax(code = "") {
  const stripped = stripCodeStringsAndComments(code);
  const safeCall = /\?\.\s*(?=$|[\n;})\]])/g;
  let match = safeCall.exec(stripped);
  if (match) {
    const loc = getCodeLineColumnFromIndex(code, match.index + 1);
    throw createCodingPracticeCompilerError("Incomplete null-safe call after ?. Add a property or function name, for example value?.length.", loc.line, loc.column);
  }

  const elvis = /\?:\s*(?=$|[\n;})\]])/g;
  match = elvis.exec(stripped);
  if (match) {
    const loc = getCodeLineColumnFromIndex(code, match.index + 1);
    throw createCodingPracticeCompilerError("Incomplete Elvis operator. Add a fallback value after ?:, for example name ?: \"Guest\".", loc.line, loc.column);
  }

  const safeLet = /\?\.let\s*\{/g.exec(stripped);
  if (safeLet) {
    const loc = getCodeLineColumnFromIndex(code, safeLet.index + 1);
    throw createCodingPracticeCompilerError("?.let { } is not supported in the free browser runner yet. Use an if check or the Elvis operator instead.", loc.line, loc.column);
  }
}

function validateKotlinDelimiters(code = "") {
  const stripped = stripCodeStringsAndComments(code);
  const stack = [];
  const pairs = { "(": ")", "[": "]", "{": "}" };
  const closers = new Set(Object.values(pairs));

  for (let index = 0; index < stripped.length; index += 1) {
    const char = stripped[index];
    if (pairs[char]) {
      const loc = getCodeLineColumnFromIndex(code, index);
      stack.push({ char, line: loc.line, column: loc.column });
      continue;
    }
    if (closers.has(char)) {
      const current = stack.pop();
      if (!current || pairs[current.char] !== char) {
        const loc = getCodeLineColumnFromIndex(code, index);
        throw createCodingPracticeCompilerError(`Unexpected '${char}'. Check your brackets or braces.`, loc.line, loc.column);
      }
    }
  }

  if (stack.length) {
    const current = stack[stack.length - 1];
    throw createCodingPracticeCompilerError(`Missing '${pairs[current.char]}' for '${current.char}'.`, current.line, current.column);
  }
}

const KOTLIN_RESERVED_WORDS = new Set([
  "as", "break", "class", "continue", "do", "else", "false", "for", "fun", "if", "in", "interface", "is", "null", "object", "package", "return", "super", "this", "throw", "true", "try", "typealias", "typeof", "val", "var", "when", "while", "by", "catch", "constructor", "delegate", "dynamic", "field", "file", "finally", "get", "import", "init", "param", "property", "receiver", "set", "setparam", "where", "actual", "abstract", "annotation", "companion", "const", "crossinline", "data", "enum", "expect", "external", "final", "infix", "inline", "inner", "internal", "lateinit", "noinline", "open", "operator", "out", "override", "private", "protected", "public", "reified", "sealed", "suspend", "tailrec", "vararg"
]);

const KOTLIN_SUPPORTED_TYPES = new Set([
  "Any", "Any?", "Unit", "Nothing", "String", "String?", "Char", "Char?", "Boolean", "Boolean?", "Int", "Int?", "Long", "Long?", "Short", "Byte", "Float", "Double", "Number", "List", "MutableList", "Set", "MutableSet", "Map", "MutableMap", "Array", "IntArray", "BooleanArray", "CharArray", "DoubleArray"
]);

const KOTLIN_BUILTIN_FUNCTIONS = new Set([
  "print", "println", "listOf", "mutableListOf", "arrayListOf", "arrayOf", "intArrayOf", "charArrayOf", "booleanArrayOf", "doubleArrayOf", "longArrayOf", "emptyList", "emptyArray", "List", "MutableList", "Array", "IntArray", "BooleanArray", "CharArray", "DoubleArray", "LongArray", "setOf", "mutableSetOf", "hashSetOf", "linkedSetOf", "emptySet", "mapOf", "mutableMapOf", "hashMapOf", "linkedMapOf", "emptyMap", "maxOf", "minOf", "abs", "ceil", "floor", "sqrt", "StringBuilder", "require", "requireNotNull", "check", "error", "TODO", "repeat", "kotlinSize", "kotlinContains", "kotlinReversed", "kotlinToList", "kotlinToSet", "kotlinCount", "kotlinAny", "kotlinAll", "kotlinNone", "kotlinSum", "kotlinMaxOrNull", "kotlinMinOrNull", "kotlinFilter", "kotlinMap", "kotlinFlatMap", "kotlinForEach", "kotlinDistinct", "kotlinSorted", "kotlinSortedDescending", "kotlinFirstOrNull", "kotlinLastOrNull", "kotlinSetAdd", "kotlinRemoveAt", "kotlinDigitToInt", "kotlinIsDigit", "kotlinIsLetter", "kotlinIsLetterOrDigit", "kotlinIsWhitespace"
]);

function normalizeKotlinType(type = "") {
  return String(type || "").trim().replace(/\s+/g, "").replace(/<.*$/, "");
}

function isKotlinKnownType(type = "") {
  const compact = String(type || "").trim().replace(/\s+/g, "");
  const base = normalizeKotlinType(compact).replace(/[?]/g, "");
  return KOTLIN_SUPPORTED_TYPES.has(compact) || KOTLIN_SUPPORTED_TYPES.has(`${base}${compact.endsWith("?") ? "?" : ""}`) || KOTLIN_SUPPORTED_TYPES.has(base);
}

function throwKotlinCompilerError(message, code = "", index = 0) {
  const loc = getCodeLineColumnFromIndex(code, index);
  throw createCodingPracticeCompilerError(message, loc.line, loc.column);
}

function throwKotlinLineError(message, lineNumber = 1, column = 1) {
  throw createCodingPracticeCompilerError(message, lineNumber, column);
}

function removeKotlinLineComment(line = "") {
  let quote = "";
  for (let index = 0; index < line.length - 1; index += 1) {
    const char = line[index];
    const prev = line[index - 1];
    if (quote) {
      if (char === quote && prev !== "\\") quote = "";
      continue;
    }
    if (char === "\"" || char === "'" || char === "`") {
      quote = char;
      continue;
    }
    if (char === "/" && line[index + 1] === "/") return line.slice(0, index);
  }
  return line;
}

function splitKotlinStatements(code = "") {
  const rawLines = String(code || "").replace(/\r\n/g, "\n").split(/\n|;/);
  const cleanLines = stripCodeStringsAndComments(code).replace(/\r\n/g, "\n").split(/\n|;/);
  return rawLines.map((line, index) => {
    const commentlessText = removeKotlinLineComment(line);
    const cleanText = cleanLines[index] || "";
    return {
      text: line,
      line: index + 1,
      trimmed: line.trim(),
      commentlessText,
      commentlessTrimmed: commentlessText.trim(),
      cleanText,
      cleanTrimmed: cleanText.trim()
    };
  });
}

function parseKotlinParameters(params = "") {
  return splitTopLevelKotlinArguments(params)
    .filter(Boolean)
    .map((param) => {
      const cleaned = param.trim().replace(/^(val|var)\s+/, "");
      const match = cleaned.match(/^([A-Za-z_$][\w$]*)(?:\s*:\s*([^=]+?))?(?:\s*=\s*(.+))?$/);
      return match ? { name: match[1], type: (match[2] || "Any?").trim(), raw: param } : { name: "", type: "", raw: param };
    });
}

function getKotlinFunctionDeclarations(code = "") {
  const functions = [];
  const pattern = /\bfun\s+([A-Za-z_$][\w$]*)\s*\(([^)]*)\)\s*(?::\s*([^={\n]+))?/g;
  let match;
  while ((match = pattern.exec(code))) {
    const loc = getCodeLineColumnFromIndex(code, match.index);
    const params = parseKotlinParameters(match[2] || "");
    functions.push({ name: match[1], params, returnType: (match[3] || "Unit").trim(), index: match.index, line: loc.line, column: loc.column });
  }
  return functions;
}

function getKotlinFunctionForLine(functions = [], lineNumber = 1) {
  const line = Number(lineNumber) || 1;
  return [...functions]
    .filter((fn) => Number(fn.line) <= line)
    .sort((a, b) => Number(b.line) - Number(a.line) || Number(b.index) - Number(a.index))[0] || null;
}

function inferKotlinExpressionType(expression = "", symbols = new Map()) {
  const value = String(expression || "").trim().replace(/[;,]$/, "");
  if (!value) return "unknown";
  const safeCast = value.match(/\bas\?\s*([A-Za-z_$][\w$]*)/);
  if (safeCast) return `${safeCast[1]}?`;
  const hardCast = value.match(/\bas\s*([A-Za-z_$][\w$]*)/);
  if (hardCast) return hardCast[1];
  const literal = getKotlinLiteralType(value);
  if (literal !== "unknown") return literal;
  if (/^'.'$/.test(value) || /^'\\[btnr'"\\]'.$/.test(value)) return "Char";
  if (/^\w+\?\./.test(value)) return "unknown";
  if (/^\w+!!/.test(value)) return symbols.get(value.replace(/!!.*/, ""))?.replace("?", "") || "unknown";
  if (/^[A-Za-z_$][\w$]*$/.test(value)) return symbols.get(value) || "unknown";
  if (/\.length\b|\.size\b|\.lastIndex\b/.test(value)) return "Int";
  if (/\.toString\(\)|\.joinToString\(|StringBuilder\(/.test(value)) return "String";
  if (/^(maxOf|minOf)\s*\(/.test(value)) return "Int";
  if (/\b(true|false)\b/.test(value) && /(&&|\|\|)/.test(value)) return "Boolean";
  if (/[+\-*/%]/.test(value)) {
    if (/"[^"\n]*"\s*[-*/%]|[-*/%]\s*"[^"\n]*"/.test(value)) return "invalid-string-op";
    if (/\b(true|false)\b\s*[+\-*/%]|[+\-*/%]\s*\b(true|false)\b/.test(value)) return "invalid-boolean-op";
    if (/\d+\.\d+/.test(value)) return "Double";
    return "Int";
  }
  if (/(==|!=|>=|<=|>|<)/.test(value)) return "Boolean";
  return "unknown";
}

function validateKotlinSecurityLimits(code = "") {
  if (String(code || "").length > 50000) throw createCodingPracticeCompilerError("Source-size limit exceeded. Keep practice solutions under 50 KB.", 1, 1);
  const tokenCount = (String(code || "").match(/[A-Za-z_$][\w$]*|\d+(?:\.\d+)?|\S/g) || []).length;
  if (tokenCount > 10000) throw createCodingPracticeCompilerError("Token limit exceeded. Simplify the source before running it.", 1, 1);
  const stripped = stripCodeStringsAndComments(code);
  let depth = 0;
  let maxDepth = 0;
  for (let index = 0; index < stripped.length; index += 1) {
    if ("({[".includes(stripped[index])) {
      depth += 1;
      maxDepth = Math.max(maxDepth, depth);
    } else if (")}]".includes(stripped[index])) {
      depth = Math.max(0, depth - 1);
    }
    if (maxDepth > 80) throwKotlinCompilerError("Nesting limit exceeded. Reduce deeply nested blocks or parentheses.", code, index);
  }
}

function validateKotlinLexicalChecks(code = "") {
  let state = "normal";
  let quoteStart = 0;
  let charContent = "";
  const validEscapes = new Set(["b", "t", "n", "r", "\"", "'", "\\", "$", "u"]);

  for (let index = 0; index < code.length; index += 1) {
    const char = code[index];
    const next = code[index + 1];

    if (state === "line") {
      if (char === "\n") state = "normal";
      continue;
    }
    if (state === "block") {
      if (char === "*" && next === "/") {
        state = "normal";
        index += 1;
      }
      continue;
    }
    if (state === "string") {
      if (char === "\\") {
        if (!validEscapes.has(next || "")) throwKotlinCompilerError("Invalid escape sequence.", code, index);
        index += next === "u" ? 4 : 1;
        continue;
      }
      if (char === "\n") throwKotlinCompilerError("Unterminated string literal.", code, quoteStart);
      if (char === "\"") state = "normal";
      continue;
    }
    if (state === "char") {
      if (char === "\\") {
        if (!validEscapes.has(next || "")) throwKotlinCompilerError("Invalid escape sequence.", code, index);
        charContent += `\\${next || ""}`;
        index += next === "u" ? 4 : 1;
        continue;
      }
      if (char === "\n") throwKotlinCompilerError("Unterminated character literal.", code, quoteStart);
      if (char === "'") {
        const logicalLength = charContent.startsWith("\\") ? 1 : [...charContent].length;
        if (logicalLength !== 1) throwKotlinCompilerError("Character literal must contain one character.", code, quoteStart);
        state = "normal";
        charContent = "";
        continue;
      }
      charContent += char;
      continue;
    }

    if (char === "/" && next === "/") {
      state = "line";
      index += 1;
      continue;
    }
    if (char === "/" && next === "*") {
      state = "block";
      quoteStart = index;
      index += 1;
      continue;
    }
    if (char === "\"") {
      state = "string";
      quoteStart = index;
      continue;
    }
    if (char === "'") {
      state = "char";
      quoteStart = index;
      charContent = "";
      continue;
    }
    if (char === "@") throwKotlinCompilerError("Invalid character `@`. Annotations are not supported in the free practice compiler.", code, index);
  }

  if (state === "string") throwKotlinCompilerError("Unterminated string literal.", code, quoteStart);
  if (state === "char") throwKotlinCompilerError("Unterminated character literal.", code, quoteStart);
  if (state === "block") throwKotlinCompilerError("Unterminated block comment.", code, quoteStart);

  const stripped = stripCodeStringsAndComments(code);
  let match = stripped.match(/\b\d+\.\d+\.\d+\b/);
  if (match) throwKotlinCompilerError("Invalid numeric literal.", code, match.index || 0);
  match = stripped.match(/\b(val|var|fun)\s+\d+[A-Za-z_$][\w$]*/);
  if (match) throwKotlinCompilerError("Identifier cannot start with a digit.", code, (match.index || 0) + match[0].indexOf(match[0].match(/\d/)[0]));
  match = stripped.match(/\b(val|var)\s+([A-Za-z_$][\w$]*)/);
  if (match && KOTLIN_RESERVED_WORDS.has(match[2])) throwKotlinCompilerError("Keyword cannot be used as an identifier.", code, (match.index || 0) + match[0].lastIndexOf(match[2]));
}

function validateKotlinSyntaxChecklist(code = "") {
  const statements = splitKotlinStatements(code);
  const stripped = stripCodeStringsAndComments(code);

  const invalidDeclaration = String(code || "").match(/\b(val|var)\s+[A-Za-z_$][\w$]*(?:\s*:\s*[^=;{}]+)?\s*=\s*(?=[;{}\n])/);
  if (invalidDeclaration) throwKotlinCompilerError("Expected expression after `=`.", code, invalidDeclaration.index || 0);

  const invalidIf = stripped.match(/\bif\s*\(\s*(\d+|"[^"]*")\s*\)/);
  if (invalidIf) throwKotlinCompilerError("Condition must be Boolean.", code, invalidIf.index || 0);

  const invalidWhile = stripped.match(/\bwhile\s*\(\s*(\d+|"[^"]*")\s*\)/);
  if (invalidWhile) throwKotlinCompilerError("Boolean condition required.", code, invalidWhile.index || 0);

  for (const { text, trimmed, commentlessTrimmed, cleanTrimmed, line } of statements) {
    if (!cleanTrimmed) continue;
    if (/^(val|var)\s*=/.test(trimmed)) throwKotlinLineError("Expected variable name.", line, Math.max(1, text.indexOf("=") + 1));
    if (/^(val|var)\s+[A-Za-z_$][\w$]*\s+[A-Za-z_$][\w$]*\s*=/.test(trimmed)) throwKotlinLineError("Expected `:` before the variable type.", line, 1);
    if (/^(val|var)\s+[A-Za-z_$][\w$]*\s*$/.test(trimmed)) throwKotlinLineError("Variable needs a type or initializer.", line, 1);
    if (/^(val|var)\s+[A-Za-z_$][\w$]*(?:\s*:\s*[^=]+)?\s*=\s*$/.test(trimmed)) throwKotlinLineError("Expected expression after `=`.", line, Math.max(1, text.lastIndexOf("=") + 2));
    if (/^const\s+val\s+[A-Za-z_$][\w$]*\s*=\s*[A-Za-z_$][\w$]*\s*\(/.test(commentlessTrimmed)) throwKotlinLineError("Compile-time constant required.", line, 1);
    if (/^fun\s*\(/.test(trimmed)) throwKotlinLineError("Expected function name.", line, Math.max(1, text.indexOf("fun") + 5));
    if (/^fun\s+[A-Za-z_$][\w$]*\s*\([^)]*$/.test(trimmed)) throwKotlinLineError("Expected `)` in function declaration.", line, text.length);
    if (/^fun\s+[A-Za-z_$][\w$]*\s*\([^)]*\)\s*(?::\s*[^={]+)?\s*$/.test(trimmed)) throwKotlinLineError("Expected function body.", line, text.length);
    if (/^fun\s+[A-Za-z_$][\w$]*\s*\(([^)]*)\)/.test(trimmed)) {
      const params = trimmed.match(/^fun\s+[A-Za-z_$][\w$]*\s*\(([^)]*)\)/)?.[1] || "";
      splitTopLevelKotlinArguments(params).forEach((param) => {
        if (/^[A-Za-z_$][\w$]*\s+[A-Za-z_$][\w$]*/.test(param.trim())) throwKotlinLineError("Expected `:` in parameter declaration.", line, Math.max(1, text.indexOf(param.trim()) + 1));
      });
    }
    if (/=\s*[+\-*/%]\s*$/.test(trimmed)) throwKotlinLineError("Expected operand.", line, Math.max(1, text.length));
    if (/[+\-*/%]\s*[+*/%]/.test(cleanTrimmed)) throwKotlinLineError("Unexpected operator sequence.", line, Math.max(1, text.search(/[+\-*/%]\s*[+*/%]/) + 1));
    if (/\d+\s+\d+/.test(trimmed)) throwKotlinLineError("Unexpected token.", line, Math.max(1, text.search(/\d+\s+\d+/) + 1));
    if (/^\(.+\)\s*=/.test(trimmed)) throwKotlinLineError("Expression is not assignable.", line, 1);
    if (/^return\b/.test(trimmed) && !/\bfun\b/.test(stripped)) {
      throwKotlinLineError("`return` is not allowed here.", line, Math.max(1, text.indexOf("return") + 1));
    }
  }
}

function collectKotlinSemanticInfo(code = "") {
  const lines = splitKotlinStatements(code);
  const functions = getKotlinFunctionDeclarations(code);
  const variables = new Map();
  const firstDeclarationLine = new Map();
  const initialized = new Map();
  const valNames = new Set();
  const params = new Map();

  functions.forEach((fn) => {
    fn.params.forEach((param) => {
      if (!param.name) return;
      params.set(param.name, param.type || "Any?");
      variables.set(param.name, param.type || "Any?");
      initialized.set(param.name, true);
      firstDeclarationLine.set(param.name, fn.line);
    });
  });

  lines.forEach(({ trimmed, commentlessTrimmed, cleanTrimmed, line }) => {
    if (!cleanTrimmed) return;
    const loopDeclaration = commentlessTrimmed.match(/^for\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\s*\)/);
    if (loopDeclaration) {
      const loopType = /\.indices\b|\buntil\b|\.\./.test(loopDeclaration[2]) ? "Int" : "Any?";
      variables.set(loopDeclaration[1], loopType);
      initialized.set(loopDeclaration[1], true);
      firstDeclarationLine.set(loopDeclaration[1], line);
    }

    const repeatDeclaration = commentlessTrimmed.match(/^repeat\s*\([^)]*\)\s*\{\s*([A-Za-z_$][\w$]*)\s*->/);
    if (repeatDeclaration) {
      variables.set(repeatDeclaration[1], "Int");
      initialized.set(repeatDeclaration[1], true);
      firstDeclarationLine.set(repeatDeclaration[1], line);
    }

    const declaration = commentlessTrimmed.match(/^(val|var)\s+([A-Za-z_$][\w$]*)(?:\s*:\s*([^=]+))?(?:\s*=\s*(.+))?$/);
    if (!declaration) return;
    const [, kind, name, declaredType, expression] = declaration;
    if (variables.has(name) && firstDeclarationLine.get(name) === line) return;
    if (variables.has(name) && firstDeclarationLine.get(name) !== line) throwKotlinLineError(`Conflicting declaration '${name}'.`, line, Math.max(1, trimmed.indexOf(name) + 1));
    if (params.has(name)) throwKotlinLineError(`Local variable '${name}' shadows parameter '${name}'.`, line, Math.max(1, trimmed.indexOf(name) + 1));
    if (kind === "val") valNames.add(name);
    if (declaredType && !isKotlinKnownType(declaredType.trim())) throwKotlinLineError(`Unresolved type '${declaredType.trim()}'.`, line, Math.max(1, trimmed.indexOf(declaredType.trim()) + 1));
    const inferred = declaredType ? declaredType.trim() : inferKotlinExpressionType(expression || "", variables);
    if (!declaredType && expression && inferred === "unknown" && /^[A-Za-z_$][\w$]*$/.test(expression.trim())) throwKotlinLineError("Cannot infer type from unresolved value.", line, Math.max(1, trimmed.indexOf(expression.trim()) + 1));
    variables.set(name, inferred || "unknown");
    initialized.set(name, Boolean(expression));
    firstDeclarationLine.set(name, line);
  });

  return { lines, functions, variables, initialized, valNames, params, firstDeclarationLine };
}

function validateKotlinDeclarationAndScopeChecks(code = "") {
  const info = collectKotlinSemanticInfo(code);
  const functionKeys = new Set();

  info.functions.forEach((fn) => {
    const names = new Set();
    fn.params.forEach((param) => {
      if (!param.name) return;
      if (names.has(param.name)) throwKotlinLineError(`Duplicate parameter '${param.name}'.`, fn.line, fn.column);
      names.add(param.name);
      if (param.type && !isKotlinKnownType(param.type)) throwKotlinLineError(`Unresolved type '${param.type}'.`, fn.line, fn.column);
    });
    const key = `${fn.name}/${fn.params.length}`;
    if (functionKeys.has(key)) throwKotlinLineError(`Conflicting function declaration '${fn.name}'.`, fn.line, fn.column);
    functionKeys.add(key);
  });

  const knownNames = new Set([...info.variables.keys(), ...info.functions.map((fn) => fn.name), ...KOTLIN_BUILTIN_FUNCTIONS, ...KOTLIN_RESERVED_WORDS, "input", "it"]);
  info.lines.forEach(({ trimmed, commentlessTrimmed, cleanTrimmed, line, text }) => {
    const scanText = cleanTrimmed;
    if (!cleanTrimmed || /^(val|var|fun|for|while|if|else|when|break|continue|package|import)\b/.test(commentlessTrimmed)) return;
    const callMatch = [...scanText.matchAll(/(^|[^.\w$])([A-Za-z_$][\w$]*)\s*\(/g)];
    callMatch.forEach((match) => {
      const name = match[2];
      if (!KOTLIN_BUILTIN_FUNCTIONS.has(name) && !info.functions.some((fn) => fn.name === name) && !["if", "for", "while", "when"].includes(name)) {
        throwKotlinLineError(`Unresolved function '${name}'.`, line, Math.max(1, text.indexOf(name) + 1));
      }
    });

    const tokens = [...scanText.matchAll(/(^|[^.\w$])([A-Za-z_$][\w$]*)\b/g)].map((match) => match[2]);
    tokens.forEach((token) => {
      if (knownNames.has(token) || /^[A-Z]/.test(token)) return;
      if (["length", "size", "indices", "lastIndex", "add", "remove", "contains", "containsKey", "containsValue", "getOrDefault", "keys", "values", "sorted", "sortedDescending", "distinct", "reversed", "filter", "map", "flatMap", "forEach", "any", "all", "none", "count", "sum", "maxOrNull", "minOrNull", "first", "last", "firstOrNull", "lastOrNull", "indexOf", "lastIndexOf", "joinToString", "toCharArray", "lowercase", "uppercase", "lowercaseChar", "uppercaseChar", "toInt", "toLong", "toDouble", "toFloat", "digitToInt", "isDigit", "isLetter", "isLetterOrDigit", "isWhitespace", "code"].includes(token)) return;
      throwKotlinLineError(`Unresolved reference '${token}'.`, line, Math.max(1, text.indexOf(token) + 1));
    });
  });

  info.lines.forEach(({ trimmed, line, text }) => {
    const readMatch = trimmed.match(/\bprintln\s*\(\s*([A-Za-z_$][\w$]*)\s*\)|\breturn\s+([A-Za-z_$][\w$]*)\b/);
    const name = readMatch?.[1] || readMatch?.[2];
    if (name && info.initialized.has(name) && !info.initialized.get(name)) throwKotlinLineError(`Variable '${name}' must be initialized before use.`, line, Math.max(1, text.indexOf(name) + 1));
  });
}

function validateKotlinFunctionCallChecks(code = "") {
  const info = collectKotlinSemanticInfo(code);
  const functionMap = new Map(info.functions.map((fn) => [fn.name, fn]));

  info.functions.forEach((fn) => {
    if (fn.returnType !== "Unit") {
      const bodyAfter = code.slice(fn.index);
      const expressionBody = new RegExp(`fun\\s+${escapeRegExp(fn.name)}[\\s\\S]*?=`).test(bodyAfter.split("\n")[0] || "");
      const hasReturn = new RegExp(`\\breturn\\s+`).test(bodyAfter);
      if (!expressionBody && !hasReturn) throwKotlinLineError("Return required on every path.", fn.line, fn.column);
    }
  });

  info.lines.forEach(({ trimmed, commentlessTrimmed, cleanTrimmed, line, text }) => {
    if (!cleanTrimmed) return;
    const scanText = commentlessTrimmed;
    const callScanText = cleanTrimmed;
    if (/^fun\b/.test(scanText)) return;
    const returnOnly = scanText.match(/^return\s*$/);
    if (returnOnly) {
      const fn = getKotlinFunctionForLine(info.functions, line);
      if (fn && fn.returnType !== "Unit") throwKotlinLineError("Return value required.", line, Math.max(1, text.indexOf("return") + 1));
    }
    const returnValue = scanText.match(/^return\s+(.+)$/);
    if (returnValue) {
      const fn = getKotlinFunctionForLine(info.functions, line);
      if (fn && fn.returnType === "Unit") throwKotlinLineError("Return value not allowed for Unit function.", line, Math.max(1, text.indexOf(returnValue[1]) + 1));
    }

    const calls = [...callScanText.matchAll(/(^|[^.\w$])([A-Za-z_$][\w$]*)\s*\(([^)]*)\)/g)];
    calls.forEach((match) => {
      const name = match[2];
      if (!functionMap.has(name) && !KOTLIN_BUILTIN_FUNCTIONS.has(name) && !["if", "for", "while", "when"].includes(name)) {
        throwKotlinLineError(`Unresolved function '${name}'.`, line, Math.max(1, text.indexOf(name) + 1));
      }
      if (!functionMap.has(name) || KOTLIN_BUILTIN_FUNCTIONS.has(name)) return;
      const fn = functionMap.get(name);
      const args = splitTopLevelKotlinArguments(match[3] || "");
      const named = new Set();
      args.forEach((arg) => {
        const namedMatch = arg.match(/^([A-Za-z_$][\w$]*)\s*=/);
        if (!namedMatch) return;
        if (!fn.params.some((param) => param.name === namedMatch[1])) throwKotlinLineError(`Unknown parameter '${namedMatch[1]}'.`, line, Math.max(1, text.indexOf(namedMatch[1]) + 1));
        if (named.has(namedMatch[1])) throwKotlinLineError(`Argument '${namedMatch[1]}' passed more than once.`, line, Math.max(1, text.indexOf(namedMatch[1]) + 1));
        named.add(namedMatch[1]);
      });
      if (args.length < fn.params.length) throwKotlinLineError(`Expected ${fn.params.length} arguments, found ${args.length}.`, line, Math.max(1, text.indexOf(name) + 1));
      if (args.length > fn.params.length) throwKotlinLineError("Too many arguments.", line, Math.max(1, text.indexOf(name) + 1));
      args.forEach((arg, index) => {
        const expected = fn.params[index]?.type || "Any?";
        const actual = inferKotlinExpressionType(arg.replace(/^[A-Za-z_$][\w$]*\s*=\s*/, ""), info.variables);
        if (!isKotlinTypeCompatible(expected, actual)) throwKotlinLineError(`Expected ${expected}, found ${actual}.`, line, Math.max(1, text.indexOf(arg.trim()) + 1));
      });
    });
  });
}

function validateKotlinOperatorExpressionChecks(code = "") {
  const info = collectKotlinSemanticInfo(code);
  info.lines.forEach(({ commentlessTrimmed, cleanTrimmed, line, text }) => {
    if (!cleanTrimmed) return;
    const scanText = commentlessTrimmed;
    if (/\b(true|false)\b\s*[+\-*/%]\s*\d+|\d+\s*[+\-*/%]\s*\b(true|false)\b/.test(scanText)) throwKotlinLineError("Arithmetic operators require numeric operands.", line, 1);
    if (/\d+\s*&&\s*\d+|"[^"]*"\s*&&|&&\s*"[^"]*"/.test(scanText)) throwKotlinLineError("`&&` requires Boolean operands.", line, 1);
    if (/"[^"]*"\s*>\s*(true|false)|\b(true|false)\b\s*>\s*"[^"]*"/.test(scanText)) throwKotlinLineError("Types cannot be compared.", line, 1);
    if (/!\s*\d+/.test(scanText)) throwKotlinLineError("`!` requires a Boolean.", line, Math.max(1, text.indexOf("!") + 1));
    if (/-\s*"[^"]*"/.test(scanText)) throwKotlinLineError("Unary `-` requires a number.", line, Math.max(1, text.indexOf("-") + 1));
    if (/\d+\s*==\s*(true|false)|(true|false)\s*==\s*\d+/.test(scanText)) throwKotlinLineError("Incompatible equality operands.", line, 1);
    if (/"[^"]*"\s*-\s*"[^"]*"/.test(scanText)) throwKotlinLineError("Operator `-` is not defined for String.", line, 1);
    if (/\b\d+\s*\(\s*\)/.test(scanText)) throwKotlinLineError("Expression cannot be invoked.", line, 1);
    if (/\b\d+\.name\b/.test(scanText)) throwKotlinLineError("Member does not exist on Int.", line, 1);
    if (/"[^"]*"\s+as\s+Int\b/.test(scanText)) throwKotlinLineError("Invalid or impossible cast.", line, 1);
    if (/\/\s*0(?![\d.])/.test(scanText)) throwKotlinLineError("Division by zero.", line, Math.max(1, text.indexOf("/ 0") + 1));
    if (/\bInt\.MAX_VALUE\s*\+\s*1\b/.test(scanText)) throwKotlinLineError("Constant value overflow.", line, 1);
    if (/^const\s+val\s+[A-Za-z_$][\w$]*\s*=\s*[A-Za-z_$][\w$]*\s*\(/.test(scanText)) throwKotlinLineError("Compile-time constant required.", line, 1);
    if (/(^|[^.\w$])([A-Za-z_$][\w$]*)\s*\+=\s*"/.test(scanText)) {
      const name = scanText.match(/(^|[^.\w$])([A-Za-z_$][\w$]*)\s*\+=\s*"/)?.[2];
      if (name && !/^String/.test(info.variables.get(name) || "")) throwKotlinLineError("Operator not applicable for compound assignment.", line, Math.max(1, text.indexOf(name) + 1));
    }
  });
}

function validateKotlinNullSafetyChecklist(code = "") {
  const info = collectKotlinSemanticInfo(code);
  info.lines.forEach(({ trimmed, line, text }) => {
    for (const [name, type] of info.variables) {
      if (String(type).endsWith("?") && new RegExp(`\\b${escapeRegExp(name)}\\.(?![?])`).test(trimmed)) {
        throwKotlinLineError("Safe or non-null access required for nullable value.", line, Math.max(1, text.indexOf(`${name}.`) + 1));
      }
      if (type !== "unknown" && !["Any?", "Any"].includes(String(type)) && !String(type).endsWith("?") && new RegExp(`\\b${escapeRegExp(name)}\\?\\.`).test(trimmed)) {
        throwKotlinLineError("Safe call is not applicable to a non-null value.", line, Math.max(1, text.indexOf(`${name}?.`) + 1));
      }
      if (type !== "unknown" && !["Any?", "Any"].includes(String(type)) && !String(type).endsWith("?") && new RegExp(`\\b${escapeRegExp(name)}!!`).test(trimmed)) {
        throwKotlinLineError("Unnecessary or invalid non-null assertion.", line, Math.max(1, text.indexOf(`${name}!!`) + 1));
      }
    }
  });
}

function validateKotlinArrayControlAndRuntimeChecks(code = "") {
  const stripped = stripCodeStringsAndComments(code);
  const breakMatch = stripped.match(/\bbreak\b/);
  if (breakMatch && !stripped.slice(0, breakMatch.index).match(/\b(for|while)\s*\(/)) throwKotlinCompilerError("`break` is allowed only in loops.", code, breakMatch.index || 0);
  const continueMatch = stripped.match(/\bcontinue\b/);
  if (continueMatch && !stripped.slice(0, continueMatch.index).match(/\b(for|while)\s*\(/)) throwKotlinCompilerError("`continue` is allowed only in loops.", code, continueMatch.index || 0);
  const info = collectKotlinSemanticInfo(code);
  info.lines.forEach(({ commentlessTrimmed, cleanTrimmed, line, text }) => {
    if (!cleanTrimmed) return;
    const scanText = commentlessTrimmed;
    const stringIndexAccess = scanText.match(/\b([A-Za-z_$][\w$]*)\s*\[\s*"[^"]+"\s*\]/);
    if (stringIndexAccess && !/\binput\s*\[/.test(scanText)) {
      const indexedType = String(info.variables.get(stringIndexAccess[1]) || "");
      if (!/^Map|^MutableMap|^Any/.test(indexedType)) throwKotlinLineError("Array index must be Int.", line, 1);
    }
    const outOfBounds = scanText.match(/arrayOf\(([^)]*)\)\s*\[\s*(\d+)\s*\]/);
    if (outOfBounds) {
      const size = splitTopLevelKotlinArguments(outOfBounds[1]).length;
      const index = Number(outOfBounds[2]);
      if (index >= size) throwKotlinLineError("Index is outside array bounds.", line, Math.max(1, text.indexOf("[") + 1));
    }
    const negativeArray = scanText.match(/IntArray\s*\(\s*(-\d+)\s*\)/);
    if (negativeArray) throwKotlinLineError("Array size cannot be negative.", line, Math.max(1, text.indexOf(negativeArray[1]) + 1));
    if (/^if\s*\(\s*(\d+|"[^"]*")\s*\)/.test(scanText)) throwKotlinLineError("Condition must be Boolean.", line, Math.max(1, text.indexOf("(") + 2));
    if (/^while\s*\(\s*(\d+|"[^"]*")\s*\)/.test(scanText)) throwKotlinLineError("Boolean condition required.", line, Math.max(1, text.indexOf("(") + 2));
    if (/\d+\s*\.\.\s*"[^"]*"|"[^"]*"\s*\.\.\s*\d+/.test(scanText)) throwKotlinLineError("Range endpoints are incompatible.", line, 1);
    if (/^break\b/.test(scanText) && !code.slice(0, code.indexOf(text)).match(/\b(for|while)\s*\(/)) throwKotlinLineError("`break` is allowed only in loops.", line, 1);
    if (/^continue\b/.test(scanText) && !code.slice(0, code.indexOf(text)).match(/\b(for|while)\s*\(/)) throwKotlinLineError("`continue` is allowed only in loops.", line, 1);
    if (/\belse\b/.test(scanText) && /->|,/.test(scanText) && !/else\s*->\s*[^,}]+\s*$/.test(scanText)) throwKotlinLineError("`else` must be last.", line, Math.max(1, text.indexOf("else") + 1));
  });

  const rawLines = String(code || "").replace(/\r\n/g, "\n").split("\n");
  rawLines.forEach((lineText, index) => {
    const isBlockExpressionReturn = /^\s*return\s+(when|if)\b/.test(lineText);
    if (!isBlockExpressionReturn && /^\s*(return|throw)\b/.test(lineText) && rawLines[index + 1] && rawLines[index + 1].trim() && !/^\s*}/.test(rawLines[index + 1])) {
      throwKotlinLineError("Unreachable code warning.", index + 2, Math.max(1, rawLines[index + 1].search(/\S/) + 1));
    }
  });

  if (/when\s*\([^)]*\)\s*\{[\s\S]*?else[\s\S]*?->/.test(code)) {
    const body = code.match(/when\s*\([^)]*\)\s*\{([\s\S]*?)\}/)?.[1] || "";
    const conditions = [...body.matchAll(/^\s*([^\s,]+)\s*->/gm)].map((match) => match[1]);
    const seen = new Set();
    conditions.forEach((condition) => {
      if (seen.has(condition)) throw createCodingPracticeCompilerError("Duplicate condition in when expression.", 1, 1);
      seen.add(condition);
    });
  }
}

function validateKotlinBackendSecurityChecks(code = "") {
  const stripped = stripCodeStringsAndComments(code);
  const unsupported = stripped.match(/\b(suspend|launch|async|runBlocking|flow|Flow|Channel|class|object|interface|data\s+class|sealed\s+class)\b/);
  if (unsupported) throwKotlinCompilerError(`Unsupported language feature '${unsupported[0]}'. The free browser compiler supports function-style practice solutions only.`, code, unsupported.index || 0);
  const unsafe = stripped.match(/\b(File|ProcessBuilder|Runtime|getRuntime|System\.exit|fetch|XMLHttpRequest|localStorage|sessionStorage|document|window|eval|Function)\b/);
  if (unsafe) throwKotlinCompilerError("Operation not permitted in the practice runner.", code, unsafe.index || 0);
  const main = stripped.match(/\bfun\s+main\s*\(([^)]*)\)/);
  if (main && main[1].trim() && !/Array\s*<\s*String\s*>|Array<String>/.test(main[1])) throwKotlinCompilerError("Unsupported main signature. Use fun solve(input: Any?): Any? for practice problems.", code, main.index || 0);
  if (!/\bfun\s+solve\s*\(/.test(stripped)) throw createCodingPracticeCompilerError("Entry point not found. Define fun solve(input: Any?): Any?.", 1, 1);
  const functions = getKotlinFunctionDeclarations(code);
  functions.forEach((fn, index) => {
    const nextFunction = functions[index + 1];
    const bodyAfter = code.slice(fn.index, nextFunction ? nextFunction.index : code.length);
    const calls = bodyAfter.match(new RegExp(`\\b${escapeRegExp(fn.name)}\\s*\\(`, "g")) || [];
    if (calls.length > 1 && !/\b(if|when)\b/.test(bodyAfter)) throwKotlinLineError("Recursion limit risk: recursive function has no obvious base condition.", fn.line, fn.column);
  });
}
function validateKotlinPracticeCode(code = "") {
  validateKotlinSecurityLimits(code);
  validateKotlinLexicalChecks(code);
  validateKotlinDelimiters(code);
  validateKotlinSyntaxChecklist(code);
  validateKotlinBackendSecurityChecks(code);
  validateKotlinDeclarationAndScopeChecks(code);
  validateKotlinFunctionCallChecks(code);
  validateKotlinNullSafetySyntax(code);
  validateKotlinNullSafetyChecklist(code);
  validateKotlinDeclaredTypes(code);
  validateKotlinOperatorExpressionChecks(code);
  validateKotlinArrayControlAndRuntimeChecks(code);
}
function compileKotlinPracticeToJavaScript(code = "") {
  let source = String(code || "").trim();
  if (!source) throw new Error("Write Kotlin code before running tests.");
  validateKotlinPracticeCode(source);

  source = source
    .replace(/^\s*(package|import)\s+.*$/gm, "")
    .replace(/\r\n/g, "\n");

  source = rewriteKotlinIfExpressions(source);
  source = rewriteKotlinWhenReturnExpressions(source);
  source = rewriteKotlinExpressionBodyFunctions(source);
  source = rewriteKotlinArrayConstructors(source);
  source = rewriteKotlinRepeatBlocks(source);

  const mapNames = [...source.matchAll(/\b(?:val|var)\s+([A-Za-z_$][\w$]*)\s*(?::[^=]+)?=\s*(?:mutableMapOf|mapOf|hashMapOf|linkedMapOf)\b/g)]
    .map((match) => match[1]);
  const mutableListNames = [...source.matchAll(/\b(?:val|var)\s+([A-Za-z_$][\w$]*)\s*(?::[^=]+)?=\s*(?:mutableListOf|arrayListOf)\b/g)]
    .map((match) => match[1]);
  const mutableSetNames = [...source.matchAll(/\b(?:val|var)\s+([A-Za-z_$][\w$]*)\s*(?::[^=]+)?=\s*(?:mutableSetOf|hashSetOf|linkedSetOf)\b/g)]
    .map((match) => match[1]);
  const stringBuilderNames = [...source.matchAll(/\b(?:val|var)\s+([A-Za-z_$][\w$]*)\s*(?::[^=]+)?=\s*StringBuilder\s*\(/g)]
    .map((match) => match[1]);

  source = source.replace(/\bfun\s+([A-Za-z_$][\w$]*)\s*\(([^)]*)\)\s*(?::\s*[^\{]+)?\s*\{/g, (_, name, params) => (
    `function ${name}(${stripKotlinParameterTypes(params)}) {`
  ));
  source = source.replace(/\bval\s+([A-Za-z_$][\w$]*)(\s*:\s*[^=]+)?\s*=/g, "const $1 =");
  source = source.replace(/\bvar\s+([A-Za-z_$][\w$]*)(\s*:\s*[^=]+)?\s*=/g, "let $1 =");
  source = source.replace(/\s+as\??\s+[A-Za-z_$][\w$]*(?:<[^>\n]+>)?/g, "");
  source = source.replace(/!!/g, "");
  source = source.replace(/\s*\?:\s*/g, " ?? ");
  source = source.replace(/\bmaxOf\s*\(/g, "Math.max(");
  source = source.replace(/\bminOf\s*\(/g, "Math.min(");
  source = source.replace(/\bStringBuilder\s*\(\s*\)/g, "[]");

  source = source.replace(/\b(?:listOf|mutableListOf|arrayListOf|arrayOf|intArrayOf|charArrayOf|booleanArrayOf|doubleArrayOf|longArrayOf)(?:<[^>]+>)?\s*\(([^)]*)\)/g, "[$1]");
  source = source.replace(/\b(?:emptyList|emptyArray)(?:<[^>]+>)?\s*\(\s*\)/g, "[]");
  source = source.replace(/\b(?:setOf|mutableSetOf|hashSetOf|linkedSetOf)(?:<[^>]+>)?\s*\(([^)]*)\)/g, (_, args) => {
    const values = splitTopLevelKotlinArguments(args).join(", ");
    return values ? `new Set([${values}])` : "new Set()";
  });
  source = source.replace(/\bemptySet(?:<[^>]+>)?\s*\(\s*\)/g, "new Set()");
  source = source.replace(/\b(?:mapOf|mutableMapOf|hashMapOf|linkedMapOf)(?:<[^>]+>)?\s*\(([^)]*)\)/g, (_, args) => compileKotlinMapEntries(args));
  source = source.replace(/\bemptyMap(?:<[^>]+>)?\s*\(\s*\)/g, "new Map()");

  for (const name of [...new Set(mapNames)]) {
    source = rewriteKotlinMapAccess(source, name);
  }
  for (const name of [...new Set(mutableListNames)]) {
    const escaped = escapeRegExp(name);
    source = source.replace(new RegExp(`${escaped}\\.add\\(`, "g"), `${name}.push(`);
    source = source.replace(new RegExp(escaped + "\\.removeAt\\(([^)]+)\\)", "g"), "kotlinRemoveAt(" + name + ", $1)");
  }
  for (const name of [...new Set(mutableSetNames)]) {
    const escaped = escapeRegExp(name);
    source = source
      .replace(new RegExp(escaped + "\\.add\\(([^)]+)\\)", "g"), "kotlinSetAdd(" + name + ", $1)")
      .replace(new RegExp(escaped + "\\.remove\\(([^)]+)\\)", "g"), name + ".delete($1)");
  }
  for (const name of [...new Set(stringBuilderNames)]) {
    const escaped = escapeRegExp(name);
    source = source.replace(new RegExp(`${escaped}\\.append\\(`, "g"), `${name}.push(`);
    source = source.replace(new RegExp(`${escaped}\\.toString\\(\\)`, "g"), `${name}.join("")`);
  }

  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+([A-Za-z_$][\w$]*)\.indices\.reversed\(\)\s*\)/g, "for (let $1 = $2.length - 1; $1 >= 0; $1--)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\s+downTo\s+(.+?)\s+step\s+(.+?)\s*\)/g, "for (let $1 = $2; $1 >= $3; $1 -= $4)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\s+until\s+(.+?)\s+step\s+(.+?)\s*\)/g, "for (let $1 = $2; $1 < $3; $1 += $4)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\.\.(.+?)\s+step\s+(.+?)\s*\)/g, "for (let $1 = $2; $1 <= $3; $1 += $4)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+([A-Za-z_$][\w$]*)\.indices\s*\)/g, "for (let $1 = 0; $1 < $2.length; $1++)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\s+downTo\s+(.+?)\s*\)/g, "for (let $1 = $2; $1 >= $3; $1--)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\s+until\s+(.+?)\s*\)/g, "for (let $1 = $2; $1 < $3; $1++)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+(.+?)\.\.(.+?)\s*\)/g, "for (let $1 = $2; $1 <= $3; $1++)");
  source = source.replace(/\bfor\s*\(\s*(?:val|var)?\s*([A-Za-z_$][\w$]*)\s+in\s+([^)]+)\)/g, "for (const $1 of $2)");

  source = source.replace(/\.lowercase\(\)|\.lowercaseChar\(\)/g, ".toLowerCase()");
  source = source.replace(/\.uppercase\(\)|\.uppercaseChar\(\)/g, ".toUpperCase()");
  const kotlinReceiverPattern = "([A-Za-z_$][\\w$]*(?:\\[[^\\]]+\\])?(?:\\.[A-Za-z_$][\\w$]*\\(\\))*)";
  source = rewriteKotlinCollectionLambdas(source, kotlinReceiverPattern);
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.toSet\\(\\)\\.size\\b", "g"), "kotlinSize(kotlinToSet($1))");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.toList\\(\\)", "g"), "kotlinToList($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.toSet\\(\\)", "g"), "kotlinToSet($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.count\\s*\\{\\s*it\\s+in\\s+([^}]+)\\}", "g"), "kotlinCount($1, (it) => kotlinContains($2, it))");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.count\\s*\\{\\s*([^}]+)\\}", "g"), "kotlinCount($1, (it) => $2)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.count\\(\\)", "g"), "kotlinSize($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.any\\s*\\{\\s*([^}]+)\\}", "g"), "kotlinAny($1, (it) => $2)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.all\\s*\\{\\s*([^}]+)\\}", "g"), "kotlinAll($1, (it) => $2)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.none\\s*\\{\\s*([^}]+)\\}", "g"), "kotlinNone($1, (it) => $2)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.contains\\(([^)]+)\\)", "g"), "kotlinContains($1, $2)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.sum\\(\\)", "g"), "kotlinSum($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.maxOrNull\\(\\)", "g"), "kotlinMaxOrNull($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.minOrNull\\(\\)", "g"), "kotlinMinOrNull($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.distinct\\(\\)", "g"), "kotlinDistinct($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.sortedDescending\\(\\)", "g"), "kotlinSortedDescending($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.sorted\\(\\)", "g"), "kotlinSorted($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.firstOrNull\\(\\)", "g"), "kotlinFirstOrNull($1)");
  source = source.replace(new RegExp(kotlinReceiverPattern + "\\.lastOrNull\\(\\)", "g"), "kotlinLastOrNull($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.lastIndex\b/g, "(kotlinSize($1) - 1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.size\b/g, "kotlinSize($1)");
  source = source.replace(/\.lowercase\(\)|\.lowercaseChar\(\)/g, ".toLowerCase()");
  source = source.replace(/\.uppercase\(\)|\.uppercaseChar\(\)/g, ".toUpperCase()");
  source = source.replace(/\.toCharArray\(\)/g, ".split(\"\")");
  source = source.replace(/\.joinToString\(\s*"([^"]*)"\s*\)/g, ".join(\"$1\")");
  source = source.replace(/\.joinToString\(\s*\)/g, ".join(\", \")");
  // sorted() is handled above with kotlinSorted() so the original collection is not mutated.
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.reversed\(\)/g, "kotlinReversed($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.first\(\)/g, "$1[0]");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.last\(\)/g, "$1[kotlinSize($1) - 1]");
  source = source.replace(/\.isEmpty\(\)/g, ".length === 0");
  source = source.replace(/\.isNotEmpty\(\)/g, ".length > 0");
  source = source.replace(/if\s*\(\s*([A-Za-z_$][\w$]*)\s+!in\s+([^)]+)\)/g, "if (!kotlinContains($2, $1))");
  source = source.replace(/if\s*\(\s*([A-Za-z_$][\w$]*)\s+in\s+([^)]+)\)/g, "if (kotlinContains($2, $1))");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*\(\))?)\s+!in\s+("[^"]*"|'[^']*'|[A-Za-z_$][\w$]*)/g, "!kotlinContains($2, $1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*\(\))?)\s+in\s+("[^"]*"|'[^']*'|[A-Za-z_$][\w$]*)/g, "kotlinContains($2, $1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.toInt\(\)/g, "Number.parseInt($1, 10)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.toLong\(\)/g, "Number.parseInt($1, 10)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.toDouble\(\)/g, "Number($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.toFloat\(\)/g, "Number($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.digitToInt\(\)/g, "kotlinDigitToInt($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.isDigit\(\)/g, "kotlinIsDigit($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.isLetterOrDigit\(\)/g, "kotlinIsLetterOrDigit($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.isLetter\(\)/g, "kotlinIsLetter($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.isWhitespace\(\)/g, "kotlinIsWhitespace($1)");
  source = source.replace(/([A-Za-z_$][\w$]*(?:\[[^\]]+\])?)\.code\b/g, "$1.charCodeAt(0)");
  source = source.replace(/\babs\s*\(/g, "Math.abs(").replace(/\bceil\s*\(/g, "Math.ceil(").replace(/\bfloor\s*\(/g, "Math.floor(").replace(/\bsqrt\s*\(/g, "Math.sqrt(");
  source = source.replace(/([A-Za-z_$][\w$]*)\s*-\s*'([^']{1})'/g, "($1.charCodeAt(0) - '$2'.charCodeAt(0))");
  source = source.replace(/\bprintln\s*\(/g, "console.log(").replace(/\bprint\s*\(/g, "console.log(");

  if (!/\bfunction\s+solve\s*\(/.test(source)) {
    throw new Error("Define fun solve(input: Any?): Any? { ... }. The runner calls solve(input) for every test case.");
  }

  return `
    const kotlinSize = (value) => {
      if (value == null) return 0;
      if (typeof value === "string" || Array.isArray(value)) return value.length;
      if (typeof value.size === "number") return value.size;
      return Object.keys(value).length;
    };
    const kotlinContains = (collection, value) => {
      if (collection == null) return false;
      if (typeof collection.has === "function") return collection.has(value);
      if (typeof collection.includes === "function") return collection.includes(value);
      return Object.prototype.hasOwnProperty.call(collection, value);
    };
    const kotlinReversed = (value) => {
      if (typeof value === "string") return value.split("").reverse().join("");
      if (value && typeof value[Symbol.iterator] === "function") return [...value].reverse();
      return value;
    };
    const kotlinToList = (value) => {
      if (value == null) return [];
      if (value instanceof Set || value instanceof Map) return [...value.values()];
      if (typeof value === "string" || Array.isArray(value)) return [...value];
      if (typeof value[Symbol.iterator] === "function") return [...value];
      return Object.values(value);
    };
    const kotlinToSet = (value) => new Set(kotlinToList(value));
    const kotlinCount = (value, predicate) => kotlinToList(value).filter((item) => predicate(item)).length;
    const kotlinAny = (value, predicate) => kotlinToList(value).some((item) => predicate(item));
    const kotlinAll = (value, predicate) => kotlinToList(value).every((item) => predicate(item));
    const kotlinNone = (value, predicate) => !kotlinToList(value).some((item) => predicate(item));
    const kotlinSum = (value) => kotlinToList(value).reduce((sum, item) => sum + Number(item || 0), 0);
    const kotlinMaxOrNull = (value) => {
      const items = kotlinToList(value);
      return items.length ? Math.max(...items) : null;
    };
    const kotlinMinOrNull = (value) => {
      const items = kotlinToList(value);
      return items.length ? Math.min(...items) : null;
    };
    const kotlinFilter = (value, predicate) => kotlinToList(value).filter((item) => predicate(item));
    const kotlinMap = (value, mapper) => kotlinToList(value).map((item) => mapper(item));
    const kotlinFlatMap = (value, mapper) => kotlinToList(value).flatMap((item) => kotlinToList(mapper(item)));
    const kotlinForEach = (value, action) => { kotlinToList(value).forEach((item) => action(item)); };
    const kotlinDistinct = (value) => [...new Set(kotlinToList(value))];
    const kotlinSorted = (value) => kotlinToList(value).slice().sort((a, b) => typeof a === "number" && typeof b === "number" ? a - b : String(a).localeCompare(String(b)));
    const kotlinSortedDescending = (value) => kotlinSorted(value).reverse();
    const kotlinFirstOrNull = (value, predicate) => {
      const items = kotlinToList(value);
      if (typeof predicate === "function") return items.find((item) => predicate(item)) ?? null;
      return items.length ? items[0] : null;
    };
    const kotlinLastOrNull = (value) => {
      const items = kotlinToList(value);
      return items.length ? items[items.length - 1] : null;
    };
    const kotlinSetAdd = (set, value) => {
      if (!(set instanceof Set)) return false;
      const exists = set.has(value);
      set.add(value);
      return !exists;
    };
    const kotlinRemoveAt = (list, index) => Array.isArray(list) ? list.splice(Number(index), 1)[0] : undefined;
    const kotlinDigitToInt = (value) => Number.parseInt(String(value), 10);
    const kotlinIsDigit = (value) => /^\\d$/.test(String(value));
    const kotlinIsLetter = (value) => /^[A-Za-z]$/.test(String(value));
    const kotlinIsLetterOrDigit = (value) => /^[A-Za-z0-9]$/.test(String(value));
    const kotlinIsWhitespace = (value) => /^\\s$/.test(String(value));
    // skillup-user-code-start
    ${source}
  `;
}

function getBrowserRunnableCodingPracticeCode(code = "", languageId = "javascript") {
  if (languageId === "kotlin") return compileKotlinPracticeToJavaScript(code);
  return code;
}


function encodeKotlinPlaygroundState(state = {}) {
  const json = JSON.stringify(state);
  const utf8 = encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
  return btoa(utf8).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

function toKotlinPlaygroundLiteral(value) {
  if (value === null || value === undefined) return "null";
  if (typeof value === "string") return JSON.stringify(value);
  if (typeof value === "number") return Number.isFinite(value) ? String(value) : "null";
  if (typeof value === "boolean") return value ? "true" : "false";
  if (Array.isArray(value)) return "listOf(" + value.map(toKotlinPlaygroundLiteral).join(", ") + ")";
  if (typeof value === "object") {
    const entries = Object.entries(value).map(([key, item]) => JSON.stringify(key) + " to " + toKotlinPlaygroundLiteral(item));
    return entries.length ? "mapOf(" + entries.join(", ") + ")" : "emptyMap<String, Any?>()";
  }
  return JSON.stringify(String(value));
}

function buildKotlinPlaygroundPracticeCode(item, userCode = "") {
  const source = String(userCode || "").trim() || getCodingPracticeStarterCode(item, "kotlin");
  const solveParamType = (source.match(/\bfun\s+solve\s*\(\s*[A-Za-z_$][\w$]*\s*:\s*([^)=]+(?:<[^)]*>[^)=]*)?)/)?.[1] || "Any?").trim();
  const normalizedParamType = solveParamType.replace(/\s+/g, "");
  const solveInputExpression = (!normalizedParamType || normalizedParamType === "Any" || normalizedParamType === "Any?")
    ? "case.input"
    : "case.input as " + solveParamType;
  const cases = getCodingPracticeTestCases(item).slice(0, 8);
  const caseLines = cases.map((testCase, index) => {
    const safeName = String(testCase.name || "Case " + (index + 1));
    return "        SkillUpCase(" + JSON.stringify(safeName) + ", " + toKotlinPlaygroundLiteral(testCase.input) + ", " + toKotlinPlaygroundLiteral(testCase.expected) + ")";
  }).join(",\n");

  return [
    "// SkillUp Class generated Kotlin Playground runner",
    "// Edit solve(input) below, then press Run. These are the visible sample tests from the website.",
    "",
    "data class SkillUpCase(val name: String, val input: Any?, val expected: Any?)",
    "",
    "fun formatValue(value: Any?): String = when (value) {",
    "    null -> \"null\"",
    "    is Map<*, *> -> value.entries.joinToString(prefix = \"{\", postfix = \"}\") { it.key.toString() + \"=\" + formatValue(it.value) }",
    "    is Iterable<*> -> value.joinToString(prefix = \"[\", postfix = \"]\") { formatValue(it) }",
    "    is Array<*> -> value.joinToString(prefix = \"[\", postfix = \"]\") { formatValue(it) }",
    "    else -> value.toString()",
    "}",
    "",
    "fun main() {",
    "    val cases = listOf(",
    caseLines,
    "    )",
    "    var passed = 0",
    "",
    "    cases.forEachIndexed { index, case ->",
    "        val actual = solve(" + solveInputExpression + ")",
    "        val ok = actual == case.expected",
    "        if (ok) passed++",
    "",
    "        println((if (ok) \"PASS\" else \"FAIL\") + \" \" + (index + 1) + \". \" + case.name)",
    "        println(\"   input    = \" + formatValue(case.input))",
    "        println(\"   expected = \" + formatValue(case.expected))",
    "        println(\"   actual   = \" + formatValue(actual))",
    "        println()",
    "    }",
    "",
    "    println(\"Result: \" + passed + \"/\" + cases.size + \" passed\")",
    "}",
    "",
    "// --- Your solution ---",
    source,
    ""
  ].join("\n");
}

function getKotlinPlaygroundPracticeUrl(item, userCode = "") {
  const code = buildKotlinPlaygroundPracticeCode(item, userCode);
  const payload = {
    version: "2.4.10",
    platform: "java",
    args: "",
    noneMarkers: true,
    theme: "idea",
    code,
    compilerArguments: {}
  };
  return "https://play.kotlinlang.org/#" + encodeKotlinPlaygroundState(payload);
}

function openKotlinPlaygroundPractice(scope) {
  const item = getCodingPracticeItemBySlug(scope?.dataset.activePractice || "");
  const editor = scope?.querySelector("[data-code-editor]");
  if (!item || !editor) return;
  persistCodingPracticeEditor(editor);
  const url = getKotlinPlaygroundPracticeUrl(item, editor.value);
  window.open(url, "_blank", "noopener,noreferrer");
}

function getCodingPracticeGeneratedLineOffset(code = "") {
  const marker = "// skillup-user-code-start";
  const index = String(code || "").indexOf(marker);
  if (index < 0) return 0;
  return String(code).slice(0, index).split("\n").length;
}
function getCodingPracticeFetchTimeout() {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), CODING_PRACTICE_COMPILER_TIMEOUT_MS);
  return {
    signal: controller.signal,
    clear: () => window.clearTimeout(timer)
  };
}

function getCodingPracticeCompilerError(error, fallback = "Compiler request failed.") {
  if (!error) return fallback;
  if (error.name === "AbortError") return "Compiler request timed out. Please try again.";
  return error.message || String(error) || fallback;
}

async function readCodingPracticeJsonResponse(response, sourceLabel) {
  const contentType = response.headers?.get("content-type") || "";
  const text = await response.text();
  let payload = null;
  try {
    payload = text ? JSON.parse(text) : null;
  } catch {
    const kind = contentType.includes("text/html") ? "the website page" : "a non-JSON response";
    throw new Error(`${sourceLabel} returned ${kind} instead of compiler results. The runCode Firebase Function is not connected on this URL.`);
  }

  if (!response.ok || !payload?.ok) {
    throw new Error(payload?.message || payload?.error || `${sourceLabel} returned HTTP ${response.status}.`);
  }

  return payload;
}

function getCodingPracticeCompilerEndpoints() {
  const projectId = firebaseConfig?.projectId || "";
  const directFunctionUrl = projectId
    ? `https://${CODING_PRACTICE_FUNCTION_REGION}-${projectId}.cloudfunctions.net/runCode`
    : "";
  const isLocalHost = ["localhost", "127.0.0.1", "0.0.0.0", ""].includes(window.location.hostname);
  const endpoints = isLocalHost
    ? [
        { url: directFunctionUrl, label: "Deployed Firebase Function" },
        { url: CODING_PRACTICE_RUNNER_ENDPOINT, label: "Local Firebase rewrite" }
      ]
    : [
        { url: CODING_PRACTICE_RUNNER_ENDPOINT, label: "Firebase Hosting rewrite" },
        { url: directFunctionUrl, label: "Deployed Firebase Function" }
      ];

  const seen = new Set();
  return endpoints.filter((endpoint) => {
    if (!endpoint.url || seen.has(endpoint.url)) return false;
    seen.add(endpoint.url);
    return true;
  });
}

async function requestCodingPracticeFirebaseCompiler(payload, endpoint) {
  const timeout = getCodingPracticeFetchTimeout();
  // The function refuses anonymous callers, so send the signed-in user's ID
  // token. Coding Practice already requires an account to open.
  const idToken = await firebase.auth?.currentUser?.getIdToken?.().catch(() => "") || "";
  try {
    const response = await fetch(endpoint.url, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}) },
      body: JSON.stringify(payload),
      signal: timeout.signal
    });
    const result = await readCodingPracticeJsonResponse(response, endpoint.label);
    return { ...result, source: endpoint.label };
  } finally {
    timeout.clear();
  }
}


async function requestCodingPracticeCompilerRun(payload) {
  const errors = [];
  for (const endpoint of getCodingPracticeCompilerEndpoints()) {
    try {
      return await requestCodingPracticeFirebaseCompiler(payload, endpoint);
    } catch (error) {
      errors.push(`${endpoint.label}: ${getCodingPracticeCompilerError(error)}`);
    }
  }

  const detail = errors.filter(Boolean).join(" | ");
  throw new Error(`Compiler backend is not ready. Deploy the runCode Firebase Function and configure PISTON_API_URL or JUDGE0_API_URL in Functions. Details: ${detail}`);
}

function buildCodingPracticeErrorSnippet(source = "", line = 0, column = 0) {
  const lines = String(source || "").replace(/\r\n/g, "\n").split("\n");
  const targetLine = Number(line) || 0;
  if (!targetLine || targetLine < 1 || targetLine > lines.length) return "";

  const start = Math.max(1, targetLine - 2);
  const end = Math.min(lines.length, targetLine + 2);
  const width = String(end).length;
  const rows = [];

  for (let number = start; number <= end; number += 1) {
    const marker = number === targetLine ? ">" : " ";
    const gutter = String(number).padStart(width, " ");
    rows.push(`${marker} ${gutter} | ${lines[number - 1] || ""}`);
    if (number === targetLine && Number(column) > 0) {
      rows.push(`  ${" ".repeat(width)} | ${" ".repeat(Math.max(0, Number(column) - 1))}^`);
    }
  }

  return `<pre class="code-error-snippet"><code>${escapeHtml(rows.join("\n"))}</code></pre>`;
}

function showCodingPracticeRunError(scope, title, message, details = {}) {
  const errorBox = scope?.querySelector("[data-code-error]");
  if (!errorBox) return;
  const line = Number(details.line || details.lineNumber || 0);
  const column = Number(details.column || details.columnNumber || 0);
  const location = line
    ? `<small class="code-error-location">Line ${line}${column ? `, column ${column}` : ""}</small>`
    : "";
  const snippet = buildCodingPracticeErrorSnippet(details.source || "", line, column);
  errorBox.hidden = false;
  errorBox.innerHTML = `<strong>${escapeHtml(title)}</strong><span>${escapeHtml(message)}</span>${location}${snippet}`;
}

function analyzeCodingPracticeComplexity(code = "", languageId = "javascript") {
  const source = stripCodeStringsAndComments(code).replace(/\r\n/g, "\n");
  const lines = source.split("\n");
  let blockDepth = 0;
  let maxLoopDepth = 0;
  let loopCount = 0;

  if (languageId === "python") {
    // Python has no braces, so track loop nesting by indentation instead.
    const loopIndents = [];
    lines.forEach((line) => {
      if (!line.trim()) return;
      const indent = (line.match(/^\s*/)[0] || "").replace(/\t/g, "    ").length;
      while (loopIndents.length && indent <= loopIndents[loopIndents.length - 1]) loopIndents.pop();
      if (/^\s*(for|while)\b.*:\s*$/.test(line)) {
        loopIndents.push(indent);
        loopCount += 1;
        maxLoopDepth = Math.max(maxLoopDepth, loopIndents.length);
      }
    });
  } else {
    lines.forEach((line) => {
      const closeCount = (line.match(/}/g) || []).length;
      blockDepth = Math.max(0, blockDepth - closeCount);
      const loopsOnLine = (line.match(/\b(for|while)\s*\(/g) || []).length;
      if (loopsOnLine) {
        loopCount += loopsOnLine;
        maxLoopDepth = Math.max(maxLoopDepth, blockDepth + loopsOnLine);
      }
      const openCount = (line.match(/{/g) || []).length;
      blockDepth += openCount;
    });
  }

  const normalized = source.toLowerCase();
  const hasSorting = /\.(sort|sorted|sortedby|sorteddescending)\s*\(|\bpriorityqueue\b/.test(normalized);
  const hasHashStructure = /\b(set|map|dict|hashset|hashmap|mutablesetof|mutablemapof|setof|mapof|new\s+set|new\s+map)\b/.test(normalized);
  const hasArrayStructure = /\b(mutablelistof|arraylistof|intarray|arrayof|new\s+array|\[\s*\])\b/.test(normalized);
  const functionNames = [...source.matchAll(/\b(?:fun|function|def)\s+([A-Za-z_$][\w$]*)\s*\(/g)].map((match) => match[1]);
  const recursive = functionNames.some((name) => {
    const calls = source.match(new RegExp(`\\b${escapeRegExp(name)}\\s*\\(`, "g")) || [];
    return calls.length > 1;
  });

  let time = "O(1)";
  if (recursive && maxLoopDepth === 0) time = "Recursive";
  if (hasSorting) time = "O(n log n)";
  if (maxLoopDepth === 1 && !hasSorting) time = "O(n)";
  if (maxLoopDepth === 2) time = "O(n^2)";
  if (maxLoopDepth >= 3) time = `O(n^${maxLoopDepth})`;

  let space = "O(1)";
  if (hasHashStructure || hasArrayStructure || recursive) space = "O(n)";

  let level = "Simple";
  let tone = "neutral";
  if (/O\(n\^/.test(time) || time === "O(n^2)") {
    level = "Needs optimization review";
    tone = "warn";
  } else if (time === "O(n log n)") {
    level = "Good for sorting-based solutions";
    tone = "good";
  } else if (time === "O(n)") {
    level = hasHashStructure ? "Strong linear approach" : "Good linear approach";
    tone = "strong";
  } else if (time === "O(1)") {
    level = "Constant-time style";
    tone = "strong";
  } else if (recursive) {
    level = "Review recursion depth";
    tone = "warn";
  }

  const notes = [];
  if (maxLoopDepth >= 2) notes.push("Nested loops detected; check if a map/set can reduce repeated scanning.");
  if (hasSorting) notes.push("Sorting detected; explain why O(n log n) is acceptable or avoid it if linear is possible.");
  if (hasHashStructure) notes.push("Map/Set usage detected; usually good for fast lookup with extra memory.");
  if (recursive) notes.push("Recursive calls detected; consider stack depth and repeated subproblems.");
  if (!notes.length) notes.push("No heavy loop or sorting pattern detected by the browser analyzer.");

  return {
    languageId,
    time,
    space,
    level,
    tone,
    notes
  };
}

function renderCodingPracticeComplexity(complexity) {
  if (!complexity) return "";
  return `
    <article class="code-complexity-card is-${escapeAttr(complexity.tone || "neutral")}">
      <div>
        <span>Complexity estimate</span>
        <strong>Time ${escapeHtml(complexity.time)} � Space ${escapeHtml(complexity.space)}</strong>
      </div>
      <small>${escapeHtml(complexity.level)}</small>
      <p>${escapeHtml((complexity.notes || []).join(" "))}</p>
    </article>
  `;
}
function renderCodingPracticeLoadingState(title, note = "") {
  return `
    <div class="code-run-loading">
      <span class="code-run-spinner" aria-hidden="true"></span>
      <strong>${escapeHtml(title)}</strong>
      <span>${note}</span>
    </div>
  `;
}

function renderCodingPracticeRunResults(scope, item, results = [], complexity = null) {
  const output = scope?.querySelector("[data-code-output]");
  if (!output) return;
  const passedCount = results.filter((test) => test.passed).length;
  const allPassed = results.length > 0 && passedCount === results.length;

  if (allPassed && item?.slug) {
    const solved = getPracticeSolvedMap();
    if (!solved[item.slug]) {
      solved[item.slug] = new Date().toISOString();
      setPracticeSolvedMap(solved);
      updateCodingPracticeProgress(scope);
    }
  }

  const failingError = results.find((test) => test.error);
  if (failingError) {
    showCodingPracticeRunError(scope, "Runtime error", `${failingError.name}: ${failingError.error}`);
  }

  output.innerHTML = `
    <div class="code-run-summary ${allPassed ? "is-pass" : "is-fail"}">
      ${icon(allPassed ? "check-circle" : "x-circle", "code-run-summary-icon")}
      <strong>${allPassed ? "Accepted" : "Tests failed"}</strong>
      <span>${passedCount}/${results.length} passed</span>
    </div>
    ${renderCodingPracticeComplexity(complexity)}
    <div class="code-result-list">
      ${results.map((test, index) => `
        <article class="code-result-row ${test.passed ? "is-pass" : "is-fail"}">
          <div class="code-result-heading">
            ${icon(test.passed ? "check-circle" : "x-circle", "code-result-icon")}
            <strong>${escapeHtml(test.name || `Case ${index + 1}`)}</strong>
          </div>
          ${test.error ? `<span class="code-result-error">${escapeHtml(test.error)}</span>` : ""}
          <code>Expected: ${escapeHtml(formatCodingPracticeValue(test.expected))}</code>
          <code>Actual: ${escapeHtml(formatCodingPracticeValue(test.actual))}</code>
        </article>
      `).join("")}
    </div>
  `;
}

function updateCodingPracticeRunState(scope, language) {
  if (!scope || !language) return;
  const canRunInBrowser = canRunCodingPracticeLanguage(language);
  const runButton = scope.querySelector("[data-run-code]");
  if (runButton) {
    runButton.disabled = !canRunInBrowser;
    runButton.title = canRunInBrowser
      ? "Run all test cases in the browser"
      : `${language.label} compiler is disabled in free mode`;
    runButton.textContent = canRunInBrowser ? "Run tests" : "Practice only";
  }

  const output = scope.querySelector("[data-code-output]");
  if (output) {
    output.innerHTML = canRunInBrowser
      ? `<strong>Ready</strong><span>${escapeHtml(language.label)} selected. Run tests will validate all cases in the browser for free${language.id === "kotlin" ? ": collections, ranges, if-expressions, simple when branches, arrays, maps, sets, strings, and chars are supported" : ""}${language.beta ? " (beta)" : ""}.</span>`
      : `<strong>Free practice mode</strong><span>${escapeHtml(language.label)} is available for writing practice. To keep SkillUp free, only JavaScript and Kotlin run test cases in the browser right now.</span>`;
  }
}

function syncCodingPracticeHighlight(editor) {
  const shell = editor?.closest("[data-code-editor-shell]");
  const highlight = shell?.querySelector("[data-code-highlight]");
  const highlightWrap = shell?.querySelector("[data-code-highlight-wrap]");
  const language = editor?.closest("[data-coding-practice-scope]")?.querySelector("[data-code-language]")?.value || getCodingPracticeSavedLanguage();
  if (!editor || !highlight || !highlightWrap) return;
  highlight.innerHTML = `${highlightCodingPracticeCode(editor.value, language)}\n`;
  highlightWrap.scrollTop = editor.scrollTop;
  highlightWrap.scrollLeft = editor.scrollLeft;
}

function getCodingPracticeConstraints(item) {
  const customConstraints = toArray(item?.constraints).map((constraint) => String(constraint || "").trim()).filter(Boolean);
  if (customConstraints.length) return customConstraints;
  const base = [
    "Write readable code with clear variable names.",
    "Handle empty input or minimum-size input where it applies.",
    "Mention time complexity and space complexity after solving."
  ];
  if (item?.difficulty === "hard") return [...base, "Think through at least one optimized approach before coding."];
  if (item?.difficulty === "easy") return [...base, "First make it correct, then simplify the implementation."];
  return [...base, "Compare brute force and optimized approaches before finalizing."];
}

// SkillUp Class leads with AI. The home page presents this path in learning
// order. A step becomes a link once a public subject matching it has
// published tutorials; until then it reads "Coming soon" and is not a link,
// so nothing on the home page leads to an empty page.
const AI_ROADMAP_STEPS = [
  { id: "python", title: "Python for AI", icon: "code", match: /\bpython\b/i, body: "NumPy, pandas and the Python you use before any model." },
  { id: "machine-learning", title: "Machine Learning", icon: "trending-up", match: /machine learning|\bml\b|deep learning/i, body: "Regression, classification and how models learn from data." },
  { id: "nlp", title: "NLP", icon: "message-circle", match: /\bnlp\b|natural language/i, body: "Tokens, embeddings and working with text." },
  { id: "generative-ai", title: "Generative AI & LLMs", icon: "sparkles", match: /generative|\bgen ?ai\b|\bllms?\b|large language|prompt/i, body: "How large language models work, prompting and building with LLM APIs." },
  { id: "rag", title: "RAG", icon: "layers", match: /\brag\b|retrieval[- ]augmented/i, body: "Grounding LLM answers in your own documents with retrieval." },
  { id: "agentic-ai", title: "Agentic AI", icon: "compass", match: /agentic|\bai agents?\b/i, body: "Agents that plan, call tools and finish multi-step tasks." }
];

// Decides what counts as AI material for the AI-only home page. Callers pass
// titles, categories and tags, not bodies, so an Android course that
// mentions an AI API in its outline is still a mobile course.
const AI_TOPIC_PATTERN = /\b(ai|artificial intelligence|machine learning|ml|deep learning|neural networks?|nlp|natural language|llms?|large language models?|gen ?ai|generative|gpt|chatgpt|gemini|claude|rag|retrieval[- ]augmented|embeddings?|agentic|ai agents?|prompt engineering|computer vision|data science|python)\b/i;

function isAiContent(...parts) {
  return AI_TOPIC_PATTERN.test(parts.flat().filter(Boolean).join(" "));
}

function getAiRoadmap() {
  const subjects = getPublicSubjects();
  const tutorials = sortTutorials(getPublicTutorials());
  return AI_ROADMAP_STEPS.map((step) => {
    const subjectTitles = new Set(subjects.filter((subject) => step.match.test(subject.title)).map((subject) => subject.title));
    const stepTutorials = tutorials.filter((tutorial) => subjectTitles.has(tutorial.category));
    return {
      ...step,
      tutorialCount: stepTutorials.length,
      href: stepTutorials[0] ? `#tutorials/${encodeURIComponent(stepTutorials[0].id)}` : ""
    };
  });
}

function renderHomeAiRoadmap(roadmap, ready) {
  return `
    <section class="section-band home-ai-roadmap" id="ai-roadmap">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">AI roadmap</p>
          <h2 tabindex="-1">From Python to AI agents, one step at a time.</h2>
        </div>
        <p class="section-intro">Follow the tracks in order, or jump to the one you need. New tracks open here as their tutorials are published.</p>
      </div>
      <ol class="ai-roadmap-grid">
        ${roadmap.map((step, index) => {
          const live = ready && Boolean(step.href);
          const status = !ready
            ? "Loading..."
            : live
              ? `${step.tutorialCount} ${step.tutorialCount === 1 ? "tutorial" : "tutorials"} ${icon("arrow-right")}`
              : "Coming soon";
          const inner = `
            <span class="ai-roadmap-top">
              <span class="ai-roadmap-step">Step ${index + 1}</span>
              <span class="ai-roadmap-icon">${icon(step.icon)}</span>
            </span>
            <h3>${escapeHtml(step.title)}</h3>
            <p>${escapeHtml(step.body)}</p>
            <span class="ai-roadmap-status">${status}</span>
          `;
          return `
            <li class="ai-roadmap-card ${live ? "is-live" : "is-soon"}" data-reveal>
              ${live ? `<a href="${escapeAttr(step.href)}">${inner}</a>` : `<div>${inner}</div>`}
            </li>
          `;
        }).join("")}
      </ol>
    </section>
  `;
}

function renderHomePage() {
  // The home page teaches AI only. Mobile development and other material
  // stay in Courses, Tutorials and the Blog; nothing here promotes them.
  const showCourses = isPublicTabVisible("courses");
  const showTutorials = isPublicTabVisible("tutorials");
  const showBlogs = isPublicTabVisible("blog");
  const canReadLearning = canReadTutorials();
  const tutorialsReady = isPublicCollectionReady("articles");
  const aiCourses = showCourses
    ? getPublicCourses().filter((course) => isAiContent(course.title, course.category))
    : [];
  const aiTutorials = showTutorials && canReadLearning
    ? sortTutorials(getPublicTutorials().filter((tutorial) => isAiContent(tutorial.category)))
    : [];
  const aiBlogs = showBlogs
    ? getPublished(state.blogs).filter((blog) => isAiContent(blog.title, blog.category, toArray(blog.tags))).sort(sortNewest)
    : [];
  const roadmap = showTutorials && canReadLearning
    ? getAiRoadmap()
    : AI_ROADMAP_STEPS.map((step) => ({ ...step, tutorialCount: 0, href: "" }));
  const firstLiveStep = tutorialsReady ? roadmap.find((step) => step.href) : null;
  // "Show on home" puts an item first and the other AI items fill the
  // remaining places. Showing only flagged items meant one flagged RAG
  // tutorial hid the other two once the home page became AI-only.
  const pickForHome = (items, limit) => [...items.filter((item) => item.showOnHome), ...items.filter((item) => !item.showOnHome)].slice(0, limit);
  const homeCourses = pickForHome(aiCourses, 4);
  const homeTutorials = pickForHome(aiTutorials, 4);
  const homeBlogs = pickForHome(aiBlogs, 3);
  const featuredTutorial = aiTutorials.find((tutorial) => tutorial.featured) || aiTutorials[0];

  return `
    <section class="hero section-band">
      <img
        class="hero-background"
        src="/assets/skillup-tech-hero.webp"
        alt=""
        fetchpriority="high"
      />
      <div class="hero-shade" aria-hidden="true"></div>
      ${renderHomeSearchSection()}
      <div class="hero-copy" data-reveal>

        <p class="eyebrow">Learn AI by building</p>
        <h1>Learn AI the practical way, from <span class="text-gradient">Python to AI agents</span>.</h1>
        <p class="hero-text">
          Follow one clear roadmap through machine learning, NLP, generative AI, RAG and agentic AI, with hands-on tutorials that turn every concept into code you can explain.
        </p>
        <div class="hero-actions">
          <button class="button primary" type="button" data-scroll-to="ai-roadmap">Start the AI roadmap</button>
          ${firstLiveStep ? `<a class="button secondary" href="${escapeAttr(firstLiveStep.href)}">Read an AI tutorial</a>` : ""}
        </div>

      </div>
      <div class="hero-logo-badge" aria-hidden="true">
        <span class="hero-logo-orbit hero-logo-orbit--outer"></span>
        <span class="hero-logo-orbit hero-logo-orbit--inner"></span>
        <img src="/assets/skillup-logo.jpg" alt="" />
      </div>
      <div class="hero-scroll-cue" aria-hidden="true">
        <span></span>
        Explore the AI roadmap
      </div>
    </section>

    ${renderHomeContinueLearning()}
    ${renderHomeAiRoadmap(roadmap, tutorialsReady || !(showTutorials && canReadLearning))}

    ${renderHomeEventsHighlight()}

    ${renderHomeDifferentiators()}

    ${renderHomePromoBanner({
      image: "/assets/covers/ai-ml.webp",
      alt: "Artificial intelligence and machine learning",
      eyebrow: "AI & Machine Learning",
      heading: "Learn AI, GenAI, and Agentic AI with real code, not just theory.",
      body: "Work through real code, from datasets and models to prompting patterns and tool-using agents, as each track on the roadmap opens.",
      ctaLabel: "Explore AI tutorials",
      ctaHref: firstLiveStep ? firstLiveStep.href : "#tutorials"
    })}

    ${homeTutorials.length ? `
      <section class="section-band home-ai-tutorials">
        <div class="section-heading" data-reveal>
          <div>
            <p class="eyebrow">AI tutorials</p>
            <h2>Read, build, and keep moving.</h2>
          </div>
          ${firstLiveStep ? `<a class="section-link" href="${escapeAttr(firstLiveStep.href)}">Open the AI tutorials</a>` : ""}
        </div>
        <div class="article-rail">
          ${homeTutorials.map(renderTutorialPreviewCard).join("")}
        </div>
        ${
          featuredTutorial
            ? `<div class="reading-callout" data-reveal>
                <span>Featured tutorial</span>
                <strong>${escapeHtml(featuredTutorial.title)}</strong>
                <a href="#tutorials/${encodeURIComponent(featuredTutorial.id)}">Open tutorial</a>
              </div>`
            : ""
        }
      </section>
    ` : ""}

    ${renderHomeFeaturedVideo()}

    <section class="section-band outcome-band">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">How you learn</p>
          <h2>A clear path from curiosity to confidence.</h2>
        </div>
        <p class="section-intro">Every lesson moves you from understanding an AI concept to proving you can build with it, in projects and in interviews.</p>
      </div>
      <div class="outcome-grid">
        <article class="outcome-card" data-reveal>
          <span class="outcome-step">01</span>
          <i class="outcome-icon" aria-hidden="true">${icon("lightbulb")}</i>
          <h3>Understand the idea</h3>
          <p>Use structured articles and video lessons to learn the why before memorizing the how.</p>
        </article>
        <article class="outcome-card" data-reveal>
          <span class="outcome-step">02</span>
          <i class="outcome-icon" aria-hidden="true">${icon("compass")}</i>
          <h3>Practice with purpose</h3>
          <p>Connect each topic to working code, model choices, and realistic problems you may face at work.</p>
        </article>
        <article class="outcome-card" data-reveal>
          <span class="outcome-step">03</span>
          <i class="outcome-icon" aria-hidden="true">${icon("repeat")}</i>
          <h3>Revise with practice</h3>
          <p>Turn topics into quiz questions, notes, and progress tracking that closes your weak areas.</p>
        </article>
        <article class="outcome-card" data-reveal>
          <span class="outcome-step">04</span>
          <i class="outcome-icon" aria-hidden="true">${icon("award")}</i>
          <h3>Show what you know</h3>
          <p>Build portfolio evidence and turn technical knowledge into clear, interview-ready explanations.</p>
        </article>
      </div>
    </section>

    ${renderAdSlot("homeBanner", "horizontal", {
      // Marketing copy is not publisher content. Require actual published
      // items to have loaded and rendered above this point.
      hasContent: homeCourses.length + homeTutorials.length + homeBlogs.length >= 3
    })}

    <section class="section-band learning-strip">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">Guided learning</p>
          <h2>${homeCourses.length ? "AI courses" : "Guided AI courses are on the way."}</h2>
        </div>
        ${homeCourses.length ? `<a class="section-link" href="#courses">View all courses</a>` : ""}
      </div>
      ${
        homeCourses.length
          ? `<div class="program-grid home-course-grid">
              ${homeCourses.map((course, index) => renderCourseCard(course, index === 0)).join("")}
            </div>`
          : `<div class="course-launch-panel" data-reveal>
              <div>
                <span class="kicker">Start learning now</span>
                <h3>Start with the free AI tutorials while guided AI courses are prepared.</h3>
                <p>Follow the roadmap in order, and tell us which AI course you want first.</p>
              </div>
              <div class="course-launch-actions">
                <button class="button dark" type="button" data-scroll-to="ai-roadmap">Start the AI roadmap</button>
                ${isPublicTabVisible("inquiry") ? `<a class="button ghost" href="#inquiry">Request an AI course</a>` : ""}
              </div>
            </div>`
      }
    </section>

    ${homeBlogs.length ? `
      <section class="section-band home-blog-section">
        <div class="section-heading" data-reveal>
          <div>
            <p class="eyebrow">Latest blog</p>
            <h2>AI notes from SkillUp Class.</h2>
          </div>
          <a class="section-link" href="#blog">Read all posts</a>
        </div>
        <div class="blog-grid home-blog-grid">
          ${homeBlogs.map(renderBlogCard).join("")}
        </div>
      </section>
    ` : ""}

    ${renderHomeCommunityBand()}

    ${renderHomeTestimonials()}

    ${renderHomeFaqCta()}
  `;
}

function renderHomeDifferentiators() {
  // Every card describes something a visitor can actually open. The
  // interview practice card only shows while Coding Practice is switched
  // on - promising a hidden section is the same leak as linking to it.
  const cards = [
    isPublicTabVisible("tutorials") ? {
      icon: "book-open",
      title: "Free AI tutorials",
      body: "Every tutorial is free to read, with no signup and no paywall."
    } : null,
    isPublicTabVisible("tutorials") ? {
      icon: "compass",
      title: "A clear AI roadmap",
      body: "Tracks run in learning order from Python to AI agents, so you always know what to learn next."
    } : null,
    isPublicTabVisible("coding-practice") ? {
      icon: "target",
      title: "Interview-ready practice",
      body: "Coding problems are tagged by the companies that ask them, so you can practice with a real interview in mind."
    } : null,
    isPublicTabVisible("events") ? {
      icon: "calendar",
      title: "Live sessions and workshops",
      body: "Register free for live sessions and doubt-clearing calls. The meeting link appears on the event page once it is shared."
    } : null,
    {
      icon: "trending-up",
      title: "Progress that follows your account",
      body: "Completed topics and bookmarked tutorials are tied to your login, so you can pick up where you left off on any device."
    }
  ].filter(Boolean).slice(0, 4);

  return `
    <section class="section-band home-differentiators dark-band">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">Why SkillUp Class</p>
          <h2>Built for people who learn by doing.</h2>
        </div>
        <p class="section-intro">No fluff, no paywall on the tutorials, no guessing what to study next.</p>
      </div>
      <div class="home-differentiator-grid">
        ${cards.map((card) => `
          <article class="home-differentiator-card" data-reveal>
            <span class="home-differentiator-icon">${icon(card.icon)}</span>
            <h3>${escapeHtml(card.title)}</h3>
            <p>${escapeHtml(card.body)}</p>
          </article>
        `).join("")}
      </div>
    </section>
  `;
}

// Placeholder learner feedback shown with illustrated initials avatars (no photos).
// These are sample quotes, not submissions from real students - swap them out once
// real, consented testimonials (with a name and quote a learner has actually given
// permission to publish) are collected.
const HOME_TESTIMONIALS = [
  {
    name: "Ananya Iyer",
    track: "AI & Machine Learning",
    icon: "sparkles",
    quote: "The AI/ML tutorials connected the math to real code instead of leaving it abstract. That's what finally made gradient descent make sense to me."
  },
  {
    name: "Yash Malhotra",
    track: "Generative AI",
    icon: "message-circle",
    quote: "The GenAI lessons showed me how to actually use large language models in a project, not just call an API and hope the output is right."
  },
  {
    name: "Ritika Desai",
    track: "Agentic AI",
    icon: "compass",
    quote: "Learning how AI agents plan tasks, call tools, and work through multi-step problems finally made 'agentic AI' more than a buzzword for me."
  }
];

const AVATAR_PALETTE = [
  ["#6d5bff", "#a78bfa"],
  ["#0ea5a3", "#5eead4"],
  ["#f59e0b", "#fbbf24"],
  ["#ef4444", "#fca5a5"],
  ["#2563eb", "#93c5fd"],
  ["#db2777", "#f9a8d4"]
];

function getInitialsAvatarGradient(seed) {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}

function renderIllustratedAvatar(name) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const [from, to] = getInitialsAvatarGradient(name);
  return `
    <svg class="testimonial-avatar" viewBox="0 0 64 64" width="56" height="56" role="img" aria-label="${escapeAttr(name)}">
      <defs>
        <linearGradient id="avatar-${escapeAttr(slugify(name))}" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${from}" />
          <stop offset="100%" stop-color="${to}" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="32" fill="url(#avatar-${escapeAttr(slugify(name))})" />
      <text x="32" y="40" text-anchor="middle" font-size="22" font-weight="700" fill="#ffffff" font-family="inherit">${escapeHtml(initials)}</text>
    </svg>
  `;
}

function renderHomeTestimonials() {
  if (!HOME_TESTIMONIALS.length) return "";
  return `
    <section class="section-band home-testimonials" aria-label="Learner feedback">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">Learner feedback</p>
          <h2>What learners say about the AI tracks.</h2>
        </div>
        <p class="section-intro">Notes from people learning machine learning, generative AI and agentic AI on SkillUp Class.</p>
      </div>
      <div class="testimonial-grid">
        ${HOME_TESTIMONIALS.map((item) => `
          <article class="testimonial-card" data-reveal>
            <span class="testimonial-track-badge">${icon(item.icon)}<span>${escapeHtml(item.track)}</span></span>
            <p class="testimonial-quote">&ldquo;${escapeHtml(item.quote)}&rdquo;</p>
            <div class="testimonial-person">
              ${renderIllustratedAvatar(item.name)}
              <div>
                <strong>${escapeHtml(item.name)}</strong>
                <span>${escapeHtml(item.track)} learner</span>
              </div>
            </div>
          </article>
        `).join("")}
      </div>
    </section>
  `;
}

// Joins a list into readable prose: "a, b and c".
function joinWithAnd(items) {
  if (items.length <= 1) return items[0] || "";
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

// Nothing renders unless there is actually something on - a permanent
// empty "Events" band on the home page would be worse than no band.
function renderHomeEventsHighlight() {
  if (!isPublicTabVisible("events")) return "";

  // The home page is AI-only; every other event stays on the Events page.
  const live = getLiveEvents().filter((event) => isAiContent(event.title));
  const upcoming = getUpcomingEvents().filter((event) => !isLiveEvent(event) && isAiContent(event.title));
  const featured = [...live, ...upcoming].slice(0, 3);
  if (!featured.length) return "";

  return `
    <section class="section-band home-events-band ${live.length ? "has-live" : ""}">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">Events</p>
          <h2>${live.length ? "Happening right now." : "Coming up next."}</h2>
        </div>
        <a class="section-link" href="#events">See all events</a>
      </div>
      <div class="home-events-grid">
        ${featured.map((event) => {
          const isLive = isLiveEvent(event);
          return `
            <article class="home-event-card ${isLive ? "is-live" : ""}" data-reveal>
              <div class="home-event-top">
                ${isLive
                  ? `<span class="home-event-badge"><i aria-hidden="true"></i>Live now</span>`
                  : `<span class="home-event-date">${escapeHtml(formatEventDateTime(event.startAt))}</span>`}
                <span class="event-chip">${escapeHtml(renderEventModeLabel(event))}</span>
              </div>
              <h3>${escapeHtml(event.title)}</h3>
              ${isLive
                ? `<p class="home-event-when">Started ${escapeHtml(formatEventDateTime(event.startAt))}</p>`
                : ""}
              <p>${escapeHtml(summarizeFormattedText(event.description, 120) || "Details on the event page.")}</p>
              <a class="button ${isLive ? "primary" : "ghost"} small" href="#events/${encodeURIComponent(event.id)}">
                ${isLive ? "Join now" : "View and register"}
              </a>
            </article>
          `;
        }).join("")}
      </div>
    </section>
  `;
}

function renderHomeFeaturedVideo() {
  const embedUrl = getLoopingYouTubeEmbedUrl(HOME_FEATURE_VIDEO_URL);
  if (!embedUrl) return "";

  // Built from what is actually reachable - promising "coding practice" to
  // a student who has no way to open it is the same leak as showing a link.
  const blurbParts = joinWithAnd([
    isPublicTabVisible("tutorials") ? "practical tutorials" : "",
    isPublicTabVisible("coding-practice") ? "coding practice" : "",
    "interview-ready explanations"
  ].filter(Boolean));
  const points = [
    isPublicTabVisible("tutorials") ? "Visual lessons" : "",
    isPublicTabVisible("coding-practice") ? "Practice problems" : "",
    "Interview notes"
  ].filter(Boolean);

  return `
    <section class="section-band home-video-feature" aria-label="SkillUp Class featured YouTube video">
      <div class="home-video-card" data-reveal>
        <div class="home-video-copy">
          <p class="eyebrow">SkillUp on YouTube</p>
          <h2>Learn the lesson, then build it.</h2>
          <p>Watch a quick SkillUp Class preview with ${escapeHtml(blurbParts)} in one clean learning flow.</p>
          <div class="home-video-actions" aria-label="Featured video actions">
            <a class="button primary" href="${escapeAttr(HOME_FEATURE_VIDEO_URL)}" target="_blank" rel="noreferrer">Watch video</a>
            <a class="button secondary home-video-channel-button" href="${escapeAttr(SKILLUP_YOUTUBE_CHANNEL_URL)}" target="_blank" rel="noreferrer">Open YouTube channel</a>
          </div>
          <div class="home-video-points" aria-label="Learning flow highlights">
            ${points.map((point) => `<span>${escapeHtml(point)}</span>`).join("")}
          </div>
        </div>
        <div class="home-video-shell">
          <div class="home-video-glow" aria-hidden="true"></div>
          <div class="home-video-frame">
            <div class="home-video-toolbar">
              <span><i></i><i></i><i></i></span>
              <strong>Featured preview</strong>
              <a href="${escapeAttr(SKILLUP_YOUTUBE_CHANNEL_URL)}" target="_blank" rel="noreferrer">YouTube</a>
            </div>
            <div class="home-video-viewport">
              <iframe
                src="${escapeAttr(embedUrl)}"
                title="SkillUp Class featured learning video"
                loading="lazy"
                allow="autoplay; encrypted-media; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  `;
}

function renderHomePromoBanner({ image, alt, eyebrow, heading, body, ctaLabel, ctaHref, reverse = false }) {
  return `
    <section class="section-band home-promo-banner${reverse ? " is-reverse" : ""}">
      <div class="home-promo-media" data-reveal>
        <img src="${escapeAttr(image)}" alt="${escapeAttr(alt)}" loading="lazy" />
      </div>
      <div class="home-promo-copy" data-reveal>
        <p class="eyebrow">${escapeHtml(eyebrow)}</p>
        <h2>${escapeHtml(heading)}</h2>
        <p>${escapeHtml(body)}</p>
        <a class="button primary" href="${escapeAttr(ctaHref)}">${escapeHtml(ctaLabel)}</a>
      </div>
    </section>
  `;
}

// Replaces the "Popular tracks" tiles, which repeated the subject chips in
// the technology banner further down. Built from the sections that are
// switched on, so a hidden WhatsApp, Students Hub or YouTube tab never
// appears here either.
function renderHomeCommunityBand() {
  const cards = [
    isPublicTabVisible("whatsapp") ? {
      icon: "message-circle",
      tone: "whatsapp",
      title: "WhatsApp community",
      body: "Ask quick questions, get updates, and help each other between lessons, right from your phone. No account needed.",
      action: `<a class="button primary whatsapp-join-button" href="${escapeAttr(SKILLUP_WHATSAPP_COMMUNITY_URL)}" target="_blank" rel="noreferrer noopener">Join on WhatsApp</a>`
    } : null,
    isPublicTabVisible("community") ? {
      icon: "users",
      title: "Students Hub",
      body: "Share your ideas, post questions, and talk through what you are building with other SkillUp students.",
      action: `<a class="button ghost" href="#community">Open the Students Hub</a>`
    } : null,
    isPublicTabVisible("youtube") ? {
      icon: "play-circle",
      title: "YouTube channel",
      body: "Watch practical lessons and walkthroughs, then come back to the tutorial and build it yourself.",
      action: `<a class="button ghost" href="${escapeAttr(SKILLUP_YOUTUBE_CHANNEL_URL)}" target="_blank" rel="noreferrer noopener">Watch on YouTube</a>`
    } : null
  ].filter(Boolean);

  if (!cards.length) return "";

  return `
    <section class="section-band home-community-band">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">Learn together</p>
          <h2>You don't have to learn alone.</h2>
        </div>
        <p class="section-intro">Ask questions, share ideas, and keep learning between lessons with other students.</p>
      </div>
      <div class="home-community-grid">
        ${cards.map((card) => `
          <article class="home-community-card${card.tone ? ` is-${card.tone}` : ""}" data-reveal>
            <span class="home-community-icon">${icon(card.icon)}</span>
            <h3>${escapeHtml(card.title)}</h3>
            <p>${escapeHtml(card.body)}</p>
            <div class="home-community-action">${card.action}</div>
          </article>
        `).join("")}
      </div>
    </section>
  `;
}

function renderHomeFaqCta() {
  const faqs = [
    { q: "Do I need an AI or maths background?", a: "No. The roadmap starts with Python and builds up to machine learning, generative AI and AI agents one step at a time." },
    { q: "Can I learn only from free tutorials?", a: "Yes. Start with tutorials and use courses only when you want guided help or a structured paid path." },
    { q: "Can I track my progress?", a: "Yes. Log in with a student account and your completed topics and bookmarked tutorials are saved to your profile, so progress follows you across devices." },
    { q: "Can I request an AI course?", a: "Yes. Use the course inquiry form and tell us your goal, your current level and the AI topic you want to learn." }
  ];

  return `
    <section class="section-band home-faq-cta">
      <div class="home-faq-panel" data-reveal>
        <div>
          <span class="kicker">Student questions</span>
          <h2>Need a clearer path?</h2>
          <p>Search the library, follow the AI roadmap, or send an inquiry when you want personal direction.</p>
          <div class="home-faq-actions">
            <a class="button primary" href="#inquiry">Send course inquiry</a>
            <button class="button ghost" type="button" data-scroll-to="ai-roadmap">View the AI roadmap</button>
          </div>
        </div>
        <div class="home-faq-list">
          ${faqs.map((faq) => `
            <details>
              <summary>${escapeHtml(faq.q)}</summary>
              <p>${escapeHtml(faq.a)}</p>
            </details>
          `).join("")}
        </div>
      </div>
    </section>
  `;
}
function renderCoursesPage() {
  const coursesReady = isPublicCollectionReady("tutorials");
  const courses = getPublicCourses();
  const categories = getCategories(courses);

  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Course catalog</p>
      <h1>Choose a focused path toward your next tech outcome.</h1>
    </section>
    <section class="section-band" data-filter-scope>
      <div class="toolbar" data-reveal>
        <label>
          <span>Search</span>
          <input type="search" data-live-search placeholder="Search courses" />
        </label>
        <label>
          <span>Category</span>
          <select data-live-category>
            <option value="all">All categories</option>
            ${categories.map((category) => `<option value="${escapeAttr(category)}">${escapeHtml(category)}</option>`).join("")}
          </select>
        </label>
      </div>
      ${renderCourseCategoryChips(courses, categories)}
      ${renderAdSlot("coursesBanner", "horizontal", {
        // This sits above the grid, so it would otherwise show against
        // "Loading courses..." and against an empty catalogue.
        hasContent: coursesReady && courses.length >= 3
      })}
      <div class="program-grid">
        ${courses.map((course) => renderCourseCard(course)).join("") || renderEmptyState(coursesReady ? "No courses are published yet." : "Loading courses...")}
      </div>
      <p class="filter-empty" data-filter-empty>No matching courses found.</p>
    </section>
  `;
}

function renderCourseDetailsPage(id = "") {
  const coursesReady = isPublicCollectionReady("tutorials");
  const courses = getPublicCourses();
  const course = courses.find((item) => item.id === id || item.slug === id);

  if (!course) {
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Course details</p>
        <h1>${coursesReady ? "Course not found." : "Loading course..."}</h1>
        <p>${coursesReady ? "This course may be unpublished or removed." : "Please wait while SkillUp Class loads the course catalog."}</p>
        <a class="button primary" href="#courses">Back to courses</a>
      </section>
    `;
  }

  const relatedCourses = courses
    .filter((item) => item.id !== course.id && item.category === course.category)
    .slice(0, 3);
  const topics = toArray(course.topics);
  const coverUrl = safeUrl(course.coverImage) || getCategoryFallbackCover(course.category, course.title);

  return `
    <section class="course-detail-hero section-band dark-band">
      <div class="course-detail-copy" data-reveal>
        <p class="eyebrow">${escapeHtml(course.category || "Course")}</p>
        <h1>${escapeHtml(course.title)}</h1>
        <p>${escapeHtml(course.description)}</p>
        ${renderCoursePrice(course)}
        <div class="course-detail-meta">
          <span><small>Level</small><strong>${escapeHtml(course.level || "Beginner")}</strong></span>
          <span><small>Duration</small><strong>${escapeHtml(course.duration || "Self paced")}</strong></span>
          <span><small>Mode</small><strong>Online guidance</strong></span>
        </div>
        <div class="course-detail-actions">
          <a class="button primary" href="#inquiry">Send course inquiry</a>
          <a class="button secondary" href="#courses">All courses</a>
        </div>
      </div>
      <div class="course-detail-media${coverUrl ? " has-cover" : ""}" data-reveal>
        ${coverUrl ? `<img src="${escapeAttr(coverUrl)}" alt="${escapeAttr(course.title)}" data-managed-image />` : `<img src="/assets/skillup-logo.jpg" alt="" />`}
      </div>
    </section>
    <section class="section-band course-detail-body">
      <article class="course-detail-panel" data-reveal>
        <span class="kicker">What you will achieve</span>
        <h2>Course outcome</h2>
        <div class="formatted-text course-outcome">${renderFormattedText(course.outcome || "Build practical confidence through structured lessons and guided practice.")}</div>
      </article>
      <article class="course-detail-panel" data-reveal>
        <span class="kicker">Topics covered</span>
        <h2>Learning roadmap</h2>
        ${topics.length
          ? `<div class="course-topic-list course-topic-list--large">${topics.map((topic) => `<span>${escapeHtml(topic)}</span>`).join("")}</div>`
          : `<p>Topics will be updated soon.</p>`}
      </article>
      ${relatedCourses.length ? `
        <div class="section-heading" data-reveal>
          <div>
            <p class="eyebrow">Related courses</p>
            <h2>Continue exploring this path.</h2>
          </div>
        </div>
        <div class="program-grid">
          ${relatedCourses.map((item) => renderCourseCard(item)).join("")}
        </div>
      ` : ""}
    </section>
  `;
}

function renderCodingPracticePage(id = "") {
  const items = getCodingPracticeItems();
  const solved = getPracticeSolvedMap();
  const companies = [...new Set(items.flatMap((item) => item.companies || []))].sort((a, b) => a.localeCompare(b));

  if (!id) {
    return renderCodingPracticeListPage(items, solved, companies);
  }

  const selected = getCodingPracticeItemBySlug(id);
  if (!selected) {
    return `
      <section class="coding-practice-shell section-band">
        <div class="empty-state">
          <p class="eyebrow">Coding Practice</p>
          <h1>Problem not found.</h1>
          <p>The selected challenge is no longer available. Return to the problem list and choose another one.</p>
          <a class="button primary" href="#coding-practice">Back to Coding Practice</a>
        </div>
      </section>
    `;
  }

  const selectedLanguage = getCodingPracticeLanguage(getCodingPracticeSavedLanguage());
  const activeCode = getCodingPracticeSavedCode(selected.slug, selectedLanguage.id) || getCodingPracticeStarterCode(selected, selectedLanguage.id);
  return renderCodingPracticeEditorScreen(selected, selectedLanguage, activeCode, solved);
}

function renderCodingPracticeListPage(items, solved = {}, companies = []) {
  const typeOptions = getCodingPracticeFilterOptions(items, "kind", "types");
  const difficultyOptions = getCodingPracticeFilterOptions(items, "difficulty", "difficulties");
  return `
    <section class="coding-practice-shell coding-practice-list-screen section-band" data-coding-practice-scope>
      <div class="coding-practice-dashboard" data-reveal>
        <div class="coding-practice-dashboard-hero">
          <div>
            <p class="eyebrow">Problem list</p>
            <h1>Coding Practice</h1>
            <p>Pick a challenge from any practice type. The next screen opens a focused code editor with test cases and run results.</p>
          </div>
          ${renderCodingLeaderboard()}
        </div>

        <div class="practice-filters coding-practice-filters coding-practice-dashboard-filters">
          <label>
            <span>Search</span>
            <input type="search" data-coding-practice-search placeholder="Search problems..." />
          </label>
          <label>
            <span>Type</span>
            <select data-coding-practice-kind>
              <option value="all">All types</option>
              ${typeOptions.map((option) => `<option value="${escapeAttr(option.id)}">${escapeHtml(option.label)}</option>`).join("")}
            </select>
          </label>
          <label>
            <span>Difficulty</span>
            <select data-coding-practice-difficulty>
              <option value="all">All difficulty</option>
              ${difficultyOptions.map((option) => `<option value="${escapeAttr(option.id)}">${escapeHtml(option.label)}</option>`).join("")}
            </select>
          </label>
          <label>
            <span>Company</span>
            <select data-coding-practice-company>
              <option value="all">All companies</option>
              ${companies.map((company) => `<option value="${escapeAttr(company.toLowerCase())}">${escapeHtml(company)}</option>`).join("")}
            </select>
          </label>
          <label>
            <span>Status</span>
            <select data-coding-practice-status>
              <option value="all">All status</option>
              <option value="solved">Solved</option>
              <option value="unsolved">Unsolved</option>
            </select>
          </label>
        </div>

        <div class="coding-practice-dashboard-list">
          ${renderCodingPracticeList(items, "", solved)}
        </div>
        <p class="filter-empty" data-coding-practice-empty>No matching coding practice items found.</p>
      </div>
    </section>
  `;
}

function renderCodingPracticeEditorScreen(item, language, code, solved = {}) {
  return `
    <section class="coding-practice-shell coding-practice-editor-screen section-band" data-coding-practice-scope data-active-practice="${escapeAttr(item.slug)}">
      <div class="coding-practice-runner-topbar" data-reveal>
        <a class="button secondary small" href="#coding-practice">Back to problems</a>
        <div>
          <p class="eyebrow">${escapeHtml(item.kindLabel)} / ${escapeHtml(item.category)}</p>
          <h1>${escapeHtml(item.title)}</h1>
        </div>
      </div>

      <div class="coding-practice-runner-layout" data-reveal>
        ${renderCodingPracticeStatement(item, solved)}
        ${renderCodingPracticeEditor(item, language, code)}
      </div>
    </section>
  `;
}

function renderCodingPracticeList(items, selectedSlug, solved = {}) {
  const groups = new Map();
  items.forEach((item) => {
    const key = `${item.kindLabel}: ${item.category}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });

  return [...groups.entries()].map(([title, groupItems], index) => `
    <details class="coding-practice-group" data-coding-practice-group ${index === 0 ? "open" : ""}>
      <summary>
        <span>${escapeHtml(title)}</span>
        <small class="coding-practice-group-cue" aria-hidden="true">+</small>
      </summary>
      <div class="coding-practice-group-list">
        ${groupItems.map((item) => renderCodingPracticeRow(item, selectedSlug, solved)).join("")}
      </div>
    </details>
  `).join("");
}

function renderCodingPracticeRow(item, selectedSlug, solved = {}) {
  const isSolved = Boolean(solved[item.slug]);
  const isActive = item.slug === selectedSlug;
  const companies = toArray(item.companies);
  const companyText = companies.map((company) => company.toLowerCase()).join(",");
  return `
    <button
      class="coding-practice-row ${isActive ? "is-active" : ""} ${isSolved ? "is-solved" : ""}"
      type="button"
      data-coding-practice-row
      data-coding-practice-item="${escapeAttr(item.slug)}"
      data-slug="${escapeAttr(item.slug)}"
      data-kind="${escapeAttr(item.kind)}"
      data-difficulty="${escapeAttr(item.difficulty)}"
      data-company="${escapeAttr(companyText)}"
      data-search="${escapeAttr(item.searchText)}"
    >
      <span class="coding-practice-status" aria-hidden="true">${isSolved ? "&#10003;" : ""}</span>
      <span class="coding-practice-row-title">
        <strong>${escapeHtml(item.title)}</strong>
        <small>${escapeHtml(item.category)}</small>
      </span>
      <span class="difficulty-badge difficulty-${escapeAttr(item.difficulty)}">${escapeHtml(item.difficultyLabel || getCodingDifficultyLabel(item.difficulty))}</span>
    </button>
  `;
}

function renderCodingPracticeStatement(item, solved = {}) {
  const testCases = getCodingPracticeTestCases(item);
  const constraints = getCodingPracticeConstraints(item);
  const companies = toArray(item.companies);
  const isSolved = Boolean(solved[item.slug]);
  return `
    <article class="coding-practice-statement coding-practice-problem-panel">
      <div class="coding-practice-title-row">
        <div>
          <p class="eyebrow">Problem</p>
          <h2>${escapeHtml(item.title)}</h2>
        </div>
        <button class="practice-check coding-practice-solved-button ${isSolved ? "is-done" : ""}" type="button" data-practice-solved="${escapeAttr(item.slug)}" aria-pressed="${isSolved ? "true" : "false"}">${isSolved ? "Solved" : "Mark solved"}</button>
      </div>
      <div class="coding-practice-meta">
        <span class="difficulty-badge difficulty-${escapeAttr(item.difficulty)}">${escapeHtml(item.difficultyLabel || getCodingDifficultyLabel(item.difficulty))}</span>
        <span>${escapeHtml(item.kindLabel)}</span>
        ${companies.length ? companies.map((company) => `<span>${escapeHtml(company)}</span>`).join("") : `<span>General practice</span>`}
      </div>
      <section>
        <h3>Problem statement</h3>
        <p>${escapeHtml(getCodingPracticePrompt(item))}</p>
      </section>
      <section>
        <h3>Test cases</h3>
        ${renderCodingPracticeTestCases(testCases)}
      </section>
      <section>
        <h3>Checklist</h3>
        <ul class="coding-practice-checklist">
          ${constraints.map((constraint) => `<li>${escapeHtml(constraint)}</li>`).join("")}
        </ul>
      </section>
    </article>
  `;
}

function renderCodingPracticeTestCases(testCases = []) {
  return `
    <div class="coding-testcase-list">
      ${testCases.map((testCase, index) => `
        <article class="coding-testcase-card" data-test-case-card="${index}">
          <div>
            <strong>${escapeHtml(testCase.name || `Case ${index + 1}`)}</strong>
            ${testCase.note ? `<span>${escapeHtml(testCase.note)}</span>` : ""}
          </div>
          <dl>
            <dt>Input</dt>
            <dd><pre>${escapeHtml(formatCodingPracticeValue(testCase.input))}</pre></dd>
            <dt>Expected</dt>
            <dd><pre>${escapeHtml(formatCodingPracticeValue(testCase.expected))}</pre></dd>
          </dl>
        </article>
      `).join("")}
    </div>
  `;
}

function renderCodingPracticeEditor(item, language, code) {
  return `
    <section class="coding-practice-editor-panel" aria-label="Code editor">
      <div class="code-editor-toolbar">
        <label>
          <span>Language</span>
          <select data-code-language>
            ${CODING_PRACTICE_LANGUAGES.map((option) => `<option value="${escapeAttr(option.id)}" ${option.id === language.id ? "selected" : ""}>${escapeHtml(option.label)}${option.runner === "browser" ? " - runs free" : " - practice only"}</option>`).join("")}
          </select>
        </label>
        <span class="code-editor-file" data-code-extension>Main.${escapeHtml(language.extension)}</span>
        <div class="code-editor-actions">
          <button class="button secondary small kotlin-playground-button" type="button" data-open-kotlin-playground ${language.id === "kotlin" ? "" : "hidden"}>Open in Kotlin Playground</button>
          <button class="button ghost small" type="button" data-reset-code>Reset</button>
          <button class="button primary small" type="button" data-run-code title="Run all test cases" ${canRunCodingPracticeLanguage(language) ? "" : "disabled"}>${canRunCodingPracticeLanguage(language) ? "Run tests" : "Practice only"}</button>
        </div>
      </div>
      <div class="code-editor-shell" data-code-editor-shell>
        <pre class="code-highlight" data-code-highlight-wrap aria-hidden="true"><code data-code-highlight>${highlightCodingPracticeCode(code, language.id)}</code></pre>
        <textarea class="code-editor" data-code-editor data-code-item="${escapeAttr(item.slug)}" spellcheck="false" autocomplete="off" autocapitalize="off" rows="20" wrap="off">${escapeHtml(code)}</textarea>
      </div>
      <div class="code-error-box" data-code-error hidden></div>
      <div class="code-console" data-code-output>
        <strong>Ready</strong>
        <span>${language.runner === "browser" ? `${escapeHtml(language.label)} can run all test cases in the browser for free${language.id === "kotlin" ? ": collections, ranges, if-expressions, simple when branches, arrays, maps, sets, strings, and chars are supported" : ""}${language.beta ? " (beta)" : ""}.` : `${escapeHtml(language.label)} is available for writing practice. Run tests with JavaScript or Kotlin in free mode.`}</span>
      </div>
    </section>
  `;
}

function renderPracticeTopic(topic, solved = {}, open = false) {
  return `
    <details class="practice-topic" data-practice-group ${open ? "open" : ""} data-reveal>
      <summary>
        <span>${escapeHtml(topic.title)}</span>
        <small>${topic.problems.length} problems</small>
      </summary>
      <div class="practice-table-wrap">
        <table class="practice-table">
          <tbody>
            ${topic.problems.map((problem) => renderPracticeProblemRow(problem, topic.title, solved)).join("")}
          </tbody>
        </table>
      </div>
    </details>
  `;
}

function renderPracticeProblemRow(problem, topicTitle, solved = {}) {
  const slug = slugify(`${topicTitle}-${problem.title}`);
  const difficulty = String(problem.difficulty || "medium").toLowerCase();
  const companies = toArray(problem.companies);
  const isSolved = Boolean(solved[slug]);
  const searchText = [problem.title, topicTitle, problem.difficulty, ...companies].join(" ").toLowerCase();

  return `
    <tr
      data-practice-row
      data-slug="${escapeAttr(slug)}"
      data-title="${escapeAttr(problem.title.toLowerCase())}"
      data-difficulty="${escapeAttr(difficulty)}"
      data-company="${escapeAttr(companies.map((company) => company.toLowerCase()).join(","))}"
      data-search="${escapeAttr(searchText)}"
    >
      <td class="practice-check-cell">
        <button class="practice-check ${isSolved ? "is-done" : ""}" type="button" data-practice-solved="${escapeAttr(slug)}" aria-label="Toggle ${escapeAttr(problem.title)} solved">${isSolved ? "&#10003;" : ""}</button>
      </td>
      <td>
        <strong>${escapeHtml(problem.title)}</strong>
        ${companies.length ? `<div class="practice-companies">${companies.map((company) => `<span>${escapeHtml(company)}</span>`).join("")}</div>` : ""}
      </td>
      <td class="practice-difficulty-cell"><span class="difficulty-badge difficulty-${escapeAttr(difficulty)}">${escapeHtml(capitalize(difficulty))}</span></td>
    </tr>
  `;
}

function renderCodingRoundCategory(category, open = false) {
  return `
    <details class="practice-topic coding-round-category" data-coding-group ${open ? "open" : ""} data-reveal>
      <summary>
        <span>${escapeHtml(category.title)}</span>
        <small>${category.programs.length} programs</small>
      </summary>
      <div class="practice-table-wrap">
        <table class="practice-table coding-table">
          <tbody>
            ${category.programs.map((program) => renderCodingRoundRow(program, category.title)).join("")}
          </tbody>
        </table>
      </div>
    </details>
  `;
}

function renderCodingRoundRow(program, categoryTitle) {
  const difficulty = String(program.difficulty || "medium").toLowerCase();
  const searchText = [program.title, categoryTitle, difficulty].join(" ").toLowerCase();
  return `
    <tr data-coding-row data-title="${escapeAttr(program.title.toLowerCase())}" data-difficulty="${escapeAttr(difficulty)}" data-search="${escapeAttr(searchText)}">
      <td><strong>${escapeHtml(program.title)}</strong><small>${escapeHtml(categoryTitle)}</small></td>
      <td class="practice-difficulty-cell"><span class="difficulty-badge difficulty-${escapeAttr(difficulty)}">${escapeHtml(capitalize(difficulty))}</span></td>
    </tr>
  `;
}
// Rules a student agrees to before joining, and the warning shown when a
// draft post trips the spam heuristics.
function renderCommunityPolicyPanel(communityId) {
  const policy = getCommunityPolicy();
  const lines = policy.body.split("\n").map((line) => line.trim()).filter(Boolean);

  return `
    <div class="community-policy-panel">
      <p class="eyebrow">Before you join</p>
      <h3>Community rules</h3>
      <ul class="community-policy-list">
        ${lines.map((line) => `<li>${escapeHtml(line)}</li>`).join("")}
      </ul>
      <button class="button primary small" type="button" data-accept-community-policy="${escapeAttr(communityId)}">
        I agree - join community
      </button>
    </div>
  `;
}

function renderBlockedNotice(area) {
  const record = state.blockedRecord;
  const reason = String(record?.reason || "").trim();
  return `
    <div class="moderation-blocked-notice">
      <strong>${area === "events" ? "You can't register for events right now." : `You can't post ${area === "community" ? "in communities" : "comments"} right now.`}</strong>
      <span>An admin has restricted your account.${reason ? ` Reason: ${escapeHtml(reason)}` : ""}</span>
    </div>
  `;
}

function renderSuspiciousWarning(scopeKey, draft) {
  const analysis = analysePostContent(draft);
  if (!analysis.suspicious) return "";

  return `
    <div class="suspicious-warning" data-suspicious-warning>
      <strong>This looks like it might break the community rules.</strong>
      <p>We spotted ${escapeHtml(analysis.reasons.join(", "))}. Posts promoting products or sharing contact details can be removed, and repeated attempts can get your account blocked.</p>
      <div class="suspicious-warning-actions">
        <button class="button ghost small" type="button" data-suspicious-edit="${escapeAttr(scopeKey)}">Edit post</button>
        <button class="button danger small" type="button" data-suspicious-continue="${escapeAttr(scopeKey)}">Post anyway</button>
      </div>
    </div>
  `;
}

function renderDiscussionSection(contentType, contentId, contentTitle) {
  if (!contentId) return "";

  const key = getDiscussionKey(contentType, contentId);
  const isLoading = state.discussionLoading.has(key);
  const loadError = state.discussionError[key];
  const allComments = state.discussionComments[key] || [];
  const topLevel = allComments.filter((comment) => !comment.parentId);
  const repliesByParent = new Map();
  allComments.forEach((comment) => {
    if (!comment.parentId) return;
    if (!repliesByParent.has(comment.parentId)) repliesByParent.set(comment.parentId, []);
    repliesByParent.get(comment.parentId).push(comment);
  });

  const canInteract = hasStudentProgressSync();
  const context = { canInteract, replyTargetId: state.discussionReplyTarget[key] || "" };
  const commentCountLabel = allComments.length
    ? `${allComments.length} ${allComments.length === 1 ? "comment" : "comments"}`
    : "Be the first to comment";

  return `
    <section class="discussion-section" data-discussion-scope data-content-type="${escapeAttr(contentType)}" data-content-id="${escapeAttr(contentId)}" data-content-title="${escapeAttr(contentTitle)}" data-reveal>
      <div class="discussion-heading">
        <h3>${icon("message-circle")}<span>Discussion</span></h3>
        <span class="discussion-count">${escapeHtml(commentCountLabel)}</span>
      </div>

      ${canInteract && isBlockedFromArea("tutorials") ? renderBlockedNotice("tutorials") : ""}

      ${canInteract && !isBlockedFromArea("tutorials") ? `
        <form class="discussion-composer" data-discussion-form>
          <textarea name="body" placeholder="Ask a question or share what helped you..." maxlength="2000" required>${escapeHtml(state.pendingSuspicious[getDiscussionKey(contentType, contentId)] || "")}</textarea>
          ${renderSuspiciousWarning(getDiscussionKey(contentType, contentId), state.pendingSuspicious[getDiscussionKey(contentType, contentId)] || "")}
          <div class="discussion-composer-actions">
            <button class="button primary small" type="submit">Post comment</button>
          </div>
        </form>
      ` : canInteract ? "" : `
        <div class="discussion-login-prompt">
          <p>Login as a student to join the discussion.</p>
          <a class="button primary small" href="#profile">Login</a>
        </div>
      `}

      ${loadError ? `
        <p class="form-error discussion-error">
          <span>${escapeHtml(loadError)}</span>
          <button type="button" class="link-button" data-retry-discussion>Retry</button>
        </p>
      ` : ""}

      <div class="discussion-list">
        ${isLoading && !allComments.length ? `<p class="discussion-status">Loading discussion...</p>` : ""}
        ${!isLoading && !loadError && !topLevel.length ? `<p class="discussion-status">No comments yet. Start the conversation.</p>` : ""}
        ${topLevel.map((comment) => renderDiscussionComment(comment, repliesByParent.get(comment.id) || [], context, true)).join("")}
      </div>
    </section>
  `;
}

function renderDiscussionComment(comment, replies, context, allowReply, parent = null) {
  const { canInteract, replyTargetId } = context;
  const isOwn = Boolean(state.user && comment.authorUid === state.user.uid);
  const canModerate = state.isAdmin || isOwn;
  const hasFlagged = Boolean(state.user && comment.flaggedBy.includes(state.user.uid));

  return `
    <article class="discussion-comment" data-comment-id="${escapeAttr(comment.id)}">
      <span class="discussion-avatar">${escapeHtml(getInitials(comment.authorName))}</span>
      <div class="discussion-comment-body">
        <div class="discussion-comment-meta">
          <strong>${escapeHtml(comment.authorName)}</strong>
          <small>${escapeHtml(formatRelativeTime(comment.createdAt))}</small>
          ${parent?.acceptedReplyId === comment.id ? `<span class="accepted-answer-badge">Accepted answer</span>` : ""}
        </div>
        <p>${escapeHtml(comment.body)}</p>
        <div class="discussion-comment-actions">
          ${renderHelpfulControl(comment, canInteract, isOwn, `data-vote-comment="${escapeAttr(comment.id)}" data-content-type="${escapeAttr(comment.contentType)}" data-content-id="${escapeAttr(comment.contentId)}"`)}
          ${renderAcceptControl(comment, parent, `data-accept-comment="${escapeAttr(comment.id)}" data-thread-id="${escapeAttr(parent?.id || "")}" data-content-type="${escapeAttr(comment.contentType)}" data-content-id="${escapeAttr(comment.contentId)}"`)}
          ${canInteract && allowReply ? `<button type="button" data-reply-comment="${escapeAttr(comment.id)}">Reply</button>` : ""}
          ${canInteract && !isOwn ? `<button type="button" data-flag-comment="${escapeAttr(comment.id)}" ${hasFlagged ? "disabled" : ""}>${hasFlagged ? "Reported" : "Report"}</button>` : ""}
          ${canModerate ? `<button type="button" class="is-danger" data-delete-comment="${escapeAttr(comment.id)}">Delete</button>` : ""}
        </div>
        ${replyTargetId === comment.id ? `
          <form class="discussion-reply-form" data-discussion-reply-form data-parent-id="${escapeAttr(comment.id)}">
            <textarea name="body" placeholder="Write a reply..." maxlength="2000" required></textarea>
            <div class="discussion-composer-actions">
              <button class="button ghost small" type="button" data-cancel-reply>Cancel</button>
              <button class="button primary small" type="submit">Post reply</button>
            </div>
          </form>
        ` : ""}
        ${replies.length ? `
          <div class="discussion-replies">
            ${sortThreadReplies(replies, comment).map((reply) => renderDiscussionComment(reply, [], context, false, comment)).join("")}
          </div>
        ` : ""}
      </div>
    </article>
  `;
}

// Open to everyone - no login, no membership check. That was a deliberate
// call: a WhatsApp invite link is shareable by nature, so gating the page
// that shows it would only add friction without adding any protection.
// The glyph is written inline rather than via icon(), which renders
// stroke-only outlines and would lose the solid WhatsApp mark.
const WHATSAPP_GLYPH = '<svg class="whatsapp-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.9-4.45 9.91-9.91a9.86 9.86 0 0 0-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.13h-.01a8.23 8.23 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.36c0-4.54 3.7-8.23 8.25-8.23a8.2 8.2 0 0 1 8.24 8.24c0 4.54-3.7 8.23-8.24 8.23Z"/><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.49.71.3 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z"/></svg>';

const WHATSAPP_HIGHLIGHTS = [
  {
    icon: "sparkles",
    title: "Share your ideas",
    body: "Post what you're building, share a resource that helped you, or think out loud about an approach before you commit to it."
  },
  {
    icon: "message-circle",
    title: "Ask on the go",
    body: "Stuck on a bug or a concept at 11pm? Drop it in the group and get a hand from students working on exactly the same thing."
  },
  {
    icon: "trending-up",
    title: "Hear it first",
    body: "New tutorials, courses, and coding practice sets get announced in the group before they show up anywhere else."
  },
  {
    icon: "flag",
    title: "Same rules as the hub",
    body: "No promotions, referral links, or swapping contact details. Keep it about learning and everyone gets more out of it."
  }
];

function renderWhatsappJoinButton(label = "Join WhatsApp community", variant = "primary") {
  return `
    <a
      class="button ${escapeAttr(variant)} whatsapp-join-button"
      href="${escapeAttr(SKILLUP_WHATSAPP_COMMUNITY_URL)}"
      target="_blank"
      rel="noreferrer noopener"
    >
      ${WHATSAPP_GLYPH}
      <span>${escapeHtml(label)}</span>
    </a>
  `;
}

function renderWhatsappPage() {
  return `
    <section class="page-title section-band dark-band slim whatsapp-hero">
      <p class="eyebrow">WhatsApp</p>
      <h1>Keep the conversation going on WhatsApp.</h1>
      <p>The SkillUp Class WhatsApp community is where students ask quick questions, share their ideas, and help each other out between lessons - straight from your phone. Everyone is welcome, and you don't need an account to join.</p>
      <div class="whatsapp-hero-actions">
        ${renderWhatsappJoinButton("Join WhatsApp community")}
        <a class="button ghost" href="#community">Browse the Students Hub</a>
      </div>
      <p class="whatsapp-hero-note">Opens WhatsApp in a new tab. No login needed.</p>
    </section>
    <section class="section-band">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">What happens inside</p>
          <h2>A place to ask, share, and keep learning.</h2>
        </div>
      </div>
      <div class="home-feature-grid">
        ${WHATSAPP_HIGHLIGHTS.map((item) => `
          <article class="home-feature-card" data-reveal>
            <span>${icon(item.icon)}</span>
            <h3>${escapeHtml(item.title)}</h3>
            <p>${escapeHtml(item.body)}</p>
          </article>
        `).join("")}
      </div>
    </section>
    <section class="section-band">
      <div class="whatsapp-join-panel" data-reveal>
        <div>
          <h2>Ready when you are.</h2>
          <p>Prefer longer, searchable discussions? The Students Hub on this site keeps every topic in its own thread. Use both - quick questions on WhatsApp, deeper write-ups in the hub.</p>
        </div>
        ${renderWhatsappJoinButton("Join the group")}
      </div>
    </section>
  `;
}

// ---- Events: public pages ---------------------------------------------
// The list and detail pages are readable signed-out (the events themselves
// are public once published); only the register action needs an account.

function renderEventsPage(id = "") {
  return id ? renderEventDetailPage(id) : renderEventsListPage();
}

function renderEventModeLabel(event) {
  const mode = EVENT_MODES.find((item) => item.id === event.mode);
  return mode ? mode.label : "Online";
}

function renderEventWhen(event) {
  const start = formatEventDateTime(event.startAt);
  if (!event.endAt) return start;
  const sameDay = new Date(event.startAt).toDateString() === new Date(event.endAt).toDateString();
  const end = sameDay
    ? new Date(event.endAt).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    : formatEventDateTime(event.endAt);
  return `${start} - ${end}`;
}

function renderEventCard(event) {
  const registered = isRegisteredForEvent(event.id);
  const past = isPastEvent(event);
  const cover = safeUrl(event.coverImage);

  return `
    <article class="event-card ${past ? "is-past" : ""}" data-reveal>
      ${cover ? `<span class="event-card-cover"><img src="${escapeAttr(cover)}" alt="" loading="lazy" /></span>` : ""}
      <div class="event-card-body">
        <div class="event-card-tags">
          <span class="event-chip">${escapeHtml(renderEventModeLabel(event))}</span>
          ${past ? `<span class="event-chip is-muted">Finished</span>` : ""}
          ${registered ? `<span class="event-chip is-live">You're registered</span>` : ""}
        </div>
        <h3>${escapeHtml(event.title)}</h3>
        <p class="event-card-when">${escapeHtml(renderEventWhen(event))}</p>
        ${event.capacity && !past ? `<p class="event-card-seats">${escapeHtml(isEventFull(event) ? "Fully booked" : `${getEventSeatsLeft(event)} of ${event.capacity} places left`)}</p>` : ""}
        <p>${escapeHtml(summarizeFormattedText(event.description, 160) || "Details coming soon.")}</p>
        <a class="button ${registered ? "ghost" : "primary"} small" href="#events/${encodeURIComponent(event.id)}">
          ${registered ? "View details" : past ? "View details" : "View and register"}
        </a>
      </div>
    </article>
  `;
}

function renderEventsListPage() {
  const upcoming = getUpcomingEvents();
  const past = getPastEvents();

  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Events</p>
      <h1>Live sessions, workshops, and doubt-clearing calls.</h1>
      <p>Register for an upcoming session and the meeting details land right here on the event page once they're shared.</p>
    </section>
    <section class="section-band">
      <div class="section-heading" data-reveal>
        <div>
          <p class="eyebrow">Upcoming</p>
          <h2>${upcoming.length ? "Save your spot." : "Nothing scheduled right now."}</h2>
        </div>
      </div>
      <div class="event-list-grid">
        ${upcoming.map(renderEventCard).join("")
          || renderEmptyState("No upcoming events yet. Check back soon - new sessions are announced here first.")}
      </div>
    </section>
    ${past.length ? `
      <section class="section-band">
        <div class="section-heading" data-reveal>
          <div>
            <p class="eyebrow">Past events</p>
            <h2>Already happened.</h2>
          </div>
        </div>
        <div class="event-list-grid">
          ${past.map(renderEventCard).join("")}
        </div>
      </section>
    ` : ""}
  `;
}

// What a registered student sees: the meeting link once the admin adds one,
// and an honest "not shared yet" message until then.
function renderEventMeetingPanel(event) {
  const meeting = state.eventMeetings[event.id];
  const link = safeUrl(meeting?.meetingLink);

  if (!link) {
    return `
      <div class="event-meeting-panel is-pending">
        <div>
          <strong>You're registered.</strong>
          <p>The meeting link hasn't been shared yet. It will appear here, and you'll get it by email, before the session starts.</p>
        </div>
      </div>
    `;
  }

  return `
    <div class="event-meeting-panel">
      <div>
        <strong>Your meeting invite</strong>
        <p>${escapeHtml(meeting.meetingNote || "Join a few minutes early so you don't miss the start.")}</p>
      </div>
      <a class="button primary" href="${escapeAttr(link)}" target="_blank" rel="noreferrer noopener">Join meeting</a>
    </div>
  `;
}

function renderEventSeatsNote(event) {
  const left = getEventSeatsLeft(event);
  if (left === null) return "";
  if (left <= 0) return `<span class="event-seats is-full">Fully booked</span>`;
  return `<span class="event-seats">${left} of ${event.capacity} ${left === 1 ? "place" : "places"} left</span>`;
}

function renderEventRegisterActions(event) {
  const past = isPastEvent(event);
  if (past) {
    return `<p class="event-detail-note">This event has finished. Watch this page for the next one.</p>`;
  }
  if (!hasStudentProgressSync()) {
    return `
      <div class="event-detail-actions">
        <a class="button primary" href="#profile">Login to register</a>
        <span class="event-detail-note">Registration needs a free student account.</span>
      </div>
    `;
  }
  if (isBlockedFromArea("events")) {
    return renderBlockedNotice("events");
  }
  if (isRegisteredForEvent(event.id)) {
    return `
      <div class="event-detail-actions">
        <button class="button ghost" type="button" data-cancel-event="${escapeAttr(event.id)}">Cancel my registration</button>
        ${renderEventSeatsNote(event)}
      </div>
    `;
  }
  if (isEventFull(event)) {
    return `
      <div class="event-detail-actions">
        <button class="button primary" type="button" disabled>Fully booked</button>
        <span class="event-detail-note">Every place has been taken. Check back in case someone cancels.</span>
      </div>
    `;
  }
  return `
    <div class="event-detail-actions">
      <button class="button primary" type="button" data-register-event="${escapeAttr(event.id)}">Register for this event</button>
      ${renderEventSeatsNote(event) || `<span class="event-detail-note">Free. You can cancel any time.</span>`}
    </div>
  `;
}

// Event descriptions and course outcomes are plain text typed or pasted into
// admin forms. Rendered as a single paragraph, their line breaks collapsed and
// a list ran together as one block of text. Now a blank line
// starts a paragraph, a single break stays a break, and lines starting with
// -, *, or "1." become lists. Bullets copied from a document usually lose
// their markers and arrive as one item per line, so two or more lines right
// after an intro ending in ":" are shown as a list as well.
// Many people type markers straight against the text ("*Item", "1.Item"),
// so a space after the marker is optional. Guards keep ordinary text out:
// "-" or "1." only count before a space or a letter ("-5°C" and "3.5 hours"
// stay text), and "*" never counts as "**bold**" or a line wrapped in
// "*emphasis*".
const LIST_BULLET_PATTERN = /^\s*(?:[-\u2013](?:\s+|(?=\p{L}))|\*\s+|\*(?![*\s])(?![^*]*\*)|[\u2022\u2023\u2043\u2217\u204E\u25AA\u25CF\u25E6\uFF0A]\s*)(\S.*)$/u;
const LIST_NUMBERED_PATTERN = /^\s*\d{1,3}[.)](?:\s+|(?=\p{L}))(\S.*)$/u;

function splitTextBlocks(text) {
  return String(text || "")
    .replace(/\r\n?/g, "\n")
    .split(/\n[ \t]*\n/)
    .map((block) => block.split("\n").map((line) => line.trim()).filter(Boolean))
    .filter((lines) => lines.length);
}

function renderFormattedText(text) {
  const isListLine = (line) => LIST_BULLET_PATTERN.test(line) || LIST_NUMBERED_PATTERN.test(line);
  const renderList = (tag, items) => `<${tag}>${items.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</${tag}>`;
  const html = [];
  let afterIntro = false;

  splitTextBlocks(text).forEach((lines) => {
    let index = 0;
    while (index < lines.length) {
      const pattern = LIST_BULLET_PATTERN.test(lines[index])
        ? LIST_BULLET_PATTERN
        : LIST_NUMBERED_PATTERN.test(lines[index]) ? LIST_NUMBERED_PATTERN : null;

      if (pattern) {
        const items = [];
        while (index < lines.length && pattern.test(lines[index])) {
          items.push(lines[index].match(pattern)[1]);
          index += 1;
        }
        html.push(renderList(pattern === LIST_BULLET_PATTERN ? "ul" : "ol", items));
        afterIntro = false;
        continue;
      }

      const run = [];
      while (index < lines.length && !isListLine(lines[index])) {
        run.push(lines[index]);
        index += 1;
      }

      if (afterIntro && run.length >= 2) {
        html.push(renderList("ul", run));
        afterIntro = false;
      } else if (run.length >= 3 && run[0].endsWith(":")) {
        html.push(`<p>${escapeHtml(run[0])}</p>`, renderList("ul", run.slice(1)));
        afterIntro = false;
      } else {
        html.push(`<p>${run.map(escapeHtml).join("<br>")}</p>`);
        afterIntro = run[run.length - 1].endsWith(":");
      }
    }
  });

  return html.join("");
}

// Card previews: the first paragraph only, list markers removed, cut at a
// word boundary. Slicing the raw text cut words in half and ran pasted list
// items together.
function summarizeFormattedText(text, maxLength) {
  const [firstBlock = []] = splitTextBlocks(text);
  const plain = firstBlock
    .map((line) => line.replace(LIST_BULLET_PATTERN, "$1").replace(LIST_NUMBERED_PATTERN, "$1"))
    .join(" ");
  if (plain.length <= maxLength) return plain;
  const window = plain.slice(0, maxLength + 1);
  const lastSpace = window.lastIndexOf(" ");
  const kept = lastSpace > maxLength * 0.6 ? window.slice(0, lastSpace) : plain.slice(0, maxLength);
  return `${kept.replace(/[\s,;:.\-\u2013\u2014]+$/, "")}\u2026`;
}

function renderEventDetailPage(eventId) {
  const event = findEventById(eventId);
  if (!event || (event.status !== "published" && !state.isAdmin)) {
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Events</p>
        <h1>${state.eventsLoaded ? "Event not found." : "Loading event..."}</h1>
        <p>${state.eventsLoaded ? "This event may have been removed or archived." : "Please wait while SkillUp Class loads events."}</p>
        <a class="button primary" href="#events">Back to events</a>
      </section>
    `;
  }

  const cover = safeUrl(event.coverImage);
  const registered = isRegisteredForEvent(event.id);
  const descriptionHtml = renderFormattedText(event.description);

  return `
    <section class="page-title section-band dark-band slim event-detail-header">
      <p class="eyebrow">Events</p>
      <h1>${escapeHtml(event.title)}</h1>
      <div class="event-detail-meta">
        <span><small>When</small><strong>${escapeHtml(renderEventWhen(event))}</strong></span>
        <span><small>Format</small><strong>${escapeHtml(renderEventModeLabel(event))}</strong></span>
        ${event.location ? `<span><small>Where</small><strong>${escapeHtml(event.location)}</strong></span>` : ""}
        ${event.host ? `<span><small>Host</small><strong>${escapeHtml(event.host)}</strong></span>` : ""}
      </div>
      ${renderEventRegisterActions(event)}
    </section>
    <section class="section-band event-detail-body">
      ${registered ? renderEventMeetingPanel(event) : ""}
      ${cover ? `<figure class="event-detail-cover"><img src="${escapeAttr(cover)}" alt="" loading="lazy" /></figure>` : ""}
      ${descriptionHtml ? `<div class="event-detail-copy formatted-text">${descriptionHtml}</div>` : ""}
      <a class="button ghost" href="#events">Back to all events</a>
    </section>
  `;
}

// ---- 1:1 sessions -------------------------------------------------------------
//
// Paid 1:1 sessions (mentorship, resume reviews, mock interviews) managed in
// Admin > 1:1 Sessions. A student picks an open time from the weekly
// availability set in Admin > Session Bookings and sends a request; the admin
// confirms it and shares the payment and meeting link. firestore.rules keeps
// one booking per time. Times are India time, which has no daylight saving,
// so a fixed +05:30 offset is exact.
const SESSION_TIME_ZONE = "Asia/Kolkata";
const SESSION_TIME_OFFSET = "+05:30";
const SESSION_WEEKDAYS = [
  { id: "mon", label: "Monday" },
  { id: "tue", label: "Tuesday" },
  { id: "wed", label: "Wednesday" },
  { id: "thu", label: "Thursday" },
  { id: "fri", label: "Friday" },
  { id: "sat", label: "Saturday" },
  { id: "sun", label: "Sunday" }
];
const SESSION_DURATIONS = [15, 30, 45, 60, 90];
const SESSION_BOOKING_STATUSES = {
  requested: "Waiting for confirmation",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled"
};

function normalizeSession(raw = {}, fallbackOrder = 1) {
  const title = String(raw.title || "").trim() || "Untitled session";
  const duration = Math.round(Number(raw.durationMinutes || 60));
  return {
    id: String(raw.id || slugify(title)),
    title,
    slug: String(raw.slug || raw.id || slugify(title)),
    description: String(raw.description || ""),
    included: String(raw.included || ""),
    mentorName: String(raw.mentorName || "").trim(),
    mentorRole: String(raw.mentorRole || "").trim(),
    durationMinutes: duration > 0 ? Math.min(duration, 240) : 60,
    originalPrice: String(raw.originalPrice || ""),
    finalPrice: String(raw.finalPrice || ""),
    bundleCount: normalizeSessionBundleCount(raw.bundleCount),
    bundlePrice: String(raw.bundlePrice || ""),
    coverImage: String(raw.coverImage || ""),
    coverImagePath: String(raw.coverImagePath || ""),
    status: raw.status === "published" ? "published" : "draft",
    order: Number(raw.order || fallbackOrder || 1),
    createdAt: String(raw.createdAt || ""),
    updatedAt: String(raw.updatedAt || "")
  };
}

// "19:00, 7:30, 20:00" -> ["07:30", "19:00", "20:00"]. Anything that is not a
// real 24-hour time is dropped.
function parseSessionSlotTimes(value) {
  const times = String(Array.isArray(value) ? value.join(",") : value || "")
    .split(/[,\s]+/)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const match = part.match(/^(\d{1,2}):(\d{2})$/);
      if (!match) return "";
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      return hours <= 23 && minutes <= 59 ? `${String(hours).padStart(2, "0")}:${match[2]}` : "";
    })
    .filter(Boolean);
  return [...new Set(times)].sort();
}

function normalizeSessionAvailability(raw = {}) {
  const weekly = {};
  SESSION_WEEKDAYS.forEach((day) => {
    weekly[day.id] = parseSessionSlotTimes(raw.weekly?.[day.id]);
  });
  const windowDays = Number(raw.bookingWindowDays);
  const noticeHours = Number(raw.minNoticeHours);
  const blockedDates = (Array.isArray(raw.blockedDates) ? raw.blockedDates : String(raw.blockedDates || "").split(/[,\s]+/))
    .map((value) => String(value).trim())
    .filter((value) => /^\d{4}-\d{2}-\d{2}$/.test(value));
  return {
    weekly,
    bookingWindowDays: Number.isFinite(windowDays) && windowDays >= 1 ? Math.min(Math.round(windowDays), 90) : 21,
    minNoticeHours: Number.isFinite(noticeHours) && noticeHours >= 0 ? Math.min(Math.round(noticeHours), 168) : 12,
    blockedDates: [...new Set(blockedDates)].sort(),
    updatedAt: String(raw.updatedAt || "")
  };
}

// The calendar date in India time, as YYYY-MM-DD.
function toSessionDateKey(date) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: SESSION_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" }).format(date);
}

function addDaysToDateKey(dateKey, days) {
  const date = new Date(`${dateKey}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

function getSessionWeekdayId(dateKey) {
  return ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][new Date(`${dateKey}T12:00:00Z`).getUTCDay()];
}

function getSessionSlotStart(slotKey) {
  return new Date(`${slotKey}:00${SESSION_TIME_OFFSET}`);
}

// Open times for the booking window, grouped by day: the weekly times, minus
// blocked dates, times inside the minimum notice, and times already taken.
function getOpenSessionSlots(availability, takenKeys = new Set(), now = new Date()) {
  const settings = normalizeSessionAvailability(availability);
  const earliest = now.getTime() + settings.minNoticeHours * 3600000;
  const firstDay = toSessionDateKey(now);
  const days = [];
  for (let offset = 0; offset < settings.bookingWindowDays; offset += 1) {
    const dateKey = addDaysToDateKey(firstDay, offset);
    if (settings.blockedDates.includes(dateKey)) continue;
    const slots = settings.weekly[getSessionWeekdayId(dateKey)]
      .map((time) => {
        const key = `${dateKey}T${time}`;
        return { key, dateKey, time, start: getSessionSlotStart(key) };
      })
      .filter((slot) => slot.start.getTime() >= earliest && !takenKeys.has(slot.key));
    if (slots.length) days.push({ dateKey, slots });
  }
  return days;
}

function formatSessionDay(dateKey) {
  return new Intl.DateTimeFormat("en-IN", { timeZone: SESSION_TIME_ZONE, weekday: "short", day: "numeric", month: "short" })
    .format(getSessionSlotStart(`${dateKey}T12:00`));
}

function formatSessionTime(slotKey) {
  return new Intl.DateTimeFormat("en-IN", { timeZone: SESSION_TIME_ZONE, hour: "numeric", minute: "2-digit", hour12: true })
    .format(getSessionSlotStart(slotKey))
    .toUpperCase();
}

function formatSessionSlot(slotKey) {
  return `${formatSessionDay(String(slotKey).slice(0, 10))}, ${formatSessionTime(slotKey)} IST`;
}

function getSessionDiscountPercent(session) {
  if (!String(session.finalPrice || "").trim()) return 0;
  const original = Number(String(session.originalPrice || "").replace(/,/g, ""));
  const final = Number(String(session.finalPrice || "").replace(/,/g, ""));
  if (!(original > 0) || !(final >= 0) || final >= original) return 0;
  return Math.round((1 - final / original) * 100);
}

function renderSessionPrice(session) {
  const final = formatCoursePrice(session.finalPrice) || formatCoursePrice(session.originalPrice);
  if (!final) return `<div class="session-price"><strong>Fee on request</strong></div>`;
  const percent = getSessionDiscountPercent(session);
  return `
    <div class="session-price">
      <strong>${escapeHtml(final)}</strong>
      ${percent ? `<del>${escapeHtml(formatCoursePrice(session.originalPrice))}</del><span class="session-discount">${percent}% off</span>` : ""}
    </div>
  `;
}

// ---- Bundles: a pack of sessions sold together, e.g. 3 mock interviews ----

const SESSION_BUNDLE_SIZES = [2, 3, 4, 5, 6, 8, 10];

function normalizeSessionBundleCount(value) {
  const count = Math.round(Number(value) || 0);
  return count >= 2 && count <= 10 ? count : 0;
}

// "Rs. 2,499" or "2499" -> 2499; anything without a number -> 0.
function parseSessionPrice(value) {
  const match = String(value || "").replace(/,/g, "").match(/\d+(?:\.\d+)?/);
  return match ? Number(match[0]) : 0;
}

function hasSessionBundle(session) {
  return session.bundleCount >= 2 && Boolean(formatCoursePrice(session.bundlePrice));
}

// How much cheaper the bundle is than booking its sessions one at a time.
function getSessionBundleSavingPercent(session) {
  const single = parseSessionPrice(session.finalPrice || session.originalPrice);
  const bundle = parseSessionPrice(session.bundlePrice);
  const full = single * session.bundleCount;
  if (!(single > 0) || !(full > bundle)) return 0;
  return Math.round((1 - bundle / full) * 100);
}

function renderSessionBundleOffer(session) {
  if (!hasSessionBundle(session)) return "";
  const saving = getSessionBundleSavingPercent(session);
  return `
    <p class="session-bundle-offer">
      Bundle: ${session.bundleCount} sessions for <strong>${escapeHtml(formatCoursePrice(session.bundlePrice))}</strong>
      ${saving ? `<span class="session-discount">Save ${saving}%</span>` : ""}
    </p>
  `;
}

// The student's bundles (for one session, or all) that still have sessions
// left to book. A bundle is "ready" once the admin has confirmed it.
function getOpenSessionBundles(sessionId = "", bookings = state.mySessionBookings) {
  return bookings
    .filter((booking) => booking.plan === "bundle" && booking.status !== "cancelled" && (!sessionId || booking.sessionId === sessionId))
    .map((bundle) => {
      const used = 1 + bookings.filter((booking) => booking.bundleBookingId === bundle.id && booking.status !== "cancelled").length;
      const total = Number(bundle.bundleCount) || 0;
      return { bundle, used, total, left: Math.max(0, total - used), ready: ["confirmed", "completed"].includes(bundle.status) };
    })
    .filter((item) => item.left > 0);
}

// "Bundle of 3 · session 1" / "Bundle · session 2 of 3" / "" for a single session.
function describeSessionPlan(booking, bookings) {
  if (booking.plan === "bundle") return `Bundle of ${Number(booking.bundleCount) || 0} · session 1`;
  if (booking.plan !== "bundle-session") return "";
  const bundle = bookings.find((item) => item.id === booking.bundleBookingId);
  const siblings = bookings
    .filter((item) => item.bundleBookingId === booking.bundleBookingId && (item.status !== "cancelled" || item.id === booking.id))
    .sort((a, b) => String(a.createdAt).localeCompare(String(b.createdAt)));
  const number = siblings.findIndex((item) => item.id === booking.id) + 2;
  return bundle ? `Bundle · session ${number} of ${Number(bundle.bundleCount) || number}` : "Bundle session";
}

// ---- Ratings ----

function getSessionRatingSummary(sessionId, reviews = state.sessionReviews) {
  const rated = reviews.filter((review) => review.sessionId === sessionId && review.status === "published" && review.rating >= 1);
  if (!rated.length) return null;
  const average = rated.reduce((sum, review) => sum + review.rating, 0) / rated.length;
  return { average: Math.round(average * 10) / 10, count: rated.length };
}

function renderStars(rating) {
  const full = Math.max(0, Math.min(5, Math.round(rating)));
  return `<span class="session-stars" role="img" aria-label="${rating} out of 5 stars">${"★".repeat(full)}<span class="is-empty">${"★".repeat(5 - full)}</span></span>`;
}

function renderSessionRating(session) {
  const summary = getSessionRatingSummary(session.id);
  if (!summary) return "";
  return `
    <span class="session-rating">
      ${renderStars(summary.average)}
      <strong>${summary.average.toFixed(1)}</strong>
      <small>(${summary.count} ${summary.count === 1 ? "review" : "reviews"})</small>
    </span>
  `;
}

function renderSessionMentor(session) {
  const name = session.mentorName || "SkillUp Class mentor";
  return `
    <div class="session-mentor">
      <span class="session-mentor-avatar">${escapeHtml(getInitials(name))}</span>
      <span><strong>${escapeHtml(name)}</strong>${session.mentorRole ? `<small>${escapeHtml(session.mentorRole)}</small>` : ""}</span>
    </div>
  `;
}

function findSessionById(id) {
  return state.sessions.find((session) => session.id === id || session.slug === id) || null;
}

function getPublicSessions() {
  return state.sessions.filter((session) => session.status === "published").sort((a, b) => a.order - b.order);
}

// ---- Loading ----

async function loadSessions({ force = false } = {}) {
  if (!state.firebaseEnabled) return false;
  if (state.sessionsLoaded && !force) return false;
  try {
    const { collection, getDocs, query, where } = firebase.api;
    // A non-admin list query must carry the status filter the rule checks.
    const constraints = state.isAdmin ? [] : [where("status", "==", "published")];
    const snapshot = await getDocs(query(collection(firebase.db, "sessions"), ...constraints));
    state.sessions = snapshot.docs.map((docSnap, index) => normalizeSession({ id: docSnap.id, ...docSnap.data() }, index + 1));
  } catch (error) {
    console.warn("Could not load sessions:", error);
  }
  state.sessionsLoaded = true;
  return true;
}

async function loadSessionAvailability({ force = false } = {}) {
  if (!state.firebaseEnabled) return false;
  if (state.sessionAvailability && !force) return false;
  try {
    const { doc, getDoc } = firebase.api;
    const snapshot = await getDoc(doc(firebase.db, "siteSettings", "sessionAvailability"));
    state.sessionAvailability = normalizeSessionAvailability(snapshot.exists() ? snapshot.data() : {});
    return true;
  } catch (error) {
    console.warn("Could not load session availability:", error);
    return false;
  }
}

async function loadTakenSessionSlots({ force = false } = {}) {
  if (!state.firebaseEnabled) return false;
  if (state.takenSessionSlotsLoaded && !force) return false;
  try {
    const { collection, getDocs, query, where } = firebase.api;
    const snapshot = await getDocs(query(collection(firebase.db, "sessionSlots"), where("slotKey", ">=", toSessionDateKey(new Date()))));
    state.takenSessionSlots = new Set(snapshot.docs.map((docSnap) => docSnap.id));
    state.takenSessionSlotsLoaded = true;
    return true;
  } catch (error) {
    console.warn("Could not load booked times:", error);
    return false;
  }
}

async function loadMySessionBookings({ force = false } = {}) {
  if (!state.firebaseEnabled || !state.user || state.isAdmin) return false;
  if (state.mySessionBookingsLoaded && !force) return false;
  try {
    const { collection, getDocs, query, where } = firebase.api;
    const snapshot = await getDocs(query(collection(firebase.db, "sessionBookings"), where("uid", "==", state.user.uid)));
    state.mySessionBookings = snapshot.docs
      .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
      .sort((a, b) => String(a.slotKey).localeCompare(String(b.slotKey)));
    state.mySessionBookingsLoaded = true;
    return true;
  } catch (error) {
    console.warn("Could not load your session requests:", error);
    return false;
  }
}

function normalizeSessionReview(raw = {}) {
  const rating = Math.round(Number(raw.rating) || 0);
  return {
    id: String(raw.id || raw.bookingId || ""),
    bookingId: String(raw.bookingId || raw.id || ""),
    sessionId: String(raw.sessionId || ""),
    sessionTitle: String(raw.sessionTitle || ""),
    uid: String(raw.uid || ""),
    name: String(raw.name || "").trim() || "Student",
    rating: rating >= 1 && rating <= 5 ? rating : 0,
    body: String(raw.body || ""),
    status: raw.status === "hidden" ? "hidden" : "published",
    createdAt: String(raw.createdAt || ""),
    updatedAt: String(raw.updatedAt || "")
  };
}

async function loadSessionReviews({ force = false } = {}) {
  if (!state.firebaseEnabled) return false;
  if (state.sessionReviewsLoaded && !force) return false;
  try {
    const { collection, getDocs, query, where } = firebase.api;
    // A non-admin list query must carry the status filter the rule checks.
    const constraints = state.isAdmin ? [] : [where("status", "==", "published")];
    const snapshot = await getDocs(query(collection(firebase.db, "sessionReviews"), ...constraints));
    state.sessionReviews = snapshot.docs.map((docSnap) => normalizeSessionReview({ id: docSnap.id, ...docSnap.data() }));
  } catch (error) {
    console.warn("Could not load session reviews:", error);
  }
  state.sessionReviewsLoaded = true;
  return true;
}

async function loadMySessionReviews({ force = false } = {}) {
  if (!state.firebaseEnabled || !state.user || state.isAdmin) return false;
  if (state.mySessionReviewsLoaded && !force) return false;
  try {
    const { collection, getDocs, query, where } = firebase.api;
    const snapshot = await getDocs(query(collection(firebase.db, "sessionReviews"), where("uid", "==", state.user.uid)));
    state.mySessionReviews = snapshot.docs.map((docSnap) => normalizeSessionReview({ id: docSnap.id, ...docSnap.data() }));
    state.mySessionReviewsLoaded = true;
    return true;
  } catch (error) {
    console.warn("Could not load your reviews:", error);
    return false;
  }
}

function scheduleSessionLoad(route) {
  if (!state.firebaseEnabled || route.page !== "sessions") return;
  Promise.all([loadSessions(), loadSessionAvailability(), loadTakenSessionSlots(), loadSessionReviews()])
    .then((changed) => { if (changed.some(Boolean)) render(); });
  if (state.user && !state.isAdmin) {
    Promise.all([loadMySessionBookings(), loadMySessionReviews()])
      .then((changed) => { if (changed.some(Boolean)) render(); });
  }
}

// ---- Public pages ----

function renderSessionsPage(id = "") {
  return id ? renderSessionDetailPage(id) : renderSessionListPage();
}

function renderSessionListPage() {
  const sessions = getPublicSessions();
  const loading = state.firebaseEnabled && !state.sessionsLoaded;
  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">1:1 Sessions</p>
      <h1>Book a 1:1 session.</h1>
      <p>Mentorship, resume reviews and mock interviews with a SkillUp Class mentor. Pick a time that suits you and we confirm it by email.</p>
    </section>
    ${renderMySessionBookings()}
    <section class="section-band">
      <div class="session-grid">
        ${sessions.map(renderSessionCard).join("") || renderEmptyState(loading ? "Loading sessions..." : "No sessions are open for booking yet. Check back soon.")}
      </div>
    </section>
  `;
}

function renderSessionCard(session) {
  const href = `#sessions/${encodeURIComponent(session.id)}`;
  const cover = safeUrl(session.coverImage) || getCategoryFallbackCover(session.title, "mentorship");
  return `
    <article class="session-card" data-reveal>
      <a class="session-card-cover" href="${href}" tabindex="-1" aria-hidden="true"><img src="${escapeAttr(cover)}" alt="" loading="lazy" /></a>
      <div class="session-card-body">
        <h3><a href="${href}">${escapeHtml(session.title)}</a></h3>
        ${renderSessionMentor(session)}
        ${renderSessionRating(session)}
        <span class="session-duration">${icon("clock")}${session.durationMinutes} mins</span>
        ${renderSessionPrice(session)}
        ${renderSessionBundleOffer(session)}
        <a class="button primary session-card-button" href="${href}">View details</a>
      </div>
    </article>
  `;
}

function renderSessionDetailPage(id) {
  const session = findSessionById(id);
  if (!session || (session.status !== "published" && !state.isAdmin)) {
    const settled = state.sessionsLoaded || !state.firebaseEnabled;
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">1:1 Sessions</p>
        <h1>${settled ? "Session not found." : "Loading session..."}</h1>
        <p>${settled ? "This session may have been removed." : "Please wait while SkillUp Class loads sessions."}</p>
        <a class="button primary" href="#sessions">All sessions</a>
      </section>
    `;
  }

  const cover = safeUrl(session.coverImage);
  const descriptionHtml = renderFormattedText(session.description);
  const includedHtml = renderFormattedText(session.included);
  return `
    <section class="page-title section-band dark-band slim session-detail-header">
      <p class="eyebrow"><a href="#sessions">1:1 Sessions</a></p>
      <h1>${escapeHtml(session.title)}</h1>
      <div class="session-detail-meta">
        ${renderSessionMentor(session)}
        <span class="session-duration">${icon("clock")}${session.durationMinutes} mins · Online</span>
        ${renderSessionRating(session)}
      </div>
    </section>
    <section class="section-band session-detail-body">
      <div class="session-detail-main">
        ${cover ? `<figure class="session-detail-cover"><img src="${escapeAttr(cover)}" alt="" loading="lazy" /></figure>` : ""}
        ${descriptionHtml ? `<div class="formatted-text">${descriptionHtml}</div>` : ""}
        ${includedHtml ? `<div class="session-included"><h2>What's included</h2><div class="formatted-text">${includedHtml}</div></div>` : ""}
        ${renderSessionReviewsSection(session)}
        <a class="button ghost session-back-link" href="#sessions">All sessions</a>
      </div>
      <aside class="session-booking-card" aria-label="Book this session">
        ${renderSessionPrice(session)}
        ${renderSessionBundleOffer(session)}
        ${renderSessionBookingPanel(session)}
      </aside>
    </section>
  `;
}

function renderMySessionBookings() {
  const today = toSessionDateKey(new Date());
  const upcoming = state.mySessionBookings.filter((booking) => ["requested", "confirmed"].includes(booking.status) && booking.slotKey >= today);
  const bundles = getOpenSessionBundles().filter((item) => item.ready);
  const toReview = getSessionBookingsToReview();
  if (!upcoming.length && !bundles.length && !toReview.length) return "";
  return `
    <section class="section-band session-my-band">
      <h2>Your sessions</h2>
      <div class="session-my-requests">
        ${upcoming.map(renderMySessionBookingItem).join("")}
        ${bundles.map((item) => `
          <div class="session-my-request">
            <div>
              <strong>${escapeHtml(item.bundle.sessionTitle)}</strong>
              <small>Bundle: ${item.left} of ${item.total} sessions left to book</small>
            </div>
            <div class="session-my-request-actions"><a class="button primary small" href="#sessions/${encodeURIComponent(item.bundle.sessionId)}">Book next</a></div>
          </div>
        `).join("")}
        ${toReview.map((booking) => `
          <div class="session-my-request">
            <div>
              <strong>${escapeHtml(booking.sessionTitle)}</strong>
              <small>${escapeHtml(formatSessionSlot(booking.slotKey))} · Completed</small>
            </div>
            <div class="session-my-request-actions"><a class="button ghost small" href="#sessions/${encodeURIComponent(booking.sessionId)}">Leave a review</a></div>
          </div>
        `).join("")}
      </div>
    </section>
  `;
}

// Finished sessions the student has not reviewed yet, newest first.
function getSessionBookingsToReview(sessionId = "") {
  if (!state.mySessionReviewsLoaded) return [];
  return state.mySessionBookings
    .filter((booking) => booking.status === "completed" && (!sessionId || booking.sessionId === sessionId))
    .filter((booking) => !state.mySessionReviews.some((review) => review.bookingId === booking.id))
    .sort((a, b) => String(b.slotKey).localeCompare(String(a.slotKey)));
}

function renderMySessionBookingItem(booking) {
  return `
    <div class="session-my-request">
      <div>
        <strong>${escapeHtml(booking.sessionTitle)}</strong>
        <small>${escapeHtml([formatSessionSlot(booking.slotKey), SESSION_BOOKING_STATUSES[booking.status] || booking.status, describeSessionPlan(booking, state.mySessionBookings)].filter(Boolean).join(" · "))}</small>
      </div>
      <div class="session-my-request-actions">
        ${booking.status === "confirmed" && safeUrl(booking.paymentLink) ? `<a class="button primary small" href="${escapeAttr(safeUrl(booking.paymentLink))}" target="_blank" rel="noopener">Pay now</a>` : ""}
        ${booking.status === "confirmed" && safeUrl(booking.meetingLink) ? `<a class="button ghost small" href="${escapeAttr(safeUrl(booking.meetingLink))}" target="_blank" rel="noopener">Join meeting</a>` : ""}
        ${booking.status === "requested" ? `<button class="button ghost small" type="button" data-cancel-session-booking="${escapeAttr(booking.id)}">Withdraw</button>` : ""}
      </div>
    </div>
  `;
}

function renderSessionTimeChips(day) {
  if (!day) return "";
  return day.slots.map((slot) => `
    <button class="session-chip" type="button" data-session-slot="${escapeAttr(slot.key)}" aria-pressed="false">${escapeHtml(formatSessionTime(slot.key))}</button>
  `).join("");
}

function renderSessionBookingPanel(session) {
  const today = toSessionDateKey(new Date());
  const mine = state.mySessionBookings.filter((booking) => booking.sessionId === session.id && ["requested", "confirmed"].includes(booking.status) && booking.slotKey >= today);
  const myRequests = mine.length ? `<div class="session-my-requests">${mine.map(renderMySessionBookingItem).join("")}</div>` : "";

  if (!hasStudentProgressSync()) {
    return `
      ${myRequests}
      <div class="session-booking-gate">
        <a class="button primary" href="#profile">Login to book</a>
        <p class="muted">Booking needs a free student account, so we can confirm your session by email.</p>
      </div>
    `;
  }
  if (isBlockedFromArea("events")) return renderBlockedNotice("events");
  if (!isEmailVerified()) {
    return `
      ${myRequests}
      <div class="session-booking-gate">
        <p class="muted">Confirm your email to book. We send the confirmation and meeting link to it.</p>
        <button class="button primary" type="button" data-send-verification>Send confirmation link</button>
        <button class="button ghost" type="button" data-refresh-verification>I've confirmed it</button>
      </div>
    `;
  }
  if (!state.sessionAvailability || !state.takenSessionSlotsLoaded) {
    return `${myRequests}<p class="muted">Loading open times...</p>`;
  }

  const days = getOpenSessionSlots(state.sessionAvailability, state.takenSessionSlots);
  if (!days.length) {
    return `
      ${myRequests}
      <div class="session-booking-gate">
        <p class="muted">No open times in the next ${state.sessionAvailability.bookingWindowDays} days. Check back soon, or <a href="#inquiry">send us an inquiry</a>.</p>
      </div>
    `;
  }

  const profile = state.studentProfile || {};
  return `
    ${myRequests}
    <form class="session-booking-form" data-session-booking-form="${escapeAttr(session.id)}">
      <fieldset>
        <legend>Pick a date</legend>
        <div class="session-date-chips">
          ${days.map((day, index) => `
            <button class="session-chip${index === 0 ? " is-selected" : ""}" type="button" data-session-date="${escapeAttr(day.dateKey)}" aria-pressed="${index === 0}">
              ${escapeHtml(formatSessionDay(day.dateKey))}<small>${day.slots.length} ${day.slots.length === 1 ? "time" : "times"}</small>
            </button>
          `).join("")}
        </div>
      </fieldset>
      <fieldset>
        <legend>Pick a time <small>(India time)</small></legend>
        <div class="session-time-chips" data-session-times>${renderSessionTimeChips(days[0])}</div>
      </fieldset>
      ${renderSessionPlanChoice(session)}
      <input type="hidden" name="slotKey" value="" />
      <label><span>Name</span><input name="name" maxlength="120" value="${escapeAttr(profile.name || state.user.displayName || "")}" autocomplete="name" required /></label>
      <label><span>Email</span><input name="email" type="email" value="${escapeAttr(state.user.email || "")}" readonly /></label>
      <label><span>Mobile no</span><input name="mobile" type="tel" maxlength="40" value="${escapeAttr(profile.mobileNo || "")}" autocomplete="tel" required /></label>
      <label><span>What would you like to discuss?</span><textarea name="note" rows="3" maxlength="1000" placeholder="Your goal, current role and questions"></textarea></label>
      <button class="button primary" type="submit">Request booking</button>
      <p class="session-booking-note">No payment now. We confirm your time by email and share the payment and meeting link.</p>
    </form>
  `;
}

// Single session, the session's bundle, or a session from a bundle the
// student already has. Nothing to choose when there is no bundle.
function renderSessionPlanChoice(session) {
  const open = getOpenSessionBundles(session.id)[0];
  const singlePrice = formatCoursePrice(session.finalPrice) || formatCoursePrice(session.originalPrice) || "Fee on request";
  const option = (value, title, detail, checked) => `
    <label class="session-plan-option">
      <input type="radio" name="plan" value="${value}" ${checked ? "checked" : ""} />
      <span><strong>${escapeHtml(title)}</strong><small>${escapeHtml(detail)}</small></span>
    </label>
  `;
  if (open?.ready) {
    return `
      <fieldset class="session-plan-choice">
        <legend>Plan</legend>
        ${option("bundle-session", "Use my bundle", `${open.left} of ${open.total} sessions left · included in your bundle`, true)}
        ${option("single", "Single session", singlePrice, false)}
        <input type="hidden" name="bundleBookingId" value="${escapeAttr(open.bundle.id)}" />
      </fieldset>
    `;
  }
  if (open) {
    return `<p class="session-plan-note">Your bundle is waiting for confirmation. Once we confirm it, you can book its other sessions here.</p>`;
  }
  if (!hasSessionBundle(session)) return "";
  const saving = getSessionBundleSavingPercent(session);
  return `
    <fieldset class="session-plan-choice">
      <legend>Plan</legend>
      ${option("single", "Single session", singlePrice, true)}
      ${option("bundle", `Bundle of ${session.bundleCount} sessions`, `${formatCoursePrice(session.bundlePrice)}${saving ? ` · save ${saving}%` : ""} · book the rest later`, false)}
    </fieldset>
  `;
}

// ---- Booking ----

async function requestSessionBooking(sessionId, formData) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to book a session.");
    return false;
  }
  if (!isEmailVerified()) {
    promptEmailVerification("book a session");
    return false;
  }
  const session = findSessionById(sessionId);
  if (!session || session.status !== "published") {
    showToast("This session is no longer open for booking.");
    return false;
  }

  const slotKey = String(formData.get("slotKey") || "");
  const name = String(formData.get("name") || "").trim().slice(0, 120);
  const mobile = String(formData.get("mobile") || "").trim().slice(0, 40);
  const note = String(formData.get("note") || "").trim().slice(0, 1000);
  if (!slotKey) {
    showToast("Pick a date and time first.");
    return false;
  }
  if (!name || mobile.replace(/\D/g, "").length < 7) {
    showToast("Add your name and a mobile number we can reach you on.");
    return false;
  }
  const stillOpen = getOpenSessionSlots(state.sessionAvailability, state.takenSessionSlots)
    .some((day) => day.slots.some((slot) => slot.key === slotKey));
  if (!stillOpen) {
    await loadTakenSessionSlots({ force: true });
    render();
    showToast("That time is no longer available. Pick another one.");
    return false;
  }

  const planChoice = String(formData.get("plan") || "single");
  let planFields = { plan: "single" };
  if (planChoice === "bundle") {
    if (!hasSessionBundle(session)) {
      showToast("This session is no longer sold as a bundle. Pick single session.");
      return false;
    }
    planFields = { plan: "bundle", bundleCount: session.bundleCount };
  } else if (planChoice === "bundle-session") {
    const open = getOpenSessionBundles(session.id).find((item) => item.ready && item.bundle.id === formData.get("bundleBookingId"));
    if (!open) {
      showToast("Your bundle has no sessions left to book.");
      return false;
    }
    planFields = { plan: "bundle-session", bundleBookingId: open.bundle.id };
  }

  const { collection, doc, writeBatch } = firebase.api;
  const bookingRef = doc(collection(firebase.db, "sessionBookings"));
  const now = new Date().toISOString();
  const booking = {
    ...planFields,
    id: bookingRef.id,
    sessionId: session.id,
    sessionTitle: session.title.slice(0, 160),
    slotKey,
    slotStart: getSessionSlotStart(slotKey).toISOString(),
    durationMinutes: session.durationMinutes,
    name,
    email: state.user.email,
    mobile,
    note,
    uid: state.user.uid,
    status: "requested",
    createdAt: now,
    updatedAt: now
  };
  // The booking and its time are written together; if someone else took the
  // time a moment ago, the rules refuse the whole batch.
  const batch = writeBatch(firebase.db);
  batch.set(bookingRef, booking);
  batch.set(doc(firebase.db, "sessionSlots", slotKey), { slotKey, bookingId: bookingRef.id, createdAt: now });
  try {
    await batch.commit();
  } catch (error) {
    console.warn("Could not book session:", error);
    await loadTakenSessionSlots({ force: true });
    render();
    showToast(state.takenSessionSlots.has(slotKey)
      ? "Someone just booked that time. Pick another one."
      : "Could not send your request. Please try again.");
    return false;
  }

  state.takenSessionSlots.add(slotKey);
  state.mySessionBookings = [...state.mySessionBookings, booking];
  queueSessionBookingEmail(booking).catch((error) => console.warn("Could not queue booking email:", error));
  showToast(`Request sent for ${formatSessionSlot(slotKey)}. We'll email you to confirm.`);
  render();
  return true;
}

// Tells the site inbox about a new request, through the same mail rule as
// course inquiries (whose reference field is named inquiryId).
async function queueSessionBookingEmail(booking) {
  const lines = [
    `New 1:1 session request: ${booking.sessionTitle}`,
    `When: ${formatSessionSlot(booking.slotKey)} (${booking.durationMinutes} mins)`,
    ...(booking.plan && booking.plan !== "single" ? [`Plan: ${describeSessionPlan(booking, state.mySessionBookings)}`] : []),
    `Name: ${booking.name}`,
    `Email: ${booking.email}`,
    `Mobile: ${booking.mobile}`,
    ...(booking.note ? [`Note: ${booking.note}`] : []),
    "Confirm or cancel it in Admin > Session Bookings."
  ];
  const { collection, doc, setDoc } = firebase.api;
  await setDoc(doc(collection(firebase.db, "mail")), {
    to: [INQUIRY_EMAIL],
    replyTo: booking.email.slice(0, 160),
    inquiryId: booking.id,
    createdAt: new Date().toISOString(),
    message: {
      subject: `1:1 session request: ${booking.sessionTitle}`.slice(0, 200),
      text: lines.join("\n").slice(0, 6000),
      html: lines.map((line) => `<p>${escapeHtml(line)}</p>`).join("").slice(0, 8000)
    }
  });
}

async function withdrawSessionBooking(bookingId) {
  const booking = state.mySessionBookings.find((item) => item.id === bookingId);
  if (!booking || booking.status !== "requested") return false;
  const { doc, writeBatch } = firebase.api;
  const batch = writeBatch(firebase.db);
  batch.delete(doc(firebase.db, "sessionBookings", bookingId));
  batch.delete(doc(firebase.db, "sessionSlots", booking.slotKey));
  try {
    await batch.commit();
  } catch (error) {
    console.warn("Could not withdraw session request:", error);
    await loadMySessionBookings({ force: true });
    render();
    showToast("Could not withdraw this request. It may already be confirmed.");
    return false;
  }
  state.mySessionBookings = state.mySessionBookings.filter((item) => item.id !== bookingId);
  state.takenSessionSlots.delete(booking.slotKey);
  showToast("Request withdrawn.");
  render();
  return true;
}

// ---- Admin: sessions ----

// ---- Suggested sessions ---------------------------------------------------------
//
// Starter outlines offered in Admin > 1:1 Sessions, the same way suggested
// courses are offered: each one is added as a draft to edit, price and
// publish. Nothing goes live on its own, and a suggestion already in the
// list is never offered again.
const SESSION_SUGGESTIONS_HIDDEN_KEY = "skillup-session-suggestions-hidden";

const SUGGESTED_SESSIONS = [
  {
    id: "resume-and-linkedin-review",
    title: "Resume and LinkedIn Review",
    durationMinutes: 30,
    originalPrice: "999",
    finalPrice: "699",
    description: "A line-by-line review of your resume and LinkedIn profile for developer roles. We rewrite the weak bullet points together, fix how your projects read, and make your profile match the jobs you are applying for.",
    included: [
      "- Line-by-line resume review you can act on the same day",
      "- Stronger project and impact bullet points",
      "- LinkedIn headline, About and skills review",
      "- An honest view of the roles your profile fits today"
    ].join("\n")
  },
  {
    id: "mock-interview-android",
    title: "Mock Interview: Android",
    durationMinutes: 60,
    originalPrice: "1500",
    finalPrice: "1200",
    bundleCount: 3,
    bundlePrice: "2500",
    description: "A full Android interview under interview conditions: Kotlin, coroutines, Jetpack Compose, architecture and the questions interviewers actually ask. You get honest feedback and a short list of what to revise first.",
    included: [
      "- 45 minutes of Android and Kotlin questions at your target level",
      "- Architecture, Jetpack Compose and coroutines discussion",
      "- Written feedback on what to revise first",
      "- Follow-up tutorials from the SkillUp Class library"
    ].join("\n")
  },
  {
    id: "mock-interview-flutter",
    title: "Mock Interview: Flutter",
    durationMinutes: 60,
    originalPrice: "1500",
    finalPrice: "1200",
    bundleCount: 3,
    bundlePrice: "2500",
    description: "A Flutter and Dart interview run like the real thing: widgets and rendering, state management, navigation, performance and release questions, followed by feedback you can use straight away.",
    included: [
      "- Dart and Flutter questions at your target level",
      "- State management, performance and testing discussion",
      "- Written feedback with the gaps to close",
      "- Suggested practice for the next two weeks"
    ].join("\n")
  },
  {
    id: "mock-interview-system-design",
    title: "Mock Interview: System Design",
    durationMinutes: 60,
    originalPrice: "1500",
    finalPrice: "1200",
    bundleCount: 3,
    bundlePrice: "2500",
    description: "Practise a system design round end to end: clarify the problem, set the scale, design the data model and APIs, then defend your trade-offs. Suited to mobile and backend engineers preparing for senior rounds.",
    included: [
      "- One full design problem with a whiteboard-style discussion",
      "- Data modelling, APIs, caching and failure handling",
      "- How to state trade-offs the way interviewers expect",
      "- Written feedback on structure and communication"
    ].join("\n")
  },
  {
    id: "coding-round-practice",
    title: "Coding Round Practice",
    durationMinutes: 45,
    originalPrice: "1500",
    finalPrice: "1100",
    bundleCount: 3,
    bundlePrice: "2400",
    description: "Solve interview coding problems live, thinking out loud, the way a coding round works. We cover the pattern behind each problem, time and space complexity, and how to recover when you get stuck.",
    included: [
      "- Two or three problems at your level, solved live",
      "- The patterns behind them, not just the answers",
      "- Time and space complexity, explained simply",
      "- A practice plan using SkillUp Class coding practice"
    ].join("\n")
  },
  {
    id: "career-roadmap-call",
    title: "Career Roadmap Call",
    durationMinutes: 30,
    originalPrice: "999",
    finalPrice: "699",
    description: "For anyone unsure what to learn next. We look at where you are now, where you want to be in a year, and turn that into a 90-day plan with the specific skills, projects and checkpoints to get there.",
    included: [
      "- An honest review of your current skills",
      "- A 90-day plan with weekly checkpoints",
      "- The projects worth building for your target role",
      "- Which SkillUp Class courses and tutorials to follow"
    ].join("\n")
  },
  {
    id: "project-code-review",
    title: "Project Code Review",
    durationMinutes: 45,
    originalPrice: "1500",
    finalPrice: "1100",
    description: "Share a repository and get it reviewed the way a senior engineer would in a pull request: structure and architecture, naming, error handling, tests, and the few changes that would improve it most.",
    included: [
      "- A walkthrough of your repository before the call",
      "- Architecture, structure and naming feedback",
      "- Error handling, testing and security points",
      "- A short list of changes in priority order"
    ].join("\n")
  },
  {
    id: "generative-ai-project-mentoring",
    title: "Generative AI Project Mentoring",
    durationMinutes: 60,
    originalPrice: "1500",
    finalPrice: "1200",
    bundleCount: 3,
    bundlePrice: "2500",
    description: "Help with the AI feature you are building: retrieval-augmented generation, agents or a chat feature. We go through chunking and embeddings, prompt design, evaluation and keeping the cost predictable.",
    included: [
      "- A review of your current approach and data",
      "- Chunking, embeddings and retrieval choices",
      "- Prompt design and how to evaluate the output",
      "- Cost, latency and what to ship first"
    ].join("\n")
  },
  {
    id: "mock-interview-ios",
    title: "Mock Interview: iOS",
    durationMinutes: 60,
    originalPrice: "1500",
    finalPrice: "1200",
    bundleCount: 3,
    bundlePrice: "2500",
    description: "An iOS interview run like the real thing: Swift language details, SwiftUI and UIKit, app architecture, memory and concurrency. You get honest feedback and a short list of what to revise first.",
    included: [
      "- Swift, SwiftUI and UIKit questions at your target level",
      "- Architecture, memory and concurrency discussion",
      "- Written feedback on what to revise first",
      "- Suggested practice for the next two weeks"
    ].join("\n")
  }
];

// The session already on file for a suggestion, by id, address or title.
function findSuggestionCopy(existingSessions = [], suggestion) {
  const title = suggestion.title.toLowerCase();
  return existingSessions.find((session) => session.id === suggestion.id
    || session.slug === suggestion.id
    || String(session.title || "").trim().toLowerCase() === title) || null;
}

// A copy nobody has worked on: still a draft, no fee, and the description
// as this suggestion wrote it. Adding the suggestion again replaces one of
// these, which is how a session left unpriced gets its fee and goes live.
// A session that was edited, priced or published is never touched.
function isUntouchedSuggestionCopy(existing, suggestion) {
  if (!existing || existing.status === "published") return false;
  if (String(existing.finalPrice || "").trim() || String(existing.originalPrice || "").trim()) return false;
  const description = String(existing.description || "").trim();
  return !description || description === suggestion.description;
}

function getRemainingSuggestedSessions(existingSessions = []) {
  return SUGGESTED_SESSIONS.filter((suggestion) => {
    const existing = findSuggestionCopy(existingSessions, suggestion);
    return !existing || isUntouchedSuggestionCopy(existing, suggestion);
  });
}

// The mentor already named on your sessions, so a new draft does not start blank.
function getDefaultSessionMentor(existingSessions = []) {
  const named = existingSessions.find((session) => String(session.mentorName || "").trim());
  return { mentorName: named?.mentorName || "", mentorRole: named?.mentorRole || "" };
}

// Sessions for the chosen suggestions ("all" or one id), placed after the
// sessions you already have. Each carries its fee and goes straight onto the
// 1:1 Sessions page; edit or unpublish any of them afterwards like any other
// session.
function getSuggestedSessionEntries(existingSessions, ids, now = new Date().toISOString()) {
  const wanted = ids === "all" ? null : new Set([].concat(ids));
  const remaining = getRemainingSuggestedSessions(existingSessions).filter((session) => !wanted || wanted.has(session.id));
  const lastOrder = existingSessions.reduce((max, session) => Math.max(max, Number(session.order) || 0), 0);
  const mentor = getDefaultSessionMentor(existingSessions);
  return remaining.map((session, index) => {
    const existing = findSuggestionCopy(existingSessions, session);
    return {
      id: session.id,
      slug: session.id,
      title: session.title,
      description: session.description,
      included: session.included,
      mentorName: mentor.mentorName,
      mentorRole: mentor.mentorRole,
      durationMinutes: session.durationMinutes,
      originalPrice: session.originalPrice || "",
      finalPrice: session.finalPrice || "",
      bundleCount: normalizeSessionBundleCount(session.bundleCount),
      bundlePrice: session.bundlePrice || "",
      coverImage: "",
      coverImagePath: "",
      status: "published",
      order: Number(existing?.order) || lastOrder + index + 1,
      createdAt: existing?.createdAt || now,
      updatedAt: now
    };
  });
}

function areSessionSuggestionsHidden() {
  try {
    return window.localStorage.getItem(SESSION_SUGGESTIONS_HIDDEN_KEY) === "1";
  } catch {
    return false;
  }
}

function setSessionSuggestionsHidden(hidden) {
  try {
    if (hidden) window.localStorage.setItem(SESSION_SUGGESTIONS_HIDDEN_KEY, "1");
    else window.localStorage.removeItem(SESSION_SUGGESTIONS_HIDDEN_KEY);
  } catch {
    // Private windows can refuse storage; the card simply stays visible.
  }
}

function renderSuggestedSessionsCard(existingSessions) {
  const remaining = getRemainingSuggestedSessions(existingSessions);
  if (!remaining.length) return "";
  if (areSessionSuggestionsHidden()) {
    return `<button class="auth-link suggested-courses-show" type="button" data-show-session-suggestions>Show suggested sessions (${remaining.length})</button>`;
  }
  return `
    <section class="suggested-courses" aria-labelledby="suggested-sessions-title">
      <div class="suggested-courses-heading">
        <div>
          <p class="admin-section-kicker">Suggestions</p>
          <h3 id="suggested-sessions-title">Suggested 1:1 sessions</h3>
          <p>Sessions students ask for, with the description, length, fee and what's included already filled in. Adding one puts it straight on your 1:1 Sessions page; you can edit, re-price or unpublish it there like any other session.</p>
        </div>
        <div class="admin-actions">
          <button class="button primary small" type="button" data-add-suggested-session="all">${renderAdminIcon("plus")}<span>Add all ${remaining.length} and publish</span></button>
          <button class="button ghost small" type="button" data-hide-session-suggestions>Hide</button>
        </div>
      </div>
      <ul class="suggested-courses-list">
        ${remaining.map((session) => `
          <li>
            <div>
              <strong>${escapeHtml(session.title)}</strong>
              <small>${escapeHtml([`${session.durationMinutes} mins`, formatCoursePrice(session.finalPrice), session.bundleCount ? `bundle of ${session.bundleCount} for ${formatCoursePrice(session.bundlePrice)}` : ""].filter(Boolean).join(" · "))}</small>
              <span>${escapeHtml(session.description)}</span>
            </div>
            <button class="button ghost small" type="button" data-add-suggested-session="${escapeAttr(session.id)}" aria-label="Add and publish ${escapeAttr(session.title)}">${renderAdminIcon("plus")}<span>Add and publish</span></button>
          </li>
        `).join("")}
      </ul>
    </section>
  `;
}

async function addSuggestedSessions(ids) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  const added = getSuggestedSessionEntries(state.sessions, ids);
  if (!added.length) {
    showToast("These sessions are already in your list.");
    return false;
  }

  if (state.firebaseEnabled) {
    const { doc, writeBatch } = firebase.api;
    const batch = writeBatch(firebase.db);
    added.forEach((session) => batch.set(doc(firebase.db, "sessions", session.id), session));
    await batch.commit();
    await loadSessions({ force: true });
  } else {
    // Same as the batch above, which writes by document id: a session this
    // suggestion already created is replaced, not added a second time.
    const replacements = added.map((session) => normalizeSession(session));
    const replacedIds = new Set(replacements.map((session) => session.id));
    state.sessions = [...state.sessions.filter((session) => !replacedIds.has(session.id)), ...replacements];
  }

  showToast(added.length === 1
    ? `"${added[0].title}" is live on your 1:1 Sessions page.`
    : `${added.length} sessions are live on your 1:1 Sessions page.`);
  render();
  return true;
}

function renderSessionAdminPanel() {
  const sessions = [...state.sessions].sort((a, b) => a.order - b.order);
  if (state.adminEditorOpen) {
    const editing = findSessionById(state.editingSessionId) || {};
    return renderAdminEditorScreen(`
      <form class="admin-form session-admin-form" data-session-form>
        <label><span>Title</span><input name="title" maxlength="140" value="${escapeAttr(editing.title || "")}" placeholder="Example: Mock interview for AI engineers" required /></label>
        <div class="form-grid">
          <label><span>Mentor name</span><input name="mentorName" maxlength="120" value="${escapeAttr(editing.mentorName || "")}" placeholder="Who runs the session" /></label>
          <label><span>Mentor role</span><input name="mentorRole" maxlength="120" value="${escapeAttr(editing.mentorRole || "")}" placeholder="Example: AI Engineer" /></label>
        </div>
        <div class="form-grid">
          <label><span>Duration</span><select name="durationMinutes">${SESSION_DURATIONS.map((minutes) => `<option value="${minutes}" ${Number(editing.durationMinutes || 60) === minutes ? "selected" : ""}>${minutes} mins</option>`).join("")}</select></label>
          <label><span>Order</span><input name="order" type="number" min="1" value="${escapeAttr(editing.order || sessions.length + 1)}" /></label>
        </div>
        <div class="form-grid">
          <label><span>Original price</span><input name="originalPrice" maxlength="40" value="${escapeAttr(editing.originalPrice || "")}" placeholder="Example: 2500" /></label>
          <label><span>Final price</span><input name="finalPrice" maxlength="40" value="${escapeAttr(editing.finalPrice || "")}" placeholder="Example: 999" /></label>
        </div>
        <div class="form-grid">
          <label><span>Bundle</span><select name="bundleCount"><option value="0">No bundle</option>${SESSION_BUNDLE_SIZES.map((count) => `<option value="${count}" ${Number(editing.bundleCount) === count ? "selected" : ""}>${count} sessions</option>`).join("")}</select><small>Sell several sessions together, e.g. 3 mock interviews.</small></label>
          <label><span>Bundle price</span><input name="bundlePrice" maxlength="40" value="${escapeAttr(editing.bundlePrice || "")}" placeholder="Example: 2499" /><small>For all the sessions in the bundle.</small></label>
        </div>
        <label><span>Description</span><textarea name="description" rows="6" maxlength="3000" required>${escapeHtml(editing.description || "")}</textarea><small>Leave a blank line between paragraphs. Start a line with - to make a list.</small></label>
        <label><span>What's included</span><textarea name="included" rows="5" maxlength="2000" placeholder="One point per line">${escapeHtml(editing.included || "")}</textarea><small>One point per line, for example "- A personal learning roadmap".</small></label>
        <label><span>Cover image URL</span><input name="coverImage" type="url" value="${escapeAttr(editing.coverImage || "")}" data-cover-url placeholder="Paste an image URL, upload, or pick from the library" /><input name="coverImagePath" type="hidden" value="${escapeAttr(editing.coverImagePath || "")}" /></label>
        ${renderCoverPreview(editing.coverImage || "")}
        <label class="upload-field"><span>Upload cover image</span><input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-upload-target="coverImage" data-storage-folder="sessions" /></label>
        <div class="session-admin-image-actions">
          <button class="button ghost small" type="button" data-media-library="coverImage">${renderAdminIcon("image")}<span>Choose from library</span></button>
          ${editing.coverImage ? `<button class="button ghost small" type="button" data-clear-image="coverImage">Remove cover</button>` : ""}
        </div>
        <label><span>Status</span><select name="status"><option value="published" ${editing.status === "published" ? "selected" : ""}>Published</option><option value="draft" ${editing.status !== "published" ? "selected" : ""}>Draft</option></select></label>
        ${renderAdminEditorActions({ keepEditing: false })}
      </form>
    `);
  }

  const published = sessions.filter((session) => session.status === "published").length;
  const drafts = sessions.length - published;
  return renderAdminLibraryScreen({
    kicker: "1:1 Sessions",
    title: "Sessions",
    meta: `${sessions.length} ${sessions.length === 1 ? "session" : "sessions"} / ${published} published / ${drafts} ${drafts === 1 ? "draft" : "drafts"}`,
    addLabel: "Add new session",
    addAttribute: "data-new-session",
    searchPlaceholder: "Search sessions",
    showSearch: sessions.length > 6,
    list: `${renderSuggestedSessionsCard(sessions)}<div class="subject-admin-list" aria-label="Sessions">${sessions.map(renderSessionAdminItem).join("") || renderEmptyState("Add your first 1:1 session, for example a mock interview or a resume review.")}</div>`
  });
}

function renderSessionAdminItem(session) {
  const cover = safeUrl(session.coverImage);
  const fee = formatCoursePrice(session.finalPrice) || formatCoursePrice(session.originalPrice) || "No fee set";
  return `
    <div class="subject-admin-item session-admin-item" data-admin-search-item data-search="${escapeAttr(`${session.title} ${session.mentorName}`)}">
      <div class="subject-admin-detail">
        ${cover ? `<img class="admin-list-thumb" src="${escapeAttr(cover)}" alt="" loading="lazy" />` : `<span class="admin-list-placeholder">${escapeHtml(getInitials(session.title))}</span>`}
        <div>
          <strong>${escapeHtml(session.title)}</strong>
          <span>${escapeHtml([`${session.durationMinutes} mins`, fee, hasSessionBundle(session) ? `Bundle of ${session.bundleCount}: ${formatCoursePrice(session.bundlePrice)}` : "", session.mentorName].filter(Boolean).join(" · "))}</span>
        </div>
      </div>
      ${renderStatusBadge(session.status)}
      <div class="admin-actions">
        ${session.status === "published" ? `<a class="button ghost small" href="#sessions/${encodeURIComponent(session.id)}">View</a>` : ""}
        <button class="button ghost small" type="button" data-edit-session="${escapeAttr(session.id)}">${renderAdminIcon("edit")}<span>Edit</span></button>
        <button class="button ghost small" type="button" data-delete-session="${escapeAttr(session.id)}">${renderAdminIcon("trash")}<span>Delete</span></button>
      </div>
    </div>
  `;
}

function sessionPayload(formData) {
  const now = new Date().toISOString();
  const existing = findSessionById(state.editingSessionId);
  const title = String(formData.get("title") || "").trim().slice(0, 140);
  const id = existing?.id || slugify(title);
  const duration = Number(formData.get("durationMinutes"));
  return {
    id,
    slug: id,
    title,
    description: String(formData.get("description") || "").trim().slice(0, 3000),
    included: String(formData.get("included") || "").trim().slice(0, 2000),
    mentorName: String(formData.get("mentorName") || "").trim().slice(0, 120),
    mentorRole: String(formData.get("mentorRole") || "").trim().slice(0, 120),
    durationMinutes: SESSION_DURATIONS.includes(duration) ? duration : 60,
    originalPrice: String(formData.get("originalPrice") || "").trim().slice(0, 40),
    finalPrice: String(formData.get("finalPrice") || "").trim().slice(0, 40),
    bundleCount: normalizeSessionBundleCount(formData.get("bundleCount")),
    bundlePrice: String(formData.get("bundlePrice") || "").trim().slice(0, 40),
    coverImage: String(formData.get("coverImage") || "").trim(),
    coverImagePath: String(formData.get("coverImagePath") || "").trim(),
    status: formData.get("status") === "published" ? "published" : "draft",
    order: Math.max(1, Number(formData.get("order") || existing?.order || state.sessions.length + 1)),
    createdAt: existing?.createdAt || now,
    updatedAt: now
  };
}

async function saveSession(payload) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  if (!payload.title || !payload.id) {
    showToast("Give the session a title.");
    return false;
  }
  if (state.sessions.some((session) => session.id === payload.id && session.id !== state.editingSessionId)) {
    showToast("A session with this title already exists.");
    return false;
  }

  const previous = findSessionById(state.editingSessionId);
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "sessions", payload.id), payload);
    await loadSessions({ force: true });
  } else {
    state.sessions = [...state.sessions.filter((session) => session.id !== payload.id), normalizeSession(payload)];
  }
  await cleanupReplacedStorageFiles(previous, payload);
  state.editingSessionId = null;
  showToast(previous ? "Session updated." : "Session added.");
  render();
  return true;
}

async function deleteSession(id) {
  if (!state.isAdmin) return;
  const session = findSessionById(id);
  if (!session) return;
  if (state.firebaseEnabled) {
    await firebase.api.deleteDoc(firebase.api.doc(firebase.db, "sessions", id));
    await deleteStoredFiles([session.coverImagePath]);
    await loadSessions({ force: true });
  } else {
    state.sessions = state.sessions.filter((item) => item.id !== id);
  }
  showToast("Session deleted. Its existing bookings stay in Session Bookings.");
  render();
}

// ---- Admin: bookings and availability ----

async function loadAdminSessionBookings() {
  if (!state.isAdmin || !state.firebaseEnabled) return;
  try {
    const { collection, getDocs } = firebase.api;
    const snapshot = await getDocs(collection(firebase.db, "sessionBookings"));
    state.adminSessionBookings = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
  } catch (error) {
    console.warn("Could not load session bookings:", error);
  }
}

function renderSessionBookingsAdminPanel() {
  const today = toSessionDateKey(new Date());
  const bookings = [...state.adminSessionBookings].sort((a, b) => String(a.slotKey).localeCompare(String(b.slotKey)));
  const upcoming = bookings.filter((booking) => booking.slotKey >= today && ["requested", "confirmed"].includes(booking.status));
  const past = bookings.filter((booking) => !upcoming.includes(booking)).reverse();
  const waiting = upcoming.filter((booking) => booking.status === "requested").length;
  return `
    <section class="admin-card session-bookings-card">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Session Bookings</p>
          <h2>Upcoming</h2>
          <span>${upcoming.length} upcoming / ${waiting} waiting for you</span>
        </div>
        <div class="admin-actions">
          <button class="button ghost small" type="button" data-export-csv="bookings">${renderAdminIcon("download")}<span>Download CSV</span></button>
          <button class="button ghost small" type="button" data-refresh-session-bookings>Refresh</button>
        </div>
      </div>
      <div class="subject-admin-list" aria-label="Upcoming bookings">${upcoming.map(renderSessionBookingAdminItem).join("") || renderEmptyState("No upcoming bookings yet.")}</div>
      ${past.length ? `
        <details class="session-bookings-past">
          <summary>Past and cancelled (${past.length})</summary>
          <div class="subject-admin-list">${past.map(renderSessionBookingAdminItem).join("")}</div>
        </details>
      ` : ""}
    </section>
    ${renderSessionReviewsAdminCard()}
    ${renderSessionAvailabilityForm()}
  `;
}

function renderSessionBookingAdminItem(booking) {
  const status = booking.status || "requested";
  const open = ["requested", "confirmed"].includes(status);
  const digits = String(booking.mobile || "").replace(/\D/g, "");
  const whatsappNumber = digits.length === 10 ? `91${digits}` : digits;
  const when = formatSessionSlot(booking.slotKey);
  const mailSubject = encodeURIComponent(`Your SkillUp Class session: ${booking.sessionTitle}`);
  const mailBody = encodeURIComponent(`Hi ${booking.name},\n\nThanks for booking "${booking.sessionTitle}" on ${when}.\n\nPayment link:\nMeeting link:\n\nSkillUp Class`);
  return `
    <div class="subject-admin-item session-booking-item${status === "cancelled" ? " is-public-hidden" : ""}" data-admin-search-item data-search="${escapeAttr(`${booking.name} ${booking.email} ${booking.sessionTitle}`)}">
      <div class="subject-admin-detail">
        <div>
          <strong>${escapeHtml(booking.name)} · ${escapeHtml(booking.sessionTitle)}</strong>
          <span>${escapeHtml([when, `${booking.durationMinutes || ""} mins`, describeSessionPlan(booking, state.adminSessionBookings)].filter(Boolean).join(" · "))}</span>
          <small class="session-booking-contact">${escapeHtml(booking.email)} · ${escapeHtml(booking.mobile || "")}</small>
          ${booking.meetingLink ? `<small class="session-booking-contact">Meeting: <a href="${escapeAttr(safeUrl(booking.meetingLink))}" target="_blank" rel="noopener">${escapeHtml(booking.meetingLink)}</a></small>` : ""}
          ${booking.note ? `<small class="session-booking-note-text">${escapeHtml(booking.note)}</small>` : ""}
        </div>
      </div>
      <span class="status-badge session-status-${escapeAttr(status)}">${escapeHtml(SESSION_BOOKING_STATUSES[status] || status)}</span>
      <div class="admin-actions">
        <a class="button ghost small" href="mailto:${escapeAttr(booking.email)}?subject=${mailSubject}&body=${mailBody}">Email</a>
        ${whatsappNumber ? `<a class="button ghost small" href="https://wa.me/${escapeAttr(whatsappNumber)}" target="_blank" rel="noopener">WhatsApp</a>` : ""}
        ${status === "requested" ? `<button class="button primary small" type="button" data-open-booking-modal="${escapeAttr(booking.id)}" data-booking-action="confirmed">Confirm</button>` : ""}
        ${status === "confirmed" ? `<button class="button ghost small" type="button" data-open-booking-modal="${escapeAttr(booking.id)}" data-booking-action="confirmed">Edit links</button>` : ""}
        ${status === "confirmed" ? `<button class="button ghost small" type="button" data-open-booking-modal="${escapeAttr(booking.id)}" data-booking-action="completed">Mark done</button>` : ""}
        ${open ? `<button class="button ghost small" type="button" data-open-booking-modal="${escapeAttr(booking.id)}" data-booking-action="cancelled">Cancel</button>` : ""}
      </div>
    </div>
  `;
}

function renderSessionAvailabilityForm() {
  const settings = normalizeSessionAvailability(state.sessionAvailability || {});
  return `
    <form class="admin-card session-availability-form" data-session-availability-form>
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Availability</p>
          <h2>Weekly booking times</h2>
          <span>India time (IST). Separate times with commas, for example 19:00, 20:00. Leave a day empty to close it.</span>
        </div>
      </div>
      <div class="session-weekday-grid">
        ${SESSION_WEEKDAYS.map((day) => `<label><span>${day.label}</span><input name="weekly-${day.id}" value="${escapeAttr(settings.weekly[day.id].join(", "))}" placeholder="Closed" /></label>`).join("")}
      </div>
      <div class="form-grid">
        <label><span>Book up to (days ahead)</span><input name="bookingWindowDays" type="number" min="1" max="90" value="${settings.bookingWindowDays}" /></label>
        <label><span>Minimum notice (hours)</span><input name="minNoticeHours" type="number" min="0" max="168" value="${settings.minNoticeHours}" /></label>
      </div>
      <label><span>Blocked dates</span><input name="blockedDates" value="${escapeAttr(settings.blockedDates.join(", "))}" placeholder="2026-10-02, 2026-10-20" /><small>Holidays or days off, as YYYY-MM-DD.</small></label>
      <p class="muted">Each booking takes one time. Space the times at least as far apart as your longest session.</p>
      <div class="form-actions"><button class="button primary" type="submit">Save availability</button></div>
    </form>
  `;
}

async function saveSessionAvailability(formData) {
  if (!state.isAdmin) return false;
  const raw = {
    weekly: {},
    bookingWindowDays: formData.get("bookingWindowDays"),
    minNoticeHours: formData.get("minNoticeHours"),
    blockedDates: formData.get("blockedDates")
  };
  SESSION_WEEKDAYS.forEach((day) => {
    raw.weekly[day.id] = formData.get(`weekly-${day.id}`);
  });
  const settings = { ...normalizeSessionAvailability(raw), updatedAt: new Date().toISOString() };
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "siteSettings", "sessionAvailability"), settings);
  }
  state.sessionAvailability = settings;
  const openDays = getOpenSessionSlots(settings, state.takenSessionSlots).length;
  showToast(`Availability saved. ${openDays} ${openDays === 1 ? "day has" : "days have"} open times in the booking window.`);
  render();
  return true;
}

// ---- Admin popups: booking replies and contributor review notes ----------------

function renderAdminPopupShell(attribute, titleId, title, kicker, body) {
  return `
    <div class="admin-modal-overlay" ${attribute}>
      <button class="admin-modal-backdrop" type="button" data-close-admin-popup tabindex="-1" aria-label="Close"></button>
      <div class="admin-modal-dialog admin-popup-dialog" role="dialog" aria-modal="true" aria-labelledby="${titleId}">
        <header class="admin-modal-header">
          <div>
            <p class="admin-section-kicker">${escapeHtml(kicker)}</p>
            <h2 id="${titleId}">${escapeHtml(title)}</h2>
          </div>
          <button class="icon-only-button" type="button" data-close-admin-popup aria-label="Close">&times;</button>
        </header>
        ${body}
      </div>
    </div>
  `;
}

function closeAdminPopup() {
  state.bookingModal = null;
  state.reviewModal = null;
  render();
}

function renderAdminBookingModal() {
  const modal = state.bookingModal;
  if (!modal || !state.isAdmin || state.adminType !== "sessionBookings" || getRoute().page !== "admin") return "";
  const booking = state.adminSessionBookings.find((item) => item.id === modal.bookingId);
  if (!booking) return "";
  const confirming = modal.action === "confirmed";
  const completing = modal.action === "completed";
  const plan = describeSessionPlan(booking, state.adminSessionBookings);
  return renderAdminPopupShell(
    "data-booking-modal",
    "booking-modal-title",
    confirming ? (booking.status === "confirmed" ? "Update booking links" : "Confirm booking") : completing ? "Mark session done" : "Cancel booking",
    `${booking.name} · ${formatSessionSlot(booking.slotKey)}`,
    `
      <form class="admin-popup-form" data-booking-modal-form>
        <p class="muted">${escapeHtml([booking.sessionTitle, plan, booking.email].filter(Boolean).join(" · "))}</p>
        ${confirming && booking.plan === "bundle-session" ? `<p class="muted">This session is part of a bundle the student already has, so leave the payment link empty.</p>` : ""}
        ${confirming ? `
          <label><span>Payment link</span><input name="paymentLink" type="url" maxlength="500" value="${escapeAttr(booking.paymentLink || "")}" placeholder="https://" /></label>
          <label><span>Meeting link</span><input name="meetingLink" type="url" maxlength="500" value="${escapeAttr(booking.meetingLink || "")}" placeholder="https://meet.google.com/..." /></label>
        ` : ""}
        <label><span>${confirming || completing ? "Message to the student" : "Reason, sent to the student"}</span><textarea name="message" rows="3" maxlength="1000" placeholder="Optional"></textarea></label>
        <label class="checkbox-line"><input name="notify" type="checkbox" checked /><span>${completing ? "Email the student a thank-you with a link to review the session" : "Email the student"}</span></label>
        <div class="admin-modal-actions">
          <button class="button ghost" type="button" data-close-admin-popup>Close</button>
          <button class="button primary" type="submit">${confirming ? (booking.status === "confirmed" ? "Save links" : "Confirm booking") : completing ? "Mark done" : "Cancel booking"}</button>
        </div>
      </form>
    `
  );
}

function findContributionItem(type, id) {
  const list = state[type];
  return Array.isArray(list) ? list.find((item) => item.id === id) || null : null;
}

function renderAdminReviewModal() {
  const modal = state.reviewModal;
  if (!modal || !state.isAdmin || getRoute().page !== "admin") return "";
  const item = findContributionItem(modal.type, modal.id);
  if (!item) return "";
  const contributor = state.contributors.find((person) => person.uid && person.uid === item.submittedByUid);
  return renderAdminPopupShell(
    "data-review-modal",
    "review-modal-title",
    "Request changes",
    item.title,
    `
      <form class="admin-popup-form" data-review-modal-form>
        <p class="muted">The draft goes back to ${escapeHtml(item.submittedByName || "the contributor")} with your note. They see it on the draft and can save a new version.</p>
        <label><span>What should change?</span><textarea name="note" rows="4" maxlength="1000" required>${escapeHtml(item.reviewStatus === "changes_requested" ? item.reviewNote : "")}</textarea></label>
        ${contributor?.email ? `<label class="checkbox-line"><input name="notify" type="checkbox" checked /><span>Email ${escapeHtml(contributor.email)}</span></label>` : ""}
        <div class="admin-modal-actions">
          <button class="button ghost" type="button" data-close-admin-popup>Close</button>
          <button class="button primary" type="submit">Send back</button>
        </div>
      </form>
    `
  );
}

// Emails someone from the admin through the mail collection that the Trigger
// Email extension sends from (the admin branch of the mail rule).
async function queueAdminEmail(to, subject, lines) {
  const paragraphs = lines.filter(Boolean);
  const { collection, doc, setDoc } = firebase.api;
  await setDoc(doc(collection(firebase.db, "mail")), {
    to: to.slice(0, 50),
    replyTo: INQUIRY_EMAIL,
    createdAt: new Date().toISOString(),
    message: {
      subject: String(subject).slice(0, 200),
      text: paragraphs.join("\n\n").slice(0, 20000),
      html: paragraphs.map((line) => `<p>${escapeHtml(line)}</p>`).join("").slice(0, 40000)
    }
  });
}

function buildSessionBookingEmail(booking, action, { paymentLink = "", meetingLink = "", message = "", bundleLeft = 0 } = {}) {
  const when = formatSessionSlot(booking.slotKey);
  const sessionLink = `https://skillupclass.com/sessions/${encodeURIComponent(booking.sessionId)}`;
  if (action === "completed") {
    return {
      subject: `Thanks for your session: ${booking.sessionTitle}`,
      lines: [
        `Hi ${booking.name},`,
        `Thanks for joining "${booking.sessionTitle}" on ${when}. We hope it helped.`,
        message,
        `How was it? A short review helps other students choose: ${sessionLink}`,
        bundleLeft > 0 ? `You have ${bundleLeft} ${bundleLeft === 1 ? "session" : "sessions"} left in your bundle. Book the next one on the same page.` : "",
        "SkillUp Class"
      ]
    };
  }
  if (action === "confirmed") {
    return {
      subject: `Confirmed: ${booking.sessionTitle} on ${when}`,
      lines: [
        `Hi ${booking.name},`,
        `Your 1:1 session "${booking.sessionTitle}" is confirmed for ${when} (${booking.durationMinutes} mins).`,
        booking.plan === "bundle" ? `This is the first of the ${booking.bundleCount} sessions in your bundle. Once it is paid, book the others any time: ${sessionLink}` : "",
        booking.plan === "bundle-session" ? "This session is part of your bundle, so there is nothing more to pay." : "",
        message,
        paymentLink ? `Payment link: ${paymentLink}` : "",
        meetingLink ? `Meeting link: ${meetingLink}` : "",
        "You can see your booking any time at https://skillupclass.com/sessions",
        "SkillUp Class"
      ]
    };
  }
  return {
    subject: `Session request update: ${booking.sessionTitle}`,
    lines: [
      `Hi ${booking.name},`,
      `We could not keep your request for "${booking.sessionTitle}" on ${when}, so it has been cancelled.`,
      message,
      `Please pick another time: https://skillupclass.com/sessions/${encodeURIComponent(booking.sessionId)}`,
      "SkillUp Class"
    ]
  };
}

// An https link, "" for empty, or null for anything else (so the form can say
// what is wrong instead of the rules refusing the save).
function toHttpsLink(value) {
  const text = String(value || "").trim();
  if (!text) return "";
  try {
    const url = new URL(text);
    return url.protocol === "https:" && url.href.length <= 500 ? url.href : null;
  } catch {
    return null;
  }
}

async function respondToSessionBooking(formData) {
  const modal = state.bookingModal;
  if (!state.isAdmin || !modal) return false;
  const booking = state.adminSessionBookings.find((item) => item.id === modal.bookingId);
  if (!booking) return false;
  const action = ["confirmed", "completed"].includes(modal.action) ? modal.action : "cancelled";
  const confirming = action === "confirmed";
  const paymentLink = confirming ? toHttpsLink(formData.get("paymentLink")) : "";
  const meetingLink = confirming ? toHttpsLink(formData.get("meetingLink")) : "";
  if (paymentLink === null || meetingLink === null) {
    showToast("Links must be full addresses starting with https://");
    return false;
  }
  const message = String(formData.get("message") || "").trim().slice(0, 1000);
  const notify = formData.get("notify") === "on";
  const updatedAt = new Date().toISOString();

  const { doc, writeBatch } = firebase.api;
  const batch = writeBatch(firebase.db);
  batch.update(doc(firebase.db, "sessionBookings", booking.id), confirming
    ? { status: "confirmed", paymentLink, meetingLink, updatedAt }
    : { status: action, updatedAt });
  // Cancelling frees the time for other students.
  if (action === "cancelled") batch.delete(doc(firebase.db, "sessionSlots", booking.slotKey));
  await batch.commit();
  if (action === "cancelled") state.takenSessionSlots.delete(booking.slotKey);

  let emailed = false;
  if (notify) {
    const bundleId = booking.plan === "bundle" ? booking.id : booking.plan === "bundle-session" ? booking.bundleBookingId : "";
    const bundleLeft = bundleId ? getOpenSessionBundles("", state.adminSessionBookings).find((item) => item.bundle.id === bundleId)?.left || 0 : 0;
    const email = buildSessionBookingEmail(booking, action, { paymentLink, meetingLink, message, bundleLeft });
    emailed = await queueAdminEmail([booking.email], email.subject, email.lines).then(() => true).catch((error) => {
      console.warn("Could not email the student:", error);
      return false;
    });
  }
  state.bookingModal = null;
  await loadAdminSessionBookings();
  showToast(confirming
    ? `Booking ${booking.status === "confirmed" ? "updated" : "confirmed"}${emailed ? " and the student emailed" : ""}.`
    : action === "completed"
      ? `Marked as done${emailed ? " and the student invited to leave a review" : ""}.`
      : `Booking cancelled${emailed ? " and the student emailed" : ""}. The time is open again.`);
  render();
  return true;
}

async function requestContributionChanges(type, id, note, notify) {
  if (!state.isAdmin) return false;
  const item = findContributionItem(type, id);
  const text = String(note || "").trim().slice(0, 1000);
  if (!item || !text) {
    showToast("Add a note about what should change.");
    return false;
  }
  const updatedAt = new Date().toISOString();
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, type, id), { reviewStatus: "changes_requested", reviewNote: text, updatedAt }, { merge: true });
    if (type === "events") await loadEventsForDashboard();
    else await loadContent({ admin: true });
  } else {
    Object.assign(item, { reviewStatus: "changes_requested", reviewNote: text, updatedAt });
  }

  const contributor = state.contributors.find((person) => person.uid && person.uid === item.submittedByUid);
  if (notify && contributor?.email && state.firebaseEnabled) {
    await queueAdminEmail([contributor.email], `Changes requested: ${item.title}`, [
      `Hi ${contributor.name || "there"},`,
      `Thanks for your draft "${item.title}". Before it can be published, please look at this note:`,
      text,
      "Update it from your dashboard: https://skillupclass.com/admin",
      "SkillUp Class"
    ]).catch((error) => console.warn("Could not email the contributor:", error));
  }
  state.reviewModal = null;
  showToast("Sent back to the contributor with your note.");
  render();
  return true;
}

// ---- Session reviews ------------------------------------------------------------

function renderSessionReviewsSection(session) {
  const reviews = state.sessionReviews
    .filter((review) => review.sessionId === session.id && review.status === "published" && review.rating >= 1)
    .sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));
  const form = renderSessionReviewForm(session);
  if (!reviews.length && !form) return "";
  const summary = getSessionRatingSummary(session.id);
  return `
    <section class="session-reviews" aria-labelledby="session-reviews-title">
      <h2 id="session-reviews-title">Reviews</h2>
      ${summary ? `<p class="session-reviews-summary">${renderStars(summary.average)}<strong>${summary.average.toFixed(1)} out of 5</strong><span>from ${summary.count} ${summary.count === 1 ? "student" : "students"}</span></p>` : ""}
      ${form}
      <div class="session-review-list">${reviews.slice(0, 30).map(renderSessionReviewItem).join("")}</div>
    </section>
  `;
}

function renderSessionReviewItem(review) {
  return `
    <article class="session-review">
      <header>
        ${renderStars(review.rating)}
        <strong>${escapeHtml(review.name)}</strong>
        <small>${escapeHtml(formatDate(review.createdAt))}</small>
      </header>
      ${review.body ? `<p>${escapeHtml(review.body)}</p>` : ""}
    </article>
  `;
}

// A student who finished this session reviews it here, once per booking,
// and can edit their review later.
function renderSessionReviewForm(session) {
  if (!hasStudentProgressSync() || !state.mySessionReviewsLoaded) return "";
  const mine = state.mySessionReviews.filter((review) => review.sessionId === session.id);
  const editing = mine.find((review) => review.id === state.editingSessionReviewId) || null;
  const booking = editing ? null : getSessionBookingsToReview(session.id)[0] || null;
  if (!editing && !booking) {
    return mine.map((review) => `
      <div class="session-my-review">
        <span>Your review: ${renderStars(review.rating)}${review.status === "hidden" ? " <small>(hidden by SkillUp Class)</small>" : ""}</span>
        <button class="button ghost small" type="button" data-edit-session-review="${escapeAttr(review.id)}">Edit</button>
      </div>
    `).join("");
  }
  const bookingId = editing ? editing.bookingId : booking.id;
  const rating = editing?.rating || 0;
  const name = state.studentProfile?.name || state.user.displayName || "Student";
  return `
    <form class="session-review-form" data-session-review-form="${escapeAttr(bookingId)}">
      <p class="session-review-form-title"><strong>${editing ? "Edit your review" : "How was your session?"}</strong>${booking ? `<small>${escapeHtml(formatSessionSlot(booking.slotKey))}</small>` : ""}</p>
      <fieldset class="session-star-input">
        <legend>Your rating</legend>
        <div class="session-star-options">
          ${[5, 4, 3, 2, 1].map((value) => `
            <input type="radio" id="session-review-star-${value}" name="rating" value="${value}" ${rating === value ? "checked" : ""} required />
            <label for="session-review-star-${value}" title="${value} out of 5">★<span class="sr-only">${value} out of 5</span></label>
          `).join("")}
        </div>
      </fieldset>
      <label><span>Your review</span><textarea name="body" rows="3" maxlength="1000" placeholder="What helped you most? Would you recommend it?">${escapeHtml(editing?.body || "")}</textarea></label>
      <p class="muted">Shown on this page with your name, ${escapeHtml(name)}.</p>
      <div class="form-actions">
        <button class="button primary" type="submit">${editing ? "Save review" : "Post review"}</button>
        ${editing ? `<button class="button ghost" type="button" data-cancel-session-review-edit>Cancel</button>` : ""}
      </div>
    </form>
  `;
}

async function saveSessionReview(bookingId, formData) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to review a session.");
    return false;
  }
  const rating = Math.round(Number(formData.get("rating")));
  const body = String(formData.get("body") || "").trim().slice(0, 1000);
  if (!(rating >= 1 && rating <= 5)) {
    showToast("Pick a rating from 1 to 5 stars.");
    return false;
  }
  const existing = state.mySessionReviews.find((review) => review.id === bookingId);
  const booking = state.mySessionBookings.find((item) => item.id === bookingId);
  if (!existing && booking?.status !== "completed") {
    showToast("You can review a session once it is done.");
    return false;
  }
  const now = new Date().toISOString();
  const name = String(state.studentProfile?.name || state.user.displayName || "Student").trim().slice(0, 120) || "Student";
  const { doc, setDoc, updateDoc } = firebase.api;
  try {
    if (existing) {
      await updateDoc(doc(firebase.db, "sessionReviews", bookingId), { name, rating, body, updatedAt: now });
    } else {
      await setDoc(doc(firebase.db, "sessionReviews", bookingId), {
        id: bookingId,
        bookingId,
        sessionId: booking.sessionId,
        sessionTitle: String(booking.sessionTitle || "").slice(0, 160),
        uid: state.user.uid,
        name,
        rating,
        body,
        status: "published",
        createdAt: now,
        updatedAt: now
      });
    }
  } catch (error) {
    console.warn("Could not save review:", error);
    showToast("Could not save your review. Please try again.");
    return false;
  }
  state.editingSessionReviewId = null;
  await Promise.all([loadMySessionReviews({ force: true }), loadSessionReviews({ force: true })]);
  showToast(existing ? "Review updated." : "Thanks for your review!");
  render();
  return true;
}

function renderSessionReviewsAdminCard() {
  const reviews = [...state.sessionReviews].sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));
  const hidden = reviews.filter((review) => review.status === "hidden").length;
  const rated = reviews.filter((review) => review.rating >= 1);
  const average = rated.length ? (rated.reduce((sum, review) => sum + review.rating, 0) / rated.length).toFixed(1) : "";
  return `
    <section class="admin-card session-reviews-admin">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Reviews</p>
          <h2>Session reviews</h2>
          <span>${reviews.length} ${reviews.length === 1 ? "review" : "reviews"}${average ? ` / ${average} average` : ""} / ${hidden} hidden</span>
        </div>
      </div>
      <div class="subject-admin-list" aria-label="Session reviews">
        ${reviews.map((review) => `
          <div class="subject-admin-item session-review-admin-item${review.status === "hidden" ? " is-public-hidden" : ""}">
            <div class="subject-admin-detail">
              <div>
                <strong>${renderStars(review.rating)} ${escapeHtml(review.name)} · ${escapeHtml(review.sessionTitle)}</strong>
                <span>${escapeHtml(formatDate(review.createdAt))}${review.status === "hidden" ? " · Hidden from the session page" : ""}</span>
                ${review.body ? `<small class="session-booking-note-text">${escapeHtml(review.body)}</small>` : ""}
              </div>
            </div>
            <div class="admin-actions">
              <button class="button ghost small" type="button" data-session-review-status="${escapeAttr(review.id)}" data-status-next="${review.status === "hidden" ? "published" : "hidden"}">${review.status === "hidden" ? "Show" : "Hide"}</button>
              <button class="button ghost small" type="button" data-delete-session-review="${escapeAttr(review.id)}">${renderAdminIcon("trash")}<span>Delete</span></button>
            </div>
          </div>
        `).join("") || renderEmptyState("Reviews appear here after students rate a finished session. Use Mark done on a booking to invite a review.")}
      </div>
    </section>
  `;
}

async function setSessionReviewStatus(reviewId, status) {
  if (!state.isAdmin || !["published", "hidden"].includes(status)) return false;
  const { doc, updateDoc } = firebase.api;
  await updateDoc(doc(firebase.db, "sessionReviews", reviewId), { status, updatedAt: new Date().toISOString() });
  await loadSessionReviews({ force: true });
  showToast(status === "hidden" ? "Review hidden from the session page." : "Review shown again.");
  render();
  return true;
}

async function deleteSessionReview(reviewId) {
  if (!state.isAdmin) return false;
  const { doc, deleteDoc } = firebase.api;
  await deleteDoc(doc(firebase.db, "sessionReviews", reviewId));
  await loadSessionReviews({ force: true });
  showToast("Review deleted.");
  render();
  return true;
}

// ---- Admin: insights ------------------------------------------------------------

// Numbers for the Insights page, worked out from the records the admin
// screens already load. Pure, so it can be unit-tested with a fixed `now`.
function computeAdminInsights({ students = [], bookings = [], sessions = [], reviews = [], inquiries = [], tutorials = [], problems = [], now = new Date() }) {
  const day = 24 * 60 * 60 * 1000;
  const time = now.getTime();
  const since = (days) => new Date(time - days * day).toISOString();
  const dateKey = (date) => new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "2-digit", day: "2-digit" }).format(date);
  const recentDays = new Set([dateKey(now), dateKey(new Date(time - day))]);
  const tally = (map, key) => map.set(key, (map.get(key) || 0) + 1);
  const top = (map, limit = 5) => [...map.entries()]
    .sort((a, b) => b[1] - a[1] || String(a[0]).localeCompare(String(b[0])))
    .slice(0, limit);
  const titleOf = (list, id) => list.find((item) => item.id === id || item.slug === id)?.title || id;
  const lastSeen = (student) => [student.lastLoginAt, student.lastTutorialAt].filter(Boolean).sort().pop() || "";

  const weekly = Array.from({ length: 8 }, (_, index) => {
    const start = time - (8 - index) * 7 * day;
    const end = start + 7 * day;
    return {
      start: new Date(start).toISOString(),
      count: students.filter((student) => {
        const created = Date.parse(student.createdAt);
        return created >= start && created < end;
      }).length
    };
  });

  const tutorialCounts = new Map();
  const problemCounts = new Map();
  let completions = 0;
  let quizAttempts = 0;
  let solves = 0;
  students.forEach((student) => {
    (student.completedTutorials || []).forEach((id) => { tally(tutorialCounts, id); completions += 1; });
    quizAttempts += Object.keys(student.quizScores || {}).length;
    Object.keys(student.solvedProblems || {}).forEach((slug) => { tally(problemCounts, slug); solves += 1; });
  });

  const statusCounts = { requested: 0, confirmed: 0, completed: 0, cancelled: 0 };
  let fees = 0;
  bookings.forEach((booking) => {
    if (Object.prototype.hasOwnProperty.call(statusCounts, booking.status)) statusCounts[booking.status] += 1;
    if (!["confirmed", "completed"].includes(booking.status) || booking.plan === "bundle-session") return;
    const session = sessions.find((item) => item.id === booking.sessionId);
    if (!session) return;
    fees += parseSessionPrice(booking.plan === "bundle" ? session.bundlePrice : session.finalPrice || session.originalPrice);
  });
  const rated = reviews.filter((review) => review.rating >= 1);

  const courseCounts = new Map();
  inquiries.forEach((inquiry) => tally(courseCounts, String(inquiry.course || "").trim() || "Not specified"));

  return {
    students: {
      total: students.length,
      new7: students.filter((student) => String(student.createdAt) >= since(7)).length,
      new30: students.filter((student) => String(student.createdAt) >= since(30)).length,
      active7: students.filter((student) => lastSeen(student) >= since(7)).length,
      weekly
    },
    learning: {
      completions,
      learners: students.filter((student) => (student.completedTutorials || []).length).length,
      streaks: students.filter((student) => (student.activityDates || []).some((key) => recentDays.has(key))).length,
      quizAttempts,
      topTutorials: top(tutorialCounts).map(([id, count]) => ({ title: titleOf(tutorials, id), count }))
    },
    coding: {
      solvers: students.filter((student) => Object.keys(student.solvedProblems || {}).length).length,
      solves,
      topProblems: top(problemCounts).map(([slug, count]) => ({ title: titleOf(problems, slug), count }))
    },
    sessions: {
      ...statusCounts,
      bundles: bookings.filter((booking) => booking.plan === "bundle" && booking.status !== "cancelled").length,
      fees,
      reviews: rated.length,
      rating: rated.length ? Math.round((rated.reduce((sum, review) => sum + review.rating, 0) / rated.length) * 10) / 10 : 0
    },
    inquiries: {
      total: inquiries.length,
      last30: inquiries.filter((inquiry) => String(inquiry.createdAt) >= since(30)).length,
      open: inquiries.filter((inquiry) => inquiry.status === "new").length,
      topCourses: top(courseCounts).map(([title, count]) => ({ title, count }))
    }
  };
}

// Counts that need a server query (the admin screens do not load these
// records): certificates, and community activity in the last 30 days.
async function loadAdminInsights({ force = false } = {}) {
  if (!state.isAdmin || !state.firebaseEnabled) return false;
  if (state.adminInsights && !force) return false;
  const since = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
  const { collection, query, where, getCountFromServer } = firebase.api;
  const count = (name, ...constraints) => getCountFromServer(query(collection(firebase.db, name), ...constraints))
    .then((snapshot) => snapshot.data().count)
    .catch((error) => {
      console.warn(`Could not count ${name}:`, error);
      return null;
    });
  const [certificates, comments30, posts30, memberships] = await Promise.all([
    count("certificates"),
    count("comments", where("createdAt", ">=", since)),
    count("communityPosts", where("createdAt", ">=", since)),
    count("communityMemberships")
  ]);
  state.adminInsights = { certificates, comments30, posts30, memberships, loadedAt: new Date().toISOString() };
  return true;
}

function renderInsightsList(items, emptyText) {
  if (!items.length) return `<p class="muted">${escapeHtml(emptyText)}</p>`;
  return `<ol class="insights-list">${items.map((item) => `<li><span>${escapeHtml(item.title)}</span><strong>${item.count}</strong></li>`).join("")}</ol>`;
}

function renderAdminInsightsPanel() {
  const insights = computeAdminInsights({
    students: state.students,
    bookings: state.adminSessionBookings,
    sessions: state.sessions,
    reviews: state.sessionReviews,
    inquiries: state.inquiries,
    tutorials: state.articles,
    problems: state.codingProblems,
    now: new Date()
  });
  const server = state.adminInsights || {};
  const shown = (value) => (value === null || value === undefined ? "–" : String(value));
  const maxWeek = Math.max(1, ...insights.students.weekly.map((week) => week.count));
  const weekLabel = (iso) => new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short" }).format(new Date(iso));
  const tile = (label, value, detail) => `
    <article class="insights-tile">
      <small>${escapeHtml(label)}</small>
      <strong>${escapeHtml(String(value))}</strong>
      <span>${escapeHtml(detail)}</span>
    </article>
  `;
  const stat = (label, value) => `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(String(value))}</dd></div>`;
  const { students, learning, coding, sessions, inquiries } = insights;
  return `
    <div class="insights-panel">
      <div class="insights-toolbar">
        <span class="muted">${state.adminInsights ? `Counted ${escapeHtml(formatRelativeTime(state.adminInsights.loadedAt))}` : "Counting..."}. Progress, streaks and solved problems come from signed-in students.</span>
        <button class="button ghost small" type="button" data-refresh-insights>Refresh</button>
      </div>
      <div class="insights-tiles">
        ${tile("Students", students.total, `+${students.new7} this week · +${students.new30} in 30 days`)}
        ${tile("Active this week", students.active7, "Signed in or studied in the last 7 days")}
        ${tile("Tutorials completed", learning.completions, `by ${learning.learners} ${learning.learners === 1 ? "student" : "students"}`)}
        ${tile("Coding problems solved", coding.solves, `by ${coding.solvers} ${coding.solvers === 1 ? "student" : "students"}`)}
        ${tile("Session requests waiting", sessions.requested, `${sessions.confirmed} confirmed · ${sessions.completed} done`)}
        ${tile("Session fees", formatCoursePrice(String(Math.round(sessions.fees))) || "Rs. 0", "Confirmed and done, at current prices")}
      </div>
      <section class="admin-card insights-card">
        <h2>New students per week</h2>
        <div class="insights-bars" role="img" aria-label="New students in each of the last 8 weeks: ${students.weekly.map((week) => week.count).join(", ")}">
          ${students.weekly.map((week) => `
            <div class="insights-bar">
              <div class="insights-bar-track"><span class="insights-bar-fill" style="height: ${Math.round((week.count / maxWeek) * 100)}%"><b>${week.count}</b></span></div>
              <small>${escapeHtml(weekLabel(week.start))}</small>
            </div>
          `).join("")}
        </div>
      </section>
      <div class="insights-cards">
        <section class="admin-card insights-card">
          <h2>Learning</h2>
          <dl class="insights-stats">
            ${stat("Learning streaks going", learning.streaks)}
            ${stat("Quizzes taken", learning.quizAttempts)}
            ${stat("Certificates issued", shown(server.certificates))}
          </dl>
          <h3>Most completed tutorials</h3>
          ${renderInsightsList(learning.topTutorials, "No completed tutorials yet.")}
        </section>
        <section class="admin-card insights-card">
          <h2>Coding practice</h2>
          <h3>Most solved problems</h3>
          ${renderInsightsList(coding.topProblems, "No solved problems yet.")}
        </section>
        <section class="admin-card insights-card">
          <h2>1:1 Sessions</h2>
          <dl class="insights-stats">
            ${stat("Waiting for you", sessions.requested)}
            ${stat("Confirmed", sessions.confirmed)}
            ${stat("Done", sessions.completed)}
            ${stat("Cancelled", sessions.cancelled)}
            ${stat("Bundles sold", sessions.bundles)}
            ${stat("Average rating", sessions.reviews ? `${sessions.rating.toFixed(1)} from ${sessions.reviews}` : "No reviews yet")}
          </dl>
        </section>
        <section class="admin-card insights-card">
          <h2>Community</h2>
          <dl class="insights-stats">
            ${stat("Community memberships", shown(server.memberships))}
            ${stat("Community posts, last 30 days", shown(server.posts30))}
            ${stat("Tutorial and blog comments, last 30 days", shown(server.comments30))}
          </dl>
        </section>
        <section class="admin-card insights-card">
          <h2>Course inquiries</h2>
          <dl class="insights-stats">
            ${stat("In the inbox", inquiries.total)}
            ${stat("Last 30 days", inquiries.last30)}
            ${stat("New, not yet handled", inquiries.open)}
          </dl>
          <h3>Most asked-about courses</h3>
          ${renderInsightsList(inquiries.topCourses, "No inquiries yet.")}
        </section>
      </div>
    </div>
  `;
}

// ---- Admin: CSV downloads -------------------------------------------------------

// One spreadsheet cell. A value starting with = + - or @ gets an apostrophe in
// front, so spreadsheet apps show it as text instead of running it as a formula.
function toCsvCell(value) {
  let text = value === null || value === undefined ? "" : String(value);
  if (/^[=+\-@]/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

function toCsv(rows) {
  return rows.map((row) => row.map(toCsvCell).join(",")).join("\r\n");
}

function downloadCsv(filename, rows) {
  // The byte-order mark makes Excel read the file as UTF-8.
  const blob = new Blob([`﻿${toCsv(rows)}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function exportAdminCsv(kind) {
  if (!state.isAdmin) return;
  const date = toSessionDateKey(new Date());
  if (kind === "students") {
    downloadCsv(`skillup-students-${date}.csv`, [
      ["Name", "Email", "Mobile", "Profession", "Organisation", "Experience", "Degree", "College", "Registered", "Last login", "Tutorials completed"],
      ...state.students.map((student) => [
        student.name, student.email, student.mobileNo, student.profession, student.currentOrganisation, student.experienceLevel,
        student.currentDegree, student.collegeName, student.createdAt, student.lastLoginAt, (student.completedTutorials || []).length
      ])
    ]);
  } else if (kind === "inquiries") {
    downloadCsv(`skillup-inquiries-${date}.csv`, [
      ["Name", "Email", "Phone", "Course", "City", "Goal", "Message", "Status", "Pinned", "Received"],
      ...state.inquiries.map((inquiry) => [
        inquiry.name, inquiry.email, inquiry.phone, inquiry.course, inquiry.city, inquiry.goal, inquiry.message,
        inquiry.status, inquiry.pinned ? "Yes" : "No", inquiry.createdAt
      ])
    ]);
  } else if (kind === "bookings") {
    downloadCsv(`skillup-session-bookings-${date}.csv`, [
      ["Session", "When (IST)", "Minutes", "Plan", "Name", "Email", "Mobile", "Note", "Status", "Payment link", "Meeting link", "Requested"],
      ...[...state.adminSessionBookings]
        .sort((a, b) => String(a.slotKey).localeCompare(String(b.slotKey)))
        .map((booking) => [
          booking.sessionTitle, formatSessionSlot(booking.slotKey), booking.durationMinutes,
          describeSessionPlan(booking, state.adminSessionBookings) || "Single session", booking.name, booking.email, booking.mobile,
          booking.note, SESSION_BOOKING_STATUSES[booking.status] || booking.status, booking.paymentLink, booking.meetingLink, booking.createdAt
        ])
    ]);
  } else {
    return;
  }
  showToast("Download started.");
}

// ---- Author credit ----------------------------------------------------------------

// "Written by" on published tutorials and blog posts that a contributor sent
// in, linking to their author page.
function renderAuthorCredit(item) {
  if (!item?.submittedByUid || !item.submittedByName || item.status !== "published") return "";
  return `<span>${icon("edit-3")}Written by <a href="#authors/${encodeURIComponent(item.submittedByUid)}">${escapeHtml(item.submittedByName)}</a></span>`;
}

function getAuthorPublications(uid) {
  const mine = (items) => items.filter((item) => item.submittedByUid === uid);
  return {
    tutorials: mine(getPublicTutorials()),
    blogs: mine(getPublished(state.blogs)),
    courses: mine(getPublicCourses()),
    codingProblems: mine(getPublished(state.codingProblems))
  };
}

function renderAuthorPage(uid) {
  const works = getAuthorPublications(uid);
  const all = [...works.tutorials, ...works.blogs, ...works.courses, ...works.codingProblems];
  if (!all.length) {
    const loading = state.firebaseEnabled && !loadedPublicCollections.has("articles");
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Author</p>
        <h1>${loading ? "Loading..." : "Nothing published yet."}</h1>
        <p>${loading ? "Please wait while SkillUp Class loads this page." : "This author has no published work on SkillUp Class yet."}</p>
        <a class="button primary" href="#tutorials">Browse tutorials</a>
      </section>
    `;
  }
  const group = (title, items, hrefFor) => items.length ? `
    <div class="author-works-group">
      <h2>${escapeHtml(title)}</h2>
      <ul class="author-works">
        ${items.map((item) => `
          <li>
            <a href="${hrefFor(item)}">${escapeHtml(item.title)}</a>
            ${item.excerpt || item.description ? `<small>${escapeHtml(summarizeFormattedText(item.excerpt || item.description, 140))}</small>` : ""}
          </li>
        `).join("")}
      </ul>
    </div>
  ` : "";
  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Author</p>
      <h1>${escapeHtml(all[0].submittedByName)}</h1>
      <p>${all.length} published ${all.length === 1 ? "piece" : "pieces"} on SkillUp Class.</p>
    </section>
    <section class="section-band author-page">
      ${group("Tutorials", works.tutorials, (item) => `#tutorials/${encodeURIComponent(item.id)}`)}
      ${group("Blog posts", works.blogs, (item) => `#blog/${encodeURIComponent(item.id)}`)}
      ${group("Courses", works.courses, (item) => `#courses/${encodeURIComponent(item.id)}`)}
      ${group("Coding problems", works.codingProblems, (item) => `#coding-practice/${encodeURIComponent(item.slug || item.id)}`)}
    </section>
  `;
}

// ---- Learning activity: continue reading, streaks, quiz scores -------------------

function getLocalDateKey(date = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "2-digit", day: "2-digit" }).format(date);
}

// Consecutive days with learning activity, ending today - or yesterday, so a
// streak is not lost in the morning before today's lesson.
function computeLearningStreak(dates = [], today = getLocalDateKey()) {
  const days = new Set(dates);
  let cursor = days.has(today) ? today : addDaysToDateKey(today, -1);
  let streak = 0;
  while (days.has(cursor)) {
    streak += 1;
    cursor = addDaysToDateKey(cursor, -1);
  }
  return streak;
}

function computeBestStreak(dates = []) {
  let best = 0;
  let run = 0;
  let previous = "";
  [...new Set(dates)].sort().forEach((day) => {
    run = previous && addDaysToDateKey(previous, 1) === day ? run + 1 : 1;
    best = Math.max(best, run);
    previous = day;
  });
  return best;
}

// The last lesson opened, the days with activity and the quiz scores: on the
// student record when signed in, in this browser otherwise.
function readLearningActivity() {
  if (hasStudentProgressSync()) {
    const profile = state.studentProfile || {};
    return {
      lastTutorialId: String(profile.lastTutorialId || ""),
      lastTutorialAt: String(profile.lastTutorialAt || ""),
      activityDates: Array.isArray(profile.activityDates) ? profile.activityDates : [],
      quizScores: profile.quizScores && typeof profile.quizScores === "object" ? profile.quizScores : {}
    };
  }
  let stored = {};
  try {
    stored = JSON.parse(localStorage.getItem(PROGRESS_STORAGE_KEY)) || {};
  } catch {
    stored = {};
  }
  return {
    lastTutorialId: String(stored.lastTutorialId || ""),
    lastTutorialAt: String(stored.lastTutorialAt || ""),
    activityDates: Array.isArray(stored.activityDates) ? stored.activityDates : [],
    quizScores: readQuizAttempts()
  };
}

// Records today as a learning day and, when given, the lesson just opened.
// Writes only when something changed, so re-rendering a lesson costs nothing.
async function recordLearningActivity({ tutorialId = "" } = {}) {
  if (state.isAdmin || state.isContributor) return;
  const activity = readLearningActivity();
  const today = getLocalDateKey();
  const changes = {};
  if (!activity.activityDates.includes(today)) {
    changes.activityDates = [...activity.activityDates, today].sort().slice(-400);
  }
  if (tutorialId && tutorialId !== activity.lastTutorialId) {
    changes.lastTutorialId = String(tutorialId).slice(0, 200);
    changes.lastTutorialAt = new Date().toISOString();
  }
  if (!Object.keys(changes).length) return;

  if (hasStudentProgressSync()) {
    const now = new Date().toISOString();
    try {
      await firebase.api.updateDoc(firebase.api.doc(firebase.db, "students", state.user.uid), { ...changes, updatedAt: now });
      state.studentProfile = { ...state.studentProfile, ...changes, updatedAt: now };
    } catch (error) {
      console.warn("Could not save learning activity:", error);
    }
  } else {
    writeProgressData(changes);
  }
}

function renderHomeContinueLearning() {
  if (state.isAdmin || state.isContributor) return "";
  const activity = readLearningActivity();
  const tutorials = getPublicTutorials();
  const lastTutorial = activity.lastTutorialId ? tutorials.find((item) => item.id === activity.lastTutorialId) : null;
  if (!lastTutorial) return "";

  const subjectTutorials = sortTutorials(tutorials.filter((item) => item.category === lastTutorial.category));
  const completed = new Set(readProgressData().completedTutorials);
  const progress = getSubjectProgress(subjectTutorials);
  const streak = computeLearningStreak(activity.activityDates);
  const next = completed.has(lastTutorial.id) ? subjectTutorials.find((item) => !completed.has(item.id)) : lastTutorial;
  const target = next || lastTutorial;
  const actionLabel = !next ? "Review" : next.id !== lastTutorial.id ? "Start next lesson" : "Continue";
  return `
    <section class="section-band home-continue" aria-labelledby="home-continue-title">
      <div class="home-continue-card">
        <div class="home-continue-copy">
          <p class="eyebrow">Continue learning</p>
          <h2 id="home-continue-title">${escapeHtml(target.title)}</h2>
          <p>${escapeHtml(lastTutorial.category)} · ${progress.completed}/${progress.total} lessons done${streak ? ` · ${streak}-day streak` : ""}</p>
          <span class="subject-progress-track"><span style="width:${progress.percent}%"></span></span>
        </div>
        <a class="button primary" href="#tutorials/${encodeURIComponent(target.id)}">${actionLabel}</a>
      </div>
    </section>
  `;
}

function renderLearningStreakCard() {
  const activity = readLearningActivity();
  const current = computeLearningStreak(activity.activityDates);
  const best = computeBestStreak(activity.activityDates);
  const today = getLocalDateKey();
  const days = new Set(activity.activityDates);
  const week = Array.from({ length: 7 }, (_, index) => addDaysToDateKey(today, index - 6));
  const dayName = (day, style) => new Intl.DateTimeFormat("en-IN", { weekday: style }).format(new Date(`${day}T12:00:00`));
  return `
    <article class="admin-card student-streak-card">
      <p class="eyebrow">Learning streak</p>
      <h3>${current} ${current === 1 ? "day" : "days"} in a row</h3>
      <div class="streak-week">
        ${week.map((day) => `<span class="${days.has(day) ? "is-active" : ""}" role="img" aria-label="${escapeAttr(`${dayName(day, "long")}${days.has(day) ? ", learned" : ""}`)}">${escapeHtml(dayName(day, "narrow"))}</span>`).join("")}
      </div>
      <p class="muted">Best streak: ${best} ${best === 1 ? "day" : "days"}. Read a lesson, finish one or take a quiz to keep it going.</p>
    </article>
  `;
}

function renderQuizScoresCard() {
  const scores = readLearningActivity().quizScores;
  const tutorials = getPublicTutorials();
  const entries = Object.entries(scores)
    .map(([id, entry]) => ({ tutorial: tutorials.find((item) => item.id === id), entry }))
    .filter((item) => item.tutorial && Number(item.entry?.total) > 0)
    .sort((a, b) => String(b.entry.attemptedAt || "").localeCompare(String(a.entry.attemptedAt || "")));
  const bestOf = (entry) => Number(entry.best ?? entry.score ?? 0);
  const average = entries.length
    ? Math.round((entries.reduce((sum, { entry }) => sum + bestOf(entry) / entry.total, 0) / entries.length) * 100)
    : 0;
  return `
    <article class="admin-card student-quiz-card">
      <p class="eyebrow">Quiz scores</p>
      <h3>${entries.length ? `${average}% average best score` : "No quizzes yet"}</h3>
      <div class="student-quiz-list">
        ${entries.slice(0, 6).map(({ tutorial, entry }) => `
          <a href="#tutorials/${encodeURIComponent(tutorial.id)}">
            <strong>${escapeHtml(tutorial.title)}</strong>
            <small>Best ${bestOf(entry)}/${entry.total} · Last ${Number(entry.score || 0)}/${entry.total}</small>
          </a>
        `).join("") || renderEmptyState("Take the practice quiz at the end of a tutorial and your scores show here.")}
      </div>
    </article>
  `;
}

// ---- Certificates of completion ----------------------------------------------------

const CERTIFICATE_MIN_TUTORIALS = 3;

function getCertificateId(uid, subjectId) {
  return `${uid}_${subjectId}`;
}

function getCertificateUrl(id) {
  return `https://skillupclass.com/certificates/${encodeURIComponent(id)}`;
}

// LinkedIn's "Add licence or certification" form, filled in.
function getLinkedInCertificationUrl(certificate) {
  const issued = new Date(certificate.issuedAt);
  const params = new URLSearchParams({
    startTask: "CERTIFICATION_NAME",
    name: `${certificate.subjectTitle} (SkillUp Class)`,
    organizationName: "SkillUp Class",
    issueYear: String(issued.getFullYear()),
    issueMonth: String(issued.getMonth() + 1),
    certUrl: getCertificateUrl(certificate.id),
    certId: certificate.id
  });
  return `https://www.linkedin.com/profile/add?${params.toString()}`;
}

// Subjects this student has finished: every published tutorial done, and at
// least CERTIFICATE_MIN_TUTORIALS of them.
function getCompletedSubjects() {
  const completed = new Set(readProgressData().completedTutorials);
  const tutorials = getPublicTutorials();
  return getPublicSubjects()
    .map((subject) => ({ subject, tutorials: tutorials.filter((tutorial) => tutorial.category === subject.title) }))
    .filter((item) => item.tutorials.length >= CERTIFICATE_MIN_TUTORIALS && item.tutorials.every((tutorial) => completed.has(tutorial.id)));
}

async function loadMyCertificates({ force = false } = {}) {
  if (!state.firebaseEnabled || !state.user || state.isAdmin) return false;
  if (state.myCertificates && !force) return false;
  try {
    const { collection, getDocs, query, where } = firebase.api;
    const snapshot = await getDocs(query(collection(firebase.db, "certificates"), where("uid", "==", state.user.uid)));
    state.myCertificates = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
    state.myCertificates.forEach((certificate) => { state.certificateCache[certificate.id] = certificate; });
    return true;
  } catch (error) {
    console.warn("Could not load your certificates:", error);
    state.myCertificates = [];
    return false;
  }
}

async function loadCertificate(id) {
  if (!state.firebaseEnabled || Object.prototype.hasOwnProperty.call(state.certificateCache, id)) return false;
  try {
    const snapshot = await firebase.api.getDoc(firebase.api.doc(firebase.db, "certificates", id));
    state.certificateCache[id] = snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
  } catch (error) {
    console.warn("Could not load certificate:", error);
    state.certificateCache[id] = null;
  }
  return true;
}

function scheduleCertificateLoad(route) {
  if (!state.firebaseEnabled) return;
  if (route.page === "certificates" && route.id) {
    loadCertificate(route.id).then((changed) => { if (changed) render(); });
  }
  if (route.page === "profile" && state.user && !state.isAdmin) {
    loadMyCertificates().then((changed) => { if (changed) render(); });
  }
}

function renderCertificatesCard() {
  const eligible = getCompletedSubjects();
  const issued = state.myCertificates || [];
  const canIssue = hasStudentProgressSync();
  const issuedLink = (certificate) => `
    <a class="student-certificate" href="#certificates/${encodeURIComponent(certificate.id)}">
      <strong>${escapeHtml(certificate.subjectTitle)}</strong>
      <small>Earned ${escapeHtml(formatDate(certificate.issuedAt))} · View and share</small>
    </a>
  `;
  const rows = [
    ...eligible.map(({ subject, tutorials }) => {
      const certificate = issued.find((item) => item.subjectId === subject.id);
      if (certificate) return issuedLink(certificate);
      return `
        <div class="student-certificate">
          <strong>${escapeHtml(subject.title)}</strong>
          <small>All ${tutorials.length} tutorials done</small>
          ${canIssue ? `<button class="button primary small" type="button" data-claim-certificate="${escapeAttr(subject.id)}">Get certificate</button>` : `<small>Log in to get your certificate.</small>`}
        </div>
      `;
    }),
    ...issued.filter((certificate) => !eligible.some(({ subject }) => subject.id === certificate.subjectId)).map(issuedLink)
  ];
  return `
    <article class="admin-card student-certificates-card">
      <p class="eyebrow">Certificates</p>
      <h3>${issued.length ? `${issued.length} earned` : eligible.length ? "Ready to claim" : "Finish a subject to earn one"}</h3>
      <div class="student-certificate-list">${rows.join("")}</div>
      ${rows.length ? "" : `<p class="muted">Complete every tutorial in a subject (at least ${CERTIFICATE_MIN_TUTORIALS}) and its certificate unlocks here.</p>`}
    </article>
  `;
}

async function claimCertificate(subjectId) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to get a certificate.");
    return false;
  }
  if (!isEmailVerified()) {
    promptEmailVerification("get a certificate");
    return false;
  }
  const match = getCompletedSubjects().find(({ subject }) => subject.id === subjectId);
  if (!match) {
    showToast("Finish every tutorial in this subject first.");
    return false;
  }
  const id = getCertificateId(state.user.uid, subjectId);
  const certificate = {
    id,
    uid: state.user.uid,
    name: state.studentProfile.name,
    subjectId,
    subjectTitle: match.subject.title.slice(0, 160),
    tutorialCount: match.tutorials.length,
    issuedAt: new Date().toISOString()
  };
  try {
    await firebase.api.setDoc(firebase.api.doc(firebase.db, "certificates", id), certificate);
  } catch (error) {
    console.warn("Could not create certificate:", error);
    showToast("Could not create the certificate. Check that your profile has your name, then try again.");
    return false;
  }
  state.myCertificates = [...(state.myCertificates || []).filter((item) => item.id !== id), certificate];
  state.certificateCache[id] = certificate;
  navigateTo(`/certificates/${encodeURIComponent(id)}`);
  return true;
}

function renderCertificatePage(id) {
  const certificate = state.certificateCache[id];
  if (certificate === undefined) {
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Certificate</p>
        <h1>Checking certificate...</h1>
      </section>
    `;
  }
  if (!certificate) {
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Certificate</p>
        <h1>Certificate not found.</h1>
        <p>This link does not match a SkillUp Class certificate.</p>
        <a class="button primary" href="#tutorials">Browse tutorials</a>
      </section>
    `;
  }
  const url = getCertificateUrl(certificate.id);
  const isOwner = state.user?.uid === certificate.uid;
  return `
    <section class="section-band certificate-page">
      <div class="certificate-card">
        <img class="certificate-mark" src="/assets/skillup-mark.png" alt="" />
        <p class="certificate-kicker">Certificate of completion</p>
        <p class="certificate-line">This certifies that</p>
        <h1 class="certificate-name">${escapeHtml(certificate.name)}</h1>
        <p class="certificate-line">completed every tutorial in</p>
        <h2 class="certificate-subject">${escapeHtml(certificate.subjectTitle)}</h2>
        <p class="certificate-meta">${escapeHtml(String(certificate.tutorialCount))} tutorials · Issued ${escapeHtml(formatDate(certificate.issuedAt))} · SkillUp Class</p>
        <p class="certificate-id">Certificate ID: ${escapeHtml(certificate.id)}</p>
      </div>
      <div class="certificate-actions">
        <p class="certificate-verified">Issued by SkillUp Class. Anyone with this link can check it.</p>
        ${isOwner ? `
          <button class="button primary" type="button" data-download-certificate="${escapeAttr(certificate.id)}">Download image</button>
          <a class="button ghost" href="${escapeAttr(getLinkedInCertificationUrl(certificate))}" target="_blank" rel="noopener">Add to LinkedIn</a>
        ` : ""}
        <button class="button ghost" type="button" data-copy-certificate-link="${escapeAttr(url)}">Copy link</button>
      </div>
    </section>
  `;
}

function loadImageElement(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

// Draws the certificate as a 1600x1130 PNG (A-series landscape proportions)
// for saving or posting.
async function downloadCertificateImage(id) {
  const certificate = state.certificateCache[id];
  if (!certificate) return false;
  if (document.fonts?.ready) await document.fonts.ready;
  const width = 1600;
  const height = 1130;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  const background = context.createLinearGradient(0, 0, width, height);
  background.addColorStop(0, "#071323");
  background.addColorStop(1, "#10284a");
  context.fillStyle = background;
  context.fillRect(0, 0, width, height);
  context.strokeStyle = "#a7f36d";
  context.lineWidth = 6;
  context.strokeRect(40, 40, width - 80, height - 80);
  context.strokeStyle = "rgba(167, 243, 109, 0.35)";
  context.lineWidth = 2;
  context.strokeRect(62, 62, width - 124, height - 124);
  const logo = await loadImageElement("/assets/skillup-mark.png").catch(() => null);
  if (logo) context.drawImage(logo, width / 2 - 60, 110, 120, 120);
  context.textAlign = "center";
  const line = (text, y, font, color) => {
    context.font = font;
    context.fillStyle = color;
    context.fillText(text, width / 2, y, width - 240);
  };
  line("CERTIFICATE OF COMPLETION", 300, "700 34px Poppins, Arial, sans-serif", "#a7f36d");
  line("This certifies that", 390, "400 30px Inter, Arial, sans-serif", "rgba(255, 255, 255, 0.8)");
  line(certificate.name, 490, "800 76px Poppins, Arial, sans-serif", "#ffffff");
  line("completed every tutorial in", 580, "400 30px Inter, Arial, sans-serif", "rgba(255, 255, 255, 0.8)");
  line(certificate.subjectTitle, 670, "700 56px Poppins, Arial, sans-serif", "#ffffff");
  line(`${certificate.tutorialCount} tutorials · Issued ${formatDate(certificate.issuedAt)}`, 780, "500 28px Inter, Arial, sans-serif", "rgba(255, 255, 255, 0.85)");
  line("SkillUp Class", 880, "700 36px Poppins, Arial, sans-serif", "#ffffff");
  line(`Check it: ${getCertificateUrl(certificate.id)}`, 1000, "400 22px Inter, Arial, sans-serif", "rgba(255, 255, 255, 0.7)");

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!blob) {
    showToast("Could not create the image in this browser.");
    return false;
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `skillup-certificate-${certificate.subjectId}.png`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  return true;
}

// ---- Helpful votes and accepted answers ----------------------------------------------

// The accepted answer first, then the most helpful, then oldest first.
function sortThreadReplies(replies, parent) {
  return [...replies].sort((a, b) => {
    const acceptedA = parent?.acceptedReplyId === a.id ? 1 : 0;
    const acceptedB = parent?.acceptedReplyId === b.id ? 1 : 0;
    if (acceptedA !== acceptedB) return acceptedB - acceptedA;
    const votes = (Number(b.upvoteCount) || 0) - (Number(a.upvoteCount) || 0);
    if (votes) return votes;
    return String(a.createdAt).localeCompare(String(b.createdAt));
  });
}

function renderHelpfulControl(item, canInteract, isOwn, dataAttributes) {
  const count = Number(item.upvoteCount) || 0;
  if (!canInteract || isOwn || state.isAdmin) {
    return count ? `<span class="helpful-count">${count} found this helpful</span>` : "";
  }
  const voted = Boolean(state.user && item.upvotedBy?.includes(state.user.uid));
  return `<button type="button" class="helpful-button${voted ? " is-voted" : ""}" ${dataAttributes} aria-pressed="${voted}">Helpful${count ? ` · ${count}` : ""}</button>`;
}

// Only the person who asked sees this, on the replies in their own thread.
function renderAcceptControl(reply, parent, dataAttributes) {
  if (!parent || !state.user || parent.authorUid !== state.user.uid || !hasStudentProgressSync()) return "";
  const accepted = parent.acceptedReplyId === reply.id;
  return `<button type="button" class="accept-button${accepted ? " is-accepted" : ""}" ${dataAttributes} aria-pressed="${accepted}">${accepted ? "Accepted answer" : "Mark as answer"}</button>`;
}

function findDiscussionItem(contentType, contentId, id) {
  return (state.discussionComments[getDiscussionKey(contentType, contentId)] || []).find((item) => item.id === id) || null;
}

function findCommunityPostItem(communityId, id) {
  return (state.communityPosts[communityId] || []).find((item) => item.id === id) || null;
}

// arrayUnion/arrayRemove and increment keep the vote right even when this
// page's copy of the voter list is out of date.
async function toggleHelpfulVote(collectionName, item) {
  if (!hasStudentProgressSync()) {
    showToast("Login as a student to vote.");
    return;
  }
  if (!item || item.authorUid === state.user.uid) return;
  const uid = state.user.uid;
  const voted = item.upvotedBy.includes(uid);
  const { doc, updateDoc, arrayUnion, arrayRemove, increment } = firebase.api;
  try {
    await updateDoc(doc(firebase.db, collectionName, item.id), {
      upvotedBy: voted ? arrayRemove(uid) : arrayUnion(uid),
      upvoteCount: increment(voted ? -1 : 1)
    });
    item.upvotedBy = voted ? item.upvotedBy.filter((value) => value !== uid) : [...item.upvotedBy, uid];
    item.upvoteCount = Math.max(0, (Number(item.upvoteCount) || 0) + (voted ? -1 : 1));
    render();
  } catch (error) {
    showToast("Could not save your vote. Please try again.");
    console.warn("Could not save vote:", error);
  }
}

async function setAcceptedReply(collectionName, thread, replyId) {
  if (!hasStudentProgressSync() || !thread || thread.authorUid !== state.user.uid) return;
  const next = thread.acceptedReplyId === replyId ? null : replyId;
  try {
    await firebase.api.updateDoc(firebase.api.doc(firebase.db, collectionName, thread.id), { acceptedReplyId: next });
    thread.acceptedReplyId = next;
    showToast(next ? "Marked as the accepted answer." : "Accepted answer cleared.");
    render();
  } catch (error) {
    showToast("Could not update the accepted answer. Please try again.");
    console.warn("Could not update accepted answer:", error);
  }
}

// ---- Coding practice leaderboard -----------------------------------------------------

let codingLeaderboardRequest = null;
let solvedProblemsMergedFor = "";

function loadCodingLeaderboard({ force = false } = {}) {
  if (!state.firebaseEnabled || !state.user) return Promise.resolve(false);
  if (state.codingLeaderboard && !force) return Promise.resolve(false);
  if (!codingLeaderboardRequest) {
    codingLeaderboardRequest = fetchCodingLeaderboard().finally(() => { codingLeaderboardRequest = null; });
  }
  return codingLeaderboardRequest;
}

async function fetchCodingLeaderboard() {
  // Problems solved in this browser before signing in count too: copy them to
  // the account once per sign-in, before reading the board.
  if (hasStudentProgressSync() && solvedProblemsMergedFor !== state.user.uid) {
    solvedProblemsMergedFor = state.user.uid;
    const merged = getPracticeSolvedMap();
    const account = state.studentProfile.solvedProblems || {};
    if (Object.keys(merged).some((slug) => !account[slug])) await syncSolvedProblems(merged);
  }
  try {
    const { collection, getDocs, query, where, orderBy, limit } = firebase.api;
    const snapshot = await getDocs(query(
      collection(firebase.db, "publicProfiles"),
      where("solvedCount", ">", 0),
      orderBy("solvedCount", "desc"),
      limit(10)
    ));
    state.codingLeaderboard = snapshot.docs.map((docSnap) => normalizePublicProfile({ uid: docSnap.id, ...docSnap.data() }));
    return true;
  } catch (error) {
    console.warn("Could not load the leaderboard:", error);
    state.codingLeaderboard = [];
    return true;
  }
}

function scheduleLeaderboardLoad(route) {
  if (!state.firebaseEnabled || !state.user) return;
  if (!["practice", "coding", "coding-round", "coding-practice"].includes(route.page) || route.id) return;
  loadCodingLeaderboard().then((changed) => { if (changed) render(); });
}

function renderCodingLeaderboard() {
  if (!state.user || state.isAdmin) return "";
  const leaders = state.codingLeaderboard;
  const mySolved = Object.keys(getPracticeSolvedMap()).length;
  const myRank = leaders ? leaders.findIndex((person) => person.uid === state.user.uid) + 1 : 0;
  return `
    <aside class="coding-leaderboard" aria-labelledby="coding-leaderboard-title">
      <h2 id="coding-leaderboard-title">Top solvers</h2>
      ${leaders === null
        ? `<p class="muted">Loading...</p>`
        : leaders.length
          ? `<ol>${leaders.map((person, index) => `
              <li class="${person.uid === state.user.uid ? "is-me" : ""}">
                <span class="coding-leaderboard-rank">${index + 1}</span>
                <span class="coding-leaderboard-name">${escapeHtml(person.name)}</span>
                <strong>${person.solvedCount}</strong>
              </li>
            `).join("")}</ol>`
          : `<p class="muted">Solve a problem to be first on the board.</p>`}
      <p class="coding-leaderboard-me">You have solved ${mySolved} ${mySolved === 1 ? "problem" : "problems"}${myRank ? ` · rank ${myRank}` : ""}.</p>
    </aside>
  `;
}

function renderCommunityPage(id = "") {
  return id ? renderCommunityDetailPage(id) : renderCommunityListPage();
}

function renderCommunityListPage() {
  const communities = getPublicCommunities();

  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Students Hub</p>
      <h1>Share your ideas and learn with other students, not just alone.</h1>
      <p>Post what you're building, ask questions, swap feedback, and see who else is learning the same thing. Pick a topic below to get started.</p>
    </section>
    <section class="section-band">
      <div class="community-list-grid">
        ${communities.map(renderCommunityCard).join("") || renderEmptyState("No communities are open yet. Check back soon.")}
      </div>
    </section>
  `;
}

// A community can carry an uploaded logo; the icon is the fallback.
function renderCommunityMark(community, className) {
  const logo = safeUrl(community.logoImage);
  return logo
    ? `<span class="${className} has-logo"><img src="${escapeAttr(logo)}" alt="" loading="lazy" /></span>`
    : `<span class="${className}">${icon(community.icon)}</span>`;
}

function renderCommunityCard(community) {
  const isMember = isCommunityMember(community.id);
  return `
    <article class="community-card${isMember ? " is-member" : ""}" data-reveal>
      <div class="community-card-top">
        ${renderCommunityMark(community, "community-card-icon")}
        ${isMember ? `<span class="community-card-badge">Joined</span>` : ""}
      </div>
      <h3>${escapeHtml(community.title)}</h3>
      <p>${escapeHtml(community.description || "Join to discuss and meet other learners.")}</p>
      <a class="button ${isMember ? "ghost" : "primary"} community-card-button" href="#community/${encodeURIComponent(community.id)}">${isMember ? "Open community" : "View community"}</a>
    </article>
  `;
}

function renderCommunityDetailPage(communityId) {
  const community = findCommunityById(communityId);
  if (!community || (community.status !== "published" && !state.isAdmin)) {
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Students Hub</p>
        <h1>${state.communitiesLoaded ? "Community not found." : "Loading community..."}</h1>
        <p>${state.communitiesLoaded ? "This community may have been removed." : "Please wait while SkillUp Class loads communities."}</p>
        <a class="button primary" href="#community">Back to Students Hub</a>
      </section>
    `;
  }

  const isMember = isCommunityMember(community.id);
  const members = state.communityMembers[community.id] || [];

  return `
    <section class="community-detail-header section-band dark-band">
      ${renderCommunityMark(community, "community-detail-icon")}
      <div data-reveal>
        <p class="eyebrow">Students Hub</p>
        <h1>${escapeHtml(community.title)}</h1>
        <p>${escapeHtml(community.description || "Discuss and meet other learners here.")}</p>
        <div class="community-detail-meta">
          <span>${members.length ? `${members.length} ${members.length === 1 ? "member" : "members"}` : "Be the first to join"}</span>
          ${hasStudentProgressSync()
            ? isMember
              ? `<button class="button ghost small" type="button" data-leave-community="${escapeAttr(community.id)}">Leave community</button>`
              : ""
            : `<a class="button primary small" href="#community">Login to join</a>`}
        </div>
      </div>
    </section>
    ${hasStudentProgressSync() && !isMember && !isBlockedFromArea("community")
      ? `<section class="section-band community-policy-band">${renderCommunityPolicyPanel(community.id)}</section>`
      : ""}
    ${hasStudentProgressSync() && !isMember && isBlockedFromArea("community")
      ? `<section class="section-band community-policy-band">${renderBlockedNotice("community")}</section>`
      : ""}
    <section class="section-band community-detail-body">
      ${renderCommunityWhatsappCta(community)}
      ${renderCommunityDiscussionSection(community.id)}
      ${renderCommunityMemberDirectory(community.id)}
    </section>
  `;
}

function renderCommunityDiscussionSection(communityId) {
  const isLoading = state.communityPostLoading.has(communityId);
  const loadError = state.communityPostError[communityId];
  const allPosts = state.communityPosts[communityId] || [];
  const topLevel = allPosts.filter((post) => !post.parentId);
  const repliesByParent = new Map();
  allPosts.forEach((post) => {
    if (!post.parentId) return;
    if (!repliesByParent.has(post.parentId)) repliesByParent.set(post.parentId, []);
    repliesByParent.get(post.parentId).push(post);
  });

  const isLoggedIn = hasStudentProgressSync();
  const isMember = isCommunityMember(communityId);
  const canInteract = isLoggedIn && isMember;
  const context = { canInteract, replyTargetId: state.communityPostReplyTarget[communityId] || "" };
  const postCountLabel = allPosts.length
    ? `${allPosts.length} ${allPosts.length === 1 ? "post" : "posts"}`
    : "Be the first to post";

  return `
    <section class="discussion-section" data-community-scope data-community-id="${escapeAttr(communityId)}" data-reveal>
      <div class="discussion-heading">
        <h3>${icon("message-circle")}<span>Discussion</span></h3>
        <span class="discussion-count">${escapeHtml(postCountLabel)}</span>
      </div>

      ${canInteract && isBlockedFromArea("community") ? renderBlockedNotice("community") : ""}

      ${canInteract && !isBlockedFromArea("community") ? `
        <form class="discussion-composer" data-community-discussion-form>
          <textarea name="body" placeholder="Ask a question or share what you're building..." maxlength="2000" required>${escapeHtml(state.pendingSuspicious[communityId] || "")}</textarea>
          ${renderSuspiciousWarning(communityId, state.pendingSuspicious[communityId] || "")}
          <div class="discussion-composer-actions">
            <button class="button primary small" type="submit">Post</button>
          </div>
        </form>
      ` : canInteract ? "" : `
        <div class="discussion-login-prompt">
          <p>${isLoggedIn ? "Join this community to post." : "Login as a student to join the discussion."}</p>
          <a class="button primary small" href="#community">${isLoggedIn ? "Join" : "Login"}</a>
        </div>
      `}

      ${loadError ? `
        <p class="form-error discussion-error">
          <span>${escapeHtml(loadError)}</span>
          <button type="button" class="link-button" data-retry-community-posts>Retry</button>
        </p>
      ` : ""}

      <div class="discussion-list">
        ${isLoading && !allPosts.length ? `<p class="discussion-status">Loading discussion...</p>` : ""}
        ${!isLoading && !loadError && !topLevel.length ? `<p class="discussion-status">No posts yet. Start the conversation.</p>` : ""}
        ${topLevel.map((post) => renderCommunityPostItem(post, repliesByParent.get(post.id) || [], context, true)).join("")}
      </div>
    </section>
  `;
}

function renderCommunityPostItem(post, replies, context, allowReply, parent = null) {
  const { canInteract, replyTargetId } = context;
  const isOwn = Boolean(state.user && post.authorUid === state.user.uid);
  const canModerate = state.isAdmin || isOwn;
  const hasFlagged = Boolean(state.user && post.flaggedBy.includes(state.user.uid));

  return `
    <article class="discussion-comment" data-post-id="${escapeAttr(post.id)}">
      <span class="discussion-avatar">${escapeHtml(getInitials(post.authorName))}</span>
      <div class="discussion-comment-body">
        <div class="discussion-comment-meta">
          <strong>${escapeHtml(post.authorName)}</strong>
          <small>${escapeHtml(formatRelativeTime(post.createdAt))}</small>
          ${parent?.acceptedReplyId === post.id ? `<span class="accepted-answer-badge">Accepted answer</span>` : ""}
        </div>
        <p>${escapeHtml(post.body)}</p>
        <div class="discussion-comment-actions">
          ${renderHelpfulControl(post, canInteract, isOwn, `data-vote-post="${escapeAttr(post.id)}" data-community-id="${escapeAttr(post.communityId)}"`)}
          ${renderAcceptControl(post, parent, `data-accept-post="${escapeAttr(post.id)}" data-thread-id="${escapeAttr(parent?.id || "")}" data-community-id="${escapeAttr(post.communityId)}"`)}
          ${canInteract && allowReply ? `<button type="button" data-reply-community-post="${escapeAttr(post.id)}">Reply</button>` : ""}
          ${canInteract && !isOwn ? `<button type="button" data-flag-community-post="${escapeAttr(post.id)}" ${hasFlagged ? "disabled" : ""}>${hasFlagged ? "Reported" : "Report"}</button>` : ""}
          ${canModerate ? `<button type="button" class="is-danger" data-delete-community-post="${escapeAttr(post.id)}">Delete</button>` : ""}
        </div>
        ${replyTargetId === post.id ? `
          <form class="discussion-reply-form" data-community-discussion-reply-form data-parent-id="${escapeAttr(post.id)}">
            <textarea name="body" placeholder="Write a reply..." maxlength="2000" required></textarea>
            <div class="discussion-composer-actions">
              <button class="button ghost small" type="button" data-cancel-community-reply>Cancel</button>
              <button class="button primary small" type="submit">Post reply</button>
            </div>
          </form>
        ` : ""}
        ${replies.length ? `
          <div class="discussion-replies">
            ${sortThreadReplies(replies, post).map((reply) => renderCommunityPostItem(reply, [], context, false, post)).join("")}
          </div>
        ` : ""}
      </div>
    </article>
  `;
}

function renderCommunityMemberDirectory(communityId) {
  const isLoading = state.communityMemberLoading.has(communityId);
  const loadError = state.communityMemberError[communityId];
  const members = state.communityMembers[communityId] || [];

  return `
    <section class="community-member-directory" data-reveal>
      <div class="discussion-heading">
        <h3>${icon("users")}<span>Members</span></h3>
        <span class="discussion-count">${members.length ? `${members.length} ${members.length === 1 ? "member" : "members"}` : ""}</span>
      </div>
      ${loadError ? `<p class="form-error">${escapeHtml(loadError)}</p>` : ""}
      ${isLoading && !members.length ? `<p class="discussion-status">Loading members...</p>` : ""}
      ${!isLoading && !loadError && !members.length ? `<p class="discussion-status">No members yet. Be the first to join.</p>` : ""}
      <div class="community-member-grid">
        ${members.map((member) => renderCommunityMemberCard(member)).join("")}
      </div>
    </section>
  `;
}

function renderCommunityMemberCard(member) {
  // Sourced only from publicProfiles, never from state.students - this is
  // the structural guarantee that email/mobileNo can never render here,
  // not just a UI choice (see publicProfiles rule + buildPublicProfilePayload).
  const profile = state.publicProfiles[member.uid];
  const experienceLabel = profile?.experienceLevel === "fresher" ? "Fresher" : profile?.experienceLevel || "";
  const fresherDetails = profile?.experienceLevel === "fresher" ? `
        <span><small>Degree</small><strong>${escapeHtml(profile.currentDegree || "Not provided")}</strong></span>
        <span><small>College</small><strong>${escapeHtml(profile.collegeName || "Not provided")}</strong></span>
      ` : "";

  return `
    <article class="community-member-card">
      <span class="community-member-avatar">${escapeHtml(getInitials(profile?.name || member.memberName))}</span>
      <div>
        <strong>${escapeHtml(profile?.name || member.memberName)}</strong>
        <small>${member.joinedAt ? `Joined ${escapeHtml(formatDate(member.joinedAt))}` : "Member"}</small>
      </div>
      ${profile ? `
        <div class="community-member-meta">
          ${profile.profession ? `<span><small>Profession</small><strong>${escapeHtml(profile.profession)}</strong></span>` : ""}
          ${profile.currentOrganisation ? `<span><small>Organisation</small><strong>${escapeHtml(profile.currentOrganisation)}</strong></span>` : ""}
          ${experienceLabel ? `<span><small>Experience</small><strong>${escapeHtml(experienceLabel)}</strong></span>` : ""}
          ${fresherDetails}
        </div>
      ` : ""}
    </article>
  `;
}

function renderBlogPage(id = "") {
  const blogsReady = isPublicCollectionReady("blogs");
  const blogs = getPublished(state.blogs).sort(sortNewest);
  const selectedBlog = id ? blogs.find((item) => item.id === id || item.slug === id) : null;

  if (id && !selectedBlog) {
    return `
      <section class="page-title section-band dark-band slim">
        <p class="eyebrow">Blog</p>
        <h1>${blogsReady ? "Blog post not found." : "Loading blog post..."}</h1>
        <p>${blogsReady ? "This post may be unpublished or removed." : "Please wait while SkillUp Class loads blog posts."}</p>
        <a class="button primary" href="#blog">Back to blog</a>
      </section>
    `;
  }

  if (selectedBlog) {
    const related = blogs.filter((item) => item.id !== selectedBlog.id).slice(0, 3);
    const coverUrl = safeUrl(selectedBlog.coverImage) || getCategoryFallbackCover(selectedBlog.category, selectedBlog.title);
    return `
      <section class="blog-detail-hero section-band dark-band">
        <div data-reveal>
          <p class="eyebrow">${escapeHtml(selectedBlog.category || "SkillUp Blog")}</p>
          <h1>${escapeHtml(selectedBlog.title)}</h1>
          <p>${escapeHtml(selectedBlog.excerpt)}</p>
          <div class="meta-row">
            <span>${icon("calendar")}${formatDate(selectedBlog.publishedAt || selectedBlog.updatedAt)}</span>
            <span>${icon("clock")}${getReadTime(selectedBlog.body)} min read</span>
            ${renderAuthorCredit(selectedBlog)}
          </div>
        </div>
        ${coverUrl ? `<img src="${escapeAttr(coverUrl)}" alt="${escapeAttr(selectedBlog.title)}" data-managed-image data-reveal />` : ""}
      </section>
      <section class="section-band blog-detail-layout">
        <article class="tutorial-reader-body blog-reader-body" data-reveal>
          ${renderYouTubePlayer(selectedBlog)}
          ${renderReaderArticle(selectedBlog.body, selectedBlog.title)}
          ${renderTutorialAttachment(selectedBlog)}
        </article>
        ${related.length ? `
          <aside class="blog-related" data-reveal>
            <span>More posts</span>
            ${related.map((blog) => `<a href="#blog/${encodeURIComponent(blog.id)}"><strong>${escapeHtml(blog.title)}</strong><small>${escapeHtml(blog.category || "Blog")}</small></a>`).join("")}
          </aside>
        ` : ""}
        ${renderDiscussionSection("blog", selectedBlog.id, selectedBlog.title)}
      </section>
    `;
  }

  const categories = getCategories(blogs);
  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">SkillUp Blog</p>
      <h1>Independent articles, announcements, and learning notes.</h1>
    </section>
    <section class="section-band" data-filter-scope>
      <div class="toolbar" data-reveal>
        <label>
          <span>Search</span>
          <input type="search" data-live-search placeholder="Search blog posts" />
        </label>
        <label>
          <span>Category</span>
          <select data-live-category>
            <option value="all">All categories</option>
            ${categories.map((category) => `<option value="${escapeAttr(category)}">${escapeHtml(category)}</option>`).join("")}
          </select>
        </label>
      </div>
      <div class="blog-grid blog-list-view">
        ${blogs.map(renderBlogCard).join("") || renderEmptyState(blogsReady ? "No blog posts are published yet." : "Loading blog posts...")}
      </div>
      <p class="filter-empty" data-filter-empty>No matching blog posts found.</p>
    </section>
  `;
}

function renderBlogCard(blog) {
  const coverUrl = safeUrl(blog.coverImage) || getCategoryFallbackCover(blog.category, blog.title, ...toArray(blog.tags));
  const searchText = [blog.title, blog.category, blog.excerpt, ...toArray(blog.tags)].join(" ");
  return `
    <article class="blog-card" data-reveal data-filter-card data-category="${escapeAttr(blog.category)}" data-search="${escapeAttr(searchText)}">
      <a href="#blog/${encodeURIComponent(blog.id)}">
        <div class="blog-card-visual has-cover">
          <img src="${escapeAttr(coverUrl)}" alt="" data-managed-image />
          <span>${escapeHtml(blog.category || "Blog")}</span>
        </div>
        <div class="card-body">
          <div class="tag-row">
            <span>${formatDate(blog.publishedAt || blog.updatedAt)}</span>
            <span>${getReadTime(blog.body)} min read</span>
          </div>
          <h3>${escapeHtml(blog.title)}</h3>
          <p>${escapeHtml(blog.excerpt)}</p>
          <span class="blog-card-read-more">Read the post ${icon("arrow-right")}</span>
        </div>
      </a>
    </article>
  `;
}

function buildHomeSearchItems() {
  const items = [...buildSearchItems()];
  if (isPublicTabVisible("coding-practice")) {
    const codingPracticeItems = getCodingPracticeItems();
    items.push({
      type: "Coding Practice",
      title: "Coding Practice",
      description: "DSA and coding-round challenges with a multi-language editor and local progress tracking.",
      meta: "Practice / Editor",
      href: "#coding-practice",
      searchText: ["Coding Practice", "DSA", "coding round", "leetcode", "hackerrank", "programs", "arrays", "strings", "dynamic programming", ...codingPracticeItems.map((item) => item.title)].join(" ")
    });
  }
  return items;
}
function renderHomeSearchTitleResult(item, query = "", options = {}) {
  const overLimit = options.limit && query && options.matchRank > options.limit;
  const hidden = (options.compact && !query) || overLimit || (query && !matchesSearch(item.searchText, query)) ? " hidden" : "";
  return `
    <a class="home-search-title-result" href="${escapeAttr(item.href)}" data-search-result data-search="${escapeAttr(item.searchText)}" data-reveal${hidden}>
      ${escapeHtml(item.title)}
    </a>
  `;
}

function renderHomeSearchSection() {
  const route = getRoute();
  const query = route.page === "home" ? String(route.query?.get("q") || "").trim().toLowerCase() : "";
  const items = query
    ? [...buildHomeSearchItems()].sort((a, b) => searchScore(b, query) - searchScore(a, query))
    : buildHomeSearchItems();
  const visibleCount = query ? items.filter((item) => matchesSearch(item.searchText, query)).length : 0;
  let matchRank = 0;

  return `
    <section class="home-search-section" data-site-search-scope data-search-empty-mode="compact" data-search-limit="15">
      <div class="home-search-card is-search-only" data-reveal>
        <label class="site-search-box home-site-search-box">
          <span>Search SkillUp Class</span>
          <input type="search" data-site-search value="${escapeAttr(query)}" placeholder="Search courses, tutorials, blogs..." />
        </label>
        <div class="search-result-summary home-search-summary" data-search-summary ${query ? "" : "hidden"}>${formatSearchSummary(visibleCount, Math.min(visibleCount, 15), 15)}</div>
        <div class="home-search-title-list" data-search-results>
          ${items.map((item) => {
            const matches = query && matchesSearch(item.searchText, query);
            const rank = matches ? ++matchRank : 0;
            return renderHomeSearchTitleResult(item, query, { compact: true, limit: 15, matchRank: rank });
          }).join("") || renderEmptyState("No searchable content is published yet.")}
        </div>
      </div>
    </section>
  `;
}
function renderSearchPage() {
  const route = getRoute();
  const query = String(route.query?.get("q") || "").trim().toLowerCase();
  const items = query
    ? [...buildSearchItems()].sort((a, b) => searchScore(b, query) - searchScore(a, query))
    : buildSearchItems();
  const visibleCount = query ? items.filter((item) => matchesSearch(item.searchText, query)).length : items.length;
  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Search SkillUp Class</p>
      <h1>Find courses, tutorials, and blog posts quickly.</h1>
    </section>
    <section class="section-band search-page">
      <label class="site-search-box" data-reveal>
        <span>Search all content</span>
        <input type="search" data-site-search value="${escapeAttr(query)}" placeholder="Search RAG, machine learning, LLMs, Python..." autofocus />
      </label>
      <div class="search-result-summary" data-search-summary>${query ? `${visibleCount} result${visibleCount === 1 ? "" : "s"} found` : `${items.length} learning items available`}</div>
      <div class="search-results" data-search-results>
        ${items.map((item) => renderSearchResult(item, query)).join("") || renderEmptyState("No searchable content is published yet.")}
      </div>
    </section>
  `;
}

function buildSearchItems() {
  const courseItems = isPublicTabVisible("courses") ? getPublicCourses().map((course) => ({
    type: "Course",
    title: course.title,
    description: course.description || course.outcome,
    meta: `${course.category || "General"} / ${course.level || "Course"}`,
    href: `#courses/${encodeURIComponent(course.id)}`,
    searchText: [course.title, course.description, course.outcome, course.category, course.level, ...toArray(course.topics)].join(" ")
  })) : [];
  const tutorialItems = isPublicTabVisible("tutorials") ? getPublicTutorials().map((tutorial) => ({
    type: "Tutorial",
    title: tutorial.title,
    description: tutorial.excerpt,
    meta: `${tutorial.category || "General"} / ${getReadTime(tutorial.body)} min read`,
    href: `#tutorials/${encodeURIComponent(tutorial.id)}`,
    searchText: [tutorial.title, tutorial.excerpt, tutorial.body, tutorial.category, ...toArray(tutorial.tags)].join(" ")
  })) : [];
  const blogItems = isPublicTabVisible("blog") ? getPublished(state.blogs).map((blog) => ({
    type: "Blog",
    title: blog.title,
    description: blog.excerpt,
    meta: `${blog.category || "Blog"} / ${getReadTime(blog.body)} min read`,
    href: `#blog/${encodeURIComponent(blog.id)}`,
    searchText: [blog.title, blog.excerpt, blog.body, blog.category, ...toArray(blog.tags)].join(" ")
  })) : [];

  return [...courseItems, ...tutorialItems, ...blogItems].sort((a, b) => a.title.localeCompare(b.title));
}
function renderSearchResult(item, query = "", options = {}) {
  const overLimit = options.limit && query && options.matchRank > options.limit;
  const hidden = (options.compact && !query) || overLimit || (query && !matchesSearch(item.searchText, query)) ? " hidden" : "";
  return `
    <a class="search-result-card" href="${escapeAttr(item.href)}" data-search-result data-search="${escapeAttr(item.searchText)}" data-reveal${hidden}>
      <span>${escapeHtml(item.type)}</span>
      <strong>${escapeHtml(item.title)}</strong>
      <p>${escapeHtml(item.description || "Open this learning item.")}</p>
      <small>${escapeHtml(item.meta)}</small>
    </a>
  `;
}

// Search matching. This used to be a single `haystack.includes(query)`, so
// "clean architecture" found three items and "architecture clean" found
// none - the right words in the wrong order read to a student as "this site
// has nothing". Every whitespace-separated token now has to appear in the
// item, in any order, and each has to match at the start of a word: plain
// substring matching made short queries useless, because "rag" matched
// three unrelated courses by sitting inside "leverage".
function searchTokens(query) {
  return String(query || "").toLowerCase().split(/\s+/).filter(Boolean);
}

// Tokens match at the start of a word, not anywhere inside one. Plain
// substring matching made short queries useless - "rag" matched three
// unrelated courses because it sits inside "leverage". Prefix matching
// still lets a half-typed word find its item ("kotl" finds "Kotlin").
function matchesSearch(haystack, query) {
  const tokens = searchTokens(query);
  if (!tokens.length) return false;
  const text = String(haystack || "").toLowerCase();
  return tokens.every((token) => wordStartPattern(token).test(text));
}

// Cached because this runs for every item on every keystroke.
const searchPatternCache = new Map();

function wordStartPattern(token) {
  let pattern = searchPatternCache.get(token);
  if (!pattern) {
    const safe = token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    pattern = new RegExp("(^|[^a-z0-9])" + safe);
    searchPatternCache.set(token, pattern);
  }
  return pattern;
}

// A title hit is worth more than a body hit, so exact-phrase and
// title matches float to the top of a limited list.
function searchScore(item, query) {
  const text = String(item?.searchText || "").toLowerCase();
  const title = String(item?.title || "").toLowerCase();
  const q = String(query || "").toLowerCase().trim();
  let score = 0;
  if (title.includes(q)) score += 4;
  if (text.includes(q)) score += 2;
  if (title.startsWith(q)) score += 2;
  const tokens = searchTokens(q);
  score += tokens.filter((token) => title.includes(token)).length;
  return score;
}

function formatSearchSummary(total, shown = total, limit = 0) {
  if (limit && total > shown) return `Showing top ${shown} of ${total} results`;
  return `${total} result${total === 1 ? "" : "s"} found`;
}

function applySiteSearch(input) {
  const scope = input.closest("[data-site-search-scope]") || document;
  const query = String(input.value || "").trim().toLowerCase();
  const compactWhenEmpty = scope.dataset?.searchEmptyMode === "compact";
  const limit = Number(scope.dataset?.searchLimit || 0);
  const results = [...scope.querySelectorAll("[data-search-result]")];
  let matched = 0;
  let visible = 0;

  results.forEach((item) => {
    const matches = !query ? !compactWhenEmpty : matchesSearch(item.dataset.search, query);
    if (matches) matched += 1;
    const underLimit = !limit || matched <= limit;
    item.hidden = !(matches && underLimit);
    if (matches && underLimit) visible += 1;
  });

  const summary = scope.querySelector("[data-search-summary]");
  if (summary) {
    summary.hidden = compactWhenEmpty && !query;
    summary.textContent = query
      ? formatSearchSummary(matched, visible, limit)
      : compactWhenEmpty
        ? ""
        : `${results.length} learning items available`;
  }
}
function renderInquiryPage() {
  const courses = getPublicCourses();

  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">Course inquiry</p>
      <h1>Tell us what you want to learn next.</h1>
    </section>
    <section class="inquiry-shell section-band">
      <div class="inquiry-copy" data-reveal>
        <span class="kicker">Student details</span>
        <h2>We will help you choose the right course path.</h2>
        <p>
          Share your contact details, course interest, and current learning goal. The SkillUp Class team can use this
          information to follow up with suitable guidance.
        </p>
        <div class="inquiry-points">
          <span>${icon("compass")}Course guidance</span>
          <span>${icon("code")}Project-based learning</span>
          <span>${icon("target")}Interview preparation</span>
        </div>
      </div>
      <form class="admin-card inquiry-form" data-inquiry-form data-reveal>
        <div class="form-grid">
          <label>
            <span>Full name</span>
            <input name="name" autocomplete="name" required />
          </label>
          <label>
            <span>Email</span>
            <input name="email" type="email" autocomplete="email" required />
          </label>
        </div>
        <div class="form-grid">
          <label>
            <span>Phone</span>
            <input name="phone" type="tel" autocomplete="tel" required />
          </label>
          <label>
            <span>Interested course</span>
            <select name="course" required>
              <option value="">Select a course</option>
              <option value="AI learning path">AI learning path (Python, ML, GenAI, RAG, agents)</option>
              ${courses.map((course) => `<option value="${escapeAttr(course.title)}">${escapeHtml(course.title)}</option>`).join("")}
              <option value="Not sure yet">Not sure yet</option>
            </select>
          </label>
        </div>
        <div class="form-grid">
          <label>
            <span>City</span>
            <input name="city" autocomplete="address-level2" />
          </label>
          <label>
            <span>Learning goal</span>
            <select name="goal">
              <option value="Career switch">Career switch</option>
              <option value="Project portfolio">Project portfolio</option>
              <option value="Interview preparation">Interview preparation</option>
              <option value="College learning">College learning</option>
            </select>
          </label>
        </div>
        <label>
          <span>Message</span>
          <textarea name="message" rows="4" placeholder="Tell us your current skill level or preferred course timing."></textarea>
        </label>
        <button class="button primary" type="submit">Submit inquiry</button>
      </form>
    </section>
  `;
}

const POLICY_UPDATED = "11 September 2026";

function renderPolicyPage({ eyebrow, title, intro, cards }) {
  const sections = cards.map((card) => ({ ...card, id: `policy-${slugify(card.heading)}` }));
  // Long policies get a contents list. Buttons rather than #anchors: the hash
  // is the router here, so an anchor link would navigate away from the page.
  const showContents = sections.length >= 5;

  return `
    <section class="page-title section-band dark-band slim">
      <p class="eyebrow">${escapeHtml(eyebrow)}</p>
      <h1>${escapeHtml(title)}</h1>
      <p>${intro}</p>
    </section>
    <section class="section-band policy-page">
      <div class="policy-layout${showContents ? "" : " no-contents"}">
        ${showContents ? `
          <nav class="policy-contents" aria-label="On this page">
            <p>On this page</p>
            ${sections.map((section) => `<button type="button" data-scroll-to="${escapeAttr(section.id)}">${escapeHtml(section.heading)}</button>`).join("")}
          </nav>
        ` : ""}
        <div class="policy-sections">
          ${sections.map((section) => `
            <article class="policy-card" id="${escapeAttr(section.id)}" data-reveal>
              <h2 tabindex="-1">${escapeHtml(section.heading)}</h2>
              ${section.body}
            </article>
          `).join("")}
        </div>
      </div>
    </section>
  `;
}

function renderPrivacyPage() {
  return renderPolicyPage({
    eyebrow: "Privacy",
    title: "Privacy Policy",
    intro: `How SkillUp Class collects, uses and protects your information. Last updated ${POLICY_UPDATED}.`,
    cards: [
      {
        heading: "Who we are",
        body: `<p>SkillUp Class publishes technology tutorials, courses, blog posts, live events and a student community. For anything in this policy, contact us at <a href="mailto:${INQUIRY_EMAIL}">${INQUIRY_EMAIL}</a>.</p>`
      },
      {
        heading: "What we collect",
        body: `
          <p><strong>Your account.</strong> When you register we collect your name, email address, mobile number, profession, current organisation and experience level. If you are a fresher we also collect your current degree and college name. Your password is handled by our secure sign-in provider and is never visible to us.</p>
          <p><strong>Your learning.</strong> The tutorials you mark complete, the tutorials you bookmark and your quiz attempts.</p>
          <p><strong>The Students Hub.</strong> The communities you join, and the posts, replies and comments you write.</p>
          <p><strong>Events.</strong> When you register for an event we store your name and email address against that event.</p>
          <p><strong>Course inquiries.</strong> The name, email, phone number, course interest, city, learning goal and message you enter in the inquiry form. You do not need an account to send one.</p>
          <p><strong>Technical information.</strong> If something breaks in your browser, we record the error message, the page, and your browser type &mdash; never your name, email or account. Where you allow it, analytics records which pages are viewed and general device and location information.</p>
        `
      },
      {
        heading: "How we use it",
        body: `
          <p>To run your account and keep your progress across devices; to send you event meeting details and reply to inquiries; to keep the Students Hub safe, which includes automatic checks for spam and promotional posts and reviewing reported content; to find and fix errors; and to understand which lessons are useful so we can improve them.</p>
          <p>We do not sell your personal information.</p>
        `
      },
      {
        heading: "Who can see it",
        body: `
          <p><strong>Other signed-in students</strong> can see your public profile &mdash; your name, profession, organisation, experience level, degree and college &mdash; along with anything you post in the Students Hub or as a comment. They never see your email address or mobile number.</p>
          <p><strong>SkillUp Class administrators</strong> can see your account details, event registrations and inquiries, in order to run the site and contact you.</p>
          <p><strong>Service providers</strong> process data on our behalf: Google Cloud services (hosting, sign-in, database, file storage and email delivery), Google AdSense (advertising) and Google Analytics. Videos are embedded from YouTube, and our community group is hosted on WhatsApp; those services apply their own privacy policies when you use them.</p>
        `
      },
      {
        heading: "Advertising and cookies",
        body: `<p>SkillUp Class shows ads through Google AdSense. Google and its partners use cookies to serve ads based on your visits to this and other websites. You can turn off personalised advertising in <a href="https://adssettings.google.com" target="_blank" rel="noreferrer">Google's Ad Settings</a>. Visitors in the European Economic Area, the United Kingdom and Switzerland are asked for consent before these cookies are used, and analytics follows the same choice.</p>`
      },
      {
        heading: "How long we keep it",
        body: `
          <p>Account information, progress, registrations and posts are kept until you delete your account. Course inquiries that are not marked for follow-up are removed after ${INQUIRY_RETENTION_DAYS} days. Error reports are cleared regularly.</p>
          <p>Our database is backed up daily, and backups are kept for 14 days. Anything you delete can remain in those backups until they expire.</p>
        `
      },
      {
        heading: "Your choices",
        body: `
          <p>You can update your details at any time on your <a href="#profile">profile page</a>. You can also delete your account there: this removes your profile, progress, event registrations, community memberships, posts and comments. To remove a course inquiry, or for any other request about your data, email <a href="mailto:${INQUIRY_EMAIL}">${INQUIRY_EMAIL}</a>.</p>
        `
      },
      {
        heading: "Younger learners",
        body: `<p>SkillUp Class is intended for learners aged 13 and over. If you are under 18, please use the site with the permission of a parent or guardian. If you believe a child under 13 has created an account, contact us and we will remove it.</p>`
      },
      {
        heading: "Changes to this policy",
        body: `<p>When this policy changes we will update the date at the top of this page. Significant changes will also be announced on the site.</p>`
      }
    ]
  });
}

function renderTermsPage() {
  return renderPolicyPage({
    eyebrow: "Terms",
    title: "Terms of Use",
    intro: `The rules for using SkillUp Class. Last updated ${POLICY_UPDATED}.`,
    cards: [
      {
        heading: "Using SkillUp Class",
        body: `<p>By using this website you agree to these terms. Tutorials and blog posts are free to read without an account. An account is needed to save progress, take part in the Students Hub and register for events.</p>`
      },
      {
        heading: "Your account",
        body: `<p>Give accurate details when you register, keep your password to yourself, and use one account per person. You need to confirm your email address before posting or registering for events. You are responsible for what happens under your account.</p>`
      },
      {
        heading: "Community rules",
        body: `
          <p>Keep posts and comments about learning. Do not post promotions, advertising, referral or affiliate links, or recruiting messages; do not share phone numbers, messaging handles or payment details; and do not harass, insult or target anyone.</p>
          <p>Administrators may hide or remove content that breaks these rules, and may block an account from posting in the Students Hub, commenting on tutorials, or registering for events.</p>
        `
      },
      {
        heading: "What you post",
        body: `<p>You keep ownership of what you write. By posting it on SkillUp Class you allow us to display it on the site. You are responsible for making sure you have the right to share anything you post.</p>`
      },
      {
        heading: "Our content",
        body: `<p>Tutorials, courses, videos and other material on SkillUp Class belong to SkillUp Class. You may use them for your own learning, and use code examples in your own projects. Do not republish, sell or pass off our tutorials or courses as your own without written permission.</p>`
      },
      {
        heading: "Events",
        body: `<p>Events are free unless stated otherwise. Dates, times and meeting links can change, and an event may occasionally be cancelled; registered students are told when that happens.</p>`
      },
      {
        heading: "Other websites",
        body: `<p>Links to YouTube, WhatsApp and other sites are provided for convenience. Those sites have their own terms, and we are not responsible for their content.</p>`
      },
      {
        heading: "No guarantees",
        body: `<p>Our content is provided to help you learn, as it is. We work to keep it accurate and current, but we cannot guarantee it is free of errors, and we do not promise any particular result such as passing an interview or getting a job.</p>`
      },
      {
        heading: "Ending your use",
        body: `<p>You can delete your account at any time from your <a href="#profile">profile page</a>. We may suspend or block accounts that break these terms.</p>`
      },
      {
        heading: "Changes and contact",
        body: `<p>We may update these terms; the date at the top of this page shows the latest version. Questions? Email <a href="mailto:${INQUIRY_EMAIL}">${INQUIRY_EMAIL}</a>.</p>`
      }
    ]
  });
}

function renderAboutPage() {
  const tutorialCount = getPublicTutorials().length;
  // AI subjects are named first, to match what the site leads with.
  const subjects = getPublicSubjects().map((subject) => subject.title).filter(Boolean)
    .sort((a, b) => Number(isAiContent(b)) - Number(isAiContent(a)));
  // Exact counts read well once the library is large. A handful of
  // tutorials ("3 free tutorials across 1 subjects") is better described as
  // a library that is growing.
  const librarySummary = tutorialCount >= 20
    ? `${tutorialCount} free tutorials${subjects.length ? ` across ${subjects.length} subjects, including ${escapeHtml(subjects.slice(0, 4).join(", "))}` : ""}`
    : subjects.length
      ? `a growing free tutorial library, starting with ${escapeHtml(joinWithAnd(subjects.slice(0, 4)))}`
      : "a free tutorial library";

  return renderPolicyPage({
    eyebrow: "About",
    title: "About SkillUp Class",
    intro: "Practical AI learning for students who want skills they can explain and build with.",
    cards: [
      {
        heading: "What we do",
        body: `<p>SkillUp Class teaches AI the way it is used at work: by building. The site has ${librarySummary}, along with guided courses, interview preparation and a blog.</p>`
      },
      {
        heading: "How it works",
        body: `
          <p><strong>Read.</strong> Every tutorial is free and open to everyone, no account needed.</p>
          <p><strong>Watch.</strong> Video walkthroughs on the <a href="${SKILLUP_YOUTUBE_CHANNEL_URL}" target="_blank" rel="noreferrer">SkillUp Class YouTube channel</a>.</p>
          <p><strong>Practise.</strong> Quizzes at the end of lessons check what stuck. A free account saves your progress and bookmarks across devices.</p>
          <p><strong>Join in.</strong> Ask questions in the <a href="#community">Students Hub</a>, register for live <a href="#events">events</a>, or join the <a href="#whatsapp">WhatsApp community</a>.</p>
        `
      },
      {
        heading: "Who it is for",
        body: `<p>College students, freshers preparing for their first role, and working developers moving into AI: machine learning, generative AI, RAG and AI agents. Lessons start from fundamentals and build up to interview-level depth. Mobile developers will also find Android and Flutter material, including how to add AI to the apps they already build.</p>`
      },
      {
        heading: "Get in touch",
        body: `<p>Questions about a course or learning path? <a href="#inquiry">Send a course inquiry</a> or see our <a href="#contact">contact page</a>.</p>`
      }
    ]
  });
}

function renderContactPage() {
  return renderPolicyPage({
    eyebrow: "Contact",
    title: "Contact SkillUp Class",
    intro: "Pick the route that fits your question.",
    cards: [
      {
        heading: "Email",
        body: `<p>For anything at all, including privacy and account requests: <a href="mailto:${INQUIRY_EMAIL}">${INQUIRY_EMAIL}</a>.</p>`
      },
      {
        heading: "Course and learning questions",
        body: `<p>Tell us your goal and current level through the <a href="#inquiry">course inquiry form</a>, and we will suggest the right course or path.</p>`
      },
      {
        heading: "Quick questions and community",
        body: `<p>Ask other students in the <a href="#community">Students Hub</a>, or join the <a href="${SKILLUP_WHATSAPP_COMMUNITY_URL}" target="_blank" rel="noreferrer noopener">WhatsApp community</a>.</p>`
      },
      {
        heading: "Videos",
        body: `<p>Follow along on the <a href="${SKILLUP_YOUTUBE_CHANNEL_URL}" target="_blank" rel="noreferrer">SkillUp Class YouTube channel</a>.</p>`
      },
      {
        heading: "Deleting your data",
        body: `<p>Signed-in students can delete their account and its data from the <a href="#profile">profile page</a>. See the <a href="#privacy">privacy policy</a> for what that removes.</p>`
      }
    ]
  });
}
// Anything that belongs to a person rather than to the page. Tutorials
// themselves stay open; this only guards the actions whose whole point is
// that they follow you between devices.
//
// #profile renders the student login screen when signed out, so it is the
// right place to land - and it returns them somewhere useful afterwards
// rather than to a dead end.
// Reading is open to everyone and signing in is enough to save progress,
// but posting and event registration also need a confirmed address - the
// security rules check email_verified, so these guards only give a clear
// message before the write would be refused.
function isEmailVerified() {
  return Boolean(state.isAdmin || state.user?.emailVerified);
}

function promptEmailVerification(action) {
  showToast(`Confirm your email to ${action}. Your profile page can send the link.`);
  navigateTo("/profile");
}

async function sendVerificationEmail() {
  const user = firebase.auth?.currentUser;
  if (!user) return;
  try {
    await firebase.api.sendEmailVerification(user);
    showToast(`Link sent to ${user.email}. Check your spam folder if it isn't there in a few minutes.`);
  } catch (error) {
    showToast(error?.code === "auth/too-many-requests"
      ? "A link was sent recently. Wait a few minutes before asking for another."
      : "Could not send the link. Try again shortly.");
    console.warn("Could not send verification email:", error);
  }
}

async function refreshVerificationStatus() {
  const user = firebase.auth?.currentUser;
  if (!user) return;
  try {
    await user.reload();
    // The rules read email_verified from the ID token, so force a fresh one -
    // otherwise posting stays refused for up to an hour after confirming.
    await user.getIdToken(true);
    state.user = firebase.auth.currentUser;
    showToast(state.user?.emailVerified
      ? "Email confirmed. You can post and register for events now."
      : "Not confirmed yet. Open the link in the email first, then try again.");
    render();
  } catch (error) {
    showToast("Could not check right now. Try again shortly.");
    console.warn("Could not refresh verification status:", error);
  }
}

// Removes everything keyed to the student, then the sign-in itself. Firebase
// will not delete an account without a recent sign-in, so the password is
// confirmed first - which also means an unlocked, borrowed laptop is not
// enough to delete someone's account.
async function deleteStudentAccount(password) {
  const user = firebase.auth?.currentUser;
  if (!user || state.isAdmin) return;
  const api = firebase.api;

  try {
    const credential = api.EmailAuthProvider.credential(user.email, password);
    await api.reauthenticateWithCredential(user, credential);
  } catch (error) {
    const wrong = ["auth/wrong-password", "auth/invalid-credential", "auth/invalid-login-credentials"].includes(error?.code);
    showToast(wrong ? "That password is not correct." : "Could not confirm your password. Try again.");
    return;
  }

  const uid = user.uid;
  const owned = [
    ["eventRegistrations", "uid"],
    ["communityMemberships", "uid"],
    ["communityPosts", "authorUid"],
    ["comments", "authorUid"]
  ];

  try {
    const { collection, getDocs, query, where, deleteDoc, doc } = api;
    for (const [name, field] of owned) {
      const snapshot = await getDocs(query(collection(firebase.db, name), where(field, "==", uid)));
      for (const item of snapshot.docs) {
        await deleteDoc(item.ref);
      }
    }
    await deleteDoc(doc(firebase.db, "publicProfiles", uid));
    await deleteDoc(doc(firebase.db, "students", uid));
    await api.deleteUser(user);
  } catch (error) {
    console.warn("Account deletion stopped part-way:", error);
    showToast(`Deletion stopped part-way. Email ${INQUIRY_EMAIL} and we will finish removing your data.`);
    return;
  }

  state.user = null;
  state.studentProfile = null;
  state.myEventRegistrations = {};
  state.myEventRegistrationsLoaded = false;
  showToast("Your account and its data have been deleted.");
  navigateTo("/");
  render();
}

function renderEmailVerificationNotice() {
  if (!state.user || isEmailVerified()) return "";
  return `
    <section class="section-band email-verify-band">
      <div class="email-verify-notice" data-reveal>
        <div>
          <strong>Confirm your email address.</strong>
          <p>Confirm ${escapeHtml(state.user.email || "your email")} to post comments, post in the Students Hub and register for events. Reading and saving progress work either way.</p>
        </div>
        <div class="email-verify-actions">
          <button class="button primary small" type="button" data-send-verification>Send confirmation link</button>
          <button class="button ghost small" type="button" data-refresh-verification>I've confirmed it</button>
        </div>
      </div>
    </section>
  `;
}

function renderDeleteAccountPanel() {
  return `
    <section class="section-band danger-zone-band">
      <form class="danger-zone" data-delete-account-form data-reveal>
        <div>
          <p class="eyebrow">Delete account</p>
          <h2>Permanently delete your account.</h2>
          <p>This removes your profile, public profile, progress and bookmarks, event registrations, Students Hub memberships, and every post and comment you have written. It can't be undone.</p>
        </div>
        <label>
          <span>Confirm with your password</span>
          <input name="password" type="password" autocomplete="current-password" required />
        </label>
        <button class="button danger-button" type="submit">Delete my account</button>
      </form>
    </section>
  `;
}

function requireStudentAccount(action) {
  if (state.user) return true;
  showToast(`Login to ${action} — your account keeps it synced across devices.`);
  navigateTo("/profile");
  return false;
}

function hasStudentProgressSync() {
  return Boolean(state.firebaseEnabled && state.user && !state.isAdmin && state.studentProfile);
}

function readProgressData() {
  if (hasStudentProgressSync()) {
    return { completedTutorials: state.studentProfile.completedTutorials || [] };
  }
  try {
    const stored = JSON.parse(localStorage.getItem(PROGRESS_STORAGE_KEY));
    return {
      completedTutorials: Array.isArray(stored?.completedTutorials) ? stored.completedTutorials : []
    };
  } catch {
    localStorage.removeItem(PROGRESS_STORAGE_KEY);
    return { completedTutorials: [] };
  }
}

// Browser-only progress for visitors who are not signed in. It also holds
// the last lesson and streak days, so each write keeps what it does not set.
function writeProgressData(progress) {
  try {
    let stored = {};
    try {
      stored = JSON.parse(localStorage.getItem(PROGRESS_STORAGE_KEY)) || {};
    } catch {
      stored = {};
    }
    localStorage.setItem(PROGRESS_STORAGE_KEY, JSON.stringify({
      ...stored,
      ...progress,
      completedTutorials: [...new Set(progress.completedTutorials || stored.completedTutorials || [])]
    }));
  } catch (error) {
    console.warn("Could not save progress in this browser:", error);
  }
}

function isTutorialCompleted(id) {
  return readProgressData().completedTutorials.includes(id);
}

async function persistStudentListField(field, values) {
  const now = new Date().toISOString();
  const studentRef = firebase.api.doc(firebase.db, "students", state.user.uid);
  await firebase.api.updateDoc(studentRef, { [field]: values, updatedAt: now });
  state.studentProfile = { ...state.studentProfile, [field]: values, updatedAt: now };
}

async function toggleTutorialProgress(id, completed) {
  const progress = readProgressData();
  const completedSet = new Set(progress.completedTutorials);
  if (completed) {
    completedSet.add(id);
  } else {
    completedSet.delete(id);
  }
  const nextCompleted = [...completedSet];

  if (hasStudentProgressSync()) {
    try {
      await persistStudentListField("completedTutorials", nextCompleted);
    } catch (error) {
      showToast("Could not save progress. Please try again.");
      console.warn("Could not update tutorial progress:", error);
      return;
    }
  } else {
    writeProgressData({ completedTutorials: nextCompleted });
  }

  showToast(completed ? "Topic marked complete." : "Topic marked incomplete.");
  recordLearningActivity();
  render();
}

function readBookmarkData() {
  if (hasStudentProgressSync()) {
    return { bookmarkedTutorials: state.studentProfile.bookmarkedTutorials || [] };
  }
  try {
    const stored = JSON.parse(localStorage.getItem(BOOKMARK_STORAGE_KEY));
    return {
      bookmarkedTutorials: Array.isArray(stored?.bookmarkedTutorials) ? stored.bookmarkedTutorials : []
    };
  } catch {
    localStorage.removeItem(BOOKMARK_STORAGE_KEY);
    return { bookmarkedTutorials: [] };
  }
}

function writeBookmarkData(bookmarks) {
  localStorage.setItem(BOOKMARK_STORAGE_KEY, JSON.stringify({
    bookmarkedTutorials: [...new Set(bookmarks.bookmarkedTutorials || [])]
  }));
}

function isTutorialBookmarked(id) {
  return readBookmarkData().bookmarkedTutorials.includes(id);
}

async function toggleTutorialBookmark(id, bookmarked) {
  const bookmarks = readBookmarkData();
  const bookmarkedSet = new Set(bookmarks.bookmarkedTutorials);
  if (bookmarked) {
    bookmarkedSet.add(id);
  } else {
    bookmarkedSet.delete(id);
  }
  const nextBookmarked = [...bookmarkedSet];

  if (hasStudentProgressSync()) {
    try {
      await persistStudentListField("bookmarkedTutorials", nextBookmarked);
    } catch (error) {
      showToast("Could not save bookmark. Please try again.");
      console.warn("Could not update tutorial bookmark:", error);
      return;
    }
  } else {
    writeBookmarkData({ bookmarkedTutorials: nextBookmarked });
  }

  showToast(bookmarked ? "Tutorial bookmarked." : "Bookmark removed.");
  render();
}

function getBookmarkedTutorials() {
  const bookmarkedIds = new Set(readBookmarkData().bookmarkedTutorials);
  if (!bookmarkedIds.size) return [];
  const allTutorials = getPublicTutorials();
  return allTutorials.filter((tutorial) => bookmarkedIds.has(tutorial.id));
}

function getSubjectProgress(tutorials = []) {
  const completedSet = new Set(readProgressData().completedTutorials);
  const total = tutorials.length;
  const completed = tutorials.filter((tutorial) => completedSet.has(tutorial.id)).length;
  return {
    total,
    completed,
    percent: total ? Math.round((completed / total) * 100) : 0
  };
}

function renderSubjectProgress(tutorials = []) {
  const progress = getSubjectProgress(tutorials);
  if (!progress.total) return "";
  return `
    <div class="subject-progress" aria-label="Subject progress">
      <div><span>${progress.completed}/${progress.total} complete</span><strong>${progress.percent}%</strong></div>
      <span class="subject-progress-track"><span style="width:${progress.percent}%"></span></span>
    </div>
  `;
}

function renderTutorialProgressControl(tutorial, subjectTutorials = []) {
  const completed = isTutorialCompleted(tutorial.id);
  const bookmarked = isTutorialBookmarked(tutorial.id);
  const progress = getSubjectProgress(subjectTutorials);
  return `
    <div class="tutorial-progress-control">
      <span>${progress.completed}/${progress.total} topics complete in this subject</span>
      <div class="tutorial-progress-actions">
        <button
          class="button ghost tutorial-complete-button ${completed ? "is-complete" : ""}"
          type="button"
          data-toggle-tutorial-progress="${escapeAttr(tutorial.id)}"
          data-progress-completed="${completed ? "false" : "true"}"
          aria-pressed="${completed ? "true" : "false"}"
        >${completed ? "Completed" : "Mark complete"}</button>
        <button
          class="icon-only-button tutorial-bookmark-button ${bookmarked ? "is-bookmarked" : ""}"
          type="button"
          data-toggle-tutorial-bookmark="${escapeAttr(tutorial.id)}"
          data-bookmark-active="${bookmarked ? "false" : "true"}"
          aria-pressed="${bookmarked ? "true" : "false"}"
          aria-label="${bookmarked ? "Remove bookmark" : "Bookmark this tutorial"}"
          title="${bookmarked ? "Remove bookmark" : "Bookmark this tutorial"}"
        >${renderReaderIcon(bookmarked ? "bookmark-filled" : "bookmark")}</button>
      </div>
    </div>
  `;
}

function readQuizAttempts() {
  try {
    const stored = JSON.parse(localStorage.getItem(QUIZ_STORAGE_KEY));
    return stored && typeof stored === "object" ? stored : {};
  } catch {
    localStorage.removeItem(QUIZ_STORAGE_KEY);
    return {};
  }
}

// The latest and best score per tutorial. Kept in the browser, and on the
// student record when signed in so it follows them across devices.
async function saveQuizAttempt(tutorialId, result) {
  const previous = getQuizAttempt(tutorialId);
  const entry = {
    score: result.score,
    total: result.total,
    answered: result.answered,
    best: Math.max(result.score, Number(previous?.best ?? previous?.score ?? 0)),
    attemptedAt: new Date().toISOString()
  };
  try {
    const attempts = readQuizAttempts();
    attempts[tutorialId] = entry;
    localStorage.setItem(QUIZ_STORAGE_KEY, JSON.stringify(attempts));
  } catch (error) {
    console.warn("Could not save the quiz score in this browser:", error);
  }
  if (hasStudentProgressSync()) {
    const quizScores = { ...(state.studentProfile.quizScores || {}), [tutorialId]: entry };
    const now = new Date().toISOString();
    try {
      await firebase.api.updateDoc(firebase.api.doc(firebase.db, "students", state.user.uid), { quizScores, updatedAt: now });
      state.studentProfile = { ...state.studentProfile, quizScores, updatedAt: now };
    } catch (error) {
      console.warn("Could not save the quiz score:", error);
    }
  }
  recordLearningActivity();
}

function getQuizAttempt(tutorialId) {
  if (hasStudentProgressSync()) {
    const synced = state.studentProfile?.quizScores?.[tutorialId];
    if (synced) return synced;
  }
  return readQuizAttempts()[tutorialId] || null;
}

function renderPracticeQuiz(tutorial) {
  const quiz = normalizeQuiz(tutorial.quiz || []);
  if (!quiz.length) return "";
  const lastAttempt = getQuizAttempt(tutorial.id);

  return `
    <section class="practice-quiz" data-quiz data-quiz-id="${escapeAttr(tutorial.id)}">
      <div class="practice-quiz-heading">
        <div>
          <span class="kicker">Quick revision</span>
          <h2>Practice quiz</h2>
          <p>Answer these short checks after reading the lesson. Explanations appear after you submit.</p>
        </div>
        ${lastAttempt ? `<small>Last score: ${lastAttempt.score}/${lastAttempt.total}${lastAttempt.best !== undefined && lastAttempt.best !== lastAttempt.score ? ` · Best: ${lastAttempt.best}/${lastAttempt.total}` : ""}</small>` : ""}
      </div>
      ${quiz.map((question, questionIndex) => `
        <fieldset class="practice-question" data-quiz-question data-answer="${escapeAttr(question.answer)}">
          <legend>${questionIndex + 1}. ${escapeHtml(question.question)}</legend>
          ${question.options.map((option, optionIndex) => {
            const value = String.fromCharCode(65 + optionIndex);
            return `
              <label class="practice-option">
                <input type="radio" name="quiz-${escapeAttr(tutorial.id)}-${questionIndex}" value="${value}" />
                <span class="practice-option-body"><strong class="practice-option-letter">${value}</strong><span class="practice-option-text">${escapeHtml(option)}</span></span>
              </label>
            `;
          }).join("")}
          ${question.explanation ? `<p class="practice-explanation" hidden>${escapeHtml(question.explanation)}</p>` : ""}
        </fieldset>
      `).join("")}
      <div class="practice-quiz-actions">
        <button class="button dark" type="button" data-check-quiz>Check answers</button>
        <span data-quiz-result aria-live="polite"></span>
      </div>
    </section>
  `;
}

function checkPracticeQuiz(button) {
  const quizShell = button.closest("[data-quiz]");
  if (!quizShell) return;
  const questionBlocks = [...quizShell.querySelectorAll("[data-quiz-question]")];
  let score = 0;
  let answered = 0;

  questionBlocks.forEach((block) => {
    const selected = block.querySelector("input:checked");
    const isCorrect = selected?.value === block.dataset.answer;
    block.classList.remove("is-correct", "is-wrong", "is-unanswered");
    block.classList.add(selected ? (isCorrect ? "is-correct" : "is-wrong") : "is-unanswered");
    block.querySelector(".practice-explanation")?.removeAttribute("hidden");
    if (selected) answered += 1;
    if (isCorrect) score += 1;
  });

  const total = questionBlocks.length;
  const result = quizShell.querySelector("[data-quiz-result]");
  if (result) {
    result.textContent = answered < total
      ? `Answered ${answered}/${total}. Score: ${score}/${total}`
      : `Score: ${score}/${total}`;
  }
  saveQuizAttempt(quizShell.dataset.quizId, { score, total, answered });
}
function renderTutorialsPage(id = "") {
  const tutorialsReady = isPublicCollectionReady("articles");
  const tutorials = sortTutorials(getPublicTutorials());
  const selectedTutorial = findTutorialById(tutorials, id) || tutorials[0];

  if (!selectedTutorial) {
    return `
      <section class="section-band reader-shell">
        ${renderEmptyState(tutorialsReady ? "No tutorials are published yet." : "Loading tutorials...")}
      </section>
    `;
  }

  const subjects = getSubjectList(tutorials);
  const activeSubject = selectedTutorial.category;
  const activeSubjectItem = subjects.find((subject) => subject.title === activeSubject) || normalizeSubject(activeSubject);
  const subjectTutorials = sortSubjectTutorials(activeSubjectItem, tutorials.filter((tutorial) => tutorial.category === activeSubject));
  const currentIndex = subjectTutorials.findIndex((tutorial) => tutorial.id === selectedTutorial.id);
  const previousTutorial = currentIndex > 0 ? subjectTutorials[currentIndex - 1] : null;
  const nextTutorial = currentIndex >= 0 && currentIndex < subjectTutorials.length - 1 ? subjectTutorials[currentIndex + 1] : null;
  const globalTutorialIndex = tutorials.findIndex((tutorial) => tutorial.id === selectedTutorial.id);
  const fullViewPreviousTutorial = previousTutorial || (globalTutorialIndex > 0 ? tutorials[globalTutorialIndex - 1] : null);
  const fullViewNextTutorial = nextTutorial || (globalTutorialIndex >= 0 && globalTutorialIndex < tutorials.length - 1 ? tutorials[globalTutorialIndex + 1] : null);
  const tutorialVideo = renderYouTubePlayer(selectedTutorial);
  const activeSubjectCover = safeUrl(activeSubjectItem.coverImage) || getCategoryFallbackCover(activeSubject);
  const activeSection = getTutorialSection(selectedTutorial, activeSubjectItem);

  return `
    <section class="tutorial-shell">
      <nav class="subject-strip" aria-label="Tutorial subjects">
        ${subjects
          .map((subject) => {
            const firstTutorial = tutorials.find((tutorial) => tutorial.category === subject.title);
            const subjectCover = safeUrl(subject.coverImage);
            return `
              <a
                class="${subject.title === activeSubject ? "is-active" : ""}"
                href="#tutorials/${encodeURIComponent(firstTutorial.id)}"
              >
                ${subjectCover ? `<img src="${escapeAttr(subjectCover)}" alt="" data-managed-image />` : ""}
                <span>${escapeHtml(subject.title)}</span>
              </a>
            `;
          })
          .join("")}
      </nav>

      <button
        class="topics-toggle"
        type="button"
        data-topics-toggle
        aria-expanded="false"
        aria-controls="topic-sidebar-panel"
      >
        ${renderReaderIcon("menu")}
        <span>Topics</span>
      </button>

      <div class="tutorial-layout" data-tutorial-layout>
        <aside class="topic-sidebar" id="topic-sidebar-panel" tabindex="-1" aria-label="${escapeAttr(activeSubject)} topics">
          <button class="topic-sidebar-close" type="button" data-topics-toggle aria-label="Close topics">
            ${renderReaderIcon("close")}
          </button>
          ${activeSubjectCover ? `<img class="subject-cover" src="${escapeAttr(activeSubjectCover)}" alt="" data-managed-image />` : ""}
          <p class="eyebrow">Topics</p>
          <h2>${escapeHtml(activeSubject)}</h2>
          ${renderSubjectProgress(subjectTutorials)}
          <nav class="topic-list">
            ${renderTopicSectionList(activeSubjectItem, subjectTutorials, selectedTutorial)}
          </nav>
        </aside>

        <article class="tutorial-reader-panel" data-tutorial-id="${escapeAttr(selectedTutorial.id)}">
          <div class="tutorial-reader-progress-track" aria-hidden="true">
            <div class="tutorial-reader-progress-fill" data-tutorial-progress-fill></div>
          </div>
          <header class="tutorial-reader-header">
            <p class="eyebrow">${escapeHtml(selectedTutorial.category)}${activeSection ? ` / ${escapeHtml(activeSection.title)}` : ""}</p>
            <h1>${escapeHtml(selectedTutorial.title)}</h1>
            <p>${escapeHtml(selectedTutorial.excerpt)}</p>
            <div class="tutorial-reader-actions">
              <div class="meta-row">
                <span>${icon("calendar")}${formatDate(selectedTutorial.publishedAt || selectedTutorial.updatedAt)}</span>
                <span>${icon("clock")}${getReadTime(selectedTutorial.body)} min read</span>
                ${renderAuthorCredit(selectedTutorial)}
              </div>
              ${renderTutorialProgressControl(selectedTutorial, subjectTutorials)}
              <button
                class="button dark tutorial-full-view-button"
                type="button"
                data-open-full-view="${escapeAttr(selectedTutorial.id)}"
              >
                ${renderReaderIcon("expand")}
                <span>Full view</span>
              </button>
            </div>
          </header>
          <div class="tutorial-reader-body">
            ${tutorialVideo}
            ${renderAdSlot("tutorialInline", "inline", {
              hasContent: String(selectedTutorial.body || "").replace(/<[^>]*>/g, " ").trim().split(/\s+/).length >= 300
            })}
            ${renderReaderArticle(selectedTutorial.body, selectedTutorial.title)}
            ${renderTutorialAttachment(selectedTutorial)}
            ${renderPracticeQuiz(selectedTutorial)}
          </div>
          <footer class="tutorial-pager">
            ${previousTutorial ? `<a class="button ghost" href="#tutorials/${encodeURIComponent(previousTutorial.id)}">Previous topic</a>` : `<span></span>`}
            ${nextTutorial ? `<a class="button dark" href="#tutorials/${encodeURIComponent(nextTutorial.id)}">Next topic</a>` : ""}
          </footer>
          ${renderDiscussionSection("tutorial", selectedTutorial.id, selectedTutorial.title)}
        </article>
      </div>
    </section>
    ${state.fullViewTutorialId === selectedTutorial.id ? renderTutorialFullView(selectedTutorial, fullViewPreviousTutorial, fullViewNextTutorial) : ""}
  `;
}

function renderTopicSectionList(subject, tutorials, selectedTutorial) {
  const sections = getSubjectSections(subject, tutorials);
  return sections
    .map((section, index) => {
      const sectionTutorials = tutorials.filter((tutorial) => getTutorialSectionId(tutorial, subject) === section.id);
      if (!sectionTutorials.length) return "";
      const hasSelectedTutorial = sectionTutorials.some((tutorial) => tutorial.id === selectedTutorial.id);
      const isOpen = index === 0 || hasSelectedTutorial;
      return `
        <details class="topic-section" ${isOpen ? "open" : ""}>
          <summary class="topic-section-summary">
            <span class="topic-section-title">${escapeHtml(section.title)}</span>
            <small>${sectionTutorials.length} ${sectionTutorials.length === 1 ? "topic" : "topics"}</small>
          </summary>
          <div class="topic-section-items">
            ${sectionTutorials.map((tutorial) => `
              <a
                class="${tutorial.id === selectedTutorial.id ? "is-active" : ""} ${isTutorialCompleted(tutorial.id) ? "is-complete" : ""}"
                href="#tutorials/${encodeURIComponent(tutorial.id)}"
              >
                <span>${isTutorialCompleted(tutorial.id) ? "✓ " : ""}${escapeHtml(tutorial.title)}</span>
                <small>${escapeHtml(toArray(tutorial.tags).slice(0, 2).join(" / ") || `${getReadTime(tutorial.body)} min read`)}</small>
              </a>
            `).join("")}
          </div>
        </details>
      `;
    })
    .join("");
}
function renderTutorialFullView(tutorial, previousTutorial = null, nextTutorial = null) {
  const titleId = `full-view-title-${slugify(tutorial.id || tutorial.title)}`;
  const fullViewContent = getTutorialFullViewContent(tutorial);
  const fullViewSubject = getSubjectByTitle(tutorial.category) || normalizeSubject(tutorial.category);
  const fullViewSection = getTutorialSection(tutorial, fullViewSubject);
  const fullViewCategoryLabel = `${tutorial.category || "General"}${fullViewSection ? ` / ${fullViewSection.title}` : ""}`;
  const tocItems = [
    { id: titleId, text: tutorial.title || "Tutorial overview", level: 1, isTitle: true },
    ...fullViewContent.headings
  ];
  const showMenu = state.fullViewMenuVisible && tocItems.length > 0;

  return `
    <div class="tutorial-full-view-overlay" data-tutorial-full-view>
      <button class="tutorial-full-view-backdrop" type="button" data-close-full-view aria-label="Close full view"></button>
      <section
        class="tutorial-full-view-dialog ${showMenu ? "" : "is-menu-collapsed"} is-reader-${escapeAttr(state.fullViewTheme)}"
        role="dialog"
        aria-modal="true"
        aria-labelledby="${escapeAttr(titleId)}"
        data-tutorial-full-view-dialog
        data-reader-theme="${escapeAttr(state.fullViewTheme)}"
      >
        <header class="tutorial-full-view-toolbar">
          <div class="tutorial-full-view-title">
            <span>${escapeHtml(fullViewCategoryLabel)}</span>
            <strong>${escapeHtml(tutorial.title)}</strong>
          </div>
          <div class="tutorial-full-view-tools" aria-label="Reader controls">
            ${renderReaderThemeControls()}
            <label class="tutorial-toc-switch" title="Show or hide topic menu">
              <input type="checkbox" data-toggle-full-view-menu ${state.fullViewMenuVisible ? "checked" : ""} />
              <span aria-hidden="true"></span>
              <small>Topic menu</small>
            </label>
            <button
              class="tutorial-full-view-bookmark tutorial-bookmark-button ${isTutorialBookmarked(tutorial.id) ? "is-bookmarked" : ""}"
              type="button"
              data-toggle-tutorial-bookmark="${escapeAttr(tutorial.id)}"
              data-bookmark-active="${isTutorialBookmarked(tutorial.id) ? "false" : "true"}"
              aria-pressed="${isTutorialBookmarked(tutorial.id) ? "true" : "false"}"
              aria-label="${isTutorialBookmarked(tutorial.id) ? "Remove bookmark" : "Bookmark this tutorial"}"
              title="${isTutorialBookmarked(tutorial.id) ? "Remove bookmark" : "Bookmark this tutorial"}"
            >${renderReaderIcon(isTutorialBookmarked(tutorial.id) ? "bookmark-filled" : "bookmark")}</button>
            <button class="tutorial-full-view-close" type="button" data-close-full-view aria-label="Close full view" title="Close reader">
              ${renderReaderIcon("close")}
            </button>
          </div>
        </header>
        <div class="tutorial-full-view-shell">
          ${tocItems.length ? renderTutorialFullViewToc(tutorial, tocItems) : ""}
          <div class="tutorial-full-view-scroll" data-full-view-scroll>
            <article class="tutorial-reader-body tutorial-full-view-body">
              <header class="tutorial-full-view-heading" id="${escapeAttr(titleId)}">
                <p class="eyebrow">${escapeHtml(fullViewCategoryLabel)}</p>
                <h1>${escapeHtml(tutorial.title)}</h1>
                <p>${escapeHtml(tutorial.excerpt)}</p>
                <div class="meta-row">
                  <span>${icon("calendar")}${formatDate(tutorial.publishedAt || tutorial.updatedAt)}</span>
                  <span>${icon("clock")}${getReadTime(tutorial.body)} min read</span>
                </div>
              </header>
              ${renderYouTubePlayer(tutorial)}
              ${fullViewContent.bodyHtml}
              ${renderTutorialAttachment(tutorial)}
              ${renderPracticeQuiz(tutorial)}
              ${renderTutorialFullViewPager(previousTutorial, nextTutorial)}
            </article>
          </div>
        </div>
      </section>
    </div>
  `;
}

function renderTutorialFullViewPager(previousTutorial, nextTutorial) {
  if (!previousTutorial && !nextTutorial) return "";

  return `
    <footer class="tutorial-full-view-pager" aria-label="Topic navigation">
      ${previousTutorial ? `
        <a
          class="tutorial-full-view-nav tutorial-full-view-nav--previous"
          href="#tutorials/${encodeURIComponent(previousTutorial.id)}"
          data-full-view-topic-nav="${escapeAttr(previousTutorial.id)}"
        >
          ${renderReaderIcon("previous")}
          <span>
            <small>Previous topic</small>
            <strong>${escapeHtml(previousTutorial.title)}</strong>
          </span>
        </a>
      ` : `<span class="tutorial-full-view-nav-spacer" aria-hidden="true"></span>`}
      ${nextTutorial ? `
        <a
          class="tutorial-full-view-nav tutorial-full-view-nav--next"
          href="#tutorials/${encodeURIComponent(nextTutorial.id)}"
          data-full-view-topic-nav="${escapeAttr(nextTutorial.id)}"
        >
          <span>
            <small>Next topic</small>
            <strong>${escapeHtml(nextTutorial.title)}</strong>
          </span>
          ${renderReaderIcon("next")}
        </a>
      ` : `<span class="tutorial-full-view-nav-spacer" aria-hidden="true"></span>`}
    </footer>
  `;
}
function getTutorialFullViewContent(tutorial) {
  const template = document.createElement("template");
  template.innerHTML = renderArticleBody(tutorial.body);
  const usedSlugs = new Map();
  const tutorialSlug = slugify(tutorial.id || tutorial.title || "tutorial");
  const headings = [];

  template.content.querySelectorAll("h1, h2, h3, h4").forEach((heading, index) => {
    const text = heading.textContent.trim();
    if (!text) return;

    const baseSlug = slugify(text) || `section-${index + 1}`;
    const repeatCount = usedSlugs.get(baseSlug) || 0;
    usedSlugs.set(baseSlug, repeatCount + 1);
    const id = `full-view-section-${tutorialSlug}-${baseSlug}${repeatCount ? `-${repeatCount + 1}` : ""}`;
    const level = Number(heading.tagName.slice(1));

    heading.id = id;
    heading.dataset.fullViewSection = "true";
    headings.push({ id, text, level: clamp(level, 1, 4) });
  });

  return { bodyHtml: template.innerHTML, headings };
}

function renderTutorialFullViewToc(tutorial, tocItems) {
  return `
    <aside class="tutorial-full-view-toc" aria-label="Tutorial headings">
      <div class="tutorial-full-view-toc-card">
        <span>Current tutorial</span>
        <strong>${escapeHtml(tutorial.title || "Tutorial")}</strong>
        <nav>
          ${tocItems.map((item, index) => `
            <button
              class="${index === 0 ? "is-active" : ""} ${item.isTitle ? "is-title" : ""} is-level-${item.level}"
              type="button"
              data-full-view-heading="${escapeAttr(item.id)}"
              aria-current="${index === 0 ? "true" : "false"}"
            >
              <span>${escapeHtml(item.text)}</span>
            </button>
          `).join("")}
        </nav>
      </div>
    </aside>
  `;
}

function initializeFullViewScrollSpy() {
  const scroller = document.querySelector("[data-full-view-scroll]");
  if (!scroller || !document.querySelector("[data-full-view-heading]")) return;

  const scheduleUpdate = () => {
    if (scroller.dataset.scrollSpyScheduled === "true") return;

    scroller.dataset.scrollSpyScheduled = "true";
    window.requestAnimationFrame(() => {
      scroller.dataset.scrollSpyScheduled = "false";
      updateFullViewActiveHeading(scroller);
    });
  };

  updateFullViewActiveHeading(scroller);
  scroller.addEventListener("scroll", scheduleUpdate, { passive: true });
  scroller.addEventListener("wheel", scheduleUpdate, { passive: true });
  scroller.addEventListener("touchmove", scheduleUpdate, { passive: true });

  const refreshInterval = window.setInterval(() => {
    if (!document.body.contains(scroller)) {
      window.clearInterval(refreshInterval);
      return;
    }

    updateFullViewActiveHeading(scroller);
  }, 250);
}

function updateFullViewActiveHeading(scroller = document.querySelector("[data-full-view-scroll]")) {
  const headingItems = Array.from(document.querySelectorAll("[data-full-view-heading]"))
    .map((button) => ({
      button,
      element: document.getElementById(button.dataset.fullViewHeading || "")
    }))
    .filter((item) => item.element);

  if (!scroller || !headingItems.length) return;

  const scrollerRect = scroller.getBoundingClientRect();
  const activationTop = scrollerRect.top + Math.min(220, scrollerRect.height * 0.32);
  let activeItem = headingItems[0];

  headingItems.forEach((item) => {
    const rect = item.element.getBoundingClientRect();
    if (rect.top <= activationTop) {
      activeItem = item;
    }
  });

  const isAtBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 18;
  if (isAtBottom) {
    activeItem = headingItems[headingItems.length - 1];
  }

  setFullViewActiveHeading(activeItem.element.id);
}

function setFullViewActiveHeading(activeId) {
  let activeButton = null;

  document.querySelectorAll("[data-full-view-heading]").forEach((button) => {
    const isActive = button.dataset.fullViewHeading === activeId;
    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-current", isActive ? "true" : "false");
    if (isActive) activeButton = button;
  });

  const menuScrollArea = activeButton?.closest(".tutorial-full-view-toc");
  if (!activeButton || !menuScrollArea || isElementInsideContainer(activeButton, menuScrollArea)) return;

  activeButton.scrollIntoView({ block: "nearest" });
}

function isElementInsideContainer(element, container) {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  return elementRect.top >= containerRect.top + 8 && elementRect.bottom <= containerRect.bottom - 8;
}
function renderReaderThemeControls() {
  return `
    <div class="reader-setting-group" role="group" aria-label="Reader theme">
      ${["light", "dark"].map((theme) => {
        const isActive = state.fullViewTheme === theme;
        const label = theme === "dark" ? "Dark" : "Light";
        return `
          <button
            class="reader-tool-button ${isActive ? "is-active" : ""}"
            type="button"
            data-reader-theme="${escapeAttr(theme)}"
            aria-pressed="${isActive ? "true" : "false"}"
            title="${escapeAttr(label)} mode"
          >
            ${renderReaderIcon(theme === "dark" ? "moon" : "sun")}
            <span>${escapeHtml(label)}</span>
          </button>
        `;
      }).join("")}
    </div>
  `;
}


function renderReaderIcon(name) {
  const paths = {
    expand: '<path d="M8 3H3v5" /><path d="M16 3h5v5" /><path d="M21 16v5h-5" /><path d="M3 16v5h5" />',
    close: '<path d="M18 6 6 18" /><path d="m6 6 12 12" />',
    sun: '<circle cx="12" cy="12" r="4" /><path d="M12 2v2" /><path d="M12 20v2" /><path d="m4.93 4.93 1.41 1.41" /><path d="m17.66 17.66 1.41 1.41" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="m6.34 17.66-1.41 1.41" /><path d="m19.07 4.93-1.41 1.41" />',
    moon: '<path d="M21 13.2A7.6 7.6 0 1 1 10.8 3a6 6 0 0 0 10.2 10.2Z" />',
    minus: '<path d="M5 12h14" />',
    plus: '<path d="M12 5v14" /><path d="M5 12h14" />',
    save: '<path d="M5 3h12l2 2v16H5z" /><path d="M9 3v6h6V3" /><path d="M8 15h8" /><path d="M8 18h8" />',
    previous: '<path d="m15 18-6-6 6-6" />',
    next: '<path d="m9 18 6-6-6-6" />',
    download: '<path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" />',
    menu: '<line x1="4" y1="7" x2="20" y2="7" /><line x1="4" y1="12" x2="20" y2="12" /><line x1="4" y1="17" x2="20" y2="17" />',
    bookmark: '<path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1Z" />',
    "bookmark-filled": '<path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1Z" fill="currentColor" stroke="none" />'
  };

  return `
    <svg class="reader-action-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      ${paths[name] || paths.expand}
    </svg>
  `;
}

function renderTutorialAttachment(tutorial) {
  const documentUrl = safeUrl(tutorial.documentUrl);
  if (!documentUrl) return "";

  return `
    <aside class="tutorial-resource">
      <div>
        <span>Resource document</span>
        <strong>${escapeHtml(tutorial.documentName || "Attached document")}</strong>
      </div>
      <a class="button ghost" href="${escapeAttr(documentUrl)}" target="_blank" rel="noreferrer">
        ${renderReaderIcon("download")}
        <span>Open document</span>
      </a>
    </aside>
  `;
}

function renderAdminPage() {
  if (!state.user) {
    return `
      <section class="admin-shell admin-login-shell section-band">
        <div class="admin-login-copy" data-reveal>
          <span class="admin-dashboard-mark">SC</span>
          <p class="eyebrow">Admin dashboard</p>
          <h1>Manage SkillUp Class content.</h1>
          <p>Securely update courses, tutorial subjects, tutorial articles, videos, and images from one workspace.</p>
          <div class="admin-login-points">
            <span>Secure sign-in</span>
            <span>Protected uploads</span>
            <span>Admin-only changes</span>
          </div>
        </div>
        <div class="admin-auth-column" data-reveal>
          ${renderAuthPanel()}
        </div>
      </section>
    `;
  }

  if (!state.isAdmin && state.isContributor && !isContributorEmailConfirmed()) {
    return renderContributorConfirmEmail();
  }

  if (!state.isAdmin && !state.isContributor) {
    return `
      <section class="admin-shell admin-login-shell section-band">
        <div class="admin-card login-panel">
          <p class="eyebrow">Access blocked</p>
          <h1>${escapeHtml(state.user.email || "This account")} does not have dashboard access.</h1>
          <button class="button dark" type="button" data-signout>Sign out</button>
        </div>
      </section>
    `;
  }

  if (!state.isAdmin && state.isContributor && !CONTRIBUTOR_ADMIN_TYPES.includes(state.adminType)) {
    state.adminType = "articles";
  }
  const subjects = getAdminSubjects();
  const activeSubject = state.adminType === "articles" ? getActiveAdminSubject() : null;
  const activeList = state.adminType === "articles"
    ? activeSubject
      ? sortSubjectTutorials(activeSubject, getAdminListItems(state.articles).filter((article) => article.category === activeSubject.title))
      : []
    : state.adminType === "blogs"
      ? getAdminListItems(state.blogs)
      : state.adminType === "tutorials"
        ? getAdminListItems(state.tutorials)
        : state.adminType === "codingProblems"
          ? sortByOrder(getAdminListItems(state.codingProblems))
          : state.adminType === "subjects"
          ? subjects
          : [];
  const editorItem = activeList.find((item) => item.id === state.editingId);
  const editorNoun = ADMIN_EDITOR_NOUNS[state.adminType];
  const editingRecord = ADMIN_CONTENT_TYPES.includes(state.adminType)
    ? editorItem
    : state.adminType === "subjects"
      ? findSubjectById(state.editingSubjectId)
      : state.adminType === "events"
        ? findEventById(state.editingEventId)
        : state.adminType === "communities"
          ? findCommunityById(state.editingCommunityId)
          : state.adminType === "sessions"
            ? findSessionById(state.editingSessionId)
            : null;
  const adminEditorTitle = state.adminEditorOpen && editorNoun && !(state.adminType === "articles" && !activeSubject)
    ? `${editingRecord ? "Edit" : "New"} ${editorNoun}`
    : "";
  const courseCount = getAdminListItems(state.tutorials).length;
  const tutorialCount = getAdminListItems(state.articles).length;
  const subjectCount = subjects.length;
  const blogCount = getAdminListItems(state.blogs).length;
  const codingProblemCount = getAdminListItems(state.codingProblems).length;
  const sectionCount = subjects.reduce((total, subject) => total + normalizeSubjectSections(subject.sections || []).length, 0);
  const publishedCourses = getPublished(state.tutorials).length;
  const publishedTutorials = getPublished(state.articles).length;
  const publishedBlogs = getPublished(state.blogs).length;
  const publishedCodingProblems = getPublished(state.codingProblems).length;
  const draftCourses = courseCount - publishedCourses;
  const draftTutorials = tutorialCount - publishedTutorials;
  const draftBlogs = blogCount - publishedBlogs;
  const draftCodingProblems = codingProblemCount - publishedCodingProblems;
  const codingMeta = getCodingMeta();
  const codingSetupCount = codingMeta.types.length + codingMeta.difficulties.length + codingMeta.categories.length;
  const inquiryCount = state.inquiries.length;
  const pinnedInquiryCount = state.inquiries.filter((inquiry) => inquiry.pinned).length;
  const studentCount = state.students.length;
  const flaggedCommentCount = state.adminComments.filter((comment) => comment.status !== "hidden").length;
  const communityCount = state.communities.length;
  const contributorCount = state.contributors.filter((person) => person.active).length;
  const sessionCount = state.sessions.length;
  const pendingBookingCount = state.adminSessionBookings.filter((booking) => booking.status === "requested").length;
  const activeLibraryName = state.adminType === "articles"
    ? "Tutorials"
    : state.adminType === "blogs"
      ? "Blogs"
      : state.adminType === "codingProblems"
        ? "Coding Problems"
        : state.adminType === "codingMeta"
          ? "Coding Setup"
        : state.adminType === "subjects"
        ? "Subjects"
        : state.adminType === "sections"
          ? "Sections"
          : state.adminType === "tutorials"
            ? "Courses"
            : state.adminType === "settings"
              ? "Settings"
              : state.adminType === "inquiries"
                ? "Course Inquiries"
                : state.adminType === "students"
                  ? "Students"
                  : state.adminType === "comments"
                    ? "Flagged Comments"
                  : state.adminType === "communities"
                    ? "Communities"
                  : state.adminType === "events"
                    ? "Events"
                  : state.adminType === "contributors"
                    ? "Contributors"
                  : state.adminType === "sessions"
                    ? "1:1 Sessions"
                  : state.adminType === "sessionBookings"
                    ? "Session Bookings"
                  : state.adminType === "insights"
                    ? "Insights"
                    : "Overview";
  const activeDescription = state.adminType === "articles"
    ? "Select a subject first, then manage only tutorials from that subject."
    : state.adminType === "blogs"
      ? "Create independent blog posts with the same rich editor, images, code blocks, and diagrams."
      : state.adminType === "codingProblems"
        ? "Create and update the HackerRank-style coding practice problems, test cases, difficulty, order, and publishing status."
        : state.adminType === "codingMeta"
          ? "Manage coding practice types, difficulty levels, and category sections used by the problem editor and public filters."
        : state.adminType === "subjects"
        ? "Create, update, and remove tutorial subjects with optional subject images."
        : state.adminType === "sections"
          ? "Add sections to existing subjects and review how tutorials are grouped."
          : state.adminType === "tutorials"
            ? "Create course cards with outcomes, category, order, status, and cover image."
            : state.adminType === "settings"
              ? "Manage administrator account security and update the sign-in password."
              : state.adminType === "inquiries"
                ? "Review student course inquiries, keep important leads pinned, and clear old unpinned data automatically."
                : state.adminType === "students"
                  ? "Review registered learners and see who has access to tutorials and coding practice."
                  : state.adminType === "comments"
                    ? "Review comments that learners have reported. Hide, restore, or delete as needed."
                  : state.adminType === "communities"
                    ? "Create and manage topic communities, and review flagged community posts."
                  : state.adminType === "events"
                    ? "Schedule sessions students can register for, see who signed up, and send everyone the meeting link."
                  : state.adminType === "insights"
                    ? "How students join, learn, practise and book, worked out from your site's own records."
                    : "Review publishing activity, jump into content, and keep the learning library healthy.";
  // Every section with an editor has its own "Add new" button on the list,
  // so the header only offers Back while an editor is open.
  const primaryAction = adminEditorTitle
    ? `<button class="button ghost" type="button" data-close-admin-editor>${renderAdminIcon("arrow").replace('class="admin-icon"', 'class="admin-icon is-back"')}<span>Back to ${escapeHtml(activeLibraryName.toLowerCase())}</span></button>`
    : state.adminType === "overview"
      ? `<button class="button primary" type="button" data-admin-tab="articles" data-open-editor>${renderAdminIcon("plus")}<span>New Tutorial</span></button>`
      : "";
  const seedCodingProblemsAction = state.adminType === "codingProblems" && state.isAdmin
    ? `<button class="button ghost" type="button" data-seed-coding-problems>${renderAdminIcon("code")}<span>Seed current problems</span></button>`
    : "";

  return `
    <section class="admin-shell admin-dashboard-shell section-band">
      <aside class="admin-sidebar" data-reveal>
        <a class="admin-sidebar-brand" href="#home" aria-label="SkillUp Class home">
          <img src="/assets/skillup-mark.png" alt="" />
          <span>
            <strong>SkillUp Class</strong>
            <small>Content dashboard</small>
          </span>
        </a>
        <nav class="admin-tabs admin-dashboard-nav" aria-label="Admin navigation">
          ${renderAdminNav(getAdminNavItemsForRole([
            { type: "overview", icon: "dashboard", label: "Overview" },
            { type: "insights", icon: "pulse", label: "Insights" },
            { group: "Learning" },
            { type: "subjects", icon: "subject", label: "Subjects", count: subjectCount },
            { type: "sections", icon: "section", label: "Sections", count: sectionCount },
            { type: "articles", icon: "tutorial", label: "Tutorials", count: tutorialCount },
            { group: "Practice" },
            { type: "codingMeta", icon: "section", label: "Coding Setup", count: codingSetupCount },
            { type: "codingProblems", icon: "code", label: "Coding Problems", count: codingProblemCount },
            { group: "Courses" },
            { type: "tutorials", icon: "course", label: "Courses", count: courseCount },
            { type: "inquiries", icon: "mail", label: "Course Inquiries", count: inquiryCount },
            { type: "sessions", icon: "calendar", label: "1:1 Sessions", count: sessionCount },
            { type: "sessionBookings", icon: "clock", label: "Session Bookings", count: pendingBookingCount },
            { group: "Publishing" },
            { type: "blogs", icon: "fileText", label: "Blogs", count: blogCount },
            { type: "events", icon: "pin", label: "Events", count: state.events.length },
            { group: "Community" },
            { type: "students", icon: "students", label: "Students", count: studentCount },
            { type: "communities", icon: "students", label: "Communities", count: communityCount },
            { type: "comments", icon: "flag", label: "Comments", count: flaggedCommentCount },
            { group: "Team" },
            { type: "contributors", icon: "students", label: "Contributors", count: contributorCount },
            { group: "Site" },
            { type: "settings", icon: "settings", label: "Settings" }
          ]))}
        </nav>
        <div class="admin-sidebar-card">
          <div class="admin-health-heading">
            ${renderAdminIcon("pulse")}
            <span>Publishing health</span>
          </div>
          <strong>${publishedCourses + publishedTutorials + publishedBlogs}</strong>
          <small>${draftCourses + draftTutorials + draftBlogs} items still in draft</small>
        </div>
        <div class="admin-sidebar-user">
          <span class="admin-user-avatar">${escapeHtml(getInitials(state.user.email || "Admin"))}</span>
          <span>
            <strong>${state.isAdmin ? "Administrator" : "Contributor"}</strong>
            <small>${escapeHtml(state.user.email || ADMIN_EMAIL)}</small>
            ${state.isAdmin ? "" : `<a class="admin-sidebar-profile-link" href="#profile">Edit profile</a>`}
          </span>
        </div>
      </aside>

      <div class="admin-main" data-reveal>
        <header class="admin-topline">
          <div>
            <p class="admin-breadcrumb">SkillUp Class <span>/</span> ${activeLibraryName}${adminEditorTitle && state.adminType === "articles" ? ` <span>/</span> ${escapeHtml(activeSubject.title)}` : ""}</p>
            <h1>${adminEditorTitle || `${activeLibraryName} dashboard`}</h1>
            <span>${adminEditorTitle ? escapeHtml(editingRecord?.title || (state.adminType === "articles" ? `Write a new tutorial for ${activeSubject.title}.` : `Add a new ${editorNoun}.`)) : activeDescription}</span>
          </div>
          <div class="admin-actions">
            ${primaryAction}
            ${seedCodingProblemsAction}

            <button class="button ghost admin-icon-command" type="button" data-signout>
              ${renderAdminIcon("logout")}
              <span>Sign out</span>
            </button>
          </div>
        </header>

        ${state.adminType === "overview" ? `
          <div class="admin-summary-grid">
            ${renderAwaitingReviewStat()}
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-amber">${renderAdminIcon("subject")}</span>
              <div><small>Subjects</small><strong>${subjectCount}</strong><span>Tutorial groups</span></div>
            </article>
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-green">${renderAdminIcon("tutorial")}</span>
              <div><small>Tutorials</small><strong>${tutorialCount}</strong><span>${draftTutorials} draft</span></div>
            </article>
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-blue">${renderAdminIcon("code")}</span>
              <div><small>Coding problems</small><strong>${codingProblemCount}</strong><span>${draftCodingProblems} draft</span></div>
            </article>
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-blue">${renderAdminIcon("course")}</span>
              <div><small>Courses</small><strong>${courseCount}</strong><span>${publishedCourses} published</span></div>
            </article>
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-violet">${renderAdminIcon("mail")}</span>
              <div><small>Course inquiries</small><strong>${inquiryCount}</strong><span>${pinnedInquiryCount} pinned</span></div>
            </article>
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-violet">${renderAdminIcon("fileText")}</span>
              <div><small>Blogs</small><strong>${blogCount}</strong><span>${publishedBlogs} published</span></div>
            </article>
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-green">${renderAdminIcon("students")}</span>
              <div><small>Students</small><strong>${studentCount}</strong><span>Learning accounts</span></div>
            </article>
          </div>
        ` : ""}

        <section class="admin-workbench">
          ${state.adminType === "overview" ? renderAdminOverview(subjects) : ""}
          ${state.adminType === "settings" ? renderSettingsAdminPanel() : ""}
          ${state.adminType === "insights" && state.isAdmin ? renderAdminInsightsPanel() : ""}
          ${state.adminType === "contributors" && state.isAdmin ? renderContributorsAdminPanel() : ""}
          ${state.adminType === "sessions" && state.isAdmin ? renderSessionAdminPanel() : ""}
          ${state.adminType === "sessionBookings" && state.isAdmin ? renderSessionBookingsAdminPanel() : ""}
          ${state.adminType === "inquiries" ? renderInquiryAdminPanel() : ""}
          ${state.adminType === "students" ? renderStudentsAdminPanel() : ""}
          ${state.adminType === "comments" ? renderCommentsAdminPanel() : ""}
          ${state.adminType === "communities" ? renderCommunityAdminPanel() : ""}
          ${state.adminType === "events" ? renderEventAdminPanel() : ""}
          ${state.adminType === "codingMeta" ? renderCodingMetaAdminPanel() : ""}
          ${state.adminType === "subjects" ? renderSubjectAdminPanel() : ""}
          ${state.adminType === "sections" ? renderSectionAdminPanel(subjects) : ""}
          ${state.adminType === "articles" && !state.adminEditorOpen ? renderAdminSubjectTabs(subjects, activeSubject) : ""}
          ${
            !ADMIN_CONTENT_TYPES.includes(state.adminType)
              ? ""
              : state.adminType === "articles" && !activeSubject
                ? renderEmptyState("Create a subject first, then add tutorials under that subject.")
                : state.adminEditorOpen
                  ? renderAdminEditorScreen(renderContentEditorForm(state.adminType, editorItem, activeSubject))
                  : renderContentLibraryScreen(state.adminType, activeList, activeSubject)
          }
        </section>
      </div>
    </section>
  `;
}

// The admin menu in working order: the tutorial library from the outside in
// (a subject holds sections, sections hold tutorials), then coding practice,
// courses and the inquiries they bring, publishing, the people side, and
// settings last. Group labels show on the desktop sidebar only (see
// .admin-nav-group); the tablet and phone strip keeps just the buttons.
function renderAdminNav(items) {
  return items
    .map((item) => item.group
      ? `<span class="admin-nav-group">${escapeHtml(item.group)}</span>`
      : `
          <button class="${state.adminType === item.type ? "is-active" : ""}" type="button" data-admin-tab="${escapeAttr(item.type)}">
            ${renderAdminIcon(item.icon)}
            <span>${escapeHtml(item.label)}</span>
            ${item.count === undefined ? "" : `<small>${item.count}</small>`}
          </button>`)
    .join("");
}

// Every admin section with a form works the same way: its list comes first,
// and adding or editing opens the form on a screen of its own, ending in a
// sticky Save bar. One flag (state.adminEditorOpen) covers whichever section
// is showing, and switching sections closes it. Sections, whose form is two
// fields, keep their popup.
const ADMIN_EDITOR_NOUNS = {
  articles: "tutorial",
  blogs: "blog post",
  tutorials: "course",
  codingProblems: "coding problem",
  subjects: "subject",
  events: "event",
  communities: "community",
  contributors: "contributor",
  sessions: "session"
};
const ADMIN_CONTENT_TYPES = ["articles", "blogs", "tutorials", "codingProblems"];

function renderAdminLibraryScreen({ kicker, title, meta, addLabel, addAttribute = "data-new-item", searchPlaceholder, showSearch, list }) {
  return `
    <section class="admin-card admin-library-card">
      <div class="admin-card-heading admin-library-heading">
        <div>
          <p class="admin-section-kicker">${escapeHtml(kicker)}</p>
          <h2>${escapeHtml(title)}</h2>
          <span>${escapeHtml(meta)}</span>
        </div>
        <button class="button primary" type="button" ${addAttribute}>
          ${renderAdminIcon("plus")}
          <span>${escapeHtml(addLabel)}</span>
        </button>
      </div>
      ${showSearch ? `
        <label class="admin-search">
          ${renderAdminIcon("search")}
          <input type="search" data-admin-search placeholder="${escapeAttr(searchPlaceholder)}" />
        </label>
      ` : ""}
      ${list}
    </section>
  `;
}

function renderAdminEditorScreen(formHtml) {
  return `
    <section class="admin-card admin-editor-card" data-admin-editor>
      ${formHtml}
    </section>
  `;
}

// "Save and keep editing" only where saving leaves the item loaded (content
// types); subjects, events and communities go back to their list on save.
function renderAdminEditorActions({ keepEditing = true } = {}) {
  return `
    <div class="form-actions admin-editor-actions">
      <button class="button primary" type="submit">${renderAdminIcon("save")}<span>${keepEditing ? "Save and close" : "Save"}</span></button>
      ${keepEditing ? `<button class="button ghost" type="submit" data-keep-editing>Save and keep editing</button>` : ""}
      <button class="button ghost" type="button" data-close-admin-editor>Cancel</button>
    </div>
  `;
}

// ---- Admin: suggested AI courses ------------------------------------------------
//
// Starter outlines only. Courses themselves are data managed in Admin >
// Courses: adding a suggestion writes an ordinary draft course, which the
// admin then edits, prices and publishes like any other. Nothing here is shown
// on the public site, and a suggestion disappears from the card once a course
// with the same id or title exists.
const SUGGESTED_AI_COURSES = [
  {
    id: "python-for-ai",
    title: "Python for AI",
    originalPrice: "12000",
    finalPrice: "5999",
    description: "Learn the Python you need before machine learning: clean code, working with data in NumPy and pandas, and charts. No programming background needed.",
    outcome: [
      "- Write and debug Python programs with confidence",
      "- Clean, analyse and chart real datasets with NumPy, pandas and Matplotlib",
      "- Call web APIs and work with JSON",
      "- Finish a small data analysis project for your portfolio"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Beginner",
    duration: "6 weeks",
    topics: ["Python basics", "Data structures", "Functions and modules", "Object-oriented Python", "NumPy", "pandas", "Matplotlib", "Jupyter notebooks", "APIs and JSON", "Git and GitHub", "Mini project"]
  },
  {
    id: "machine-learning-foundations",
    title: "Machine Learning Foundations",
    originalPrice: "16000",
    finalPrice: "7999",
    description: "Understand how models learn from data and build them with scikit-learn: regression, classification, clustering and honest model evaluation.",
    outcome: [
      "- Turn a real problem into a machine learning task",
      "- Prepare data and engineer useful features",
      "- Train, tune and compare regression and classification models",
      "- Choose the right metrics and avoid overfitting",
      "- Present an end-to-end machine learning project"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Beginner to Intermediate",
    duration: "8 weeks",
    topics: ["Machine learning basics", "Data preparation", "Feature engineering", "Linear regression", "Logistic regression", "Decision trees", "Random forests", "Clustering", "Model evaluation", "Cross-validation", "scikit-learn", "Capstone project"]
  },
  {
    id: "deep-learning-with-pytorch",
    title: "Deep Learning with PyTorch",
    originalPrice: "16000",
    finalPrice: "7999",
    description: "Build and train neural networks in PyTorch, from how backpropagation works to image models, transfer learning and the transformer ideas behind LLMs.",
    outcome: [
      "- Explain how neural networks learn",
      "- Write training loops in PyTorch",
      "- Train image classifiers with CNNs and transfer learning",
      "- Understand attention and transformers",
      "- Track experiments and improve model accuracy"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Intermediate",
    duration: "8 weeks",
    topics: ["Neural networks", "PyTorch", "Backpropagation", "Training loops", "CNNs", "Transfer learning", "Sequence models", "Attention", "Transformers", "GPU training", "Experiment tracking", "Capstone project"]
  },
  {
    id: "llm-app-development-with-ai-apis",
    title: "LLM App Development with AI APIs",
    originalPrice: "12000",
    finalPrice: "5999",
    description: "Build real applications on large language models: prompting, structured output, tool calling, streaming and testing, with the OpenAI, Gemini and Claude APIs.",
    outcome: [
      "- Write prompts that give reliable, structured results",
      "- Build chat and content features on LLM APIs",
      "- Use tool calling to connect a model to your own code",
      "- Test answer quality and keep costs under control",
      "- Ship a working LLM application"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Intermediate",
    duration: "6 weeks",
    topics: ["LLM basics", "Prompt engineering", "OpenAI API", "Gemini API", "Claude API", "Structured output", "Tool calling", "Streaming responses", "Evaluation", "Cost and rate limits", "Safety and guardrails", "Capstone project"]
  },
  {
    id: "rag-systems-chat-with-your-own-data",
    title: "RAG Systems: Chat With Your Own Data",
    originalPrice: "12000",
    finalPrice: "5999",
    description: "Ground LLM answers in your own documents. Build retrieval-augmented generation pipelines with embeddings, vector databases, reranking and evaluation.",
    outcome: [
      "- Decide when RAG is the right approach",
      "- Split, embed and index documents in a vector database",
      "- Build retrieval with filters, hybrid search and reranking",
      "- Measure answer quality and reduce hallucinations",
      "- Deploy a document question-answering assistant"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Intermediate",
    duration: "6 weeks",
    topics: ["RAG fundamentals", "Embeddings", "Chunking strategies", "Vector databases", "Semantic search", "Hybrid search", "Reranking", "LangChain", "LlamaIndex", "RAG evaluation", "Deployment", "Capstone project"]
  },
  {
    id: "agentic-ai-build-ai-agents",
    title: "Agentic AI: Build AI Agents",
    originalPrice: "14000",
    finalPrice: "6999",
    description: "Build AI agents that plan, call tools and complete multi-step tasks, with memory, guardrails, human approval and monitoring.",
    outcome: [
      "- Design agent workflows with tools and memory",
      "- Build single-agent and multi-agent systems",
      "- Connect agents to APIs, databases and MCP servers",
      "- Add guardrails, human approval and monitoring",
      "- Deliver a working automation agent"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Advanced",
    duration: "6 weeks",
    topics: ["Agent fundamentals", "Tool calling", "Planning and reasoning", "Agent memory", "LangGraph", "Multi-agent systems", "Model Context Protocol", "Workflow automation", "Guardrails", "Human in the loop", "Observability", "Capstone project"]
  },
  {
    id: "ai-for-android-and-flutter-developers",
    title: "AI for Android and Flutter Developers",
    originalPrice: "8000",
    finalPrice: "3999",
    description: "Add AI features to mobile apps: on-device machine learning with ML Kit and TensorFlow Lite, and generative AI with the Gemini API, in Android and Flutter.",
    outcome: [
      "- Add text, image and barcode recognition with ML Kit",
      "- Run TensorFlow Lite models on the device",
      "- Build chat and summary features with the Gemini API",
      "- Keep API keys and user data safe in mobile apps",
      "- Publish an AI-powered app project"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Intermediate",
    duration: "4 weeks",
    topics: ["ML Kit", "TensorFlow Lite", "Gemini API", "On-device AI", "Text recognition", "Image labelling", "Chat features", "Android with Kotlin", "Flutter with Dart", "API key security", "Capstone project"]
  },
  {
    id: "ai-and-ml-interview-preparation",
    title: "AI and ML Interview Preparation",
    originalPrice: "8000",
    finalPrice: "3999",
    description: "Prepare for machine learning, generative AI and AI engineer interviews: concept revision, coding rounds, system design and explaining your projects.",
    outcome: [
      "- Revise core machine learning, deep learning and LLM concepts",
      "- Solve Python and data coding rounds",
      "- Answer ML and generative AI system design questions",
      "- Explain your projects clearly and confidently",
      "- Practise with realistic interview questions"
    ].join("\n"),
    category: "Artificial Intelligence",
    level: "Intermediate",
    duration: "4 weeks",
    topics: ["ML concepts", "Deep learning concepts", "LLM and RAG concepts", "Python coding rounds", "SQL and data questions", "ML system design", "GenAI system design", "Project walkthroughs", "Behavioural questions", "Practice interviews"]
  },
  {
    id: "data-structures-and-algorithms-for-coding-interviews",
    title: "Data Structures and Algorithms for Coding Interviews",
    originalPrice: "16000",
    finalPrice: "7999",
    description: "Work through the patterns behind interview coding rounds in Java or Kotlin: arrays and strings, hash maps, two pointers, recursion, trees, graphs and dynamic programming, with timed practice every week.",
    outcome: [
      "- Recognise the pattern behind a problem instead of memorising answers",
      "- Work out time and space complexity with confidence",
      "- Solve medium-level problems inside the time limit",
      "- Explain your approach out loud the way interviewers expect",
      "- Finish with a revision sheet and a practice routine"
    ].join("\n"),
    category: "Interview Preparation",
    level: "Beginner to Intermediate",
    duration: "8 weeks",
    topics: ["Complexity analysis", "Arrays and strings", "Hash maps and sets", "Two pointers and sliding window", "Stacks and queues", "Recursion and backtracking", "Sorting and searching", "Linked lists", "Trees and binary search trees", "Graphs and BFS/DFS", "Dynamic programming", "Timed mock rounds"]
  },
  {
    id: "java-backend-development-with-spring-boot",
    title: "Java Backend Development with Spring Boot",
    originalPrice: "20000",
    finalPrice: "9999",
    description: "Build and ship a REST backend with Java and Spring Boot: controllers and services, databases with JPA, authentication, testing, and deploying an API that a mobile or web app can rely on.",
    outcome: [
      "- Build REST APIs with Spring Boot and Spring Data JPA",
      "- Design database tables and queries that hold up in production",
      "- Secure an API with authentication and roles",
      "- Write unit and integration tests you trust",
      "- Deploy an API and keep an eye on it"
    ].join("\n"),
    category: "Backend Development",
    level: "Beginner to Intermediate",
    duration: "10 weeks",
    topics: ["Java refresher", "Spring Boot basics", "REST controllers", "Spring Data JPA", "Databases and migrations", "Validation and error handling", "Authentication and roles", "Testing with JUnit", "Caching", "Logging and monitoring", "Docker basics", "Deployment"]
  },
  {
    id: "kotlin-multiplatform-one-codebase-for-android-and-ios",
    title: "Kotlin Multiplatform: One Codebase for Android and iOS",
    originalPrice: "14000",
    finalPrice: "6999",
    description: "Share your business logic between Android and iOS with Kotlin Multiplatform. Set up a shared module, handle networking, storage and concurrency once, and keep each platform's own interface.",
    outcome: [
      "- Set up a Kotlin Multiplatform project from scratch",
      "- Share networking, storage and business logic across platforms",
      "- Keep native UI with Jetpack Compose and SwiftUI",
      "- Test shared code once instead of twice",
      "- Ship a working app to both stores"
    ].join("\n"),
    category: "Mobile App Development",
    level: "Intermediate",
    duration: "6 weeks",
    topics: ["Kotlin Multiplatform setup", "Shared modules", "Expect and actual", "Ktor networking", "SQLDelight storage", "Coroutines and flows", "Dependency injection", "Jetpack Compose UI", "SwiftUI basics", "Testing shared code", "Build and release"]
  },
  {
    id: "full-stack-web-development-with-react-and-node",
    title: "Full-Stack Web Development with React and Node",
    originalPrice: "20000",
    finalPrice: "9999",
    description: "Go from HTML and CSS to a full web app: React on the front end, Node and Express on the back, a real database, authentication, and a deployed site you can show an employer.",
    outcome: [
      "- Build responsive interfaces with React",
      "- Write a Node and Express API with a database behind it",
      "- Add sign-up, login and protected pages",
      "- Test and debug a full-stack app",
      "- Deploy the finished app and keep it running"
    ].join("\n"),
    category: "Web Development",
    level: "Beginner to Advanced",
    duration: "12 weeks",
    topics: ["HTML and CSS", "Modern JavaScript", "React components and hooks", "State management", "Routing", "Node and Express", "REST APIs", "Databases", "Authentication", "Testing", "Performance", "Deployment"]
  },
  {
    id: "ios-app-development-masterclass-swift-and-swiftui",
    title: "iOS App Development Masterclass: Swift and SwiftUI",
    originalPrice: "25000",
    finalPrice: "8000",
    description: "Build iPhone apps with Swift and SwiftUI, from your first screen to the App Store: layouts and navigation, networking, local storage, concurrency with async/await, testing and release.",
    outcome: [
      "- Write Swift confidently, from the basics to protocols and generics",
      "- Build screens, navigation and state with SwiftUI",
      "- Call APIs and store data on the device",
      "- Handle background work with async/await",
      "- Test, sign and publish an app to the App Store"
    ].join("\n"),
    category: "Mobile App Development",
    level: "Beginner to Advanced",
    duration: "24 weeks",
    topics: ["Swift fundamentals", "Optionals and error handling", "Protocols and generics", "SwiftUI layouts", "Navigation and state", "MVVM architecture", "Networking with URLSession", "Core Data and storage", "Concurrency with async/await", "Unit and UI testing", "Push notifications", "App Store release"]
  },
  {
    id: "python-programming-masterclass-basic-to-advanced",
    title: "Python Programming Masterclass: Basic to Advanced",
    originalPrice: "20000",
    finalPrice: "8000",
    description: "Learn Python properly, from your first script to working applications: control flow, functions, object-oriented code, files and databases, REST APIs with Flask, automation, testing and a portfolio project.",
    outcome: [
      "- Write clean Python with functions, modules and classes",
      "- Work with files, JSON, CSV and SQL databases",
      "- Build REST APIs with Flask and call other web APIs",
      "- Automate everyday tasks and collect data responsibly",
      "- Test, debug and package a project you can show an employer"
    ].join("\n"),
    category: "Programming Fundamentals",
    level: "Beginner to Advanced",
    duration: "20 weeks",
    topics: ["Python basics", "Control flow", "Functions and modules", "Data structures", "Object-oriented Python", "Files, JSON and CSV", "Errors and debugging", "SQL and databases", "Flask REST APIs", "Working with web APIs", "Automation scripts", "Testing with pytest", "Virtual environments", "Portfolio project"]
  }
];

const COURSE_SUGGESTIONS_HIDDEN_KEY = "skillup-course-suggestions-hidden";

// The course already on file for a suggestion, by id, address or title.
function findCourseSuggestionCopy(existingCourses = [], suggestion) {
  const title = suggestion.title.toLowerCase();
  return existingCourses.find((course) => course.id === suggestion.id
    || course.slug === suggestion.id
    || String(course.title || "").trim().toLowerCase() === title) || null;
}

// A copy nobody has worked on: still a draft, no fee, and the description as
// this suggestion wrote it. Adding the suggestion again replaces one of
// these, which is how a course left unpriced gets its fee and goes live. A
// course that was edited, priced or published is never touched.
function isUntouchedCourseSuggestionCopy(existing, suggestion) {
  if (!existing || existing.status === "published") return false;
  if (String(existing.finalPrice || "").trim() || String(existing.originalPrice || "").trim()) return false;
  const description = String(existing.description || "").trim();
  return !description || description === suggestion.description;
}

function getRemainingSuggestedCourses(existingCourses = []) {
  return SUGGESTED_AI_COURSES.filter((suggestion) => {
    const existing = findCourseSuggestionCopy(existingCourses, suggestion);
    return !existing || isUntouchedCourseSuggestionCopy(existing, suggestion);
  });
}

// Course documents for the chosen suggestions ("all" or one id), placed after
// the courses you already have. Each carries its fee and goes straight onto
// the Courses page; edit, re-price, hide or unpublish it there like any
// other course. A copy left unpriced by an earlier version is replaced.
function getSuggestedCourseEntries(existingCourses, ids, now = new Date().toISOString()) {
  const wanted = ids === "all" ? null : new Set([].concat(ids));
  const remaining = getRemainingSuggestedCourses(existingCourses).filter((course) => !wanted || wanted.has(course.id));
  const lastOrder = existingCourses.reduce((max, course) => Math.max(max, Number(course.order) || 0), 0);
  return remaining.map((course, index) => {
    const existing = findCourseSuggestionCopy(existingCourses, course);
    return {
      ...course,
      slug: course.id,
      topics: [...course.topics],
      originalPrice: course.originalPrice || "",
      finalPrice: course.finalPrice || "",
      coverImage: "",
      coverImagePath: "",
      status: "published",
      hiddenFromPublic: false,
      showOnHome: false,
      order: Number(existing?.order) || lastOrder + index + 1,
      createdAt: existing?.createdAt || now,
      updatedAt: now
    };
  });
}

function areCourseSuggestionsHidden() {
  try {
    return window.localStorage.getItem(COURSE_SUGGESTIONS_HIDDEN_KEY) === "1";
  } catch {
    return false;
  }
}

function setCourseSuggestionsHidden(hidden) {
  try {
    if (hidden) window.localStorage.setItem(COURSE_SUGGESTIONS_HIDDEN_KEY, "1");
    else window.localStorage.removeItem(COURSE_SUGGESTIONS_HIDDEN_KEY);
  } catch {
    // Private windows can refuse storage; the card simply stays visible.
  }
}

// ---- Merging the catalogue -------------------------------------------------------
//
// Seventeen published courses is more than the catalogue can carry, and
// several of them are one subject split into pieces. Each group below keeps
// one course and folds the others into it: their topics and outcomes are
// added to the one that stays, and the folded courses become drafts, so
// nothing is deleted and the merge can be undone by publishing them again.
//
// Fees and durations are deliberately left alone - what a longer course
// should cost is the admin's call, not something to guess here.
const COURSE_MERGE_GROUPS = [
  {
    keep: "android-app-development-masterclass-basic-to-advanced",
    fold: ["kotlin-multiplatform-one-codebase-for-android-and-ios", "ai-for-android-and-flutter-developers"]
  },
  {
    keep: "python-programming-masterclass-basic-to-advanced",
    fold: ["python-for-ai"]
  },
  {
    keep: "generative-ai-masterclass-basic-to-advanced",
    fold: ["llm-app-development-with-ai-apis", "rag-systems-chat-with-your-own-data", "agentic-ai-build-ai-agents"]
  },
  {
    keep: "machine-learning-foundations",
    title: "Machine Learning and Deep Learning",
    description: "Learn how models learn from data, then build neural networks: regression and classification with scikit-learn, followed by training, transfer learning and the transformer ideas behind modern AI in PyTorch.",
    fold: ["deep-learning-with-pytorch"]
  },
  {
    keep: "data-structures-and-algorithms-for-coding-interviews",
    title: "Coding and AI Interview Preparation",
    description: "Prepare for the whole interview: data structures and algorithms in Java or Kotlin, plus the machine learning, generative AI and project questions asked in AI and data roles.",
    fold: ["ai-and-ml-interview-preparation"]
  },
  {
    keep: "full-stack-web-development-with-react-and-node",
    title: "Backend and Full-Stack Development",
    description: "Build the server and the screens: REST APIs with Java and Spring Boot, a React front end on Node, databases, authentication, testing and deployment.",
    fold: ["java-backend-development-with-spring-boot"]
  }
];

const MERGED_TOPIC_LIMIT = 40;
const MERGED_OUTCOME_LIMIT = 10;

// Keeps the first spelling of each entry and drops repeats, so "Kotlin" from
// two courses appears once.
function mergeUniqueList(lists, limit) {
  const seen = new Set();
  const merged = [];
  for (const value of lists.flat()) {
    const text = String(value || "").trim();
    const key = text.toLowerCase();
    if (!text || seen.has(key)) continue;
    seen.add(key);
    merged.push(text);
    if (merged.length >= limit) break;
  }
  return merged;
}

// What each group would become, given the courses on file. Groups whose kept
// course is missing, and folds that are already unpublished, are skipped, so
// running this twice changes nothing the second time.
function planCourseMerges(courses = []) {
  const byId = new Map(courses.map((course) => [course.id, course]));
  return COURSE_MERGE_GROUPS.map((group) => {
    const keeper = byId.get(group.keep);
    if (!keeper) return null;
    const folds = group.fold
      .map((id) => byId.get(id))
      .filter((course) => course && course.status === "published");
    const renames = Boolean(group.title) && keeper.title !== group.title;
    if (!folds.length && !renames) return null;
    return {
      keeper,
      folds,
      title: group.title || keeper.title,
      description: group.description || keeper.description,
      topics: mergeUniqueList([toArray(keeper.topics), ...folds.map((course) => toArray(course.topics))], MERGED_TOPIC_LIMIT),
      outcome: mergeUniqueList(
        [keeper.outcome, ...folds.map((course) => course.outcome)].map((text) => String(text || "").split(/\r?\n/)),
        MERGED_OUTCOME_LIMIT
      ).join("\n")
    };
  }).filter(Boolean);
}

// The documents to write: each kept course with the merged syllabus, and each
// folded course back to draft. Fee, level, duration and cover are untouched.
function buildCourseMergeWrites(courses, now = new Date().toISOString()) {
  const writes = [];
  for (const plan of planCourseMerges(courses)) {
    writes.push({
      ...plan.keeper,
      title: plan.title,
      description: plan.description,
      topics: plan.topics,
      outcome: plan.outcome,
      updatedAt: now
    });
    for (const folded of plan.folds) {
      writes.push({ ...folded, status: "draft", hiddenFromPublic: true, updatedAt: now });
    }
  }
  return writes;
}

function renderCourseMergeCard(courses) {
  const plans = planCourseMerges(courses);
  if (!plans.length) return "";
  const foldCount = plans.reduce((total, plan) => total + plan.folds.length, 0);
  const published = courses.filter((course) => course.status === "published").length;
  return `
    <section class="suggested-courses course-merge-card" aria-labelledby="course-merge-title">
      <div class="suggested-courses-heading">
        <div>
          <p class="admin-section-kicker">Catalogue</p>
          <h3 id="course-merge-title">Merge into ${published - foldCount} courses</h3>
          <p>Several courses cover one subject in pieces. This folds ${foldCount} of them into the course that stays: their topics and outcomes are added to it, and they become drafts you can publish again at any time. Fees and durations are left as they are - set those yourself once you see the merged courses.</p>
        </div>
        <div class="admin-actions">
          <button class="button primary small" type="button" data-merge-courses>${renderAdminIcon("plus")}<span>Merge ${foldCount} courses</span></button>
        </div>
      </div>
      <ul class="suggested-courses-list">
        ${plans.map((plan) => `
          <li>
            <div>
              <strong>${escapeHtml(plan.title)}${plan.title !== plan.keeper.title ? ` <small>(renamed from ${escapeHtml(plan.keeper.title)})</small>` : ""}</strong>
              <small>${plan.topics.length} topics after merging</small>
              <span>${plan.folds.length ? `Folds in: ${escapeHtml(plan.folds.map((course) => course.title).join(", "))}` : "Renamed only"}</span>
            </div>
          </li>
        `).join("")}
      </ul>
    </section>
  `;
}

async function mergeCourses() {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  const writes = buildCourseMergeWrites(state.tutorials);
  if (!writes.length) {
    showToast("The catalogue is already merged.");
    return false;
  }

  if (state.firebaseEnabled) {
    const { doc, writeBatch } = firebase.api;
    const batch = writeBatch(firebase.db);
    writes.forEach((course) => batch.set(doc(firebase.db, "tutorials", course.id), course));
    await batch.commit();
    await loadContent({ admin: true });
  } else {
    const byId = new Map(writes.map((course) => [course.id, normalizeItem(course, "tutorials")]));
    state.tutorials = state.tutorials.map((course) => byId.get(course.id) || course);
    persistLocalContent();
  }

  const folded = writes.filter((course) => course.status === "draft").length;
  showToast(`${folded} ${folded === 1 ? "course" : "courses"} folded in. Check the fees and durations of the merged courses.`);
  render();
  return true;
}

function renderSuggestedCoursesCard(existingCourses) {
  const remaining = getRemainingSuggestedCourses(existingCourses);
  if (!remaining.length) return "";
  if (areCourseSuggestionsHidden()) {
    return `<button class="auth-link suggested-courses-show" type="button" data-show-course-suggestions>Show suggested AI courses (${remaining.length})</button>`;
  }
  return `
    <section class="suggested-courses" aria-labelledby="suggested-courses-title">
      <div class="suggested-courses-heading">
        <div>
          <p class="admin-section-kicker">Suggestions</p>
          <h3 id="suggested-courses-title">Suggested courses</h3>
          <p>Course outlines with the description, outcomes, topics and fee already filled in. Adding one puts it straight on your Courses page; you can edit, re-price, add a cover image or unpublish it there like any other course.</p>
        </div>
        <div class="admin-actions">
          <button class="button primary small" type="button" data-add-suggested-course="all">${renderAdminIcon("plus")}<span>Add all ${remaining.length} and publish</span></button>
          <button class="button ghost small" type="button" data-hide-course-suggestions>Hide</button>
        </div>
      </div>
      <ul class="suggested-courses-list">
        ${remaining.map((course) => `
          <li>
            <div>
              <strong>${escapeHtml(course.title)}</strong>
              <small>${escapeHtml([course.level, course.duration, formatCoursePrice(course.finalPrice)].filter(Boolean).join(" · "))}</small>
              <span>${escapeHtml(course.description)}</span>
            </div>
            <button class="button ghost small" type="button" data-add-suggested-course="${escapeAttr(course.id)}" aria-label="Add and publish ${escapeAttr(course.title)}">${renderAdminIcon("plus")}<span>Add and publish</span></button>
          </li>
        `).join("")}
      </ul>
    </section>
  `;
}

async function addSuggestedCourses(ids) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  const added = getSuggestedCourseEntries(state.tutorials, ids);
  if (!added.length) {
    showToast("These courses are already in your list.");
    return false;
  }

  if (state.firebaseEnabled) {
    const { doc, writeBatch } = firebase.api;
    const batch = writeBatch(firebase.db);
    added.forEach((course) => batch.set(doc(firebase.db, "tutorials", course.id), course));
    await batch.commit();
    await loadContent({ admin: true });
  } else {
    // Same as the batch above, which writes by document id: a course this
    // suggestion already created is replaced, not added a second time.
    const replacements = added.map((course) => normalizeItem(course, "tutorials"));
    const replacedIds = new Set(replacements.map((course) => course.id));
    state.tutorials = [...state.tutorials.filter((course) => !replacedIds.has(course.id)), ...replacements];
    persistLocalContent();
  }

  state.adminType = "tutorials";
  state.editingId = null;
  showToast(added.length === 1
    ? `"${added[0].title}" is live on your Courses page. Add a cover image when you have one.`
    : `${added.length} courses are live on your Courses page. Add cover images when you have them.`);
  render();
  return true;
}

function renderContentLibraryScreen(type, items, subject) {
  const labels = {
    articles: { kicker: "Tutorials", title: subject?.title || "Tutorials", singular: "tutorial", plural: "tutorials" },
    blogs: { kicker: "Blog", title: "Blog posts", singular: "post", plural: "posts" },
    tutorials: { kicker: "Courses", title: "Courses", singular: "course", plural: "courses" },
    codingProblems: { kicker: "Coding practice", title: "Coding problems", singular: "problem", plural: "problems" }
  }[type];
  const published = items.filter((item) => item.status === "published").length;
  const drafts = items.length - published;
  const hiddenCount = type === "tutorials" ? items.filter((item) => item.hiddenFromPublic).length : 0;
  const rows = type === "articles"
    ? renderSectionedAdminTutorialList(subject, items)
    : items.map((item) => renderAdminListItem(item, type)).join("") || renderEmptyState(`No ${labels.plural} yet.`);

  return renderAdminLibraryScreen({
    kicker: labels.kicker,
    title: labels.title,
    meta: `${items.length} ${items.length === 1 ? labels.singular : labels.plural} / ${published} published / ${drafts} ${drafts === 1 ? "draft" : "drafts"}${hiddenCount ? ` / ${hiddenCount} hidden` : ""}`,
    addLabel: `Add new ${ADMIN_EDITOR_NOUNS[type]}`,
    searchPlaceholder: type === "articles" ? `Search tutorials in ${subject?.title || "this subject"}` : `Search ${labels.plural}`,
    showSearch: items.length > 6,
    list: `${type === "tutorials" && state.isAdmin ? renderCourseMergeCard(items) + renderSuggestedCoursesCard(items) : ""}${type === "blogs" && state.isAdmin ? renderSuggestedBlogsCard(items) : ""}<div class="admin-list">${rows}</div>`
  });
}

function renderContentEditorForm(type, item, subject) {
  if (type === "articles") return renderArticleForm(item || {}, subject);
  if (type === "blogs") return renderBlogForm(item || {});
  if (type === "codingProblems") return renderCodingProblemForm(item || {});
  return renderCourseForm(item || {});
}

function isAdminEditorDirty() {
  return document.querySelector("[data-admin-editor] form")?.dataset.dirty === "true";
}

// Asks before throwing away unsaved typing. True means it is fine to leave.
function confirmLeaveAdminEditor() {
  if (!state.adminEditorOpen || !isAdminEditorDirty()) return true;
  return window.confirm("Leave without saving? Your changes will be lost.");
}

function openAdminEditor() {
  state.adminEditorOpen = true;
  render();
  window.requestAnimationFrame(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    document.querySelector('[data-admin-editor] input[name="title"]')?.focus({ preventScroll: true });
  });
}

function closeAdminEditor() {
  state.adminEditorOpen = false;
  state.editingId = null;
  state.editingSubjectId = null;
  state.editingEventId = null;
  state.editingCommunityId = null;
  render();
  window.requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "auto" }));
}

function renderAdminIcon(name) {
  const icons = {
    calendar: '<rect x="3" y="4" width="18" height="17" rx="2" /><path d="M8 2v4" /><path d="M16 2v4" /><path d="M3 10h18" />',
    clock: '<circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />',
    dashboard: '<rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />',
    tutorial: '<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5z" /><path d="M4 5.5v16" /><path d="M8 7h8" /><path d="M8 11h6" />',
    subject: '<path d="M4 5h16v14H4z" /><path d="M8 3v4" /><path d="M16 3v4" /><path d="M8 11h8" /><path d="M8 15h5" />',
    section: '<path d="M4 6h16" /><path d="M4 12h16" /><path d="M4 18h16" /><path d="M8 4v4" /><path d="M14 10v4" /><path d="M10 16v4" />',
    course: '<path d="m3 7 9-4 9 4-9 4z" /><path d="M7 9.5v5.2c0 1.3 2.2 2.8 5 2.8s5-1.5 5-2.8V9.5" /><path d="M21 7v6" />',
    code: '<path d="m8 9-4 3 4 3" /><path d="m16 9 4 3-4 3" /><path d="m14 4-4 16" />',
    book: '<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H7a3 3 0 0 0-3 3V5.5z" /><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M8 7h8" /><path d="M8 11h6" />',
    download: '<path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" />',
    settings: '<circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.83 2.83-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1.1V21H10v-.1A1.7 1.7 0 0 0 8.6 19.3a1.7 1.7 0 0 0-1.5.4l-.06.06-2.83-2.83.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1.1-.4H3V10h.1A1.7 1.7 0 0 0 4.7 8.6a1.7 1.7 0 0 0-.4-1.5l-.06-.06 2.83-2.83.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1.1V3H14v.1A1.7 1.7 0 0 0 15.4 4.7a1.7 1.7 0 0 0 1.5-.4l.06-.06 2.83 2.83-.06.06A1.7 1.7 0 0 0 19.4 9c.4.6 1 .9 1.7 1H21v4h-.1a1.7 1.7 0 0 0-1.5 1z" />',
    mail: '<path d="M4 5h16v14H4z" /><path d="m4 7 8 6 8-6" />',
    students: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />',
    pin: '<path d="M12 17v5" /><path d="M5 17h14" /><path d="M8 3h8l-1 8 3 3v3H6v-3l3-3z" />',
    pulse: '<path d="M3 12h4l2-6 4 12 2-6h6" />',
    plus: '<path d="M12 5v14" /><path d="M5 12h14" />',
    save: '<path d="M5 3h12l2 2v16H5z" /><path d="M9 3v6h6V3" /><path d="M8 15h8" /><path d="M8 18h8" />',
    logout: '<path d="M10 17l5-5-5-5" /><path d="M15 12H3" /><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />',
    edit: '<path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4z" />',
    trash: '<path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 15H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" />',
    fileText: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6" /><path d="M8 13h8" /><path d="M8 17h6" /><path d="M8 9h2" />',
    image: '<rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8.5" cy="9.5" r="1.5" /><path d="m21 16-5-5-6 6-3-3-4 4" />',
    search: '<circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" />',
    arrow: '<path d="M5 12h14" /><path d="m13 6 6 6-6 6" />',
    arrowUp: '<path d="m6 15 6-6 6 6" />',
    arrowDown: '<path d="m6 9 6 6 6-6" />',
    eye: '<path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" /><circle cx="12" cy="12" r="3" />',
    eyeOff: '<path d="M3 3l18 18" /><path d="M10.6 10.6A2 2 0 0 0 13.4 13.4" /><path d="M9.9 5.2A10.5 10.5 0 0 1 12 5c6.5 0 10 7 10 7a17.8 17.8 0 0 1-3.1 4.1" /><path d="M6.6 6.6C3.6 8.5 2 12 2 12s3.5 7 10 7a10.7 10.7 0 0 0 4.2-.8" />',
    flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V4s-1 1-4 1-5-2-8-2-4 1-4 1z" /><line x1="4" y1="22" x2="4" y2="15" />'
  };
  return `<svg class="admin-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${icons[name] || icons.dashboard}</svg>`;
}

function renderCodingMetaAdminPanel() {
  const meta = getCodingMeta();
  return `
    <section class="admin-card coding-meta-panel">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Coding practice setup</p>
          <h2>Manage type, difficulty, and category sections</h2>
          <span>These lists power the coding-problem editor, public filters, and problem group headings.</span>
        </div>
      </div>
      <form class="coding-meta-form" data-coding-meta-form>
        <div class="coding-meta-grid">
          ${renderCodingMetaListEditor("types", "Type", "Examples: DSA, Coding Round, SQL Practice.", meta.types)}
          ${renderCodingMetaListEditor("difficulties", "Difficulty", "Examples: Easy, Medium, Hard, Interview Ready.", meta.difficulties)}
          ${renderCodingMetaListEditor("categories", "Category / section", "Examples: Arrays & Hashing, Matrix Programs, Real-World Scenarios.", meta.categories)}
        </div>
        <div class="form-actions coding-meta-actions">
          <button class="button primary" type="submit">${renderAdminIcon("save")}<span>Save coding setup</span></button>
        </div>
      </form>
    </section>
  `;
}

function renderCodingMetaListEditor(listName, title, description, items = []) {
  return `
    <article class="coding-meta-card">
      <header>
        <div>
          <h3>${escapeHtml(title)}</h3>
          <p>${escapeHtml(description)}</p>
        </div>
        <button class="button ghost small" type="button" data-add-coding-meta-row="${escapeAttr(listName)}">${renderAdminIcon("plus")}<span>Add</span></button>
      </header>
      <div class="coding-meta-rows" data-coding-meta-rows="${escapeAttr(listName)}">
        ${items.map((item, index) => renderCodingMetaRow(listName, item, index)).join("") || renderCodingMetaRow(listName, { label: "", order: 1 }, 0)}
      </div>
    </article>
  `;
}

function renderCodingMetaRow(listName, item = {}, index = 0) {
  const option = normalizeCodingMetaOption(item, index + 1) || { id: "", label: "", order: index + 1 };
  return `
    <div class="coding-meta-row" data-coding-meta-row>
      <input type="hidden" name="${escapeAttr(listName)}Id" value="${escapeAttr(option.id)}" />
      <label>
        <span>Name</span>
        <input name="${escapeAttr(listName)}Label" value="${escapeAttr(option.label)}" placeholder="Add ${escapeAttr(listName.replace(/s$/, ""))}" />
      </label>
      <label>
        <span>Order</span>
        <input name="${escapeAttr(listName)}Order" type="number" min="1" value="${escapeAttr(option.order || index + 1)}" />
      </label>
      <button class="icon-only-button" type="button" data-remove-coding-meta-row title="Remove ${escapeAttr(option.label || titleCaseListName(listName))}" aria-label="Remove ${escapeAttr(option.label || titleCaseListName(listName))}">${renderAdminIcon("trash")}</button>
    </div>
  `;
}

function titleCaseListName(value = "") {
  return String(value || "item").replace(/[-_]/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
function renderStudentsAdminPanel() {
  const students = [...state.students].sort((a, b) => new Date(b.lastLoginAt || b.updatedAt || b.createdAt || 0) - new Date(a.lastLoginAt || a.updatedAt || a.createdAt || 0));
  const activeThisWeek = students.filter((student) => {
    const loginTime = new Date(student.lastLoginAt || 0).getTime();
    return Number.isFinite(loginTime) && Date.now() - loginTime <= 7 * 24 * 60 * 60 * 1000;
  }).length;

  return `
    <section class="admin-card student-admin-panel">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Registered learners</p>
          <h2>Students</h2>
          <span>Students who create an account to access tutorials and coding practice appear here.</span>
        </div>
        <div class="admin-actions">
          <button class="button ghost" type="button" data-export-csv="students">${renderAdminIcon("download")}<span>Download CSV</span></button>
          <button class="button ghost" type="button" data-refresh-students>Refresh students</button>
        </div>
      </div>
      ${state.adminStudentLoadError ? `<p class="form-error">${escapeHtml(state.adminStudentLoadError)}</p>` : ""}
      <div class="student-admin-summary">
        <span><strong>${students.length}</strong><small>Total students</small></span>
        <span><strong>${activeThisWeek}</strong><small>Active this week</small></span>
        <span><strong>${students.filter((student) => student.email).length}</strong><small>Email accounts</small></span>
      </div>
      <label class="admin-search">
        ${renderAdminIcon("search")}
        <input type="search" data-admin-search placeholder="Search students" />
      </label>
      <div class="student-admin-list">
        ${students.map(renderStudentAdminItem).join("") || renderEmptyState("No student accounts yet.")}
      </div>
    </section>
  `;
}

function renderCommentsAdminPanel() {
  const comments = [...state.adminComments].sort((a, b) => b.flagCount - a.flagCount);
  const hiddenCount = comments.filter((comment) => comment.status === "hidden").length;

  return `
    <section class="admin-card comment-admin-panel">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Community moderation</p>
          <h2>Flagged comments</h2>
          <span>Comments learners have reported on tutorials and blog posts appear here for review.</span>
        </div>
        <button class="button ghost" type="button" data-refresh-comments>Refresh</button>
      </div>
      ${state.adminCommentLoadError ? `<p class="form-error">${escapeHtml(state.adminCommentLoadError)}</p>` : ""}
      <div class="student-admin-summary">
        <span><strong>${comments.length}</strong><small>Recent comments</small></span>
        <span><strong>${comments.filter((comment) => comment.flagCount > 0).length}</strong><small>Reported</small></span>
        <span><strong>${comments.filter((comment) => comment.suspicious).length}</strong><small>Suspicious</small></span>
        <span><strong>${hiddenCount}</strong><small>Hidden</small></span>
      </div>
      ${renderModerationFilterTabs()}
      <div class="comment-admin-list">
        ${filterModerationItems(comments).map((comment) => renderCommentAdminItem(comment)).join("")
          || renderEmptyState("Nothing matches this filter.")}
      </div>
      ${renderBlockedStudentsPanel()}
    </section>
  `;
}

const MODERATION_FILTERS = [
  { id: "all", label: "All" },
  { id: "reported", label: "Reported" },
  { id: "suspicious", label: "Suspicious" },
  { id: "hidden", label: "Hidden" }
];

function filterModerationItems(items = []) {
  const filter = state.adminModerationFilter || "all";
  if (filter === "reported") return items.filter((item) => item.flagCount > 0);
  if (filter === "suspicious") return items.filter((item) => item.suspicious);
  if (filter === "hidden") return items.filter((item) => item.status === "hidden");
  return items;
}

function renderModerationFilterTabs() {
  const active = state.adminModerationFilter || "all";
  return `
    <div class="moderation-filter-tabs" role="tablist" aria-label="Moderation filter">
      ${MODERATION_FILTERS.map((filter) => `
        <button class="moderation-filter-tab ${filter.id === active ? "is-active" : ""}" type="button"
          role="tab" aria-selected="${filter.id === active}" data-moderation-filter="${escapeAttr(filter.id)}">
          ${escapeHtml(filter.label)}
        </button>
      `).join("")}
    </div>
  `;
}

function renderBlockAuthorActions(item, area) {
  if (!item.authorUid) return "";
  const blocked = state.adminBlockedUsers.some((entry) => entry.uid === item.authorUid);
  if (blocked) {
    return `<button class="button ghost small" type="button" data-unblock-student="${escapeAttr(item.authorUid)}">Unblock author</button>`;
  }
  return `
    <button class="button ghost small" type="button"
      data-block-author="${escapeAttr(item.authorUid)}"
      data-author-name="${escapeAttr(item.authorName || "Student")}"
      data-block-area="${escapeAttr(area)}">Block author</button>
  `;
}

function renderBlockedStudentsPanel() {
  const blocked = state.adminBlockedUsers || [];
  if (!blocked.length) return "";

  return `
    <div class="blocked-students-panel">
      <h3>Blocked students</h3>
      <div class="blocked-students-list">
        ${blocked.map((entry) => `
          <div class="blocked-student-row">
            <div>
              <strong>${escapeHtml(entry.name || entry.uid)}</strong>
              <span>${escapeHtml((entry.areas || []).join(", "))}${entry.reason ? ` - ${escapeHtml(entry.reason)}` : ""}</span>
            </div>
            <button class="button ghost small" type="button" data-unblock-student="${escapeAttr(entry.uid)}">Unblock</button>
          </div>
        `).join("")}
      </div>
    </div>
  `;
}

function renderCommentAdminItem(comment) {
  const isHidden = comment.status === "hidden";
  return `
    <article class="comment-admin-item ${isHidden ? "is-hidden" : ""}">
      <div class="comment-admin-meta">
        ${comment.flagCount > 0 ? `<span class="difficulty-badge difficulty-hard">${comment.flagCount} report${comment.flagCount === 1 ? "" : "s"}</span>` : ""}
        ${comment.suspicious ? `<span class="difficulty-badge difficulty-medium">Auto-flagged</span>` : ""}
        ${comment.parentId ? `<span class="difficulty-badge">Reply</span>` : ""}
        <span>${escapeHtml(comment.contentType === "blog" ? "Blog" : "Tutorial")} &middot; ${escapeHtml(comment.contentTitle || comment.contentId)}</span>
        <span>${escapeHtml(comment.authorName)} &middot; ${escapeHtml(formatDate(comment.createdAt))}</span>
      </div>
      <p class="comment-admin-body">${escapeHtml(comment.body)}</p>
      <div class="admin-actions">
        ${isHidden
          ? `<button class="button ghost small" type="button" data-restore-comment="${escapeAttr(comment.id)}">Restore</button>`
          : `<button class="button ghost small" type="button" data-hide-comment="${escapeAttr(comment.id)}">Hide</button>`}
        <button class="button ghost small" type="button" data-dismiss-comment-flags="${escapeAttr(comment.id)}">Dismiss reports</button>
        ${renderBlockAuthorActions(comment, "tutorials")}
        <button class="button danger small" type="button" data-delete-admin-comment="${escapeAttr(comment.id)}">Delete</button>
      </div>
    </article>
  `;
}

const COMMUNITY_ICON_OPTIONS = ["users", "smartphone", "apple", "layers", "code", "sparkles", "compass", "target", "trending-up", "lightbulb"];

function renderEventAdminPanel() {
  const events = getAdminEvents();
  if (!state.adminEditorOpen) {
    const upcomingCount = events.filter((event) => event.status === "published" && !isPastEvent(event)).length;
    const archivedCount = events.filter((event) => event.status === "archived").length;
    return renderAdminLibraryScreen({
      kicker: "Events",
      title: "Events",
      meta: `${events.length} ${events.length === 1 ? "event" : "events"} / ${upcomingCount} upcoming / ${archivedCount} archived`,
      addLabel: "Add new event",
      addAttribute: "data-new-event",
      searchPlaceholder: "Search events",
      showSearch: events.length > 6,
      list: `<div class="subject-admin-list" aria-label="Events">${events.map(renderEventAdminItem).join("") || renderEmptyState("Create your first event.")}</div>`
    });
  }

  const editingEvent = findEventById(state.editingEventId);
  return renderAdminEditorScreen(`
      <form class="subject-admin-form event-admin-form" data-event-form>
        <label class="event-field-title">
          <span>Event title</span>
          <input name="title" value="${escapeAttr(editingEvent?.title || "")}" placeholder="Example: Android Interview Prep Live" required />
        </label>
        <label class="event-field-status">
          <span>Status</span>
          ${state.isAdmin ? `<select name="status">
            <option value="published" ${!editingEvent || editingEvent.status === "published" ? "selected" : ""}>Published</option>
            <option value="draft" ${editingEvent?.status === "draft" ? "selected" : ""}>Draft (not shown)</option>
            <option value="archived" ${editingEvent?.status === "archived" ? "selected" : ""}>Archived</option>
          </select>
          <small>${editingEvent?.status === "archived" ? "Hidden from students." : editingEvent?.status === "draft" ? "Not shown until you publish it." : "Visible to students."}</small>` : `<input type="hidden" name="status" value="draft" /><strong>Draft</strong>${editingEvent?.reviewStatus === "changes_requested" ? `<p class="contributor-review-note"><strong>Changes requested:</strong> ${escapeHtml(editingEvent.reviewNote || "See the admin's note.")}</p>` : ""}
          <small>The admin reviews your event and publishes it.</small>`}
        </label>
        <label class="event-field-description">
          <span>Description</span>
          <textarea name="description" maxlength="1200" rows="8" placeholder="What will you cover? Who is it for?">${escapeHtml(editingEvent?.description || "")}</textarea>
          <small>Leave a blank line between paragraphs. Start a line with -, * or 1. to make a list.</small>
        </label>
        <p class="event-form-legend">Schedule</p>
        <label>
          <span>Starts</span>
          <input name="startAt" type="datetime-local" value="${escapeAttr(isoToLocalInput(editingEvent?.startAt))}" required />
        </label>
        <label>
          <span>Ends</span>
          <input name="endAt" type="datetime-local" value="${escapeAttr(isoToLocalInput(editingEvent?.endAt))}" />
          <small>Optional.</small>
        </label>
        <label>
          <span>Format</span>
          <select name="mode">
            ${EVENT_MODES.map((mode) => `<option value="${escapeAttr(mode.id)}" ${editingEvent?.mode === mode.id ? "selected" : ""}>${escapeHtml(mode.label)}</option>`).join("")}
          </select>
        </label>
        <p class="event-form-legend">Where and who</p>
        <label>
          <span>Location</span>
          <input name="location" value="${escapeAttr(editingEvent?.location || "")}" placeholder="Online, or a venue" />
        </label>
        <label>
          <span>Host</span>
          <input name="host" value="${escapeAttr(editingEvent?.host || "")}" placeholder="Who is running it?" />
        </label>
        <label>
          <span>Capacity</span>
          <input name="capacity" type="number" min="0" value="${escapeAttr(editingEvent?.capacity || 0)}" />
          <small>0 means no limit. Students see how many places are left.</small>
        </label>
        <p class="event-form-legend">Cover image</p>
        <label class="event-field-cover">
          <span>Image URL</span>
          <input name="coverImage" type="url" value="${escapeAttr(editingEvent?.coverImage || "")}" data-cover-url placeholder="Paste an image URL, upload, or pick from the library" />
          <input name="coverImagePath" type="hidden" value="${escapeAttr(editingEvent?.coverImagePath || "")}" />
        </label>
        ${renderCoverPreview(editingEvent?.coverImage || "")}
        <label class="upload-field event-field-cover-upload">
          <span>Upload cover</span>
          <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-upload-target="coverImage" data-storage-folder="events" />
          <small>Stored in Firebase Storage under <code>events/</code>.</small>
        </label>
        <div class="event-field-cover-library">
          <button class="button ghost small" type="button" data-media-library="coverImage">${renderAdminIcon("image")}<span>Choose from library</span></button>
          ${editingEvent?.coverImage ? `<button class="button ghost small" type="button" data-clear-image="coverImage">Remove cover</button>` : ""}
        </div>
        ${renderAdminEditorActions({ keepEditing: false })}
      </form>
  `);
}

function renderEventAdminItem(event) {
  const isEditing = state.editingEventId === event.id;
  const registrations = state.eventRegistrations[event.id];
  const loaded = Array.isArray(registrations);
  const searchText = `${event.title} ${event.description} ${event.host} ${event.location}`;

  return `
    <div class="subject-admin-item event-admin-item ${isEditing ? "is-editing" : ""}" data-admin-search-item data-search="${escapeAttr(searchText)}">
      <div class="event-admin-topline">
        <div>
          <strong>${escapeHtml(event.title)}</strong>
          <small>${escapeHtml(renderEventWhen(event))} / ${escapeHtml(renderEventModeLabel(event))}${event.status === "archived" ? " / Archived" : ""}${event.status === "draft" ? " / Draft" : ""}${isPastEvent(event) ? " / Finished" : ""}</small>
          ${renderContributionCredit(event)}
        </div>
        <div class="admin-actions">
          ${state.isAdmin || event.status === "published" ? `<a class="button ghost small" href="#events/${encodeURIComponent(event.id)}">View</a>` : ""}
          ${state.isAdmin && event.submittedByUid && event.status === "draft" ? `<button class="button ghost small" type="button" data-request-changes="${escapeAttr(event.id)}" data-request-type="events">${renderAdminIcon("flag")}<span>Request changes</span></button>` : ""}
          ${state.isAdmin || canContributorEdit(event) ? `<button class="button ghost small" type="button" data-edit-event="${escapeAttr(event.id)}">${renderAdminIcon("edit")}<span>Edit</span></button>
          <button class="button ghost small" type="button" data-delete-event="${escapeAttr(event.id)}">${renderAdminIcon("trash")}<span>Delete</span></button>` : `<span class="contributor-locked-note">Published by admin</span>`}
        </div>
      </div>
      ${!state.isAdmin ? "" : loaded ? renderEventRegistrationsPanel(event) : `
        <div class="event-registrations-collapsed">
          <button class="button ghost small" type="button" data-load-event-registrations="${escapeAttr(event.id)}">
            ${renderAdminIcon("students")}<span>Show registrations</span>
          </button>
        </div>
      `}
    </div>
  `;
}

function renderEventRegistrationsPanel(event) {
  const registrations = state.eventRegistrations[event.id] || [];
  const meeting = state.eventMeetings[event.id];
  const error = state.eventRegistrationError[event.id];
  const inviteHref = buildEventInviteMailto(event, meeting);
  const emails = getEventRegistrationEmails(event.id);

  return `
    <div class="event-registrations">
      ${error ? `<p class="form-error">${escapeHtml(error)}</p>` : ""}
      <div class="event-registrations-heading">
        <strong>${registrations.length} registered${event.capacity ? ` of ${event.capacity}` : ""}</strong>
        <button class="button ghost small" type="button" data-load-event-registrations="${escapeAttr(event.id)}" data-force="true">Refresh</button>
      </div>

      <form class="event-meeting-form" data-event-meeting-form="${escapeAttr(event.id)}">
        <label>
          <span>Meeting link</span>
          <input name="meetingLink" type="url" value="${escapeAttr(meeting?.meetingLink || "")}" placeholder="https://meet.google.com/..." />
          <small>Only the admin and registered students can read this. Leave empty to hide it again.</small>
        </label>
        <label>
          <span>Note for attendees</span>
          <input name="meetingNote" maxlength="500" value="${escapeAttr(meeting?.meetingNote || "")}" placeholder="Optional: joining instructions" />
        </label>
        <div class="event-meeting-actions">
          <button class="button primary small" type="submit">${renderAdminIcon("save")}<span>Save meeting link</span></button>
          ${registrations.length
            ? `<button class="button ghost small" type="button" data-send-event-invite="${escapeAttr(event.id)}">${renderAdminIcon("mail")}<span>Send invite to all ${registrations.length}</span></button>`
            : `<span class="event-detail-note">Add at least one registration to send invites.</span>`}
          ${inviteHref ? `<a class="button ghost small" href="${escapeAttr(inviteHref)}">Open in mail app</a>` : ""}
          ${emails.length ? `<button class="button ghost small" type="button" data-copy-event-emails="${escapeAttr(event.id)}">Copy ${emails.length} email${emails.length === 1 ? "" : "s"}</button>` : ""}
        </div>
      </form>

      ${registrations.length ? `
        <ul class="event-registration-list">
          ${registrations.map((registration) => `
            <li>
              <span>
                <strong>${escapeHtml(registration.studentName || "Student")}</strong>
                <small>${escapeHtml(registration.studentEmail || "No email on file")}</small>
              </span>
              <small>${escapeHtml(formatDate(registration.registeredAt))}</small>
            </li>
          `).join("")}
        </ul>
      ` : renderEmptyState("Nobody has registered yet.")}
    </div>
  `;
}

// ---- Admin: contributors and review -------------------------------------------

async function loadContributors() {
  if (!state.isAdmin || !state.firebaseEnabled) return;
  try {
    const { collection, getDocs } = firebase.api;
    const snapshot = await getDocs(collection(firebase.db, "contributors"));
    state.contributors = snapshot.docs
      .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
      .sort((a, b) => String(a.name || a.email).localeCompare(String(b.name || b.email)));
    state.contributorsLoaded = true;
    // Events are not part of the main admin load; the review count needs them.
    await loadEvents().catch(() => false);
  } catch (error) {
    console.warn("Could not load contributors:", error);
  }
}

// Contributor drafts waiting for the admin, for one contributor or everyone.
function countContributionsAwaitingReview(uid = "") {
  return [state.articles, state.tutorials, state.blogs, state.codingProblems, state.events]
    .flat()
    .filter((item) => item?.status === "draft" && item.submittedByUid && item.reviewStatus !== "changes_requested" && (!uid || item.submittedByUid === uid))
    .length;
}

function renderAwaitingReviewStat() {
  const count = countContributionsAwaitingReview();
  if (!count) return "";
  return `
            <article class="admin-stat-card">
              <span class="admin-stat-icon is-amber">${renderAdminIcon("edit")}</span>
              <div><small>Awaiting review</small><strong>${count}</strong><span>Drafts from contributors</span></div>
            </article>`;
}

// Who sent an item in. The admin sees the name, with "Awaiting review" while
// it is a draft; the contributor sees where their item stands.
function renderContributionCredit(item) {
  if (!item?.submittedByUid) return "";
  const pending = item.status === "draft";
  const sentBack = pending && item.reviewStatus === "changes_requested";
  if (!state.isAdmin) {
    if (sentBack) {
      return `<small class="contribution-credit is-changes">Changes requested${item.reviewNote ? `: ${escapeHtml(item.reviewNote)}` : ""}</small>`;
    }
    return `<small class="contribution-credit${pending ? " is-pending" : ""}">${pending ? "Waiting for admin review" : "Published by admin"}</small>`;
  }
  const name = item.submittedByName || "Contributor";
  const label = sentBack ? " · Changes requested" : pending ? " · Awaiting review" : "";
  return `<small class="contribution-credit${sentBack ? " is-changes" : pending ? " is-pending" : ""}">By ${escapeHtml(name)}${label}</small>`;
}

function renderContentStatusField(item = {}) {
  if (!state.isAdmin && state.isContributor) {
    return `
        <div class="contributor-status-note">
          <span>Status</span>
          <strong>Draft</strong>
          ${item.reviewStatus === "changes_requested" ? `<p class="contributor-review-note"><strong>Changes requested:</strong> ${escapeHtml(item.reviewNote || "See the admin's note.")}</p>` : ""}
          <small>The admin reviews your draft and publishes it.</small>
          <input type="hidden" name="status" value="draft" />
        </div>`;
  }
  return `
        <label>
          <span>Status</span>
          <select name="status">
            <option value="published" ${item.status === "published" ? "selected" : ""}>Published</option>
            <option value="draft" ${item.status !== "published" ? "selected" : ""}>Draft</option>
          </select>
        </label>`;
}

function renderContributorConfirmEmail() {
  return `
    <section class="admin-shell admin-login-shell section-band">
      <div class="admin-card login-panel contributor-confirm-panel">
        <p class="eyebrow">Contributor access</p>
        <h1>Confirm your email to start contributing.</h1>
        <p class="muted">Before you can save drafts we need to know ${escapeHtml(state.user.email || "this address")} is yours. Send the link, open it from your inbox, then come back here.</p>
        <div class="form-actions">
          <button class="button primary" type="button" data-send-verification>Send confirmation link</button>
          <button class="button ghost" type="button" data-refresh-verification>I've confirmed it</button>
        </div>
        <button class="auth-link" type="button" data-signout>Sign out</button>
      </div>
    </section>
  `;
}

function renderContributorsAdminPanel() {
  if (state.adminEditorOpen) {
    return renderAdminEditorScreen(`
      <form class="subject-admin-form contributor-admin-form" data-contributor-form>
        <label>
          <span>Name</span>
          <input name="name" maxlength="120" placeholder="Example: Asha Rao" required />
        </label>
        <label>
          <span>Email</span>
          <input name="email" type="email" maxlength="160" placeholder="asha@example.com" required />
          <small>If they have no account yet, one is created and they get an email to set their password.</small>
        </label>
        <p class="contributor-admin-help">Contributors can add tutorials, courses, coding problems, blog posts and events. Everything they save is a draft that you review and publish. They cannot see or change anything else in the admin panel.</p>
        ${renderAdminEditorActions({ keepEditing: false })}
      </form>
    `);
  }

  const contributors = state.contributors;
  const activeCount = contributors.filter((person) => person.active).length;
  return renderAdminLibraryScreen({
    kicker: "Team",
    title: "Contributors",
    meta: state.contributorsLoaded
      ? `${activeCount} active / ${contributors.length - activeCount} removed / ${countContributionsAwaitingReview()} awaiting review`
      : "Loading contributors...",
    addLabel: "Add contributor",
    addAttribute: "data-new-contributor",
    searchPlaceholder: "Search contributors",
    showSearch: contributors.length > 6,
    list: `<div class="subject-admin-list" aria-label="Contributors">${contributors.map(renderContributorAdminItem).join("") || renderEmptyState(state.contributorsLoaded ? "No contributors yet. Add someone so they can send in drafts." : "Loading contributors...")}</div>`
  });
}

function renderContributorAdminItem(person) {
  // Drafts are matched by account id, which the record gets on the
  // contributor's first sign-in with a confirmed email.
  const pending = person.uid ? countContributionsAwaitingReview(person.uid) : 0;
  return `
    <div class="subject-admin-item contributor-admin-item${person.active ? "" : " is-public-hidden"}" data-admin-search-item data-search="${escapeAttr(`${person.name} ${person.email}`)}">
      <div class="subject-admin-detail">
        <span class="student-admin-avatar">${escapeHtml(getInitials(person.name || person.email))}</span>
        <div>
          <strong>${escapeHtml(person.name || person.email)}</strong>
          <span>${escapeHtml(person.email)}${person.active ? "" : " · Access removed"}${pending ? ` · ${pending} awaiting review` : ""}</span>
          ${person.profession || person.currentOrganisation || person.mobileNo ? `<small class="contributor-admin-details">${escapeHtml([[person.profession, person.currentOrganisation].filter(Boolean).join(" at "), person.mobileNo].filter(Boolean).join(" · "))}</small>` : ""}
        </div>
      </div>
      <div class="admin-actions">
        ${person.active ? `
          <button class="button ghost small" type="button" data-contributor-password-link="${escapeAttr(person.email)}">${renderAdminIcon("mail")}<span>Send password link</span></button>
          <button class="button ghost small" type="button" data-contributor-active="${escapeAttr(person.email)}" data-active-next="false">${renderAdminIcon("eyeOff")}<span>Remove access</span></button>
        ` : `
          <button class="button ghost small" type="button" data-contributor-active="${escapeAttr(person.email)}" data-active-next="true">${renderAdminIcon("eye")}<span>Restore access</span></button>
        `}
      </div>
    </div>
  `;
}

function contributorPayload(formData) {
  return {
    name: String(formData.get("name") || "").trim().slice(0, 120),
    email: getContributorKey(formData.get("email"))
  };
}

async function saveContributor({ name, email }) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showToast("Enter the contributor's name and a valid email address.");
    return false;
  }
  if (isAdminEmail(email)) {
    showToast("That is the admin account, which can already do everything.");
    return false;
  }

  const now = new Date().toISOString();
  const existing = state.contributors.find((person) => person.email === email);
  const { doc, setDoc } = firebase.api;
  // merge keeps the profile details the contributor filled in themselves.
  await setDoc(doc(firebase.db, "contributors", email), {
    email,
    name,
    active: true,
    addedAt: existing?.addedAt || now,
    addedBy: state.user.email || ADMIN_EMAIL,
    updatedAt: now
  }, { merge: true });
  const account = await createContributorAccount(email);
  await loadContributors();
  showToast(account === "created"
    ? `${name} can now contribute. We emailed ${email} a link to set a password.`
    : account === "existing"
      ? `${name} can now contribute. They already have an account, so they sign in with their current password.`
      : `${name} can now contribute, but their account could not be created. Use "Send password link" to try again.`);
  render();
  return true;
}

// Creates the sign-in account without signing the admin out: a separate,
// throwaway Firebase app instance makes it with a random password nobody
// sees, then a password-reset email lets the contributor choose their own.
async function createContributorAccount(email) {
  let secondaryApp = null;
  let appModule = null;
  try {
    const [loadedAppModule, authModule] = await Promise.all([
      import("./assets/firebase-10.12.2-v1/firebase-app.js"),
      import("./assets/firebase-10.12.2-v1/firebase-auth.js")
    ]);
    appModule = loadedAppModule;
    secondaryApp = appModule.initializeApp(firebaseConfig, `contributor-invite-${Date.now()}`);
    const secondaryAuth = authModule.initializeAuth(secondaryApp, { persistence: authModule.inMemoryPersistence });
    try {
      await authModule.createUserWithEmailAndPassword(secondaryAuth, email, `${crypto.randomUUID()}Aa1!`);
    } catch (error) {
      if (error?.code === "auth/email-already-in-use") return "existing";
      throw error;
    }
    await authModule.signOut(secondaryAuth).catch(() => {});
    await firebase.api.sendPasswordResetEmail(firebase.auth, email);
    return "created";
  } catch (error) {
    console.warn("Could not create contributor account:", error);
    return "failed";
  } finally {
    if (secondaryApp && appModule) await appModule.deleteApp(secondaryApp).catch(() => {});
  }
}

async function sendContributorPasswordLink(email) {
  if (!state.isAdmin) return;
  const account = await createContributorAccount(email);
  if (account === "existing") {
    await firebase.api.sendPasswordResetEmail(firebase.auth, email);
  }
  showToast(account === "failed" ? "Could not send the link. Try again shortly." : `Password link sent to ${email}.`);
}

async function setContributorActive(email, active) {
  if (!state.isAdmin) return;
  const person = state.contributors.find((item) => item.email === email);
  if (!person) return;
  const now = new Date().toISOString();
  const { doc, setDoc } = firebase.api;
  await setDoc(doc(firebase.db, "contributors", email), {
    email: person.email,
    name: person.name || person.email,
    active,
    addedAt: person.addedAt || now,
    addedBy: person.addedBy || state.user.email || ADMIN_EMAIL,
    updatedAt: now
  }, { merge: true });
  await loadContributors();
  showToast(active
    ? `${person.name || email} can contribute again.`
    : `${person.name || email} can no longer contribute. Their drafts stay for you to review.`);
  render();
}

// ---- Suggested blog posts ---------------------------------------------------------
//
// Written posts offered in Admin > Blogs. The articles are several thousand
// words, so they live in /suggested-blogs.js and are fetched only when the
// admin opens that screen - a visitor reading the site never downloads them.
const BLOG_SUGGESTIONS_HIDDEN_KEY = "skillup-blog-suggestions-hidden";

let suggestedBlogsRequest = null;

function loadSuggestedBlogs() {
  if (state.suggestedBlogs) return Promise.resolve(false);
  if (!suggestedBlogsRequest) {
    suggestedBlogsRequest = import("/suggested-blogs.js")
      .then((module) => {
        state.suggestedBlogs = module.SUGGESTED_BLOGS || [];
        return true;
      })
      .catch((error) => {
        console.warn("Could not load the suggested blog posts:", error);
        state.suggestedBlogs = [];
        return true;
      })
      .finally(() => {
        suggestedBlogsRequest = null;
      });
  }
  return suggestedBlogsRequest;
}

function getRemainingSuggestedBlogs(existingBlogs = []) {
  const posts = state.suggestedBlogs || [];
  const ids = new Set(existingBlogs.flatMap((blog) => [blog.id, blog.slug]).filter(Boolean));
  const titles = new Set(existingBlogs.map((blog) => String(blog.title || "").trim().toLowerCase()));
  return posts.filter((post) => !ids.has(post.id) && !titles.has(post.title.toLowerCase()));
}

// Blog documents for the chosen suggestions ("all" or one id), placed after
// the posts you already have. They are published with today's date; add a
// cover image afterwards if you want one on the card.
function getSuggestedBlogEntries(existingBlogs, ids, now = new Date().toISOString()) {
  const wanted = ids === "all" ? null : new Set([].concat(ids));
  const remaining = getRemainingSuggestedBlogs(existingBlogs).filter((post) => !wanted || wanted.has(post.id));
  const lastOrder = existingBlogs.reduce((max, blog) => Math.max(max, Number(blog.order) || 0), 0);
  return remaining.map((post, index) => ({
    id: post.id,
    slug: post.id,
    title: post.title,
    excerpt: post.excerpt,
    body: post.body,
    category: "SkillUp Blog",
    tags: [...post.tags],
    coverImage: "",
    coverImagePath: "",
    youtubeUrl: "",
    documentUrl: "",
    documentName: "",
    documentPath: "",
    status: "published",
    featured: false,
    showOnHome: false,
    order: lastOrder + index + 1,
    publishedAt: now,
    createdAt: now,
    updatedAt: now
  }));
}

function areBlogSuggestionsHidden() {
  try {
    return window.localStorage.getItem(BLOG_SUGGESTIONS_HIDDEN_KEY) === "1";
  } catch {
    return false;
  }
}

function setBlogSuggestionsHidden(hidden) {
  try {
    if (hidden) window.localStorage.setItem(BLOG_SUGGESTIONS_HIDDEN_KEY, "1");
    else window.localStorage.removeItem(BLOG_SUGGESTIONS_HIDDEN_KEY);
  } catch {
    // Private windows can refuse storage; the card simply stays visible.
  }
}

// Roughly how long the post takes to read, from its own word count.
function getBlogReadingMinutes(body) {
  const words = String(body || "").replace(/<[^>]*>/g, " ").trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 220));
}

function renderSuggestedBlogsCard(existingBlogs) {
  if (!state.suggestedBlogs) {
    loadSuggestedBlogs().then((changed) => { if (changed) render(); });
    return "";
  }
  const remaining = getRemainingSuggestedBlogs(existingBlogs);
  if (!remaining.length) return "";
  if (areBlogSuggestionsHidden()) {
    return `<button class="auth-link suggested-courses-show" type="button" data-show-blog-suggestions>Show suggested posts (${remaining.length})</button>`;
  }
  return `
    <section class="suggested-courses" aria-labelledby="suggested-blogs-title">
      <div class="suggested-courses-heading">
        <div>
          <p class="admin-section-kicker">Suggestions</p>
          <h3 id="suggested-blogs-title">Written posts, ready to publish</h3>
          <p>Full articles for the readers these tutorials already have, with code and headings written. Adding one publishes it to the blog, where you can edit it, add a cover image or unpublish it like any other post.</p>
        </div>
        <div class="admin-actions">
          <button class="button primary small" type="button" data-add-suggested-blog="all">${renderAdminIcon("plus")}<span>Add all ${remaining.length} and publish</span></button>
          <button class="button ghost small" type="button" data-hide-blog-suggestions>Hide</button>
        </div>
      </div>
      <ul class="suggested-courses-list">
        ${remaining.map((post) => `
          <li>
            <div>
              <strong>${escapeHtml(post.title)}</strong>
              <small>${escapeHtml([`${getBlogReadingMinutes(post.body)} min read`, ...post.tags].join(" · "))}</small>
              <span>${escapeHtml(post.excerpt)}</span>
            </div>
            <button class="button ghost small" type="button" data-add-suggested-blog="${escapeAttr(post.id)}" aria-label="Add and publish ${escapeAttr(post.title)}">${renderAdminIcon("plus")}<span>Add and publish</span></button>
          </li>
        `).join("")}
      </ul>
    </section>
  `;
}

async function addSuggestedBlogs(ids) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  const added = getSuggestedBlogEntries(state.blogs, ids);
  if (!added.length) {
    showToast("These posts are already on your blog.");
    return false;
  }

  if (state.firebaseEnabled) {
    const { doc, writeBatch } = firebase.api;
    const batch = writeBatch(firebase.db);
    added.forEach((post) => batch.set(doc(firebase.db, "blogs", post.id), post));
    await batch.commit();
    await loadContent({ admin: true });
  } else {
    const replacements = added.map((post) => normalizeItem(post, "blogs"));
    const replacedIds = new Set(replacements.map((post) => post.id));
    state.blogs = [...state.blogs.filter((post) => !replacedIds.has(post.id)), ...replacements];
    persistLocalContent();
  }

  showToast(added.length === 1
    ? `"${added[0].title}" is live on your blog.`
    : `${added.length} posts are live on your blog.`);
  render();
  return true;
}

// ---- Suggested communities --------------------------------------------------------
//
// Topic groups offered in Admin > Communities, the same way suggested courses
// and sessions are offered. Each one is added with its description and icon
// and goes straight onto the Students Hub; a community already on the list is
// never offered again.
const COMMUNITY_SUGGESTIONS_HIDDEN_KEY = "skillup-community-suggestions-hidden";

const SUGGESTED_COMMUNITIES = [
  {
    id: "flutter-developers",
    title: "Flutter Developers",
    icon: "smartphone",
    description: "For everyone building with Flutter and Dart. Share widgets and layouts that worked, ask about state management, performance or publishing, and compare notes on running one codebase across Android and iOS."
  },
  {
    id: "ios-developers",
    title: "iOS Developers",
    icon: "apple",
    description: "Swift and SwiftUI, from your first screen to App Store review. Ask about layouts, navigation, concurrency and testing, and share what you learned shipping an iPhone app."
  },
  {
    id: "python-developers",
    title: "Python Developers",
    icon: "code",
    description: "A place for Python of every kind: scripts and automation, APIs with Flask or FastAPI, data work with pandas, and the libraries worth knowing. Beginners welcome, questions encouraged."
  },
  {
    id: "machine-learning",
    title: "Machine Learning",
    icon: "layers",
    description: "Models, data and the parts in between. Discuss feature engineering, training and evaluation, read papers together, and get a second opinion on why your model will not learn."
  },
  {
    id: "coding-interview-prep",
    title: "Coding Interview Prep",
    icon: "target",
    description: "Practise for coding rounds together. Post the problem you are stuck on, compare approaches and complexity, share interview experiences, and keep each other to a weekly practice routine."
  },
  {
    id: "java-and-backend-developers",
    title: "Java and Backend Developers",
    icon: "code",
    description: "Java, Spring Boot and the backend craft: APIs, databases, caching, testing and deployment. Bring a design you are unsure about and talk it through with people who have shipped one."
  },
  {
    id: "web-developers",
    title: "Web Developers",
    icon: "compass",
    description: "HTML, CSS, JavaScript and the frameworks on top. Share what you are building, ask for a review of your layout or API, and work out the browser problem that has eaten your afternoon."
  },
  {
    id: "career-and-placements",
    title: "Career and Placements",
    icon: "trending-up",
    description: "Resumes, job hunting and the first year in a role. Ask what to learn next, get your resume read by people who have hired, and share openings and interview experiences with other students."
  }
];

function getRemainingSuggestedCommunities(existingCommunities = []) {
  const ids = new Set(existingCommunities.flatMap((community) => [community.id, community.slug]).filter(Boolean));
  const titles = new Set(existingCommunities.map((community) => String(community.title || "").trim().toLowerCase()));
  return SUGGESTED_COMMUNITIES.filter((community) => !ids.has(community.id) && !titles.has(community.title.toLowerCase()));
}

// Community documents for the chosen suggestions ("all" or one id), placed
// after the communities you already have. Fields match what the community
// form saves, so one can be edited afterwards like any other.
function getSuggestedCommunityEntries(existingCommunities, ids, now = new Date().toISOString()) {
  const wanted = ids === "all" ? null : new Set([].concat(ids));
  const remaining = getRemainingSuggestedCommunities(existingCommunities).filter((community) => !wanted || wanted.has(community.id));
  const lastOrder = existingCommunities.reduce((max, community) => Math.max(max, Number(community.order) || 0), 0);
  return remaining.map((community, index) => ({
    id: community.id,
    slug: community.id,
    title: community.title,
    description: community.description,
    icon: community.icon,
    logoImage: "",
    logoImagePath: "",
    whatsappUrl: "",
    status: "published",
    order: lastOrder + index + 1,
    createdAt: now,
    updatedAt: now
  }));
}

function areCommunitySuggestionsHidden() {
  try {
    return window.localStorage.getItem(COMMUNITY_SUGGESTIONS_HIDDEN_KEY) === "1";
  } catch {
    return false;
  }
}

function setCommunitySuggestionsHidden(hidden) {
  try {
    if (hidden) window.localStorage.setItem(COMMUNITY_SUGGESTIONS_HIDDEN_KEY, "1");
    else window.localStorage.removeItem(COMMUNITY_SUGGESTIONS_HIDDEN_KEY);
  } catch {
    // Private windows can refuse storage; the card simply stays visible.
  }
}

function renderSuggestedCommunitiesCard(existingCommunities) {
  const remaining = getRemainingSuggestedCommunities(existingCommunities);
  if (!remaining.length) return "";
  if (areCommunitySuggestionsHidden()) {
    return `<button class="auth-link suggested-courses-show" type="button" data-show-community-suggestions>Show suggested communities (${remaining.length})</button>`;
  }
  return `
    <section class="suggested-courses" aria-labelledby="suggested-communities-title">
      <div class="suggested-courses-heading">
        <div>
          <p class="admin-section-kicker">Suggestions</p>
          <h3 id="suggested-communities-title">Suggested communities</h3>
          <p>Topic groups for the subjects your tutorials already cover. Adding one puts it on the Students Hub straight away; you can rename it, add a logo or a WhatsApp link, or archive it there. A quiet community reads as empty, so add the few you will post in first.</p>
        </div>
        <div class="admin-actions">
          <button class="button primary small" type="button" data-add-suggested-community="all">${renderAdminIcon("plus")}<span>Add all ${remaining.length}</span></button>
          <button class="button ghost small" type="button" data-hide-community-suggestions>Hide</button>
        </div>
      </div>
      <ul class="suggested-courses-list">
        ${remaining.map((community) => `
          <li>
            <div>
              <strong>${escapeHtml(community.title)}</strong>
              <small>${escapeHtml(community.icon)}</small>
              <span>${escapeHtml(community.description)}</span>
            </div>
            <button class="button ghost small" type="button" data-add-suggested-community="${escapeAttr(community.id)}" aria-label="Add ${escapeAttr(community.title)}">${renderAdminIcon("plus")}<span>Add</span></button>
          </li>
        `).join("")}
      </ul>
    </section>
  `;
}

async function addSuggestedCommunities(ids) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }
  if (!state.firebaseEnabled) {
    showToast("Communities are not available right now. Please try again later.");
    return false;
  }
  const added = getSuggestedCommunityEntries(state.communities, ids);
  if (!added.length) {
    showToast("These communities are already on your list.");
    return false;
  }

  try {
    const { doc, writeBatch } = firebase.api;
    const batch = writeBatch(firebase.db);
    added.forEach((community) => batch.set(doc(firebase.db, "communities", community.id), community));
    await batch.commit();
    await loadCommunities({ force: true });
  } catch (error) {
    showToast("Could not add these communities. Please try again.");
    console.warn("Could not add suggested communities:", error);
    return false;
  }

  showToast(added.length === 1
    ? `"${added[0].title}" is live in the Students Hub.`
    : `${added.length} communities are live in the Students Hub.`);
  render();
  return true;
}

function renderCommunityAdminPanel() {
  const communities = getAdminCommunities();
  if (state.adminEditorOpen) {
    const editingCommunity = findCommunityById(state.editingCommunityId);
    const nextOrder = communities.length + 1;
    return renderAdminEditorScreen(`
      <form class="subject-admin-form community-admin-form" data-community-form>
        <label class="community-field-name">
          <span>Community name</span>
          <input name="title" value="${escapeAttr(editingCommunity?.title || "")}" placeholder="Example: Mobile Developers" required />
        </label>
        <label class="community-field-description">
          <span>Description</span>
          <textarea name="description" maxlength="500" rows="3" placeholder="What is this community for?">${escapeHtml(editingCommunity?.description || "")}</textarea>
        </label>
        <label>
          <span>Icon</span>
          <select name="icon">
            ${COMMUNITY_ICON_OPTIONS.map((key) => `<option value="${escapeAttr(key)}" ${editingCommunity?.icon === key ? "selected" : ""}>${escapeHtml(key)}</option>`).join("")}
          </select>
        </label>
        <label>
          <span>Order</span>
          <input name="order" type="number" min="1" value="${escapeAttr(editingCommunity?.order || nextOrder)}" />
        </label>
        <label>
          <span>Status</span>
          <select name="status">
            <option value="published" ${editingCommunity?.status !== "archived" ? "selected" : ""}>Published</option>
            <option value="archived" ${editingCommunity?.status === "archived" ? "selected" : ""}>Archived (hidden from students)</option>
          </select>
        </label>
        <label class="community-field-logo">
          <span>Community logo</span>
          <input name="logoImage" type="url" value="${escapeAttr(editingCommunity?.logoImage || "")}" data-cover-url placeholder="Paste an image URL, upload, or pick from the library" />
          <input name="logoImagePath" type="hidden" value="${escapeAttr(editingCommunity?.logoImagePath || "")}" />
        </label>
        ${renderCoverPreview(editingCommunity?.logoImage || "")}
        <label class="upload-field community-field-logo-upload">
          <span>Upload logo</span>
          <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-upload-target="logoImage" data-storage-folder="communities" />
          <small>Stored in Firebase Storage under <code>communities/</code>. Leave empty to use the icon above.</small>
        </label>
        <label class="community-field-whatsapp">
          <span>WhatsApp invite link</span>
          <input name="whatsappUrl" type="url" value="${escapeAttr(editingCommunity?.whatsappUrl || "")}" placeholder="https://chat.whatsapp.com/..." />
          <small>Shown publicly on the community page - anyone can open it, no login needed. Leave empty to hide the button.</small>
        </label>
        <div class="community-field-logo-library">
          <button class="button ghost small" type="button" data-media-library="logoImage">${renderAdminIcon("image")}<span>Choose from library</span></button>
          ${editingCommunity?.logoImage ? `<button class="button ghost small" type="button" data-clear-image="logoImage">Remove logo</button>` : ""}
        </div>
        ${renderAdminEditorActions({ keepEditing: false })}
      </form>
    `);
  }

  const flaggedPosts = [...state.adminCommunityPosts].sort((a, b) => b.flagCount - a.flagCount);
  const hiddenPostCount = flaggedPosts.filter((post) => post.status === "hidden").length;
  const archivedCount = communities.filter((community) => community.status === "archived").length;

  return `
    ${renderAdminLibraryScreen({
      kicker: "Students Hub",
      title: "Communities",
      meta: `${communities.length} ${communities.length === 1 ? "community" : "communities"} / ${archivedCount} archived`,
      addLabel: "Add new community",
      addAttribute: "data-new-community",
      searchPlaceholder: "Search communities",
      showSearch: communities.length > 6,
      list: `${renderSuggestedCommunitiesCard(communities)}<div class="subject-admin-list" aria-label="Communities">${communities.map(renderCommunityAdminItem).join("") || renderEmptyState("Create your first community.")}</div>`
    })}

    <section class="admin-card comment-admin-panel">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Community moderation</p>
          <h2>Flagged community posts</h2>
          <span>Posts learners have reported inside a community appear here for review.</span>
        </div>
        <button class="button ghost" type="button" data-refresh-community-posts>Refresh</button>
      </div>
      ${state.adminCommunityPostLoadError ? `<p class="form-error">${escapeHtml(state.adminCommunityPostLoadError)}</p>` : ""}
      <div class="student-admin-summary">
        <span><strong>${flaggedPosts.length}</strong><small>Recent posts</small></span>
        <span><strong>${flaggedPosts.filter((post) => post.flagCount > 0).length}</strong><small>Reported</small></span>
        <span><strong>${flaggedPosts.filter((post) => post.suspicious).length}</strong><small>Suspicious</small></span>
        <span><strong>${hiddenPostCount}</strong><small>Hidden</small></span>
      </div>
      ${renderModerationFilterTabs()}
      <div class="comment-admin-list">
        ${filterModerationItems(flaggedPosts).map((post) => renderCommunityPostAdminItem(post)).join("")
          || renderEmptyState("Nothing matches this filter.")}
      </div>
    </section>
  `;
}

function renderCommunityAdminItem(community) {
  const isEditing = state.editingCommunityId === community.id;
  const isArchived = community.status === "archived";
  const searchText = `${community.title} ${community.description}`;

  return `
    <div class="subject-admin-item ${isEditing ? "is-editing" : ""}" data-admin-search-item data-search="${escapeAttr(searchText)}">
      <div class="subject-admin-detail">
        ${safeUrl(community.logoImage)
          ? `<img class="admin-list-thumb" src="${escapeAttr(safeUrl(community.logoImage))}" alt="" loading="lazy" />`
          : `<span class="admin-list-placeholder">${renderAdminIcon("students")}</span>`}
        <div><strong>${escapeHtml(community.title)}</strong><span>${escapeHtml(community.description || "No description yet")}</span></div>
      </div>
      ${renderStatusBadge(isArchived ? "hidden" : "public")}
      <div class="subject-admin-actions">
        <button class="icon-only-button" type="button" data-edit-community="${escapeAttr(community.id)}" title="Edit ${escapeAttr(community.title)}" aria-label="Edit ${escapeAttr(community.title)}">${renderAdminIcon("edit")}</button>
        <button class="icon-only-button is-danger" type="button" data-delete-community="${escapeAttr(community.id)}" title="Remove ${escapeAttr(community.title)}" aria-label="Remove ${escapeAttr(community.title)}">${renderAdminIcon("trash")}</button>
      </div>
    </div>
  `;
}

function renderCommunityPostAdminItem(post) {
  const isHidden = post.status === "hidden";
  const community = findCommunityById(post.communityId);
  return `
    <article class="comment-admin-item ${isHidden ? "is-hidden" : ""}">
      <div class="comment-admin-meta">
        ${post.flagCount > 0 ? `<span class="difficulty-badge difficulty-hard">${post.flagCount} report${post.flagCount === 1 ? "" : "s"}</span>` : ""}
        ${post.suspicious ? `<span class="difficulty-badge difficulty-medium">Auto-flagged</span>` : ""}
        ${post.parentId ? `<span class="difficulty-badge">Reply</span>` : ""}
        <span>${escapeHtml(community?.title || post.communityId)}</span>
        <span>${escapeHtml(post.authorName)} &middot; ${escapeHtml(formatDate(post.createdAt))}</span>
      </div>
      <p class="comment-admin-body">${escapeHtml(post.body)}</p>
      <div class="admin-actions">
        ${isHidden
          ? `<button class="button ghost small" type="button" data-restore-community-post="${escapeAttr(post.id)}">Restore</button>`
          : `<button class="button ghost small" type="button" data-hide-community-post="${escapeAttr(post.id)}">Hide</button>`}
        <button class="button ghost small" type="button" data-dismiss-community-post-flags="${escapeAttr(post.id)}">Dismiss reports</button>
        ${renderBlockAuthorActions(post, "community")}
        <button class="button danger small" type="button" data-delete-admin-community-post="${escapeAttr(post.id)}">Delete</button>
      </div>
    </article>
  `;
}

// The list stays scannable: avatar, name and email with a View button. The
// rest of the profile opens in a popup (renderStudentDetailModal), rendered
// at the end of the admin shell like the Sections popup.
function getStudentKey(student) {
  return String(student?.uid || student?.id || student?.email || "");
}

function renderStudentAdminItem(student) {
  const searchText = [
    student.name,
    student.email,
    student.mobileNo,
    student.profession,
    student.currentOrganisation,
    student.experienceLevel,
    student.currentDegree,
    student.collegeName,
    student.uid,
    student.role
  ].join(" ");
  const initials = getInitials(student.name || student.email || "Student");
  const name = student.name || "Student";

  return `
    <article class="student-admin-item" data-admin-search-item data-search="${escapeAttr(searchText)}">
      <span class="student-admin-avatar">${escapeHtml(initials)}</span>
      <div class="student-admin-identity">
        <strong>${escapeHtml(name)}</strong>
        <small>${escapeHtml(student.email || "No email")}</small>
      </div>
      <button class="button ghost small" type="button" data-view-student="${escapeAttr(getStudentKey(student))}" aria-label="View details for ${escapeAttr(name)}">
        ${renderAdminIcon("eye")}
        <span>View</span>
      </button>
    </article>
  `;
}

function renderStudentDetailModal(student) {
  const name = student.name || "Student";
  const experienceLabel = student.experienceLevel === "fresher" ? "Fresher" : student.experienceLevel || "Not provided";
  const detail = (label, value) => `<span><small>${escapeHtml(label)}</small><strong>${escapeHtml(value)}</strong></span>`;

  return `
    <div class="admin-modal-overlay" data-student-modal>
      <button class="admin-modal-backdrop" type="button" data-close-student-modal tabindex="-1" aria-label="Close"></button>
      <div class="admin-modal-dialog student-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="student-modal-title">
        <header class="admin-modal-header">
          <div class="student-modal-identity">
            <span class="student-admin-avatar">${escapeHtml(getInitials(student.name || student.email || "Student"))}</span>
            <div>
              <p class="admin-section-kicker">Student</p>
              <h2 id="student-modal-title">${escapeHtml(name)}</h2>
              <small>${escapeHtml(student.email || "No email")}</small>
            </div>
          </div>
          <button class="icon-only-button" type="button" data-close-student-modal data-student-modal-focus aria-label="Close">&times;</button>
        </header>
        <div class="student-admin-meta">
          ${detail("Mobile", student.mobileNo || "Not provided")}
          ${detail("Profession", student.profession || "Not provided")}
          ${detail("Organisation", student.currentOrganisation || "Not provided")}
          ${detail("Experience", experienceLabel)}
          ${student.experienceLevel === "fresher" ? `
            ${detail("Degree", student.currentDegree || "Not provided")}
            ${detail("College", student.collegeName || "Not provided")}
          ` : ""}
          ${detail("Registered", formatDate(student.createdAt))}
          ${detail("Last login", formatDate(student.lastLoginAt || student.updatedAt))}
          ${detail("Tutorials completed", String((student.completedTutorials || []).length))}
          ${detail("Bookmarks", String((student.bookmarkedTutorials || []).length))}
        </div>
        <div class="admin-modal-actions">
          <button class="button primary" type="button" data-close-student-modal>Close</button>
        </div>
      </div>
    </div>
  `;
}

function renderAdminStudentModal() {
  if (!state.studentDetailId || !state.isAdmin || state.adminType !== "students" || getRoute().page !== "admin") return "";
  const student = state.students.find((item) => getStudentKey(item) === state.studentDetailId);
  return student ? renderStudentDetailModal(student) : "";
}

function openStudentModal(studentKey) {
  state.studentDetailId = studentKey;
  render();
  window.requestAnimationFrame(() => document.querySelector("[data-student-modal-focus]")?.focus());
}

function closeStudentModal() {
  const studentKey = state.studentDetailId;
  state.studentDetailId = null;
  render();
  if (!studentKey) return;
  window.requestAnimationFrame(() => {
    document.querySelector(`[data-view-student="${CSS.escape(studentKey)}"]`)?.focus();
  });
}

function renderInquiryAdminPanel() {
  const inquiries = [...state.inquiries].sort(sortInquiries);
  const pinnedCount = inquiries.filter((inquiry) => inquiry.pinned).length;
  const unpinnedCount = inquiries.length - pinnedCount;

  return `
    <section class="admin-card inquiry-admin-panel">
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Student leads</p>
          <h2>Course inquiries</h2>
          <span>Unpinned inquiries older than ${INQUIRY_RETENTION_DAYS} days are cleared when admin content loads. Pinned inquiries stay saved.</span>
        </div>
        <div class="admin-actions">
          <button class="button ghost" type="button" data-export-csv="inquiries">${renderAdminIcon("download")}<span>Download CSV</span></button>
        </div>
      </div>
      <div class="inquiry-admin-summary">
        <span><strong>${inquiries.length}</strong><small>Total inquiries</small></span>
        <span><strong>${pinnedCount}</strong><small>Pinned</small></span>
        <span><strong>${unpinnedCount}</strong><small>Auto-cleanup queue</small></span>
      </div>
      <label class="admin-search">
        ${renderAdminIcon("search")}
        <input type="search" data-admin-search placeholder="Search course inquiries" />
      </label>
      <div class="inquiry-admin-list">
        ${inquiries.map(renderInquiryAdminItem).join("") || renderEmptyState("No course inquiries yet.")}
      </div>
    </section>
  `;
}

function renderInquiryAdminItem(inquiry) {
  const contactParts = [inquiry.email, inquiry.phone, inquiry.city].filter(Boolean).join(" / ");
  const searchText = [inquiry.name, inquiry.email, inquiry.phone, inquiry.course, inquiry.city, inquiry.goal, inquiry.message].join(" ");
  const nextPinned = !inquiry.pinned;
  const replyHref = `mailto:${encodeURIComponent(inquiry.email)}?subject=${encodeURIComponent(`SkillUp Class course inquiry - ${inquiry.course || "Course guidance"}`)}`;
  const phoneHref = inquiry.phone ? `tel:${encodeURIComponent(inquiry.phone.replace(/\s+/g, ""))}` : "";

  return `
    <article class="inquiry-admin-item ${inquiry.pinned ? "is-pinned" : ""}" data-admin-search-item data-search="${escapeAttr(searchText)}">
      <header>
        <span class="inquiry-pin-mark">${renderAdminIcon("pin")}</span>
        <div>
          <strong>${escapeHtml(inquiry.name || "Unnamed student")}</strong>
          <small>${escapeHtml(inquiry.course || "Course not selected")} / ${formatDate(inquiry.createdAt)}</small>
        </div>
        <button class="button ghost" type="button" data-pin-inquiry="${escapeAttr(inquiry.id)}" data-pin-value="${String(nextPinned)}">
          ${renderAdminIcon("pin")}
          <span>${inquiry.pinned ? "Unpin" : "Pin"}</span>
        </button>
      </header>
      <div class="inquiry-admin-grid">
        <span><small>Contact</small><strong>${escapeHtml(contactParts || "Not provided")}</strong></span>
        <span><small>Goal</small><strong>${escapeHtml(inquiry.goal || "Not provided")}</strong></span>
        <span><small>Email status</small><strong>${inquiry.emailQueued ? "Queued" : "Needs setup"}</strong></span>
      </div>
      ${inquiry.message ? `<p>${escapeHtml(inquiry.message)}</p>` : ""}
      <footer>
        <a class="button ghost" href="${escapeAttr(replyHref)}">Reply by email</a>
        ${phoneHref ? `<a class="button ghost" href="${escapeAttr(phoneHref)}">Call student</a>` : ""}
      </footer>
    </article>
  `;
}
function renderAdminOverview(subjects) {
  const recentItems = [
    ...state.articles.map((item) => ({ ...item, contentType: "articles", typeLabel: "Tutorial" })),
    ...state.blogs.map((item) => ({ ...item, contentType: "blogs", typeLabel: "Blog" })),
    ...state.codingProblems.map((item) => ({ ...item, contentType: "codingProblems", typeLabel: "Coding Problem" })),
    ...state.tutorials.map((item) => ({ ...item, contentType: "tutorials", typeLabel: "Course" }))
  ].sort((a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0)).slice(0, 6);
  const publishedCount = recentItems.filter((item) => item.status === "published").length;
  const subjectWithMostTutorials = subjects.map((subject) => ({
    ...subject,
    tutorialCount: state.articles.filter((article) => article.category === subject.title).length
  })).sort((a, b) => b.tutorialCount - a.tutorialCount)[0];

  return `
    <div class="admin-overview-grid">
      <section class="admin-card admin-recent-card">
        <div class="admin-card-heading">
          <div><p class="admin-section-kicker">Recent activity</p><h2>Recently updated</h2></div>
          <button class="button ghost" type="button" data-admin-tab="articles"><span>View tutorials</span>${renderAdminIcon("arrow")}</button>
        </div>
        <div class="admin-table">
          <div class="admin-table-head"><span>Content</span><span>Type</span><span>Status</span><span>Updated</span><span class="sr-only">Actions</span></div>
          ${recentItems.length ? recentItems.map(renderAdminRecentItem).join("") : renderEmptyState("No content has been created yet.")}
        </div>
      </section>
      <aside class="admin-overview-side">
        <section class="admin-card admin-quick-actions">
          <div><p class="admin-section-kicker">Quick actions</p><h2>Create content</h2></div>
          <button type="button" data-admin-tab="subjects" data-open-editor><span class="admin-quick-icon is-amber">${renderAdminIcon("subject")}</span><span><strong>New subject</strong><small>Organize the tutorial library</small></span>${renderAdminIcon("arrow")}</button>
          <button type="button" data-admin-tab="articles" data-open-editor><span class="admin-quick-icon is-blue">${renderAdminIcon("tutorial")}</span><span><strong>New tutorial</strong><small>Write under a subject</small></span>${renderAdminIcon("arrow")}</button>
          <button type="button" data-admin-tab="codingMeta"><span class="admin-quick-icon is-green">${renderAdminIcon("section")}</span><span><strong>Coding setup</strong><small>Manage types and sections</small></span>${renderAdminIcon("arrow")}</button>
          <button type="button" data-admin-tab="codingProblems" data-open-editor><span class="admin-quick-icon is-blue">${renderAdminIcon("code")}</span><span><strong>New coding problem</strong><small>Add test cases for practice</small></span>${renderAdminIcon("arrow")}</button>
          <button type="button" data-admin-tab="tutorials" data-open-editor><span class="admin-quick-icon is-green">${renderAdminIcon("course")}</span><span><strong>New course</strong><small>Add a guided learning path</small></span>${renderAdminIcon("arrow")}</button>
          <button type="button" data-admin-tab="blogs" data-open-editor><span class="admin-quick-icon is-violet">${renderAdminIcon("fileText")}</span><span><strong>New blog post</strong><small>Publish independent articles</small></span>${renderAdminIcon("arrow")}</button>
        </section>
        <section class="admin-card admin-library-health">
          <p class="admin-section-kicker">Library health</p><h2>Publishing snapshot</h2>
          <div class="admin-health-meter"><span style="width: ${Math.round((publishedCount / Math.max(recentItems.length, 1)) * 100)}%"></span></div>
          <div class="admin-health-row"><span>Published recently</span><strong>${publishedCount} / ${recentItems.length}</strong></div>
          <div class="admin-health-row"><span>Largest subject</span><strong>${escapeHtml(subjectWithMostTutorials?.title || "None")}</strong></div>
          <div class="admin-health-row"><span>Tutorials in subject</span><strong>${subjectWithMostTutorials?.tutorialCount || 0}</strong></div>
        </section>
      </aside>
    </div>
  `;
}

function renderAdminRecentItem(item) {
  return `
    <div class="admin-table-row">
      <div><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.category || "General")}</small></div>
      <span>${escapeHtml(item.typeLabel)}</span>
      ${renderStatusBadge(item.status)}
      <span>${formatDate(item.updatedAt)}</span>
      <button class="icon-only-button" type="button" data-edit="${escapeAttr(item.id)}" data-edit-type="${escapeAttr(item.contentType)}" title="Edit ${escapeAttr(item.title)}" aria-label="Edit ${escapeAttr(item.title)}">${renderAdminIcon("edit")}</button>
    </div>
  `;
}

function renderStatusBadge(status = "draft") {
  const normalizedStatus = String(status || "draft").toLowerCase();
  const label = normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1);
  return `<span class="status-badge status-${escapeAttr(normalizedStatus)}">${escapeHtml(label)}</span>`;
}
function renderAuthPanel() {
  if (state.firebaseInitializing) {
    return `
      <div class="admin-card login-panel security-setup-panel">
        <p class="eyebrow">Connecting securely</p>
        <h2>Preparing secure admin login...</h2>
        <p class="muted">Please wait while SkillUp Class prepares the admin sign-in.</p>
        <div class="admin-login-points">
          <span>Checking access</span>
          <span>Loading sign-in</span>
          <span>Opening dashboard</span>
        </div>
      </div>
    `;
  }

  if (!state.firebaseEnabled) {
    if (state.firebaseError) {
      return `
        <div class="admin-card login-panel security-setup-panel">
          <p class="eyebrow">Connection issue</p>
          <h2>Admin login could not connect.</h2>
          <p class="muted">SkillUp Class could not finish connecting. Try once more after refreshing the page.</p>
          <div class="form-actions">
            <button class="button primary" type="button" data-reload-page>Retry connection</button>
            <a class="button ghost" href="#home">Go home</a>
          </div>
          <p class="form-error">${escapeHtml(state.firebaseError)}</p>
        </div>
      `;
    }

    // Only reached when sign-in is switched off in firebase-config.js (local
    // previews). To enable it: turn on Email/Password sign-in, create the admin
    // user, set USE_FIREBASE to true with the web app config, and deploy rules
    // for the same admin email. The page itself names no service.
    return `
      <div class="admin-card login-panel security-setup-panel">
        <p class="eyebrow">Admin sign-in</p>
        <h2>Admin sign-in is not available here.</h2>
        <p class="muted">Sign-in is switched off on this copy of the website. The public pages still work.</p>
      </div>
    `;
  }

  return state.authView === "forgot" ? renderForgotPasswordForm() : renderLoginForm();
}

function renderLoginForm() {
  return `
    <form class="admin-card login-panel" data-login-form>
      <div>
        <p class="eyebrow">Secure admin login</p>
        <h2>Sign in to the dashboard.</h2>
        <p class="muted">Use the administrator email address and password.</p>
      </div>
      <label>
        <span>Email</span>
        <input name="email" type="email" placeholder="Enter admin email" autocomplete="username" required />
      </label>
      <label>
        <span>Password</span>
        <input name="password" type="password" autocomplete="current-password" required />
      </label>
      <button class="button primary" type="submit">Sign in</button>
      <button class="auth-link" type="button" data-auth-view="forgot">Forgot password?</button>
      ${state.firebaseError ? `<p class="form-error">${escapeHtml(state.firebaseError)}</p>` : ""}
    </form>
  `;
}

function renderForgotPasswordForm() {
  return `
    <form class="admin-card login-panel" data-reset-password-form>
      <div>
        <p class="eyebrow">Password recovery</p>
        <h2>Send reset link.</h2>
        <p class="muted">Enter the admin account email and we will send a password reset link to it.</p>
      </div>
      <label>
        <span>Email</span>
        <input name="email" type="email" placeholder="Enter admin email" autocomplete="username" required />
      </label>
      <button class="button primary" type="submit">Send reset email</button>
      <button class="auth-link" type="button" data-auth-view="login">Back to sign in</button>
      ${state.firebaseError ? `<p class="form-error">${escapeHtml(state.firebaseError)}</p>` : ""}
    </form>
  `;
}

function renderSettingsAdminPanel() {
  return `
    ${renderSiteNavigationPanel()}
    ${renderCommunityPolicyAdminPanel()}
    ${renderClientErrorsAdminPanel()}
    ${renderChangePasswordPanel()}
  `;
}

function renderCommunityPolicyAdminPanel() {
  const policy = getCommunityPolicy();
  return `
    <form class="admin-card community-policy-admin-panel" data-community-policy-form>
      <div class="admin-card-heading">
        <div>
          <p class="admin-section-kicker">Community rules</p>
          <h2>Policy shown before joining</h2>
          <span>Students see this on every community before they can join, and agree to it as they join. One rule per line.</span>
        </div>
      </div>
      <label>
        <span>Policy text</span>
        <textarea name="body" rows="8" maxlength="4000" required>${escapeHtml(policy.body)}</textarea>
      </label>
      <div class="form-actions">
        <button class="button primary" type="submit">Save policy</button>
      </div>
    </form>
  `;
}

function renderSiteNavigationPanel() {
  const settings = normalizeSiteNavigation(state.siteNavigation);
  return `
    <form class="admin-card site-navigation-panel" data-site-navigation-form>
      <div class="admin-card-heading">
        <div>
          <p class="eyebrow">Public website</p>
          <h2>Show or hide public tabs</h2>
          <span>Turn off a tab when you want to hide that section from students and visitors. Admin users can still preview everything.</span>
        </div>
      </div>
      <div class="site-navigation-grid">
        ${PUBLIC_NAV_TABS.map((tab) => `
          <label class="site-navigation-toggle">
            <input name="visibleTabs" type="checkbox" value="${escapeAttr(tab.id)}" ${settings.visibleTabs[tab.id] !== false ? "checked" : ""} />
            <span>
              <strong>${escapeHtml(tab.label)}</strong>
              <small>${settings.visibleTabs[tab.id] !== false ? "Visible on public website" : "Hidden from public website"}</small>
            </span>
          </label>
        `).join("")}
      </div>
      <div class="form-actions">
        <button class="button primary" type="submit">Save tab visibility</button>
      </div>
    </form>
  `;
}
function renderChangePasswordPanel({ showBack = true } = {}) {
  return `
    <form class="admin-card password-panel" data-change-password-form>
      <div>
        <p class="eyebrow">Account security</p>
        <h2>Change password</h2>
        <p class="muted">Re-enter the current password before setting a new one.</p>
      </div>
      <div class="form-grid">
        <label>
          <span>Current password</span>
          <input name="currentPassword" type="password" autocomplete="current-password" required />
        </label>
        <label>
          <span>New password</span>
          <input name="newPassword" type="password" autocomplete="new-password" minlength="8" required />
        </label>
      </div>
      <div class="form-grid">
        <label>
          <span>Confirm new password</span>
          <input name="confirmPassword" type="password" autocomplete="new-password" minlength="8" required />
        </label>
        <div class="password-actions">
          <button class="button primary" type="submit">Update password</button>
          ${showBack ? `<button class="button ghost" type="button" data-admin-tab="overview">Back to overview</button>` : ""}
        </div>
      </div>
    </form>
  `;
}

function renderSubjectAdminPanel() {
  const subjects = getAdminSubjects();
  if (!state.adminEditorOpen) {
    const hiddenCount = subjects.filter((subject) => subject.hiddenFromPublic).length;
    return renderAdminLibraryScreen({
      kicker: "Tutorial subjects",
      title: "Subjects",
      meta: `${subjects.length} ${subjects.length === 1 ? "subject" : "subjects"} / ${hiddenCount} hidden from the public website`,
      addLabel: "Add new subject",
      addAttribute: "data-new-subject",
      searchPlaceholder: "Search subjects",
      showSearch: subjects.length > 6,
      list: `<div class="subject-admin-list" aria-label="Tutorial subjects">${subjects.map(renderSubjectAdminItem).join("") || renderEmptyState("Add your first subject.")}</div>`
    });
  }

  const editingSubject = findSubjectById(state.editingSubjectId);
  const nextOrder = subjects.length + 1;
  return renderAdminEditorScreen(`
      <form class="subject-admin-form" data-subject-form>
        <label>
          <span>Subject name</span>
          <input name="title" value="${escapeAttr(editingSubject?.title || "")}" placeholder="Example: Java" required />
        </label>
        <label>
          <span>Order</span>
          <input name="order" type="number" min="1" value="${escapeAttr(editingSubject?.order || nextOrder)}" />
        </label>
        <label class="subject-cover-field">
          <span>Subject image URL</span>
          <input name="coverImage" type="url" value="${escapeAttr(editingSubject?.coverImage || "")}" data-cover-url placeholder="Firebase Storage or direct image URL" />
          <input name="coverImagePath" type="hidden" value="${escapeAttr(editingSubject?.coverImagePath || "")}" />
        </label>
        ${renderCoverPreview(editingSubject?.coverImage || "")}
        <label class="checkbox-line checkbox-line-compact subject-visibility-field">
          <input name="hiddenFromPublic" type="checkbox" ${editingSubject?.hiddenFromPublic ? "checked" : ""} />
          <span>Hide this subject and all its tutorials from the public website</span>
        </label>
        <label class="upload-field subject-cover-upload">
          <span>Upload subject image</span>
          <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-upload-target="coverImage" data-storage-folder="subjects" />
          <small>Stored in Firebase Storage under <code>subjects/</code>.</small>
        </label>
        <div class="media-library-trigger subject-cover-library">
          <button class="button ghost small" type="button" data-media-library="coverImage">${renderAdminIcon("image")}<span>Choose from library</span></button>
        </div>
        ${renderAdminEditorActions({ keepEditing: false })}
      </form>
  `);
}

function renderSectionAdminPanel(subjects = []) {
  // One subject at a time, chosen from the same tabs the Tutorials screen
  // uses. Sections are a numbered, read-only list; adding and editing happen
  // in a popup (renderSectionFormModal) so the list stays easy to scan.
  const activeSubject = subjects.length ? getActiveAdminSubject() : null;
  if (!activeSubject) {
    return `
      <div class="section-admin-screen" data-reveal>
        ${renderEmptyState("Create a subject in the Subjects tab, then add its sections here.")}
      </div>
    `;
  }

  const sections = normalizeSubjectSections(activeSubject.sections || []);
  const subjectTutorials = state.articles.filter((article) => article.category === activeSubject.title);
  const countInSection = (sectionId) => subjectTutorials.filter((article) => getTutorialSectionId(article, activeSubject) === sectionId).length;
  const unsectionedCount = sections.length ? countInSection(UNSECTIONED_SECTION_ID) : 0;

  return `
    <div class="section-admin-screen" data-reveal>
      ${renderAdminSubjectTabs(subjects, activeSubject, {
        attribute: "data-admin-section-subject",
        eyebrow: "Subject sections",
        label: "Choose a subject to manage its sections"
      })}
      <section class="admin-card section-admin-library">
        <div class="admin-card-heading section-admin-heading">
          <div>
            <p class="admin-section-kicker">Sections</p>
            <h2>${escapeHtml(activeSubject.title)}</h2>
            <span>${sections.length} ${sections.length === 1 ? "section" : "sections"} / ${subjectTutorials.length} ${subjectTutorials.length === 1 ? "tutorial" : "tutorials"} / Subject ID: ${escapeHtml(activeSubject.id)}</span>
          </div>
          <button class="button primary" type="button" data-open-section-modal="add">
            ${renderAdminIcon("plus")}
            <span>Add new section</span>
          </button>
        </div>
        ${sections.length > 6 ? `
          <label class="admin-search">
            ${renderAdminIcon("search")}
            <input type="search" data-admin-search placeholder="Search sections in ${escapeAttr(activeSubject.title)}" />
          </label>
        ` : ""}
        ${unsectionedCount ? `
          <p class="section-admin-note">${unsectionedCount} ${unsectionedCount === 1 ? "tutorial is" : "tutorials are"} not in any section yet. Assign ${unsectionedCount === 1 ? "it" : "them"} from the tutorial editor.</p>
        ` : ""}
        <div class="section-admin-list">
          ${sections.length
            ? `<ol class="section-admin-rows">
                ${sections.map((section, index) => renderSectionAdminRow(activeSubject, section, index, sections.length, countInSection(section.id))).join("")}
              </ol>`
            : `<div class="section-admin-empty">
                <strong>No sections in ${escapeHtml(activeSubject.title)} yet.</strong>
                <span>Sections group this subject's tutorials in the order students read them.</span>
                <button class="button ghost" type="button" data-open-section-modal="add">${renderAdminIcon("plus")}<span>Add the first section</span></button>
              </div>`}
        </div>
      </section>
    </div>
  `;
}

function renderSectionAdminRow(subject, section, index, total, tutorialCount) {
  return `
    <li class="section-admin-row" data-admin-search-item data-search="${escapeAttr(`${section.title} ${section.id}`)}">
      <span class="section-admin-position" aria-hidden="true">${index + 1}</span>
      <div class="section-admin-row-text">
        <strong>${escapeHtml(section.title)}</strong>
        <small>${tutorialCount} ${tutorialCount === 1 ? "tutorial" : "tutorials"} / ID: ${escapeHtml(section.id)}</small>
      </div>
      <div class="section-admin-row-actions">
        <button class="icon-only-button" type="button" data-move-subject-section="${escapeAttr(subject.id)}" data-section-id="${escapeAttr(section.id)}" data-move-direction="-1" title="Move ${escapeAttr(section.title)} up" aria-label="Move ${escapeAttr(section.title)} up" ${index <= 0 ? "disabled" : ""}>${renderAdminIcon("arrowUp")}</button>
        <button class="icon-only-button" type="button" data-move-subject-section="${escapeAttr(subject.id)}" data-section-id="${escapeAttr(section.id)}" data-move-direction="1" title="Move ${escapeAttr(section.title)} down" aria-label="Move ${escapeAttr(section.title)} down" ${index >= total - 1 ? "disabled" : ""}>${renderAdminIcon("arrowDown")}</button>
        <button class="button ghost small" type="button" data-open-section-modal="edit" data-section-id="${escapeAttr(section.id)}" aria-label="Edit ${escapeAttr(section.title)}">${renderAdminIcon("edit")}<span>Edit</span></button>
        <button class="icon-only-button" type="button" data-download-section-doc="${escapeAttr(subject.id)}" data-section-id="${escapeAttr(section.id)}" title="Download ${escapeAttr(section.title)} as Word document" aria-label="Download ${escapeAttr(section.title)} as Word document">${renderAdminIcon("download")}</button>
        <button class="icon-only-button is-danger" type="button" data-delete-subject-section="${escapeAttr(subject.id)}" data-section-id="${escapeAttr(section.id)}" title="Delete ${escapeAttr(section.title)}" aria-label="Delete ${escapeAttr(section.title)}">${renderAdminIcon("trash")}</button>
      </div>
    </li>
  `;
}

// Add and edit share one popup. It is rendered from state, so a save that
// fails validation (a duplicate name, say) leaves it open with what was typed.
// It is placed at the end of the admin shell (renderAdminSectionModal), not
// inside the Sections screen: the admin columns fade in with a transform, and
// any transformed ancestor traps a position: fixed overlay inside its box.
function renderSectionFormModal(subject, sections) {
  const modal = state.sectionModal;
  if (!modal || modal.subjectId !== subject.id) return "";
  const editing = modal.mode === "edit" ? sections.find((section) => section.id === modal.sectionId) : null;
  if (modal.mode === "edit" && !editing) return "";
  const position = editing ? sections.indexOf(editing) + 1 : sections.length + 1;
  const lastPosition = editing ? sections.length : sections.length + 1;

  return `
    <div class="admin-modal-overlay" data-section-modal>
      <button class="admin-modal-backdrop" type="button" data-close-section-modal tabindex="-1" aria-label="Close"></button>
      <div class="admin-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="section-modal-title">
        <header class="admin-modal-header">
          <div>
            <p class="admin-section-kicker">${escapeHtml(subject.title)}</p>
            <h2 id="section-modal-title">${editing ? "Edit section" : "Add new section"}</h2>
          </div>
          <button class="icon-only-button" type="button" data-close-section-modal aria-label="Close">&times;</button>
        </header>
        <form class="section-modal-form" ${editing ? "data-existing-subject-section-update-form" : "data-existing-subject-section-form"}>
          <input type="hidden" name="subjectId" value="${escapeAttr(subject.id)}" />
          ${editing ? `<input type="hidden" name="sectionId" value="${escapeAttr(editing.id)}" />` : ""}
          <label>
            <span>Section name</span>
            <input name="sectionTitle" value="${escapeAttr(editing?.title || "")}" placeholder="Example: Kotlin basics" maxlength="120" autocomplete="off" required data-section-modal-focus />
          </label>
          <label>
            <span>Position</span>
            <input name="sectionOrder" type="number" min="1" max="${lastPosition}" value="${position}" required />
            <small>1 is first. ${editing ? `Currently ${position} of ${sections.length}.` : `${position} adds it at the end.`}</small>
          </label>
          <div class="admin-modal-actions">
            <button class="button ghost" type="button" data-close-section-modal>Cancel</button>
            <button class="button primary" type="submit">${renderAdminIcon(editing ? "save" : "plus")}<span>${editing ? "Save changes" : "Add section"}</span></button>
          </div>
        </form>
      </div>
    </div>
  `;
}

function renderAdminSectionModal() {
  if (!state.sectionModal || !state.isAdmin || state.adminType !== "sections" || getRoute().page !== "admin") return "";
  const subject = getActiveAdminSubject();
  if (!subject) return "";
  return renderSectionFormModal(subject, normalizeSubjectSections(subject.sections || []));
}

function openSectionModal(mode, subjectId, sectionId = "") {
  state.sectionModal = { mode, subjectId, sectionId };
  render();
  window.requestAnimationFrame(() => {
    const input = document.querySelector("[data-section-modal-focus]");
    input?.focus();
    input?.select();
  });
}

function closeSectionModal() {
  const modal = state.sectionModal;
  state.sectionModal = null;
  render();
  if (!modal) return;
  // Hand focus back to the button that opened the popup.
  window.requestAnimationFrame(() => {
    const selector = modal.mode === "edit"
      ? `[data-open-section-modal="edit"][data-section-id="${CSS.escape(modal.sectionId)}"]`
      : `[data-open-section-modal="add"]`;
    document.querySelector(selector)?.focus();
  });
}

// Keeps Tab and Shift+Tab inside the popup while it is open.
function trapModalFocus(event, dialog) {
  if (!dialog) return;
  const focusable = [...dialog.querySelectorAll("button, input, select, textarea, [href]")]
    .filter((element) => !element.disabled && element.getClientRects().length);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (!dialog.contains(document.activeElement)) {
    event.preventDefault();
    first.focus();
  } else if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

function renderSubjectSectionRow(section = {}, index = 0) {
  return `
    <div class="subject-section-row" data-subject-section-row>
      <input name="sectionId" type="hidden" value="${escapeAttr(section.id || "")}" />
      <label>
        <span>Section</span>
        <input name="sectionTitle" value="${escapeAttr(section.title || "")}" placeholder="Example: Basics" />
      </label>
      <label>
        <span>Order</span>
        <input name="sectionOrder" type="number" min="1" value="${escapeAttr(section.order || index + 1)}" />
      </label>
      <button class="icon-only-button is-danger" type="button" data-remove-subject-section title="Remove section" aria-label="Remove section">
        ${renderAdminIcon("trash")}
      </button>
    </div>
  `;
}
function renderAdminSubjectTabs(subjects, activeSubject, options = {}) {
  // Shared by the Tutorials and Sections screens; each passes its own click
  // attribute so a tab keeps the admin on the screen it was clicked from.
  const attribute = options.attribute || "data-admin-subject";
  return `
    <section class="admin-subject-tabs-card">
      <div>
        <p class="eyebrow">${escapeHtml(options.eyebrow || "Tutorial subjects")}</p>
        <h2>Select subject</h2>
      </div>
      <nav class="admin-subject-tabs" aria-label="${escapeAttr(options.label || "Filter tutorials by subject")}">
        ${
          subjects
            .map((subject) => {
              const count = state.articles.filter((article) => article.category === subject.title).length;
              const sectionCount = normalizeSubjectSections(subject.sections || []).length || 1;
              return `
                <button
                  class="${activeSubject?.id === subject.id ? "is-active" : ""}"
                  type="button"
                  ${attribute}="${escapeAttr(subject.id)}"
                  ${activeSubject?.id === subject.id ? 'aria-current="true"' : ""}
                >
                  <span>${escapeHtml(subject.title)}</span>
                  <small>${sectionCount} ${sectionCount === 1 ? "section" : "sections"} / ${count} ${count === 1 ? "tutorial" : "tutorials"}</small>
                </button>
              `;
            })
            .join("") || `<span class="empty-state">Create a subject in the Subjects tab.</span>`
        }
      </nav>
    </section>
  `;
}

function renderSubjectAdminItem(subject) {
  const subjects = getAdminSubjects();
  const tutorialCount = state.articles.filter((article) => article.category === subject.title).length;
  const sectionCount = normalizeSubjectSections(subject.sections || []).length;
  const isHidden = Boolean(subject.hiddenFromPublic);
  const label = `${sectionCount || 1} ${(sectionCount || 1) === 1 ? "section" : "sections"} / ${tutorialCount} ${tutorialCount === 1 ? "tutorial" : "tutorials"}`;
  const visibilityText = isHidden ? "Hidden from public website" : "Visible on public website";
  const coverUrl = safeUrl(subject.coverImage);
  const isEditing = Boolean(findSubjectById(state.editingSubjectId)?.id === subject.id);

  return `
    <div class="subject-admin-item ${isEditing ? "is-editing" : ""} ${isHidden ? "is-public-hidden" : ""}" data-admin-search-item data-search="${escapeAttr(`${subject.title} ${label} ${visibilityText}`)}">
      <div class="subject-admin-detail">
        ${coverUrl ? `<img class="admin-list-thumb" src="${escapeAttr(coverUrl)}" alt="" data-managed-image />` : `<span class="admin-list-placeholder">${escapeHtml(getInitials(subject.title))}</span>`}
        <div><strong>${escapeHtml(subject.title)}</strong><span>${escapeHtml(label)} / ${escapeHtml(visibilityText)}</span></div>
      </div>
      ${renderStatusBadge(isHidden ? "hidden" : "public")}
      <div class="subject-admin-actions">
        ${renderOrderControls(subject, "subjects", subjects)}
        <button class="icon-only-button ${isHidden ? "is-success" : "is-warning"}" type="button" data-toggle-subject-public="${escapeAttr(subject.id)}" data-hidden-next="${escapeAttr(String(!isHidden))}" title="${isHidden ? `Show ${escapeAttr(subject.title)} on public website` : `Hide ${escapeAttr(subject.title)} and its tutorials from public website`}" aria-label="${isHidden ? `Show ${escapeAttr(subject.title)} on public website` : `Hide ${escapeAttr(subject.title)} and its tutorials from public website`}">${renderAdminIcon(isHidden ? "eye" : "eyeOff")}</button>
        <button class="icon-only-button" type="button" data-generate-subject-book="${escapeAttr(subject.id)}" title="Download editable Word book for ${escapeAttr(subject.title)}" aria-label="Download editable Word book for ${escapeAttr(subject.title)}">${renderAdminIcon("book")}</button>
        <button class="icon-only-button" type="button" data-edit-subject="${escapeAttr(subject.id)}" title="Edit ${escapeAttr(subject.title)}" aria-label="Edit ${escapeAttr(subject.title)}">${renderAdminIcon("edit")}</button>
        <button class="icon-only-button is-danger" type="button" data-delete-subject="${escapeAttr(subject.id)}" title="Remove ${escapeAttr(subject.title)}" aria-label="Remove ${escapeAttr(subject.title)}">${renderAdminIcon("trash")}</button>
      </div>
    </div>
  `;
}
function renderCoverPreview(url = "") {
  const imageUrl = safeUrl(url);

  return `
    <div class="cover-preview ${imageUrl ? "is-visible" : ""}" data-cover-preview>
      ${imageUrl ? `<img src="${escapeAttr(imageUrl)}" alt="" data-managed-image />` : ""}
      <span>${imageUrl ? "Cover preview" : "No cover image selected yet"}</span>
    </div>
  `;
}

function renderDocumentPreview(item = {}) {
  const documentUrl = safeUrl(item.documentUrl);

  return `
    <div class="document-preview ${documentUrl ? "is-visible" : ""}" data-document-preview>
      <div>
        <span>${documentUrl ? "Attached resource" : "No document attached"}</span>
        ${documentUrl ? `<strong>${escapeHtml(item.documentName || "Attached document")}</strong>` : ""}
      </div>
      ${
        documentUrl
          ? `<div class="document-preview-actions">
              <a class="button ghost" href="${escapeAttr(documentUrl)}" target="_blank" rel="noreferrer">Open</a>
              <button class="button ghost" type="button" data-clear-document>Remove</button>
            </div>`
          : ""
      }
    </div>
  `;
}

function renderRichToolbarButton(command, iconName, label) {
  return `
    <button class="rich-icon-button" type="button" data-rich-command="${escapeAttr(command)}" title="${escapeAttr(label)}" aria-label="${escapeAttr(label)}">
      ${renderToolbarIcon(iconName)}
      <span class="sr-only">${escapeHtml(label)}</span>
    </button>
  `;
}

function renderRichImageActionButton(action, iconName, label) {
  return `
    <button class="rich-icon-button" type="button" data-rich-image-action="${escapeAttr(action)}" title="${escapeAttr(label)}" aria-label="${escapeAttr(label)}">
      ${renderToolbarIcon(iconName)}
      <span class="sr-only">${escapeHtml(label)}</span>
    </button>
  `;
}

function renderRichImageToolbar() {
  return `
    <div class="rich-image-toolbar" data-rich-image-toolbar hidden>
      <div class="toolbar-group" role="group" aria-label="Image alignment">
        ${renderRichImageActionButton("align-left", "alignLeft", "Align image left")}
        ${renderRichImageActionButton("align-center", "alignCenter", "Align image center")}
        ${renderRichImageActionButton("align-right", "alignRight", "Align image right")}
      </div>
      <div class="toolbar-group" role="group" aria-label="Image crop">
        ${renderRichImageActionButton("crop-original", "imageOriginal", "Original crop")}
        ${renderRichImageActionButton("crop-wide", "cropWide", "Wide crop")}
        ${renderRichImageActionButton("crop-square", "cropSquare", "Square crop")}
      </div>
      <div class="toolbar-group" role="group" aria-label="Image size">
        ${renderRichImageActionButton("size-full", "expand", "Full width")}
      </div>
      <div class="toolbar-group image-delete-group" role="group" aria-label="Remove image">
        ${renderRichImageActionButton("remove-image", "trash", "Delete selected image")}
      </div>
    </div>
  `;
}

function renderDiagramSymbolPanel() {
  return `
    <div class="rich-insert-panel rich-diagram-panel" data-rich-diagram-panel hidden>
      <div class="diagram-panel-head">
        <div>
          <strong>Diagram symbols</strong>
          <small>Click inside a diagram, then insert lines, arrows, branches, and labels.</small>
        </div>
        <button class="button ghost" type="button" data-diagram-new>New diagram</button>
      </div>
      <div class="diagram-symbol-grid" role="group" aria-label="Diagram symbols">
        ${DIAGRAM_SYMBOLS.map(renderDiagramSymbolButton).join("")}
      </div>
      <div class="rich-panel-actions">
        <button class="button ghost" type="button" data-diagram-close>Close</button>
      </div>
    </div>
  `;
}

function renderDiagramSymbolButton(symbol) {
  return `
    <button class="diagram-symbol-button" type="button" data-diagram-symbol="${escapeAttr(symbol.key)}" title="${escapeAttr(symbol.label)}" aria-label="${escapeAttr(symbol.label)}">
      <span>${escapeHtml(symbol.preview)}</span>
      <small>${escapeHtml(symbol.label)}</small>
    </button>
  `;
}

function renderToolbarIcon(name) {
  const icons = {
    bold: '<path d="M6 4h8a4 4 0 0 1 0 8H6z" /><path d="M6 12h9a4 4 0 0 1 0 8H6z" />',
    italic: '<line x1="19" x2="10" y1="4" y2="4" /><line x1="14" x2="5" y1="20" y2="20" /><line x1="15" x2="9" y1="4" y2="20" />',
    underline: '<path d="M6 4v6a6 6 0 0 0 12 0V4" /><line x1="4" x2="20" y1="20" y2="20" />',
    list: '<line x1="9" x2="21" y1="6" y2="6" /><line x1="9" x2="21" y1="12" y2="12" /><line x1="9" x2="21" y1="18" y2="18" /><circle cx="4" cy="6" r="1" /><circle cx="4" cy="12" r="1" /><circle cx="4" cy="18" r="1" />',
    listOrdered: '<path d="M4 6h1v4" /><path d="M4 10h2" /><path d="M4 16h2l-2 3h2" /><line x1="10" x2="21" y1="7" y2="7" /><line x1="10" x2="21" y1="17" y2="17" />',
    alignLeft: '<line x1="4" x2="21" y1="6" y2="6" /><line x1="4" x2="15" y1="12" y2="12" /><line x1="4" x2="19" y1="18" y2="18" />',
    alignCenter: '<line x1="4" x2="20" y1="6" y2="6" /><line x1="8" x2="16" y1="12" y2="12" /><line x1="6" x2="18" y1="18" y2="18" />',
    alignRight: '<line x1="3" x2="20" y1="6" y2="6" /><line x1="9" x2="20" y1="12" y2="12" /><line x1="5" x2="20" y1="18" y2="18" />',
    alignJustify: '<line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="18" y2="18" />',
    link: '<path d="M10 13a5 5 0 0 0 7.07 0l2.12-2.12a5 5 0 0 0-7.07-7.07L10.9 5.03" /><path d="M14 11a5 5 0 0 0-7.07 0l-2.12 2.12a5 5 0 0 0 7.07 7.07l1.22-1.22" />',
    image: '<rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="8.5" cy="10.5" r="1.5" /><path d="m21 15-5-5L5 21" />',
    diagram: '<rect x="4" y="4" width="6" height="5" rx="1" /><rect x="14" y="15" width="6" height="5" rx="1" /><path d="M10 6.5h3a3 3 0 0 1 3 3V15" /><path d="m13 12 3 3 3-3" /><path d="M7 9v6" /><path d="m4 12 3 3 3-3" />',
    code: '<path d="m8 9-4 3 4 3" /><path d="m16 9 4 3-4 3" /><path d="m14 5-4 14" />',
    textLines: '<path d="M4 6h16" /><path d="M4 12h13" /><path d="M4 18h10" />',
    symbols: '<path d="M4 7h16" /><path d="m16 3 4 4-4 4" /><path d="M20 17H4" /><path d="m8 13-4 4 4 4" />',
    eraser: '<path d="m7 21-4-4 10-10 4 4-10 10Z" /><path d="m14 4 6 6" /><path d="M11 21h10" />',
    imageOriginal: '<rect x="4" y="5" width="16" height="14" rx="2" /><circle cx="9" cy="10" r="1.4" /><path d="m20 15-4-4-8 8" />',
    cropWide: '<rect x="4" y="7" width="16" height="10" rx="2" /><path d="M8 3v18" /><path d="M16 3v18" />',
    cropSquare: '<rect x="5" y="5" width="14" height="14" rx="2" /><path d="M9 3v18" /><path d="M15 3v18" />',
    expand: '<path d="M8 3H3v5" /><path d="M16 3h5v5" /><path d="M21 16v5h-5" /><path d="M3 16v5h5" /><path d="M3 3l7 7" /><path d="M21 3l-7 7" /><path d="M21 21l-7-7" /><path d="M3 21l7-7" />',
    trash: '<path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 15H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" />',
    fileText: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6" /><path d="M8 13h8" /><path d="M8 17h6" /><path d="M8 9h2" />'
  };

  return `
    <svg class="toolbar-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      ${icons[name] || icons.bold}
    </svg>
  `;
}

function renderArticleSectionOptions(subject, selectedSectionId = "", tutorial = {}) {
  const sections = getSubjectSectionsForArticleForm(subject, tutorial);
  if (!subject) return `<option value="">Select subject first</option>`;
  return sections
    .map((section) => `
      <option value="${escapeAttr(section.id)}" ${section.id === selectedSectionId ? "selected" : ""}>
        ${escapeHtml(section.title)}
      </option>
    `)
    .join("");
}
function updateArticleSectionSelect(form, subjectTitle) {
  const sectionSelect = form?.querySelector("[data-article-section-select]");
  if (!sectionSelect) return;

  const subject = getSubjectByTitle(subjectTitle);
  sectionSelect.innerHTML = renderArticleSectionOptions(subject, "", {});

  const orderInput = form.querySelector('input[name="order"]');
  if (orderInput && !state.editingId && subject) {
    const selectedSectionId = sectionSelect.value || getSubjectSectionsForForm(subject)[0]?.id || "";
    const nextOrder = state.articles.filter((article) => article.category === subject.title && getTutorialSectionId(article, subject) === selectedSectionId).length + 1;
    orderInput.value = String(nextOrder);
  }
}
function renderArticleForm(item = {}, activeSubject = null) {
  const subjects = getAdminSubjects();
  const selectedSubject = item.category || activeSubject?.title || subjects[0]?.title || "";
  const selectedSubjectItem = subjects.find((subject) => subject.title === selectedSubject) || null;
  const sectionOptions = getSubjectSectionsForArticleForm(selectedSubjectItem, item);
  const selectedSectionId = sectionOptions.some((section) => section.id === item.sectionId)
    ? item.sectionId
    : sectionOptions[0]?.id || "";
  const nextOrder = state.articles.filter((article) => article.category === selectedSubject && getTutorialSectionId(article, selectedSubjectItem) === selectedSectionId).length + 1;

  return `
    <form class="admin-form" data-admin-form data-content-type="articles">
      <label>
        <span>Title</span>
        <input name="title" value="${escapeAttr(item.title)}" required />
      </label>
      <label>
        <span>Slug</span>
        <input name="slug" value="${escapeAttr(item.slug)}" placeholder="auto-generated-from-title" />
      </label>
      <label>
        <span>Excerpt</span>
        <textarea name="excerpt" rows="3" required>${escapeHtml(item.excerpt)}</textarea>
      </label>
      <div class="rich-editor-field">
        <span>Tutorial body</span>
        <div class="tutorial-import-panel">
          <label class="upload-field tutorial-import-field">
            <span>Import tutorial content</span>
            <input type="file" accept=".md,.markdown,.ipynb,.doc,.docx" data-tutorial-import />
            <small>Markdown, Jupyter Notebook, or Word .docx. Imported content stays editable before saving.</small>
          </label>
          <div class="tutorial-import-badges" aria-label="Supported import formats">
            <span>MD</span>
            <span>IPYNB</span>
            <span>DOCX</span>
          </div>
        </div>
        <textarea class="rich-editor-source" name="body" data-rich-source>${escapeHtml(htmlForEditor(item.body))}</textarea>
        <div class="rich-editor-shell">
          <div class="rich-toolbar" role="toolbar" aria-label="Tutorial formatting tools">
            <div class="toolbar-group format-group" role="group" aria-label="Block style">
              <select data-rich-command="formatBlock" aria-label="Text style">
                <option value="p">Paragraph</option>
                <option value="h1">Heading 1</option>
                <option value="h2">Heading 2</option>
                <option value="h3">Heading 3</option>
                <option value="blockquote">Quote</option>
              </select>
            </div>
            <div class="toolbar-group" role="group" aria-label="Inline formatting">
              ${renderRichToolbarButton("bold", "bold", "Bold")}
              ${renderRichToolbarButton("italic", "italic", "Italic")}
              ${renderRichToolbarButton("underline", "underline", "Underline")}
            </div>
            <div class="toolbar-group" role="group" aria-label="Lists">
              ${renderRichToolbarButton("insertUnorderedList", "list", "Bulleted list")}
              ${renderRichToolbarButton("insertOrderedList", "listOrdered", "Numbered list")}
            </div>
            <div class="toolbar-group" role="group" aria-label="Alignment">
              ${renderRichToolbarButton("justifyLeft", "alignLeft", "Align left")}
              ${renderRichToolbarButton("justifyCenter", "alignCenter", "Align center")}
              ${renderRichToolbarButton("justifyRight", "alignRight", "Align right")}
              ${renderRichToolbarButton("justifyFull", "alignJustify", "Justify")}
            </div>
            <div class="toolbar-group" role="group" aria-label="Insert">
              ${renderRichToolbarButton("createLink", "link", "Add link")}
              ${renderRichToolbarButton("insertImage", "image", "Add image")}
              ${renderRichToolbarButton("diagramBlock", "diagram", "Insert text diagram")}
              ${renderRichToolbarButton("diagramSymbols", "symbols", "Diagram symbols")}
              ${renderRichToolbarButton("codeBlock", "code", "Toggle code block")}
            </div>
            <div class="toolbar-group" role="group" aria-label="Cleanup">
              ${renderRichToolbarButton("removeFormat", "eraser", "Clear formatting")}
              ${renderRichToolbarButton("unwrapCodeBlock", "textLines", "Remove text from code block")}
            </div>
          </div>
          ${renderRichImageToolbar()}
          ${renderDiagramSymbolPanel()}
          <div class="rich-insert-panel" data-rich-image-panel hidden>
            <label>
              <span>Image URL</span>
              <input type="url" data-rich-image-url placeholder="https://example.com/image.jpg" />
            </label>
            <label>
              <span>Alt text</span>
              <input data-rich-image-alt placeholder="Short image description" />
            </label>
            <label>
              <span>Upload image</span>
              <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-rich-image-upload data-storage-folder="tutorials" />
            </label>
            <div class="rich-panel-actions">
              <button class="button dark" type="button" data-rich-insert-image>Insert image</button>
              <button class="button ghost" type="button" data-rich-cancel-panel>Cancel</button>
            </div>
          </div>
          <div
            class="rich-editor-area"
            contenteditable="true"
            data-rich-editor
            data-placeholder="Start writing your tutorial..."
          >${htmlForEditor(item.body)}</div>
        </div>
      </div>
      <div class="form-grid form-grid-three">
        <label>
          <span>Subject</span>
          <select name="category" required data-article-subject-select>
            <option value="" ${selectedSubject ? "" : "selected"}>Select subject</option>
            ${subjects
              .map(
                (subject) => `
                  <option value="${escapeAttr(subject.title)}" ${subject.title === selectedSubject ? "selected" : ""}>
                    ${escapeHtml(subject.title)}
                  </option>
                `
              )
              .join("")}
          </select>
        </label>
        <label>
          <span>Section</span>
          <select name="sectionId" required data-article-section-select>
            ${renderArticleSectionOptions(selectedSubjectItem, selectedSectionId, item)}
          </select>
        </label>
        <label>
          <span>Display order</span>
          <input name="order" type="number" min="1" value="${escapeAttr(item.order || nextOrder)}" />
        </label>
      </div>
      <label>
        <span>Tags</span>
        <input name="tags" value="${escapeAttr(toArray(item.tags).join(", "))}" />
      </label>
      <label>
        <span>Quiz / practice questions optional</span>
        <textarea name="quizSource" rows="8" placeholder="Question: What is Dependency Injection?\nA) Class creates dependencies itself\nB) Class receives dependencies from outside\nAnswer: B\nExplanation: DI makes code easier to test.">${escapeHtml(formatQuizForEditor(item.quiz || []))}</textarea>
        <small>Use Question, A/B/C/D options, Answer, and optional Explanation. Separate questions with <code>---</code>.</small>
      </label>
      <label>
        <span>YouTube link optional</span>
        <input
          name="youtubeUrl"
          type="url"
          value="${escapeAttr(item.youtubeUrl)}"
          placeholder="https://www.youtube.com/watch?v=..."
        />
      </label>
      <div class="document-upload-group">
        <label class="upload-field">
          <span>Resource document optional</span>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
            data-document-upload
            data-storage-folder="documents"
          />
          <small>PDF, Word, PowerPoint, Excel, or text up to 20 MB. Stored under <code>documents/</code>.</small>
        </label>
        <input name="documentUrl" type="hidden" value="${escapeAttr(item.documentUrl || "")}" />
        <input name="documentName" type="hidden" value="${escapeAttr(item.documentName || "")}" />
        <input name="documentPath" type="hidden" value="${escapeAttr(item.documentPath || "")}" />
        ${renderDocumentPreview(item)}
      </div>
      <div class="form-grid">
        ${renderContentStatusField(item)}
        <label class="checkbox-line">
          <input name="featured" type="checkbox" ${item.featured ? "checked" : ""} />
          <span>Featured tutorial</span>
        </label>
      </div>
      <label class="checkbox-line checkbox-line-compact">
        <input name="showOnHome" type="checkbox" ${item.showOnHome ? "checked" : ""} />
        <span>Show on home</span>
      </label>
      ${renderAdminEditorActions()}
    </form>
  `;
}

function renderRichBodyEditor(item = {}, options = {}) {
  const label = options.label || "Content body";
  const importLabel = options.importLabel || "Import content";
  const importHelp = options.importHelp || "Markdown, Jupyter Notebook, or Word .docx. Imported content stays editable before saving.";
  const placeholder = options.placeholder || "Start writing...";
  const storageFolder = options.storageFolder || "tutorials";

  return `
    <div class="rich-editor-field">
      <span>${escapeHtml(label)}</span>
      <div class="tutorial-import-panel">
        <label class="upload-field tutorial-import-field">
          <span>${escapeHtml(importLabel)}</span>
          <input type="file" accept=".md,.markdown,.ipynb,.doc,.docx" data-tutorial-import />
          <small>${escapeHtml(importHelp)}</small>
        </label>
        <div class="tutorial-import-badges" aria-label="Supported import formats">
          <span>MD</span>
          <span>IPYNB</span>
          <span>DOCX</span>
        </div>
      </div>
      <textarea class="rich-editor-source" name="body" data-rich-source>${escapeHtml(htmlForEditor(item.body))}</textarea>
      <div class="rich-editor-shell">
        <div class="rich-toolbar" role="toolbar" aria-label="Formatting tools">
          <div class="toolbar-group format-group" role="group" aria-label="Block style">
            <select data-rich-command="formatBlock" aria-label="Text style">
              <option value="p">Paragraph</option>
              <option value="h1">Heading 1</option>
              <option value="h2">Heading 2</option>
              <option value="h3">Heading 3</option>
              <option value="blockquote">Quote</option>
            </select>
          </div>
          <div class="toolbar-group" role="group" aria-label="Inline formatting">
            ${renderRichToolbarButton("bold", "bold", "Bold")}
            ${renderRichToolbarButton("italic", "italic", "Italic")}
            ${renderRichToolbarButton("underline", "underline", "Underline")}
          </div>
          <div class="toolbar-group" role="group" aria-label="Lists">
            ${renderRichToolbarButton("insertUnorderedList", "list", "Bulleted list")}
            ${renderRichToolbarButton("insertOrderedList", "listOrdered", "Numbered list")}
          </div>
          <div class="toolbar-group" role="group" aria-label="Alignment">
            ${renderRichToolbarButton("justifyLeft", "alignLeft", "Align left")}
            ${renderRichToolbarButton("justifyCenter", "alignCenter", "Align center")}
            ${renderRichToolbarButton("justifyRight", "alignRight", "Align right")}
            ${renderRichToolbarButton("justifyFull", "alignJustify", "Justify")}
          </div>
          <div class="toolbar-group" role="group" aria-label="Insert">
            ${renderRichToolbarButton("createLink", "link", "Add link")}
            ${renderRichToolbarButton("insertImage", "image", "Add image")}
            ${renderRichToolbarButton("diagramBlock", "diagram", "Insert text diagram")}
            ${renderRichToolbarButton("diagramSymbols", "symbols", "Diagram symbols")}
            ${renderRichToolbarButton("codeBlock", "code", "Toggle code block")}
          </div>
          <div class="toolbar-group" role="group" aria-label="Cleanup">
            ${renderRichToolbarButton("removeFormat", "eraser", "Clear formatting")}
            ${renderRichToolbarButton("unwrapCodeBlock", "textLines", "Remove text from code block")}
          </div>
        </div>
        ${renderRichImageToolbar()}
        ${renderDiagramSymbolPanel()}
        <div class="rich-insert-panel" data-rich-image-panel hidden>
          <label>
            <span>Image URL</span>
            <input type="url" data-rich-image-url placeholder="https://example.com/image.jpg" />
          </label>
          <label>
            <span>Alt text</span>
            <input data-rich-image-alt placeholder="Short image description" />
          </label>
          <label>
            <span>Upload image</span>
            <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-rich-image-upload data-storage-folder="${escapeAttr(storageFolder)}" />
          </label>
          <div class="rich-panel-actions">
            <button class="button dark" type="button" data-rich-insert-image>Insert image</button>
            <button class="button ghost" type="button" data-rich-cancel-panel>Cancel</button>
          </div>
        </div>
        <div
          class="rich-editor-area"
          contenteditable="true"
          data-rich-editor
          data-placeholder="${escapeAttr(placeholder)}"
        >${htmlForEditor(item.body)}</div>
      </div>
    </div>
  `;
}

function renderBlogForm(item = {}) {
  // Same fields as the tutorial editor where they make sense for a post
  // (body editor with import, tags, YouTube video, resource document), plus
  // the banner. The banner used to sit below Tags as a bare URL box, which
  // was easy to miss, so it now has its own group near the top.
  return `
    <form class="admin-form" data-admin-form data-content-type="blogs">
      <label>
        <span>Title</span>
        <input name="title" value="${escapeAttr(item.title)}" required />
      </label>
      <label>
        <span>Slug</span>
        <input name="slug" value="${escapeAttr(item.slug)}" placeholder="auto-generated-from-title" />
      </label>
      <fieldset class="blog-banner-field">
        <legend>Banner image</legend>
        <p class="blog-banner-help">Shown at the top of the post, on its blog card and when the post is shared. Use a wide image, ideally 1600 &times; 900 px. Without one, the post uses a default image for its category.</p>
        ${renderCoverPreview(item.coverImage)}
        <div class="blog-banner-actions">
          <label class="upload-field">
            <span>Upload banner</span>
            <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-upload-target="coverImage" data-storage-folder="blogs" />
            <small>JPG, PNG, WebP, GIF or AVIF. Stored in Firebase Storage under <code>blogs/</code>.</small>
          </label>
          <div class="media-library-trigger">
            <button class="button ghost small" type="button" data-media-library="coverImage">${renderAdminIcon("image")}<span>Choose from library</span></button>
            ${item.coverImage ? `<button class="button ghost small" type="button" data-clear-image="coverImage">Remove banner</button>` : ""}
          </div>
        </div>
        <label>
          <span>Or paste an image URL</span>
          <input name="coverImage" type="url" value="${escapeAttr(item.coverImage || "")}" data-cover-url placeholder="https://example.com/banner.jpg" />
          <input name="coverImagePath" type="hidden" value="${escapeAttr(item.coverImagePath || "")}" />
        </label>
      </fieldset>
      <label>
        <span>Excerpt</span>
        <textarea name="excerpt" rows="3" required>${escapeHtml(item.excerpt)}</textarea>
      </label>
      ${renderRichBodyEditor(item, {
        label: "Blog body",
        importLabel: "Import blog content",
        importHelp: "Markdown, Jupyter Notebook, or Word .docx. Imported content stays editable before saving.",
        placeholder: "Write an independent SkillUp blog post...",
        storageFolder: "blogs"
      })}
      <div class="form-grid">
        <label>
          <span>Category</span>
          <input name="category" value="${escapeAttr(item.category || "SkillUp Blog")}" required />
        </label>
        <label>
          <span>Display order</span>
          <input name="order" type="number" min="1" value="${escapeAttr(item.order || state.blogs.length + 1)}" />
        </label>
      </div>
      <label>
        <span>Tags</span>
        <input name="tags" value="${escapeAttr(toArray(item.tags).join(", "))}" />
      </label>
      <label>
        <span>YouTube link optional</span>
        <input
          name="youtubeUrl"
          type="url"
          value="${escapeAttr(item.youtubeUrl)}"
          placeholder="https://www.youtube.com/watch?v=..."
        />
      </label>
      <div class="document-upload-group">
        <label class="upload-field">
          <span>Resource document optional</span>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
            data-document-upload
            data-storage-folder="documents"
          />
          <small>PDF, Word, PowerPoint, Excel, or text up to 20 MB. Stored under <code>documents/</code>.</small>
        </label>
        <input name="documentUrl" type="hidden" value="${escapeAttr(item.documentUrl || "")}" />
        <input name="documentName" type="hidden" value="${escapeAttr(item.documentName || "")}" />
        <input name="documentPath" type="hidden" value="${escapeAttr(item.documentPath || "")}" />
        ${renderDocumentPreview(item)}
      </div>
      <div class="form-grid">
        ${renderContentStatusField(item)}
        <label class="checkbox-line">
          <input name="featured" type="checkbox" ${item.featured ? "checked" : ""} />
          <span>Featured blog</span>
        </label>
      </div>
      <label class="checkbox-line checkbox-line-compact">
        <input name="showOnHome" type="checkbox" ${item.showOnHome ? "checked" : ""} />
        <span>Show on home</span>
      </label>
      ${renderAdminEditorActions()}
    </form>
  `;
}
function renderCodingProblemForm(item = {}) {
  const kind = normalizeCodingTypeId(item.kind || "dsa");
  const difficulty = normalizeCodingDifficultyId(item.difficulty || "easy");
  const typeOptions = getCodingTypeOptions();
  const difficultyOptions = getCodingDifficultyOptions();
  return `
    <form class="admin-form coding-problem-form" data-admin-form data-content-type="codingProblems">
      <label><span>Problem title</span><input name="title" value="${escapeAttr(item.title)}" required /></label>
      <label><span>Slug</span><input name="slug" value="${escapeAttr(item.slug)}" placeholder="auto-generated-from-title" /></label>
      <div class="form-grid">
        <label><span>Type</span><select name="kind">${renderCodingMetaSelectOptions(typeOptions, kind)}</select></label>
        <label><span>Difficulty</span><select name="difficulty">${renderCodingMetaSelectOptions(difficultyOptions, difficulty)}</select></label>
      </div>
      <div class="form-grid">
        <label><span>Category / section</span><select name="category" required>${renderCodingCategorySelectOptions(item.category || "DSA: Arrays & Hashing")}</select><small>Manage this list in Coding Setup.</small></label>
        <label><span>Display order</span><input name="order" type="number" min="1" value="${escapeAttr(item.order || state.codingProblems.length + 1)}" /></label>
      </div>
      <label><span>Companies</span><input name="companies" value="${escapeAttr(toArray(item.companies).join(", "))}" placeholder="Google, Amazon, Apple" /></label>
      <label><span>Problem statement</span><textarea name="prompt" rows="5" required>${escapeHtml(item.prompt || item.description || "")}</textarea></label>
      <label><span>Checklist / constraints</span><textarea name="constraintsSource" rows="4" placeholder="One point per line">${escapeHtml(toArray(item.constraints).join("\n"))}</textarea><small>Write one constraint or checklist item per line.</small></label>
      <label><span>Test cases JSON</span><textarea name="testCasesSource" rows="12" spellcheck="false">${escapeHtml(formatCodingProblemTestCasesForEditor(getCodingPracticeTestCases(item)))}</textarea><small>Use a JSON array with <code>name</code>, <code>input</code>, <code>expected</code>, and optional <code>note</code>.</small></label>
      ${renderContentStatusField(item)}
      ${renderAdminEditorActions()}
    </form>
  `;
}
function renderCourseForm(item = {}) {
  return `
    <form class="admin-form" data-admin-form data-content-type="tutorials">
      <label>
        <span>Title</span>
        <input name="title" value="${escapeAttr(item.title)}" required />
      </label>
      <label>
        <span>Slug</span>
        <input name="slug" value="${escapeAttr(item.slug)}" placeholder="auto-generated-from-title" />
      </label>
      <label>
        <span>Description</span>
        <textarea name="description" rows="4" required>${escapeHtml(item.description)}</textarea>
      </label>
      <label>
        <span>Outcome</span>
        <textarea name="outcome" rows="6" required>${escapeHtml(item.outcome)}</textarea>
        <small>One point per line. Start a line with •, - or * to show it as a bullet.</small>
      </label>
      <div class="form-grid">
        <label>
          <span>Category</span>
          <input name="category" value="${escapeAttr(item.category)}" required />
        </label>
        <label>
          <span>Level</span>
          <input name="level" value="${escapeAttr(item.level)}" required />
        </label>
      </div>
      <div class="form-grid">
        <label>
          <span>Duration</span>
          <input name="duration" value="${escapeAttr(item.duration)}" />
        </label>
        <label>
          <span>Order</span>
          <input name="order" type="number" min="1" value="${escapeAttr(item.order || 1)}" />
        </label>
      </div>
      <div class="form-grid">
        <label>
          <span>Original price</span>
          <input name="originalPrice" value="${escapeAttr(item.originalPrice || "")}" placeholder="Example: 4999" />
        </label>
        <label>
          <span>Final price</span>
          <input name="finalPrice" value="${escapeAttr(item.finalPrice || "")}" placeholder="Example: 2999" />
        </label>
      </div>
      <label>
        <span>Topics</span>
        <textarea name="topics" rows="5" placeholder="One topic per line, or separate them with commas">${escapeHtml(toArray(item.topics).join("\n"))}</textarea>
      </label>
      <label>
        <span>Course image URL</span>
        <input name="coverImage" type="url" value="${escapeAttr(item.coverImage)}" data-cover-url />
        <input name="coverImagePath" type="hidden" value="${escapeAttr(item.coverImagePath || "")}" />
      </label>
      ${renderCoverPreview(item.coverImage)}
      <label class="upload-field">
        <span>Upload course image</span>
        <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/avif" data-image-upload data-upload-target="coverImage" data-storage-folder="courses" />
        <small>Stored in Firebase Storage under <code>courses/</code>.</small>
      </label>
      <div class="media-library-trigger">
        <button class="button ghost small" type="button" data-media-library="coverImage">${renderAdminIcon("image")}<span>Choose from library</span></button>
      </div>
      <div class="form-grid">
        ${renderContentStatusField(item)}
        <label class="checkbox-line">
          <input name="showOnHome" type="checkbox" ${item.showOnHome ? "checked" : ""} />
          <span>Show on home</span>
        </label>
      </div>
      <label class="checkbox-line checkbox-line-compact">
        <input name="hiddenFromPublic" type="checkbox" ${item.hiddenFromPublic ? "checked" : ""} />
        <span>Hide this course from the public website</span>
      </label>
      ${renderAdminEditorActions()}
    </form>
  `;
}

// The short line on a course card's picture ("Android Studio / Kotlin"): the
// first two topics that read as labels. A long run of text saved as one topic
// would cover the picture, so it is skipped.
function getCourseSignal(topics) {
  return toArray(topics)
    .filter((topic) => String(topic).length <= 32)
    .slice(0, 2)
    .join(" / ") || "Guided path";
}

// One tap per subject, over the grid. The chips drive the same filter the
// search box and the category menu use, so the three stay in step.
function renderCourseCategoryChips(courses, categories) {
  if (categories.length < 2) return "";
  const chip = (value, label, count) => `
    <button class="course-chip${value === "all" ? " is-active" : ""}" type="button" data-course-category="${escapeAttr(value)}" aria-pressed="${value === "all"}">
      ${escapeHtml(label)}<small>${count}</small>
    </button>
  `;
  return `
    <div class="course-filter-chips" role="group" aria-label="Filter courses by subject">
      ${chip("all", "All courses", courses.length)}
      ${categories.map((category) => chip(category, category, courses.filter((course) => course.category === category).length)).join("")}
    </div>
  `;
}

function syncCourseCategoryChips(scope, value) {
  scope?.querySelectorAll("[data-course-category]").forEach((chip) => {
    const active = chip.dataset.courseCategory === value;
    chip.classList.toggle("is-active", active);
    chip.setAttribute("aria-pressed", String(active));
  });
}

// How much the course is marked down, from its own two prices.
function getCourseDiscountPercent(course) {
  const original = parseSessionPrice(course.originalPrice);
  const final = parseSessionPrice(course.finalPrice);
  if (!(original > 0) || !(final > 0) || final >= original) return 0;
  return Math.round((1 - final / original) * 100);
}

function renderCourseCard(course, featured = false) {
  const title = escapeHtml(course.title);
  const topics = toArray(course.topics);
  const searchText = [
    course.title,
    course.category,
    course.level,
    course.description,
    course.outcome,
    course.originalPrice,
    course.finalPrice,
    ...topics
  ].join(" ");
  const signal = getCourseSignal(topics);
  const coverUrl = safeUrl(course.coverImage) || getCategoryFallbackCover(course.category, course.title);
  const discount = getCourseDiscountPercent(course);
  // What a student checks before opening a course: how hard, how long, how
  // much ground it covers. Only what this course actually records is shown.
  const facts = [
    course.level,
    course.duration,
    topics.length ? `${topics.length} topics` : ""
  ].filter(Boolean);
  const shownTopics = topics.slice(0, 3);

  // Each subject keeps the same two colours wherever its courses appear, so
  // the catalogue reads as a set rather than a pile of unrelated cards.
  const [accentFrom, accentTo] = getInitialsAvatarGradient(course.category || course.title);

  return `
    <article
      class="program-card ${featured ? "featured-card" : ""}"
      data-reveal
      data-filter-card
      data-category="${escapeAttr(course.category)}"
      data-search="${escapeAttr(searchText)}"
      style="--course-accent-from: ${escapeAttr(accentFrom)}; --course-accent-to: ${escapeAttr(accentTo)}"
    >
      <div class="program-banner">
        <span class="program-label">${escapeHtml(course.category)}</span>
        ${featured ? `<span class="program-featured-badge">Popular</span>` : ""}
        ${discount ? `<span class="program-discount-badge">${discount}% off</span>` : ""}
      </div>
      <div class="program-medallion">
        ${coverUrl
          ? `<img src="${escapeAttr(coverUrl)}" alt="" loading="lazy" data-managed-image />`
          : `<span>${escapeHtml(getInitials(course.title))}</span>`}
      </div>
      <div class="card-body course-card-body">
        <span class="program-signal">${escapeHtml(signal)}</span>
        <h3>${title}</h3>
        ${facts.length ? `<ul class="course-card-facts">${facts.map((fact) => `<li>${escapeHtml(fact)}</li>`).join("")}</ul>` : ""}
        <p class="course-card-description">${escapeHtml(course.description)}</p>
        ${shownTopics.length ? `
          <div class="course-topic-list course-card-topics">
            ${shownTopics.map((topic) => `<span>${escapeHtml(topic)}</span>`).join("")}
            ${topics.length > shownTopics.length ? `<span class="is-more">+${topics.length - shownTopics.length} more</span>` : ""}
          </div>
        ` : ""}
        ${renderCoursePrice(course)}
        <a class="button primary course-details-button" href="#courses/${encodeURIComponent(course.id)}">
          View course
        </a>
      </div>
    </article>
  `;
}

function renderCourseModal() {
  if (!state.activeCourseId) return "";

  const course = state.tutorials.find((item) => item.id === state.activeCourseId || item.slug === state.activeCourseId);
  if (!course) return "";

  const topics = toArray(course.topics);
  const coverUrl = safeUrl(course.coverImage) || getCategoryFallbackCover(course.category, course.title);

  return `
    <section class="course-modal-overlay" data-course-modal role="dialog" aria-modal="true" aria-labelledby="course-modal-title">
      <button class="course-modal-backdrop" type="button" data-close-course-modal aria-label="Close course details"></button>
      <div class="course-modal-dialog">
        <button class="course-modal-close" type="button" data-close-course-modal aria-label="Close course details">&times;</button>
        <div class="course-modal-visual${coverUrl ? " has-cover" : ""}">
          ${coverUrl ? `<img src="${escapeAttr(coverUrl)}" alt="" data-managed-image />` : ""}
          <span>${escapeHtml(course.category || "Course")}</span>
        </div>
        <div class="course-modal-content">
          <p class="eyebrow">Course details</p>
          <h2 id="course-modal-title">${escapeHtml(course.title)}</h2>
          <p>${escapeHtml(course.description)}</p>
          ${renderCoursePrice(course)}
          <div class="course-detail-grid">
            <span><small>Category</small><strong>${escapeHtml(course.category || "General")}</strong></span>
            <span><small>Level</small><strong>${escapeHtml(course.level || "Beginner")}</strong></span>
            <span><small>Duration</small><strong>${escapeHtml(course.duration || "Self paced")}</strong></span>
          </div>
          ${course.outcome ? `<div class="course-modal-section"><span>Outcome</span><div class="formatted-text outcome-line">${renderFormattedText(course.outcome)}</div></div>` : ""}
          ${topics.length ? `<div class="course-modal-section"><span>Topics covered</span><div class="course-topic-list">${topics.map((topic) => `<span>${escapeHtml(topic)}</span>`).join("")}</div></div>` : ""}
          <div class="course-modal-actions">
            <a class="button dark" href="#inquiry">Ask about this course</a>
            <button class="button ghost" type="button" data-close-course-modal>Back to courses</button>
          </div>
        </div>
      </div>
    </section>
  `;
}

// The course list Google reads. It used to be a fixed list in index.html; it
// now follows the published courses managed in Admin > Courses.
function buildCourseCatalogJsonLd(courses = []) {
  if (!courses.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "SkillUp Class courses",
    itemListElement: courses.map((course, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Course",
        name: course.title,
        description: summarizeFormattedText(course.description, 240) || course.title,
        url: `https://skillupclass.com/courses/${encodeURIComponent(course.id)}`,
        provider: { "@type": "Organization", name: "SkillUp Class", sameAs: "https://skillupclass.com/" }
      }
    }))
  };
}

function updateCourseStructuredData() {
  const courses = getPublicCourses().filter((course) => course.status === "published" && !course.hiddenFromPublic);
  const data = buildCourseCatalogJsonLd(courses);
  const json = data ? JSON.stringify(data) : "";
  let node = document.getElementById("course-catalog-jsonld");
  if (!json) {
    node?.remove();
    return;
  }
  if (node?.textContent === json) return;
  if (!node) {
    node = document.createElement("script");
    node.type = "application/ld+json";
    node.id = "course-catalog-jsonld";
    document.head.appendChild(node);
  }
  node.textContent = json;
}

function renderCoursePrice(course) {
  const originalPrice = formatCoursePrice(course.originalPrice);
  const finalPrice = formatCoursePrice(course.finalPrice);
  const showOriginal = originalPrice && finalPrice && originalPrice !== finalPrice;
  const primaryPrice = finalPrice || originalPrice;

  if (!primaryPrice) {
    return `
      <div class="course-price is-empty">
        <span>Course fee</span>
        <strong>Contact for fee</strong>
      </div>
    `;
  }

  const percent = getCourseDiscountPercent(course);
  return `
    <div class="course-price">
      <span>Course fee</span>
      <div>
        <strong>${escapeHtml(primaryPrice)}</strong>
        ${showOriginal ? `<del>${escapeHtml(originalPrice)}</del>` : ""}
        ${percent ? `<span class="course-discount">${percent}% off</span>` : ""}
      </div>
    </div>
  `;
}

function renderTutorialPreviewCard(tutorial) {
  const searchText = [tutorial.title, tutorial.category, tutorial.excerpt, ...toArray(tutorial.tags)].join(" ");
  const tags = toArray(tutorial.tags).slice(0, 3);
  const subject = getSubjectByTitle(tutorial.category);
  const subjectCover = safeUrl(subject?.coverImage) || getCategoryFallbackCover(tutorial.category, tutorial.title);

  return `
    <article
      class="article-card"
      data-reveal
      data-filter-card
      data-category="${escapeAttr(tutorial.category)}"
      data-search="${escapeAttr(searchText)}"
    >
      <a href="#tutorials/${encodeURIComponent(tutorial.id)}" aria-label="Open ${escapeAttr(tutorial.title)}">
        <div class="article-visual has-subject-cover">
          <img src="${escapeAttr(subjectCover)}" alt="${escapeAttr(tutorial.category)}" data-managed-image />
          <span class="article-subject-label">${escapeHtml(tutorial.category)}</span>
        </div>
        <div class="card-body">
          <div class="tag-row">
            <span>${escapeHtml(tutorial.category)}</span>
            <span>${getReadTime(tutorial.body)} min read</span>
          </div>
          <h3>${escapeHtml(tutorial.title)}</h3>
          <p>${escapeHtml(tutorial.excerpt)}</p>
          <div class="chip-row">
            ${tags.map((tag) => `<span>${escapeHtml(tag)}</span>`).join("")}
          </div>
        </div>
      </a>
    </article>
  `;
}

function renderSectionedAdminTutorialList(subject, tutorials) {
  if (!tutorials.length) return renderEmptyState("No tutorials in this subject yet.");
  const sections = getSubjectSections(subject, tutorials);
  return sections
    .map((section) => {
      const sectionTutorials = tutorials.filter((tutorial) => getTutorialSectionId(tutorial, subject) === section.id);
      return `
        <section class="admin-tutorial-section" data-admin-search-group>
          <header>
            <strong>${escapeHtml(section.title)}</strong>
            <span>${sectionTutorials.length} ${sectionTutorials.length === 1 ? "tutorial" : "tutorials"}</span>
          </header>
          <div>
            ${sectionTutorials.map((item) => renderAdminListItem(item, "articles")).join("") || renderEmptyState("No tutorials in this section yet.")}
          </div>
        </section>
      `;
    })
    .join("");
}
function renderAdminListItem(item, type) {
  const subject = type === "articles" ? getSubjectByTitle(item.category) : null;
  const section = type === "articles" ? getTutorialSection(item, subject) : null;
  const detail = type === "articles"
    ? `${item.category || "General"}${section ? ` / ${section.title}` : ""} / ${getReadTime(item.body)} min read`
    : type === "blogs"
      ? `${item.category || "Blog"} / ${getReadTime(item.body)} min read`
      : type === "codingProblems"
        ? `${item.kindLabel || "Coding"} / ${item.category || "General"} / ${capitalize(item.difficulty || "medium")}`
        : `${item.category || "General"} / ${item.level || "Course"} / ${item.duration || "Self paced"}`;
  const coverUrl = type === "tutorials" || type === "blogs" ? safeUrl(item.coverImage) : "";
  const orderItems = type === "articles"
    ? sortByOrder(state.articles.filter((article) => article.category === item.category && getTutorialSectionId(article, subject) === getTutorialSectionId(item, subject)))
    : type === "codingProblems"
      ? sortByOrder(state.codingProblems)
      : [];
  return `
    <div class="admin-list-item${type === "tutorials" && item.hiddenFromPublic ? " is-public-hidden" : ""}" data-admin-search-item data-search="${escapeAttr(`${item.title} ${detail} ${item.status}${type === "tutorials" && item.hiddenFromPublic ? " hidden" : ""}`)}">
      <div class="admin-list-detail">
        ${coverUrl ? `<img class="admin-list-thumb" src="${escapeAttr(coverUrl)}" alt="" data-managed-image />` : `<span class="admin-list-placeholder">${escapeHtml(getInitials(item.title))}</span>`}
        <div><strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(detail)}</span>${renderContributionCredit(item)}</div>
      </div>
      ${renderStatusBadge(type === "tutorials" && item.hiddenFromPublic ? "hidden" : item.status)}
      <div class="admin-actions">
        ${type === "articles" && state.isAdmin ? renderOrderControls(item, "articles", orderItems) : ""}
        ${type === "codingProblems" && state.isAdmin ? renderOrderControls(item, "codingProblems", orderItems) : ""}
        ${type === "articles" ? `<button class="icon-only-button" type="button" data-download-tutorial-doc="${escapeAttr(item.id)}" title="Download ${escapeAttr(item.title)} as Word document" aria-label="Download ${escapeAttr(item.title)} as Word document">${renderAdminIcon("download")}</button>` : ""}
        ${type === "tutorials" && state.isAdmin ? renderCourseVisibilityToggle(item) : ""}
        ${state.isAdmin && item.submittedByUid && item.status === "draft" ? `<button class="icon-only-button" type="button" data-request-changes="${escapeAttr(item.id)}" data-request-type="${type}" title="Send back with a note" aria-label="Send ${escapeAttr(item.title)} back to the contributor with a note">${renderAdminIcon("flag")}</button>` : ""}
        ${state.isAdmin || canContributorEdit(item) ? `<button class="icon-only-button" type="button" data-edit="${escapeAttr(item.id)}" data-edit-type="${type}" title="Edit ${escapeAttr(item.title)}" aria-label="Edit ${escapeAttr(item.title)}">${renderAdminIcon("edit")}</button>
        <button class="icon-only-button is-danger" type="button" data-delete="${escapeAttr(item.id)}" data-delete-type="${type}" title="Remove ${escapeAttr(item.title)}" aria-label="Remove ${escapeAttr(item.title)}">${renderAdminIcon("trash")}</button>` : `<span class="contributor-locked-note">Published by admin</span>`}
      </div>
    </div>
  `;
}
function renderCourseVisibilityToggle(course) {
  const hidden = Boolean(course.hiddenFromPublic);
  const label = hidden ? `Show ${course.title} on public website` : `Hide ${course.title} from public website`;
  return `<button class="icon-only-button ${hidden ? "is-success" : "is-warning"}" type="button" data-toggle-course-public="${escapeAttr(course.id)}" data-hidden-next="${escapeAttr(String(!hidden))}" title="${escapeAttr(label)}" aria-label="${escapeAttr(label)}">${renderAdminIcon(hidden ? "eye" : "eyeOff")}</button>`;
}

function renderOrderControls(item, type, orderedItems) {
  const index = orderedItems.findIndex((candidate) => candidate.id === item.id);
  const disableUp = index <= 0;
  const disableDown = index < 0 || index >= orderedItems.length - 1;

  return `
    <span class="order-controls" aria-label="Rearrange ${escapeAttr(item.title)}">
      <button
        class="icon-only-button"
        type="button"
        data-move-item="${escapeAttr(item.id)}"
        data-move-type="${escapeAttr(type)}"
        data-move-direction="-1"
        title="Move ${escapeAttr(item.title)} up"
        aria-label="Move ${escapeAttr(item.title)} up"
        ${disableUp ? "disabled" : ""}
      >${renderAdminIcon("arrowUp")}</button>
      <button
        class="icon-only-button"
        type="button"
        data-move-item="${escapeAttr(item.id)}"
        data-move-type="${escapeAttr(type)}"
        data-move-direction="1"
        title="Move ${escapeAttr(item.title)} down"
        aria-label="Move ${escapeAttr(item.title)} down"
        ${disableDown ? "disabled" : ""}
      >${renderAdminIcon("arrowDown")}</button>
    </span>
  `;
}
// AdSense refuses ads on screens "without content or with low value
// content ... that are under construction ... used for alerts, navigation
// or other behavioural purposes". A slot rendered unconditionally breaks
// that the moment its screen is empty, still loading, filtered down to
// nothing, or showing a login gate - so every caller has to pass the
// evidence that its screen carries real published content.
function renderAdSlot(slotName, layout = "horizontal", options = {}) {
  if (!adsConfig?.enabled) return "";
  if (options.hasContent !== true) return "";
  const slot = getConfiguredAdSlot(slotName);
  const classes = `ad-placement ad-placement--${escapeAttr(layout)}${slot ? "" : " ad-placement--placeholder"}`;

  return `
    <aside class="${classes}" aria-label="Advertisement">
      <span class="ad-placement-label">Advertisement</span>
      ${slot
        ? `<ins
            class="adsbygoogle"
            data-ad-client="${escapeAttr(adsConfig.client)}"
            data-ad-slot="${escapeAttr(slot)}"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>`
        : `<div class="ad-placeholder" data-ad-placeholder>
            <span>Ad space</span>
            <strong>SkillUp Class</strong>
          </div>`}
    </aside>
  `;
}

function getConfiguredAdSlot(slotName) {
  const client = String(adsConfig?.client || "").trim();
  const slot = String(adsConfig?.slots?.[slotName] || "").trim();
  if (!adsConfig?.enabled) return "";
  if (!/^ca-pub-\d+$/.test(client) || !/^\d+$/.test(slot)) return "";
  return slot;
}

function initializeAds() {
  const adUnits = [...document.querySelectorAll(".adsbygoogle[data-ad-slot]")];
  const client = String(adsConfig?.client || "").trim();
  if (!adUnits.length || !/^ca-pub-\d+$/.test(client)) return;

  let script = document.querySelector("script[data-adsense-script]");
  if (!script) {
    script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.dataset.adsenseScript = "true";
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(adsConfig.client)}`;
    script.addEventListener("error", () => {
      document.querySelectorAll(".ad-placement").forEach((placement) => {
        placement.hidden = true;
      });
    });
    document.head.append(script);
  }

  window.adsbygoogle = window.adsbygoogle || [];
  adUnits.forEach((unit) => {
    if (unit.dataset.adLoaded === "true") return;
    unit.dataset.adLoaded = "true";
    const observer = new MutationObserver(() => {
      if (unit.dataset.adStatus === "unfilled") {
        unit.closest(".ad-placement")?.setAttribute("hidden", "");
        observer.disconnect();
      }
    });
    observer.observe(unit, { attributes: true, attributeFilter: ["data-ad-status"] });
    try {
      window.adsbygoogle.push({});
    } catch {
      observer.disconnect();
      unit.closest(".ad-placement")?.setAttribute("hidden", "");
    }
  });
}

function renderEmptyState(message) {
  return `<div class="empty-state" data-reveal>${escapeHtml(message)}</div>`;
}

function handleMouseDown(event) {
  const resizeHandle = event.target.closest("[data-rich-resize-image]");
  if (resizeHandle) {
    startRichImageResize(resizeHandle, event);
    return;
  }



  const richImageAction = event.target.closest("[data-rich-image-action]");
  if (richImageAction) {
    const form = richImageAction.closest("[data-admin-form]");
    const editor = form?.querySelector("[data-rich-editor]");
    if (editor) saveRichSelection(editor);
    event.preventDefault();
    return;
  }

  const editorImage = event.target.closest("[data-rich-editor] figure img");
  if (editorImage) {
    const imageFigure = editorImage.closest("figure");
    const editor = imageFigure?.closest("[data-rich-editor]");
    selectRichImageFigure(imageFigure);
    if (editor) saveRichSelection(editor);
    event.preventDefault();
    return;
  }

  const richControl = event.target.closest("[data-rich-command], [data-rich-insert-image], [data-rich-cancel-panel], [data-diagram-symbol], [data-diagram-new], [data-diagram-close]");
  if (!richControl) return;

  const form = richControl.closest("[data-admin-form]");
  const editor = form?.querySelector("[data-rich-editor]");
  if (!editor) return;

  saveRichSelection(editor);
  if (richControl.tagName === "SELECT") return;
  event.preventDefault();
}

function appendSubjectSectionRow(form) {
  const input = form?.querySelector("[data-new-subject-section]");
  const rows = form?.querySelector("[data-subject-section-rows]");
  const title = String(input?.value || "").trim();
  if (!form || !rows) return;
  if (!title) {
    showToast("Enter a section name first.");
    input?.focus();
    return;
  }

  rows.querySelector("[data-subject-section-empty]")?.remove();
  const nextIndex = rows.querySelectorAll("[data-subject-section-row]").length;
  rows.insertAdjacentHTML("beforeend", renderSubjectSectionRow({ title, order: nextIndex + 1 }, nextIndex));
  input.value = "";
  input.focus();
}

function removeSubjectSectionRow(button) {
  const form = button?.closest("[data-subject-form]");
  const row = button?.closest("[data-subject-section-row]");
  row?.remove();
  resequenceSubjectSectionRows(form);
  updateSubjectSectionEmptyState(form);
}

function resequenceSubjectSectionRows(form) {
  form?.querySelectorAll("[data-subject-section-row]").forEach((row, index) => {
    const orderInput = row.querySelector('input[name="sectionOrder"]');
    if (orderInput) orderInput.value = String(index + 1);
  });
}

function updateSubjectSectionEmptyState(form) {
  const rows = form?.querySelector("[data-subject-section-rows]");
  if (!rows || rows.querySelector("[data-subject-section-row]")) return;
  rows.innerHTML = '<div class="subject-section-empty" data-subject-section-empty>No sections yet. Add a section above or save with the default tutorial group.</div>';
}
async function handleClick(event) {
  const installButton = event.target.closest("[data-install-app]");
  if (installButton) {
    event.preventDefault();
    await installSkillUpApp();
    return;
  }

  const reloadButton = event.target.closest("[data-reload-page]");
  if (reloadButton) {
    event.preventDefault();
    window.location.reload();
    return;
  }

  const accountMenuButton = event.target.closest("[data-account-menu-toggle]");
  if (accountMenuButton) {
    event.preventDefault();
    const account = accountMenuButton.closest("[data-nav-account]");
    const willOpen = !account?.classList.contains("is-open");
    closeAccountMenus();
    account?.classList.toggle("is-open", willOpen);
    accountMenuButton.setAttribute("aria-expanded", String(willOpen));
    return;
  }

  const accountMenuLink = event.target.closest("[data-account-menu-link]");
  if (accountMenuLink) {
    closeMenu();
  } else if (!event.target.closest("[data-nav-account]")) {
    closeAccountMenus();
  }
  const progressButton = event.target.closest("[data-toggle-tutorial-progress]");
  if (progressButton) {
    event.preventDefault();
    if (!requireStudentAccount("save your progress")) return;
    await toggleTutorialProgress(progressButton.dataset.toggleTutorialProgress, progressButton.dataset.progressCompleted === "true");
    return;
  }

  const bookmarkButton = event.target.closest("[data-toggle-tutorial-bookmark]");
  if (bookmarkButton) {
    event.preventDefault();
    if (!requireStudentAccount("bookmark this tutorial")) return;
    await toggleTutorialBookmark(bookmarkButton.dataset.toggleTutorialBookmark, bookmarkButton.dataset.bookmarkActive === "true");
    return;
  }

  const quizButton = event.target.closest("[data-check-quiz]");
  if (quizButton) {
    event.preventDefault();
    if (!requireStudentAccount("check your answers")) return;
    checkPracticeQuiz(quizButton);
    return;
  }

  const codingPracticeItem = event.target.closest("[data-coding-practice-item]");
  if (codingPracticeItem) {
    event.preventDefault();
    selectCodingPracticeItem(codingPracticeItem.dataset.codingPracticeItem);
    return;
  }

  const runCodeButton = event.target.closest("[data-run-code]");
  if (runCodeButton) {
    event.preventDefault();
    runCodingPracticeSample(runCodeButton.closest("[data-coding-practice-scope]"));
    return;
  }

  const openKotlinPlaygroundButton = event.target.closest("[data-open-kotlin-playground]");
  if (openKotlinPlaygroundButton) {
    event.preventDefault();
    openKotlinPlaygroundPractice(openKotlinPlaygroundButton.closest("[data-coding-practice-scope]"));
    return;
  }

  const resetCodeButton = event.target.closest("[data-reset-code]");
  if (resetCodeButton) {
    event.preventDefault();
    resetCodingPracticeEditor(resetCodeButton.closest("[data-coding-practice-scope]"));
    return;
  }

  const practiceSolvedButton = event.target.closest("[data-practice-solved]");
  if (practiceSolvedButton) {
    event.preventDefault();
    togglePracticeSolved(practiceSolvedButton.dataset.practiceSolved, practiceSolvedButton.closest("[data-coding-practice-scope], [data-practice-scope]"));
    return;
  }

  const generateSubjectBookButton = event.target.closest("[data-generate-subject-book]");
  if (generateSubjectBookButton) {
    event.preventDefault();
    generateSubjectBook(generateSubjectBookButton.dataset.generateSubjectBook);
    return;
  }

  const downloadSectionDocButton = event.target.closest("[data-download-section-doc]");
  if (downloadSectionDocButton) {
    event.preventDefault();
    downloadSectionDocument(downloadSectionDocButton.dataset.downloadSectionDoc, downloadSectionDocButton.dataset.sectionId);
    return;
  }

  const downloadTutorialDocButton = event.target.closest("[data-download-tutorial-doc]");
  if (downloadTutorialDocButton) {
    event.preventDefault();
    downloadTutorialDocument(downloadTutorialDocButton.dataset.downloadTutorialDoc);
    return;
  }
  const openCourseDetailsButton = event.target.closest("[data-open-course-details]");
  if (openCourseDetailsButton) {
    event.preventDefault();
    state.activeCourseId = openCourseDetailsButton.dataset.openCourseDetails;
    render();
    window.requestAnimationFrame(() => {
      document.querySelector("[data-close-course-modal].course-modal-close")?.focus();
    });
    return;
  }

  const closeCourseModalButton = event.target.closest("[data-close-course-modal]");
  if (closeCourseModalButton) {
    event.preventDefault();
    state.activeCourseId = "";
    render();
    return;
  }

  const addSubjectSectionButton = event.target.closest("[data-add-subject-section]");
  if (addSubjectSectionButton) {
    event.preventDefault();
    appendSubjectSectionRow(addSubjectSectionButton.closest("[data-subject-form]"));
    return;
  }

  const removeSubjectSectionButton = event.target.closest("[data-remove-subject-section]");
  if (removeSubjectSectionButton) {
    event.preventDefault();
    removeSubjectSectionRow(removeSubjectSectionButton);
    return;
  }

  const openFullViewButton = event.target.closest("[data-open-full-view]");
  if (openFullViewButton) {
    state.fullViewTutorialId = openFullViewButton.dataset.openFullView;
    render();
    window.requestAnimationFrame(() => {
      document.querySelector("[data-close-full-view].tutorial-full-view-close")?.focus();
    });
    return;
  }

  const clearDocumentButton = event.target.closest("[data-clear-document]");
  if (clearDocumentButton) {
    const form = clearDocumentButton.closest("[data-admin-form]");
    if (!form) return;
    const urlInput = form.querySelector('input[name="documentUrl"]');
    const nameInput = form.querySelector('input[name="documentName"]');
    const pathInput = form.querySelector('input[name="documentPath"]');
    if (urlInput) urlInput.value = "";
    if (nameInput) nameInput.value = "";
    if (pathInput) pathInput.value = "";
    updateDocumentPreview(form, {});
    return;
  }

  const closeFullViewButton = event.target.closest("[data-close-full-view]");
  if (closeFullViewButton) {
    const tutorialId = state.fullViewTutorialId;
    state.fullViewTutorialId = "";
    render();
    window.requestAnimationFrame(() => {
      focusFullViewButton(tutorialId);
    });
    return;
  }

  const fullViewTopicNav = event.target.closest("[data-full-view-topic-nav]");
  if (fullViewTopicNav) {
    event.preventDefault();
    const targetId = fullViewTopicNav.dataset.fullViewTopicNav;
    if (!targetId) return;
    state.fullViewTutorialId = targetId;
    navigateTo(`/tutorials/${encodeURIComponent(targetId)}`);
    return;
  }
  const fullViewHeadingButton = event.target.closest("[data-full-view-heading]");
  if (fullViewHeadingButton) {
    const target = document.getElementById(fullViewHeadingButton.dataset.fullViewHeading);
    if (target) {
      setFullViewActiveHeading(target.id);
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return;
  }




  const readerControlButton = event.target.closest("button[data-reader-theme]");
  if (applyFullViewReaderControl(readerControlButton)) return;
  const richImageAction = event.target.closest("[data-rich-image-action]");
  if (richImageAction) {
    event.preventDefault();
    applyRichImageAction(richImageAction);
    return;
  }

  const clickedEditorImage = event.target.closest("[data-rich-editor] figure img");
  if (clickedEditorImage) {
    selectRichImageFigure(clickedEditorImage.closest("figure"));
    return;
  }

  if (!event.target.closest("[data-rich-image-toolbar], [data-rich-editor]")) {
    clearRichImageSelection();
  }

  const diagramSymbolButton = event.target.closest("[data-diagram-symbol]");
  if (diagramSymbolButton) {
    event.preventDefault();
    insertDiagramSymbol(diagramSymbolButton);
    return;
  }

  const newDiagramButton = event.target.closest("[data-diagram-new]");
  if (newDiagramButton) {
    event.preventDefault();
    const form = newDiagramButton.closest("[data-admin-form]");
    const editor = form?.querySelector("[data-rich-editor]");
    if (editor) {
      restoreRichSelection(editor);
      insertNewDiagramBlock(editor);
      syncRichEditor(form);
      editor.focus();
    }
    return;
  }

  const closeDiagramButton = event.target.closest("[data-diagram-close]");
  if (closeDiagramButton) {
    event.preventDefault();
    closeDiagramPanel(closeDiagramButton.closest("[data-admin-form]"));
    return;
  }

  const insertImageButton = event.target.closest("[data-rich-insert-image]");
  if (insertImageButton) {
    event.preventDefault();
    await insertPanelImage(insertImageButton);
    return;
  }

  const cancelPanelButton = event.target.closest("[data-rich-cancel-panel]");
  if (cancelPanelButton) {
    event.preventDefault();
    closeRichImagePanel(cancelPanelButton.closest("[data-admin-form]"));
    return;
  }

  const richCommand = event.target.closest("[data-rich-command]");
  if (richCommand && richCommand.tagName !== "SELECT") {
    event.preventDefault();
    applyRichCommand(richCommand);
    return;
  }

  const menuButton = event.target.closest("[data-menu-toggle]");
  if (menuButton) {
    const nav = document.querySelector("[data-nav]");
    const expanded = menuButton.getAttribute("aria-expanded") === "true";
    menuButton.setAttribute("aria-expanded", String(!expanded));
    nav.classList.toggle("is-open", !expanded);
    return;
  }

  const topicsToggle = event.target.closest("[data-topics-toggle]");
  if (topicsToggle) {
    const layout = document.querySelector("[data-tutorial-layout]");
    const toggleButton = document.querySelector(".topics-toggle[data-topics-toggle]");
    const willOpen = !layout?.classList.contains("is-topics-open");
    layout?.classList.toggle("is-topics-open", willOpen);
    toggleButton?.setAttribute("aria-expanded", String(willOpen));
    if (willOpen) {
      document.getElementById("topic-sidebar-panel")?.focus({ preventScroll: true });
    } else {
      toggleButton?.focus({ preventScroll: true });
    }
    return;
  }

  const authViewButton = event.target.closest("[data-auth-view]");
  if (authViewButton) {
    state.authView = authViewButton.dataset.authView || "login";
    render();
    return;
  }

  const studentAuthViewButton = event.target.closest("[data-student-auth-view]");
  if (studentAuthViewButton) {
    state.studentAuthView = studentAuthViewButton.dataset.studentAuthView || "login";
    render();
    return;
  }

  const addCodingMetaRowButton = event.target.closest("[data-add-coding-meta-row]");
  if (addCodingMetaRowButton) {
    event.preventDefault();
    appendCodingMetaRow(addCodingMetaRowButton);
    return;
  }

  const removeCodingMetaRowButton = event.target.closest("[data-remove-coding-meta-row]");
  if (removeCodingMetaRowButton) {
    event.preventDefault();
    removeCodingMetaRow(removeCodingMetaRowButton);
    return;
  }
  const refreshStudentsButton = event.target.closest("[data-refresh-students]");
  if (refreshStudentsButton) {
    event.preventDefault();
    await refreshAdminStudents();
    return;
  }

  const refreshCommentsButton = event.target.closest("[data-refresh-comments]");
  if (refreshCommentsButton) {
    event.preventDefault();
    await refreshAdminComments();
    return;
  }

  const refreshCommunityPostsButton = event.target.closest("[data-refresh-community-posts]");
  if (refreshCommunityPostsButton) {
    event.preventDefault();
    await refreshAdminCommunityPosts();
    return;
  }

  const replyCommentButton = event.target.closest("[data-reply-comment]");
  if (replyCommentButton) {
    event.preventDefault();
    const scope = replyCommentButton.closest("[data-discussion-scope]");
    if (!scope) return;
    const key = getDiscussionKey(scope.dataset.contentType, scope.dataset.contentId);
    const commentId = replyCommentButton.dataset.replyComment;
    state.discussionReplyTarget[key] = state.discussionReplyTarget[key] === commentId ? "" : commentId;
    render();
    return;
  }

  const cancelReplyButton = event.target.closest("[data-cancel-reply]");
  if (cancelReplyButton) {
    event.preventDefault();
    const scope = cancelReplyButton.closest("[data-discussion-scope]");
    if (!scope) return;
    const key = getDiscussionKey(scope.dataset.contentType, scope.dataset.contentId);
    delete state.discussionReplyTarget[key];
    render();
    return;
  }

  const retryDiscussionButton = event.target.closest("[data-retry-discussion]");
  if (retryDiscussionButton) {
    event.preventDefault();
    const scope = retryDiscussionButton.closest("[data-discussion-scope]");
    if (!scope) return;
    const key = getDiscussionKey(scope.dataset.contentType, scope.dataset.contentId);
    delete state.discussionError[key];
    loadDiscussionComments(scope.dataset.contentType, scope.dataset.contentId, scope.dataset.contentTitle);
    render();
    return;
  }

  const flagCommentButton = event.target.closest("[data-flag-comment]");
  if (flagCommentButton) {
    event.preventDefault();
    const scope = flagCommentButton.closest("[data-discussion-scope]");
    if (!scope) return;
    await flagDiscussionComment(scope.dataset.contentType, scope.dataset.contentId, flagCommentButton.dataset.flagComment);
    return;
  }

  const deleteCommentButton = event.target.closest("[data-delete-comment]");
  if (deleteCommentButton) {
    event.preventDefault();
    const scope = deleteCommentButton.closest("[data-discussion-scope]");
    if (!scope) return;
    if (!window.confirm("Delete this comment?")) return;
    await deleteDiscussionComment(scope.dataset.contentType, scope.dataset.contentId, deleteCommentButton.dataset.deleteComment);
    return;
  }

  const joinCommunityButton = event.target.closest("[data-join-community]");
  if (joinCommunityButton) {
    event.preventDefault();
    await runWithLoader("Joining community...", () => joinCommunity(joinCommunityButton.dataset.joinCommunity));
    return;
  }

  const leaveCommunityButton = event.target.closest("[data-leave-community]");
  if (leaveCommunityButton) {
    event.preventDefault();
    if (!window.confirm("Leave this community?")) return;
    await runWithLoader("Leaving community...", () => leaveCommunity(leaveCommunityButton.dataset.leaveCommunity));
    return;
  }

  const replyCommunityPostButton = event.target.closest("[data-reply-community-post]");
  if (replyCommunityPostButton) {
    event.preventDefault();
    const scope = replyCommunityPostButton.closest("[data-community-scope]");
    if (!scope) return;
    const communityId = scope.dataset.communityId;
    const postId = replyCommunityPostButton.dataset.replyCommunityPost;
    state.communityPostReplyTarget[communityId] = state.communityPostReplyTarget[communityId] === postId ? "" : postId;
    render();
    return;
  }

  const cancelCommunityReplyButton = event.target.closest("[data-cancel-community-reply]");
  if (cancelCommunityReplyButton) {
    event.preventDefault();
    const scope = cancelCommunityReplyButton.closest("[data-community-scope]");
    if (!scope) return;
    delete state.communityPostReplyTarget[scope.dataset.communityId];
    render();
    return;
  }

  const retryCommunityPostsButton = event.target.closest("[data-retry-community-posts]");
  if (retryCommunityPostsButton) {
    event.preventDefault();
    const scope = retryCommunityPostsButton.closest("[data-community-scope]");
    if (!scope) return;
    delete state.communityPostError[scope.dataset.communityId];
    loadCommunityPosts(scope.dataset.communityId);
    render();
    return;
  }

  const flagCommunityPostButton = event.target.closest("[data-flag-community-post]");
  if (flagCommunityPostButton) {
    event.preventDefault();
    const scope = flagCommunityPostButton.closest("[data-community-scope]");
    if (!scope) return;
    await flagCommunityPost(scope.dataset.communityId, flagCommunityPostButton.dataset.flagCommunityPost);
    return;
  }

  const deleteCommunityPostButton = event.target.closest("[data-delete-community-post]");
  if (deleteCommunityPostButton) {
    event.preventDefault();
    const scope = deleteCommunityPostButton.closest("[data-community-scope]");
    if (!scope) return;
    if (!window.confirm("Delete this post?")) return;
    await deleteCommunityPost(scope.dataset.communityId, deleteCommunityPostButton.dataset.deleteCommunityPost);
    return;
  }

  const hideCommentButton = event.target.closest("[data-hide-comment]");
  if (hideCommentButton) {
    event.preventDefault();
    await setCommentStatus(hideCommentButton.dataset.hideComment, "hidden");
    return;
  }

  const restoreCommentButton = event.target.closest("[data-restore-comment]");
  if (restoreCommentButton) {
    event.preventDefault();
    await setCommentStatus(restoreCommentButton.dataset.restoreComment, "visible");
    return;
  }

  const dismissCommentFlagsButton = event.target.closest("[data-dismiss-comment-flags]");
  if (dismissCommentFlagsButton) {
    event.preventDefault();
    await dismissCommentFlags(dismissCommentFlagsButton.dataset.dismissCommentFlags);
    return;
  }

  const deleteAdminCommentButton = event.target.closest("[data-delete-admin-comment]");
  if (deleteAdminCommentButton) {
    event.preventDefault();
    if (!window.confirm("Delete this comment permanently?")) return;
    await deleteAdminComment(deleteAdminCommentButton.dataset.deleteAdminComment);
    return;
  }

  const mediaLibraryButton = event.target.closest("[data-media-library]");
  if (mediaLibraryButton) {
    event.preventDefault();
    await openMediaLibrary(mediaLibraryButton);
    return;
  }

  const clearImageButton = event.target.closest("[data-clear-image]");
  if (clearImageButton) {
    event.preventDefault();
    const form = clearImageButton.closest("[data-admin-form], [data-subject-form], [data-community-form], [data-event-form], [data-session-form]");
    applyImageToField(form, clearImageButton.dataset.clearImage, "", "");
    clearImageButton.remove();
    showToast("Image removed. Save to apply it.");
    return;
  }

  const acceptPolicyButton = event.target.closest("[data-accept-community-policy]");
  if (acceptPolicyButton) {
    event.preventDefault();
    await joinCommunity(acceptPolicyButton.dataset.acceptCommunityPolicy);
    return;
  }

  const suspiciousEditButton = event.target.closest("[data-suspicious-edit]");
  if (suspiciousEditButton) {
    event.preventDefault();
    delete state.pendingSuspicious[suspiciousEditButton.dataset.suspiciousEdit];
    render();
    return;
  }

  // The draft is already held in state; posting again with the same text
  // passes the "already warned" check in the post handlers.
  const suspiciousContinueButton = event.target.closest("[data-suspicious-continue]");
  if (suspiciousContinueButton) {
    event.preventDefault();
    const scopeKey = suspiciousContinueButton.dataset.suspiciousContinue;
    const draft = state.pendingSuspicious[scopeKey] || "";
    const scope = suspiciousContinueButton.closest("[data-community-scope], [data-discussion-scope]");
    if (!draft || !scope) return;
    if (scope.matches("[data-community-scope]")) {
      await postCommunityMessage({ communityId: scope.dataset.communityId, body: draft });
    } else {
      await postDiscussionComment({
        contentType: scope.dataset.contentType,
        contentId: scope.dataset.contentId,
        contentTitle: scope.dataset.contentTitle,
        body: draft
      });
    }
    return;
  }

  const moderationFilterButton = event.target.closest("[data-moderation-filter]");
  if (moderationFilterButton) {
    event.preventDefault();
    state.adminModerationFilter = moderationFilterButton.dataset.moderationFilter;
    render();
    return;
  }

  const blockAuthorButton = event.target.closest("[data-block-author]");
  if (blockAuthorButton) {
    event.preventDefault();
    const { blockAuthor: uid, authorName: name, blockArea: area } = blockAuthorButton.dataset;
    const reason = window.prompt(`Block ${name || "this student"} from posting. Add a short reason (optional):`, "");
    if (reason === null) return;
    await blockStudentFromAreas({ uid, name, areas: [area], reason });
    return;
  }

  const unblockButton = event.target.closest("[data-unblock-student]");
  if (unblockButton) {
    event.preventDefault();
    await unblockStudent(unblockButton.dataset.unblockStudent);
    return;
  }

  const scrollToButton = event.target.closest("[data-scroll-to]");
  if (scrollToButton) {
    event.preventDefault();
    const target = document.getElementById(scrollToButton.dataset.scrollTo);
    if (target) {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      // Move focus with the view, so keyboard and screen-reader users land
      // on the section they chose rather than staying on the button.
      target.querySelector("h2")?.focus({ preventScroll: true });
    }
    return;
  }

  if (event.target.closest("[data-send-verification]")) {
    event.preventDefault();
    await runWithLoader("Sending link...", () => sendVerificationEmail());
    return;
  }

  if (event.target.closest("[data-refresh-verification]")) {
    event.preventDefault();
    await runWithLoader("Checking...", () => refreshVerificationStatus());
    return;
  }

  if (event.target.closest("[data-refresh-client-errors]")) {
    event.preventDefault();
    await runWithLoader("Loading site errors...", () => loadClientErrors({ force: true }));
    render();
    return;
  }

  if (event.target.closest("[data-clear-client-errors]")) {
    event.preventDefault();
    if (!window.confirm("Clear every reported site error?")) return;
    await runWithLoader("Clearing...", () => clearClientErrors());
    return;
  }

  const newEventButton = event.target.closest("[data-new-event]");
  if (newEventButton) {
    state.adminType = "events";
    state.editingEventId = null;
    openAdminEditor();
    return;
  }

  const editEventButton = event.target.closest("[data-edit-event]");
  if (editEventButton) {
    state.adminType = "events";
    state.editingEventId = editEventButton.dataset.editEvent;
    openAdminEditor();
    return;
  }

  const deleteEventButton = event.target.closest("[data-delete-event]");
  if (deleteEventButton) {
    event.preventDefault();
    if (!window.confirm("Delete this event? Its registrations and meeting link are removed too.")) return;
    await runWithLoader("Deleting event...", () => deleteEvent(deleteEventButton.dataset.deleteEvent));
    return;
  }

  const loadRegistrationsButton = event.target.closest("[data-load-event-registrations]");
  if (loadRegistrationsButton) {
    event.preventDefault();
    const eventId = loadRegistrationsButton.dataset.loadEventRegistrations;
    const force = loadRegistrationsButton.dataset.force === "true";
    await runWithLoader("Loading registrations...", async () => {
      await loadEventRegistrations(eventId, { force });
      await loadEventMeeting(eventId, { force });
    });
    render();
    return;
  }

  const sendInviteButton = event.target.closest("[data-send-event-invite]");
  if (sendInviteButton) {
    event.preventDefault();
    const target = findEventById(sendInviteButton.dataset.sendEventInvite);
    if (!target) return;
    const count = getEventRegistrationEmails(target.id).length;
    if (!window.confirm(`Send the meeting invite to ${count} registrant${count === 1 ? "" : "s"}?`)) return;
    await runWithLoader("Queueing invite...", () => sendEventInviteEmail(target));
    return;
  }

  const copyEmailsButton = event.target.closest("[data-copy-event-emails]");
  if (copyEmailsButton) {
    event.preventDefault();
    const emails = getEventRegistrationEmails(copyEmailsButton.dataset.copyEventEmails);
    try {
      await navigator.clipboard.writeText(emails.join(", "));
      showToast(`Copied ${emails.length} email${emails.length === 1 ? "" : "s"}.`);
    } catch (error) {
      showToast("Could not copy. Select the addresses in the list instead.");
      console.warn("Clipboard write failed:", error);
    }
    return;
  }

  const registerEventButton = event.target.closest("[data-register-event]");
  if (registerEventButton) {
    event.preventDefault();
    await runWithLoader("Registering...", () => registerForEvent(registerEventButton.dataset.registerEvent));
    return;
  }

  const cancelEventButton = event.target.closest("[data-cancel-event]");
  if (cancelEventButton) {
    event.preventDefault();
    if (!window.confirm("Cancel your registration for this event?")) return;
    await runWithLoader("Cancelling...", () => cancelEventRegistration(cancelEventButton.dataset.cancelEvent));
    return;
  }

  const newCommunityButton = event.target.closest("[data-new-community]");
  if (newCommunityButton) {
    state.adminType = "communities";
    state.editingCommunityId = null;
    openAdminEditor();
    return;
  }

  const editCommunityButton = event.target.closest("[data-edit-community]");
  if (editCommunityButton) {
    state.adminType = "communities";
    state.editingCommunityId = editCommunityButton.dataset.editCommunity;
    openAdminEditor();
    return;
  }

  const deleteCommunityButton = event.target.closest("[data-delete-community]");
  if (deleteCommunityButton) {
    event.preventDefault();
    if (!window.confirm("Delete this community? Its posts and memberships will remain but the community will no longer be reachable.")) return;
    await runWithLoader("Deleting community...", () => deleteCommunity(deleteCommunityButton.dataset.deleteCommunity));
    return;
  }

  const hideCommunityPostButton = event.target.closest("[data-hide-community-post]");
  if (hideCommunityPostButton) {
    event.preventDefault();
    await setCommunityPostStatus(hideCommunityPostButton.dataset.hideCommunityPost, "hidden");
    return;
  }

  const restoreCommunityPostButton = event.target.closest("[data-restore-community-post]");
  if (restoreCommunityPostButton) {
    event.preventDefault();
    await setCommunityPostStatus(restoreCommunityPostButton.dataset.restoreCommunityPost, "visible");
    return;
  }

  const dismissCommunityPostFlagsButton = event.target.closest("[data-dismiss-community-post-flags]");
  if (dismissCommunityPostFlagsButton) {
    event.preventDefault();
    await dismissCommunityPostFlags(dismissCommunityPostFlagsButton.dataset.dismissCommunityPostFlags);
    return;
  }

  const deleteAdminCommunityPostButton = event.target.closest("[data-delete-admin-community-post]");
  if (deleteAdminCommunityPostButton) {
    event.preventDefault();
    if (!window.confirm("Delete this post permanently?")) return;
    await deleteAdminCommunityPost(deleteAdminCommunityPostButton.dataset.deleteAdminCommunityPost);
    return;
  }

  const voteCommentButton = event.target.closest("[data-vote-comment]");
  if (voteCommentButton) {
    event.preventDefault();
    const { contentType, contentId, voteComment } = voteCommentButton.dataset;
    await toggleHelpfulVote("comments", findDiscussionItem(contentType, contentId, voteComment));
    return;
  }

  const votePostButton = event.target.closest("[data-vote-post]");
  if (votePostButton) {
    event.preventDefault();
    await toggleHelpfulVote("communityPosts", findCommunityPostItem(votePostButton.dataset.communityId, votePostButton.dataset.votePost));
    return;
  }

  const acceptCommentButton = event.target.closest("[data-accept-comment]");
  if (acceptCommentButton) {
    event.preventDefault();
    const { contentType, contentId, threadId, acceptComment } = acceptCommentButton.dataset;
    await setAcceptedReply("comments", findDiscussionItem(contentType, contentId, threadId), acceptComment);
    return;
  }

  const acceptPostButton = event.target.closest("[data-accept-post]");
  if (acceptPostButton) {
    event.preventDefault();
    const { communityId, threadId, acceptPost } = acceptPostButton.dataset;
    await setAcceptedReply("communityPosts", findCommunityPostItem(communityId, threadId), acceptPost);
    return;
  }

  const claimCertificateButton = event.target.closest("[data-claim-certificate]");
  if (claimCertificateButton) {
    event.preventDefault();
    await runWithLoader("Creating your certificate...", () => claimCertificate(claimCertificateButton.dataset.claimCertificate));
    return;
  }

  const downloadCertificateButton = event.target.closest("[data-download-certificate]");
  if (downloadCertificateButton) {
    event.preventDefault();
    await runWithLoader("Preparing the image...", () => downloadCertificateImage(downloadCertificateButton.dataset.downloadCertificate));
    return;
  }

  const copyCertificateButton = event.target.closest("[data-copy-certificate-link]");
  if (copyCertificateButton) {
    event.preventDefault();
    try {
      await navigator.clipboard.writeText(copyCertificateButton.dataset.copyCertificateLink);
      showToast("Link copied.");
    } catch {
      showToast(copyCertificateButton.dataset.copyCertificateLink);
    }
    return;
  }

  const editSessionReviewButton = event.target.closest("[data-edit-session-review]");
  if (editSessionReviewButton) {
    event.preventDefault();
    state.editingSessionReviewId = editSessionReviewButton.dataset.editSessionReview;
    render();
    return;
  }

  if (event.target.closest("[data-cancel-session-review-edit]")) {
    event.preventDefault();
    state.editingSessionReviewId = null;
    render();
    return;
  }

  const sessionReviewStatusButton = event.target.closest("[data-session-review-status]");
  if (sessionReviewStatusButton) {
    event.preventDefault();
    await runWithLoader("Updating review...", () => setSessionReviewStatus(sessionReviewStatusButton.dataset.sessionReviewStatus, sessionReviewStatusButton.dataset.statusNext));
    return;
  }

  const deleteSessionReviewButton = event.target.closest("[data-delete-session-review]");
  if (deleteSessionReviewButton) {
    event.preventDefault();
    if (!window.confirm("Delete this review? This cannot be undone.")) return;
    await runWithLoader("Deleting review...", () => deleteSessionReview(deleteSessionReviewButton.dataset.deleteSessionReview));
    return;
  }

  if (event.target.closest("[data-refresh-insights]")) {
    event.preventDefault();
    await runWithLoader("Counting...", async () => {
      await Promise.all([
        loadStudents().then((students) => { state.students = students; }).catch((error) => console.warn("Could not load students:", error)),
        loadAdminSessionBookings(),
        loadSessionReviews({ force: true }),
        loadAdminInsights({ force: true })
      ]);
    });
    render();
    return;
  }

  const openBookingModalButton = event.target.closest("[data-open-booking-modal]");
  if (openBookingModalButton) {
    event.preventDefault();
    state.bookingModal = { bookingId: openBookingModalButton.dataset.openBookingModal, action: openBookingModalButton.dataset.bookingAction };
    render();
    window.requestAnimationFrame(() => document.querySelector("[data-booking-modal] input, [data-booking-modal] textarea")?.focus());
    return;
  }

  const requestChangesButton = event.target.closest("[data-request-changes]");
  if (requestChangesButton) {
    event.preventDefault();
    state.reviewModal = { type: requestChangesButton.dataset.requestType, id: requestChangesButton.dataset.requestChanges };
    render();
    window.requestAnimationFrame(() => document.querySelector("[data-review-modal] textarea")?.focus());
    return;
  }

  if (event.target.closest("[data-close-admin-popup]")) {
    event.preventDefault();
    closeAdminPopup();
    return;
  }

  const exportCsvButton = event.target.closest("[data-export-csv]");
  if (exportCsvButton) {
    event.preventDefault();
    exportAdminCsv(exportCsvButton.dataset.exportCsv);
    return;
  }

  // Picking a date or time updates the booking form in place, so a name or
  // note already typed is not lost to a re-render.
  const sessionDateButton = event.target.closest("[data-session-date]");
  if (sessionDateButton) {
    const form = sessionDateButton.closest("[data-session-booking-form]");
    const day = getOpenSessionSlots(state.sessionAvailability, state.takenSessionSlots)
      .find((item) => item.dateKey === sessionDateButton.dataset.sessionDate);
    form.querySelectorAll("[data-session-date]").forEach((button) => {
      const selected = button === sessionDateButton;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
    form.querySelector("[data-session-times]").innerHTML = renderSessionTimeChips(day);
    form.querySelector('[name="slotKey"]').value = "";
    return;
  }

  const sessionSlotButton = event.target.closest("[data-session-slot]");
  if (sessionSlotButton) {
    const form = sessionSlotButton.closest("[data-session-booking-form]");
    form.querySelectorAll("[data-session-slot]").forEach((button) => {
      const selected = button === sessionSlotButton;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
    form.querySelector('[name="slotKey"]').value = sessionSlotButton.dataset.sessionSlot;
    return;
  }

  const withdrawSessionButton = event.target.closest("[data-cancel-session-booking]");
  if (withdrawSessionButton) {
    event.preventDefault();
    if (!window.confirm("Withdraw this session request? The time opens up for others.")) return;
    await runWithLoader("Withdrawing request...", () => withdrawSessionBooking(withdrawSessionButton.dataset.cancelSessionBooking));
    return;
  }

  if (event.target.closest("[data-new-session]")) {
    state.adminType = "sessions";
    state.editingSessionId = null;
    openAdminEditor();
    return;
  }

  const editSessionButton = event.target.closest("[data-edit-session]");
  if (editSessionButton) {
    state.adminType = "sessions";
    state.editingSessionId = editSessionButton.dataset.editSession;
    openAdminEditor();
    return;
  }

  const deleteSessionButton = event.target.closest("[data-delete-session]");
  if (deleteSessionButton) {
    event.preventDefault();
    if (!window.confirm("Delete this session? Its existing bookings stay in Session Bookings.")) return;
    await runWithLoader("Deleting session...", () => deleteSession(deleteSessionButton.dataset.deleteSession));
    return;
  }

  if (event.target.closest("[data-refresh-session-bookings]")) {
    event.preventDefault();
    await runWithLoader("Loading bookings...", async () => {
      await loadAdminSessionBookings();
      await loadTakenSessionSlots({ force: true });
    });
    render();
    return;
  }

  const addSuggestedSessionButton = event.target.closest("[data-add-suggested-session]");
  if (addSuggestedSessionButton) {
    event.preventDefault();
    const suggestionId = addSuggestedSessionButton.dataset.addSuggestedSession;
    await runWithLoader(
      suggestionId === "all" ? "Publishing suggested sessions..." : "Publishing session...",
      () => addSuggestedSessions(suggestionId)
    );
    return;
  }

  if (event.target.closest("[data-hide-session-suggestions]")) {
    setSessionSuggestionsHidden(true);
    render();
    return;
  }

  if (event.target.closest("[data-show-session-suggestions]")) {
    setSessionSuggestionsHidden(false);
    render();
    return;
  }

  if (event.target.closest("[data-merge-courses]")) {
    event.preventDefault();
    if (!window.confirm("Merge the catalogue? The folded courses become drafts and can be published again at any time.")) return;
    await runWithLoader("Merging courses...", () => mergeCourses());
    return;
  }

  const addSuggestedBlogButton = event.target.closest("[data-add-suggested-blog]");
  if (addSuggestedBlogButton) {
    event.preventDefault();
    const suggestionId = addSuggestedBlogButton.dataset.addSuggestedBlog;
    await runWithLoader(
      suggestionId === "all" ? "Publishing posts..." : "Publishing post...",
      () => addSuggestedBlogs(suggestionId)
    );
    return;
  }

  if (event.target.closest("[data-hide-blog-suggestions]")) {
    setBlogSuggestionsHidden(true);
    render();
    return;
  }

  if (event.target.closest("[data-show-blog-suggestions]")) {
    setBlogSuggestionsHidden(false);
    render();
    return;
  }

  const courseCategoryChip = event.target.closest("[data-course-category]");
  if (courseCategoryChip) {
    event.preventDefault();
    const scope = courseCategoryChip.closest("[data-filter-scope]");
    const category = courseCategoryChip.dataset.courseCategory;
    const select = scope?.querySelector("[data-live-category]");
    if (select) select.value = category;
    syncCourseCategoryChips(scope, category);
    applyLiveFilters(scope);
    return;
  }

  const addSuggestedCommunityButton = event.target.closest("[data-add-suggested-community]");
  if (addSuggestedCommunityButton) {
    event.preventDefault();
    const suggestionId = addSuggestedCommunityButton.dataset.addSuggestedCommunity;
    await runWithLoader(
      suggestionId === "all" ? "Adding suggested communities..." : "Adding community...",
      () => addSuggestedCommunities(suggestionId)
    );
    return;
  }

  if (event.target.closest("[data-hide-community-suggestions]")) {
    setCommunitySuggestionsHidden(true);
    render();
    return;
  }

  if (event.target.closest("[data-show-community-suggestions]")) {
    setCommunitySuggestionsHidden(false);
    render();
    return;
  }

  const addSuggestedCourseButton = event.target.closest("[data-add-suggested-course]");
  if (addSuggestedCourseButton) {
    event.preventDefault();
    const suggestionId = addSuggestedCourseButton.dataset.addSuggestedCourse;
    await runWithLoader(
      suggestionId === "all" ? "Publishing suggested courses..." : "Publishing course...",
      () => addSuggestedCourses(suggestionId)
    );
    return;
  }

  if (event.target.closest("[data-hide-course-suggestions]")) {
    setCourseSuggestionsHidden(true);
    render();
    return;
  }

  if (event.target.closest("[data-show-course-suggestions]")) {
    setCourseSuggestionsHidden(false);
    render();
    return;
  }

  const seedCodingProblemsButton = event.target.closest("[data-seed-coding-problems]");
  if (seedCodingProblemsButton) {
    event.preventDefault();
    const confirmed = window.confirm("Seed all current static coding problems into Firestore? Existing problems with the same slug will be updated.");
    if (!confirmed) return;
    await runWithLoader("Seeding coding problems...", seedStaticCodingProblems);
    return;
  }

  if (event.target.closest("[data-new-contributor]")) {
    state.adminType = "contributors";
    openAdminEditor();
    return;
  }

  const contributorLinkButton = event.target.closest("[data-contributor-password-link]");
  if (contributorLinkButton) {
    event.preventDefault();
    await runWithLoader("Sending password link...", () => sendContributorPasswordLink(contributorLinkButton.dataset.contributorPasswordLink));
    return;
  }

  const contributorActiveButton = event.target.closest("[data-contributor-active]");
  if (contributorActiveButton) {
    event.preventDefault();
    const nextActive = contributorActiveButton.dataset.activeNext === "true";
    if (!nextActive && !window.confirm("Remove this person's contributor access? Their drafts stay for you to review.")) return;
    await runWithLoader(
      nextActive ? "Restoring access..." : "Removing access...",
      () => setContributorActive(contributorActiveButton.dataset.contributorActive, nextActive)
    );
    return;
  }

  const tab = event.target.closest("[data-admin-tab]");
  if (tab) {
    if (!state.isAdmin && state.isContributor && !CONTRIBUTOR_ADMIN_TYPES.includes(tab.dataset.adminTab)) return;
    if (!confirmLeaveAdminEditor()) return;
    state.adminType = tab.dataset.adminTab;
    state.editingId = null;
    // "New ..." shortcuts open the section straight into its editor.
    state.adminEditorOpen = Boolean(ADMIN_EDITOR_NOUNS[state.adminType]) && tab.hasAttribute("data-open-editor");
    if (state.adminEditorOpen) {
      state.editingSubjectId = null;
      state.editingEventId = null;
      state.editingCommunityId = null;
    }
    if (state.adminType === "articles") {
      state.activeSubjectId = getActiveAdminSubject()?.id || "";
    } else {
      state.activeSubjectId = "";
    }
    if (state.adminType !== "subjects") state.editingSubjectId = null;
    if (state.adminType !== "communities") state.editingCommunityId = null;
    if (state.adminType !== "events") state.editingEventId = null;
    if (state.adminType !== "sessions") state.editingSessionId = null;
    render();
    if (state.adminType === "students") {
      await refreshAdminStudents();
    }
    if (state.adminType === "settings") {
      await loadClientErrors({ force: true });
      render();
    }
    if (state.adminType === "insights" && state.isAdmin) {
      await loadAdminInsights();
      render();
    }
    if (state.adminType === "comments") {
      await refreshAdminComments();
    }
    if (state.adminType === "communities") {
      await loadCommunities({ force: true });
      await refreshAdminCommunityPosts();
    }
    if (state.adminType === "events") {
      await loadEvents({ force: true });
      render();
    }
    return;
  }

  const sectionSubjectTab = event.target.closest("[data-admin-section-subject]");
  if (sectionSubjectTab) {
    state.activeSubjectId = sectionSubjectTab.dataset.adminSectionSubject;
    state.sectionModal = null;
    render();
    return;
  }

  const openSectionModalButton = event.target.closest("[data-open-section-modal]");
  if (openSectionModalButton) {
    event.preventDefault();
    const subject = getActiveAdminSubject();
    if (subject) {
      const mode = openSectionModalButton.dataset.openSectionModal === "edit" ? "edit" : "add";
      openSectionModal(mode, subject.id, openSectionModalButton.dataset.sectionId || "");
    }
    return;
  }

  if (event.target.closest("[data-close-section-modal]")) {
    event.preventDefault();
    closeSectionModal();
    return;
  }

  const viewStudentButton = event.target.closest("[data-view-student]");
  if (viewStudentButton) {
    event.preventDefault();
    openStudentModal(viewStudentButton.dataset.viewStudent);
    return;
  }

  if (event.target.closest("[data-close-student-modal]")) {
    event.preventDefault();
    closeStudentModal();
    return;
  }

  const subjectTab = event.target.closest("[data-admin-subject]");
  if (subjectTab) {
    state.adminType = "articles";
    state.activeSubjectId = subjectTab.dataset.adminSubject;
    state.editingId = null;
    state.adminEditorOpen = false;
    render();
    return;
  }

  const newItem = event.target.closest("[data-new-item]");
  if (newItem) {
    state.editingId = null;
    openAdminEditor();
    return;
  }

  const closeAdminEditorButton = event.target.closest("[data-close-admin-editor]");
  if (closeAdminEditorButton) {
    event.preventDefault();
    if (confirmLeaveAdminEditor()) closeAdminEditor();
    return;
  }

  const newSubjectButton = event.target.closest("[data-new-subject]");
  if (newSubjectButton) {
    state.adminType = "subjects";
    state.editingSubjectId = null;
    openAdminEditor();
    return;
  }

  const moveSubjectSectionButton = event.target.closest("[data-move-subject-section]");
  if (moveSubjectSectionButton) {
    event.preventDefault();
    await runWithLoader(
      "Updating section order...",
      () => moveExistingSubjectSection(
        moveSubjectSectionButton.dataset.moveSubjectSection,
        moveSubjectSectionButton.dataset.sectionId,
        Number(moveSubjectSectionButton.dataset.moveDirection || 0)
      )
    );
    return;
  }

  const moveButton = event.target.closest("[data-move-item]");
  if (moveButton) {
    const moveLabel = moveButton.dataset.moveType === "subjects" ? "subject" : moveButton.dataset.moveType === "codingProblems" ? "coding problem" : "tutorial";
    await runWithLoader(
      `Updating ${moveLabel} order...`,
      () => moveOrderedItem(
        moveButton.dataset.moveType,
        moveButton.dataset.moveItem,
        Number(moveButton.dataset.moveDirection || 0)
      )
    );
    return;
  }
  const editButton = event.target.closest("[data-edit]");
  if (editButton) {
    state.adminType = editButton.dataset.editType;
    state.editingId = editButton.dataset.edit;
    if (state.adminType === "articles") {
      const item = state.articles.find((article) => article.id === state.editingId);
      const subject = getAdminSubjects().find((candidate) => candidate.title === item?.category);
      state.activeSubjectId = subject?.id || state.activeSubjectId;
    }
    openAdminEditor();
    return;
  }

  const editSubjectButton = event.target.closest("[data-edit-subject]");
  if (editSubjectButton) {
    state.adminType = "subjects";
    state.editingSubjectId = editSubjectButton.dataset.editSubject;
    openAdminEditor();
    return;
  }

  const deleteSubjectSectionButton = event.target.closest("[data-delete-subject-section]");
  if (deleteSubjectSectionButton) {
    event.preventDefault();
    const confirmed = window.confirm("Delete this section? Tutorials assigned to it will move to Unsectioned.");
    if (!confirmed) return;
    await runWithLoader(
      "Deleting section...",
      () => deleteExistingSubjectSection(deleteSubjectSectionButton.dataset.deleteSubjectSection, deleteSubjectSectionButton.dataset.sectionId)
    );
    return;
  }

  const deleteButton = event.target.closest("[data-delete]");
  if (deleteButton) {
    const confirmed = window.confirm("Delete this item?");
    if (!confirmed) return;
    await runWithLoader("Deleting item...", () => deleteItem(deleteButton.dataset.deleteType, deleteButton.dataset.delete));
    return;
  }

  const toggleSubjectPublicButton = event.target.closest("[data-toggle-subject-public]");
  if (toggleSubjectPublicButton) {
    event.preventDefault();
    const nextHidden = toggleSubjectPublicButton.dataset.hiddenNext === "true";
    await runWithLoader(
      nextHidden ? "Hiding subject from public website..." : "Showing subject on public website...",
      () => toggleSubjectPublicVisibility(toggleSubjectPublicButton.dataset.toggleSubjectPublic, nextHidden)
    );
    return;
  }
  const toggleCoursePublicButton = event.target.closest("[data-toggle-course-public]");
  if (toggleCoursePublicButton) {
    event.preventDefault();
    const nextHidden = toggleCoursePublicButton.dataset.hiddenNext === "true";
    await runWithLoader(
      nextHidden ? "Hiding course from public website..." : "Showing course on public website...",
      () => toggleCourseVisibility(toggleCoursePublicButton.dataset.toggleCoursePublic, nextHidden)
    );
    return;
  }

  const deleteSubjectButton = event.target.closest("[data-delete-subject]");
  if (deleteSubjectButton) {
    await runWithLoader("Deleting subject...", () => deleteSubject(deleteSubjectButton.dataset.deleteSubject));
    return;
  }

  const pinInquiryButton = event.target.closest("[data-pin-inquiry]");
  if (pinInquiryButton) {
    await runWithLoader(
      pinInquiryButton.dataset.pinValue === "true" ? "Pinning inquiry..." : "Unpinning inquiry...",
      () => toggleInquiryPin(pinInquiryButton.dataset.pinInquiry, pinInquiryButton.dataset.pinValue === "true")
    );
    return;
  }
  const signOutButton = event.target.closest("[data-signout]");
  if (signOutButton) {
    await runWithLoader("Signing out...", () => signOutAdmin());
  }
}

function appendCodingMetaRow(button) {
  const listName = button.dataset.addCodingMetaRow;
  const rows = button.closest(".coding-meta-card")?.querySelector(`[data-coding-meta-rows="${listName}"]`);
  if (!rows) return;
  const nextIndex = rows.querySelectorAll("[data-coding-meta-row]").length;
  rows.insertAdjacentHTML("beforeend", renderCodingMetaRow(listName, { label: "", order: nextIndex + 1 }, nextIndex));
  rows.querySelector("[data-coding-meta-row]:last-child input:not([type='hidden'])")?.focus();
}

function removeCodingMetaRow(button) {
  const rows = button.closest("[data-coding-meta-rows]");
  const row = button.closest("[data-coding-meta-row]");
  if (!rows || !row) return;
  const allRows = [...rows.querySelectorAll("[data-coding-meta-row]")];
  if (allRows.length <= 1) {
    row.querySelectorAll("input").forEach((input) => {
      input.value = input.name.endsWith("Order") ? "1" : "";
    });
    return;
  }
  row.remove();
  resequenceCodingMetaRows(rows);
}

function resequenceCodingMetaRows(rows) {
  rows.querySelectorAll("[data-coding-meta-row]").forEach((row, index) => {
    const orderInput = row.querySelector("input[name$='Order']");
    if (orderInput) orderInput.value = String(index + 1);
  });
}
function handlePointerMove(event) {
  if (!richImageResizeState) return;

  event.preventDefault();
  const { form, figure, image, startX, startWidth, editorWidth } = richImageResizeState;
  const delta = event.clientX - startX;
  const nextWidth = clamp(((startWidth + delta) / editorWidth) * 100, 24, 100);
  setRichImageWidth(image, nextWidth);
  positionRichResizeHandle(figure);
  syncRichEditor(form);
}

function handlePointerUp() {
  if (!richImageResizeState) return;

  const { handle, form, figure } = richImageResizeState;
  handle.releasePointerCapture?.(richImageResizeState.pointerId);
  richImageResizeState = null;
  positionRichResizeHandle(figure);
  syncRichEditor(form);
}

async function handleSubmit(event) {
  const inquiryForm = event.target.closest("[data-inquiry-form]");
  if (inquiryForm) {
    event.preventDefault();
    const result = await runWithLoader("Submitting inquiry...", () => saveInquiry(new FormData(inquiryForm)));
    if (result) {
      inquiryForm.reset();
      showToast("Course inquiry submitted. We will get back to you soon.");
      if (!result.emailQueued) console.warn("Course inquiry saved, but the notification email was not queued.");
    }
    return;
  }

  const studentLoginForm = event.target.closest("[data-student-login-form]");
  if (studentLoginForm) {
    event.preventDefault();
    const formData = new FormData(studentLoginForm);
    await runWithLoader("Logging in...", () => signInStudent(formData.get("email"), formData.get("password")));
    return;
  }

  const studentRegisterForm = event.target.closest("[data-student-register-form]");
  if (studentRegisterForm) {
    event.preventDefault();
    await runWithLoader("Creating student account...", () => registerStudent(new FormData(studentRegisterForm)));
    return;
  }

  const studentProfileForm = event.target.closest("[data-student-profile-form]");
  if (studentProfileForm) {
    event.preventDefault();
    await runWithLoader("Saving profile...", () => updateStudentProfile(new FormData(studentProfileForm)));
    return;
  }

  const discussionForm = event.target.closest("[data-discussion-form]");
  if (discussionForm) {
    event.preventDefault();
    const scope = discussionForm.closest("[data-discussion-scope]");
    if (!scope) return;
    const formData = new FormData(discussionForm);
    await runWithLoader("Posting comment...", () => postDiscussionComment({
      contentType: scope.dataset.contentType,
      contentId: scope.dataset.contentId,
      contentTitle: scope.dataset.contentTitle,
      body: formData.get("body")
    }));
    discussionForm.reset();
    return;
  }

  const discussionReplyForm = event.target.closest("[data-discussion-reply-form]");
  if (discussionReplyForm) {
    event.preventDefault();
    const scope = discussionReplyForm.closest("[data-discussion-scope]");
    if (!scope) return;
    const formData = new FormData(discussionReplyForm);
    await runWithLoader("Posting reply...", () => postDiscussionComment({
      contentType: scope.dataset.contentType,
      contentId: scope.dataset.contentId,
      contentTitle: scope.dataset.contentTitle,
      body: formData.get("body"),
      parentId: discussionReplyForm.dataset.parentId
    }));
    return;
  }

  const communityDiscussionForm = event.target.closest("[data-community-discussion-form]");
  if (communityDiscussionForm) {
    event.preventDefault();
    const scope = communityDiscussionForm.closest("[data-community-scope]");
    if (!scope) return;
    const formData = new FormData(communityDiscussionForm);
    await runWithLoader("Posting...", () => postCommunityMessage({
      communityId: scope.dataset.communityId,
      body: formData.get("body")
    }));
    communityDiscussionForm.reset();
    return;
  }

  const communityDiscussionReplyForm = event.target.closest("[data-community-discussion-reply-form]");
  if (communityDiscussionReplyForm) {
    event.preventDefault();
    const scope = communityDiscussionReplyForm.closest("[data-community-scope]");
    if (!scope) return;
    const formData = new FormData(communityDiscussionReplyForm);
    await runWithLoader("Posting reply...", () => postCommunityMessage({
      communityId: scope.dataset.communityId,
      body: formData.get("body"),
      parentId: communityDiscussionReplyForm.dataset.parentId
    }));
    return;
  }

  const loginForm = event.target.closest("[data-login-form]");
  if (loginForm) {
    event.preventDefault();
    const formData = new FormData(loginForm);
    await runWithLoader("Signing in...", () => signInAdmin(formData.get("email"), formData.get("password")));
    return;
  }

  const resetPasswordForm = event.target.closest("[data-reset-password-form]");
  if (resetPasswordForm) {
    event.preventDefault();
    await runWithLoader("Sending password reset email...", () => sendAdminPasswordReset(new FormData(resetPasswordForm).get("email")));
    return;
  }

  const siteNavigationForm = event.target.closest("[data-site-navigation-form]");
  if (siteNavigationForm) {
    event.preventDefault();
    await runWithLoader("Saving tab visibility...", () => saveSiteNavigation(siteNavigationPayload(new FormData(siteNavigationForm))));
    return;
  }
  const changePasswordForm = event.target.closest("[data-change-password-form]");
  if (changePasswordForm) {
    event.preventDefault();
    await runWithLoader("Updating password...", () => changeAdminPassword(new FormData(changePasswordForm)));
    return;
  }

  const codingMetaForm = event.target.closest("[data-coding-meta-form]");
  if (codingMetaForm) {
    event.preventDefault();
    let payload;
    try {
      payload = codingMetaPayload(new FormData(codingMetaForm));
    } catch (error) {
      showToast(error.message);
      return;
    }
    await runWithLoader("Saving coding setup...", () => saveCodingMeta(payload));
    return;
  }
  const existingSubjectSectionUpdateForm = event.target.closest("[data-existing-subject-section-update-form]");
  if (existingSubjectSectionUpdateForm) {
    event.preventDefault();
    await runWithLoader("Updating section...", () => updateExistingSubjectSection(new FormData(existingSubjectSectionUpdateForm)));
    return;
  }

  const existingSubjectSectionForm = event.target.closest("[data-existing-subject-section-form]");
  if (existingSubjectSectionForm) {
    event.preventDefault();
    const saved = await runWithLoader("Adding section to subject...", () => addSectionToExistingSubject(new FormData(existingSubjectSectionForm)));
    if (saved) existingSubjectSectionForm.reset();
    return;
  }

  const subjectForm = event.target.closest("[data-subject-form]");
  if (subjectForm) {
    event.preventDefault();
    const formData = new FormData(subjectForm);
    if (String(formData.get("coverImage") || "").trim()) {
      const coverIsReady = await canLoadImage(formData.get("coverImage"));
      if (!coverIsReady) {
        showToast("Subject image must be a direct image URL. Upload to Firebase Storage, wait for preview, then save.");
        return;
      }
    }
    const saved = await runWithLoader("Saving subject...", () => saveSubject(subjectPayload(formData)));
    if (saved) {
      subjectForm.reset();
      updateCoverPreview(subjectForm, "");
      if (state.adminEditorOpen) closeAdminEditor();
    }
    return;
  }

  const policyForm = event.target.closest("[data-community-policy-form]");
  if (policyForm) {
    event.preventDefault();
    const formData = new FormData(policyForm);
    await runWithLoader("Saving community policy...", () => saveCommunityPolicy(formData.get("body")));
    render();
    return;
  }

  const deleteAccountForm = event.target.closest("[data-delete-account-form]");
  if (deleteAccountForm) {
    event.preventDefault();
    if (!window.confirm("Delete your account and everything attached to it? This can't be undone.")) return;
    const password = String(new FormData(deleteAccountForm).get("password") || "");
    await runWithLoader("Deleting your account...", () => deleteStudentAccount(password));
    return;
  }

  const eventForm = event.target.closest("[data-event-form]");
  if (eventForm) {
    event.preventDefault();
    const formData = new FormData(eventForm);
    const saved = await runWithLoader("Saving event...", () => saveEvent(eventPayload(formData)));
    if (saved && state.adminEditorOpen) closeAdminEditor();
    return;
  }

  const eventMeetingForm = event.target.closest("[data-event-meeting-form]");
  if (eventMeetingForm) {
    event.preventDefault();
    const formData = new FormData(eventMeetingForm);
    await runWithLoader("Saving meeting link...", () => saveEventMeeting(
      eventMeetingForm.dataset.eventMeetingForm,
      formData.get("meetingLink"),
      formData.get("meetingNote")
    ));
    return;
  }

  const bookingModalForm = event.target.closest("[data-booking-modal-form]");
  if (bookingModalForm) {
    event.preventDefault();
    await runWithLoader("Updating booking...", () => respondToSessionBooking(new FormData(bookingModalForm)));
    return;
  }

  const reviewModalForm = event.target.closest("[data-review-modal-form]");
  if (reviewModalForm) {
    event.preventDefault();
    const modal = state.reviewModal;
    const formData = new FormData(reviewModalForm);
    if (modal) {
      await runWithLoader("Sending it back...", () => requestContributionChanges(modal.type, modal.id, formData.get("note"), formData.get("notify") === "on"));
    }
    return;
  }

  const sessionForm = event.target.closest("[data-session-form]");
  if (sessionForm) {
    event.preventDefault();
    const saved = await runWithLoader("Saving session...", () => saveSession(sessionPayload(new FormData(sessionForm))));
    if (saved && state.adminEditorOpen) closeAdminEditor();
    return;
  }

  const sessionAvailabilityForm = event.target.closest("[data-session-availability-form]");
  if (sessionAvailabilityForm) {
    event.preventDefault();
    await runWithLoader("Saving availability...", () => saveSessionAvailability(new FormData(sessionAvailabilityForm)));
    return;
  }

  const sessionReviewForm = event.target.closest("[data-session-review-form]");
  if (sessionReviewForm) {
    event.preventDefault();
    await runWithLoader("Saving your review...", () => saveSessionReview(sessionReviewForm.dataset.sessionReviewForm, new FormData(sessionReviewForm)));
    return;
  }

  const sessionBookingForm = event.target.closest("[data-session-booking-form]");
  if (sessionBookingForm) {
    event.preventDefault();
    await runWithLoader("Sending your request...", () => requestSessionBooking(sessionBookingForm.dataset.sessionBookingForm, new FormData(sessionBookingForm)));
    return;
  }

  const contributorProfileForm = event.target.closest("[data-contributor-profile-form]");
  if (contributorProfileForm) {
    event.preventDefault();
    await runWithLoader("Saving profile...", () => saveContributorProfile(contributorProfilePayload(new FormData(contributorProfileForm))));
    return;
  }

  const contributorForm = event.target.closest("[data-contributor-form]");
  if (contributorForm) {
    event.preventDefault();
    const saved = await runWithLoader("Adding contributor...", () => saveContributor(contributorPayload(new FormData(contributorForm))));
    if (saved && state.adminEditorOpen) closeAdminEditor();
    return;
  }

  const communityForm = event.target.closest("[data-community-form]");
  if (communityForm) {
    event.preventDefault();
    const formData = new FormData(communityForm);
    const saved = await runWithLoader("Saving community...", () => saveCommunity(communityPayload(formData)));
    if (saved && state.adminEditorOpen) closeAdminEditor();
    return;
  }

  const adminForm = event.target.closest("[data-admin-form]");
  if (adminForm) {
    event.preventDefault();
    syncRichEditor(adminForm);
    const formData = new FormData(adminForm);
    const type = adminForm.dataset.contentType;
    if (type === "articles" && !String(formData.get("category") || "").trim()) {
      showToast("Choose a subject before saving the tutorial.");
      return;
    }
    if ((type === "articles" || type === "blogs") && String(formData.get("youtubeUrl") || "").trim() && !getYouTubeEmbedUrl(formData.get("youtubeUrl"))) {
      showToast("Use a valid YouTube link or leave it blank.");
      return;
    }
    if ((type === "tutorials" || type === "blogs") && String(formData.get("coverImage") || "").trim()) {
      const coverIsReady = await canLoadImage(formData.get("coverImage"));
      if (!coverIsReady) {
        showToast(`${type === "blogs" ? "Blog" : "Course"} image must be a direct image URL. Upload to Firebase Storage, wait for preview, then save.`);
        return;
      }
    }
    if ((type === "articles" || type === "blogs") && !hasRichContent(formData.get("body"))) {
      showToast(`Add ${type === "blogs" ? "blog" : "tutorial"} body content before saving.`);
      return;
    }
    let payload;
    try {
      payload = type === "articles"
        ? articlePayload(formData)
        : type === "blogs"
          ? blogPayload(formData)
          : type === "codingProblems"
            ? codingProblemPayload(formData)
            : tutorialPayload(formData);
    } catch (error) {
      showToast(error.message);
      return;
    }
    // "Save and close" returns to the list; "Save and keep editing" stays on
    // the editor with the saved item loaded.
    const keepEditing = Boolean(event.submitter?.hasAttribute("data-keep-editing"));
    const saved = await runWithLoader(`Saving ${getContentTypeLabel(type).toLowerCase()}...`, () => saveItem(type, payload));
    if (saved && state.adminEditorOpen && !keepEditing) {
      closeAdminEditor();
    }
  }
}

async function saveInquiry(formData) {
  const inquiry = buildInquiryPayload(formData);
  let emailQueued = false;

  if (state.firebaseEnabled) {
    const { collection, doc, setDoc, writeBatch } = firebase.api;
    const inquiryRef = doc(firebase.db, "courseInquiries", inquiry.id);

    try {
      const queuedInquiry = { ...inquiry, emailQueued: true };
      const mailRef = doc(collection(firebase.db, "mail"));
      const batch = writeBatch(firebase.db);
      batch.set(inquiryRef, queuedInquiry);
      batch.set(mailRef, buildInquiryEmailDocument(queuedInquiry));
      await batch.commit();
      emailQueued = true;
    } catch (error) {
      console.warn("Could not queue inquiry email with inquiry:", error);
      await setDoc(inquiryRef, inquiry);
    }
  } else {
    const inquiries = [inquiry, ...readInquiries()].filter((item) => !isInquiryExpired(item)).slice(0, 100);
    persistLocalInquiries(inquiries);
    state.inquiries = inquiries.sort(sortInquiries);
  }

  return { inquiry: { ...inquiry, emailQueued }, emailQueued };
}

function buildInquiryPayload(formData) {
  const now = new Date().toISOString();
  const inquiry = normalizeInquiry({
    id: `inquiry-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    name: formData.get("name"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    course: formData.get("course"),
    city: formData.get("city"),
    goal: formData.get("goal"),
    message: formData.get("message"),
    source: "website",
    status: "new",
    pinned: false,
    emailQueued: false,
    createdAt: now,
    updatedAt: now
  });

  if (!inquiry.name || !inquiry.email || !inquiry.phone || !inquiry.course) {
    throw new Error("Fill name, email, phone, and interested course before submitting.");
  }

  return inquiry;
}


function buildInquiryEmailDocument(inquiry) {
  return {
    to: [INQUIRY_EMAIL],
    replyTo: inquiry.email,
    inquiryId: inquiry.id,
    createdAt: inquiry.createdAt,
    message: {
      subject: `New course inquiry: ${inquiry.course || inquiry.name}`,
      text: formatInquiryEmailText(inquiry),
      html: formatInquiryEmailHtml(inquiry)
    }
  };
}

function formatInquiryEmailText(inquiry) {
  return [
    "New SkillUp Class course inquiry",
    "",
    `Name: ${inquiry.name}`,
    `Email: ${inquiry.email}`,
    `Phone: ${inquiry.phone}`,
    `Interested course: ${inquiry.course}`,
    `City: ${inquiry.city || "Not provided"}`,
    `Learning goal: ${inquiry.goal || "Not provided"}`,
    `Submitted: ${formatDate(inquiry.createdAt)}`,
    "",
    "Message:",
    inquiry.message || "Not provided"
  ].join("\n");
}

function formatInquiryEmailHtml(inquiry) {
  const rows = [
    ["Name", inquiry.name],
    ["Email", inquiry.email],
    ["Phone", inquiry.phone],
    ["Interested course", inquiry.course],
    ["City", inquiry.city || "Not provided"],
    ["Learning goal", inquiry.goal || "Not provided"],
    ["Submitted", formatDate(inquiry.createdAt)]
  ];

  return `
    <h2>New SkillUp Class course inquiry</h2>
    <table cellpadding="8" cellspacing="0" style="border-collapse:collapse;border:1px solid #d9e2ec;">
      ${rows.map(([label, value]) => `<tr><td style="border:1px solid #d9e2ec;font-weight:bold;">${escapeHtml(label)}</td><td style="border:1px solid #d9e2ec;">${escapeHtml(value)}</td></tr>`).join("")}
    </table>
    <h3>Message</h3>
    <p>${escapeHtml(inquiry.message || "Not provided").replace(/\n/g, "<br>")}</p>
  `;
}

function readInquiries() {
  try {
    const stored = JSON.parse(localStorage.getItem(INQUIRY_STORAGE_KEY));
    const inquiries = Array.isArray(stored) ? stored.map(normalizeInquiry).filter((item) => !isInquiryExpired(item)) : [];
    persistLocalInquiries(inquiries);
    return inquiries;
  } catch {
    localStorage.removeItem(INQUIRY_STORAGE_KEY);
    return [];
  }
}

function persistLocalInquiries(inquiries) {
  localStorage.setItem(INQUIRY_STORAGE_KEY, JSON.stringify(inquiries.map(normalizeInquiry).sort(sortInquiries).slice(0, 100)));
}

async function toggleInquiryPin(id, pinned) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return;
  }

  const updatedAt = new Date().toISOString();
  const update = { pinned, pinnedAt: pinned ? updatedAt : "", updatedAt };

  if (state.firebaseEnabled) {
    await firebase.api.setDoc(firebase.api.doc(firebase.db, "courseInquiries", id), update, { merge: true });
    await loadContent({ admin: true });
  } else {
    state.inquiries = state.inquiries
      .map((inquiry) => inquiry.id === id ? normalizeInquiry({ ...inquiry, ...update }) : inquiry)
      .filter((inquiry) => !isInquiryExpired(inquiry))
      .sort(sortInquiries);
    persistLocalInquiries(state.inquiries);
  }

  showToast(pinned ? "Inquiry pinned." : "Inquiry unpinned.");
  render();
}
function handleInput(event) {
  const adminEditorForm = event.target.closest("[data-admin-editor] form");
  if (adminEditorForm) adminEditorForm.dataset.dirty = "true";

  const richEditor = event.target.closest("[data-rich-editor]");
  if (richEditor) {
    saveRichSelection(richEditor);
    syncRichEditor(richEditor.closest("[data-admin-form]"));
    return;
  }

  const codeEditor = event.target.closest("[data-code-editor]");
  if (codeEditor) {
    persistCodingPracticeEditor(codeEditor);
    syncCodingPracticeHighlight(codeEditor);
    return;
  }

  const coverUrlInput = event.target.closest("[data-cover-url]");
  if (coverUrlInput) {
    const form = coverUrlInput.closest("[data-admin-form], [data-subject-form]");
    const storagePath = form?.querySelector('input[name="coverImagePath"]');
    if (storagePath) storagePath.value = "";
    updateCoverPreview(form, coverUrlInput.value);
    return;
  }

  if (event.target.matches("[data-live-search], [data-live-category]")) {
    const scope = event.target.closest("[data-filter-scope]");
    applyLiveFilters(scope);
    if (event.target.matches("[data-live-category]")) syncCourseCategoryChips(scope, event.target.value);
    return;
  }

  if (event.target.matches("[data-coding-practice-search], [data-coding-practice-kind], [data-coding-practice-difficulty], [data-coding-practice-company], [data-coding-practice-status]")) {
    applyCodingPracticeFilters(event.target.closest("[data-coding-practice-scope]"));
    return;
  }

  if (event.target.matches("[data-practice-search], [data-practice-difficulty], [data-practice-company], [data-practice-status]")) {
    applyPracticeFilters(event.target.closest("[data-practice-scope]"));
    return;
  }

  if (event.target.matches("[data-coding-search], [data-coding-difficulty]")) {
    applyCodingRoundFilters(event.target.closest("[data-coding-scope]"));
    return;
  }

  const siteSearch = event.target.closest("[data-site-search]");
  if (siteSearch) {
    applySiteSearch(siteSearch);
    return;
  }

  const adminSearch = event.target.closest("[data-admin-search]");
  if (adminSearch) applyAdminSearch(adminSearch);
}

function applyAdminSearch(input) {
  const scope = input.closest(".admin-card, .subject-admin-panel") || document;
  const search = input.value.trim().toLowerCase();
  scope.querySelectorAll("[data-admin-search-item]").forEach((item) => {
    item.hidden = Boolean(search) && !matchesSearch(item.dataset.search, search);
  });
  scope.querySelectorAll("[data-admin-search-group]").forEach((group) => {
    const items = [...group.querySelectorAll("[data-admin-search-item]")];
    group.hidden = Boolean(search) && items.length > 0 && items.every((item) => item.hidden);
  });
}

function handlePaste(event) {
  const editor = event.target.closest("[data-rich-editor]");
  if (!editor) return;

  const codeBlockHtml = getPastedCodeBlockHtml(event.clipboardData);
  if (!codeBlockHtml) return;

  event.preventDefault();
  restoreRichSelection(editor);
  const inserted = document.execCommand("insertHTML", false, codeBlockHtml);
  if (!inserted) editor.insertAdjacentHTML("beforeend", codeBlockHtml);
  syncRichEditor(editor.closest("[data-admin-form]"));
}

function getPastedCodeBlockHtml(clipboardData) {
  const html = clipboardData?.getData("text/html") || "";
  const plainText = normalizePastedPlainText(clipboardData?.getData("text/plain") || "");
  const mixedPasteHtml = getMixedTutorialPasteHtml(plainText);
  const markdownPasteHtml = mixedPasteHtml ? "" : getMarkdownTutorialPasteHtml(plainText);

  if (mixedPasteHtml || markdownPasteHtml) return mixedPasteHtml || markdownPasteHtml;

  if (!html) {
    return isLikelyCodeSnippet(plainText) ? buildHighlightedCodeBlockHtml(plainText) : "";
  }

  const template = document.createElement("template");
  template.innerHTML = html;
  template.content.querySelectorAll("script, style, meta, link").forEach((node) => node.remove());

  const root = findPastedCodeRoot(template.content, html, plainText);
  if (!root) {
    return isLikelyCodeSnippet(plainText) ? buildHighlightedCodeBlockHtml(plainText) : "";
  }

  const codeText = getPastedCodeText(root, plainText);
  if (!codeText.trim()) return "";

  const preStyle = getAllowedCodeBlockStyle(root);
  const codeHtml = hasColoredCodeMarkup(root)
    ? getPastedCodeInnerHtml(root)
    : renderHighlightedCode(codeText, getPastedCodeLanguage(root, html) || inferCodeLanguage(codeText));

  if (!codeHtml.trim()) return "";
  return `<pre${preStyle ? ` style="${escapeAttr(preStyle)}"` : ""}><code>${codeHtml}</code></pre><p><br></p>`;
}

function buildHighlightedCodeBlockHtml(rawCode, language = "") {
  const fenced = parseMarkdownCodeFence(rawCode);
  const code = normalizePastedPlainText(fenced ? fenced.code : rawCode).trimEnd();
  if (!code.trim()) return "";
  const codeLanguage = language || fenced?.language || inferCodeLanguage(code);
  return `<pre><code>${renderHighlightedCode(code, codeLanguage)}</code></pre><p><br></p>`;
}

function getMarkdownTutorialPasteHtml(text) {
  const value = normalizeMarkdownPasteText(text).trim();
  if (!value || !isMarkdownFormattedPaste(value)) return "";
  const html = renderMarkdown(value).trim();
  return html ? html + "<p><br></p>" : "";
}

function normalizeMarkdownPasteText(text) {
  const lines = normalizePastedPlainText(text).split("\n");
  const normalized = [];

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];
    if (line.trim()) {
      normalized.push(line);
      continue;
    }

    const previous = [...normalized].reverse().find((item) => item.trim()) || "";
    const next = lines.slice(index + 1).find((item) => item.trim()) || "";
    if (isMarkdownTableLine(previous) && isMarkdownTableLine(next)) continue;

    normalized.push(line);
  }

  return normalized.join("\n");
}

function isMarkdownFormattedPaste(text) {
  const value = normalizeMarkdownPasteText(text);
  const lines = value.split("\n");
  return Boolean(
    /^#{1,4}\s+\S/m.test(value) ||
    /^```/m.test(value.trim()) ||
    /^!\[[^\]]*\]\([^\s)]+/m.test(value) ||
    lines.some((_, index) => isMarkdownTableStart(lines, index))
  );
}

function isMarkdownTableLine(line) {
  const value = String(line || "").trim();
  if (!value.includes("|")) return false;
  const cells = splitMarkdownRow(value);
  return cells.length > 1 && cells.some((cell) => cell.trim());
}

function getMixedTutorialPasteHtml(text) {
  const blocks = parseMixedTutorialPasteBlocks(text);
  if (!blocks.length) return "";

  const hasText = blocks.some((block) => block.type === "text");
  const hasCode = blocks.some((block) => block.type === "code");
  if (!hasText || !hasCode) return "";

  return blocks.map(renderMixedTutorialPasteBlock).join("") + "<p><br></p>";
}

function parseMixedTutorialPasteBlocks(text) {
  const lines = normalizeMarkdownPasteText(text).split("\n");
  const blocks = [];
  let pendingLines = [];

  const flushPendingLines = () => {
    splitPasteTextBlocks(pendingLines).forEach((blockLines) => {
      const value = blockLines.join("\n").trimEnd();
      if (!value.trim()) return;
      blocks.push({
        type: isPasteCodeBlock(blockLines) ? "code" : "text",
        value
      });
    });
    pendingLines = [];
  };

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];
    const fenceMatch = line.trim().match(/^```\s*([a-z0-9_+#.-]*)/i);

    if (!fenceMatch) {
      pendingLines.push(line);
      continue;
    }

    flushPendingLines();
    const language = normalizeCodeLanguage(fenceMatch[1] || "");
    const codeLines = [];
    index += 1;

    while (index < lines.length && !lines[index].trim().startsWith("```")) {
      codeLines.push(lines[index]);
      index += 1;
    }

    const value = codeLines.join("\n").trimEnd();
    if (value.trim()) {
      blocks.push({
        type: "code",
        value,
        language
      });
    }
  }

  flushPendingLines();
  return blocks;
}

function splitPasteTextBlocks(lines) {
  const blocks = [];
  let block = [];

  lines.forEach((line) => {
    if (line.trim()) {
      block.push(line);
      return;
    }

    if (block.length) {
      blocks.push(block);
      block = [];
    }
  });

  if (block.length) blocks.push(block);
  return blocks;
}

function isPasteCodeBlock(lines) {
  const nonEmptyLines = lines.filter((line) => line.trim());
  if (!nonEmptyLines.length) return false;

  const codeLines = nonEmptyLines.filter(isLikelyCodeLine);
  if (!codeLines.length) return false;
  if (codeLines.length === nonEmptyLines.length) return true;
  if (codeLines.length >= Math.ceil(nonEmptyLines.length * 0.7)) return true;

  const combined = nonEmptyLines.join("\n");
  return codeLines.length >= 2 && isLikelyCodeSnippet(combined) && !looksLikePasteProse(combined);
}

function isLikelyCodeLine(line) {
  const value = String(line || "").trim();
  if (!value) return false;
  if (looksLikePasteHeading(value)) return false;
  if (/^[)}\]}]$/.test(value)) return true;
  if (/^(import|export|from|const|let|var|function|class|interface|object|data\s+class|sealed\s+class|def|return|if|else|elif|for|while|try|catch|public|private|protected|package|fun|val|override|suspend|print\(|println\(|console\.|System\.out)/i.test(value)) return true;
  if (/^[A-Za-z_$][\w$]*\s*=\s*[^=]/.test(value)) return true;
  if (/^[A-Za-z_$][\w$]*\s*:\s*[A-Za-z_$][\w$<>,.?]*/.test(value)) return true;
  if (/[{};]/.test(value) && /[A-Za-z_$]/.test(value)) return true;
  if (/[A-Za-z_$][\w$]*\([^)]*\)/.test(value) && !/[.!?]$/.test(value)) return true;
  return false;
}

function looksLikePasteHeading(line) {
  const value = String(line || "").trim();
  return /^\d+[.)]\s+\S/.test(value) || /^[A-Z][\w\s/+-]{1,70}:$/.test(value);
}

function looksLikePasteProse(text) {
  return /[.!?]\s+[A-Z]/.test(text) || /\b(means|because|instead|example|problem|simple|hard to|class becomes)\b/i.test(text);
}

function renderMixedTutorialPasteBlock(block) {
  if (block.type === "code") {
    const language = block.language || inferCodeLanguage(block.value);
    if (language === "mermaid" || isMermaidDiagramText(block.value)) {
      return renderMermaidSourceBlock(block.value);
    }
    return `<pre><code>${renderHighlightedCode(block.value, language)}</code></pre>`;
  }

  if (isMarkdownFormattedPaste(block.value)) return renderMarkdown(block.value);

  return block.value
    .split("\n")
    .filter((line) => line.trim())
    .map(renderMixedTutorialTextLine)
    .join("");
}

function renderMixedTutorialTextLine(line) {
  const value = line.trim();
  if (/^####\s+\S/.test(value)) return `<h4>${formatInline(value.replace(/^####\s+/, ""))}</h4>`;
  if (/^###\s+\S/.test(value)) return `<h3>${formatInline(value.replace(/^###\s+/, ""))}</h3>`;
  if (/^##\s+\S/.test(value)) return `<h2>${formatInline(value.replace(/^##\s+/, ""))}</h2>`;
  if (/^#\s+\S/.test(value)) return `<h1>${formatInline(value.replace(/^#\s+/, ""))}</h1>`;
  if (/^\d+[.)]\s+\S/.test(value)) return `<h2>${formatInline(value)}</h2>`;
  if (/^[A-Z][\w\s/+-]{1,70}:$/.test(value)) return `<p><strong>${escapeHtml(value)}</strong></p>`;
  return `<p>${formatInline(value)}</p>`;
}
function findPastedCodeRoot(content, html, plainText) {
  const explicitCode = content.querySelector("pre, code, .hljs, .shiki, .highlight, [class*='language-'], [class*='token']");
  if (explicitCode) return explicitCode;

  const lowerHtml = String(html || "").toLowerCase();
  const hasAiCodeHint = /chatgpt|openai|claude|anthropic|gemini|bard|copilot|perplexity|code-block|highlight|language-/.test(lowerHtml);
  const hasCodeEditorHint = /vscode|monaco|cascadia|consolas|menlo|source code|fira code|jetbrains mono|courier|monospace|hljs|prism|shiki/.test(lowerHtml);
  const hasMultipleLines = String(plainText || "").split(/\r\n|\r|\n/).length > 1;
  if (!(hasAiCodeHint || hasCodeEditorHint) || !hasMultipleLines) return null;

  const coloredRoot = [...content.querySelectorAll("div, span, table, tbody, tr, td")]
    .find((node) => hasSyntaxColorStyles(node));
  return coloredRoot?.closest("div, table, pre") || coloredRoot || content.firstElementChild;
}

function getPastedCodeText(root, fallbackText = "") {
  const text = normalizePastedPlainText(root?.textContent || fallbackText || "");
  return text || normalizePastedPlainText(fallbackText || "");
}

function getPastedCodeInnerHtml(root) {
  const clone = root.cloneNode(true);
  clone.querySelectorAll("script, style, meta, link").forEach((node) => node.remove());

  if (clone.matches?.("pre") || clone.matches?.("code")) {
    return clone.innerHTML;
  }

  return clone.innerHTML || escapeHtml(clone.textContent || "");
}

function getPastedCodeLanguage(root, html = "") {
  const classText = [root?.className || "", root?.querySelector?.("[class*='language-'], [class*='lang-']")?.className || "", html || ""].join(" ");
  const classMatch = String(classText).match(/(?:language|lang)-([a-z0-9_+#.-]+)/i);
  const dataLanguage = root?.getAttribute?.("data-language") || root?.querySelector?.("[data-language]")?.getAttribute("data-language") || "";
  return normalizeCodeLanguage(classMatch?.[1] || dataLanguage);
}

function parseMarkdownCodeFence(text) {
  const match = String(text || "").trim().match(/^```\s*([a-z0-9_+#.-]*)[^\n]*\n([\s\S]*?)\n?```$/i);
  return match ? { language: normalizeCodeLanguage(match[1]), code: match[2] } : null;
}

function normalizePastedPlainText(text) {
  return String(text || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
}

function hasSyntaxColorStyles(element) {
  return Boolean(getAllowedCssColor(element.style?.color) || getAllowedCssColor(element.style?.backgroundColor));
}

function hasColoredCodeMarkup(root) {
  return Boolean(hasSyntaxColorStyles(root) || root?.querySelector?.("[style*='color'], [style*='background-color']"));
}

function getAllowedCodeBlockStyle(element) {
  const color = getAllowedCssColor(element?.style?.color);
  const backgroundColor = getAllowedCssColor(element?.style?.backgroundColor);
  return [
    color ? `color: ${color};` : "",
    backgroundColor ? `background-color: ${backgroundColor};` : ""
  ].filter(Boolean).join(" ");
}

function isLikelyCodeSnippet(text) {
  const value = normalizePastedPlainText(text).trim();
  if (!value) return false;
  if (parseMarkdownCodeFence(value)) return true;

  const lines = value.split("\n").filter((line) => line.trim());
  const codePattern = /^\s*(import|export|from|const|let|var|function|class|def|return|if|else|elif|for|while|try|catch|public|private|protected|package|fun|val|override|SELECT|INSERT|UPDATE|DELETE|CREATE|<\/?[a-z][\w:-]*|[#.]?[\w-]+\s*\{|console\.|print\(|println\(|System\.out)/i;
  const operatorPattern = /[{}()[\];=<>]|=>|:\s*[^\s]/;
  const codeLines = lines.filter((line) => codePattern.test(line) || operatorPattern.test(line)).length;
  return codeLines >= Math.min(2, lines.length) || (lines.length === 1 && codeLines === 1 && /[;{}()=<>]/.test(value));
}

function inferCodeLanguage(text) {
  const value = normalizePastedPlainText(text);
  const fenced = parseMarkdownCodeFence(value);
  if (fenced?.language) return fenced.language;
  if (/^\s*</m.test(value) && /<\/?[a-z][\w:-]*(\s|>|\/)/i.test(value)) return "html";
  if (/\b(SELECT|INSERT|UPDATE|DELETE|CREATE|ALTER|DROP)\b[\s\S]*\b(FROM|TABLE|WHERE|VALUES|SET)\b/i.test(value)) return "sql";
  if (/^\s*(def|from|import|print\(|elif|except|with|async\s+def)\b/m.test(value)) return "python";
  if (/\b(fun|val|override|suspend|data class|sealed class)\b/.test(value)) return "kotlin";
  if (/\b(public|private|protected)\s+(class|static|void)|System\.out|package\s+[\w.]+;/.test(value)) return "java";
  if (/^\s*[.#]?[\w-]+\s*\{[\s\S]*?:[\s\S]*?;[\s\S]*?\}/m.test(value)) return "css";
  if (/\b(const|let|var|function|=>|import|export|console\.|useState|useEffect|Promise)\b/.test(value)) return "javascript";
  return "generic";
}

function normalizeCodeLanguage(language = "") {
  const normalized = String(language || "").trim().toLowerCase();
  const aliases = {
    js: "javascript",
    jsx: "javascript",
    ts: "typescript",
    tsx: "typescript",
    py: "python",
    kt: "kotlin",
    html: "html",
    xml: "html",
    css: "css",
    java: "java",
    sql: "sql"
  };
  return aliases[normalized] || normalized || "generic";
}

function renderHighlightedCode(code, language = "") {
  const normalizedLanguage = normalizeCodeLanguage(language);
  return normalizePastedPlainText(code)
    .split("\n")
    .map((line) => highlightCodeLine(line, normalizedLanguage))
    .join("\n");
}

function highlightCodeLine(line, language) {
  const keywords = getCodeKeywords(language);
  const builtins = getCodeBuiltins(language);
  const tokenPattern = /(\/\/.*$|#.*$|\/\*.*?\*\/|<!--.*?-->|"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`|\b(?:true|false|null|undefined|None|nil)\b|\b\d+(?:\.\d+)?\b|\b[A-Za-z_$][\w$]*\b|[{}()[\].,;:+\-*\/%=&|!<>?]+)/g;
  let html = "";
  let lastIndex = 0;

  String(line || "").replace(tokenPattern, (token, match, offset) => {
    html += escapeHtml(line.slice(lastIndex, offset));
    html += renderCodeToken(token, keywords, builtins);
    lastIndex = offset + token.length;
    return token;
  });

  html += escapeHtml(line.slice(lastIndex));
  return html;
}

const CODE_TOKEN_STYLES = {
  boolean: "color: #79c0ff; font-weight: 800;",
  builtin: "color: #5eead4; font-weight: 700;",
  comment: "color: #8ba99c; font-style: italic;",
  keyword: "color: #8bd5ff; font-weight: 800;",
  number: "color: #ffb86c;",
  string: "color: #f9d77e;"
};

function renderSyntaxToken(type, content) {
  const style = CODE_TOKEN_STYLES[type] || "";
  return `<span class="token-${type}"${style ? ` style="${style}"` : ""}>${content}</span>`;
}

function renderCodeToken(token, keywords, builtins) {
  const escaped = escapeHtml(token);
  if (/^(\/\/|#|\/\*|<!--)/.test(token)) return renderSyntaxToken("comment", escaped);
  if (/^["'`]/.test(token)) return renderSyntaxToken("string", escaped);
  if (/^\d/.test(token)) return renderSyntaxToken("number", escaped);
  if (/^(true|false|null|undefined|None|nil)$/.test(token)) return renderSyntaxToken("boolean", escaped);
  if (keywords.has(token)) return renderSyntaxToken("keyword", escaped);
  if (builtins.has(token)) return renderSyntaxToken("builtin", escaped);
  return escaped;
}

function getCodeKeywords(language) {
  const common = ["break", "case", "catch", "class", "const", "continue", "default", "do", "else", "enum", "export", "extends", "finally", "for", "from", "function", "if", "import", "in", "instanceof", "interface", "new", "return", "static", "switch", "this", "throw", "try", "typeof", "var", "void", "while", "with", "yield", "async", "await", "let"];
  const byLanguage = {
    python: ["and", "as", "assert", "async", "await", "break", "class", "continue", "def", "del", "elif", "else", "except", "finally", "for", "from", "global", "if", "import", "in", "is", "lambda", "nonlocal", "not", "or", "pass", "raise", "return", "try", "while", "with", "yield"],
    java: ["abstract", "assert", "boolean", "break", "byte", "case", "catch", "char", "class", "continue", "default", "do", "double", "else", "enum", "extends", "final", "finally", "float", "for", "if", "implements", "import", "instanceof", "int", "interface", "long", "native", "new", "package", "private", "protected", "public", "return", "short", "static", "strictfp", "super", "switch", "synchronized", "this", "throw", "throws", "transient", "try", "void", "volatile", "while"],
    kotlin: ["actual", "annotation", "as", "break", "by", "catch", "class", "companion", "const", "constructor", "continue", "crossinline", "data", "do", "else", "enum", "expect", "external", "false", "field", "file", "final", "finally", "for", "fun", "get", "if", "import", "in", "init", "inline", "inner", "interface", "internal", "is", "lateinit", "noinline", "null", "object", "open", "operator", "out", "override", "package", "private", "protected", "public", "reified", "return", "sealed", "set", "super", "suspend", "tailrec", "this", "throw", "true", "try", "typealias", "val", "var", "vararg", "when", "where", "while"],
    dart: ["abstract", "as", "async", "await", "bool", "break", "case", "catch", "class", "const", "continue", "default", "deferred", "do", "dynamic", "else", "enum", "export", "extends", "extension", "external", "factory", "false", "final", "finally", "for", "Function", "get", "hide", "if", "implements", "import", "in", "interface", "is", "late", "library", "mixin", "new", "null", "on", "operator", "part", "required", "rethrow", "return", "set", "show", "static", "super", "switch", "sync", "this", "throw", "true", "try", "typedef", "var", "void", "while", "with", "yield"],
    swift: ["Any", "as", "associatedtype", "break", "case", "catch", "class", "continue", "default", "defer", "do", "else", "enum", "extension", "false", "fileprivate", "for", "func", "guard", "if", "import", "in", "init", "inout", "internal", "is", "let", "nil", "open", "operator", "private", "protocol", "public", "repeat", "return", "self", "static", "struct", "subscript", "super", "switch", "throw", "throws", "true", "try", "typealias", "var", "where", "while"],
    cpp: ["alignas", "alignof", "auto", "bool", "break", "case", "catch", "char", "class", "const", "constexpr", "continue", "default", "delete", "do", "double", "else", "enum", "explicit", "extern", "false", "float", "for", "friend", "if", "include", "inline", "int", "long", "namespace", "new", "nullptr", "operator", "private", "protected", "public", "return", "short", "signed", "sizeof", "static", "struct", "switch", "template", "this", "throw", "true", "try", "typedef", "typename", "using", "virtual", "void", "while"],
    sql: ["SELECT", "FROM", "WHERE", "JOIN", "LEFT", "RIGHT", "INNER", "OUTER", "INSERT", "INTO", "UPDATE", "DELETE", "CREATE", "ALTER", "DROP", "TABLE", "VALUES", "SET", "GROUP", "ORDER", "BY", "HAVING", "LIMIT", "OFFSET", "AND", "OR", "NOT", "NULL", "AS"],
    css: ["important", "media", "keyframes", "from", "to"],
    html: ["DOCTYPE", "html", "head", "body", "script", "style", "div", "span", "section", "article", "header", "footer", "main", "button", "input", "form", "a", "img"]
  };
  return new Set([...(byLanguage[language] || common), ...common]);
}

function getCodeBuiltins(language) {
  const common = ["Array", "Boolean", "Date", "Error", "JSON", "Map", "Math", "Number", "Object", "Promise", "Set", "String", "console", "document", "window"];
  const byLanguage = {
    python: ["dict", "enumerate", "float", "int", "len", "list", "print", "range", "set", "str", "tuple"],
    java: ["ArrayList", "Arrays", "HashMap", "HashSet", "Integer", "List", "Map", "Objects", "Optional", "Set", "String", "System"],
    kotlin: ["Any", "Boolean", "Channel", "CoroutineScope", "Dispatchers", "Double", "Flow", "Int", "Job", "List", "Long", "Map", "MutableList", "MutableMap", "MutableSet", "SharedFlow", "StateFlow", "String", "SupervisorJob", "Unit", "arrayOf", "delay", "flow", "launch", "mutableListOf", "println", "runBlocking", "withContext"],
    dart: ["BuildContext", "Column", "Container", "Future", "List", "Map", "Scaffold", "State", "StatefulWidget", "StatelessWidget", "Stream", "String", "Widget", "print"],
    swift: ["Array", "Dictionary", "Double", "Int", "Set", "String", "print"],
    cpp: ["cout", "cin", "endl", "map", "set", "string", "unordered_map", "vector"],
    sql: ["COUNT", "SUM", "AVG", "MIN", "MAX"],
    javascript: ["Array", "Boolean", "Date", "Error", "JSON", "Map", "Math", "Number", "Object", "Promise", "React", "Set", "String", "console", "document", "window", "useEffect", "useState"]
  };
  return new Set([...(byLanguage[language] || []), ...common]);
}
function handleScroll(event) {
  const codeEditor = event.target?.closest?.("[data-code-editor]");
  if (codeEditor) syncCodingPracticeHighlight(codeEditor);
  updateTutorialReadingProgress();
}

function updateTutorialReadingProgress() {
  const fill = document.querySelector("[data-tutorial-progress-fill]");
  if (!fill) return;
  const scrollable = document.documentElement.scrollHeight - window.innerHeight;
  const progress = scrollable > 0 ? Math.min(100, Math.max(0, (window.scrollY / scrollable) * 100)) : 0;
  fill.style.width = `${progress}%`;
}

async function handleChange(event) {
  const adminEditorForm = event.target.closest("[data-admin-editor] form");
  if (adminEditorForm) adminEditorForm.dataset.dirty = "true";

  const experienceLevelSelect = event.target.closest("[data-experience-level]");
  if (experienceLevelSelect) {
    syncFresherFields(experienceLevelSelect.closest("[data-student-register-form], [data-student-profile-form]"));
    return;
  }

  const articleSubjectSelect = event.target.closest("[data-article-subject-select]");
  if (articleSubjectSelect) {
    updateArticleSectionSelect(articleSubjectSelect.closest("[data-admin-form]"), articleSubjectSelect.value);
    return;
  }

  const articleSectionSelect = event.target.closest("[data-article-section-select]");
  if (articleSectionSelect && !state.editingId) {
    const form = articleSectionSelect.closest("[data-admin-form]");
    const subject = getSubjectByTitle(form?.querySelector("[data-article-subject-select]")?.value || "");
    const orderInput = form?.querySelector('input[name="order"]');
    if (subject && orderInput) {
      const nextOrder = state.articles.filter((article) => article.category === subject.title && getTutorialSectionId(article, subject) === articleSectionSelect.value).length + 1;
      orderInput.value = String(nextOrder);
    }
    return;
  }

  const fullViewMenuToggle = event.target.closest("[data-toggle-full-view-menu]");
  if (fullViewMenuToggle) {
    state.fullViewMenuVisible = fullViewMenuToggle.checked;
    setFullViewMenuPreference(state.fullViewMenuVisible);
    render();
    return;
  }

  const tutorialImport = event.target.closest("[data-tutorial-import]");
  if (tutorialImport) {
    await handleTutorialImport(tutorialImport);
    return;
  }

  const fileUpload = event.target.closest("[data-image-upload], [data-document-upload]");
  if (fileUpload) {
    await handleFileUpload(fileUpload);
    return;
  }

  const codeLanguageSelect = event.target.closest("[data-code-language]");
  if (codeLanguageSelect) {
    updateCodingPracticeLanguage(codeLanguageSelect);
    return;
  }

  if (event.target.matches("[data-coding-practice-kind], [data-coding-practice-difficulty], [data-coding-practice-company], [data-coding-practice-status]")) {
    applyCodingPracticeFilters(event.target.closest("[data-coding-practice-scope]"));
    return;
  }

  if (event.target.matches("[data-practice-difficulty], [data-practice-company], [data-practice-status]")) {
    applyPracticeFilters(event.target.closest("[data-practice-scope]"));
    return;
  }

  if (event.target.matches("[data-coding-difficulty]")) {
    applyCodingRoundFilters(event.target.closest("[data-coding-scope]"));
    return;
  }

  const richCommand = event.target.closest("select[data-rich-command]");
  if (richCommand) {
    applyRichCommand(richCommand);
  }
}

function handleSelectionChange() {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;

  const anchor = selection.anchorNode;
  const element = anchor?.nodeType === Node.ELEMENT_NODE ? anchor : anchor?.parentElement;
  const editor = element?.closest?.("[data-rich-editor]");
  if (editor) saveRichSelection(editor);
}

function handleKeyDown(event) {
  const openModal = state.sectionModal ? "[data-section-modal]"
    : state.studentDetailId ? "[data-student-modal]"
      : state.bookingModal ? "[data-booking-modal]"
        : state.reviewModal ? "[data-review-modal]"
          : "";
  if (openModal && event.key === "Tab") {
    trapModalFocus(event, document.querySelector(`${openModal} [role='dialog']`));
    return;
  }

  if (event.key !== "Escape") return;

  if (state.sectionModal) {
    closeSectionModal();
    return;
  }

  if (state.studentDetailId) {
    closeStudentModal();
    return;
  }

  if (state.bookingModal || state.reviewModal) {
    closeAdminPopup();
    return;
  }

  if (state.activeCourseId) {
    state.activeCourseId = "";
    render();
    return;
  }

  if (!state.fullViewTutorialId) return;

  const tutorialId = state.fullViewTutorialId;
  state.fullViewTutorialId = "";
  render();
  window.requestAnimationFrame(() => {
    focusFullViewButton(tutorialId);
  });
}

function focusFullViewButton(tutorialId) {
  [...document.querySelectorAll("[data-open-full-view]")]
    .find((button) => button.dataset.openFullView === tutorialId)
    ?.focus();
}

function selectRichImageFigure(figure) {
  if (!figure) return;
  const editor = figure.closest("[data-rich-editor]");
  const form = figure.closest("[data-admin-form]");
  if (!editor || !form) return;

  clearRichImageSelection(form);
  ensureRichImageState(figure);
  figure.classList.add("is-selected");
  activeRichImageFigure = figure;
  ensureRichResizeHandle(figure);
  positionRichResizeHandle(figure);
  updateRichImageToolbar(form, figure);
}

function clearRichImageSelection(scope = document) {
  const root = scope instanceof HTMLElement ? scope : document;
  root.querySelectorAll(".rich-editor-area figure.is-selected").forEach((figure) => {
    figure.classList.remove("is-selected");
    figure.querySelectorAll("[data-rich-resize-image]").forEach((handle) => handle.remove());
  });

  root.querySelectorAll("[data-rich-image-toolbar]").forEach((toolbar) => {
    toolbar.hidden = true;
    toolbar.querySelectorAll(".rich-icon-button.is-active").forEach((button) => button.classList.remove("is-active"));
  });

  if (scope === document || (activeRichImageFigure && root.contains(activeRichImageFigure))) {
    activeRichImageFigure = null;
  }
}

function ensureRichImageState(figure) {
  const image = figure?.querySelector("img");
  if (!figure || !image) return;

  ensureRichImageFrame(figure);
  const align = getAllowedImageAlign(figure.dataset.align || getAllowedTextAlign(figure) || "center");
  const crop = getAllowedImageCrop(figure.dataset.crop || "original");
  const frame = ensureRichImageFrame(figure);
  const width = getAllowedImageWidth(frame) || getAllowedImageWidth(image) || 100;

  setRichFigureAlign(figure, align);
  setRichFigureCrop(figure, crop);
  setRichImageWidth(image, width);
}

function ensureRichResizeHandle(figure) {
  let handle = figure.querySelector("[data-rich-resize-image]");
  if (handle) return handle;

  handle = document.createElement("span");
  handle.className = "rich-image-resize-handle";
  handle.dataset.richResizeImage = "true";
  handle.setAttribute("contenteditable", "false");
  handle.setAttribute("role", "presentation");
  figure.append(handle);
  return handle;
}

function positionRichResizeHandle(figure) {
  const handle = figure?.querySelector("[data-rich-resize-image]");
  const frame = getRichImageFrame(figure);
  if (!handle || !frame) return;

  const figureRect = figure.getBoundingClientRect();
  const frameRect = frame.getBoundingClientRect();
  handle.style.left = `${frameRect.right - figureRect.left - 8}px`;
  handle.style.top = `${frameRect.bottom - figureRect.top - 8}px`;
}

function startRichImageResize(handle, event) {
  const figure = handle.closest("figure");
  const image = figure?.querySelector("img");
  const editor = figure?.closest("[data-rich-editor]");
  const form = figure?.closest("[data-admin-form]");
  if (!figure || !image || !editor || !form) return;

  ensureRichImageState(figure);
  const frame = getRichImageFrame(figure);
  if (!frame) return;
  figure.classList.add("is-selected");
  activeRichImageFigure = figure;
  updateRichImageToolbar(form, figure);
  const frameRect = frame.getBoundingClientRect();
  const editorRect = editor.getBoundingClientRect();
  richImageResizeState = {
    form,
    figure,
    image,
    handle,
    pointerId: event.pointerId,
    startX: event.clientX,
    startWidth: frameRect.width,
    editorWidth: Math.max(editorRect.width - 52, 1)
  };
  handle.setPointerCapture?.(event.pointerId);
  event.preventDefault();
}

function updateRichImageToolbar(form, figure) {
  const toolbar = form?.querySelector("[data-rich-image-toolbar]");
  if (!toolbar || !figure) return;

  const align = getAllowedImageAlign(figure.dataset.align || "center");
  const crop = getAllowedImageCrop(figure.dataset.crop || "original");
  toolbar.hidden = false;
  toolbar.querySelectorAll("[data-rich-image-action]").forEach((button) => {
    const action = button.dataset.richImageAction;
    button.classList.toggle("is-active", action === `align-${align}` || action === `crop-${crop}`);
  });
}

function applyRichImageAction(button) {
  const form = button.closest("[data-admin-form]");
  const editor = form?.querySelector("[data-rich-editor]");
  const figure = getActiveRichImageFigure(editor);
  const image = figure?.querySelector("img");
  if (!form || !editor || !figure || !image) {
    showToast("Select an image first.");
    return;
  }

  const action = button.dataset.richImageAction;
  if (action?.startsWith("align-")) {
    setRichFigureAlign(figure, action.replace("align-", ""));
  } else if (action?.startsWith("crop-")) {
    setRichFigureCrop(figure, action.replace("crop-", ""));
  } else if (action === "size-full") {
    setRichImageWidth(image, 100);
  } else if (action === "remove-image") {
    figure.remove();
    activeRichImageFigure = null;
    updateRichImageToolbar(form, null);
    syncRichEditor(form);
    showToast("Image removed. Save the tutorial to apply the change.");
    return;
  }

  ensureRichResizeHandle(figure);
  positionRichResizeHandle(figure);
  updateRichImageToolbar(form, figure);
  syncRichEditor(form);
}

function getActiveRichImageFigure(editor) {
  if (activeRichImageFigure && editor?.contains(activeRichImageFigure)) {
    return activeRichImageFigure;
  }

  return editor?.querySelector("figure.is-selected");
}

function setRichFigureAlign(figure, align) {
  const value = getAllowedImageAlign(align);
  figure.dataset.align = value;
  figure.style.textAlign = value;
}

function setRichFigureCrop(figure, crop) {
  const value = getAllowedImageCrop(crop);
  figure.dataset.crop = value;
  const frame = ensureRichImageFrame(figure);
  const image = figure.querySelector("img");
  if (!frame || !image) return;

  if (value === "wide") {
    frame.style.aspectRatio = "16 / 9";
    image.style.objectFit = "cover";
  } else if (value === "square") {
    frame.style.aspectRatio = "1 / 1";
    image.style.objectFit = "cover";
  } else {
    frame.style.removeProperty("aspect-ratio");
    image.style.removeProperty("object-fit");
  }
}

function setRichImageWidth(image, width) {
  const value = clamp(Number(width) || 100, 24, 100);
  const rounded = Math.round(value);
  const figure = image.closest("figure");
  const frame = ensureRichImageFrame(figure);
  image.dataset.width = String(rounded);
  image.style.width = "100%";
  if (frame) {
    frame.dataset.width = String(rounded);
    frame.style.width = `${rounded}%`;
  }
}

function ensureRichImageFrame(figure) {
  if (!figure) return null;
  const image = figure.querySelector("img");
  if (!image) return null;

  const existingFrame = getRichImageFrame(figure);
  if (existingFrame) return existingFrame;

  const frame = document.createElement("span");
  frame.className = "rich-image-frame";
  frame.dataset.imageFrame = "true";
  frame.setAttribute("contenteditable", "false");
  image.before(frame);
  frame.append(image);
  return frame;
}

function getRichImageFrame(figure) {
  return figure?.querySelector("[data-image-frame]");
}

function optimizeRenderedImages() {
  app.querySelectorAll("img").forEach((image) => {
    image.decoding = "async";
    const isHeroImage = image.classList.contains("hero-background") || Boolean(image.closest(".hero-logo-badge"));
    if (!isHeroImage && !image.hasAttribute("loading")) {
      image.loading = "lazy";
    }
  });
}

function handleManagedImageError(event) {
  const image = event.target;
  if (!(image instanceof HTMLImageElement) || !image.matches("[data-managed-image]")) return;
  if (image.dataset.imageFailed === "true") return;

  image.dataset.imageFailed = "true";
  const fallback = image.dataset.fallback || "";
  const preview = image.closest("[data-cover-preview]");

  if (preview) {
    preview.classList.remove("is-visible");
    preview.classList.add("has-error");
    preview.innerHTML = "<span>Saved cover link is not a direct image. Upload the image to Firebase Storage, wait for preview, then save.</span>";
    return;
  }

  if (image.parentElement?.classList.contains("article-visual") && fallback) {
    const fallbackNode = document.createElement("span");
    fallbackNode.textContent = fallback;
    image.replaceWith(fallbackNode);
    return;
  }

  image.remove();
}

// Two different questions that used to share one answer.
//
// canReadTutorials(): may this visitor read the tutorial library? Now yes,
// for everyone - the library is the site's public content, and gating it
// was what made the site look empty to both search engines and AdSense.
//
// hasLearningAccess(): may this visitor use the parts that genuinely need
// an account - coding practice, and the Students Hub, where everything is
// tied to a profile.
function canReadTutorials() {
  return true;
}

function hasLearningAccess() {
  if (!state.firebaseEnabled) return true;
  return Boolean(state.user);
}

function renderLearningAuthGate(feature = "learning") {
  const isRegister = state.studentAuthView === "register";
  const featureTitle = feature === "coding practice" ? "Coding Practice" : feature === "community" ? "the Students Hub" : feature === "profile" ? "Profile" : "Tutorials";
  // The login form used to be the ONLY thing on this screen - real, crawlable
  // content here matters beyond just UX: a screen with nothing but a login
  // box (no article text, just a form) is exactly what ad-network policy
  // reviews flag as "no publisher content". These preview blocks pull from
  // data that's already public (subjects/sections; the static coding-practice
  // language/category lists; published community titles), so a logged-out
  // visitor - or a crawler - sees genuine information about what's inside.
  const previewBlock = feature === "coding practice"
    ? renderCodingPracticeAuthPreview()
    : feature === "community" ? renderCommunityAuthPreview()
    : feature === "profile" ? "" : renderTutorialsAuthPreview();

  return `
    <section class="learning-auth-shell section-band">
      <div class="learning-auth-copy" data-reveal>
        <p class="eyebrow">Student access</p>
        <h1>Login to keep your learning progress saved.</h1>
        <p>Student login is required for ${escapeHtml(featureTitle)} so your completed topics, quiz practice, coding attempts, and revision history can be tracked safely across devices.</p>
        <div class="learning-auth-points">
          <span>Saved progress</span>
          <span>Quiz history</span>
          <span>Code attempts</span>
          <span>Private student profile</span>
        </div>
      </div>
      <div class="learning-auth-card" data-reveal>
        ${isRegister ? renderStudentRegisterForm(featureTitle) : renderStudentLoginForm(featureTitle)}
      </div>
      ${previewBlock}
    </section>
  `;
}

function renderTutorialsAuthPreview() {
  const subjects = getPublicSubjects().slice(0, 8);
  if (!subjects.length) return "";
  const totalSections = subjects.reduce((total, subject) => total + subject.sections.length, 0);

  return `
    <div class="learning-auth-preview">
      <h2>What's inside the tutorial library</h2>
      <p>${subjects.length} subject${subjects.length === 1 ? "" : "s"}, ${totalSections} structured section${totalSections === 1 ? "" : "s"} covering language fundamentals through interview-ready practice.</p>
      <ul class="learning-auth-preview-list">
        ${subjects.map((subject) => {
          const sectionTitles = subject.sections.slice(0, 4).map((section) => section.title);
          const moreCount = subject.sections.length - sectionTitles.length;
          return `
            <li>
              <strong>${escapeHtml(subject.title)}</strong>
              <span>${escapeHtml(subject.sections.length)} section${subject.sections.length === 1 ? "" : "s"}${sectionTitles.length ? `: ${escapeHtml(sectionTitles.join(", "))}${moreCount > 0 ? ` and ${moreCount} more` : ""}` : ""}</span>
            </li>
          `;
        }).join("")}
      </ul>
    </div>
  `;
}

function renderCodingPracticeAuthPreview() {
  const freeLanguages = CODING_PRACTICE_LANGUAGES.filter((language) => language.runner === "browser");
  const types = (state.codingMeta?.types?.length ? state.codingMeta.types : DEFAULT_CODING_META_TYPES).map((type) => type.label);
  const difficulties = (state.codingMeta?.difficulties?.length ? state.codingMeta.difficulties : DEFAULT_CODING_META_DIFFICULTIES).map((difficulty) => difficulty.label);

  return `
    <div class="learning-auth-preview">
      <h2>What's inside Coding Practice</h2>
      <p>Run ${escapeHtml(freeLanguages.map((language) => language.label).join(", "))} instantly in your browser - no signup, no server, no waiting.</p>
      <ul class="learning-auth-preview-list">
        <li><strong>Problem types</strong><span>${escapeHtml(types.join(", "))}</span></li>
        <li><strong>Difficulty levels</strong><span>${escapeHtml(difficulties.join(", "))}</span></li>
        <li><strong>Free in-browser languages</strong><span>${escapeHtml(freeLanguages.map((language) => language.label).join(", "))}</span></li>
      </ul>
    </div>
  `;
}

function renderCommunityAuthPreview() {
  const communities = getPublicCommunities().slice(0, 8);
  if (!communities.length) return "";

  return `
    <div class="learning-auth-preview">
      <h2>Communities you can join</h2>
      <p>${communities.length} topic ${communities.length === 1 ? "community" : "communities"} in the Students Hub where learners share ideas, discuss what they're building, and ask for help.</p>
      <ul class="learning-auth-preview-list">
        ${communities.map((community) => `
          <li>
            <strong>${escapeHtml(community.title)}</strong>
            <span>${escapeHtml(community.description || "Join to discuss and meet other learners.")}</span>
          </li>
        `).join("")}
      </ul>
    </div>
  `;
}

function renderStudentLoginForm(featureTitle = "learning") {
  return `
    <form class="admin-card login-panel student-auth-panel" data-student-login-form>
      <div>
        <p class="eyebrow">Student login</p>
        <h2>Continue to ${escapeHtml(featureTitle)}.</h2>
        <p class="muted">Use your student account to restore progress, quiz attempts, and coding practice activity.</p>
      </div>
      <label>
        <span>Email</span>
        <input name="email" type="email" placeholder="Enter your email" autocomplete="username" required />
      </label>
      <label>
        <span>Password</span>
        <input name="password" type="password" autocomplete="current-password" required />
      </label>
      <button class="button primary" type="submit">Login</button>
      <button class="auth-link" type="button" data-student-auth-view="register">New student? Register</button>
      ${state.firebaseError ? `<p class="form-error">${escapeHtml(state.firebaseError)}</p>` : ""}
    </form>
  `;
}

const STUDENT_PROFESSION_OPTIONS = [
  "Student",
  "Software Developer",
  "Android Developer",
  "Flutter Developer",
  "Web Developer",
  "Backend Developer",
  "QA / Tester",
  "Data / AI Learner",
  "UI / UX Designer",
  "Working Professional",
  "Other"
];

const STUDENT_EXPERIENCE_OPTIONS = [
  { value: "fresher", label: "Fresher / No work experience" },
  { value: "0-1", label: "0-1 years" },
  { value: "1-3", label: "1-3 years" },
  { value: "3-5", label: "3-5 years" },
  { value: "5-8", label: "5-8 years" },
  { value: "8+", label: "8+ years" }
];

function renderStudentProfessionOptions(selectedValue = "") {
  const selected = String(selectedValue || "").trim();
  const options = selected && !STUDENT_PROFESSION_OPTIONS.includes(selected)
    ? [selected, ...STUDENT_PROFESSION_OPTIONS]
    : STUDENT_PROFESSION_OPTIONS;
  return `<option value="">Select profession</option>${options.map((option) => `<option value="${escapeAttr(option)}" ${option === selected ? "selected" : ""}>${escapeHtml(option)}</option>`).join("")}`;
}

function renderStudentExperienceOptions(selectedValue = "") {
  const selected = String(selectedValue || "").trim();
  return `<option value="">Select experience</option>${STUDENT_EXPERIENCE_OPTIONS.map((option) => `<option value="${escapeAttr(option.value)}" ${option.value === selected ? "selected" : ""}>${escapeHtml(option.label)}</option>`).join("")}`;
}

function getCurrentStudentProfile() {
  const user = state.user || {};
  return normalizeStudent({
    ...(state.studentProfile || {}),
    uid: state.studentProfile?.uid || user.uid || "",
    id: state.studentProfile?.id || user.uid || "",
    name: state.studentProfile?.name || user.displayName || user.email?.split("@")[0] || "Student",
    email: state.studentProfile?.email || user.email || ""
  });
}

function renderStudentProfilePage() {
  if (!state.user) return renderLearningAuthGate("profile");

  if (!state.isAdmin && state.isContributor) {
    return renderContributorProfilePage();
  }

  if (state.isAdmin) {
    return `
      <section class="learning-auth-shell student-profile-shell section-band">
        <div class="learning-auth-copy" data-reveal>
          <p class="eyebrow">Admin account</p>
          <h1>Your administrator tools are ready.</h1>
          <p>Use the admin dashboard to manage courses, tutorials, coding problems, students, and settings.</p>
        </div>
        <div class="learning-auth-card" data-reveal>
          <div class="admin-card login-panel student-auth-panel">
            <p class="eyebrow">Administrator</p>
            <h2>${escapeHtml(state.user.email || ADMIN_EMAIL)}</h2>
            <a class="button primary" href="#admin">Go to Admin Page</a>
            <button class="button ghost" type="button" data-signout>Sign out</button>
          </div>
        </div>
      </section>
    `;
  }

  const profile = getCurrentStudentProfile();
  const isFresher = profile.experienceLevel === "fresher";

  return `
    ${renderEmailVerificationNotice()}
    <section class="learning-auth-shell student-profile-shell section-band">
      <div class="learning-auth-copy" data-reveal>
        <p class="eyebrow">Student profile</p>
        <h1>Keep your learning profile updated.</h1>
        <p>Your profile helps SkillUp Class understand your current stage and keep tutorial, course, and practice progress connected to the right account.</p>
        <div class="learning-auth-points">
          <span>Saved progress</span>
          <span>Course support</span>
          <span>Practice history</span>
          <span>Profile data</span>
        </div>
      </div>
      <div class="learning-auth-card" data-reveal>
        <form class="admin-card login-panel student-auth-panel student-profile-panel" data-student-profile-form>
          <div>
            <p class="eyebrow">Edit profile</p>
            <h2>${escapeHtml(profile.name || "Student")}</h2>
            <p class="muted">Update the details used for student access and progress tracking.</p>
          </div>
          <div class="student-auth-grid">
            <label>
              <span>Name</span>
              <input name="name" type="text" value="${escapeAttr(profile.name)}" autocomplete="name" required />
            </label>
            <label>
              <span>Mobile no</span>
              <input name="mobileNo" type="tel" value="${escapeAttr(profile.mobileNo)}" autocomplete="tel" required />
            </label>
            <label>
              <span>Email</span>
              <input name="email" type="email" value="${escapeAttr(profile.email)}" readonly />
            </label>
            <label>
              <span>Profession</span>
              <select name="profession" autocomplete="organization-title" required>${renderStudentProfessionOptions(profile.profession)}</select>
            </label>
            <label>
              <span>Current organisation</span>
              <input name="currentOrganisation" type="text" value="${escapeAttr(profile.currentOrganisation)}" autocomplete="organization" required />
            </label>
            <label>
              <span>Experience level</span>
              <select name="experienceLevel" data-experience-level required>${renderStudentExperienceOptions(profile.experienceLevel)}</select>
            </label>
          </div>
          <div class="student-fresher-fields" data-fresher-fields ${isFresher ? "" : "hidden"}>
            <label>
              <span>Current degree</span>
              <input name="currentDegree" type="text" value="${escapeAttr(profile.currentDegree)}" ${isFresher ? "required" : ""} />
            </label>
            <label>
              <span>College name</span>
              <input name="collegeName" type="text" value="${escapeAttr(profile.collegeName)}" ${isFresher ? "required" : ""} />
            </label>
          </div>
          <label class="checkbox-line">
            <input name="emailReplies" type="checkbox" ${profile.emailReplies !== false ? "checked" : ""} />
            <span>Email me when someone replies to my posts or comments</span>
          </label>
          <div class="form-actions">
            <button class="button primary" type="submit">Save profile</button>
            <a class="button ghost" href="#home">Back home</a>
          </div>
        </form>
      </div>
    </section>
    ${renderStudentLearningSummary()}
    ${renderDeleteAccountPanel()}
  `;
}

// A contributor's own profile: the name credited on their drafts, contact
// details the admin sees in Admin > Contributors, and their password. Email
// and access stay with the admin (firestore.rules allows only these fields).
function renderContributorProfilePage() {
  const record = state.contributorRecord || {};
  const confirmed = isContributorEmailConfirmed();
  return `
    <section class="learning-auth-shell student-profile-shell section-band">
      <div class="learning-auth-copy" data-reveal>
        <p class="eyebrow">Contributor profile</p>
        <h1>Keep your contributor profile updated.</h1>
        <p>The admin sees your name on every draft you send in. Write tutorials, courses, coding problems, blog posts and events from the dashboard.</p>
        <div class="learning-auth-points">
          <span>Draft credit</span>
          <span>Contact details</span>
          <span>Password</span>
        </div>
        <div class="form-actions">
          <a class="button primary" href="#admin">Go to Dashboard</a>
        </div>
      </div>
      <div class="learning-auth-card" data-reveal>
        <form class="admin-card login-panel student-auth-panel student-profile-panel" data-contributor-profile-form>
          <div>
            <p class="eyebrow">Edit profile</p>
            <h2>${escapeHtml(record.name || state.user.email || "Contributor")}</h2>
            <p class="muted">Your email and dashboard access are managed by the admin.</p>
          </div>
          ${confirmed ? "" : `
            <div class="contributor-confirm-inline">
              <p class="muted">Confirm your email before saving changes.</p>
              <button class="button ghost small" type="button" data-send-verification>Send confirmation link</button>
              <button class="button ghost small" type="button" data-refresh-verification>I've confirmed it</button>
            </div>
          `}
          <div class="student-auth-grid">
            <label>
              <span>Name</span>
              <input name="name" type="text" maxlength="120" value="${escapeAttr(record.name || "")}" autocomplete="name" required />
            </label>
            <label>
              <span>Email</span>
              <input name="email" type="email" value="${escapeAttr(state.user.email || "")}" readonly />
            </label>
            <label>
              <span>Mobile no</span>
              <input name="mobileNo" type="tel" maxlength="40" value="${escapeAttr(record.mobileNo || "")}" autocomplete="tel" />
            </label>
            <label>
              <span>Profession</span>
              <input name="profession" type="text" maxlength="120" value="${escapeAttr(record.profession || "")}" placeholder="Example: ML engineer" autocomplete="organization-title" />
            </label>
            <label>
              <span>Current organisation</span>
              <input name="currentOrganisation" type="text" maxlength="160" value="${escapeAttr(record.currentOrganisation || "")}" autocomplete="organization" />
            </label>
          </div>
          <div class="form-actions">
            <button class="button primary" type="submit">Save profile</button>
            <button class="button ghost" type="button" data-signout>Sign out</button>
          </div>
        </form>
      </div>
    </section>
    <section class="section-band contributor-password-band">
      ${renderChangePasswordPanel({ showBack: false })}
    </section>
  `;
}

function contributorProfilePayload(formData) {
  return {
    name: String(formData.get("name") || "").trim().slice(0, 120),
    mobileNo: String(formData.get("mobileNo") || "").trim().slice(0, 40),
    profession: String(formData.get("profession") || "").trim().slice(0, 120),
    currentOrganisation: String(formData.get("currentOrganisation") || "").trim().slice(0, 160)
  };
}

async function saveContributorProfile(profile) {
  if (state.isAdmin || !state.isContributor || !state.user) return false;
  if (!profile.name) {
    showToast("Add your name.");
    return false;
  }
  if (!isContributorEmailConfirmed()) {
    showToast("Confirm your email before saving your profile.");
    return false;
  }

  const updatedAt = new Date().toISOString();
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "contributors", getContributorKey(state.user.email)), { ...profile, updatedAt }, { merge: true });
  }
  state.contributorRecord = { ...state.contributorRecord, ...profile, updatedAt };
  showToast("Profile saved.");
  render();
  return true;
}

function renderStudentLearningSummary() {
  const allTutorials = getPublicTutorials();
  const progress = getSubjectProgress(allTutorials);
  const bookmarked = getBookmarkedTutorials();

  return `
    <section class="section-band student-learning-summary">
      <div class="section-heading is-visible" data-reveal>
        <div>
          <p class="eyebrow">My learning</p>
          <h2>Your progress and saved tutorials.</h2>
        </div>
        <p class="section-intro">Progress and bookmarks are tied to your account, so they follow you across devices.</p>
      </div>
      <div class="student-learning-grid">
        <article class="admin-card student-progress-card" data-reveal>
          <p class="eyebrow">Overall progress</p>
          <h3>${progress.completed}/${progress.total} tutorials completed</h3>
          <span class="subject-progress-track"><span style="width:${progress.percent}%"></span></span>
          <p class="muted">${progress.percent}% of all published tutorials marked complete.</p>
        </article>
        <article class="admin-card student-bookmarks-card" data-reveal>
          <p class="eyebrow">Bookmarked tutorials</p>
          <h3>${bookmarked.length} saved for later</h3>
          <div class="student-bookmark-list">
            ${bookmarked.length
              ? bookmarked.map((tutorial) => `
                <div class="student-bookmark-item">
                  <a href="#tutorials/${encodeURIComponent(tutorial.id)}">
                    <strong>${escapeHtml(tutorial.title)}</strong>
                    <small>${escapeHtml(tutorial.category || "")}</small>
                  </a>
                  <button
                    class="icon-only-button"
                    type="button"
                    data-toggle-tutorial-bookmark="${escapeAttr(tutorial.id)}"
                    data-bookmark-active="false"
                    aria-label="Remove bookmark"
                    title="Remove bookmark"
                  >${renderReaderIcon("close")}</button>
                </div>
              `).join("")
              : renderEmptyState("No bookmarks yet. Open a tutorial and tap the bookmark icon to save it here.")}
          </div>
        </article>
        ${renderLearningStreakCard()}
        ${renderQuizScoresCard()}
        ${renderCertificatesCard()}
      </div>
    </section>
  `;
}

function renderStudentRegisterForm(featureTitle = "learning") {
  return `
    <form class="admin-card login-panel student-auth-panel" data-student-register-form>
      <div>
        <p class="eyebrow">Student registration</p>
        <h2>Create your learning account.</h2>
        <p class="muted">Register once to unlock ${escapeHtml(featureTitle)} and keep your learning progress connected to your profile.</p>
      </div>
      <div class="student-auth-grid">
        <label>
          <span>Name</span>
          <input name="name" type="text" placeholder="Your full name" autocomplete="name" required />
        </label>
        <label>
          <span>Mobile no</span>
          <input name="mobileNo" type="tel" placeholder="Mobile number" autocomplete="tel" required />
        </label>
        <label>
          <span>Email</span>
          <input name="email" type="email" placeholder="Enter your email" autocomplete="username" required />
        </label>
        <label>
          <span>Profession</span>
          <select name="profession" autocomplete="organization-title" required>
            <option value="">Select profession</option>
            <option value="Student">Student</option>
            <option value="AI / ML Engineer">AI / ML Engineer</option>
            <option value="Data Scientist">Data Scientist</option>
            <option value="Software Developer">Software Developer</option>
            <option value="Android Developer">Android Developer</option>
            <option value="Flutter Developer">Flutter Developer</option>
            <option value="Web Developer">Web Developer</option>
            <option value="Backend Developer">Backend Developer</option>
            <option value="QA / Tester">QA / Tester</option>
            <option value="Data / AI Learner">Data / AI Learner</option>
            <option value="UI / UX Designer">UI / UX Designer</option>
            <option value="Working Professional">Working Professional</option>
            <option value="Other">Other</option>
          </select>
        </label>
        <label>
          <span>Current organisation</span>
          <input name="currentOrganisation" type="text" placeholder="Company, institute, or self-learning" autocomplete="organization" required />
        </label>
        <label>
          <span>Experience level</span>
          <select name="experienceLevel" data-experience-level required>
            <option value="">Select experience</option>
            <option value="fresher">Fresher / No work experience</option>
            <option value="0-1">0-1 years</option>
            <option value="1-3">1-3 years</option>
            <option value="3-5">3-5 years</option>
            <option value="5-8">5-8 years</option>
            <option value="8+">8+ years</option>
          </select>
        </label>
        <label>
          <span>Password</span>
          <input name="password" type="password" minlength="8" autocomplete="new-password" required />
        </label>
        <label>
          <span>Confirm password</span>
          <input name="confirmPassword" type="password" minlength="8" autocomplete="new-password" required />
        </label>
      </div>
      <div class="student-fresher-fields" data-fresher-fields hidden>
        <label>
          <span>Current degree</span>
          <input name="currentDegree" type="text" placeholder="B.Tech, BCA, MCA..." />
        </label>
        <label>
          <span>College name</span>
          <input name="collegeName" type="text" placeholder="Your college name" />
        </label>
      </div>
      <button class="button primary" type="submit">Register and continue</button>
      <button class="auth-link" type="button" data-student-auth-view="login">Already registered? Login</button>
      ${state.firebaseError ? `<p class="form-error">${escapeHtml(state.firebaseError)}</p>` : ""}
    </form>
  `;
}

function syncFresherFields(form) {
  const fresherFields = form?.querySelector("[data-fresher-fields]");
  const experienceLevel = form?.querySelector("[data-experience-level]")?.value || "";
  if (!fresherFields) return;

  const isFresher = experienceLevel === "fresher";
  fresherFields.hidden = !isFresher;
  fresherFields.querySelectorAll("input").forEach((input) => {
    input.required = isFresher;
    if (!isFresher) input.value = "";
  });
}

async function ensureStudentProfile(user, extra = {}) {
  if (!state.firebaseEnabled || !user || state.isAdmin) return;
  const now = new Date().toISOString();
  const name = String(extra.name || user.displayName || user.email?.split("@")[0] || "Student").trim();
  const studentRef = firebase.api.doc(firebase.db, "students", user.uid);
  const existingProfile = await firebase.api.getDoc(studentRef).catch(() => null);
  const profile = {
    uid: user.uid,
    name,
    email: String(user.email || "").trim().toLowerCase(),
    role: "student",
    updatedAt: now,
    lastLoginAt: now
  };

  ["mobileNo", "profession", "currentOrganisation", "experienceLevel", "currentDegree", "collegeName"].forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(extra, key)) {
      profile[key] = String(extra[key] || "").trim();
    }
  });

  if (!existingProfile?.exists()) {
    profile.createdAt = extra.createdAt || now;
  }

  await firebase.api.setDoc(studentRef, profile, { merge: true });

  // Sync the safe-fields-only publicProfiles doc used by the community member
  // directory. `profile` above may be partial (a plain login without `extra`
  // carries no profession/mobileNo/etc, relying on merge:true to leave the
  // students doc untouched) - re-read the merged record so this sync always
  // reflects the student's FULL current profile, never wiping fields with
  // empty strings on an ordinary login.
  try {
    const mergedSnapshot = await firebase.api.getDoc(studentRef);
    const mergedProfile = mergedSnapshot.exists()
      ? normalizeStudent({ id: user.uid, uid: user.uid, ...mergedSnapshot.data() })
      : normalizeStudent({ ...profile });
    await firebase.api.setDoc(
      firebase.api.doc(firebase.db, "publicProfiles", user.uid),
      buildPublicProfilePayload(mergedProfile),
      { merge: true }
    );
  } catch (error) {
    console.warn("Could not sync public profile:", error);
  }
}

async function loadCurrentStudentProfile(user = state.user) {
  if (!state.firebaseEnabled || !user || state.isAdmin) return null;
  const studentRef = firebase.api.doc(firebase.db, "students", user.uid);
  const snapshot = await firebase.api.getDoc(studentRef);
  if (snapshot.exists()) {
    return normalizeStudent({ id: user.uid, uid: user.uid, ...snapshot.data() });
  }
  return normalizeStudent({
    id: user.uid,
    uid: user.uid,
    name: user.displayName || user.email?.split("@")[0] || "Student",
    email: user.email || "",
    role: "student"
  });
}

async function updateStudentProfile(formData) {
  if (!state.firebaseEnabled || !state.user || state.isAdmin) {
    showToast("Login as a student before editing profile.");
    return;
  }

  const name = String(formData.get("name") || "").trim();
  const mobileNo = String(formData.get("mobileNo") || "").trim();
  const profession = String(formData.get("profession") || "").trim();
  const currentOrganisation = String(formData.get("currentOrganisation") || "").trim();
  const experienceLevel = String(formData.get("experienceLevel") || "").trim();
  const currentDegree = experienceLevel === "fresher" ? String(formData.get("currentDegree") || "").trim() : "";
  const collegeName = experienceLevel === "fresher" ? String(formData.get("collegeName") || "").trim() : "";

  if (!name) {
    showToast("Enter your name.");
    return;
  }

  if (mobileNo.replace(/\D/g, "").length < 7) {
    showToast("Enter a valid mobile number.");
    return;
  }

  if (!profession) {
    showToast("Select your profession.");
    return;
  }

  if (!currentOrganisation) {
    showToast("Enter your current organisation or institute.");
    return;
  }

  if (!experienceLevel) {
    showToast("Select your experience level.");
    return;
  }

  if (experienceLevel === "fresher" && (!currentDegree || !collegeName)) {
    showToast("Freshers should enter current degree and college name.");
    return;
  }

  const now = new Date().toISOString();
  const payload = {
    uid: state.user.uid,
    name,
    email: String(state.user.email || "").trim().toLowerCase(),
    mobileNo,
    profession,
    currentOrganisation,
    experienceLevel,
    currentDegree,
    collegeName,
    emailReplies: formData.get("emailReplies") === "on",
    role: "student",
    updatedAt: now
  };

  if (firebase.api.updateProfile) {
    await firebase.api.updateProfile(state.user, { displayName: name });
  }

  const studentRef = firebase.api.doc(firebase.db, "students", state.user.uid);
  await firebase.api.setDoc(studentRef, payload, { merge: true });
  state.studentProfile = normalizeStudent({ id: state.user.uid, ...state.studentProfile, ...payload });

  try {
    await firebase.api.setDoc(
      firebase.api.doc(firebase.db, "publicProfiles", state.user.uid),
      buildPublicProfilePayload(state.studentProfile),
      { merge: true }
    );
  } catch (error) {
    console.warn("Could not sync public profile:", error);
  }

  showToast("Profile updated.");
  render();
}
async function signInStudent(email, password) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (!state.firebaseEnabled) {
    showToast("Sign-in is not available right now. Please try again later.");
    return;
  }

  if (isAdminEmail(normalizedEmail)) {
    showToast("Use the admin panel for the administrator account.");
    return;
  }

  try {
    await firebase.api.signInWithEmailAndPassword(firebase.auth, normalizedEmail, String(password || ""));
    state.studentAuthView = "login";
    showToast("Logged in.");
  } catch (error) {
    showToast(formatAuthError(error));
  }
}

async function registerStudent(formData) {
  const name = String(formData.get("name") || "").trim();
  const mobileNo = String(formData.get("mobileNo") || "").trim();
  const email = String(formData.get("email") || "").trim().toLowerCase();
  const profession = String(formData.get("profession") || "").trim();
  const currentOrganisation = String(formData.get("currentOrganisation") || "").trim();
  const experienceLevel = String(formData.get("experienceLevel") || "").trim();
  const currentDegree = String(formData.get("currentDegree") || "").trim();
  const collegeName = String(formData.get("collegeName") || "").trim();
  const password = String(formData.get("password") || "");
  const confirmPassword = String(formData.get("confirmPassword") || "");

  if (!state.firebaseEnabled) {
    showToast("Registration is not available right now. Please try again later.");
    return;
  }

  if (!name) {
    showToast("Enter your name.");
    return;
  }

  if (mobileNo.replace(/\D/g, "").length < 7) {
    showToast("Enter a valid mobile number.");
    return;
  }

  if (!profession) {
    showToast("Enter your profession.");
    return;
  }

  if (!currentOrganisation) {
    showToast("Enter your current organisation or institute.");
    return;
  }

  if (!experienceLevel) {
    showToast("Select your experience level.");
    return;
  }

  if (experienceLevel === "fresher" && (!currentDegree || !collegeName)) {
    showToast("Freshers should enter current degree and college name.");
    return;
  }

  if (isAdminEmail(email)) {
    showToast("Use a different email for student registration.");
    return;
  }

  if (password.length < 8) {
    showToast("Use at least 8 characters for the password.");
    return;
  }

  if (password !== confirmPassword) {
    showToast("Password and confirm password do not match.");
    return;
  }

  try {
    const credential = await firebase.api.createUserWithEmailAndPassword(firebase.auth, email, password);
    if (firebase.api.updateProfile) {
      await firebase.api.updateProfile(credential.user, { displayName: name });
    }
    await ensureStudentProfile(credential.user, {
      name,
      mobileNo,
      profession,
      currentOrganisation,
      experienceLevel,
      currentDegree,
      collegeName,
      createdAt: new Date().toISOString()
    });
    state.studentProfile = await loadCurrentStudentProfile(credential.user).catch(() => normalizeStudent({
      id: credential.user.uid,
      uid: credential.user.uid,
      name,
      email,
      mobileNo,
      profession,
      currentOrganisation,
      experienceLevel,
      currentDegree,
      collegeName,
      role: "student"
    }));
    state.studentAuthView = "login";
    const verificationSent = await firebase.api.sendEmailVerification(credential.user).then(() => true).catch((error) => {
      console.warn("Could not send the verification email:", error);
      return false;
    });
    showToast(verificationSent
      ? `Registration complete. Confirm the link we sent to ${email} to post and register for events.`
      : "Registration complete. Open your profile to send the email confirmation link.");
  } catch (error) {
    showToast(formatAuthError(error));
  }
}

async function signInAdmin(email, password) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (!state.firebaseEnabled) {
    showToast("Sign-in is not available right now. Please try again later.");
    return;
  }

  // Contributors sign in here too; what the account may open is decided after
  // sign-in, by the dashboard gate and the rules.
  try {
    await firebase.api.signInWithEmailAndPassword(firebase.auth, normalizedEmail, String(password || ""));
    state.authView = "login";
    showToast("Signed in.");
  } catch (error) {
    showToast(formatAuthError(error));
  }
}

async function signOutAdmin() {
  if (state.firebaseEnabled) {
    await firebase.api.signOut(firebase.auth);
  }

  state.user = null;
  state.isAdmin = false;
  state.isContributor = false;
  state.contributorRecord = null;
  state.contributors = [];
  state.contributorsLoaded = false;
  // The next account on this device must not see the last one's dashboard.
  adminContentLoaded = false;
  state.editingId = null;
  state.adminEditorOpen = false;
  state.editingSubjectId = null;
  state.activeSubjectId = "";
  showToast("Signed out.");
  render();
}

async function sendAdminPasswordReset(email) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (!state.firebaseEnabled) {
    showToast("Password reset is not available right now. Please try again later.");
    return;
  }

  try {
    await firebase.api.sendPasswordResetEmail(firebase.auth, normalizedEmail);
    state.authView = "login";
    showToast("If that email has an account, a reset link is on its way.");
    render();
  } catch (error) {
    showToast(formatAuthError(error));
  }
}

async function changeAdminPassword(formData) {
  if (!state.firebaseEnabled || !firebase.auth?.currentUser) {
    showToast("Sign in again before changing password.");
    return;
  }

  const currentPassword = String(formData.get("currentPassword") || "");
  const newPassword = String(formData.get("newPassword") || "");
  const confirmPassword = String(formData.get("confirmPassword") || "");

  if (newPassword.length < 8) {
    showToast("Use at least 8 characters for the new password.");
    return;
  }

  if (newPassword !== confirmPassword) {
    showToast("New password and confirmation do not match.");
    return;
  }

  try {
    const user = firebase.auth.currentUser;
    const credential = firebase.api.EmailAuthProvider.credential(user.email, currentPassword);
    await firebase.api.reauthenticateWithCredential(user, credential);
    await firebase.api.updatePassword(user, newPassword);
    showToast("Password updated.");
    render();
  } catch (error) {
    showToast(formatAuthError(error));
  }
}

function isAdminEmail(email) {
  return String(email || "").trim().toLowerCase() === ADMIN_EMAIL.trim().toLowerCase();
}

function formatAuthError(error) {
  const code = String(error?.code || "");
  const messages = {
    "auth/invalid-credential": "Email or password is incorrect.",
    "auth/user-not-found": "Email or password is incorrect.",
    "auth/wrong-password": "Email or password is incorrect.",
    "auth/too-many-requests": "Too many attempts. Try again later or reset the password.",
    "auth/network-request-failed": "Network error. Check your connection and try again.",
    "auth/invalid-email": "Enter a valid admin email address.",
    "auth/weak-password": "Use a stronger password with at least 8 characters.",
    "auth/requires-recent-login": "Please sign in again before changing password."
  };

  return messages[code] || "Authentication failed. Please try again.";
}

function articlePayload(formData) {
  const now = new Date().toISOString();
  const existing = state.articles.find((item) => item.id === state.editingId) || {};
  const title = String(formData.get("title") || "").trim();
  const slug = slugify(formData.get("slug") || title);
  const status = String(formData.get("status") || "draft");
  const category = String(formData.get("category") || "General").trim();
  const subject = getSubjectByTitle(category);

  return {
    id: slug,
    title,
    slug,
    excerpt: String(formData.get("excerpt") || "").trim(),
    body: sanitizeRichHtml(String(formData.get("body") || "").trim()),
    category,
    sectionId: getValidTutorialSectionId(subject, formData.get("sectionId")),
    tags: splitTags(formData.get("tags")),
    quiz: parseQuizInput(formData.get("quizSource")),
    youtubeUrl: normalizeYouTubeInput(formData.get("youtubeUrl")),
    documentUrl: String(formData.get("documentUrl") || "").trim(),
    documentName: String(formData.get("documentName") || "").trim(),
    documentPath: String(formData.get("documentPath") || "").trim(),
    status,
    featured: formData.get("featured") === "on",
    showOnHome: formData.get("showOnHome") === "on",
    order: Number(formData.get("order") || existing.order || 1),
    publishedAt: status === "published" ? existing.publishedAt || now : "",
    createdAt: existing.createdAt || now,
    updatedAt: now
  };
}

function blogPayload(formData) {
  const now = new Date().toISOString();
  const existing = state.blogs.find((item) => item.id === state.editingId) || {};
  const title = String(formData.get("title") || "").trim();
  const slug = slugify(formData.get("slug") || title);
  const status = String(formData.get("status") || "draft");

  return {
    id: slug,
    title,
    slug,
    excerpt: String(formData.get("excerpt") || "").trim(),
    body: sanitizeRichHtml(String(formData.get("body") || "").trim()),
    category: String(formData.get("category") || "SkillUp Blog").trim(),
    tags: splitTags(formData.get("tags")),
    coverImage: String(formData.get("coverImage") || "").trim(),
    coverImagePath: String(formData.get("coverImagePath") || "").trim(),
    youtubeUrl: normalizeYouTubeInput(formData.get("youtubeUrl")),
    documentUrl: String(formData.get("documentUrl") || "").trim(),
    documentName: String(formData.get("documentName") || "").trim(),
    documentPath: String(formData.get("documentPath") || "").trim(),
    status,
    featured: formData.get("featured") === "on",
    showOnHome: formData.get("showOnHome") === "on",
    order: Number(formData.get("order") || existing.order || 1),
    publishedAt: status === "published" ? existing.publishedAt || now : "",
    createdAt: existing.createdAt || now,
    updatedAt: now
  };
}

function siteNavigationPayload(formData) {
  const selected = new Set(formData.getAll("visibleTabs").map((value) => String(value || "")));
  const visibleTabs = {};
  PUBLIC_NAV_TABS.forEach((tab) => {
    visibleTabs[tab.id] = selected.has(tab.id);
  });
  return normalizeSiteNavigation({ visibleTabs, updatedAt: new Date().toISOString() });
}

async function saveSiteNavigation(payload) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const normalized = normalizeSiteNavigation(payload);
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "siteSettings", "navigation"), normalized, { merge: true });
    loadedPublicCollections.add("siteNavigation");
    stalePublicCollections.delete("siteNavigation");
  }

  state.siteNavigation = normalized;
  state.siteNavigationReady = true;
  if (!state.firebaseEnabled) persistLocalContent();
  showToast("Public tab visibility saved.");
  render();
  return true;
}
function codingMetaPayload(formData) {
  const payload = {
    types: parseCodingMetaOptions(formData, "types"),
    difficulties: parseCodingMetaOptions(formData, "difficulties"),
    categories: parseCodingMetaOptions(formData, "categories"),
    updatedAt: new Date().toISOString()
  };

  if (!payload.types.length) throw new Error("Add at least one coding practice type.");
  if (!payload.difficulties.length) throw new Error("Add at least one difficulty level.");
  if (!payload.categories.length) throw new Error("Add at least one category / section.");

  return normalizeCodingMeta(payload);
}

function parseCodingMetaOptions(formData, listName) {
  const ids = formData.getAll(`${listName}Id`);
  const labels = formData.getAll(`${listName}Label`);
  const orders = formData.getAll(`${listName}Order`);
  const seenLabels = new Set();
  const rows = [];

  labels.forEach((labelValue, index) => {
    const label = String(labelValue || "").trim();
    if (!label) return;
    const labelKey = label.toLowerCase();
    if (seenLabels.has(labelKey)) {
      throw new Error(`Remove duplicate ${titleCaseListName(listName)} value: ${label}.`);
    }
    seenLabels.add(labelKey);
    rows.push({
      id: normalizeCodingMetaId(ids[index] || label),
      label,
      order: Number(orders[index] || rows.length + 1)
    });
  });

  return rows.map((row, index) => ({ ...row, order: Number(row.order || index + 1) }));
}

async function saveCodingMeta(payload) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const normalized = normalizeCodingMeta(payload);
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "siteSettings", "codingPractice"), normalized, { merge: true });
  }

  state.codingMeta = normalized;
  state.codingProblems = state.codingProblems.map((item, index) => normalizeCodingProblem(item, index + 1));
  if (!state.firebaseEnabled) persistLocalContent();
  showToast("Coding setup saved.");
  render();
  return true;
}
function codingProblemPayload(formData) {
  const now = new Date().toISOString();
  const existing = state.codingProblems.find((item) => item.id === state.editingId || item.slug === state.editingId) || {};
  const title = String(formData.get("title") || "").trim();
  const slug = slugify(formData.get("slug") || title);
  const kind = normalizeCodingTypeId(formData.get("kind") || "dsa");
  const difficulty = normalizeCodingDifficultyId(formData.get("difficulty") || "medium");
  const prompt = String(formData.get("prompt") || "").trim();
  const testCases = parseCodingPracticeTestCasesInput(formData.get("testCasesSource"));
  if (!title) throw new Error("Add a problem title.");
  if (!prompt) throw new Error("Add a problem statement.");
  if (!testCases.length) throw new Error("Add at least one test case.");
  return normalizeCodingProblem({
    id: slug,
    title,
    slug,
    kind,
    difficulty,
    category: String(formData.get("category") || "General Practice").trim(),
    companies: splitTags(formData.get("companies")),
    prompt,
    constraints: splitLines(formData.get("constraintsSource")),
    testCases,
    status: String(formData.get("status") || "draft"),
    order: Number(formData.get("order") || existing.order || state.codingProblems.length + 1),
    createdAt: existing.createdAt || now,
    updatedAt: now
  }, state.codingProblems.length + 1);
}
function getContentTypeLabel(type) {
  if (type === "articles") return "Tutorial";
  if (type === "blogs") return "Blog";
  if (type === "codingProblems") return "Coding Problem";
  if (type === "tutorials") return "Course";
  return "Content";
}
function tutorialPayload(formData) {
  const now = new Date().toISOString();
  const existing = state.tutorials.find((item) => item.id === state.editingId) || {};
  const title = String(formData.get("title") || "").trim();
  const slug = slugify(formData.get("slug") || title);

  return {
    id: slug,
    title,
    slug,
    description: String(formData.get("description") || "").trim(),
    outcome: String(formData.get("outcome") || "").trim(),
    category: String(formData.get("category") || "General").trim(),
    level: String(formData.get("level") || "Beginner").trim(),
    duration: String(formData.get("duration") || "").trim(),
    originalPrice: String(formData.get("originalPrice") || "").trim(),
    finalPrice: String(formData.get("finalPrice") || "").trim(),
    topics: splitTopics(formData.get("topics")),
    coverImage: String(formData.get("coverImage") || "").trim(),
    coverImagePath: String(formData.get("coverImagePath") || "").trim(),
    status: String(formData.get("status") || "draft"),
    hiddenFromPublic: formData.get("hiddenFromPublic") === "on",
    showOnHome: formData.get("showOnHome") === "on",
    order: Number(formData.get("order") || existing.order || 1),
    createdAt: existing.createdAt || now,
    updatedAt: now
  };
}

function subjectPayload(formData) {
  const now = new Date().toISOString();
  const existing = findSubjectById(state.editingSubjectId);
  const title = String(formData.get("title") || "").trim();
  const slug = slugify(title);

  return {
    id: existing?.id || slug,
    title,
    slug,
    order: Number(formData.get("order") || existing?.order || getAdminSubjects().length + 1),
    coverImage: String(formData.get("coverImage") || "").trim(),
    coverImagePath: String(formData.get("coverImagePath") || "").trim(),
    hiddenFromPublic: formData.get("hiddenFromPublic") === "on",
    sections: normalizeSubjectSections(existing?.sections || []),
    createdAt: existing?.createdAt || now,
    updatedAt: now
  };
}

// Puts `section` at a 1-based position among the others (clamped to the
// list), replacing any entry with the same id, and renumbers every order to
// match. Add and edit both use it, so position 1 always means first.
function placeSectionAt(sections, section, position) {
  const others = sections.filter((item) => item.id !== section.id);
  const index = clamp((Number(position) || others.length + 1) - 1, 0, others.length);
  const placed = [...others];
  placed.splice(index, 0, section);
  return placed.map((item, order) => ({ ...item, order: order + 1 }));
}

async function addSectionToExistingSubject(formData) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const subjectId = String(formData.get("subjectId") || "").trim();
  const title = String(formData.get("sectionTitle") || "").trim();
  const subject = findSubjectById(subjectId);
  if (!subject) {
    showToast("Select a valid existing Subject ID.");
    return false;
  }
  if (!title) {
    showToast("Add a section name.");
    return false;
  }

  const sections = normalizeSubjectSections(subject.sections || []);
  const slug = slugify(title);
  if (!slug) {
    showToast("Use letters or numbers in the section name.");
    return false;
  }
  const duplicate = sections.find(
    (section) => section.id === slug || section.title.toLowerCase() === title.toLowerCase()
  );
  if (duplicate) {
    showToast("This section already exists for the selected subject.");
    return false;
  }

  const requestedOrder = Number(formData.get("sectionOrder") || 0);
  return saveSubjectSections(
    subject,
    placeSectionAt(sections, { id: slug, title }, requestedOrder || sections.length + 1),
    `Section added to ${subject.title}.`
  );
}
async function updateExistingSubjectSection(formData) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const subjectId = String(formData.get("subjectId") || "").trim();
  const sectionId = String(formData.get("sectionId") || "").trim();
  const title = String(formData.get("sectionTitle") || "").trim();
  const requestedOrder = Number(formData.get("sectionOrder") || 0);
  const subject = findSubjectById(subjectId);
  if (!subject) {
    showToast("Select a valid existing Subject ID.");
    return false;
  }
  if (!sectionId || !normalizeSubjectSections(subject.sections || []).some((section) => section.id === sectionId)) {
    showToast("Section not found.");
    return false;
  }
  if (!title) {
    showToast("Add a section name.");
    return false;
  }

  const sections = normalizeSubjectSections(subject.sections || []);
  const duplicate = sections.find((section) => section.id !== sectionId && section.title.toLowerCase() === title.toLowerCase());
  if (duplicate) {
    showToast("Another section with this name already exists for this subject.");
    return false;
  }

  const currentIndex = sections.findIndex((section) => section.id === sectionId);
  return saveSubjectSections(
    subject,
    placeSectionAt(sections, { ...sections[currentIndex], title }, requestedOrder || currentIndex + 1),
    "Section updated."
  );
}

async function moveExistingSubjectSection(subjectId, sectionId, direction) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const subject = findSubjectById(subjectId);
  if (!subject) {
    showToast("Subject not found.");
    return false;
  }

  const sections = normalizeSubjectSections(subject.sections || []);
  const currentIndex = sections.findIndex((section) => section.id === sectionId);
  if (currentIndex < 0) {
    showToast("Section not found.");
    return false;
  }

  const nextIndex = clamp(currentIndex + Number(direction || 0), 0, sections.length - 1);
  if (nextIndex === currentIndex) return false;

  const reorderedSections = [...sections];
  const [movedSection] = reorderedSections.splice(currentIndex, 1);
  reorderedSections.splice(nextIndex, 0, movedSection);

  return saveSubjectSections(subject, reorderedSections, "Section order updated.");
}

async function deleteExistingSubjectSection(subjectId, sectionId) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const subject = findSubjectById(subjectId);
  if (!subject) {
    showToast("Subject not found.");
    return false;
  }

  const sections = normalizeSubjectSections(subject.sections || []);
  const section = sections.find((item) => item.id === sectionId);
  if (!section) {
    showToast("Section not found.");
    return false;
  }

  const updatedSections = sections.filter((item) => item.id !== sectionId);
  return saveSubjectSections(subject, updatedSections, "Section deleted.");
}

async function saveSubjectSections(subject, sections, successMessage) {
  const orderedInput = sections.map((section, index) => ({ ...section, order: index + 1 }));
  const updatedSections = normalizeSubjectSections(orderedInput).map((section, index) => ({ ...section, order: index + 1 }));
  const updatedAt = new Date().toISOString();

  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "subjects", subject.id), { sections: updatedSections, updatedAt }, { merge: true });
    await loadContent({ admin: true });
  } else {
    const finalPayload = normalizeSubject({ ...subject, sections: updatedSections, updatedAt });
    const updatedSubjects = state.subjects.filter((item) => {
      const normalized = normalizeSubject(item);
      return normalized.id !== finalPayload.id && normalized.slug !== finalPayload.slug;
    });
    state.subjects = getNormalizedSubjects([...updatedSubjects, finalPayload], state.articles);
    persistLocalContent();
  }

  state.adminType = "sections";
  state.editingSubjectId = null;
  state.activeSubjectId = subject.id;
  state.sectionModal = null;
  showToast(successMessage);
  render();
  return true;
}
async function saveItem(type, payload) {
  const asContributor = !state.isAdmin && state.isContributor && CONTRIBUTABLE_COLLECTIONS.includes(type);
  if (!state.isAdmin && !asContributor) {
    showToast("Admin access is required.");
    return false;
  }

  const oldId = state.editingId;
  const previousItem = state[type].find((item) => item.id === oldId || item.id === payload.id);
  if (asContributor) {
    const editing = state[type].find((item) => item.id === oldId);
    if (editing && !canContributorEdit(editing)) {
      showToast("This item is published, so only the admin can change it now.");
      return false;
    }
    if (state[type].some((item) => item.id === payload.id && item.id !== oldId)) {
      showToast("Something with this title already exists. Choose a different title.");
      return false;
    }
    if (!isContributorEmailConfirmed()) {
      showToast("Confirm your email before saving drafts.");
      return false;
    }
    payload = applyContributorDraft(payload, editing);
  }

  if (state.firebaseEnabled) {
    const { deleteDoc, doc, setDoc } = firebase.api;
    // Older contributor drafts stored the contributor's email, which is
    // public once published; the admin's save removes it.
    const written = !asContributor && previousItem?.submittedByUid ? { ...payload, submittedByEmail: firebase.api.deleteField() } : payload;
    try {
      await setDoc(doc(firebase.db, type, payload.id), written, { merge: true });
    } catch (error) {
      // The id can belong to someone else's draft, which a contributor cannot
      // see or overwrite.
      if (asContributor && error?.code === "permission-denied") {
        showToast("Could not save this draft. Another item may already use this title, so try a different one.");
        return false;
      }
      throw error;
    }
    if (oldId && oldId !== payload.id) {
      await deleteDoc(doc(firebase.db, type, oldId));
    }
    await loadContent({ admin: true });
  } else {
    const list = state[type].filter((item) => item.id !== oldId && item.id !== payload.id);
    state[type] = [payload, ...list].map((item) => normalizeItem(item, type));
    persistLocalContent();
  }

  // Only the admin's saves remove replaced files: contributors cannot delete
  // stored files, and an old upload on a draft does no harm.
  if (!asContributor) await cleanupReplacedStorageFiles(previousItem, payload);
  state.editingId = payload.id;
  if (type === "articles") {
    const subject = getAdminSubjects().find((item) => item.title === payload.category);
    if (subject) state.activeSubjectId = subject.id;
  }
  showToast(asContributor ? "Draft saved. The admin will review it." : `${getContentTypeLabel(type)} saved.`);
  render();
  return true;
}

async function saveSubject(payload) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  if (!payload.title || !payload.slug) {
    showToast("Add a subject name.");
    return false;
  }

  const existingSubject = findSubjectById(state.editingSubjectId);
  const duplicate = getAdminSubjects().find(
    (subject) =>
      subject.id !== existingSubject?.id
      && (subject.slug === payload.slug || subject.title.toLowerCase() === payload.title.toLowerCase())
  );
  if (duplicate) {
    showToast("Subject already exists. Use Edit on that subject instead.");
    return false;
  }

  const finalPayload = {
    ...existingSubject,
    ...payload,
    createdAt: existingSubject?.createdAt || payload.createdAt
  };
  const previousSubject = existingSubject ? { ...existingSubject } : null;
  const oldTitle = existingSubject?.title || "";

  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "subjects", finalPayload.id), finalPayload, { merge: true });
    await updateTutorialSubjectCategory(oldTitle, finalPayload.title, finalPayload.updatedAt);
    await loadContent({ admin: true });
  } else {
    const updatedSubjects = state.subjects.filter((subject) => {
      const normalized = normalizeSubject(subject);
      return normalized.id !== finalPayload.id
        && normalized.slug !== finalPayload.slug
        && normalized.id !== existingSubject?.id
        && normalized.slug !== existingSubject?.slug;
    });
    if (oldTitle && oldTitle !== finalPayload.title) {
      state.articles = state.articles.map((article) =>
        article.category === oldTitle
          ? normalizeItem({ ...article, category: finalPayload.title, updatedAt: finalPayload.updatedAt }, "articles")
          : article
      );
    }
    state.subjects = getNormalizedSubjects([...updatedSubjects, finalPayload], state.articles);
    persistLocalContent();
  }

  await cleanupReplacedStorageFiles(previousSubject, finalPayload);
  state.editingSubjectId = null;
  state.activeSubjectId = finalPayload.id;
  showToast(existingSubject ? "Subject updated." : "Subject added.");
  render();
  return true;
}

async function toggleSubjectPublicVisibility(id, hiddenFromPublic) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const subject = findSubjectById(id);
  if (!subject) {
    showToast("Subject not found.");
    return false;
  }

  const updatedAt = new Date().toISOString();
  const finalPayload = normalizeSubject({ ...subject, hiddenFromPublic: Boolean(hiddenFromPublic), updatedAt });

  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "subjects", finalPayload.id), finalPayload, { merge: true });
    await loadContent({ admin: true });
  } else {
    const updatedSubjects = state.subjects.filter((item) => {
      const normalized = normalizeSubject(item);
      return normalized.id !== finalPayload.id && normalized.slug !== finalPayload.slug;
    });
    state.subjects = getNormalizedSubjects([...updatedSubjects, finalPayload], state.articles);
    persistLocalContent();
  }

  state.adminType = "subjects";
  state.editingSubjectId = null;
  state.activeSubjectId = finalPayload.id;
  showToast(finalPayload.hiddenFromPublic ? "Subject hidden from public website." : "Subject visible on public website.");
  render();
  return true;
}
// Hiding keeps the course and its Published/Draft status; it only takes the
// course off the public pages until it is shown again.
async function toggleCourseVisibility(id, hiddenFromPublic) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return false;
  }

  const course = state.tutorials.find((item) => item.id === id);
  if (!course) {
    showToast("Course not found.");
    return false;
  }

  const updatedAt = new Date().toISOString();
  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await setDoc(doc(firebase.db, "tutorials", course.id), { hiddenFromPublic: Boolean(hiddenFromPublic), updatedAt }, { merge: true });
    await loadContent({ admin: true });
  } else {
    state.tutorials = state.tutorials.map((item) => (item.id === course.id
      ? normalizeItem({ ...item, hiddenFromPublic: Boolean(hiddenFromPublic), updatedAt }, "tutorials")
      : item));
    persistLocalContent();
  }

  showToast(hiddenFromPublic ? `${course.title} is hidden from the public website.` : `${course.title} is visible on the public website.`);
  render();
  return true;
}

async function moveOrderedItem(type, id, direction) {
  if (!state.isAdmin || ![-1, 1].includes(direction)) return;
  const isSubject = type === "subjects";
  const isCodingProblem = type === "codingProblems";
  const target = isSubject
    ? getAdminSubjects().find((item) => item.id === id || item.slug === id)
    : isCodingProblem
      ? state.codingProblems.find((item) => item.id === id || item.slug === id)
      : state.articles.find((item) => item.id === id);
  if (!target) return;
  const targetSubject = isSubject || isCodingProblem ? null : getSubjectByTitle(target.category);
  const targetSectionId = isSubject || isCodingProblem ? "" : getTutorialSectionId(target, targetSubject);
  const orderedItems = isSubject
    ? sortByOrder(getAdminSubjects())
    : isCodingProblem
      ? sortByOrder(state.codingProblems)
      : sortByOrder(state.articles.filter((item) => item.category === target.category && getTutorialSectionId(item, targetSubject) === targetSectionId));
  const currentIndex = orderedItems.findIndex((item) => item.id === target.id);
  const nextIndex = currentIndex + direction;
  if (currentIndex < 0 || nextIndex < 0 || nextIndex >= orderedItems.length) return;
  [orderedItems[currentIndex], orderedItems[nextIndex]] = [orderedItems[nextIndex], orderedItems[currentIndex]];
  const resequenced = orderedItems.map((item, index) => ({ ...item, order: index + 1 }));
  if (state.firebaseEnabled) {
    const collectionName = isSubject ? "subjects" : isCodingProblem ? "codingProblems" : "articles";
    const updatedAt = new Date().toISOString();
    const { doc, setDoc } = firebase.api;
    await Promise.all(resequenced.map((item) => setDoc(doc(firebase.db, collectionName, item.id), { order: item.order, updatedAt }, { merge: true })));
    await loadContent({ admin: true });
  } else if (isSubject) {
    const orderMap = new Map(resequenced.map((item) => [item.id, item.order]));
    state.subjects = state.subjects.map((item) => {
      const normalized = normalizeSubject(item);
      return orderMap.has(normalized.id) ? { ...normalized, order: orderMap.get(normalized.id) } : normalized;
    });
    persistLocalContent();
  } else if (isCodingProblem) {
    const orderMap = new Map(resequenced.map((item) => [item.id, item.order]));
    state.codingProblems = state.codingProblems.map((item) => orderMap.has(item.id) ? normalizeItem({ ...item, order: orderMap.get(item.id) }, "codingProblems") : item);
    persistLocalContent();
  } else {
    const orderMap = new Map(resequenced.map((item) => [item.id, item.order]));
    state.articles = state.articles.map((item) => orderMap.has(item.id) ? normalizeItem({ ...item, order: orderMap.get(item.id) }, "articles") : item);
    persistLocalContent();
  }
  showToast(`${isSubject ? "Subject" : isCodingProblem ? "Coding problem" : "Tutorial"} order updated.`);
  render();
}
async function updateTutorialSubjectCategory(oldTitle, newTitle, updatedAt) {
  if (!oldTitle || oldTitle === newTitle) return;

  const affectedTutorials = state.articles.filter((article) => article.category === oldTitle);
  if (!affectedTutorials.length) return;

  if (state.firebaseEnabled) {
    const { doc, setDoc } = firebase.api;
    await Promise.all(
      affectedTutorials.map((article) =>
        setDoc(doc(firebase.db, "articles", article.id), { category: newTitle, updatedAt }, { merge: true })
      )
    );
    return;
  }

  state.articles = state.articles.map((article) =>
    article.category === oldTitle
      ? normalizeItem({ ...article, category: newTitle, updatedAt }, "articles")
      : article
  );
}

async function deleteItem(type, id) {
  const item = state[type]?.find((candidate) => candidate.id === id);
  const asContributor = !state.isAdmin && state.isContributor && CONTRIBUTABLE_COLLECTIONS.includes(type);
  if (!state.isAdmin && !(asContributor && item && canContributorEdit(item))) {
    showToast(asContributor ? "Only drafts you wrote can be removed." : "Admin access is required.");
    return;
  }

  if (state.firebaseEnabled) {
    await firebase.api.deleteDoc(firebase.api.doc(firebase.db, type, id));
    if (!asContributor) await deleteStoredFiles([
      item?.coverImagePath,
      item?.documentPath,
      ...extractInlineStoragePaths(item?.body)
    ]);
    await loadContent({ admin: true });
  } else {
    state[type] = state[type].filter((item) => item.id !== id);
    persistLocalContent();
  }

  if (state.editingId === id) state.editingId = null;
  showToast("Deleted.");
  render();
}

async function deleteSubject(id) {
  if (!state.isAdmin) {
    showToast("Admin access is required.");
    return;
  }

  const subject = getAdminSubjects().find((item) => item.id === id || item.slug === id);
  if (!subject) {
    showToast("Subject not found.");
    return;
  }

  const tutorialCount = state.articles.filter((article) => article.category === subject.title).length;
  if (tutorialCount > 0) {
    showToast("Move or delete tutorials before deleting this subject.");
    return;
  }

  if (state.firebaseEnabled) {
    await firebase.api.deleteDoc(firebase.api.doc(firebase.db, "subjects", subject.id));
    await deleteStoredFiles([subject.coverImagePath]);
    await loadContent({ admin: true });
  } else {
    state.subjects = state.subjects.filter((item) => {
      const normalized = normalizeSubject(item);
      return normalized.id !== subject.id && normalized.slug !== subject.slug;
    });
    persistLocalContent();
  }

  if (state.editingSubjectId === subject.id || state.editingSubjectId === subject.slug) {
    state.editingSubjectId = null;
  }
  if (state.activeSubjectId === subject.id || state.activeSubjectId === subject.slug) {
    state.activeSubjectId = "";
  }
  showToast("Subject removed.");
  render();
}

async function handleFileUpload(input) {
  const file = input.files?.[0];
  if (!file) return;

  const form = input.closest("[data-admin-form], [data-subject-form], [data-community-form], [data-event-form], [data-session-form]");
  if (!form) {
    input.value = "";
    return;
  }

  const isDocument = input.matches("[data-document-upload]");
  beginLoading(`Uploading ${isDocument ? "document" : "image"}...`);
  try {
    showToast(`Uploading ${isDocument ? "document" : "image"}...`);
    const upload = await uploadFileToFirebase(file, input, form);

    if (input.dataset.uploadTarget) {
      // Target the field by name so the same handler serves coverImage,
      // the community logoImage, and any future image field.
      applyImageToField(form, input.dataset.uploadTarget, upload.url, upload.path);
      showToast("Image uploaded. Save to publish it.");
    } else if (input.matches("[data-rich-image-upload]")) {
      const target = form.querySelector("[data-rich-image-url]");
      if (target) target.value = upload.url;
      const editor = form.querySelector("[data-rich-editor]");
      const altInput = form.querySelector("[data-rich-image-alt]");
      if (editor) {
        insertRichImage(editor, upload.url, altInput?.value || "");
        closeRichImagePanel(form);
        syncRichEditor(form);
        if (target) target.value = "";
        if (altInput) altInput.value = "";
        showToast("Image uploaded and inserted. Save to publish it.");
      } else {
        showToast("Image uploaded. Add alt text, then insert.");
      }
    } else if (isDocument) {
      const urlTarget = form.querySelector('input[name="documentUrl"]');
      const nameTarget = form.querySelector('input[name="documentName"]');
      const pathTarget = form.querySelector('input[name="documentPath"]');
      if (urlTarget) urlTarget.value = upload.url;
      if (nameTarget) nameTarget.value = file.name;
      if (pathTarget) pathTarget.value = upload.path;
      updateDocumentPreview(form, { documentUrl: upload.url, documentName: file.name });
      showToast("Document uploaded. Save to publish it.");
    }
  } catch (error) {
    showToast(formatStorageError(error));
  } finally {
    input.value = "";
    endLoading();
  }
}

async function handleTutorialImport(input) {
  const file = input.files?.[0];
  if (!file) return;

  const form = input.closest("[data-admin-form]");
  const editor = form?.querySelector("[data-rich-editor]");
  if (!form || !editor) {
    input.value = "";
    return;
  }

  if (hasRichContent(getCleanRichEditorHtml(editor))) {
    const confirmed = window.confirm("Replace the current tutorial body with imported file content?");
    if (!confirmed) {
      input.value = "";
      return;
    }
  }

  beginLoading("Importing " + file.name + "...");
  try {
    const imported = await importTutorialFile(file, form);
    if (!hasRichContent(imported.html)) {
      throw new Error("The selected file does not contain readable tutorial content.");
    }

    imported.html = enhanceCodeBlocksInHtml(imported.html);
    editor.innerHTML = imported.html;
    normalizeEditorLinks(editor);
    clearRichImageSelection(form);
    syncRichEditor(form);
    applyImportedTutorialMeta(form, imported, file);
    showToast("Imported " + file.name + ". Review and save the tutorial.");
  } catch (error) {
    console.error(error);
    showToast(error?.message || "Could not import this tutorial file.");
  } finally {
    input.value = "";
    endLoading();
  }
}

async function importTutorialFile(file, form) {
  const extension = getFileExtension(file.name);
  validateTutorialImportFile(file, extension);
  updateLoading("Reading " + file.name + "...");

  if (["md", "markdown"].includes(extension)) {
    const markdown = await file.text();
    const html = sanitizeRichHtml(renderMarkdown(markdown));
    return { html, title: extractTitleFromHtml(html) || getFileBaseName(file.name) };
  }

  if (extension === "ipynb") {
    return importNotebookFile(file, form);
  }

  if (extension === "docx") {
    return importDocxFile(file, form);
  }

  if (extension === "doc") {
    throw new Error("Legacy .doc files cannot be imported in the browser. Save the document as .docx and import again.");
  }

  throw new Error("Choose a Markdown, Jupyter Notebook, or Word .docx file.");
}

function validateTutorialImportFile(file, extension) {
  if (!TUTORIAL_IMPORT_EXTENSIONS.has(extension)) {
    throw new Error("Choose a Markdown, Jupyter Notebook, or Word .docx file.");
  }
  if (file.size > MAX_TUTORIAL_IMPORT_SIZE) {
    throw new Error("Use an import file smaller than 30 MB.");
  }
}

function applyImportedTutorialMeta(form, imported, file) {
  const titleInput = form.querySelector('input[name="title"]');
  const excerptInput = form.querySelector('textarea[name="excerpt"]');
  const title = imported.title || getFileBaseName(file.name);

  if (titleInput && !titleInput.value.trim()) {
    titleInput.value = title;
  }

  if (excerptInput && !excerptInput.value.trim()) {
    excerptInput.value = createExcerptFromHtml(imported.html);
  }
}

// Excerpts auto-filled on import read "...Step-by-Step TutorialThis tutorial
// ... emptyAndroid project: **search": the document's title heading came
// first, textContent joins block elements with no space between them, and
// Markdown markers survived conversion. Build the excerpt from the prose
// only (no headings or code), keep a space at every block boundary, drop
// leftover markers, and cut at a word boundary.
function createExcerptFromHtml(html) {
  const spaceBlocks = (value) => value.replace(/<br\s*\/?>|<\/(?:p|div|li|blockquote|ul|ol|section|article|h[1-6])>/gi, "$& ");
  const toText = (value) => getPlainText(spaceBlocks(value))
    .replace(/\*\*|__|`+/g, "")
    .replace(/(^|\s)#{1,6}\s+/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
  const source = String(html || "");
  const prose = toText(source.replace(/<(h[1-6]|pre|figure|table|script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, " "));
  return summarizeFormattedText(prose || toText(source), 180);
}

async function importNotebookFile(file, form) {
  let notebook;
  try {
    notebook = JSON.parse(await file.text());
  } catch {
    throw new Error("This .ipynb file could not be read. Check that it is a valid Jupyter Notebook.");
  }

  if (!Array.isArray(notebook.cells)) {
    throw new Error("This notebook does not contain readable cells.");
  }

  const parts = [];
  for (const [index, cell] of notebook.cells.entries()) {
    updateLoading("Importing notebook cell " + (index + 1) + " of " + notebook.cells.length + "...");
    const source = getNotebookSource(cell.source);
    if (cell.cell_type === "markdown") {
      parts.push(renderMarkdown(source));
    } else if (cell.cell_type === "code") {
      if (source.trim()) {
        parts.push("<pre><code>" + escapeHtml(source.trimEnd()) + "</code></pre>");
      }
      parts.push(await renderNotebookOutputs(cell.outputs, form, index));
    } else if (source.trim()) {
      parts.push("<p>" + formatInline(source.trim()) + "</p>");
    }
  }

  const html = sanitizeRichHtml(parts.filter(Boolean).join(""));
  return { html, title: extractTitleFromHtml(html) || getFileBaseName(file.name) };
}

function getNotebookSource(source) {
  return Array.isArray(source) ? source.join("") : String(source || "");
}

async function renderNotebookOutputs(outputs = [], form, cellIndex = 0) {
  if (!Array.isArray(outputs) || outputs.length === 0) return "";

  const parts = [];
  for (const [outputIndex, output] of outputs.entries()) {
    const data = output.data || {};
    const imageType = ["image/png", "image/jpeg", "image/webp", "image/gif"].find((type) => data[type]);
    if (imageType) {
      const imageFile = base64DataToFile(data[imageType], imageType, "notebook-output-" + (cellIndex + 1) + "-" + (outputIndex + 1));
      const upload = await uploadImportedEditorImage(imageFile, form, "Uploading notebook image");
      parts.push(renderImportedImage(upload.url, "Notebook output"));
      continue;
    }

    if (data["text/html"]) {
      parts.push(sanitizeRichHtml(getNotebookSource(data["text/html"])));
    } else if (data["text/markdown"]) {
      parts.push(renderMarkdown(getNotebookSource(data["text/markdown"])));
    } else if (data["text/plain"]) {
      parts.push("<pre><code>" + escapeHtml(getNotebookSource(data["text/plain"]).trimEnd()) + "</code></pre>");
    } else if (output.text) {
      parts.push("<pre><code>" + escapeHtml(getNotebookSource(output.text).trimEnd()) + "</code></pre>");
    } else if (Array.isArray(output.traceback)) {
      parts.push("<pre><code>" + escapeHtml(output.traceback.join("\n")) + "</code></pre>");
    }
  }

  return parts.join("");
}
async function importDocxFile(file, form) {
  if (!("DecompressionStream" in window)) {
    throw new Error("Word import needs a modern Chrome or Edge browser.");
  }

  updateLoading("Reading Word document...");
  const zip = await readZipPackage(await file.arrayBuffer());
  const documentXml = await zip.getText("word/document.xml");
  if (!documentXml) {
    throw new Error("This .docx file does not contain a readable Word document.");
  }

  const context = {
    form,
    zip,
    relationships: parseDocxRelationships(await zip.getText("word/_rels/document.xml.rels")),
    numbering: parseDocxNumbering(await zip.getText("word/numbering.xml")),
    imageCache: new Map()
  };
  const doc = parseXmlDocument(documentXml, "Word document");
  const body = findFirstByLocalName(doc.documentElement, "body");
  if (!body) {
    throw new Error("This .docx file does not contain readable body content.");
  }

  const parts = [];
  let openListType = "";
  for (const child of [...body.childNodes].filter((node) => node.nodeType === Node.ELEMENT_NODE)) {
    if (child.localName === "p") {
      const block = await renderDocxParagraph(child, context);
      if (block.listType) {
        if (openListType && openListType !== block.listType) {
          parts.push("</" + openListType + ">");
          openListType = "";
        }
        if (!openListType) {
          openListType = block.listType;
          parts.push("<" + openListType + ">");
        }
        parts.push("<li>" + (block.content || "<br>") + "</li>");
      } else {
        if (openListType) {
          parts.push("</" + openListType + ">");
          openListType = "";
        }
        if (block.html) parts.push(block.html);
      }
    } else if (child.localName === "tbl") {
      if (openListType) {
        parts.push("</" + openListType + ">");
        openListType = "";
      }
      parts.push(await renderDocxTable(child, context));
    }
  }
  if (openListType) parts.push("</" + openListType + ">");

  const html = sanitizeRichHtml(parts.join(""));
  return { html, title: extractTitleFromHtml(html) || getFileBaseName(file.name) };
}

async function renderDocxParagraph(paragraph, context) {
  const style = getDocxParagraphStyle(paragraph);
  const align = getDocxParagraphAlignment(paragraph);
  const listType = getDocxListType(paragraph, context.numbering);
  const content = await renderDocxInlineContent(paragraph, context);
  if (listType) return { listType, content };
  if (!content.trim()) return { html: "" };

  const tag = getDocxParagraphTag(style);
  const styleAttr = align ? ' style="text-align: ' + align + ';"' : "";
  if (tag === "blockquote") {
    return { html: "<blockquote" + styleAttr + ">" + content + "</blockquote>" };
  }
  return { html: "<" + tag + styleAttr + ">" + content + "</" + tag + ">" };
}

async function renderDocxInlineContent(parent, context) {
  const parts = [];
  for (const child of [...parent.childNodes].filter((node) => node.nodeType === Node.ELEMENT_NODE)) {
    if (child.localName === "r") {
      parts.push(await renderDocxRun(child, context));
    } else if (child.localName === "hyperlink") {
      const content = await renderDocxInlineContent(child, context);
      const relationshipId = child.getAttribute("r:id");
      const anchor = child.getAttribute("w:anchor");
      const href = relationshipId ? context.relationships.get(relationshipId)?.target : anchor ? "#" + anchor : "";
      const url = safeUrl(href);
      parts.push(url ? '<a href="' + escapeAttr(url) + '" target="_blank" rel="noreferrer">' + content + "</a>" : content);
    }
  }
  return parts.join("");
}

async function renderDocxRun(run, context) {
  const properties = getDirectChild(run, "rPr");
  const wrappers = [];
  if (hasDirectChild(properties, "b")) wrappers.push("strong");
  if (hasDirectChild(properties, "i")) wrappers.push("em");
  if (hasDirectChild(properties, "u")) wrappers.push("u");

  let content = "";
  for (const child of [...run.childNodes].filter((node) => node.nodeType === Node.ELEMENT_NODE)) {
    if (child.localName === "t") {
      content += escapeHtml(child.textContent || "");
    } else if (child.localName === "tab") {
      content += "&nbsp;&nbsp;&nbsp;&nbsp;";
    } else if (child.localName === "br") {
      content += "<br>";
    } else if (["drawing", "pict"].includes(child.localName)) {
      content += await renderDocxImage(child, context);
    }
  }

  return wrappers.reduce((html, tag) => "<" + tag + ">" + html + "</" + tag + ">", content);
}

async function renderDocxTable(table, context) {
  const rows = [];
  for (const row of getDirectChildren(table, "tr")) {
    const cells = [];
    for (const cell of getDirectChildren(row, "tc")) {
      const cellParts = [];
      for (const paragraph of getDirectChildren(cell, "p")) {
        const block = await renderDocxParagraph(paragraph, context);
        cellParts.push(block.content || block.html || "");
      }
      cells.push("<td>" + (cellParts.join("") || "<br>") + "</td>");
    }
    rows.push("<tr>" + cells.join("") + "</tr>");
  }
  return rows.length ? "<table><tbody>" + rows.join("") + "</tbody></table>" : "";
}

async function renderDocxImage(element, context) {
  const blip = findFirstByLocalName(element, "blip");
  const relationshipId = blip?.getAttribute("r:embed") || blip?.getAttribute("r:link");
  if (!relationshipId) return "";
  if (context.imageCache.has(relationshipId)) return context.imageCache.get(relationshipId);

  const relationship = context.relationships.get(relationshipId);
  if (!relationship) return "";

  if (relationship.targetMode === "External") {
    const url = safeUrl(relationship.target);
    const html = url ? renderImportedImage(url, "Imported document image") : "";
    context.imageCache.set(relationshipId, html);
    return html;
  }

  const entryPath = resolveZipPath("word/document.xml", relationship.target);
  const bytes = await context.zip.getBytes(entryPath);
  if (!bytes?.length) return "";

  const contentType = getImageContentType(entryPath);
  const imageFile = new File([bytes], getZipFileName(entryPath), { type: contentType });
  const upload = await uploadImportedEditorImage(imageFile, context.form, "Uploading Word image");
  const html = renderImportedImage(upload.url, getFileBaseName(entryPath) || "Imported document image");
  context.imageCache.set(relationshipId, html);
  return html;
}

function renderImportedImage(url, altText = "") {
  return '<figure data-image-figure="true" data-align="center" data-crop="original" style="text-align: center;">' +
    '<span data-image-frame="true" data-width="100" style="width: 100%;">' +
    '<img src="' + escapeAttr(url) + '" alt="' + escapeAttr(altText) + '" loading="lazy" data-width="100" style="width: 100%;">' +
    '</span>' +
    (altText ? '<figcaption>' + escapeHtml(altText) + '</figcaption>' : "") +
    '</figure>';
}

function getDocxParagraphStyle(paragraph) {
  const style = findFirstByLocalName(getDirectChild(paragraph, "pPr"), "pStyle");
  return getDocxValue(style).replace(/\s+/g, "").toLowerCase();
}

function getDocxParagraphAlignment(paragraph) {
  const alignment = findFirstByLocalName(getDirectChild(paragraph, "pPr"), "jc");
  const value = getDocxValue(alignment).toLowerCase();
  if (value === "both") return "justify";
  return ["left", "center", "right", "justify"].includes(value) ? value : "";
}

function getDocxParagraphTag(style) {
  if (/^(title|heading1|h1)$/.test(style)) return "h1";
  if (/^(subtitle|heading2|h2)$/.test(style)) return "h2";
  if (/^(heading3|h3)$/.test(style)) return "h3";
  if (/^(heading4|h4)$/.test(style)) return "h4";
  if (/quote/.test(style)) return "blockquote";
  return "p";
}

function getDocxListType(paragraph, numbering) {
  const numPr = findFirstByLocalName(getDirectChild(paragraph, "pPr"), "numPr");
  if (!numPr) return "";
  const numId = getDocxValue(findFirstByLocalName(numPr, "numId"));
  const level = getDocxValue(findFirstByLocalName(numPr, "ilvl")) || "0";
  const format = numbering.get(numId + ":" + level) || numbering.get(numId + ":0") || "bullet";
  return /decimal|number|lowerLetter|upperLetter|lowerRoman|upperRoman/i.test(format) ? "ol" : "ul";
}

function parseDocxRelationships(xmlText) {
  const relationships = new Map();
  if (!xmlText) return relationships;
  const doc = parseXmlDocument(xmlText, "Word relationships");
  [...doc.documentElement.children].forEach((relationship) => {
    relationships.set(relationship.getAttribute("Id"), {
      target: relationship.getAttribute("Target") || "",
      targetMode: relationship.getAttribute("TargetMode") || ""
    });
  });
  return relationships;
}

function parseDocxNumbering(xmlText) {
  const numbering = new Map();
  if (!xmlText) return numbering;
  const doc = parseXmlDocument(xmlText, "Word numbering");
  const abstractFormats = new Map();

  getDirectChildren(doc.documentElement, "abstractNum").forEach((abstractNum) => {
    const abstractId = getDocxValue(abstractNum, "abstractNumId");
    getDirectChildren(abstractNum, "lvl").forEach((level) => {
      const levelId = getDocxValue(level, "ilvl") || "0";
      const format = getDocxValue(findFirstByLocalName(level, "numFmt")) || "bullet";
      abstractFormats.set(abstractId + ":" + levelId, format);
    });
  });

  getDirectChildren(doc.documentElement, "num").forEach((num) => {
    const numId = getDocxValue(num, "numId");
    const abstractId = getDocxValue(findFirstByLocalName(num, "abstractNumId"));
    for (const [key, format] of abstractFormats.entries()) {
      const [candidateAbstractId, level] = key.split(":");
      if (candidateAbstractId === abstractId) numbering.set(numId + ":" + level, format);
    }
  });

  return numbering;
}
async function readZipPackage(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  const view = new DataView(arrayBuffer);
  const eocdOffset = findZipEndOfCentralDirectory(view);
  if (eocdOffset < 0) throw new Error("This .docx file is not a readable ZIP package.");

  const entryCount = view.getUint16(eocdOffset + 10, true);
  const centralDirectoryOffset = view.getUint32(eocdOffset + 16, true);
  const entries = new Map();
  let offset = centralDirectoryOffset;

  for (let index = 0; index < entryCount; index += 1) {
    if (view.getUint32(offset, true) !== 0x02014b50) break;
    const method = view.getUint16(offset + 10, true);
    const compressedSize = view.getUint32(offset + 20, true);
    const uncompressedSize = view.getUint32(offset + 24, true);
    const nameLength = view.getUint16(offset + 28, true);
    const extraLength = view.getUint16(offset + 30, true);
    const commentLength = view.getUint16(offset + 32, true);
    const localHeaderOffset = view.getUint32(offset + 42, true);
    const name = new TextDecoder("utf-8").decode(bytes.slice(offset + 46, offset + 46 + nameLength));
    entries.set(name, { method, compressedSize, uncompressedSize, localHeaderOffset, data: null });
    offset += 46 + nameLength + extraLength + commentLength;
  }

  return {
    async getBytes(name) {
      const entry = entries.get(name);
      if (!entry) return null;
      if (entry.data) return entry.data;
      entry.data = await extractZipEntry(bytes, view, entry);
      return entry.data;
    },
    async getText(name) {
      const data = await this.getBytes(name);
      return data ? new TextDecoder("utf-8").decode(data) : "";
    }
  };
}

function findZipEndOfCentralDirectory(view) {
  const minOffset = Math.max(0, view.byteLength - 0x10000 - 22);
  for (let offset = view.byteLength - 22; offset >= minOffset; offset -= 1) {
    if (view.getUint32(offset, true) === 0x06054b50) return offset;
  }
  return -1;
}

async function extractZipEntry(bytes, view, entry) {
  const offset = entry.localHeaderOffset;
  if (view.getUint32(offset, true) !== 0x04034b50) return null;
  const nameLength = view.getUint16(offset + 26, true);
  const extraLength = view.getUint16(offset + 28, true);
  const dataStart = offset + 30 + nameLength + extraLength;
  const compressed = bytes.slice(dataStart, dataStart + entry.compressedSize);

  if (entry.method === 0) return compressed;
  if (entry.method !== 8) {
    throw new Error("This Word document uses an unsupported compression method.");
  }

  const stream = new Blob([compressed]).stream().pipeThrough(new DecompressionStream("deflate-raw"));
  const inflated = new Uint8Array(await new Response(stream).arrayBuffer());
  return entry.uncompressedSize ? inflated.slice(0, entry.uncompressedSize) : inflated;
}

function parseXmlDocument(xmlText, label) {
  const doc = new DOMParser().parseFromString(xmlText, "application/xml");
  if (doc.querySelector("parsererror")) {
    throw new Error(label + " could not be parsed.");
  }
  return doc;
}

function findFirstByLocalName(root, localName) {
  if (!root) return null;
  if (root.localName === localName) return root;
  return [...root.getElementsByTagName("*")].find((node) => node.localName === localName) || null;
}

function getDirectChild(root, localName) {
  return getDirectChildren(root, localName)[0] || null;
}

function getDirectChildren(root, localName) {
  if (!root) return [];
  return [...root.children].filter((child) => child.localName === localName);
}

function hasDirectChild(root, localName) {
  return Boolean(getDirectChild(root, localName));
}

function getDocxValue(element, attribute = "val") {
  if (!element) return "";
  return element.getAttribute("w:" + attribute) || element.getAttribute(attribute) || "";
}

function resolveZipPath(basePath, target) {
  if (!target) return "";
  if (/^https?:\/\//i.test(target)) return target;
  if (target.startsWith("/")) return target.slice(1);
  const baseParts = basePath.split("/").slice(0, -1);
  const targetParts = target.split("/");
  for (const part of targetParts) {
    if (!part || part === ".") continue;
    if (part === "..") baseParts.pop();
    else baseParts.push(part);
  }
  return baseParts.join("/");
}

function getImageContentType(path) {
  const extension = getFileExtension(path);
  const types = {
    avif: "image/avif",
    gif: "image/gif",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    webp: "image/webp"
  };
  return types[extension] || "image/png";
}

function base64DataToFile(value, contentType, baseName) {
  const base64 = getNotebookSource(value).replace(/\s+/g, "");
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  const extension = IMAGE_EXTENSION_BY_TYPE[contentType] || "png";
  return new File([bytes], baseName + "." + extension, { type: contentType });
}

function getFileExtension(fileName) {
  const match = String(fileName || "").toLowerCase().match(/\.([a-z0-9]+)$/);
  return match ? match[1] : "";
}

function getZipFileName(path) {
  return String(path || "file").split("/").pop() || "file";
}

function getFileBaseName(fileName) {
  return getZipFileName(fileName).replace(/\.[a-z0-9]+$/i, "").replace(/[-_]+/g, " ").trim();
}

function extractTitleFromHtml(html) {
  const template = document.createElement("template");
  template.innerHTML = sanitizeRichHtml(html);
  return template.content.querySelector("h1, h2, h3")?.textContent?.trim() || "";
}
function updateDocumentPreview(form, item = {}) {
  const preview = form?.querySelector("[data-document-preview]");
  if (!preview) return;

  const replacement = document.createElement("template");
  replacement.innerHTML = renderDocumentPreview(item).trim();
  preview.replaceWith(replacement.content.firstElementChild);
}

// Writes a chosen/uploaded image into a form's url + path inputs and
// refreshes the preview. `fieldName` is the url input's name; the stored
// storage path lives alongside it as `<fieldName>Path`.
function applyImageToField(form, fieldName, url, path = "") {
  if (!form || !fieldName) return;
  const target = form.querySelector(`input[name="${fieldName}"]`);
  const pathTarget = form.querySelector(`input[name="${fieldName}Path"]`);
  if (target) target.value = url;
  if (pathTarget) pathTarget.value = path;
  updateCoverPreview(form, url);
}

function updateCoverPreview(form, url) {
  const preview = form?.querySelector("[data-cover-preview]");
  if (!preview) return;

  const imageUrl = safeUrl(url);
  preview.classList.toggle("is-visible", Boolean(imageUrl));
  preview.classList.remove("has-error");
  preview.innerHTML = imageUrl
    ? `<img src="${escapeAttr(imageUrl)}" alt="" data-managed-image /><span>Cover preview</span>`
    : "<span>No cover image selected yet</span>";
}

async function uploadFileToFirebase(file, input, form) {
  if (!state.isAdmin && !state.isContributor) {
    throw new Error("Admin access is required.");
  }

  if (!state.firebaseEnabled) {
    throw new Error("Firebase Storage is not available. Check the Firebase configuration.");
  }
  await ensureFirebaseStorage();

  const isDocument = input.matches("[data-document-upload]");
  validateUploadFile(file, isDocument ? "document" : "image");
  const folder = getStorageFolder(input, form);
  const fileName = createStorageFileName(file.name);
  const objectPath = `${folder}/${fileName}`;
  return uploadStorageObject(file, objectPath, "Uploading " + (isDocument ? "document" : "image"));
}
async function uploadImportedEditorImage(file, form, label = "Uploading imported image") {
  if (!state.isAdmin && !state.isContributor) {
    throw new Error("Admin access is required.");
  }

  if (!state.firebaseEnabled) {
    throw new Error("Firebase Storage is required to import embedded images.");
  }
  await ensureFirebaseStorage();

  validateUploadFile(file, "image");
  const baseFolder = form?.dataset.contentType === "blogs" ? "blogs" : "tutorials";
  const folder = getStorageFolder({ dataset: { storageFolder: baseFolder } }, form) + "/imported-media";
  const objectPath = folder + "/" + createStorageFileName(file.name);
  return uploadStorageObject(file, objectPath, label);
}
async function uploadStorageObject(file, objectPath, progressLabel) {
  await ensureFirebaseStorage();
  const storageRef = firebase.api.ref(firebase.storage, objectPath);
  const metadata = {
    cacheControl: IMAGE_TYPES.has(file.type) ? "public,max-age=31536000,immutable" : "public,max-age=86400",
    customMetadata: {
      originalName: file.name,
      uploadedBy: state.user?.email || ADMIN_EMAIL
    }
  };
  if (file.type) metadata.contentType = file.type;

  const uploadTask = firebase.api.uploadBytesResumable(storageRef, file, metadata);
  const snapshot = await new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (progressSnapshot) => {
        const percent = progressSnapshot.totalBytes
          ? Math.round((progressSnapshot.bytesTransferred / progressSnapshot.totalBytes) * 100)
          : 0;
        updateLoading(progressLabel + "... " + percent + "%", percent);
      },
      reject,
      () => resolve(uploadTask.snapshot)
    );
  });
  updateLoading("Preparing uploaded file...", 100);

  return {
    url: await firebase.api.getDownloadURL(snapshot.ref),
    path: snapshot.ref.fullPath
  };
}

async function ensureFirebaseStorage() {
  if (!state.firebaseEnabled || !firebase.app) {
    throw new Error("Firebase Storage is not available. Check the Firebase configuration.");
  }

  if (firebase.storage) return firebase.storage;

  // Must come from the same bundled SDK as firebase-app.js. The CDN copy
  // pulls in its own firebase-app instance with a separate component
  // registry, so getStorage() on our locally-created app throws
  // "Service storage is not available".
  const storageModule = await import("./assets/firebase-10.12.2-v1/firebase-storage.js");
  firebase.storage = storageModule.getStorage(firebase.app);
  firebase.api = { ...firebase.api, ...storageModule };
  return firebase.storage;
}
function validateUploadFile(file, kind) {
  if (kind === "image") {
    if (!IMAGE_TYPES.has(file.type)) {
      throw new Error("Choose a JPG, PNG, WebP, GIF, or AVIF image.");
    }
    if (file.size > MAX_IMAGE_SIZE) {
      throw new Error("Use an image smaller than 5 MB.");
    }
    return;
  }

  const extension = file.name.split(".").pop()?.toLowerCase() || "";
  if (!DOCUMENT_EXTENSIONS.has(extension)) {
    throw new Error("Choose a PDF, Word, PowerPoint, Excel, or text document.");
  }
  if (file.size > MAX_DOCUMENT_SIZE) {
    throw new Error("Use a document smaller than 20 MB.");
  }
}

function getStorageFolder(input, form) {
  const baseFolder = slugify(input.dataset.storageFolder || "uploads");
  const title = form.querySelector('input[name="title"]')?.value || "";
  const entityId = baseFolder === "subjects"
    ? state.editingSubjectId || title
    : baseFolder === "communities"
      ? state.editingCommunityId || title
      : baseFolder === "events"
        ? state.editingEventId || title
        : state.editingId || title;
  const folder = `${baseFolder}/${slugify(entityId || "drafts")}`;
  // Contributors upload into a folder of their own (see storage.rules).
  return !state.isAdmin && state.isContributor && state.user ? `contributions/${state.user.uid}/${folder}` : folder;
}

// ---- Media library ----------------------------------------------------
//
// Lists images already uploaded to Firebase Storage so an admin can reuse
// one instead of uploading the same file again. The picker is appended to
// <body> and manages its own DOM rather than going through render(): the
// admin forms are rebuilt from saved data on every render, so re-rendering
// while a form is half-filled would throw away unsaved input.

const MEDIA_LIBRARY_FOLDERS = ["events", "communities", "subjects", "courses", "sessions", "blogs", "tutorials"];
const MEDIA_LIBRARY_MAX_ITEMS = 300;
const MEDIA_LIBRARY_IMAGE_PATTERN = /\.(png|jpe?g|webp|gif|avif)$/i;
let mediaLibraryCache = null;
let mediaLibraryNode = null;
let mediaLibraryKeyHandler = null;

async function loadStorageMediaItems({ force = false } = {}) {
  if (!force && mediaLibraryCache) return mediaLibraryCache;

  await ensureFirebaseStorage();
  const { ref, listAll, getDownloadURL } = firebase.api;
  const found = [];

  async function walk(folderRef, depth) {
    if (depth > 3 || found.length >= MEDIA_LIBRARY_MAX_ITEMS) return;
    const listing = await listAll(folderRef);
    listing.items.forEach((item) => {
      if (found.length >= MEDIA_LIBRARY_MAX_ITEMS) return;
      if (!MEDIA_LIBRARY_IMAGE_PATTERN.test(item.name)) return;
      found.push(item);
    });
    for (const prefix of listing.prefixes) {
      if (found.length >= MEDIA_LIBRARY_MAX_ITEMS) break;
      await walk(prefix, depth + 1);
    }
  }

  for (const folder of MEDIA_LIBRARY_FOLDERS) {
    if (found.length >= MEDIA_LIBRARY_MAX_ITEMS) break;
    try {
      await walk(ref(firebase.storage, folder), 0);
    } catch (error) {
      // A folder that does not exist yet just yields nothing.
      console.warn(`Could not list Storage folder "${folder}":`, error);
    }
  }

  const resolved = await Promise.all(found.map(async (item) => {
    try {
      return { name: item.name, path: item.fullPath, url: await getDownloadURL(item) };
    } catch {
      return null;
    }
  }));

  // Upload names are prefixed with Date.now(), so a descending sort puts
  // the most recent uploads first.
  mediaLibraryCache = resolved
    .filter(Boolean)
    .sort((a, b) => b.name.localeCompare(a.name));
  return mediaLibraryCache;
}

function closeMediaLibrary() {
  if (mediaLibraryKeyHandler) {
    document.removeEventListener("keydown", mediaLibraryKeyHandler);
    mediaLibraryKeyHandler = null;
  }
  mediaLibraryNode?.remove();
  mediaLibraryNode = null;
}

function renderMediaLibraryBody(items) {
  if (!items.length) {
    return `<p class="media-library-empty">No images have been uploaded to Firebase Storage yet. Upload one below and it will appear here next time.</p>`;
  }

  return `
    <div class="media-library-grid" role="listbox" aria-label="Uploaded images">
      ${items.map((item) => `
        <button class="media-library-item" type="button" role="option" aria-selected="false"
          data-media-pick data-url="${escapeAttr(item.url)}" data-path="${escapeAttr(item.path)}"
          title="${escapeAttr(item.path)}">
          <img src="${escapeAttr(item.url)}" alt="" loading="lazy" />
          <span>${escapeHtml(item.path.split("/")[0])}</span>
        </button>
      `).join("")}
    </div>
  `;
}

async function openMediaLibrary(trigger) {
  const form = trigger.closest("[data-admin-form], [data-subject-form], [data-community-form], [data-event-form], [data-session-form]");
  const fieldName = trigger.dataset.mediaLibrary;
  if (!form || !fieldName) return;

  if (!state.firebaseEnabled) {
    showToast("Firebase Storage is not configured, so there is no image library to show.");
    return;
  }

  closeMediaLibrary();
  const node = document.createElement("div");
  node.className = "media-library-overlay";
  node.innerHTML = `
    <button class="media-library-backdrop" type="button" data-media-close aria-label="Close image library"></button>
    <div class="media-library-dialog" role="dialog" aria-modal="true" aria-labelledby="media-library-title">
      <header class="media-library-header">
        <div>
          <p class="admin-section-kicker">Image library</p>
          <h2 id="media-library-title">Reuse an uploaded image</h2>
        </div>
        <div class="media-library-header-actions">
          <button class="button ghost small" type="button" data-media-refresh>Refresh</button>
          <button class="button ghost small" type="button" data-media-close>Close</button>
        </div>
      </header>
      <div class="media-library-body" data-media-library-body>
        <p class="media-library-empty">Loading images from Firebase Storage...</p>
      </div>
    </div>
  `;
  document.body.appendChild(node);
  mediaLibraryNode = node;

  mediaLibraryKeyHandler = (event) => {
    if (event.key === "Escape") closeMediaLibrary();
  };
  document.addEventListener("keydown", mediaLibraryKeyHandler);

  const body = node.querySelector("[data-media-library-body]");
  const fill = async ({ force = false } = {}) => {
    body.innerHTML = `<p class="media-library-empty">Loading images from Firebase Storage...</p>`;
    try {
      body.innerHTML = renderMediaLibraryBody(await loadStorageMediaItems({ force }));
    } catch (error) {
      body.innerHTML = `<p class="media-library-empty">${escapeHtml(formatStorageError(error))}</p>`;
    }
  };

  node.addEventListener("click", async (event) => {
    if (event.target.closest("[data-media-close]")) {
      closeMediaLibrary();
      return;
    }
    if (event.target.closest("[data-media-refresh]")) {
      await fill({ force: true });
      return;
    }
    const pick = event.target.closest("[data-media-pick]");
    if (pick) {
      applyImageToField(form, fieldName, pick.dataset.url, pick.dataset.path);
      closeMediaLibrary();
      showToast("Image selected. Save to publish it.");
    }
  });

  await fill();
}

function createStorageFileName(originalName) {
  const name = String(originalName || "file").trim();
  const extensionMatch = name.match(/\.([a-zA-Z0-9]+)$/);
  const extension = extensionMatch ? `.${extensionMatch[1].toLowerCase()}` : "";
  const baseName = extension ? name.slice(0, -extension.length) : name;
  const safeBase = slugify(baseName).slice(0, 70) || "file";
  return `${Date.now()}-${safeBase}${extension}`;
}

async function cleanupReplacedStorageFiles(previousItem, nextItem) {
  if (!previousItem) return;
  const stalePaths = ["coverImagePath", "documentPath"]
    .map((key) => previousItem[key] && previousItem[key] !== nextItem[key] ? previousItem[key] : "")
    .filter(Boolean);
  const nextInlinePaths = new Set(extractInlineStoragePaths(nextItem?.body));
  stalePaths.push(
    ...extractInlineStoragePaths(previousItem?.body).filter((path) => !nextInlinePaths.has(path))
  );
  await deleteStoredFiles(stalePaths);
}

function extractInlineStoragePaths(body) {
  const html = String(body || "");
  if (!html.includes("<img")) return [];
  const template = document.createElement("template");
  template.innerHTML = html;
  return [...template.content.querySelectorAll("img[src]")]
    .map((image) => getFirebaseStoragePath(image.getAttribute("src")))
    .filter(Boolean);
}

function getFirebaseStoragePath(url) {
  try {
    const parsed = new URL(String(url || ""));
    if (parsed.hostname !== "firebasestorage.googleapis.com") return "";
    const match = parsed.pathname.match(/\/o\/(.+)$/);
    return match ? decodeURIComponent(match[1]) : "";
  } catch {
    return "";
  }
}

async function deleteStoredFiles(paths) {
  if (!state.firebaseEnabled) return;
  const uniquePaths = [...new Set(paths.filter(Boolean))];
  if (!uniquePaths.length) return;

  try {
    await ensureFirebaseStorage();
  } catch (error) {
    console.warn("Could not prepare Firebase Storage cleanup:", error);
    return;
  }

  await Promise.all(
    uniquePaths.map(async (path) => {
      try {
        await firebase.api.deleteObject(firebase.api.ref(firebase.storage, path));
      } catch (error) {
        if (error?.code !== "storage/object-not-found") {
          console.warn("Could not remove Firebase Storage file:", path, error);
        }
      }
    })
  );
}
function formatStorageError(error) {
  const detail = String(error?.message || "");
  if (/402|blaze|billing|quota/i.test(detail)) {
    return "Firebase Storage requires an active Blaze plan. Check billing and the Storage bucket in Firebase Console.";
  }
  const messages = {
    "storage/unauthorized": "Upload blocked. Sign in as the configured admin and deploy storage.rules.",
    "storage/quota-exceeded": "Firebase Storage is unavailable. Check that the project is on the Blaze plan and billing is active.",
    "storage/retry-limit-exceeded": "Upload timed out. Check your connection and try again.",
    "storage/canceled": "Upload canceled."
  };
  return messages[error?.code] || error?.message || "Firebase Storage upload failed.";
}

function togglePracticeSolved(slug, scope) {
  if (!slug) return;
  const solved = getPracticeSolvedMap();
  if (solved[slug]) {
    delete solved[slug];
  } else {
    solved[slug] = new Date().toISOString();
  }
  setPracticeSolvedMap(solved);

  const activeScope = scope || document.querySelector("[data-coding-practice-scope], [data-practice-scope]");
  if (activeScope?.matches("[data-coding-practice-scope]")) {
    updateCodingPracticeProgress(activeScope);
    applyCodingPracticeFilters(activeScope);
  } else {
    updatePracticeProgress(activeScope);
    applyPracticeFilters(activeScope);
  }
}

function updatePracticeProgress(scope) {
  if (!scope) return;
  const solved = getPracticeSolvedMap();
  const rows = [...scope.querySelectorAll("[data-practice-row]")];
  let solvedCount = 0;

  rows.forEach((row) => {
    const slug = row.dataset.slug;
    const done = Boolean(solved[slug]);
    if (done) solvedCount += 1;
    const button = row.querySelector("[data-practice-solved]");
    if (button) {
      button.classList.toggle("is-done", done);
      button.innerHTML = done ? "&#10003;" : "";
      button.setAttribute("aria-pressed", String(done));
    }
  });

  const total = rows.length;
  const count = scope.querySelector("[data-practice-solved-count]");
  const bar = scope.querySelector("[data-practice-progress]");
  if (count) count.textContent = String(solvedCount);
  if (bar) bar.style.width = `${total ? Math.round((solvedCount / total) * 100) : 0}%`;
}

function applyPracticeFilters(scope) {
  if (!scope) return;
  const query = scope.querySelector("[data-practice-search]")?.value.trim().toLowerCase() || "";
  const difficulty = scope.querySelector("[data-practice-difficulty]")?.value || "all";
  const company = scope.querySelector("[data-practice-company]")?.value || "all";
  const status = scope.querySelector("[data-practice-status]")?.value || "all";
  const solved = getPracticeSolvedMap();
  let visible = 0;

  scope.querySelectorAll("[data-practice-row]").forEach((row) => {
    const rowSolved = Boolean(solved[row.dataset.slug]);
    const matchesSearch = !query || String(row.dataset.search || "").includes(query);
    const matchesDifficulty = difficulty === "all" || row.dataset.difficulty === difficulty;
    const matchesCompany = company === "all" || String(row.dataset.company || "").split(",").includes(company);
    const matchesStatus = status === "all" || (status === "solved" ? rowSolved : !rowSolved);
    const show = matchesSearch && matchesDifficulty && matchesCompany && matchesStatus;
    row.hidden = !show;
    if (show) visible += 1;
  });

  scope.querySelectorAll("[data-practice-group]").forEach((group) => {
    const rows = [...group.querySelectorAll("[data-practice-row]")];
    group.hidden = rows.length > 0 && rows.every((row) => row.hidden);
  });

  const empty = scope.querySelector("[data-practice-empty]");
  if (empty) empty.classList.toggle("is-visible", visible === 0);
}

function applyCodingRoundFilters(scope) {
  if (!scope) return;
  const query = scope.querySelector("[data-coding-search]")?.value.trim().toLowerCase() || "";
  const difficulty = scope.querySelector("[data-coding-difficulty]")?.value || "all";
  let visible = 0;

  scope.querySelectorAll("[data-coding-row]").forEach((row) => {
    const matchesSearch = !query || String(row.dataset.search || "").includes(query);
    const matchesDifficulty = difficulty === "all" || row.dataset.difficulty === difficulty;
    const show = matchesSearch && matchesDifficulty;
    row.hidden = !show;
    if (show) visible += 1;
  });

  scope.querySelectorAll("[data-coding-group]").forEach((group) => {
    const rows = [...group.querySelectorAll("[data-coding-row]")];
    group.hidden = rows.length > 0 && rows.every((row) => row.hidden);
  });

  const empty = scope.querySelector("[data-coding-empty]");
  if (empty) empty.classList.toggle("is-visible", visible === 0);
}
function selectCodingPracticeItem(slug) {
  if (!slug) return;
  navigateTo(`/coding-practice/${encodeURIComponent(slug)}`);
}

function persistCodingPracticeEditor(editor) {
  const scope = editor.closest("[data-coding-practice-scope]");
  const item = getCodingPracticeItemBySlug(scope?.dataset.activePractice || editor.dataset.codeItem || "");
  const language = getCodingPracticeLanguage(scope?.querySelector("[data-code-language]")?.value || getCodingPracticeSavedLanguage());
  if (!item) return;
  setCodingPracticeSavedCode(item.slug, language.id, editor.value);
}

function updateCodingPracticeLanguage(select) {
  const scope = select.closest("[data-coding-practice-scope]");
  const item = getCodingPracticeItemBySlug(scope?.dataset.activePractice || "");
  const language = getCodingPracticeLanguage(select.value);
  if (!scope || !item) return;

  setCodingPracticeSavedLanguage(language.id);
  const editor = scope.querySelector("[data-code-editor]");
  const saved = getCodingPracticeSavedCode(item.slug, language.id);
  if (editor) {
    editor.value = saved || getCodingPracticeStarterCode(item, language.id);
    editor.dataset.codeItem = item.slug;
    syncCodingPracticeHighlight(editor);
  }

  const errorBox = scope.querySelector("[data-code-error]");
  if (errorBox) {
    errorBox.hidden = true;
    errorBox.innerHTML = "";
  }

  const fileLabel = scope.querySelector("[data-code-extension]");
  if (fileLabel) fileLabel.textContent = `Main.${language.extension}`;

  const playgroundButton = scope.querySelector("[data-open-kotlin-playground]");
  if (playgroundButton) playgroundButton.hidden = language.id !== "kotlin";

  updateCodingPracticeRunState(scope, language);
  const output = scope.querySelector("[data-code-output]");
  if (output && saved) {
    output.innerHTML = `<strong>${escapeHtml(language.label)} selected</strong><span>${language.runner === "browser" ? "Loaded your saved draft. Run tests is available." : "Loaded your saved draft in free practice mode. Switch to JavaScript or Kotlin to run tests."}</span>`;
  }
}

function resetCodingPracticeEditor(scope) {
  const item = getCodingPracticeItemBySlug(scope?.dataset.activePractice || "");
  const language = getCodingPracticeLanguage(scope?.querySelector("[data-code-language]")?.value || getCodingPracticeSavedLanguage());
  const editor = scope?.querySelector("[data-code-editor]");
  if (!item || !editor) return;
  const starter = getCodingPracticeStarterCode(item, language.id);
  editor.value = starter;
  setCodingPracticeSavedCode(item.slug, language.id, starter);
  syncCodingPracticeHighlight(editor);

  const errorBox = scope.querySelector("[data-code-error]");
  if (errorBox) {
    errorBox.hidden = true;
    errorBox.innerHTML = "";
  }

  const output = scope.querySelector("[data-code-output]");
  if (output) {
    output.innerHTML = `<strong>Editor reset</strong><span>Starter code restored for ${escapeHtml(language.label)}.</span>`;
  }
}

async function runCodingPracticeSample(scope) {
  const item = getCodingPracticeItemBySlug(scope?.dataset.activePractice || "");
  const language = getCodingPracticeLanguage(scope?.querySelector("[data-code-language]")?.value || getCodingPracticeSavedLanguage());
  const editor = scope?.querySelector("[data-code-editor]");
  const output = scope?.querySelector("[data-code-output]");
  const errorBox = scope?.querySelector("[data-code-error]");
  if (!item || !editor || !output) return;

  persistCodingPracticeEditor(editor);
  syncCodingPracticeHighlight(editor);
  const code = editor.value.trim();
  if (errorBox) {
    errorBox.hidden = true;
    errorBox.innerHTML = "";
  }

  if (!code) {
    showCodingPracticeRunError(scope, "No code found", "Write your solution before running test cases.");
    return;
  }

  const testCases = getCodingPracticeTestCases(item);

  if (language.runner !== "browser") {
    output.innerHTML = `<strong>Free practice mode</strong><span>${escapeHtml(language.label)} compiler is disabled to keep the website free. Write and study the solution here, or switch to JavaScript, Python, or Kotlin to run all test cases in the browser.</span>`;
    return;
  }

  if (language.engine === "pyodide") {
    const complexity = analyzeCodingPracticeComplexity(code, language.id);
    const loadingNote = pythonRunnerState.ready
      ? `Checking ${testCases.length} cases for ${escapeHtml(item.title)}.`
      : `Setting up the Python runtime (first run only, this can take up to 15 seconds)...`;
    output.innerHTML = renderCodingPracticeLoadingState("Running tests...", loadingNote);
    await runPythonCodingPracticeTests(scope, item, code, testCases, complexity);
    return;
  }

  let browserCode = code;
  try {
    browserCode = getBrowserRunnableCodingPracticeCode(code, language.id);
  } catch (error) {
    showCodingPracticeRunError(scope, "Compile error", error?.message || `Unable to prepare your ${language.label} solution.`, { line: error?.line, column: error?.column, source: code });
    output.innerHTML = `<strong>Tests not started</strong><span>Fix the compile error and run again.</span>`;
    return;
  }

  const generatedLineOffset = getCodingPracticeGeneratedLineOffset(browserCode);
  const complexity = analyzeCodingPracticeComplexity(code, language.id);

  output.innerHTML = renderCodingPracticeLoadingState("Running tests...", `Checking ${testCases.length} cases for ${escapeHtml(item.title)}.`);

  const workerSource = `
    const normalize = (value) => {
      if (Array.isArray(value)) return value.map(normalize);
      if (value && typeof value === "object") {
        return Object.keys(value).sort().reduce((acc, key) => {
          acc[key] = normalize(value[key]);
          return acc;
        }, {});
      }
      return value;
    };
    const equals = (actual, expected) => JSON.stringify(normalize(actual)) === JSON.stringify(normalize(expected));
    const getStackLocation = (error) => {
      const stack = String(error && error.stack ? error.stack : "");
      const match = stack.match(/<anonymous>:(\\d+):(\\d+)/) || stack.match(/skillup-[^:]+:(\\d+):(\\d+)/);
      return match ? { line: Number(match[1]), column: Number(match[2]) } : null;
    };
    const isIncompleteSyntax = (message) => /Unexpected end of input|Unexpected token ['\"]?\\)['\"]?|missing\\s+\\)|unterminated/i.test(String(message || ""));
    const findSyntaxLocation = (code, error, lineOffset = 0) => {
      const lines = String(code || "").replace(/\\r\\n/g, "\\n").split("\\n");
      let generatedLine = 0;
      for (let index = 1; index <= lines.length; index += 1) {
        try {
          new Function(lines.slice(0, index).join("\\n"));
        } catch (candidate) {
          const message = candidate && candidate.message ? candidate.message : "";
          if (index < lines.length && isIncompleteSyntax(message)) continue;
          generatedLine = index;
          break;
        }
      }
      if (!generatedLine && isIncompleteSyntax(error && error.message)) generatedLine = lines.length;
      const offset = Number(lineOffset) || 0;
      return {
        line: generatedLine ? Math.max(1, generatedLine - offset) : 0,
        column: 0
      };
    };
    self.onmessage = (event) => {
      const { code, cases, lineOffset } = event.data;
      try {
        const solve = new Function(code + "\\n; return typeof solve === 'function' ? solve : null;")();
        if (typeof solve !== "function") {
          throw new Error("Define a function named solve(input). The test runner calls solve(input) for each case.");
        }
        const results = cases.map((testCase, index) => {
          try {
            const actual = solve(testCase.input);
            return {
              name: testCase.name || "Case " + (index + 1),
              input: testCase.input,
              expected: testCase.expected,
              actual,
              passed: equals(actual, testCase.expected)
            };
          } catch (error) {
            return {
              name: testCase.name || "Case " + (index + 1),
              input: testCase.input,
              expected: testCase.expected,
              actual: undefined,
              passed: false,
              error: error && error.message ? error.message : String(error)
            };
          }
        });
        self.postMessage({ ok: true, results });
      } catch (error) {
        const location = findSyntaxLocation(code, error, lineOffset);
        self.postMessage({ ok: false, error: error && error.message ? error.message : String(error), stack: error && error.stack ? error.stack : "", line: location.line, column: location.column });
      }
    };
  `;

  const workerUrl = URL.createObjectURL(new Blob([workerSource], { type: "text/javascript" }));
  const worker = new Worker(workerUrl);
  let settled = false;
  const finish = () => {
    settled = true;
    worker.terminate();
    URL.revokeObjectURL(workerUrl);
  };

  const timer = window.setTimeout(() => {
    if (settled) return;
    finish();
    showCodingPracticeRunError(scope, "Execution timed out", "Your code took too long. Check for infinite loops or very slow logic.");
    output.innerHTML = `<strong>Tests stopped</strong><span>No results were produced before the timeout.</span>`;
  }, 4000);

  worker.onmessage = (event) => {
    if (settled) return;
    window.clearTimeout(timer);
    finish();
    const result = event.data || {};

    if (!result.ok) {
      showCodingPracticeRunError(scope, "Compile error", result.error || `Unable to compile your ${language.label} solution.`, { line: result.line, column: result.column, source: code });
      output.innerHTML = `<strong>Tests not started</strong><span>Fix the compile error and run again.</span>`;
      return;
    }

    renderCodingPracticeRunResults(scope, item, result.results || [], complexity);
  };

  worker.onerror = (event) => {
    if (settled) return;
    window.clearTimeout(timer);
    finish();
    showCodingPracticeRunError(scope, "Runner error", event.message || "Unable to run this solution.", { line: event.lineno, column: event.colno, source: code });
    output.innerHTML = `<strong>Tests stopped</strong><span>Fix the error and run again.</span>`;
  };

  worker.postMessage({
    code: browserCode,
    lineOffset: generatedLineOffset,
    cases: testCases.map((testCase) => ({ name: testCase.name, input: testCase.input, expected: testCase.expected }))
  });
}

function getPythonWorker() {
  if (pythonRunnerState.worker) return pythonRunnerState.worker;

  const workerSource = `
    importScripts(${JSON.stringify(`${PYODIDE_CDN_BASE}pyodide.js`)});

    let pyodideReadyPromise = null;
    function getPyodideInstance() {
      if (!pyodideReadyPromise) {
        pyodideReadyPromise = loadPyodide({ indexURL: ${JSON.stringify(PYODIDE_CDN_BASE)} });
      }
      return pyodideReadyPromise;
    }

    function normalize(value) {
      if (Array.isArray(value)) return value.map(normalize);
      if (value && typeof value === "object") {
        return Object.keys(value).sort().reduce((acc, key) => {
          acc[key] = normalize(value[key]);
          return acc;
        }, {});
      }
      return value;
    }
    function equalsValue(actual, expected) {
      return JSON.stringify(normalize(actual)) === JSON.stringify(normalize(expected));
    }

    self.onmessage = async (event) => {
      const { code, cases, requestId } = event.data;
      let namespace = null;
      try {
        const pyodide = await getPyodideInstance();
        namespace = pyodide.toPy({});
        pyodide.runPython(code, { globals: namespace });
        const solve = namespace.get("solve");
        if (typeof solve !== "function") {
          throw new Error("Define a function named solve(input). The test runner calls solve(input) for each case.");
        }

        const results = cases.map((testCase, index) => {
          let pyInput;
          try {
            pyInput = pyodide.toPy(testCase.input);
            const raw = solve(pyInput);
            const actual = raw && typeof raw.toJs === "function" ? raw.toJs({ dict_converter: Object.fromEntries }) : raw;
            if (raw && typeof raw.destroy === "function") raw.destroy();
            return {
              name: testCase.name || "Case " + (index + 1),
              input: testCase.input,
              expected: testCase.expected,
              actual,
              passed: equalsValue(actual, testCase.expected)
            };
          } catch (caseError) {
            return {
              name: testCase.name || "Case " + (index + 1),
              input: testCase.input,
              expected: testCase.expected,
              actual: undefined,
              passed: false,
              error: caseError && caseError.message ? caseError.message : String(caseError)
            };
          } finally {
            if (pyInput && typeof pyInput.destroy === "function") pyInput.destroy();
          }
        });

        if (typeof solve.destroy === "function") solve.destroy();
        self.postMessage({ ok: true, results, requestId });
      } catch (error) {
        self.postMessage({ ok: false, error: error && error.message ? error.message : String(error), requestId });
      } finally {
        if (namespace && typeof namespace.destroy === "function") namespace.destroy();
      }
    };
  `;

  const workerUrl = URL.createObjectURL(new Blob([workerSource], { type: "text/javascript" }));
  const worker = new Worker(workerUrl);
  pythonRunnerState.worker = worker;
  pythonRunnerState.workerUrl = workerUrl;
  return worker;
}

function formatPythonRunError(rawMessage = "") {
  const text = String(rawMessage || "").trim();
  const lines = text.split("\n").map((line) => line.trim()).filter(Boolean);
  const summary = lines[lines.length - 1] || text || "Unable to run this solution.";
  const lineMatch = text.match(/File "<exec>", line (\d+)/);
  return {
    message: summary,
    line: lineMatch ? Number(lineMatch[1]) : null
  };
}

async function runPythonCodingPracticeTests(scope, item, code, testCases, complexity) {
  const output = scope?.querySelector("[data-code-output]");
  if (!output) return;

  const worker = getPythonWorker();
  const requestId = ++pythonRunnerState.requestSeq;
  let settled = false;

  const timer = window.setTimeout(() => {
    if (settled) return;
    settled = true;
    showCodingPracticeRunError(scope, "Execution timed out", "Your code took too long, or the Python runtime is still loading over a slow connection. Please try again.");
    output.innerHTML = `<strong>Tests stopped</strong><span>No results were produced before the timeout.</span>`;
  }, 30000);

  worker.onmessage = (event) => {
    if (settled || event.data?.requestId !== requestId) return;
    settled = true;
    window.clearTimeout(timer);
    pythonRunnerState.ready = true;
    const result = event.data || {};

    if (!result.ok) {
      const parsed = formatPythonRunError(result.error);
      showCodingPracticeRunError(scope, "Compile error", parsed.message, { line: parsed.line, source: code });
      output.innerHTML = `<strong>Tests not started</strong><span>Fix the error and run again.</span>`;
      return;
    }

    renderCodingPracticeRunResults(scope, item, result.results || [], complexity);
  };

  worker.onerror = (event) => {
    if (settled) return;
    settled = true;
    window.clearTimeout(timer);
    showCodingPracticeRunError(scope, "Runner error", event.message || "Unable to load the Python runtime. Check your connection and try again.");
    output.innerHTML = `<strong>Tests stopped</strong><span>Fix the error and run again.</span>`;
    pythonRunnerState.worker = null;
    if (pythonRunnerState.workerUrl) URL.revokeObjectURL(pythonRunnerState.workerUrl);
  };

  worker.postMessage({
    code,
    requestId,
    cases: testCases.map((testCase) => ({ name: testCase.name, input: testCase.input, expected: testCase.expected }))
  });
}

function updateCodingPracticeProgress(scope) {
  if (!scope) return;
  const solved = getPracticeSolvedMap();
  const rows = [...scope.querySelectorAll("[data-coding-practice-row]")];
  let solvedCount = 0;

  rows.forEach((row) => {
    const done = Boolean(solved[row.dataset.slug]);
    if (done) solvedCount += 1;
    row.classList.toggle("is-solved", done);
    const status = row.querySelector(".coding-practice-status");
    if (status) status.innerHTML = done ? "&#10003;" : "";
  });

  scope.querySelectorAll("[data-practice-solved]").forEach((button) => {
    const done = Boolean(solved[button.dataset.practiceSolved]);
    button.classList.toggle("is-done", done);
    button.setAttribute("aria-pressed", String(done));
    if (button.classList.contains("coding-practice-solved-button")) {
      button.textContent = done ? "Solved" : "Mark solved";
    } else {
      button.innerHTML = done ? "&#10003;" : "";
    }
  });

  const total = rows.length;
  const count = scope.querySelector("[data-practice-solved-count]");
  const bar = scope.querySelector("[data-practice-progress]");
  if (count) count.textContent = String(solvedCount);
  if (bar) bar.style.width = `${total ? Math.round((solvedCount / total) * 100) : 0}%`;
}

function applyCodingPracticeFilters(scope) {
  if (!scope) return;
  const query = scope.querySelector("[data-coding-practice-search]")?.value.trim().toLowerCase() || "";
  const kind = scope.querySelector("[data-coding-practice-kind]")?.value || "all";
  const difficulty = scope.querySelector("[data-coding-practice-difficulty]")?.value || "all";
  const company = scope.querySelector("[data-coding-practice-company]")?.value || "all";
  const status = scope.querySelector("[data-coding-practice-status]")?.value || "all";
  const solved = getPracticeSolvedMap();
  let visible = 0;

  scope.querySelectorAll("[data-coding-practice-row]").forEach((row) => {
    const rowSolved = Boolean(solved[row.dataset.slug]);
    const matchesSearch = !query || String(row.dataset.search || "").includes(query);
    const matchesKind = kind === "all" || row.dataset.kind === kind;
    const matchesDifficulty = difficulty === "all" || row.dataset.difficulty === difficulty;
    const companies = String(row.dataset.company || "").split(",").filter(Boolean);
    const matchesCompany = company === "all" || companies.includes(company);
    const matchesStatus = status === "all" || (status === "solved" ? rowSolved : !rowSolved);
    const show = matchesSearch && matchesKind && matchesDifficulty && matchesCompany && matchesStatus;
    row.hidden = !show;
    if (show) visible += 1;
  });

  scope.querySelectorAll("[data-coding-practice-group]").forEach((group) => {
    const rows = [...group.querySelectorAll("[data-coding-practice-row]")];
    group.hidden = rows.length > 0 && rows.every((row) => row.hidden);
  });

  const empty = scope.querySelector("[data-coding-practice-empty]");
  if (empty) empty.classList.toggle("is-visible", visible === 0);
}

function applyLiveFilters(scope) {
  if (!scope) return;

  const search = scope.querySelector("[data-live-search]")?.value.trim().toLowerCase() || "";
  const category = scope.querySelector("[data-live-category]")?.value || "all";
  let visible = 0;

  scope.querySelectorAll("[data-filter-card]").forEach((card) => {
    const cardSearch = card.dataset.search.toLowerCase();
    const cardCategory = card.dataset.category;
    const matchesSearch = !search || cardSearch.includes(search);
    const matchesCategory = category === "all" || cardCategory === category;
    const show = matchesSearch && matchesCategory;
    card.hidden = !show;
    if (show) visible += 1;
  });

  const empty = scope.querySelector("[data-filter-empty]");
  if (empty) empty.classList.toggle("is-visible", visible === 0);
}

function isMermaidDiagramText(value = "") {
  const firstLine = stripMermaidCodeFence(value).split("\n").find((line) => line.trim()) || "";
  return getMermaidStartPattern().test(firstLine.trim());
}

function normalizeMermaidSource(value = "") {
  return decodeMermaidHtmlEntities(value)
    .replace(/\u00a0/g, " ")
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .split("\n")
    .map((line) => line.replace(/\s+$/g, ""))
    .join("\n")
    .replace(/^\n+|\n+$/g, "");
}

function decodeMermaidHtmlEntities(value = "") {
  const text = String(value || "");
  if (!/&(?:[a-z][a-z0-9]+|#\d+|#x[\da-f]+);/i.test(text) || typeof document === "undefined") return text;

  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

function stripMermaidCodeFence(value = "") {
  const source = normalizeMermaidSource(value);
  const fenced = source.match(/^(```|~~~)\s*([a-z0-9_+#.-]*)[^\n]*\n([\s\S]*?)\n?\1$/i);
  if (!fenced) return stripMermaidLanguageLine(source);

  const language = normalizeCodeLanguage(fenced[2] || "");
  const inner = stripMermaidLanguageLine(fenced[3]);
  const firstInnerLine = inner.split("\n").find((line) => line.trim()) || "";
  return language === "mermaid" || (!language && getMermaidStartPattern().test(firstInnerLine.trim())) ? inner : stripMermaidLanguageLine(source);
}

function stripMermaidLanguageLine(value = "") {
  const source = normalizeMermaidSource(value);
  const lines = source.split("\n");
  const firstIndex = lines.findIndex((line) => line.trim());
  if (firstIndex < 0 || lines[firstIndex].trim().toLowerCase() !== "mermaid") return source;

  const nextLine = lines.slice(firstIndex + 1).find((line) => line.trim()) || "";
  if (!getMermaidStartPattern().test(nextLine.trim())) return source;

  lines.splice(firstIndex, 1);
  return normalizeMermaidSource(lines.join("\n"));
}

function getMermaidStartPattern() {
  return /^(flowchart|graph|sequenceDiagram|classDiagram|classDiagram-v2|stateDiagram|stateDiagram-v2|erDiagram|journey|gantt|pie|gitGraph|mindmap|timeline|quadrantChart|requirementDiagram|C4Context|C4Container|C4Component|C4Dynamic)\b/i;
}

function renderMermaidSourceBlock(value = "") {
  const source = stripMermaidCodeFence(value);
  if (!source.trim()) return "";
  return `<pre data-diagram="true"><code>${escapeHtml(source)}</code></pre>`;
}

function renderMermaidFigure(value = "") {
  const source = stripMermaidCodeFence(value);
  if (!source.trim()) return "";
  return `<figure class="tutorial-mermaid-diagram" data-mermaid-diagram="pending"><div class="mermaid">${escapeHtml(source)}</div></figure>`;
}

function renderMarkdownCodeFence(code = "", language = "") {
  const normalizedLanguage = normalizeCodeLanguage(language);
  const source = normalizeMermaidSource(code);
  if (normalizedLanguage === "mermaid" || isMermaidDiagramText(source)) {
    return renderMermaidSourceBlock(source);
  }
  return "<pre><code>" + renderHighlightedCode(code, language) + "</code></pre>";
}

function collectMermaidMarkdownBlock(lines, startIndex) {
  const firstLine = lines[startIndex] || "";
  if (!isMermaidDiagramText(firstLine)) return null;

  const blockLines = [];
  let index = startIndex;
  while (index < lines.length) {
    const line = lines[index] || "";
    const trimmed = line.trim();
    if (!trimmed) break;
    if (index > startIndex && /^(#{1,4}\s+|```|[-*+]\s+|\d+[.)]\s+)/.test(trimmed)) break;
    blockLines.push(line);
    index += 1;
  }

  return {
    value: normalizeMermaidSource(blockLines.join("\n")),
    nextIndex: index
  };
}
function renderMarkdown(markdown) {
  const parsedMarkdown = getMarkdownLinesAndReferenceLinks(markdown);
  const lines = parsedMarkdown.lines;
  const referenceLinks = parsedMarkdown.referenceLinks;
  let html = "";
  let listType = "";
  let inCodeFence = false;
  let codeFenceLanguage = "";
  let codeLines = [];

  const closeList = () => {
    if (listType) {
      html += "</" + listType + ">";
      listType = "";
    }
  };

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];
    const trimmed = line.trim();

    if (/^\x60\x60\x60/.test(trimmed)) {
      if (inCodeFence) {
        html += renderMarkdownCodeFence(codeLines.join("\n"), codeFenceLanguage);
        codeLines = [];
        inCodeFence = false;
      } else {
        closeList();
        codeFenceLanguage = normalizeCodeLanguage(trimmed.replace(/^\x60\x60\x60/, "").trim().split(/\s+/)[0] || "");
        inCodeFence = true;
      }
      continue;
    }

    if (inCodeFence) {
      codeLines.push(line);
      continue;
    }

    if (!trimmed) {
      closeList();
      continue;
    }

    if (/^(-{3,}|\*{3,})$/.test(trimmed)) {
      closeList();
      html += "<hr>";
      continue;
    }

    const mermaidBlock = collectMermaidMarkdownBlock(lines, index);
    if (mermaidBlock) {
      closeList();
      html += renderMermaidSourceBlock(mermaidBlock.value);
      index = mermaidBlock.nextIndex - 1;
      continue;
    }

    if (isMarkdownTableStart(lines, index)) {
      closeList();
      const table = renderMarkdownTable(lines, index, referenceLinks);
      html += table.html;
      index = table.nextIndex - 1;
      continue;
    }

    const bullet = trimmed.match(/^[-*+]\s+(.+)$/);
    const numbered = trimmed.match(/^\d+[.)]\s+(.+)$/);
    if (bullet || numbered) {
      const nextListType = bullet ? "ul" : "ol";
      if (listType && listType !== nextListType) closeList();
      if (!listType) {
        listType = nextListType;
        html += "<" + listType + ">";
      }
      html += "<li>" + formatInline(bullet ? bullet[1] : numbered[1], referenceLinks) + "</li>";
      continue;
    }

    closeList();

    const imageHtml = renderMarkdownImageLine(trimmed);
    if (imageHtml) {
      html += imageHtml;
    } else if (trimmed.startsWith("#### ")) {
      html += "<h4>" + formatInline(trimmed.slice(5), referenceLinks) + "</h4>";
    } else if (trimmed.startsWith("### ")) {
      html += "<h3>" + formatInline(trimmed.slice(4), referenceLinks) + "</h3>";
    } else if (trimmed.startsWith("## ")) {
      html += "<h2>" + formatInline(trimmed.slice(3), referenceLinks) + "</h2>";
    } else if (trimmed.startsWith("# ")) {
      html += "<h1>" + formatInline(trimmed.slice(2), referenceLinks) + "</h1>";
    } else if (trimmed.startsWith("> ")) {
      html += "<blockquote>" + formatInline(trimmed.slice(2), referenceLinks) + "</blockquote>";
    } else {
      html += "<p>" + formatInline(trimmed, referenceLinks) + "</p>";
    }
  }

  if (inCodeFence) html += renderMarkdownCodeFence(codeLines.join("\n"), codeFenceLanguage);
  closeList();
  return html;
}

function getMarkdownLinesAndReferenceLinks(markdown) {
  const lines = String(markdown || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n").split("\n");
  const referenceLinks = new Map();
  const contentLines = [];

  lines.forEach((line) => {
    const reference = parseMarkdownReferenceDefinition(line);
    if (reference) {
      referenceLinks.set(reference.id, reference.url);
      return;
    }
    contentLines.push(line);
  });

  return { lines: contentLines, referenceLinks };
}

function parseMarkdownReferenceDefinition(line) {
  const match = String(line || "").match(/^\s{0,3}\[([^\]]+)\]:\s*<?([^\s>]+)>?(?:\s+["'(].*["')])?\s*$/);
  if (!match) return null;

  const url = safeUrl(match[2].replace(/&amp;/g, "&"));
  if (!url) return null;

  return {
    id: normalizeMarkdownReferenceId(match[1]),
    url
  };
}

function normalizeMarkdownReferenceId(value) {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

function renderMarkdownImageLine(line) {
  const match = line.match(/^!\[([^\]]*)\]\(([^)\s]+)(?:\s+"[^"]*")?\)$/);
  if (!match) return "";
  const url = safeUrl(match[2]);
  if (!url) return "";
  const altText = match[1] || "Tutorial image";
  return renderImportedImage(url, altText);
}

function isMarkdownTableStart(lines, index) {
  return Boolean(lines[index]?.includes("|") && isMarkdownTableDivider(lines[index + 1] || ""));
}

function isMarkdownTableDivider(line) {
  const cells = splitMarkdownRow(line);
  return cells.length > 1 && cells.every((cell) => /^:?-{3,}:?$/.test(cell.trim()));
}

function renderMarkdownTable(lines, startIndex, referenceLinks = new Map()) {
  const headers = splitMarkdownRow(lines[startIndex]);
  let index = startIndex + 2;
  const rows = [];

  while (index < lines.length && lines[index].trim() && lines[index].includes("|")) {
    rows.push(splitMarkdownRow(lines[index]));
    index += 1;
  }

  const headHtml = headers.map((cell) => "<th>" + formatInline(cell.trim(), referenceLinks) + "</th>").join("");
  const bodyHtml = rows.map((row) => "<tr>" + headers.map((_, cellIndex) => "<td>" + formatInline((row[cellIndex] || "").trim(), referenceLinks) + "</td>").join("") + "</tr>").join("");
  return {
    html: "<table><thead><tr>" + headHtml + "</tr></thead><tbody>" + bodyHtml + "</tbody></table>",
    nextIndex: index
  };
}

function splitMarkdownRow(row) {
  return String(row || "").trim().replace(/^\|/, "").replace(/\|$/, "").split("|");
}

function renderMermaidDiagramsInHtml(html = "") {
  const template = document.createElement("template");
  template.innerHTML = String(html || "");

  template.content.querySelectorAll("figure").forEach((figure) => {
    if (figure.querySelector("img, svg")) return;
    const source = stripMermaidCodeFence(getMermaidElementText(figure));
    if (isMermaidDiagramText(source)) {
      figure.replaceWith(htmlToFragment(renderMermaidFigure(source)));
    }
  });

  template.content.querySelectorAll("pre").forEach((pre) => {
    const source = stripMermaidCodeFence(pre.textContent || "");
    const codeLanguage = normalizeCodeLanguage(pre.querySelector("code")?.className?.match(/language-([\w-]+)/)?.[1] || "");
    if (pre.dataset.diagram === "true" || codeLanguage === "mermaid" || isMermaidDiagramText(source)) {
      pre.replaceWith(htmlToFragment(renderMermaidFigure(source)));
    }
  });

  convertFencedMermaidElementSequences(template.content);
  convertMermaidParagraphSequences(template.content);
  return template.innerHTML;
}

function getMermaidElementText(element) {
  const clone = element.cloneNode(true);
  clone.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
  return normalizeMermaidSource(clone.textContent || "");
}

function getMermaidFenceMarker(text = "") {
  const firstLine = normalizeMermaidSource(text).split("\n").find((line) => line.trim()) || "";
  const match = firstLine.trim().match(/^(```|~~~)\s*mermaid\b/i);
  return match?.[1] || "";
}

function canConvertMermaidTextElement(element) {
  return Boolean(
    element?.isConnected &&
    !element.closest("pre, code, table, .tutorial-mermaid-diagram") &&
    !element.querySelector("img, svg")
  );
}

function convertFencedMermaidElementSequences(root) {
  const starts = [...root.querySelectorAll("p, div")].filter((element) => {
    return canConvertMermaidTextElement(element) && getMermaidFenceMarker(getMermaidElementText(element));
  });

  starts.forEach((start) => {
    if (!canConvertMermaidTextElement(start)) return;

    const singleSource = stripMermaidCodeFence(getMermaidElementText(start));
    if (isMermaidDiagramText(singleSource)) {
      start.replaceWith(htmlToFragment(renderMermaidFigure(singleSource)));
      return;
    }

    const marker = getMermaidFenceMarker(getMermaidElementText(start));
    const nodes = [];
    const sourceLines = [];
    let cursor = start;
    let reachedEnd = false;

    while (cursor && /^(p|div)$/i.test(cursor.tagName) && canConvertMermaidTextElement(cursor)) {
      const lines = getMermaidElementText(cursor).split("\n");
      nodes.push(cursor);

      const firstContentIndex = lines.findIndex((line) => line.trim());
      const startIndex = cursor === start ? Math.max(firstContentIndex + 1, 0) : 0;

      for (let index = startIndex; index < lines.length; index += 1) {
        const line = lines[index] || "";
        if (line.trim().startsWith(marker)) {
          reachedEnd = true;
          break;
        }
        sourceLines.push(line);
      }

      if (reachedEnd) break;
      cursor = cursor.nextElementSibling;
    }

    const source = normalizeMermaidSource(sourceLines.join("\n"));
    if (!isMermaidDiagramText(source)) return;

    nodes[0].replaceWith(htmlToFragment(renderMermaidFigure(source)));
    nodes.slice(1).forEach((node) => node.remove());
  });
}

function convertMermaidParagraphSequences(root) {
  const candidates = [...root.querySelectorAll("p, div")].filter((element) => {
    if (!canConvertMermaidTextElement(element) || element.closest("figure")) return false;
    return isMermaidDiagramText(getMermaidElementText(element));
  });

  candidates.forEach((start) => {
    if (!canConvertMermaidTextElement(start) || start.closest("figure")) return;
    const lines = [];
    const nodes = [];
    let cursor = start;

    while (cursor && cursor.nodeType === Node.ELEMENT_NODE && /^(p|div)$/i.test(cursor.tagName) && canConvertMermaidTextElement(cursor)) {
      if (cursor.closest("figure")) break;
      const text = getMermaidElementText(cursor);
      if (!text.trim()) break;
      if (cursor !== start && /^(#{1,4}\s+|```|[-*+]\s+|\d+[.)]\s+)/.test(text.trim())) break;
      lines.push(text);
      nodes.push(cursor);
      cursor = cursor.nextElementSibling;
    }

    const source = normalizeMermaidSource(lines.join("\n"));
    if (!isMermaidDiagramText(source)) return;
    nodes[0].replaceWith(htmlToFragment(renderMermaidFigure(source)));
    nodes.slice(1).forEach((node) => node.remove());
  });
}

function htmlToFragment(html = "") {
  const template = document.createElement("template");
  template.innerHTML = html;
  return template.content;
}
function enhanceCodeBlocksInHtml(html = "") {
  if (typeof document === "undefined") return html;

  const template = document.createElement("template");
  template.innerHTML = String(html || "");

  template.content.querySelectorAll("pre").forEach((pre) => {
    let code = pre.querySelector("code");
    const rawText = getCodeBlockPlainText(code || pre);
    const source = stripMermaidCodeFence(rawText);
    const language = getCodeBlockLanguage(pre, code, rawText);

    if (pre.dataset.diagram === "true" || language === "mermaid" || isMermaidDiagramText(source)) return;
    if (!rawText.trim()) return;

    if (!code) {
      code = document.createElement("code");
      pre.replaceChildren(code);
    }

    pre.classList.add("syntax-code-block");
    if (language && language !== "generic") code.classList.add(`language-${language}`);

    if (hasRichCodeMarkup(code)) return;

    const formatted = formatCodeForDisplay(rawText, language);
    code.innerHTML = renderHighlightedCode(formatted, language || inferCodeLanguage(formatted));
  });

  return template.innerHTML;
}

function getCodeBlockPlainText(element) {
  const clone = element?.cloneNode?.(true);
  if (!clone) return "";

  clone.querySelectorAll?.("br").forEach((br) => br.replaceWith("\n"));
  clone.querySelectorAll?.("div, p").forEach((block) => {
    if (block.nextSibling) block.appendChild(document.createTextNode("\n"));
  });

  return normalizePastedPlainText(clone.textContent || "")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trimEnd();
}

function getCodeBlockLanguage(pre, code, rawText = "") {
  const classText = [pre?.className || "", code?.className || ""].join(" ");
  const classMatch = String(classText).match(/(?:language|lang)-([a-z0-9_+#.-]+)/i);
  const dataLanguage = pre?.dataset?.language || code?.dataset?.language || pre?.getAttribute?.("data-language") || code?.getAttribute?.("data-language") || "";
  return normalizeCodeLanguage(classMatch?.[1] || dataLanguage || inferCodeLanguage(rawText));
}

function hasRichCodeMarkup(code) {
  if (!code) return false;
  return Boolean(
    hasColoredCodeMarkup(code) ||
    code.querySelector?.("span[class], span[style], b, strong, i, em, mark")
  );
}

function formatCodeForDisplay(code = "", language = "") {
  const normalized = normalizePastedPlainText(code).replace(/^\n+|\n+$/g, "");
  if (!shouldAutoIndentCode(normalized, language)) return normalized;
  return autoIndentBraceCode(normalized);
}

function shouldAutoIndentCode(code = "", language = "") {
  const normalizedLanguage = normalizeCodeLanguage(language || inferCodeLanguage(code));
  if (["python", "sql", "html", "css", "generic", "mermaid"].includes(normalizedLanguage)) return false;

  const lines = normalizePastedPlainText(code).split("\n").filter((line) => line.trim());
  if (lines.length < 3 || !/[{}]/.test(code)) return false;

  const indentedLines = lines.filter((line) => /^\s{2,}\S/.test(line)).length;
  const braceLines = lines.filter((line) => /[{}]/.test(line)).length;
  return indentedLines <= Math.max(1, Math.floor(lines.length * 0.18)) && braceLines >= 2;
}

function autoIndentBraceCode(code = "") {
  const lines = normalizePastedPlainText(code).split("\n");
  let indent = 0;

  return lines.map((line) => {
    const trimmed = line.trim();
    if (!trimmed) return "";

    if (/^[})\]]/.test(trimmed)) indent = Math.max(0, indent - 1);
    const output = `${"  ".repeat(indent)}${trimmed}`;
    const structureText = removeCodeStringsAndComments(trimmed);
    const opens = (structureText.match(/[({\[]/g) || []).length;
    const closes = (structureText.match(/[)}\]]/g) || []).length;
    indent = Math.max(0, indent + opens - closes);
    return output;
  }).join("\n");
}

function removeCodeStringsAndComments(line = "") {
  return String(line || "")
    .replace(/"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`/g, "")
    .replace(/\/\/.*$/g, "")
    .replace(/#.*$/g, "");
}

// Tutorial and blog content was authored with <h1> for every section, so a
// reader page carried up to 22 h1s, and many articles opened by repeating the
// title the reader header had just shown. Here a leading heading that only
// repeats the title is dropped, then every heading shifts by the same amount
// so the highest level left becomes h2, directly under the page title. A
// fixed "down one level" shift was not enough: once a repeated h1 title is
// removed, an article whose sections were h2 would start at h3 and skip a
// level. Only the on-page readers use this; the Word export and full-view
// contents build from renderArticleBody and keep the original levels.
function normalizeHeadingText(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&[a-z0-9#]+;/gi, " ")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

function renderReaderArticle(body, title) {
  let html = renderArticleBody(body);
  const leading = html.match(/^\s*<h([1-6])\b[^>]*>([\s\S]*?)<\/h\1>/i);
  if (leading && normalizeHeadingText(leading[2]) === normalizeHeadingText(title)) {
    html = html.slice(leading[0].length);
  }
  const levels = [...html.matchAll(/<h([1-6])(?=[\s>])/gi)].map((match) => Number(match[1]));
  if (!levels.length) return html;
  const shift = 2 - Math.min(...levels);
  if (!shift) return html;
  const move = (level) => Math.min(6, Math.max(2, Number(level) + shift));
  return html
    .replace(/<h([1-6])(?=[\s>])/gi, (match, level) => `<h${move(level)}`)
    .replace(/<\/h([1-6])>/gi, (match, level) => `</h${move(level)}>`);
}

function renderArticleBody(body) {
  const value = String(body || "");
  const html = isHtml(value) ? resolveReferenceLinksInHtml(sanitizeRichHtml(value)) : renderMarkdown(value);
  return renderMermaidDiagramsInHtml(enhanceCodeBlocksInHtml(html));
}

function renderYouTubePlayer(tutorial) {
  const embedUrl = getYouTubeEmbedUrl(tutorial.youtubeUrl);
  if (!embedUrl) return "";

  return `
    <section class="tutorial-video" aria-label="Video">
      <div class="video-frame">
        <iframe
          src="${escapeAttr(embedUrl)}"
          title="${escapeAttr(`${tutorial.title} video`)}"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
    </section>
  `;
}

// ---- Word (.docx) export: OOXML document generation --------------------
//
// The admin panel's "Download as Word document" buttons build a real
// OOXML .docx (not the old MSO-conditional-comment HTML-as-.doc trick),
// reusing a reference document's own template parts (fonts, theme,
// watermark, header/footer) from assets/docx-template/ so exported files
// carry the exact same fonts/colors/watermark/header/footer as the
// SkillUp Class reference document. Only word/document.xml (and the
// header's title text) are generated per document; every other OOXML
// part is copied from the template unchanged.

const DOCX_NAVY = "0f4761";
const DOCX_FONT_BODY = "Play";
const DOCX_FONT_CODE = "Consolas";

function docxXmlEscape(str) {
  return String(str == null ? "" : str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function docxRFontsXml(font) {
  return `<w:rFonts w:ascii="${font}" w:cs="${font}" w:eastAsia="${font}" w:hAnsi="${font}"/>`;
}

// One <w:r> run. `size` is in half-points (Word's native unit).
function docxRunXml({ text, bold = false, italic = false, font = DOCX_FONT_BODY, color = null, size = 18 }) {
  const rPr = [
    docxRFontsXml(font),
    bold ? `<w:b w:val="1"/><w:bCs w:val="1"/>` : "",
    italic ? `<w:i w:val="1"/><w:iCs w:val="1"/>` : "",
    color ? `<w:color w:val="${color}"/>` : "",
    `<w:sz w:val="${size}"/><w:szCs w:val="${size}"/>`
  ].join("");
  const lines = String(text == null ? "" : text).split("\n");
  return lines
    .map((line, i) => `<w:r><w:rPr>${rPr}</w:rPr>${i > 0 ? "<w:br/>" : ""}<w:t xml:space="preserve">${docxXmlEscape(line)}</w:t></w:r>`)
    .join("");
}

// w:pPr child order is schema-enforced: numPr, spacing, ind, jc, outlineLvl
// (CT_PPrBase). `outlineLvl` (0-8) marks a paragraph as a heading level so
// Word's TOC field (docxTocBlockXml) can find it - independent of any
// named paragraph style.
function docxParagraphXml({ runsXml = "", align = null, spacingBefore = 0, spacingAfter = 120, numId = null, ilvl = 0, indentLeft = null, outlineLvl = null }) {
  const jc = align ? `<w:jc w:val="${align}"/>` : "";
  const numPr = numId ? `<w:numPr><w:ilvl w:val="${ilvl}"/><w:numId w:val="${numId}"/></w:numPr>` : "";
  const ind = indentLeft ? `<w:ind w:left="${indentLeft}"/>` : "";
  const outline = outlineLvl != null ? `<w:outlineLvl w:val="${outlineLvl}"/>` : "";
  return `<w:p><w:pPr>${numPr}<w:spacing w:before="${spacingBefore}" w:after="${spacingAfter}"/>${ind}${jc}${outline}</w:pPr>${runsXml}</w:p>`;
}

function docxRuleParagraphXml() {
  return `<w:p><w:pPr><w:spacing w:before="60" w:after="60"/></w:pPr><w:r><w:pict><v:rect style="width:0.0pt;height:1.5pt" o:hr="t" o:hrstd="t" o:hralign="center" fillcolor="#A0A0A0" stroked="f"/></w:pict></w:r></w:p>`;
}

// Dark editor-style code block colors, matching the on-page tutorial
// reader/editor's own syntax-highlighted <pre><code> styling
// (.tutorial-reader-body pre / CODE_TOKEN_STYLES in styles.css/app.js)
// instead of the reference document's plain black-on-white code.
const DOCX_CODE_BG_COLOR = "0D1B2D";
const DOCX_CODE_TEXT_COLOR = "D9FCE2";
const DOCX_CODE_BORDER_COLOR = "3A5568";
const DOCX_CODE_ACCENT_COLOR = "97F564";

// A single-cell, dark-shaded, bordered table used as a "code block box"
// (the reference document's own code-as-a-1x1-table technique, restyled
// to match the site's dark editor theme). `codeInput` is either a plain
// string (the raw-source fallback when a mermaid diagram fails to
// rasterize) or an array of lines, each an array of
// {text, color, bold, italic} run descriptors carrying the on-page
// syntax-highlight colors (see docxCodeRunLinesFromNode).
function docxCodeBlockTableXml(codeInput) {
  const lines = Array.isArray(codeInput)
    ? codeInput
    : String(codeInput || "").replace(/\r\n/g, "\n").split("\n").map((line) => [{ text: line }]);

  const paras = lines
    .map((runs) => {
      const runsXml = runs.length
        ? runs.map((r) => docxRunXml({ text: r.text, bold: r.bold, italic: r.italic, font: DOCX_FONT_CODE, color: r.color || DOCX_CODE_TEXT_COLOR, size: 18 })).join("")
        : docxRunXml({ text: " ", font: DOCX_FONT_CODE, color: DOCX_CODE_TEXT_COLOR, size: 18 });
      return `<w:p><w:pPr><w:spacing w:before="0" w:after="0" w:line="240" w:lineRule="auto"/></w:pPr>${runsXml}</w:p>`;
    })
    .join("");
  // A thicker lime left border mimics the editor's accent-bar look.
  const border = `<w:top w:color="${DOCX_CODE_BORDER_COLOR}" w:space="0" w:sz="6" w:val="single"/><w:left w:color="${DOCX_CODE_ACCENT_COLOR}" w:space="0" w:sz="24" w:val="single"/><w:bottom w:color="${DOCX_CODE_BORDER_COLOR}" w:space="0" w:sz="6" w:val="single"/><w:right w:color="${DOCX_CODE_BORDER_COLOR}" w:space="0" w:sz="6" w:val="single"/>`;
  // w:tcPr child order is schema-enforced: tcBorders, shd, tcMar (CT_TcPr).
  return `<w:tbl><w:tblPr><w:tblW w:w="0" w:type="auto"/><w:tblBorders>${border}</w:tblBorders><w:tblLook w:val="0000"/></w:tblPr><w:tblGrid><w:gridCol/></w:tblGrid><w:tr><w:tc><w:tcPr><w:tcBorders>${border}</w:tcBorders><w:shd w:fill="${DOCX_CODE_BG_COLOR}" w:val="clear"/><w:tcMar><w:top w:w="120" w:type="dxa"/><w:left w:w="160" w:type="dxa"/><w:bottom w:w="120" w:type="dxa"/><w:right w:w="120" w:type="dxa"/></w:tcMar></w:tcPr>${paras}</w:tc></w:tr></w:tbl><w:p><w:pPr><w:spacing w:before="0" w:after="160"/></w:pPr></w:p>`;
}

// Extracts a syntax-highlight span's color/weight/style so the exported
// code keeps the same token colors as enhanceCodeBlocksInHtml's on-page
// output (CODE_TOKEN_STYLES) instead of flattening to plain text.
function docxExtractCodeRunStyle(el) {
  const styleAttr = (el.getAttribute && el.getAttribute("style")) || "";
  const style = {};
  const colorMatch = /color:\s*#([0-9a-fA-F]{3,8})/.exec(styleAttr);
  if (colorMatch) style.color = colorMatch[1].toUpperCase();
  if (/font-weight:\s*(?:bold|[7-9]\d\d)/.test(styleAttr)) style.bold = true;
  if (/font-style:\s*italic/.test(styleAttr)) style.italic = true;
  return style;
}

// Walks a <code> element's children (including enhanceCodeBlocksInHtml's
// token-* highlight spans) into per-line arrays of colored run
// descriptors for docxCodeBlockTableXml, instead of collapsing to plain
// .textContent and losing the highlighting.
function docxCodeRunLinesFromNode(codeEl) {
  const lines = [[]];
  function pushText(text, style) {
    String(text).split("\n").forEach((part, i) => {
      if (i > 0) lines.push([]);
      if (part) lines[lines.length - 1].push({ text: part, ...style });
    });
  }
  function walk(node, style) {
    if (node.nodeType === 3) { pushText(node.textContent, style); return; }
    if (node.nodeType !== 1) return;
    if (node.tagName === "BR") { lines.push([]); return; }
    const nextStyle = { ...style, ...docxExtractCodeRunStyle(node) };
    for (const child of node.childNodes) walk(child, nextStyle);
  }
  walk(codeEl, {});
  return lines;
}

// A real comparison table: thin black borders, bold centered Play header
// row, plain left-aligned Play data rows - matches the reference exactly.
function docxDataTableXml(rows) {
  if (!rows.length) return "";
  const colCount = Math.max(...rows.map((r) => r.length));
  const border = `<w:top w:color="000000" w:space="0" w:sz="4" w:val="single"/><w:left w:color="000000" w:space="0" w:sz="4" w:val="single"/><w:bottom w:color="000000" w:space="0" w:sz="4" w:val="single"/><w:right w:color="000000" w:space="0" w:sz="4" w:val="single"/>`;
  const gridCols = Array.from({ length: colCount }).map(() => `<w:gridCol/>`).join("");
  const trs = rows
    .map((cells, rowIndex) => {
      const isHeader = rowIndex === 0;
      const tcs = Array.from({ length: colCount }).map((_, colIndex) => {
        const text = cells[colIndex] || "";
        const run = docxRunXml({ text, bold: isHeader, size: 18 });
        const para = docxParagraphXml({ runsXml: run, align: isHeader ? "center" : null, spacingBefore: 0, spacingAfter: 0 });
        return `<w:tc><w:tcPr><w:tcBorders>${border}</w:tcBorders><w:tcMar><w:top w:w="100" w:type="dxa"/><w:left w:w="100" w:type="dxa"/><w:bottom w:w="100" w:type="dxa"/><w:right w:w="100" w:type="dxa"/></w:tcMar><w:vAlign w:val="top"/></w:tcPr>${para}</w:tc>`;
      }).join("");
      return `<w:tr>${tcs}</w:tr>`;
    })
    .join("");
  return `<w:tbl><w:tblPr><w:tblW w:w="0" w:type="auto"/><w:tblBorders>${border}</w:tblBorders><w:tblLook w:val="0000"/></w:tblPr><w:tblGrid>${gridCols}</w:tblGrid>${trs}</w:tbl><w:p><w:pPr><w:spacing w:before="0" w:after="200"/></w:pPr></w:p>`;
}

function docxPictureParagraphXml({ relId, widthEmu, heightEmu, docPrId }) {
  const drawing = `<w:drawing><wp:inline distT="0" distB="0" distL="0" distR="0"><wp:extent cx="${widthEmu}" cy="${heightEmu}"/><wp:docPr id="${docPrId}" name="Picture ${docPrId}"/><a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"><a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture"><pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture"><pic:nvPicPr><pic:cNvPr id="${docPrId}" name="Picture ${docPrId}"/><pic:cNvPicPr/></pic:nvPicPr><pic:blipFill><a:blip r:embed="${relId}"/><a:stretch><a:fillRect/></a:stretch></pic:blipFill><pic:spPr><a:xfrm><a:off x="0" y="0"/><a:ext cx="${widthEmu}" cy="${heightEmu}"/></a:xfrm><a:prstGeom prst="rect"><a:avLst/></a:prstGeom></pic:spPr></pic:pic></a:graphicData></a:graphic></wp:inline></w:drawing>`;
  return `<w:p><w:pPr><w:spacing w:before="120" w:after="200"/><w:jc w:val="center"/></w:pPr><w:r>${drawing}</w:r></w:p>`;
}

const DOCX_HEADING_SIZES = { H1: 30, H2: 26, H3: 22, H4: 20 };

// Walk inline children of a block element (p, li, heading) into run XML,
// preserving bold/italic/inline-code emphasis. Ignores syntax-highlight
// wrapper spans (just uses their text) since regular body text stays
// plain black/navy - only fenced code blocks (docxCodeRunLinesFromNode)
// keep per-token syntax colors.
function docxInlineRunsXml(node, { size = 18, color = null, bold: forceBold = false } = {}) {
  let xml = "";
  const walk = (n, bold, italic, code) => {
    if (n.nodeType === 3) {
      if (n.textContent) xml += docxRunXml({ text: n.textContent, bold: bold || forceBold, italic, font: code ? DOCX_FONT_CODE : DOCX_FONT_BODY, color, size });
      return;
    }
    if (n.nodeType !== 1) return;
    const tag = n.tagName;
    if (tag === "BR") { xml += docxRunXml({ text: "\n", bold, italic, color, size }); return; }
    const nextBold = bold || tag === "STRONG" || tag === "B";
    const nextItalic = italic || tag === "EM" || tag === "I";
    const nextCode = code || tag === "CODE";
    for (const child of n.childNodes) walk(child, nextBold, nextItalic, nextCode);
  };
  for (const child of node.childNodes) walk(child, false, false, false);
  return xml;
}

function docxIsMermaidFigure(el) {
  return el.tagName === "FIGURE" && el.classList.contains("tutorial-mermaid-diagram");
}

// Converts a tutorial's rendered body HTML into OOXML paragraph/table XML
// for word/document.xml, plus a list of images that need embedding so the
// caller can fetch/pack them and wire up relationships.
// Maps H1/H2/H3 to Word outline levels 0/1/2 (TOC levels 1/2/3) so
// docxTocBlockXml's `TOC \o "1-3"` field picks them up; H4 stays out of
// the TOC (too granular).
const DOCX_HEADING_OUTLINE_LEVELS = { H1: 0, H2: 1, H3: 2 };

function docxHtmlBodyToXml(rootEl) {
  let xml = "";
  const images = [];
  let headingCount = 0;

  function pushImagePlaceholder(item) {
    const idx = images.length;
    images.push(item);
    return idx;
  }

  function walkBlock(el) {
    if (el.nodeType === 3) {
      const text = el.textContent.trim();
      if (text) xml += docxParagraphXml({ runsXml: docxRunXml({ text, size: 18 }) });
      return;
    }
    if (el.nodeType !== 1) return;
    const tag = el.tagName;

    if (tag === "H1" || tag === "H2") {
      headingCount++;
      xml += docxParagraphXml({ runsXml: docxInlineRunsXml(el, { size: DOCX_HEADING_SIZES[tag], color: DOCX_NAVY, bold: true }), spacingBefore: 320, spacingAfter: 140, outlineLvl: DOCX_HEADING_OUTLINE_LEVELS[tag] });
      return;
    }
    if (tag === "H3" || tag === "H4") {
      if (tag === "H3") headingCount++;
      xml += docxParagraphXml({ runsXml: docxInlineRunsXml(el, { size: DOCX_HEADING_SIZES[tag], color: DOCX_NAVY, bold: true }), spacingBefore: 260, spacingAfter: 120, outlineLvl: DOCX_HEADING_OUTLINE_LEVELS[tag] ?? null });
      return;
    }
    if (docxIsMermaidFigure(el)) {
      const source = el.querySelector(".mermaid")?.textContent || el.textContent || "";
      const idx = pushImagePlaceholder({ kind: "mermaid", source: source.trim() });
      xml += docxParagraphXml({ runsXml: docxRunXml({ text: "Diagram", bold: true, color: DOCX_NAVY, size: 20 }), spacingBefore: 260, spacingAfter: 80 });
      xml += `{{IMAGE:${idx}}}`;
      return;
    }
    if (tag === "PRE") {
      const code = el.querySelector("code") || el;
      xml += docxCodeBlockTableXml(docxCodeRunLinesFromNode(code));
      return;
    }
    if (tag === "TABLE") {
      const rows = [...el.querySelectorAll("tr")].map((tr) => [...tr.querySelectorAll("th,td")].map((cell) => cell.textContent.trim()));
      xml += docxDataTableXml(rows);
      return;
    }
    if (tag === "UL" || tag === "OL") {
      const numId = tag === "UL" ? 1 : 2;
      [...el.children].filter((c) => c.tagName === "LI").forEach((li) => {
        xml += docxParagraphXml({ runsXml: docxInlineRunsXml(li, { size: 18 }), numId, spacingBefore: 0, spacingAfter: 60 });
      });
      return;
    }
    if (tag === "BLOCKQUOTE") {
      xml += docxParagraphXml({ runsXml: docxInlineRunsXml(el, { size: 18 }), indentLeft: 480, spacingBefore: 120, spacingAfter: 120 });
      return;
    }
    if (tag === "HR") {
      xml += docxRuleParagraphXml();
      return;
    }
    if (tag === "IMG") {
      const idx = pushImagePlaceholder({ kind: "img", src: el.getAttribute("src") || "" });
      xml += `{{IMAGE:${idx}}}`;
      return;
    }
    if (tag === "P" || tag === "FIGCAPTION") {
      const hasImg = el.querySelector && el.querySelector("img");
      if (hasImg) {
        [...el.childNodes].forEach((child) => walkBlock(child));
        return;
      }
      const runs = docxInlineRunsXml(el, { size: 18 });
      if (runs) xml += docxParagraphXml({ runsXml: runs });
      return;
    }
    if (tag === "DIV" || tag === "SECTION" || tag === "ARTICLE" || tag === "FIGURE") {
      [...el.childNodes].forEach((child) => walkBlock(child));
      return;
    }
    // Unknown block element - fall back to treating it as a paragraph of its text.
    const text = el.textContent ? el.textContent.trim() : "";
    if (text) xml += docxParagraphXml({ runsXml: docxRunXml({ text, size: 18 }) });
  }

  [...rootEl.childNodes].forEach((child) => walkBlock(child));
  return { xml, images, headingCount };
}

// Title block: two thin rules around a right-aligned Play/bold/navy title,
// matching the reference document's exact cover treatment.
function docxTitleBlockXml(title) {
  return (
    docxRuleParagraphXml() +
    docxParagraphXml({ runsXml: docxRunXml({ text: title, bold: true, color: DOCX_NAVY, size: 40 }), align: "right", spacingBefore: 0, spacingAfter: 60 }) +
    docxRuleParagraphXml() +
    docxParagraphXml({ runsXml: "", spacingBefore: 0, spacingAfter: 0 })
  );
}

const DOCX_SECT_PR_XML = `<w:sectPr><w:headerReference r:id="rId7" w:type="default"/><w:footerReference r:id="rId8" w:type="default"/><w:pgSz w:h="16834" w:w="11909" w:orient="portrait"/><w:pgMar w:bottom="1440" w:top="1440" w:left="1440" w:right="1440" w:header="283" w:footer="283" w:gutter="0"/><w:pgNumType w:start="1"/></w:sectPr>`;

const DOCX_DOCUMENT_NS = `xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml"`;

// A real Word TOC field (the same field code Word's own "Table of
// Contents" button inserts) built from paragraph outline levels 0-2
// (docxHtmlBodyToXml's H1/H2/H3 handling) - not a hand-typed page list,
// since we don't paginate ourselves. Word computes the actual page
// numbers when it opens/updates the field; word/settings.xml's
// `w:updateFields` asks Word to do that automatically on open, but the
// placeholder text covers the case where a viewer's Word doesn't.
function docxTocBlockXml() {
  const label = docxParagraphXml({ runsXml: docxRunXml({ text: "Table of Contents", bold: true, color: DOCX_NAVY, size: 30 }), spacingBefore: 0, spacingAfter: 160 });
  const placeholderRun = `<w:r><w:rPr>${docxRFontsXml(DOCX_FONT_BODY)}<w:i w:val="1"/><w:iCs w:val="1"/><w:sz w:val="18"/><w:szCs w:val="18"/></w:rPr><w:t xml:space="preserve">Right-click here and choose "Update Field" (or press F9) to generate the table of contents with page numbers.</w:t></w:r>`;
  const fieldPara = `<w:p><w:pPr><w:spacing w:before="0" w:after="120"/></w:pPr><w:r><w:fldChar w:fldCharType="begin" w:dirty="true"/></w:r><w:r><w:instrText xml:space="preserve"> TOC \\o "1-3" \\h \\z \\u </w:instrText></w:r><w:r><w:fldChar w:fldCharType="separate"/></w:r>${placeholderRun}<w:r><w:fldChar w:fldCharType="end"/></w:r></w:p>`;
  const pageBreak = `<w:p><w:r><w:br w:type="page"/></w:r></w:p>`;
  return label + fieldPara + pageBreak;
}

function docxBuildDocumentXml({ title, bodyXml, includeToc }) {
  const tocXml = includeToc ? docxTocBlockXml() : "";
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><w:document ${DOCX_DOCUMENT_NS}><w:body>${docxTitleBlockXml(title)}${tocXml}${bodyXml}${DOCX_SECT_PR_XML}</w:body></w:document>`;
}

// EMU = 914400 per inch. Caps embedded images at 6in wide (page content
// width at 1in margins on A4), keeping aspect ratio.
const DOCX_MAX_WIDTH_EMU = 6 * 914400;

function docxGuessImageExt(src, contentType) {
  if (contentType) {
    if (contentType.includes("png")) return "png";
    if (contentType.includes("jpeg") || contentType.includes("jpg")) return "jpg";
    if (contentType.includes("gif")) return "png";
    if (contentType.includes("webp")) return "png";
  }
  const m = /\.(png|jpe?g|gif|webp)(\?|#|$)/i.exec(src || "");
  if (!m) return "png";
  const ext = m[1].toLowerCase();
  return ext === "jpeg" ? "jpg" : (ext === "gif" || ext === "webp" ? "png" : ext);
}

function docxEscapeXmlText(str) {
  return String(str == null ? "" : str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// `assets.templates` is a map of the flat template-file names -> string
// content (already loaded). `assets.fonts`/`assets.watermark` are
// ArrayBuffer/Uint8Array. `fetchImage(src)` must resolve
// { bytes: Uint8Array, contentType, width, height } or null if
// unavailable (image is then skipped, not fatal). `renderMermaid(source)`
// must resolve the same shape for a mermaid diagram's rasterized PNG, or
// null if rendering failed (falls back to a labeled raw-source code
// block instead of dropping the diagram). `parseHtml(html)` must return a
// DOM root element (browser: DOMParser).
async function docxBuildTutorialZip({ JSZipCtor, templates, fonts, watermark, title, headerText, bodyHtml, parseHtml, fetchImage, renderMermaid }) {
  const rootEl = parseHtml(bodyHtml);
  const { xml: rawBodyXml, images, headingCount } = docxHtmlBodyToXml(rootEl);

  let bodyXml = rawBodyXml;
  const extraRels = [];
  const mediaFiles = [];
  let nextRelId = 9; // rId1-5,7,8 are the fixed template rels; images start at 9
  let nextDocPr = 1000;

  for (let i = 0; i < images.length; i++) {
    const placeholder = `{{IMAGE:${i}}}`;
    const item = images[i];
    const isMermaid = item.kind === "mermaid";
    let replacement = "";
    try {
      const fetched = isMermaid
        ? (renderMermaid ? await renderMermaid(item.source) : null)
        : (item.src ? await fetchImage(item.src) : null);

      if (fetched && fetched.bytes && fetched.bytes.length) {
        const relId = `rId${nextRelId++}`;
        const ext = isMermaid ? "png" : docxGuessImageExt(item.src, fetched.contentType);
        const fileName = `image${i + 1}.${ext}`;
        mediaFiles.push({ fileName, bytes: fetched.bytes });
        extraRels.push({ id: relId, target: `media/${fileName}` });

        const size = fetched.width && fetched.height ? { width: fetched.width, height: fetched.height } : { width: 800, height: 500 };
        // OOXML's ST_PositiveCoordinate requires a whole EMU - a
        // non-integer pixel width (e.g. a mermaid SVG's fractional
        // viewBox size) must be rounded or Word rejects the file.
        const widthEmu = Math.round(Math.min(size.width * 9525, DOCX_MAX_WIDTH_EMU)); // 9525 EMU per px at 96dpi
        const heightEmu = Math.round(widthEmu * (size.height / size.width));
        replacement = docxPictureParagraphXml({ relId, widthEmu, heightEmu, docPrId: nextDocPr++ });
      } else if (isMermaid) {
        // Rendering failed (mermaid unavailable, diagram syntax error,
        // etc.) - fall back to a labeled code block of the raw source
        // rather than silently dropping the diagram.
        replacement = docxCodeBlockTableXml(item.source);
      }
    } catch {
      replacement = isMermaid ? docxCodeBlockTableXml(item.source) : "";
    }
    bodyXml = bodyXml.split(placeholder).join(replacement);
  }

  const documentXml = docxBuildDocumentXml({ title, bodyXml, includeToc: headingCount > 0 });
  const headerXml = templates["header1.xml"].split("{{HEADER_TEXT}}").join(docxEscapeXmlText(headerText));

  let documentRelsXml = templates["document-rels-base.xml"];
  if (extraRels.length) {
    const relsXml = extraRels.map((r) => `<Relationship Id="${r.id}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="${r.target}"/>`).join("");
    documentRelsXml = documentRelsXml.replace("</Relationships>", `${relsXml}</Relationships>`);
  }

  const zip = new JSZipCtor();
  zip.file("[Content_Types].xml", templates["content-types.xml"]);
  zip.file("_rels/.rels", templates["rels-root.xml"]);
  zip.file("word/document.xml", documentXml);
  zip.file("word/_rels/document.xml.rels", documentRelsXml);
  zip.file("word/_rels/fontTable.xml.rels", templates["fontTable-rels.xml"]);
  zip.file("word/_rels/header1.xml.rels", templates["header1-rels.xml"]);
  zip.file("word/styles.xml", templates["styles.xml"]);
  zip.file("word/theme/theme1.xml", templates["theme1.xml"]);
  zip.file("word/fontTable.xml", templates["fontTable.xml"]);
  zip.file("word/settings.xml", templates["settings.xml"]);
  zip.file("word/numbering.xml", templates["numbering.xml"]);
  zip.file("word/header1.xml", headerXml);
  zip.file("word/footer1.xml", templates["footer1.xml"]);
  zip.file("word/fonts/Play-regular.ttf", fonts.regular);
  zip.file("word/fonts/Play-bold.ttf", fonts.bold);
  zip.file("word/media/watermark.png", watermark);
  mediaFiles.forEach((m) => zip.file(`word/media/${m.fileName}`, m.bytes));

  return zip;
}

const DOCX_TEMPLATE_TEXT_FILES = [
  "content-types.xml", "rels-root.xml", "document-rels-base.xml",
  "fontTable-rels.xml", "header1-rels.xml", "styles.xml", "theme1.xml",
  "fontTable.xml", "settings.xml", "numbering.xml", "header1.xml", "footer1.xml"
];

function loadDocxTemplateAssets() {
  if (docxTemplateAssetsPromise) return docxTemplateAssetsPromise;
  docxTemplateAssetsPromise = (async () => {
    const base = new URL("/assets/docx-template/", window.location.href).href;
    const templates = {};
    await Promise.all(DOCX_TEMPLATE_TEXT_FILES.map(async (name) => {
      const res = await fetch(`${base}${name}`);
      if (!res.ok) throw new Error(`Failed to load docx template asset: ${name}`);
      templates[name] = await res.text();
    }));
    const [regular, bold, watermark] = await Promise.all([
      fetch(`${base}fonts/Play-regular.ttf`).then((r) => r.arrayBuffer()),
      fetch(`${base}fonts/Play-bold.ttf`).then((r) => r.arrayBuffer()),
      fetch(`${base}media/watermark.png`).then((r) => r.arrayBuffer())
    ]);
    return { templates, fonts: { regular, bold }, watermark };
  })();
  docxTemplateAssetsPromise.catch(() => { docxTemplateAssetsPromise = null; });
  return docxTemplateAssetsPromise;
}

function parseHtmlForDocx(html) {
  const parsed = new DOMParser().parseFromString(`<!doctype html><body>${html}</body>`, "text/html");
  return parsed.body;
}

async function docxLoadImageBitmap(blob) {
  if (window.createImageBitmap) {
    try { return await createImageBitmap(blob); } catch { /* fall through to <img> */ }
  }
  return new Promise((resolve) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
    img.src = url;
  });
}

// Fetches a tutorial image for embedding. Word can only embed real
// PNG/JPEG bytes - a WebP or GIF source (SkillUp's cover images are
// .webp) is decoded and re-encoded to real PNG bytes via an offscreen
// canvas first; PNG/JPEG sources pass through unchanged.
async function fetchImageForDocx(src) {
  if (!src) return null;
  try {
    const absoluteUrl = new URL(src, `${window.location.origin}/`).href;
    const res = await fetch(absoluteUrl);
    if (!res.ok) return null;
    const contentType = res.headers.get("content-type") || "";
    const blob = await res.blob();
    const needsReencode = /webp|gif/i.test(contentType) || /\.(webp|gif)(\?|#|$)/i.test(src);

    if (needsReencode) {
      const bitmap = await docxLoadImageBitmap(blob);
      if (!bitmap) return null;
      const width = bitmap.naturalWidth || bitmap.width;
      const height = bitmap.naturalHeight || bitmap.height;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(bitmap, 0, 0);
      const pngBlob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
      if (!pngBlob) return null;
      const bytes = new Uint8Array(await pngBlob.arrayBuffer());
      return { bytes, contentType: "image/png", width, height };
    }

    const bitmap = await docxLoadImageBitmap(blob);
    const width = bitmap ? (bitmap.naturalWidth || bitmap.width) : 800;
    const height = bitmap ? (bitmap.naturalHeight || bitmap.height) : 500;
    const bytes = new Uint8Array(await blob.arrayBuffer());
    return { bytes, contentType: contentType || blob.type || "image/png", width, height };
  } catch {
    return null;
  }
}

// A "100%"/"auto" width or height attribute (mermaid's default on its
// <svg> root) is not a usable pixel size - parseFloat("100%") silently
// returns 100 and would be read as a real (wrong) size, so percentage
// values must be rejected in favor of the viewBox instead.
function docxParseSvgLength(value) {
  if (!value) return 0;
  const trimmed = String(value).trim();
  if (!trimmed || trimmed.endsWith("%")) return 0;
  const n = parseFloat(trimmed);
  return Number.isFinite(n) ? n : 0;
}

// Rasterizes a mermaid diagram to a real embeddable PNG, reusing the
// site's own mermaid renderer/theme (loadMermaid()) instead of exporting
// the raw diagram source as text. Renders via mermaid's string API
// (mermaid.render), then draws the resulting self-contained SVG onto an
// offscreen canvas at 2x scale for a crisp embedded image. Returns null
// (caller falls back to a labeled code block of the raw source) if
// rendering fails for any reason - a malformed diagram must not break
// the whole export.
async function renderMermaidDiagramToPng(source) {
  if (!source || !String(source).trim()) return null;
  try {
    const mermaid = await loadMermaid();
    mermaid.initialize({
      startOnLoad: false,
      securityLevel: "strict",
      theme: "base",
      // Chrome taints (and refuses to export) a canvas that drew an SVG
      // containing <foreignObject> - mermaid's default HTML-based labels
      // - so force plain SVG <text> labels instead; this is required for
      // canvas.toBlob() to succeed, not just a style preference.
      flowchart: { htmlLabels: false },
      htmlLabels: false,
      themeVariables: {
        primaryColor: "#eaffdf",
        primaryTextColor: "#102033",
        primaryBorderColor: "#75cf55",
        lineColor: "#2f6f1f",
        secondaryColor: "#edf7ff",
        tertiaryColor: "#ffffff",
        fontFamily: "Inter, Arial, sans-serif"
      }
    });

    const renderId = `docx-mermaid-${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
    const { svg } = await mermaid.render(renderId, source);

    const svgDoc = new DOMParser().parseFromString(svg, "image/svg+xml");
    const svgEl = svgDoc.documentElement;
    if (!svgEl || svgEl.tagName.toLowerCase() !== "svg") return null;
    if (svgEl.querySelector("foreignObject")) return null; // would taint the canvas on export

    let width = docxParseSvgLength(svgEl.getAttribute("width"));
    let height = docxParseSvgLength(svgEl.getAttribute("height"));
    if (!width || !height) {
      const viewBoxParts = (svgEl.getAttribute("viewBox") || "").trim().split(/\s+/).map(Number);
      if (viewBoxParts.length === 4 && viewBoxParts.every((n) => Number.isFinite(n))) {
        width = width || viewBoxParts[2];
        height = height || viewBoxParts[3];
      }
    }
    width = width || 800;
    height = height || 500;
    svgEl.setAttribute("width", String(width));
    svgEl.setAttribute("height", String(height));

    const serialized = new XMLSerializer().serializeToString(svgEl);
    const svgBlob = new Blob([serialized], { type: "image/svg+xml;charset=utf-8" });
    const svgUrl = URL.createObjectURL(svgBlob);

    let image;
    try {
      image = await new Promise((resolve, reject) => {
        const el = new Image();
        el.onload = () => resolve(el);
        el.onerror = () => reject(new Error("Could not rasterize mermaid diagram."));
        el.src = svgUrl;
      });
    } finally {
      URL.revokeObjectURL(svgUrl);
    }

    const scale = 2; // supersample for a crisper embedded image
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    const pngBlob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!pngBlob) return null;
    const bytes = new Uint8Array(await pngBlob.arrayBuffer());
    return { bytes, contentType: "image/png", width, height };
  } catch (err) {
    console.warn("Could not rasterize mermaid diagram for Word export:", err);
    return null;
  }
}

async function buildTutorialDocxBlob({ title, headerText, bodyHtml }) {
  const [JSZipCtor, assets] = await Promise.all([loadDocxLib(), loadDocxTemplateAssets()]);
  const zip = await docxBuildTutorialZip({
    JSZipCtor,
    templates: assets.templates,
    fonts: assets.fonts,
    watermark: assets.watermark,
    title,
    headerText,
    bodyHtml,
    parseHtml: parseHtmlForDocx,
    fetchImage: fetchImageForDocx,
    renderMermaid: renderMermaidDiagramToPng
  });
  return zip.generateAsync({
    type: "blob",
    compression: "DEFLATE",
    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  });
}

function downloadDocxBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.rel = "noreferrer";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
}

function getSubjectBookFileName(subject) {
  const safeName = String(subject?.title || "SkillUp Class")
    .replace(/[\\/:*?"<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 90) || "SkillUp Class";
  return `${safeName} - SkillUp Class Book.docx`;
}

function getSkillUpDocFileName(name, suffix = "SkillUp Class Document") {
  const safeName = String(name || "SkillUp Class")
    .replace(/[\\/:*?"<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 90) || "SkillUp Class";
  const safeSuffix = String(suffix || "Document")
    .replace(/[\\/:*?"<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim() || "Document";
  return `${safeName} - ${safeSuffix}.docx`;
}

function buildTutorialDocxBodyHtml(tutorial) {
  const bodyHtml = renderArticleBody(tutorial.body || "").trim();
  return bodyHtml || "<p>No tutorial body added yet.</p>";
}

async function generateSubjectBook(subjectId) {
  const subject = findSubjectById(subjectId);
  if (!subject) {
    showToast("Subject not found.");
    return;
  }

  const tutorials = sortSubjectTutorials(
    subject,
    state.articles.filter((article) => article.category === subject.title)
  );

  if (!tutorials.length) {
    showToast("Add tutorials to this subject before generating a book.");
    return;
  }

  const sections = getSubjectBookSections(subject, tutorials);
  const bodyHtml = sections.map((section) => `
    <h1>${escapeHtml(section.title || "Section")}</h1>
    ${section.tutorials.map((tutorial) => `
      <h2>${escapeHtml(tutorial.title || "Untitled tutorial")}</h2>
      ${buildTutorialDocxBodyHtml(tutorial)}
    `).join("")}
  `).join("");

  showToast("Preparing Word book...");
  try {
    const blob = await buildTutorialDocxBlob({
      title: subject.title,
      headerText: `${subject.title} Guide`,
      bodyHtml
    });
    downloadDocxBlob(blob, getSubjectBookFileName(subject));
    showToast("Word book downloaded.");
  } catch (err) {
    console.error(err);
    showToast("Could not generate the Word book. Please try again.");
  }
}

async function downloadTutorialDocument(tutorialId) {
  const tutorial = state.articles.find((article) => article.id === tutorialId);
  if (!tutorial) {
    showToast("Tutorial not found.");
    return;
  }

  const subject = getSubjectByTitle(tutorial.category) || { title: tutorial.category || "General" };

  showToast("Preparing Word document...");
  try {
    const blob = await buildTutorialDocxBlob({
      title: tutorial.title || "SkillUp Tutorial",
      headerText: `${subject.title || tutorial.category || "General"} Tutorial`,
      bodyHtml: buildTutorialDocxBodyHtml(tutorial)
    });
    downloadDocxBlob(blob, getSkillUpDocFileName(tutorial.title, "SkillUp Class Tutorial"));
    showToast("Tutorial Word document downloaded.");
  } catch (err) {
    console.error(err);
    showToast("Could not generate the Word document. Please try again.");
  }
}

async function downloadSectionDocument(subjectId, sectionId) {
  const subject = findSubjectById(subjectId);
  if (!subject) {
    showToast("Subject not found.");
    return;
  }

  const subjectTutorials = sortSubjectTutorials(
    subject,
    state.articles.filter((article) => article.category === subject.title)
  );
  const section = getSubjectSections(subject, subjectTutorials).find((candidate) => candidate.id === sectionId);
  if (!section) {
    showToast("Section not found.");
    return;
  }

  const tutorials = subjectTutorials.filter((tutorial) => getTutorialSectionId(tutorial, subject) === section.id);
  if (!tutorials.length) {
    showToast("This section does not contain any tutorials yet.");
    return;
  }

  const bodyHtml = tutorials.map((tutorial) => `
    <h2>${escapeHtml(tutorial.title || "Untitled tutorial")}</h2>
    ${buildTutorialDocxBodyHtml(tutorial)}
  `).join("");

  showToast("Preparing Word document...");
  try {
    const blob = await buildTutorialDocxBlob({
      title: `${subject.title} - ${section.title}`,
      headerText: `${subject.title} - ${section.title}`,
      bodyHtml
    });
    downloadDocxBlob(blob, getSkillUpDocFileName(`${subject.title} ${section.title}`, "SkillUp Class Section"));
    showToast("Section Word document downloaded.");
  } catch (err) {
    console.error(err);
    showToast("Could not generate the Word document. Please try again.");
  }
}

function getSubjectBookSections(subject, tutorials) {
  return getSubjectSections(subject, tutorials)
    .map((section) => ({
      ...section,
      tutorials: tutorials.filter((tutorial) => getTutorialSectionId(tutorial, subject) === section.id)
    }))
    .filter((section) => section.tutorials.length);
}

function htmlForEditor(body) {
  const value = String(body || "");
  return enhanceCodeBlocksInHtml(isHtml(value) ? resolveReferenceLinksInHtml(sanitizeRichHtml(value)) : renderMarkdown(value));
}

function saveRichSelection(editor) {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;

  const range = selection.getRangeAt(0);
  const container = range.commonAncestorContainer;
  const element = container.nodeType === Node.ELEMENT_NODE ? container : container.parentElement;

  if (element && (element === editor || editor.contains(element))) {
    richSelections.set(editor, range.cloneRange());
  }
}

function restoreRichSelection(editor) {
  editor.focus();
  const selection = window.getSelection();
  const savedRange = richSelections.get(editor);

  if (!selection) return;

  try {
    if (savedRange) {
      selection.removeAllRanges();
      selection.addRange(savedRange);
      return;
    }
  } catch {
    selection.removeAllRanges();
  }

  const range = document.createRange();
  range.selectNodeContents(editor);
  range.collapse(false);
  selection.removeAllRanges();
  selection.addRange(range);
}

function applyRichCommand(control) {
  const form = control.closest("[data-admin-form]");
  const editor = form?.querySelector("[data-rich-editor]");
  if (!form || !editor) return;

  restoreRichSelection(editor);

  const command = control.dataset.richCommand;
  const value = control.value || control.dataset.richValue || null;

  if (command === "createLink") {
    insertRichLink(editor);
  } else if (command === "insertImage") {
    openRichImagePanel(form);
  } else if (command === "diagramBlock") {
    insertDiagramBlock(editor);
  } else if (command === "diagramSymbols") {
    openDiagramPanel(form);
  } else if (command === "codeBlock") {
    wrapSelectionInCodeBlock(editor);
  } else if (command === "unwrapCodeBlock") {
    unwrapSelectionFromCodeBlock(editor);
  } else {
    document.execCommand(command, false, value);
  }

  syncRichEditor(form);
}

function getEditorSelectionRange(editor) {
  const selection = window.getSelection();
  if (!selection || !selection.rangeCount) return null;

  const range = selection.getRangeAt(0);
  return editor.contains(range.commonAncestorContainer) ? range : null;
}

function getClosestCodeBlock(node, editor) {
  const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
  const pre = element?.closest?.("pre");
  return pre && editor.contains(pre) ? pre : null;
}

function insertHtmlAtRichSelection(editor, html) {
  const inserted = document.execCommand("insertHTML", false, html);
  if (inserted) return;

  const range = getEditorSelectionRange(editor);
  const template = document.createElement("template");
  template.innerHTML = html;

  if (range) {
    range.deleteContents();
    range.insertNode(template.content);
  } else {
    editor.append(template.content);
  }
}

function openDiagramPanel(form) {
  const panel = form?.querySelector("[data-rich-diagram-panel]");
  const editor = form?.querySelector("[data-rich-editor]");
  if (!panel) return;

  if (editor) saveRichSelection(editor);
  panel.hidden = false;
}

function closeDiagramPanel(form) {
  const panel = form?.querySelector("[data-rich-diagram-panel]");
  if (!panel) return;

  panel.hidden = true;
}

function insertNewDiagramBlock(editor) {
  insertHtmlAtRichSelection(editor, buildDiagramBlockHtml(getDefaultDiagramText()));
  moveCaretToEnd(getLastDiagramBlock(editor));
}

function insertDiagramSymbol(button) {
  const form = button.closest("[data-admin-form]");
  const editor = form?.querySelector("[data-rich-editor]");
  const symbol = getDiagramSymbolValue(button.dataset.diagramSymbol);
  if (!form || !editor || symbol === null) return;

  restoreRichSelection(editor);
  const range = getEditorSelectionRange(editor);
  const activeDiagram = range ? getActiveDiagramBlock(range, editor) : null;

  if (!activeDiagram) {
    insertHtmlAtRichSelection(editor, buildDiagramBlockHtml(symbol.trim() ? symbol : getDefaultDiagramText()));
    moveCaretToEnd(getLastDiagramBlock(editor));
  } else if (!document.execCommand("insertText", false, symbol)) {
    insertTextAtCurrentRange(editor, symbol);
  }

  syncRichEditor(form);
  saveRichSelection(editor);
  editor.focus();
}

function getDiagramSymbolValue(key) {
  const symbol = DIAGRAM_SYMBOLS.find((item) => item.key === key);
  return symbol ? symbol.value : null;
}

function getActiveDiagramBlock(range, editor) {
  const candidates = [
    getClosestDiagramBlock(range.startContainer, editor),
    getClosestDiagramBlock(range.endContainer, editor),
    getBoundaryDiagramBlock(range, editor)
  ];
  return candidates.find(Boolean) || null;
}

function getClosestDiagramBlock(node, editor) {
  const pre = getClosestCodeBlock(node, editor);
  return pre?.dataset?.diagram === "true" ? pre : null;
}

function getBoundaryDiagramBlock(range, editor) {
  const pre = getBoundaryCodeBlock(range, editor);
  return pre?.dataset?.diagram === "true" ? pre : null;
}

function getLastDiagramBlock(editor) {
  const diagrams = editor.querySelectorAll('pre[data-diagram="true"]');
  return diagrams[diagrams.length - 1] || null;
}

function insertTextAtCurrentRange(editor, text) {
  const range = getEditorSelectionRange(editor);
  if (!range) {
    editor.appendChild(document.createTextNode(text));
    return;
  }

  range.deleteContents();
  const node = document.createTextNode(text);
  range.insertNode(node);
  range.setStartAfter(node);
  range.collapse(true);
  const selection = window.getSelection();
  if (!selection) return;
  selection.removeAllRanges();
  selection.addRange(range);
}

function insertDiagramBlock(editor) {
  const selection = window.getSelection();
  const range = getEditorSelectionRange(editor);
  const selectedText = normalizePastedPlainText(selection?.toString() || "").trimEnd();

  if (range) {
    const startPre = getClosestCodeBlock(range.startContainer, editor);
    const endPre = getClosestCodeBlock(range.endContainer, editor);
    const boundaryPre = getBoundaryCodeBlock(range, editor);
    const activePre = startPre || endPre || boundaryPre;

    if (activePre) {
      convertCodeBlockToDiagram(activePre);
      moveCaretToEnd(activePre);
      return;
    }
  }

  const diagramText = selectedText || getDefaultDiagramText();
  insertHtmlAtRichSelection(editor, buildDiagramBlockHtml(diagramText));
}

function convertCodeBlockToDiagram(pre) {
  const diagramText = normalizePastedPlainText(pre?.textContent || getDefaultDiagramText()).trimEnd();
  pre.setAttribute("data-diagram", "true");
  pre.innerHTML = `<code>${escapeHtml(diagramText) || "<br>"}</code>`;
}

function buildDiagramBlockHtml(rawDiagram) {
  const diagram = normalizePastedPlainText(rawDiagram || getDefaultDiagramText()).trimEnd();
  return `<pre data-diagram="true"><code>${escapeHtml(diagram) || "<br>"}</code></pre><p><br></p>`;
}

function getDefaultDiagramText() {
  return "[Start]\n   |\n   v\n[Step] ---> [Result]";
}

function wrapSelectionInCodeBlock(editor) {
  const selection = window.getSelection();
  const range = getEditorSelectionRange(editor);
  const selectedText = normalizePastedPlainText(selection?.toString() || "").trimEnd();

  if (range) {
    const startPre = getClosestCodeBlock(range.startContainer, editor);
    const endPre = getClosestCodeBlock(range.endContainer, editor);
    const boundaryPre = getBoundaryCodeBlock(range, editor);
    const activePre = startPre || endPre || boundaryPre;

    if (startPre && startPre === endPre && !range.collapsed && selectedText.trim()) {
      unwrapTextSelectionFromCodeBlock(startPre, range);
      return;
    }

    if (activePre && range.collapsed) {
      const caretTarget = replaceCodeBlockWithText(activePre);
      moveCaretToEnd(caretTarget);
      return;
    }
  }

  const codeBlockHtml = selectedText
    ? buildHighlightedCodeBlockHtml(selectedText)
    : "<pre><code><br></code></pre><p><br></p>";
  insertHtmlAtRichSelection(editor, codeBlockHtml);
}

function unwrapSelectionFromCodeBlock(editor) {
  const selection = window.getSelection();
  const range = getEditorSelectionRange(editor);
  if (!selection || !range) {
    showToast("Place the cursor inside a code block first.");
    return;
  }

  const startPre = getClosestCodeBlock(range.startContainer, editor);
  const endPre = getClosestCodeBlock(range.endContainer, editor);
  const boundaryPre = getBoundaryCodeBlock(range, editor);
  const activePre = startPre || endPre || boundaryPre;

  if (startPre && startPre === endPre && !range.collapsed && selection.toString().trim()) {
    unwrapTextSelectionFromCodeBlock(startPre, range);
    return;
  }

  if (activePre && range.collapsed) {
    const caretTarget = replaceCodeBlockWithText(activePre);
    moveCaretToEnd(caretTarget);
    return;
  }

  const targets = getSelectedCodeBlocks(editor, range, [startPre, endPre, boundaryPre]);
  if (!targets.length) {
    showToast("Place the cursor inside a code block first.");
    return;
  }

  let caretTarget = null;
  targets.forEach((pre) => {
    if (!pre.isConnected) return;
    const target = replaceCodeBlockWithText(pre);
    if (!caretTarget && target) caretTarget = target;
  });
  moveCaretToEnd(caretTarget);
}

function getSelectedCodeBlocks(editor, range, priorityBlocks = []) {
  const blocks = priorityBlocks.filter((pre) => pre && editor.contains(pre));

  editor.querySelectorAll("pre").forEach((pre) => {
    try {
      if (range.intersectsNode(pre)) blocks.push(pre);
    } catch {
      // Some browsers throw for detached or unusual contenteditable ranges.
    }
  });

  return [...new Set(blocks)];
}

function getBoundaryCodeBlock(range, editor) {
  if (!range) return null;
  return getCodeBlockNearBoundary(range.startContainer, range.startOffset, editor)
    || getCodeBlockNearBoundary(range.endContainer, range.endOffset, editor);
}

function getCodeBlockNearBoundary(container, offset, editor) {
  if (container?.nodeType !== Node.ELEMENT_NODE) return null;

  const candidates = [container.childNodes[offset], container.childNodes[offset - 1]].filter(Boolean);
  for (const node of candidates) {
    const pre = node.nodeType === Node.ELEMENT_NODE
      ? node.matches("pre") ? node : node.querySelector?.("pre") || node.closest?.("pre")
      : getClosestCodeBlock(node, editor);
    if (pre && editor.contains(pre)) return pre;
  }

  return null;
}

function unwrapTextSelectionFromCodeBlock(pre, range) {
  const selectedText = normalizePastedPlainText(range.toString());
  if (!selectedText.trim()) {
    replaceCodeBlockWithText(pre);
    return;
  }

  const beforeRange = document.createRange();
  beforeRange.selectNodeContents(pre);
  beforeRange.setEnd(range.startContainer, range.startOffset);

  const afterRange = document.createRange();
  afterRange.selectNodeContents(pre);
  afterRange.setStart(range.endContainer, range.endOffset);

  const fragment = document.createDocumentFragment();
  appendCodeBlockToFragment(fragment, beforeRange.toString());
  const caretTarget = appendTextParagraphsToFragment(fragment, selectedText);
  appendCodeBlockToFragment(fragment, afterRange.toString());

  pre.replaceWith(fragment);
  moveCaretToEnd(caretTarget);
}

function replaceCodeBlockWithText(pre) {
  const fragment = document.createDocumentFragment();
  const caretTarget = appendTextParagraphsToFragment(fragment, pre.textContent || "");
  pre.replaceWith(fragment);
  return caretTarget;
}

function appendCodeBlockToFragment(fragment, text) {
  const code = cleanSplitCodeText(text);
  if (!code.trim()) return null;

  const pre = document.createElement("pre");
  const codeElement = document.createElement("code");
  codeElement.innerHTML = renderHighlightedCode(code, inferCodeLanguage(code));
  pre.appendChild(codeElement);
  fragment.appendChild(pre);
  return pre;
}

function cleanSplitCodeText(text) {
  return normalizePastedPlainText(text).replace(/^\n+/, "").replace(/\n+$/, "");
}

function appendTextParagraphsToFragment(fragment, text) {
  const blocks = normalizePastedPlainText(text)
    .trim()
    .split(/\n{2,}/)
    .map((block) => block.replace(/\n+/g, " ").trim())
    .filter(Boolean);
  const values = blocks.length ? blocks : [""];
  let firstParagraph = null;

  values.forEach((value) => {
    const paragraph = document.createElement("p");
    if (value) {
      paragraph.textContent = value;
    } else {
      paragraph.innerHTML = "<br>";
    }
    fragment.appendChild(paragraph);
    if (!firstParagraph) firstParagraph = paragraph;
  });

  return firstParagraph;
}

function moveCaretToEnd(node) {
  if (!node) return;
  const selection = window.getSelection();
  if (!selection) return;

  const range = document.createRange();
  range.selectNodeContents(node);
  range.collapse(false);
  selection.removeAllRanges();
  selection.addRange(range);
}

function insertRichLink(editor) {
  restoreRichSelection(editor);
  const selection = window.getSelection();
  const selectedText = normalizeLinkDisplayText(selection?.toString() || "");
  const rawLinkText = window.prompt("Text to show for this link", selectedText);
  if (rawLinkText === null) return;

  const linkText = normalizeLinkDisplayText(rawLinkText) || selectedText;
  if (!linkText) {
    showToast("Enter the text to show for the link.");
    return;
  }

  const rawUrl = window.prompt("Paste the link URL");
  const url = safeUrl(rawUrl || "");
  if (!url) {
    showToast("Use a valid http or https link.");
    return;
  }

  restoreRichSelection(editor);
  document.execCommand("insertHTML", false, `<a href="${escapeAttr(url)}" target="_blank" rel="noreferrer">${escapeHtml(linkText)}</a>`);
  normalizeEditorLinks(editor);
}

function normalizeLinkDisplayText(text) {
  return normalizePastedPlainText(text).replace(/\s+/g, " ").trim();
}

function openRichImagePanel(form) {
  const panel = form?.querySelector("[data-rich-image-panel]");
  const input = form?.querySelector("[data-rich-image-url]");
  const editor = form?.querySelector("[data-rich-editor]");
  if (!panel || !input) return;

  if (editor) saveRichSelection(editor);
  panel.hidden = false;
  input.focus();
}

function closeRichImagePanel(form) {
  const panel = form?.querySelector("[data-rich-image-panel]");
  if (!panel) return;

  panel.hidden = true;
}

async function insertPanelImage(button) {
  const form = button.closest("[data-admin-form]");
  const editor = form?.querySelector("[data-rich-editor]");
  const urlInput = form?.querySelector("[data-rich-image-url]");
  const altInput = form?.querySelector("[data-rich-image-alt]");
  if (!form || !editor || !urlInput || !altInput) return;

  const url = safeUrl(urlInput.value);
  if (!url) {
    showToast("Use a valid http or https image URL.");
    return;
  }

  const imageIsReady = await canLoadImage(url);
  if (!imageIsReady) {
    showToast("Use a direct image URL. Upload the image to Firebase Storage or paste a valid image link.");
    return;
  }

  restoreRichSelection(editor);
  insertRichImage(editor, url, altInput.value);
  urlInput.value = "";
  altInput.value = "";
  closeRichImagePanel(form);
  syncRichEditor(form);
}

function insertRichImage(editor, url, altText = "") {
  const imageHtml = `
    <figure data-image-figure="true" data-align="center" data-crop="original" style="text-align: center;">
      <span data-image-frame="true" data-width="100" style="width: 100%;">
        <img src="${escapeAttr(url)}" alt="${escapeAttr(altText)}" loading="lazy" data-width="100" style="width: 100%;">
      </span>
      ${altText ? `<figcaption>${escapeHtml(altText)}</figcaption>` : ""}
    </figure>
    <p><br></p>
  `;
  restoreRichSelection(editor);
  const inserted = document.execCommand("insertHTML", false, imageHtml);
  if (!inserted) {
    editor.insertAdjacentHTML("beforeend", imageHtml);
  }
  normalizeEditorLinks(editor);
  const figures = editor.querySelectorAll("figure[data-image-figure]");
  const insertedFigure = figures[figures.length - 1];
  if (insertedFigure) selectRichImageFigure(insertedFigure);
}

function normalizeEditorLinks(editor) {
  editor.querySelectorAll("a[href]").forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noreferrer");
  });
}

function syncRichEditor(form) {
  const editor = form?.querySelector("[data-rich-editor]");
  const source = form?.querySelector("[data-rich-source]");
  if (!editor || !source) return;

  source.value = sanitizeRichHtml(getCleanRichEditorHtml(editor));
}

function getCleanRichEditorHtml(editor) {
  const clone = editor.cloneNode(true);
  clone.querySelectorAll("[data-rich-resize-image]").forEach((node) => node.remove());
  clone.querySelectorAll(".is-selected").forEach((node) => node.classList.remove("is-selected"));
  return clone.innerHTML;
}

function sanitizeRichHtml(html) {
  const template = document.createElement("template");
  template.innerHTML = String(html || "");
  cleanRichNode(template.content);
  return template.innerHTML.trim();
}

function cleanRichNode(parent) {
  [...parent.childNodes].forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) return;

    if (node.nodeType !== Node.ELEMENT_NODE) {
      node.remove();
      return;
    }

    const tag = node.tagName.toLowerCase();
    if (node.matches("[data-rich-resize-image]")) {
      node.remove();
      return;
    }

    const allowedTags = new Set([
      "a",
      "b",
      "blockquote",
      "br",
      "code",
      "div",
      "em",
      "figcaption",
      "figure",
      "h1",
      "h2",
      "h3",
      "h4",
      "hr",
      "i",
      "img",
      "li",
      "ol",
      "p",
      "pre",
      "s",
      "span",
      "strong",
      "table",
      "tbody",
      "td",
      "th",
      "thead",
      "tr",
      "u",
      "ul"
    ]);

    if (!allowedTags.has(tag)) {
      node.replaceWith(...node.childNodes);
      cleanRichNode(parent);
      return;
    }

    cleanRichElement(node, tag);
    cleanRichNode(node);
  });
}

function cleanRichElement(element, tag) {
  const hrefValue = element.getAttribute("href") || "";
  const srcValue = element.getAttribute("src") || "";
  const altValue = element.getAttribute("alt") || "";
  const imageAlignValue = element.getAttribute("data-align") || "";
  const imageCropValue = element.getAttribute("data-crop") || "";
  const imageWidthValue = element.getAttribute("data-width") || "";
  const imageStyleWidthValue = element.style?.width || "";
  const imageWidthAttrValue = element.getAttribute("width") || "";
  const imageFrameValue = element.getAttribute("data-image-frame") || "";
  const diagramValue = element.getAttribute("data-diagram") || "";
  const textAlign = getAllowedTextAlign(element);
  const syntaxStyle = getAllowedSyntaxStyle(element, tag);

  [...element.attributes].forEach((attribute) => element.removeAttribute(attribute.name));

  if (["p", "div", "h1", "h2", "h3", "h4", "blockquote", "figure", "td", "th"].includes(tag) && textAlign) {
    element.setAttribute("style", `text-align: ${textAlign};`);
  }

  if (tag === "figure" && element.querySelector("img")) {
    const align = getAllowedImageAlign(imageAlignValue || textAlign || "center");
    const crop = getAllowedImageCrop(imageCropValue || "original");
    element.setAttribute("data-image-figure", "true");
    element.setAttribute("data-align", align);
    element.setAttribute("data-crop", crop);
    element.setAttribute("style", `text-align: ${align};`);
  }

  if (tag === "span" && imageFrameValue && element.querySelector("img")) {
    const width = getAllowedImageWidthValue(imageWidthValue || imageStyleWidthValue || imageWidthAttrValue || 100);
    element.setAttribute("data-image-frame", "true");
    element.setAttribute("data-width", String(width || 100));
    element.setAttribute("style", `width: ${width || 100}%;`);
  }

  if (tag === "pre" && diagramValue === "true") {
    element.setAttribute("data-diagram", "true");
  }

  if (tag === "a") {
    const href = safeUrl(hrefValue);
    if (href) {
      element.setAttribute("href", href);
      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noreferrer");
    }
  }

  if (tag === "img") {
    const src = safeUrl(srcValue);
    const width = getAllowedImageWidthValue(imageWidthValue || imageStyleWidthValue || imageWidthAttrValue);
    const inImageFrame = Boolean(element.closest("[data-image-frame]"));
    if (!src) {
      element.remove();
      return;
    }

    element.setAttribute("src", src);
    element.setAttribute("alt", altValue);
    element.setAttribute("loading", "lazy");
    if (inImageFrame) {
      element.setAttribute("data-width", String(width || 100));
      element.setAttribute("style", "width: 100%;");
    } else if (width) {
      element.setAttribute("data-width", String(width));
      element.setAttribute("style", `width: ${width}%;`);
    }
  }

  if (syntaxStyle) appendInlineStyle(element, syntaxStyle);
}

function appendInlineStyle(element, styleText) {
  const nextStyle = [element.getAttribute("style") || "", styleText].filter(Boolean).join(" ").trim();
  if (nextStyle) element.setAttribute("style", nextStyle);
}

function getAllowedSyntaxStyle(element, tag) {
  const insideCodeBlock = tag === "pre" || tag === "code" || Boolean(element.closest("pre, code"));
  if (!insideCodeBlock || !["pre", "code", "span", "div", "p", "b", "strong", "i", "em"].includes(tag)) return "";

  const style = element.style;
  const color = getAllowedCssColor(style?.color || element.getAttribute("color"));
  const backgroundColor = getAllowedCssColor(style?.backgroundColor);
  const fontWeight = String(style?.fontWeight || "").trim().toLowerCase();
  const fontStyle = String(style?.fontStyle || "").trim().toLowerCase();
  const textDecoration = `${style?.textDecoration || ""} ${style?.textDecorationLine || ""}`.toLowerCase();

  return [
    color ? `color: ${color};` : "",
    backgroundColor ? `background-color: ${backgroundColor};` : "",
    ["bold", "600", "700", "800", "900"].includes(fontWeight) ? "font-weight: 700;" : "",
    fontStyle === "italic" ? "font-style: italic;" : "",
    textDecoration.includes("underline") ? "text-decoration: underline;" : ""
  ].filter(Boolean).join(" ");
}

function getAllowedCssColor(value = "") {
  const color = String(value || "").trim().toLowerCase();
  if (!color) return "";
  if (/^#[0-9a-f]{3,8}$/i.test(color)) return color;

  const rgbMatch = color.match(/^rgba?\(([^)]+)\)$/i);
  if (rgbMatch) {
    const parts = rgbMatch[1].split(",").map((part) => part.trim());
    const channels = parts.slice(0, 3).map(Number);
    const alpha = parts[3] === undefined ? 1 : Number(parts[3]);
    if (channels.length === 3 && channels.every((channel) => Number.isInteger(channel) && channel >= 0 && channel <= 255) && Number.isFinite(alpha) && alpha >= 0 && alpha <= 1) {
      return parts.length === 4 ? `rgba(${channels[0]}, ${channels[1]}, ${channels[2]}, ${alpha})` : `rgb(${channels[0]}, ${channels[1]}, ${channels[2]})`;
    }
  }

  const namedColors = new Set(["black", "white", "red", "orange", "yellow", "green", "blue", "purple", "pink", "brown", "gray", "grey", "cyan", "magenta", "lime", "navy", "teal", "silver", "maroon", "olive", "transparent"]);
  return namedColors.has(color) ? color : "";
}

function getAllowedTextAlign(element) {
  const value = element.style?.textAlign || element.getAttribute("align") || "";
  const normalized = value.trim().toLowerCase();
  return ["left", "center", "right", "justify"].includes(normalized) ? normalized : "";
}

function getAllowedImageAlign(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return ["left", "center", "right"].includes(normalized) ? normalized : "center";
}

function getAllowedImageCrop(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return ["original", "wide", "square"].includes(normalized) ? normalized : "original";
}

function getAllowedImageWidth(image) {
  const rawValue = image?.dataset?.width || image?.style?.width || image?.getAttribute?.("width") || "";
  return getAllowedImageWidthValue(rawValue);
}

function getAllowedImageWidthValue(rawValue) {
  const numeric = Number(String(rawValue).replace("%", "").trim());
  if (!Number.isFinite(numeric)) return 0;
  return Math.round(clamp(numeric, 24, 100));
}

function isHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(String(value || ""));
}

function resolveReferenceLinksInHtml(html) {
  const template = document.createElement("template");
  template.innerHTML = String(html || "");
  const referenceLinks = new Map();

  template.content.querySelectorAll("p, div").forEach((element) => {
    if (element.children.length) return;
    const reference = parseMarkdownReferenceDefinition(element.textContent || "");
    if (!reference) return;
    referenceLinks.set(reference.id, reference.url);
    element.remove();
  });

  replaceReferenceLinkTextNodes(template.content, referenceLinks);
  return template.innerHTML;
}

function replaceReferenceLinkTextNodes(root, referenceLinks = new Map()) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!/\[[^\]]+\]\[[^\]]*\]/.test(node.nodeValue || "")) return NodeFilter.FILTER_REJECT;
      if (node.parentElement?.closest("a, code, pre")) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  nodes.forEach((node) => {
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    const value = node.nodeValue || "";
    value.replace(/\[([^\]]+)\]\[([^\]]*)\]/g, (match, label, id, offset) => {
      if (offset > lastIndex) fragment.appendChild(document.createTextNode(value.slice(lastIndex, offset)));
      const replacement = createReferenceLinkNode(label, id, referenceLinks);
      fragment.appendChild(replacement || document.createTextNode(match));
      lastIndex = offset + match.length;
      return match;
    });
    if (lastIndex < value.length) fragment.appendChild(document.createTextNode(value.slice(lastIndex)));
    node.replaceWith(fragment);
  });
}

function createReferenceLinkNode(label, id, referenceLinks = new Map()) {
  const key = normalizeMarkdownReferenceId(id || label);
  const href = referenceLinks.get(key);
  if (href) {
    const link = document.createElement("a");
    link.href = href;
    link.target = "_blank";
    link.rel = "noreferrer";
    link.textContent = label;
    return link;
  }

  if (/^\d+$/.test(String(id || "").trim())) {
    return document.createTextNode(label);
  }

  return null;
}

function formatInline(value, referenceLinks = new Map()) {
  let text = escapeHtml(value);
  text = text.replace(/\x60([^\x60]+)\x60/g, "<code>$1</code>");
  text = text.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  text = text.replace(/\*([^*]+)\*/g, "<em>$1</em>");
  text = text.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, (match, label, url) => {
    const href = safeUrl(url.replace(/&amp;/g, "&"));
    return href ? '<a href="' + escapeAttr(href) + '" target="_blank" rel="noreferrer">' + label + "</a>" : match;
  });
  text = text.replace(/\[([^\]]+)\]\[([^\]]*)\]/g, (match, label, id) => {
    const key = normalizeMarkdownReferenceId(id || label);
    const href = referenceLinks.get(key);
    if (href) return '<a href="' + escapeAttr(href) + '" target="_blank" rel="noreferrer">' + label + "</a>";
    return /^\d+$/.test(String(id || "").trim()) ? label : match;
  });
  return text;
}

function revealVisibleItems() {
  const items = document.querySelectorAll("[data-reveal]");

  if (!("IntersectionObserver" in window)) {
    items.forEach((item) => item.classList.add("is-visible"));
    return;
  }

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01 }
  );

  items.forEach((item) => {
    const rect = item.getBoundingClientRect();
    if (rect.top < viewportHeight && rect.bottom > 0) {
      item.classList.add("is-visible");
      return;
    }
    observer.observe(item);
  });
}

function closeAccountMenus() {
  document.querySelectorAll("[data-nav-account].is-open").forEach((account) => {
    account.classList.remove("is-open");
    account.querySelector("[data-account-menu-toggle]")?.setAttribute("aria-expanded", "false");
  });
}

function closeMenu() {
  const nav = document.querySelector("[data-nav]");
  const button = document.querySelector("[data-menu-toggle]");
  nav?.classList.remove("is-open");
  button?.setAttribute("aria-expanded", "false");
  closeAccountMenus();
}
// Errors from the sign-in, database and storage SDKs name the service
// ("Firebase: Error (auth/...)"). The admin keeps the full text, which helps
// when a save fails; everyone else gets a plain line instead.
function getVisibleToastText(message) {
  const text = String(message ?? "");
  if (state.isAdmin) return text;
  return /firebase|firestore|googleapis|\b(?:auth|storage|functions|firestore)\/[a-z-]+|permission-denied|insufficient permissions/i.test(text)
    ? "Something went wrong. Please try again."
    : text;
}

function showToast(message) {
  toast.textContent = getVisibleToastText(message);
  toast.classList.add("is-visible");
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => toast.classList.remove("is-visible"), 3200);
}

function beginLoading(message = "Loading...") {
  loadingDepth += 1;
  window.clearTimeout(endLoading.timer);
  updateLoading(message);
  appLoader.hidden = false;
  document.body.classList.add("is-busy");
  window.requestAnimationFrame(() => appLoader.classList.add("is-visible"));
}

function updateLoading(message, progress = null) {
  if (message) loaderMessage.textContent = message;

  const hasProgress = Number.isFinite(progress);
  appLoader.classList.toggle("has-progress", hasProgress);
  loaderProgress.setAttribute("aria-hidden", String(!hasProgress));
  loaderProgressBar.style.width = hasProgress ? `${clamp(progress, 0, 100)}%` : "";
}

function endLoading() {
  loadingDepth = Math.max(0, loadingDepth - 1);
  if (loadingDepth > 0) return;

  appLoader.classList.remove("is-visible", "has-progress");
  document.body.classList.remove("is-busy");
  endLoading.timer = window.setTimeout(() => {
    if (loadingDepth === 0) appLoader.hidden = true;
  }, 180);
}

async function runWithLoader(message, operation) {
  beginLoading(message);
  try {
    return await operation();
  } catch (error) {
    console.error(error);
    showToast(error?.message || "Something went wrong. Please try again.");
    return undefined;
  } finally {
    endLoading();
  }
}
function getPublished(items) {
  return items.filter((item) => item.status === "published");
}

function canViewHiddenLearningContent() {
  return Boolean(state.isAdmin);
}

function isSubjectPublic(subject) {
  return canViewHiddenLearningContent() || !normalizeSubject(subject).hiddenFromPublic;
}

function getPublicSubjects() {
  return getAdminSubjects().filter(isSubjectPublic);
}

function getHiddenPublicSubjectTitles() {
  if (canViewHiddenLearningContent()) return new Set();
  return new Set(
    getAdminSubjects()
      .filter((subject) => subject.hiddenFromPublic)
      .map((subject) => subject.title)
  );
}

// Published courses that are not switched off with the admin's Show/Hide
// toggle. Like hidden subjects, the admin still sees hidden courses when
// browsing the public pages.
function getPublicCourses() {
  return getPublished(state.tutorials)
    .filter((course) => canViewHiddenLearningContent() || !course.hiddenFromPublic)
    .sort((a, b) => a.order - b.order);
}

function getPublicTutorials() {
  if (canViewHiddenLearningContent()) return [...state.articles];
  const hiddenSubjectTitles = getHiddenPublicSubjectTitles();
  return getPublished(state.articles).filter((tutorial) => !hiddenSubjectTitles.has(tutorial.category));
}

function getCategories(items) {
  return [...new Set(items.map((item) => item.category).filter(Boolean))].sort((a, b) => a.localeCompare(b));
}

function getAdminSubjects() {
  return getNormalizedSubjects(state.subjects, state.articles);
}

function getActiveAdminSubject() {
  const subjects = getAdminSubjects();
  if (!subjects.length) return null;
  return subjects.find((subject) => subject.id === state.activeSubjectId || subject.slug === state.activeSubjectId) || subjects[0];
}

function findSubjectById(id) {
  if (!id) return null;
  return getAdminSubjects().find((subject) => subject.id === id || subject.slug === id) || null;
}

function getSubjectByTitle(title) {
  const normalizedTitle = String(title || "").trim().toLowerCase();
  return getAdminSubjects().find((subject) => subject.title.toLowerCase() === normalizedTitle) || null;
}

function getDefaultSection() {
  return { id: DEFAULT_SECTION_ID, slug: DEFAULT_SECTION_ID, title: DEFAULT_SECTION_TITLE, order: 1, isFallback: true };
}

function getUnsectionedSection(order = 9999) {
  return { id: UNSECTIONED_SECTION_ID, slug: UNSECTIONED_SECTION_ID, title: UNSECTIONED_SECTION_TITLE, order, isFallback: true };
}

function getSubjectSections(subject, tutorials = []) {
  const sections = normalizeSubjectSections(subject?.sections || []);
  const sectionIds = new Set(sections.map((section) => section.id));
  const subjectTitle = subject?.title || "";
  const subjectTutorials = tutorials.filter((tutorial) => !subjectTitle || tutorial.category === subjectTitle);

  if (!sections.length) {
    return subjectTutorials.length ? [getDefaultSection()] : [];
  }

  const hasUnsectionedTutorials = subjectTutorials.some((tutorial) => !tutorial.sectionId || !sectionIds.has(tutorial.sectionId));
  return hasUnsectionedTutorials ? [...sections, getUnsectionedSection(sections.length + 1)] : sections;
}

function getSubjectSectionsForForm(subject) {
  const sections = normalizeSubjectSections(subject?.sections || []);
  return sections.length ? sections : [getDefaultSection()];
}

function getSubjectSectionsForArticleForm(subject, tutorial = {}) {
  const sections = getSubjectSectionsForForm(subject);
  const validIds = new Set(sections.map((section) => section.id));
  const currentId = String(tutorial.sectionId || "").trim();
  if (tutorial?.id && normalizeSubjectSections(subject?.sections || []).length && (!currentId || !validIds.has(currentId))) {
    return [getUnsectionedSection(0), ...sections];
  }
  return sections;
}
function getTutorialSectionId(tutorial, subject) {
  const sections = normalizeSubjectSections(subject?.sections || []);
  if (!sections.length) return DEFAULT_SECTION_ID;
  return sections.some((section) => section.id === tutorial.sectionId) ? tutorial.sectionId : UNSECTIONED_SECTION_ID;
}

function getTutorialSection(tutorial, subject) {
  const sections = getSubjectSections(subject, [tutorial]);
  return sections.find((section) => section.id === getTutorialSectionId(tutorial, subject)) || sections[0] || getDefaultSection();
}

function getValidTutorialSectionId(subject, rawSectionId) {
  const value = String(rawSectionId || "").trim();
  if (value === UNSECTIONED_SECTION_ID) return "";
  const sections = normalizeSubjectSections(subject?.sections || []);
  if (!sections.length) return DEFAULT_SECTION_ID;
  return sections.some((section) => section.id === value) ? value : "";
}

function sortSubjectTutorials(subject, tutorials) {
  const sectionOrder = new Map(getSubjectSections(subject, tutorials).map((section, index) => [section.id, Number(section.order || index + 1)]));
  return [...tutorials].sort((a, b) => {
    const sectionDifference = (sectionOrder.get(getTutorialSectionId(a, subject)) || Number.MAX_SAFE_INTEGER)
      - (sectionOrder.get(getTutorialSectionId(b, subject)) || Number.MAX_SAFE_INTEGER);
    if (sectionDifference) return sectionDifference;
    return Number(a.order || Number.MAX_SAFE_INTEGER) - Number(b.order || Number.MAX_SAFE_INTEGER)
      || String(a.title || "").localeCompare(String(b.title || ""));
  });
}
function getSubjectList(items) {
  const subjectMap = new Map();

  getAdminSubjects().forEach((subject) => {
    subjectMap.set(subject.title, subject);
  });

  items
    .map((item) => item.category)
    .filter(Boolean)
    .forEach((title) => {
      if (!subjectMap.has(title)) {
        subjectMap.set(title, normalizeSubject({ title, order: subjectMap.size + 1 }, subjectMap.size + 1));
      }
    });

  return [...subjectMap.values()]
    .filter((subject) => items.some((item) => item.category === subject.title))
    .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title));
}

function findTutorialById(tutorials, id) {
  return tutorials.find((item) => item.id === id || item.slug === id);
}

function sortByOrder(items) {
  return [...items].sort((a, b) => {
    const orderDifference = Number(a.order || Number.MAX_SAFE_INTEGER) - Number(b.order || Number.MAX_SAFE_INTEGER);
    if (orderDifference) return orderDifference;
    return new Date(a.createdAt || a.publishedAt || 0) - new Date(b.createdAt || b.publishedAt || 0)
      || String(a.title || "").localeCompare(String(b.title || ""));
  });
}

function sortTutorials(items) {
  const subjects = getAdminSubjects();
  const subjectOrder = new Map(subjects.map((subject, index) => [subject.title, Number(subject.order || index + 1)]));
  const subjectMap = new Map(subjects.map((subject) => [subject.title, subject]));
  const sectionOrderBySubject = new Map(
    subjects.map((subject) => {
      const subjectItems = items.filter((item) => item.category === subject.title);
      return [subject.title, new Map(getSubjectSections(subject, subjectItems).map((section, index) => [section.id, Number(section.order || index + 1)]))];
    })
  );

  return [...items].sort((a, b) => {
    const subjectDifference = (subjectOrder.get(a.category) || Number.MAX_SAFE_INTEGER)
      - (subjectOrder.get(b.category) || Number.MAX_SAFE_INTEGER);
    if (subjectDifference) return subjectDifference;

    const subject = subjectMap.get(a.category) || getSubjectByTitle(a.category) || normalizeSubject(a.category);
    const sectionOrder = sectionOrderBySubject.get(a.category) || new Map();
    const sectionDifference = (sectionOrder.get(getTutorialSectionId(a, subject)) || Number.MAX_SAFE_INTEGER)
      - (sectionOrder.get(getTutorialSectionId(b, subject)) || Number.MAX_SAFE_INTEGER);
    if (sectionDifference) return sectionDifference;

    return Number(a.order || Number.MAX_SAFE_INTEGER) - Number(b.order || Number.MAX_SAFE_INTEGER)
      || String(a.title || "").localeCompare(String(b.title || ""));
  });
}
function sortNewest(a, b) {
  return new Date(b.publishedAt || b.updatedAt) - new Date(a.publishedAt || a.updatedAt);
}

function getReadTime(text) {
  const words = getPlainText(text).trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 220));
}

function getPlainText(value) {
  const text = String(value || "");
  if (!isHtml(text)) return text;

  const template = document.createElement("template");
  template.innerHTML = text;
  return template.content.textContent || "";
}

function hasRichContent(value) {
  const text = String(value || "");
  return Boolean(getPlainText(text).trim() || /<img[\s>]/i.test(text));
}

function getInitials(value) {
  return String(value || "SC")
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}

function splitTags(value) {
  return String(value || "")
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean);
}

function splitLines(value) {
  return String(value || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}

// Course topics come from a textarea: one topic per line, or separated by
// commas. A pasted bullet or number in front of a line is dropped, and a
// comma inside brackets stays in its topic ("Payment Gateway (Stripe, Razorpay)").
function splitTopics(value) {
  return splitLines(value).flatMap((line) => {
    const text = line.replace(/^(?:[-*•▪◦‣●]|\d+[.)])\s*/u, "");
    const parts = [];
    let depth = 0;
    let current = "";
    for (const char of text) {
      if (char === "(" || char === "[") depth += 1;
      if ((char === ")" || char === "]") && depth > 0) depth -= 1;
      if (char === "," && depth === 0) {
        parts.push(current);
        current = "";
      } else {
        current += char;
      }
    }
    parts.push(current);
    return parts.map((part) => part.trim()).filter(Boolean);
  });
}

function toArray(value) {
  if (Array.isArray(value)) return value;
  return splitTags(value);
}

function capitalize(value = "") {
  const text = String(value || "").trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";
}
function slugify(value) {
  const slug = String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || `item-${Date.now()}`;
}

const CATEGORY_COVER_IMAGES = [
  { keywords: ["android", "kotlin", "flutter", "mobile", "ios", "swift", "app development"], src: "/assets/covers/android.webp" },
  { keywords: ["web", "javascript", "react", "html", "css", "frontend", "node", "dom"], src: "/assets/covers/web-development.webp" },
  { keywords: ["python"], src: "/assets/covers/python.webp" },
  { keywords: ["ai ", "artificial intelligence", "machine learning", " ml", "data science", "rag"], src: "/assets/covers/ai-ml.webp" },
  { keywords: ["system design", "architecture"], src: "/assets/covers/system-design.webp" },
  { keywords: ["interview"], src: "/assets/covers/interview-prep.webp" },
  { keywords: ["java"], src: "/assets/covers/java.webp" },
  { keywords: ["firebase", "cloud", "backend", "server", "database", "sql"], src: "/assets/covers/cloud-firebase.webp" }
];
const DEFAULT_COVER_IMAGE = "/assets/covers/general-coding.webp";

function getCategoryFallbackCover(...parts) {
  const text = ` ${parts.filter(Boolean).join(" ").toLowerCase()} `;
  const match = CATEGORY_COVER_IMAGES.find((entry) => entry.keywords.some((keyword) => text.includes(keyword)));
  return match ? match.src : DEFAULT_COVER_IMAGE;
}

function safeUrl(value) {
  const text = String(value || "").trim();
  if (!text) return "";

  try {
    const url = new URL(text, window.location.origin);
    if (["http:", "https:"].includes(url.protocol)) {
      return url.href;
    }
  } catch {
    return "";
  }

  return "";
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function canLoadImage(value) {
  const url = safeUrl(value);
  if (!url) return Promise.resolve(false);

  return new Promise((resolve) => {
    const image = new Image();
    const timeout = window.setTimeout(() => {
      image.onload = null;
      image.onerror = null;
      resolve(false);
    }, 7000);

    image.onload = () => {
      window.clearTimeout(timeout);
      resolve(Boolean(image.naturalWidth && image.naturalHeight));
    };

    image.onerror = () => {
      window.clearTimeout(timeout);
      resolve(false);
    };

    image.src = url;
  });
}

function normalizeYouTubeInput(value) {
  const text = String(value || "").trim();
  if (!text) return "";

  if (/^(youtube\.com|www\.youtube\.com|m\.youtube\.com|music\.youtube\.com|youtu\.be)\//i.test(text)) {
    return `https://${text}`;
  }

  return text;
}

function getYouTubeEmbedUrl(value) {
  const safeInput = safeUrl(normalizeYouTubeInput(value));
  if (!safeInput) return "";

  try {
    const url = new URL(safeInput);
    const hostname = url.hostname.replace(/^www\./, "").toLowerCase();
    const pathParts = url.pathname.split("/").filter(Boolean);
    let videoId = "";

    if (hostname === "youtu.be") {
      videoId = pathParts[0] || "";
    } else if (["youtube.com", "m.youtube.com", "music.youtube.com"].includes(hostname)) {
      if (pathParts[0] === "watch") {
        videoId = url.searchParams.get("v") || "";
      } else if (["embed", "shorts", "live"].includes(pathParts[0])) {
        videoId = pathParts[1] || "";
      }
    }

    if (!/^[a-zA-Z0-9_-]{6,}$/.test(videoId)) return "";

    const params = new URLSearchParams({
      rel: "0",
      modestbranding: "1"
    });
    const start = parseYouTubeStart(url.searchParams.get("start") || url.searchParams.get("t"));
    if (start) params.set("start", String(start));

    return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
  } catch {
    return "";
  }
}

function getLoopingYouTubeEmbedUrl(value) {
  const safeInput = safeUrl(normalizeYouTubeInput(value));
  if (!safeInput) return "";

  try {
    const url = new URL(safeInput);
    const hostname = url.hostname.replace(/^www\./, "").toLowerCase();
    const pathParts = url.pathname.split("/").filter(Boolean);
    let videoId = "";

    if (hostname === "youtu.be") {
      videoId = pathParts[0] || "";
    } else if (["youtube.com", "m.youtube.com", "music.youtube.com"].includes(hostname)) {
      if (pathParts[0] === "watch") {
        videoId = url.searchParams.get("v") || "";
      } else if (["embed", "shorts", "live"].includes(pathParts[0])) {
        videoId = pathParts[1] || "";
      }
    }

    if (!/^[a-zA-Z0-9_-]{6,}$/.test(videoId)) return "";

    const params = new URLSearchParams({
      autoplay: "1",
      mute: "1",
      loop: "1",
      playlist: videoId,
      controls: "0",
      playsinline: "1",
      rel: "0",
      modestbranding: "1",
      iv_load_policy: "3",
      disablekb: "1"
    });

    return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
  } catch {
    return "";
  }
}
function parseYouTubeStart(value) {
  const text = String(value || "").trim().toLowerCase();
  if (!text) return 0;
  if (/^\d+$/.test(text)) return Number(text);

  const match = text.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
  if (!match) return 0;

  const [, hours = "0", minutes = "0", seconds = "0"] = match;
  return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
}

function normalizeFullViewTheme(value) {
  const theme = String(value || "").trim().toLowerCase();
  return FULL_VIEW_THEMES.has(theme) ? theme : "light";
}

function applyFullViewReaderControl(control) {
  if (!control) return false;

  if (control.matches("button[data-reader-theme]")) {
    updateFullViewTheme(control.dataset.readerTheme);
    return true;
  }

  return false;
}
function updateFullViewTheme(value) {
  state.fullViewTheme = normalizeFullViewTheme(value);
  setFullViewThemePreference(state.fullViewTheme);
  applyFullViewReaderPreferences();
}

function applyFullViewReaderPreferences() {
  const dialog = document.querySelector("[data-tutorial-full-view-dialog]");
  if (!dialog) return;

  FULL_VIEW_THEMES.forEach((theme) => {
    dialog.classList.toggle(`is-reader-${theme}`, state.fullViewTheme === theme);
  });
  dialog.dataset.readerTheme = state.fullViewTheme;

  dialog.querySelectorAll("[data-reader-theme]").forEach((button) => {
    const isActive = button.dataset.readerTheme === state.fullViewTheme;
    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
  });
}
function getFullViewMenuPreference() {
  try {
    return localStorage.getItem(FULL_VIEW_MENU_STORAGE_KEY) !== "false";
  } catch {
    return true;
  }
}

function setFullViewMenuPreference(value) {
  try {
    localStorage.setItem(FULL_VIEW_MENU_STORAGE_KEY, value ? "true" : "false");
  } catch {
    // Preference storage is optional; the switch still works for the current page render.
  }
}
function getFullViewThemePreference() {
  try {
    return normalizeFullViewTheme(localStorage.getItem(FULL_VIEW_THEME_STORAGE_KEY));
  } catch {
    return "light";
  }
}

function setFullViewThemePreference(value) {
  try {
    localStorage.setItem(FULL_VIEW_THEME_STORAGE_KEY, normalizeFullViewTheme(value));
  } catch {
    // Preference storage is optional; the controls still work for the current reader.
  }
}


function formatCoursePrice(value) {
  const text = String(value || "").trim();
  if (!text) return "";

  const numericText = text.replace(/,/g, "");
  if (/^\d+(?:\.\d+)?$/.test(numericText)) {
    const amount = Number(numericText);
    const hasDecimals = !Number.isInteger(amount);
    return `Rs. ${amount.toLocaleString("en-IN", {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0
    })}`;
  }

  return text;
}

function formatDate(value) {
  if (!value) return "Draft";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Recently updated";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}

function formatRelativeTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const diffMs = Date.now() - date.getTime();
  const diffMinutes = Math.round(diffMs / 60000);
  if (diffMinutes < 1) return "just now";
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  const diffHours = Math.round(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.round(diffHours / 24);
  if (diffDays < 30) return `${diffDays}d ago`;
  return formatDate(value);
}

function escapeHtml(value = "") {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function escapeAttr(value = "") {
  return escapeHtml(value);
}

boot();
registerServiceWorker();
